(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree5d8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree5d8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fgQxl", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $b1e11a606f143445$export$ffb0004e005737fa, (v) => $b1e11a606f143445$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $b1e11a606f143445$export$34b9dba7ce09269b, (v) => $b1e11a606f143445$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $b1e11a606f143445$export$25062201e9e25d76, (v) => $b1e11a606f143445$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b1e11a606f143445$export$ffb0004e005737fa;
var $b1e11a606f143445$export$34b9dba7ce09269b;
var $b1e11a606f143445$export$25062201e9e25d76;
"use strict";

var $1EuC8 = parcelRequire("1EuC8");
var $b1e11a606f143445$var$k = Symbol.for("react.element"), $b1e11a606f143445$var$l = Symbol.for("react.fragment"), $b1e11a606f143445$var$m = Object.prototype.hasOwnProperty, $b1e11a606f143445$var$n = $1EuC8.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $b1e11a606f143445$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b1e11a606f143445$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$b1e11a606f143445$var$m.call(a, b) && !$b1e11a606f143445$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $b1e11a606f143445$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $b1e11a606f143445$var$n.current
    };
}
$b1e11a606f143445$export$ffb0004e005737fa = $b1e11a606f143445$var$l;
$b1e11a606f143445$export$34b9dba7ce09269b = $b1e11a606f143445$var$q;
$b1e11a606f143445$export$25062201e9e25d76 = $b1e11a606f143445$var$q;

});
parcelRegister("1EuC8", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dB41e"));

});
parcelRegister("dB41e", function(module, exports) {

$parcel$export(module.exports, "Children", () => $9e61d920aea51fe2$export$dca3b0875bd9a954, (v) => $9e61d920aea51fe2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $9e61d920aea51fe2$export$16fa2f45be04daa8, (v) => $9e61d920aea51fe2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $9e61d920aea51fe2$export$ffb0004e005737fa, (v) => $9e61d920aea51fe2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $9e61d920aea51fe2$export$e2c29f18771995cb, (v) => $9e61d920aea51fe2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $9e61d920aea51fe2$export$221d75b3f55bb0bd, (v) => $9e61d920aea51fe2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $9e61d920aea51fe2$export$5f8d39834fd61797, (v) => $9e61d920aea51fe2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9e61d920aea51fe2$export$74bf444e3cd11ea5, (v) => $9e61d920aea51fe2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $9e61d920aea51fe2$export$ae55be85d98224ed, (v) => $9e61d920aea51fe2$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $9e61d920aea51fe2$export$e530037191fcd5d7, (v) => $9e61d920aea51fe2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $9e61d920aea51fe2$export$fd42f52fd3ae1109, (v) => $9e61d920aea51fe2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $9e61d920aea51fe2$export$c8a8987d4410bf2d, (v) => $9e61d920aea51fe2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $9e61d920aea51fe2$export$d38cd72104c1f0e9, (v) => $9e61d920aea51fe2$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $9e61d920aea51fe2$export$7d1e3a5e95ceca43, (v) => $9e61d920aea51fe2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $9e61d920aea51fe2$export$257a8862b851cb5b, (v) => $9e61d920aea51fe2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $9e61d920aea51fe2$export$a8257692ac88316c, (v) => $9e61d920aea51fe2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $9e61d920aea51fe2$export$488013bae63b21da, (v) => $9e61d920aea51fe2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $9e61d920aea51fe2$export$7c73462e0d25e514, (v) => $9e61d920aea51fe2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $9e61d920aea51fe2$export$7568632d0d33d16d, (v) => $9e61d920aea51fe2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $9e61d920aea51fe2$export$88948ce120ea2619, (v) => $9e61d920aea51fe2$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $9e61d920aea51fe2$export$35808ee640e87ca7, (v) => $9e61d920aea51fe2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $9e61d920aea51fe2$export$fae74005e78b1a27, (v) => $9e61d920aea51fe2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $9e61d920aea51fe2$export$dc8fbce3eb94dc1e, (v) => $9e61d920aea51fe2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $9e61d920aea51fe2$export$6a7bc4e911dc01cf, (v) => $9e61d920aea51fe2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $9e61d920aea51fe2$export$6d9c69b0de29b591, (v) => $9e61d920aea51fe2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $9e61d920aea51fe2$export$f680877a34711e37, (v) => $9e61d920aea51fe2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $9e61d920aea51fe2$export$d5a552a76deda3c2, (v) => $9e61d920aea51fe2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $9e61d920aea51fe2$export$aaabe4eda9ed9969, (v) => $9e61d920aea51fe2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $9e61d920aea51fe2$export$e5c5a5f917a5871c, (v) => $9e61d920aea51fe2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $9e61d920aea51fe2$export$1538c33de8887b59, (v) => $9e61d920aea51fe2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $9e61d920aea51fe2$export$13e3392192263954, (v) => $9e61d920aea51fe2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $9e61d920aea51fe2$export$b8f5890fc79d6aca, (v) => $9e61d920aea51fe2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $9e61d920aea51fe2$export$60241385465d0a34, (v) => $9e61d920aea51fe2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $9e61d920aea51fe2$export$306c0aa65ff9ec16, (v) => $9e61d920aea51fe2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $9e61d920aea51fe2$export$7b286972b8d8ccbf, (v) => $9e61d920aea51fe2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $9e61d920aea51fe2$export$83d89fbfd8236492, (v) => $9e61d920aea51fe2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9e61d920aea51fe2$export$dca3b0875bd9a954;
var $9e61d920aea51fe2$export$16fa2f45be04daa8;
var $9e61d920aea51fe2$export$ffb0004e005737fa;
var $9e61d920aea51fe2$export$e2c29f18771995cb;
var $9e61d920aea51fe2$export$221d75b3f55bb0bd;
var $9e61d920aea51fe2$export$5f8d39834fd61797;
var $9e61d920aea51fe2$export$74bf444e3cd11ea5;
var $9e61d920aea51fe2$export$ae55be85d98224ed;
var $9e61d920aea51fe2$export$e530037191fcd5d7;
var $9e61d920aea51fe2$export$fd42f52fd3ae1109;
var $9e61d920aea51fe2$export$c8a8987d4410bf2d;
var $9e61d920aea51fe2$export$d38cd72104c1f0e9;
var $9e61d920aea51fe2$export$7d1e3a5e95ceca43;
var $9e61d920aea51fe2$export$257a8862b851cb5b;
var $9e61d920aea51fe2$export$a8257692ac88316c;
var $9e61d920aea51fe2$export$488013bae63b21da;
var $9e61d920aea51fe2$export$7c73462e0d25e514;
var $9e61d920aea51fe2$export$7568632d0d33d16d;
var $9e61d920aea51fe2$export$88948ce120ea2619;
var $9e61d920aea51fe2$export$35808ee640e87ca7;
var $9e61d920aea51fe2$export$fae74005e78b1a27;
var $9e61d920aea51fe2$export$dc8fbce3eb94dc1e;
var $9e61d920aea51fe2$export$6a7bc4e911dc01cf;
var $9e61d920aea51fe2$export$6d9c69b0de29b591;
var $9e61d920aea51fe2$export$f680877a34711e37;
var $9e61d920aea51fe2$export$d5a552a76deda3c2;
var $9e61d920aea51fe2$export$aaabe4eda9ed9969;
var $9e61d920aea51fe2$export$e5c5a5f917a5871c;
var $9e61d920aea51fe2$export$1538c33de8887b59;
var $9e61d920aea51fe2$export$13e3392192263954;
var $9e61d920aea51fe2$export$b8f5890fc79d6aca;
var $9e61d920aea51fe2$export$60241385465d0a34;
var $9e61d920aea51fe2$export$306c0aa65ff9ec16;
var $9e61d920aea51fe2$export$7b286972b8d8ccbf;
var $9e61d920aea51fe2$export$83d89fbfd8236492;
"use strict";
var $9e61d920aea51fe2$var$l = Symbol.for("react.element"), $9e61d920aea51fe2$var$n = Symbol.for("react.portal"), $9e61d920aea51fe2$var$p = Symbol.for("react.fragment"), $9e61d920aea51fe2$var$q = Symbol.for("react.strict_mode"), $9e61d920aea51fe2$var$r = Symbol.for("react.profiler"), $9e61d920aea51fe2$var$t = Symbol.for("react.provider"), $9e61d920aea51fe2$var$u = Symbol.for("react.context"), $9e61d920aea51fe2$var$v = Symbol.for("react.forward_ref"), $9e61d920aea51fe2$var$w = Symbol.for("react.suspense"), $9e61d920aea51fe2$var$x = Symbol.for("react.memo"), $9e61d920aea51fe2$var$y = Symbol.for("react.lazy"), $9e61d920aea51fe2$var$z = Symbol.iterator;
function $9e61d920aea51fe2$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9e61d920aea51fe2$var$z && a[$9e61d920aea51fe2$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9e61d920aea51fe2$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $9e61d920aea51fe2$var$C = Object.assign, $9e61d920aea51fe2$var$D = {};
function $9e61d920aea51fe2$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $9e61d920aea51fe2$var$D;
    this.updater = e || $9e61d920aea51fe2$var$B;
}
$9e61d920aea51fe2$var$E.prototype.isReactComponent = {};
$9e61d920aea51fe2$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$9e61d920aea51fe2$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $9e61d920aea51fe2$var$F() {}
$9e61d920aea51fe2$var$F.prototype = $9e61d920aea51fe2$var$E.prototype;
function $9e61d920aea51fe2$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $9e61d920aea51fe2$var$D;
    this.updater = e || $9e61d920aea51fe2$var$B;
}
var $9e61d920aea51fe2$var$H = $9e61d920aea51fe2$var$G.prototype = new $9e61d920aea51fe2$var$F;
$9e61d920aea51fe2$var$H.constructor = $9e61d920aea51fe2$var$G;
$9e61d920aea51fe2$var$C($9e61d920aea51fe2$var$H, $9e61d920aea51fe2$var$E.prototype);
$9e61d920aea51fe2$var$H.isPureReactComponent = !0;
var $9e61d920aea51fe2$var$I = Array.isArray, $9e61d920aea51fe2$var$J = Object.prototype.hasOwnProperty, $9e61d920aea51fe2$var$K = {
    current: null
}, $9e61d920aea51fe2$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $9e61d920aea51fe2$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$9e61d920aea51fe2$var$J.call(b, d) && !$9e61d920aea51fe2$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $9e61d920aea51fe2$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $9e61d920aea51fe2$var$K.current
    };
}
function $9e61d920aea51fe2$var$N(a, b) {
    return {
        $$typeof: $9e61d920aea51fe2$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $9e61d920aea51fe2$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9e61d920aea51fe2$var$l;
}
function $9e61d920aea51fe2$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $9e61d920aea51fe2$var$P = /\/+/g;
function $9e61d920aea51fe2$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $9e61d920aea51fe2$var$escape("" + a.key) : b.toString(36);
}
function $9e61d920aea51fe2$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $9e61d920aea51fe2$var$l:
                case $9e61d920aea51fe2$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $9e61d920aea51fe2$var$Q(h, 0) : d, $9e61d920aea51fe2$var$I(c) ? (e = "", null != a && (e = a.replace($9e61d920aea51fe2$var$P, "$&/") + "/"), $9e61d920aea51fe2$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($9e61d920aea51fe2$var$O(c) && (c = $9e61d920aea51fe2$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($9e61d920aea51fe2$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($9e61d920aea51fe2$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $9e61d920aea51fe2$var$Q(k, g);
        h += $9e61d920aea51fe2$var$R(k, b, e, f, c);
    }
    else if (f = $9e61d920aea51fe2$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $9e61d920aea51fe2$var$Q(k, g++), h += $9e61d920aea51fe2$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $9e61d920aea51fe2$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $9e61d920aea51fe2$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $9e61d920aea51fe2$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $9e61d920aea51fe2$var$U = {
    current: null
}, $9e61d920aea51fe2$var$V = {
    transition: null
}, $9e61d920aea51fe2$var$W = {
    ReactCurrentDispatcher: $9e61d920aea51fe2$var$U,
    ReactCurrentBatchConfig: $9e61d920aea51fe2$var$V,
    ReactCurrentOwner: $9e61d920aea51fe2$var$K
};
$9e61d920aea51fe2$export$dca3b0875bd9a954 = {
    map: $9e61d920aea51fe2$var$S,
    forEach: function(a, b, e) {
        $9e61d920aea51fe2$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $9e61d920aea51fe2$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $9e61d920aea51fe2$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$9e61d920aea51fe2$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$9e61d920aea51fe2$export$16fa2f45be04daa8 = $9e61d920aea51fe2$var$E;
$9e61d920aea51fe2$export$ffb0004e005737fa = $9e61d920aea51fe2$var$p;
$9e61d920aea51fe2$export$e2c29f18771995cb = $9e61d920aea51fe2$var$r;
$9e61d920aea51fe2$export$221d75b3f55bb0bd = $9e61d920aea51fe2$var$G;
$9e61d920aea51fe2$export$5f8d39834fd61797 = $9e61d920aea51fe2$var$q;
$9e61d920aea51fe2$export$74bf444e3cd11ea5 = $9e61d920aea51fe2$var$w;
$9e61d920aea51fe2$export$ae55be85d98224ed = $9e61d920aea51fe2$var$W;
$9e61d920aea51fe2$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $9e61d920aea51fe2$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $9e61d920aea51fe2$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$9e61d920aea51fe2$var$J.call(b, f) && !$9e61d920aea51fe2$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $9e61d920aea51fe2$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$9e61d920aea51fe2$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $9e61d920aea51fe2$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $9e61d920aea51fe2$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$9e61d920aea51fe2$export$c8a8987d4410bf2d = $9e61d920aea51fe2$var$M;
$9e61d920aea51fe2$export$d38cd72104c1f0e9 = function(a) {
    var b = $9e61d920aea51fe2$var$M.bind(null, a);
    b.type = a;
    return b;
};
$9e61d920aea51fe2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$9e61d920aea51fe2$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $9e61d920aea51fe2$var$v,
        render: a
    };
};
$9e61d920aea51fe2$export$a8257692ac88316c = $9e61d920aea51fe2$var$O;
$9e61d920aea51fe2$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $9e61d920aea51fe2$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $9e61d920aea51fe2$var$T
    };
};
$9e61d920aea51fe2$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $9e61d920aea51fe2$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$9e61d920aea51fe2$export$7568632d0d33d16d = function(a) {
    var b = $9e61d920aea51fe2$var$V.transition;
    $9e61d920aea51fe2$var$V.transition = {};
    try {
        a();
    } finally{
        $9e61d920aea51fe2$var$V.transition = b;
    }
};
$9e61d920aea51fe2$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$9e61d920aea51fe2$export$35808ee640e87ca7 = function(a, b) {
    return $9e61d920aea51fe2$var$U.current.useCallback(a, b);
};
$9e61d920aea51fe2$export$fae74005e78b1a27 = function(a) {
    return $9e61d920aea51fe2$var$U.current.useContext(a);
};
$9e61d920aea51fe2$export$dc8fbce3eb94dc1e = function() {};
$9e61d920aea51fe2$export$6a7bc4e911dc01cf = function(a) {
    return $9e61d920aea51fe2$var$U.current.useDeferredValue(a);
};
$9e61d920aea51fe2$export$6d9c69b0de29b591 = function(a, b) {
    return $9e61d920aea51fe2$var$U.current.useEffect(a, b);
};
$9e61d920aea51fe2$export$f680877a34711e37 = function() {
    return $9e61d920aea51fe2$var$U.current.useId();
};
$9e61d920aea51fe2$export$d5a552a76deda3c2 = function(a, b, e) {
    return $9e61d920aea51fe2$var$U.current.useImperativeHandle(a, b, e);
};
$9e61d920aea51fe2$export$aaabe4eda9ed9969 = function(a, b) {
    return $9e61d920aea51fe2$var$U.current.useInsertionEffect(a, b);
};
$9e61d920aea51fe2$export$e5c5a5f917a5871c = function(a, b) {
    return $9e61d920aea51fe2$var$U.current.useLayoutEffect(a, b);
};
$9e61d920aea51fe2$export$1538c33de8887b59 = function(a, b) {
    return $9e61d920aea51fe2$var$U.current.useMemo(a, b);
};
$9e61d920aea51fe2$export$13e3392192263954 = function(a, b, e) {
    return $9e61d920aea51fe2$var$U.current.useReducer(a, b, e);
};
$9e61d920aea51fe2$export$b8f5890fc79d6aca = function(a) {
    return $9e61d920aea51fe2$var$U.current.useRef(a);
};
$9e61d920aea51fe2$export$60241385465d0a34 = function(a) {
    return $9e61d920aea51fe2$var$U.current.useState(a);
};
$9e61d920aea51fe2$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $9e61d920aea51fe2$var$U.current.useSyncExternalStore(a, b, e);
};
$9e61d920aea51fe2$export$7b286972b8d8ccbf = function() {
    return $9e61d920aea51fe2$var$U.current.useTransition();
};
$9e61d920aea51fe2$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("k9STf", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $eacf39ed46aa2edf$export$2b8d127b894957b9, (v) => $eacf39ed46aa2edf$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $eacf39ed46aa2edf$export$cea3a54a6425200c, (v) => $eacf39ed46aa2edf$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $eacf39ed46aa2edf$export$a7c73072b1a182ae, (v) => $eacf39ed46aa2edf$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $eacf39ed46aa2edf$export$9f27bc3417b4524d, (v) => $eacf39ed46aa2edf$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $eacf39ed46aa2edf$export$db77ccec0bb4ccac, (v) => $eacf39ed46aa2edf$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $eacf39ed46aa2edf$export$8392c0c9d3dcbd35, (v) => $eacf39ed46aa2edf$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $eacf39ed46aa2edf$export$ffb0004e005737fa, (v) => $eacf39ed46aa2edf$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $eacf39ed46aa2edf$export$b624eff549462981, (v) => $eacf39ed46aa2edf$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $eacf39ed46aa2edf$export$7897aa7841a5380c, (v) => $eacf39ed46aa2edf$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $eacf39ed46aa2edf$export$602eac185826482c, (v) => $eacf39ed46aa2edf$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $eacf39ed46aa2edf$export$e2c29f18771995cb, (v) => $eacf39ed46aa2edf$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $eacf39ed46aa2edf$export$5f8d39834fd61797, (v) => $eacf39ed46aa2edf$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $eacf39ed46aa2edf$export$74bf444e3cd11ea5, (v) => $eacf39ed46aa2edf$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $eacf39ed46aa2edf$export$92387174baf9b227, (v) => $eacf39ed46aa2edf$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $eacf39ed46aa2edf$export$ec112efeb987d9c6, (v) => $eacf39ed46aa2edf$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $eacf39ed46aa2edf$export$b706b080d889d2c9, (v) => $eacf39ed46aa2edf$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $eacf39ed46aa2edf$export$5be5a87408f70ddc, (v) => $eacf39ed46aa2edf$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $eacf39ed46aa2edf$export$45a5e7f76e0caa8d, (v) => $eacf39ed46aa2edf$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $eacf39ed46aa2edf$export$455c2e768291efa6, (v) => $eacf39ed46aa2edf$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $eacf39ed46aa2edf$export$9522e17588c12572, (v) => $eacf39ed46aa2edf$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $eacf39ed46aa2edf$export$2110ac352bb060b9, (v) => $eacf39ed46aa2edf$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $eacf39ed46aa2edf$export$56885ab8b9c456ab, (v) => $eacf39ed46aa2edf$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $eacf39ed46aa2edf$export$d927fcb6adf8f9de, (v) => $eacf39ed46aa2edf$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $eacf39ed46aa2edf$export$b82d16f27459e05a, (v) => $eacf39ed46aa2edf$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $eacf39ed46aa2edf$export$522c17b4f5e123e8, (v) => $eacf39ed46aa2edf$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $eacf39ed46aa2edf$export$1aabd8a0274ecfd6, (v) => $eacf39ed46aa2edf$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $eacf39ed46aa2edf$export$9b621391a187a31a, (v) => $eacf39ed46aa2edf$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $eacf39ed46aa2edf$export$f5bbd400c2f4426f, (v) => $eacf39ed46aa2edf$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eacf39ed46aa2edf$export$2b8d127b894957b9;
var $eacf39ed46aa2edf$export$cea3a54a6425200c;
var $eacf39ed46aa2edf$export$a7c73072b1a182ae;
var $eacf39ed46aa2edf$export$9f27bc3417b4524d;
var $eacf39ed46aa2edf$export$db77ccec0bb4ccac;
var $eacf39ed46aa2edf$export$8392c0c9d3dcbd35;
var $eacf39ed46aa2edf$export$ffb0004e005737fa;
var $eacf39ed46aa2edf$export$b624eff549462981;
var $eacf39ed46aa2edf$export$7897aa7841a5380c;
var $eacf39ed46aa2edf$export$602eac185826482c;
var $eacf39ed46aa2edf$export$e2c29f18771995cb;
var $eacf39ed46aa2edf$export$5f8d39834fd61797;
var $eacf39ed46aa2edf$export$74bf444e3cd11ea5;
var $eacf39ed46aa2edf$export$92387174baf9b227;
var $eacf39ed46aa2edf$export$ec112efeb987d9c6;
var $eacf39ed46aa2edf$export$b706b080d889d2c9;
var $eacf39ed46aa2edf$export$5be5a87408f70ddc;
var $eacf39ed46aa2edf$export$45a5e7f76e0caa8d;
var $eacf39ed46aa2edf$export$455c2e768291efa6;
var $eacf39ed46aa2edf$export$9522e17588c12572;
var $eacf39ed46aa2edf$export$2110ac352bb060b9;
var $eacf39ed46aa2edf$export$56885ab8b9c456ab;
var $eacf39ed46aa2edf$export$d927fcb6adf8f9de;
var $eacf39ed46aa2edf$export$b82d16f27459e05a;
var $eacf39ed46aa2edf$export$522c17b4f5e123e8;
var $eacf39ed46aa2edf$export$1aabd8a0274ecfd6;
var $eacf39ed46aa2edf$export$9b621391a187a31a;
var $eacf39ed46aa2edf$export$f5bbd400c2f4426f;
"use strict";
var $eacf39ed46aa2edf$var$b = "function" === typeof Symbol && Symbol.for, $eacf39ed46aa2edf$var$c = $eacf39ed46aa2edf$var$b ? Symbol.for("react.element") : 60103, $eacf39ed46aa2edf$var$d = $eacf39ed46aa2edf$var$b ? Symbol.for("react.portal") : 60106, $eacf39ed46aa2edf$var$e = $eacf39ed46aa2edf$var$b ? Symbol.for("react.fragment") : 60107, $eacf39ed46aa2edf$var$f = $eacf39ed46aa2edf$var$b ? Symbol.for("react.strict_mode") : 60108, $eacf39ed46aa2edf$var$g = $eacf39ed46aa2edf$var$b ? Symbol.for("react.profiler") : 60114, $eacf39ed46aa2edf$var$h = $eacf39ed46aa2edf$var$b ? Symbol.for("react.provider") : 60109, $eacf39ed46aa2edf$var$k = $eacf39ed46aa2edf$var$b ? Symbol.for("react.context") : 60110, $eacf39ed46aa2edf$var$l = $eacf39ed46aa2edf$var$b ? Symbol.for("react.async_mode") : 60111, $eacf39ed46aa2edf$var$m = $eacf39ed46aa2edf$var$b ? Symbol.for("react.concurrent_mode") : 60111, $eacf39ed46aa2edf$var$n = $eacf39ed46aa2edf$var$b ? Symbol.for("react.forward_ref") : 60112, $eacf39ed46aa2edf$var$p = $eacf39ed46aa2edf$var$b ? Symbol.for("react.suspense") : 60113, $eacf39ed46aa2edf$var$q = $eacf39ed46aa2edf$var$b ? Symbol.for("react.suspense_list") : 60120, $eacf39ed46aa2edf$var$r = $eacf39ed46aa2edf$var$b ? Symbol.for("react.memo") : 60115, $eacf39ed46aa2edf$var$t = $eacf39ed46aa2edf$var$b ? Symbol.for("react.lazy") : 60116, $eacf39ed46aa2edf$var$v = $eacf39ed46aa2edf$var$b ? Symbol.for("react.block") : 60121, $eacf39ed46aa2edf$var$w = $eacf39ed46aa2edf$var$b ? Symbol.for("react.fundamental") : 60117, $eacf39ed46aa2edf$var$x = $eacf39ed46aa2edf$var$b ? Symbol.for("react.responder") : 60118, $eacf39ed46aa2edf$var$y = $eacf39ed46aa2edf$var$b ? Symbol.for("react.scope") : 60119;
function $eacf39ed46aa2edf$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $eacf39ed46aa2edf$var$c:
                switch(a = a.type, a){
                    case $eacf39ed46aa2edf$var$l:
                    case $eacf39ed46aa2edf$var$m:
                    case $eacf39ed46aa2edf$var$e:
                    case $eacf39ed46aa2edf$var$g:
                    case $eacf39ed46aa2edf$var$f:
                    case $eacf39ed46aa2edf$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $eacf39ed46aa2edf$var$k:
                            case $eacf39ed46aa2edf$var$n:
                            case $eacf39ed46aa2edf$var$t:
                            case $eacf39ed46aa2edf$var$r:
                            case $eacf39ed46aa2edf$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $eacf39ed46aa2edf$var$d:
                return u;
        }
    }
}
function $eacf39ed46aa2edf$var$A(a) {
    return $eacf39ed46aa2edf$var$z(a) === $eacf39ed46aa2edf$var$m;
}
$eacf39ed46aa2edf$export$2b8d127b894957b9 = $eacf39ed46aa2edf$var$l;
$eacf39ed46aa2edf$export$cea3a54a6425200c = $eacf39ed46aa2edf$var$m;
$eacf39ed46aa2edf$export$a7c73072b1a182ae = $eacf39ed46aa2edf$var$k;
$eacf39ed46aa2edf$export$9f27bc3417b4524d = $eacf39ed46aa2edf$var$h;
$eacf39ed46aa2edf$export$db77ccec0bb4ccac = $eacf39ed46aa2edf$var$c;
$eacf39ed46aa2edf$export$8392c0c9d3dcbd35 = $eacf39ed46aa2edf$var$n;
$eacf39ed46aa2edf$export$ffb0004e005737fa = $eacf39ed46aa2edf$var$e;
$eacf39ed46aa2edf$export$b624eff549462981 = $eacf39ed46aa2edf$var$t;
$eacf39ed46aa2edf$export$7897aa7841a5380c = $eacf39ed46aa2edf$var$r;
$eacf39ed46aa2edf$export$602eac185826482c = $eacf39ed46aa2edf$var$d;
$eacf39ed46aa2edf$export$e2c29f18771995cb = $eacf39ed46aa2edf$var$g;
$eacf39ed46aa2edf$export$5f8d39834fd61797 = $eacf39ed46aa2edf$var$f;
$eacf39ed46aa2edf$export$74bf444e3cd11ea5 = $eacf39ed46aa2edf$var$p;
$eacf39ed46aa2edf$export$92387174baf9b227 = function(a) {
    return $eacf39ed46aa2edf$var$A(a) || $eacf39ed46aa2edf$var$z(a) === $eacf39ed46aa2edf$var$l;
};
$eacf39ed46aa2edf$export$ec112efeb987d9c6 = $eacf39ed46aa2edf$var$A;
$eacf39ed46aa2edf$export$b706b080d889d2c9 = function(a) {
    return $eacf39ed46aa2edf$var$z(a) === $eacf39ed46aa2edf$var$k;
};
$eacf39ed46aa2edf$export$5be5a87408f70ddc = function(a) {
    return $eacf39ed46aa2edf$var$z(a) === $eacf39ed46aa2edf$var$h;
};
$eacf39ed46aa2edf$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $eacf39ed46aa2edf$var$c;
};
$eacf39ed46aa2edf$export$455c2e768291efa6 = function(a) {
    return $eacf39ed46aa2edf$var$z(a) === $eacf39ed46aa2edf$var$n;
};
$eacf39ed46aa2edf$export$9522e17588c12572 = function(a) {
    return $eacf39ed46aa2edf$var$z(a) === $eacf39ed46aa2edf$var$e;
};
$eacf39ed46aa2edf$export$2110ac352bb060b9 = function(a) {
    return $eacf39ed46aa2edf$var$z(a) === $eacf39ed46aa2edf$var$t;
};
$eacf39ed46aa2edf$export$56885ab8b9c456ab = function(a) {
    return $eacf39ed46aa2edf$var$z(a) === $eacf39ed46aa2edf$var$r;
};
$eacf39ed46aa2edf$export$d927fcb6adf8f9de = function(a) {
    return $eacf39ed46aa2edf$var$z(a) === $eacf39ed46aa2edf$var$d;
};
$eacf39ed46aa2edf$export$b82d16f27459e05a = function(a) {
    return $eacf39ed46aa2edf$var$z(a) === $eacf39ed46aa2edf$var$g;
};
$eacf39ed46aa2edf$export$522c17b4f5e123e8 = function(a) {
    return $eacf39ed46aa2edf$var$z(a) === $eacf39ed46aa2edf$var$f;
};
$eacf39ed46aa2edf$export$1aabd8a0274ecfd6 = function(a) {
    return $eacf39ed46aa2edf$var$z(a) === $eacf39ed46aa2edf$var$p;
};
$eacf39ed46aa2edf$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $eacf39ed46aa2edf$var$e || a === $eacf39ed46aa2edf$var$m || a === $eacf39ed46aa2edf$var$g || a === $eacf39ed46aa2edf$var$f || a === $eacf39ed46aa2edf$var$p || a === $eacf39ed46aa2edf$var$q || "object" === typeof a && null !== a && (a.$$typeof === $eacf39ed46aa2edf$var$t || a.$$typeof === $eacf39ed46aa2edf$var$r || a.$$typeof === $eacf39ed46aa2edf$var$h || a.$$typeof === $eacf39ed46aa2edf$var$k || a.$$typeof === $eacf39ed46aa2edf$var$n || a.$$typeof === $eacf39ed46aa2edf$var$w || a.$$typeof === $eacf39ed46aa2edf$var$x || a.$$typeof === $eacf39ed46aa2edf$var$y || a.$$typeof === $eacf39ed46aa2edf$var$v);
};
$eacf39ed46aa2edf$export$f5bbd400c2f4426f = $eacf39ed46aa2edf$var$z;

});

parcelRegister("8MUNR", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $aTPKh = parcelRequire("aTPKh");
function $665ede565220a94c$var$emptyFunction() {}
function $665ede565220a94c$var$emptyFunctionWithReset() {}
$665ede565220a94c$var$emptyFunctionWithReset.resetWarningCache = $665ede565220a94c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aTPKh) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $665ede565220a94c$var$emptyFunctionWithReset,
        resetWarningCache: $665ede565220a94c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("aTPKh", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $7ef72dfc16b7488e$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $7ef72dfc16b7488e$var$ReactPropTypesSecret;

});


parcelRegister("clnOu", function(module, exports) {
function $8fc9eb098d723cb4$var$_extends() {
    return module.exports = $8fc9eb098d723cb4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8fc9eb098d723cb4$var$_extends.apply(null, arguments);
}
module.exports = $8fc9eb098d723cb4$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("e8KCL", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $a4b5faa14259b18e$var$runtime = (parcelRequire("7o1Rq"))();
module.exports = $a4b5faa14259b18e$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $a4b5faa14259b18e$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $a4b5faa14259b18e$var$runtime;
    else Function("r", "regeneratorRuntime = r")($a4b5faa14259b18e$var$runtime);
}

});
parcelRegister("7o1Rq", function(module, exports) {

var $cJzNa = parcelRequire("cJzNa");
var $560c37ca323b57b3$var$_typeof = $cJzNa.default;
function $560c37ca323b57b3$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $560c37ca323b57b3$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $560c37ca323b57b3$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($560c37ca323b57b3$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $560c37ca323b57b3$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cJzNa", function(module, exports) {
function $94557389e001fb76$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $94557389e001fb76$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $94557389e001fb76$var$_typeof(o);
}
module.exports = $94557389e001fb76$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("afboQ", function(module, exports) {

var $1TPU5 = parcelRequire("1TPU5");
function $775425da5f0c1b5f$var$_defineProperty(e, r, t) {
    return (r = $1TPU5(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $775425da5f0c1b5f$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1TPU5", function(module, exports) {

var $cJzNa = parcelRequire("cJzNa");
var $1623307770a8fd52$var$_typeof = $cJzNa.default;

var $dHGeN = parcelRequire("dHGeN");
function $1623307770a8fd52$var$toPropertyKey(t) {
    var i = $dHGeN(t, "string");
    return "symbol" == $1623307770a8fd52$var$_typeof(i) ? i : i + "";
}
module.exports = $1623307770a8fd52$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dHGeN", function(module, exports) {

var $cJzNa = parcelRequire("cJzNa");
var $9fa00e0c04db4940$var$_typeof = $cJzNa.default;
function $9fa00e0c04db4940$var$toPrimitive(t, r) {
    if ("object" != $9fa00e0c04db4940$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9fa00e0c04db4940$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $9fa00e0c04db4940$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("3ir6W", function(module, exports) {
function $26681533e29c0379$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $26681533e29c0379$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $26681533e29c0379$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $26681533e29c0379$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $26681533e29c0379$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("epA29", function(module, exports) {

var $bKcQB = parcelRequire("bKcQB");

var $1gw1O = parcelRequire("1gw1O");

var $2ZFsr = parcelRequire("2ZFsr");

var $bE5s0 = parcelRequire("bE5s0");
function $a7df5a07b4143632$var$_slicedToArray(r, e) {
    return $bKcQB(r) || $1gw1O(r, e) || $2ZFsr(r, e) || $bE5s0();
}
module.exports = $a7df5a07b4143632$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bKcQB", function(module, exports) {
function $88cdf4d7ab94f28a$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $88cdf4d7ab94f28a$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1gw1O", function(module, exports) {
function $0ec02139e1b330b8$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $0ec02139e1b330b8$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2ZFsr", function(module, exports) {

var $3PAzW = parcelRequire("3PAzW");
function $22e16fe69bdcbff9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3PAzW(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3PAzW(r, a) : void 0;
    }
}
module.exports = $22e16fe69bdcbff9$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3PAzW", function(module, exports) {
function $2ca2824703dce122$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $2ca2824703dce122$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("bE5s0", function(module, exports) {
function $87a7a8834da9fe9f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $87a7a8834da9fe9f$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5Qinz", function(module, exports) {
"use strict";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.proxyLogger = $441010cf02c3dddb$var$proxyLogger;
module.exports.setLogger = $441010cf02c3dddb$var$setLogger;

var $441010cf02c3dddb$var$_defineProperty2 = $4n9Eb((parcelRequire("afboQ")));

var $gY4FH = parcelRequire("gY4FH");
function $441010cf02c3dddb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $441010cf02c3dddb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $441010cf02c3dddb$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $441010cf02c3dddb$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $441010cf02c3dddb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $441010cf02c3dddb$var$formatError(o) {
    if (o instanceof Error && !(o instanceof $gY4FH.UnknownError)) return {
        message: o.message,
        stack: o.stack,
        name: o.name
    };
    if ($441010cf02c3dddb$var$hasErrorProperty(o)) {
        var _o$message;
        o.error = $441010cf02c3dddb$var$formatError(o.error);
        o.message = (_o$message = o.message) !== null && _o$message !== void 0 ? _o$message : o.error.message;
    }
    return o;
}
function $441010cf02c3dddb$var$hasErrorProperty(x) {
    return !!(x !== null && x !== void 0 && x.error);
}
var $441010cf02c3dddb$var$_logger = {
    error: function error(code, metadata) {
        metadata = $441010cf02c3dddb$var$formatError(metadata);
        console.error("[next-auth][error][".concat(code, "]"), "\nhttps://next-auth.js.org/errors#".concat(code.toLowerCase()), metadata.message, metadata);
    },
    warn: function warn(code) {
        console.warn("[next-auth][warn][".concat(code, "]"), "\nhttps://next-auth.js.org/warnings#".concat(code.toLowerCase()));
    },
    debug: function debug(code, metadata) {
        console.log("[next-auth][debug][".concat(code, "]"), metadata);
    }
};
function $441010cf02c3dddb$var$setLogger() {
    var newLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var debug = arguments.length > 1 ? arguments[1] : undefined;
    if (!debug) $441010cf02c3dddb$var$_logger.debug = function() {};
    if (newLogger.error) $441010cf02c3dddb$var$_logger.error = newLogger.error;
    if (newLogger.warn) $441010cf02c3dddb$var$_logger.warn = newLogger.warn;
    if (newLogger.debug) $441010cf02c3dddb$var$_logger.debug = newLogger.debug;
}
var $441010cf02c3dddb$var$_default = $441010cf02c3dddb$var$_logger;
module.exports.default = $441010cf02c3dddb$var$_default;
function $441010cf02c3dddb$var$proxyLogger() {
    var logger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $441010cf02c3dddb$var$_logger;
    var basePath = arguments.length > 1 ? arguments[1] : undefined;
    try {
        if (typeof window === "undefined") return logger;
        var clientLogger = {};
        var _loop = function _loop(level) {
            clientLogger[level] = function(code, metadata) {
                $441010cf02c3dddb$var$_logger[level](code, metadata);
                if (level === "error") metadata = $441010cf02c3dddb$var$formatError(metadata);
                metadata.client = true;
                var url = "".concat(basePath, "/_log");
                var body = new URLSearchParams($441010cf02c3dddb$var$_objectSpread({
                    level: level,
                    code: code
                }, metadata));
                if (navigator.sendBeacon) return navigator.sendBeacon(url, body);
                return fetch(url, {
                    method: "POST",
                    body: body,
                    keepalive: true
                });
            };
        };
        for(var level in logger)_loop(level);
        return clientLogger;
    } catch (_unused) {
        return $441010cf02c3dddb$var$_logger;
    }
}

});
parcelRegister("4n9Eb", function(module, exports) {
function $32f0cb23449de4f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $32f0cb23449de4f3$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gY4FH", function(module, exports) {
"use strict";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnsupportedStrategy = module.exports.UnknownError = module.exports.OAuthCallbackError = module.exports.MissingSecret = module.exports.MissingAuthorize = module.exports.MissingAdapterMethods = module.exports.MissingAdapter = module.exports.MissingAPIRoute = module.exports.InvalidCallbackUrl = module.exports.AccountNotLinkedError = void 0;
module.exports.adapterErrorHandler = $c5a5df9eaa9ea7f3$var$adapterErrorHandler;
module.exports.capitalize = $c5a5df9eaa9ea7f3$var$capitalize;
module.exports.eventsErrorHandler = $c5a5df9eaa9ea7f3$var$eventsErrorHandler;
module.exports.upperSnake = $c5a5df9eaa9ea7f3$var$upperSnake;

var $c5a5df9eaa9ea7f3$var$_regenerator = $4n9Eb((parcelRequire("e8KCL")));

var $c5a5df9eaa9ea7f3$var$_asyncToGenerator2 = $4n9Eb((parcelRequire("3ir6W")));

var $c5a5df9eaa9ea7f3$var$_assertThisInitialized2 = $4n9Eb((parcelRequire("lU6Jh")));

var $c5a5df9eaa9ea7f3$var$_defineProperty2 = $4n9Eb((parcelRequire("afboQ")));

var $c5a5df9eaa9ea7f3$var$_classCallCheck2 = $4n9Eb((parcelRequire("c9D2Q")));

var $c5a5df9eaa9ea7f3$var$_createClass2 = $4n9Eb((parcelRequire("lE7J7")));

var $c5a5df9eaa9ea7f3$var$_inherits2 = $4n9Eb((parcelRequire("eBQvp")));

var $c5a5df9eaa9ea7f3$var$_possibleConstructorReturn2 = $4n9Eb((parcelRequire("9r7xm")));

var $c5a5df9eaa9ea7f3$var$_getPrototypeOf2 = $4n9Eb((parcelRequire("7v5hG")));

var $c5a5df9eaa9ea7f3$var$_wrapNativeSuper2 = $4n9Eb((parcelRequire("j8Uox")));
function $c5a5df9eaa9ea7f3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c5a5df9eaa9ea7f3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $c5a5df9eaa9ea7f3$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $c5a5df9eaa9ea7f3$var$_getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c5a5df9eaa9ea7f3$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $c5a5df9eaa9ea7f3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $c5a5df9eaa9ea7f3$var$UnknownError = function(_Error) {
    (0, $c5a5df9eaa9ea7f3$var$_inherits2.default)(UnknownError, _Error);
    var _super = $c5a5df9eaa9ea7f3$var$_createSuper(UnknownError);
    function UnknownError(error) {
        var _message;
        var _this;
        (0, $c5a5df9eaa9ea7f3$var$_classCallCheck2.default)(this, UnknownError);
        _this = _super.call(this, (_message = error === null || error === void 0 ? void 0 : error.message) !== null && _message !== void 0 ? _message : error);
        _this.name = "UnknownError";
        _this.code = error.code;
        if (error instanceof Error) _this.stack = error.stack;
        return _this;
    }
    (0, $c5a5df9eaa9ea7f3$var$_createClass2.default)(UnknownError, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    name: this.name,
                    message: this.message,
                    stack: this.stack
                };
            }
        }
    ]);
    return UnknownError;
}((0, $c5a5df9eaa9ea7f3$var$_wrapNativeSuper2.default)(Error));
module.exports.UnknownError = $c5a5df9eaa9ea7f3$var$UnknownError;
var $c5a5df9eaa9ea7f3$var$OAuthCallbackError = function(_UnknownError) {
    (0, $c5a5df9eaa9ea7f3$var$_inherits2.default)(OAuthCallbackError, _UnknownError);
    var _super2 = $c5a5df9eaa9ea7f3$var$_createSuper(OAuthCallbackError);
    function OAuthCallbackError() {
        var _this2;
        (0, $c5a5df9eaa9ea7f3$var$_classCallCheck2.default)(this, OAuthCallbackError);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this2), "name", "OAuthCallbackError");
        return _this2;
    }
    return (0, $c5a5df9eaa9ea7f3$var$_createClass2.default)(OAuthCallbackError);
}($c5a5df9eaa9ea7f3$var$UnknownError);
module.exports.OAuthCallbackError = $c5a5df9eaa9ea7f3$var$OAuthCallbackError;
var $c5a5df9eaa9ea7f3$var$AccountNotLinkedError = function(_UnknownError2) {
    (0, $c5a5df9eaa9ea7f3$var$_inherits2.default)(AccountNotLinkedError, _UnknownError2);
    var _super3 = $c5a5df9eaa9ea7f3$var$_createSuper(AccountNotLinkedError);
    function AccountNotLinkedError() {
        var _this3;
        (0, $c5a5df9eaa9ea7f3$var$_classCallCheck2.default)(this, AccountNotLinkedError);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this3 = _super3.call.apply(_super3, [
            this
        ].concat(args));
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this3), "name", "AccountNotLinkedError");
        return _this3;
    }
    return (0, $c5a5df9eaa9ea7f3$var$_createClass2.default)(AccountNotLinkedError);
}($c5a5df9eaa9ea7f3$var$UnknownError);
module.exports.AccountNotLinkedError = $c5a5df9eaa9ea7f3$var$AccountNotLinkedError;
var $c5a5df9eaa9ea7f3$var$MissingAPIRoute = function(_UnknownError3) {
    (0, $c5a5df9eaa9ea7f3$var$_inherits2.default)(MissingAPIRoute, _UnknownError3);
    var _super4 = $c5a5df9eaa9ea7f3$var$_createSuper(MissingAPIRoute);
    function MissingAPIRoute() {
        var _this4;
        (0, $c5a5df9eaa9ea7f3$var$_classCallCheck2.default)(this, MissingAPIRoute);
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        _this4 = _super4.call.apply(_super4, [
            this
        ].concat(args));
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this4), "name", "MissingAPIRouteError");
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this4), "code", "MISSING_NEXTAUTH_API_ROUTE_ERROR");
        return _this4;
    }
    return (0, $c5a5df9eaa9ea7f3$var$_createClass2.default)(MissingAPIRoute);
}($c5a5df9eaa9ea7f3$var$UnknownError);
module.exports.MissingAPIRoute = $c5a5df9eaa9ea7f3$var$MissingAPIRoute;
var $c5a5df9eaa9ea7f3$var$MissingSecret = function(_UnknownError4) {
    (0, $c5a5df9eaa9ea7f3$var$_inherits2.default)(MissingSecret, _UnknownError4);
    var _super5 = $c5a5df9eaa9ea7f3$var$_createSuper(MissingSecret);
    function MissingSecret() {
        var _this5;
        (0, $c5a5df9eaa9ea7f3$var$_classCallCheck2.default)(this, MissingSecret);
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        _this5 = _super5.call.apply(_super5, [
            this
        ].concat(args));
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this5), "name", "MissingSecretError");
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this5), "code", "NO_SECRET");
        return _this5;
    }
    return (0, $c5a5df9eaa9ea7f3$var$_createClass2.default)(MissingSecret);
}($c5a5df9eaa9ea7f3$var$UnknownError);
module.exports.MissingSecret = $c5a5df9eaa9ea7f3$var$MissingSecret;
var $c5a5df9eaa9ea7f3$var$MissingAuthorize = function(_UnknownError5) {
    (0, $c5a5df9eaa9ea7f3$var$_inherits2.default)(MissingAuthorize, _UnknownError5);
    var _super6 = $c5a5df9eaa9ea7f3$var$_createSuper(MissingAuthorize);
    function MissingAuthorize() {
        var _this6;
        (0, $c5a5df9eaa9ea7f3$var$_classCallCheck2.default)(this, MissingAuthorize);
        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
        _this6 = _super6.call.apply(_super6, [
            this
        ].concat(args));
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this6), "name", "MissingAuthorizeError");
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this6), "code", "CALLBACK_CREDENTIALS_HANDLER_ERROR");
        return _this6;
    }
    return (0, $c5a5df9eaa9ea7f3$var$_createClass2.default)(MissingAuthorize);
}($c5a5df9eaa9ea7f3$var$UnknownError);
module.exports.MissingAuthorize = $c5a5df9eaa9ea7f3$var$MissingAuthorize;
var $c5a5df9eaa9ea7f3$var$MissingAdapter = function(_UnknownError6) {
    (0, $c5a5df9eaa9ea7f3$var$_inherits2.default)(MissingAdapter, _UnknownError6);
    var _super7 = $c5a5df9eaa9ea7f3$var$_createSuper(MissingAdapter);
    function MissingAdapter() {
        var _this7;
        (0, $c5a5df9eaa9ea7f3$var$_classCallCheck2.default)(this, MissingAdapter);
        for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
        _this7 = _super7.call.apply(_super7, [
            this
        ].concat(args));
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this7), "name", "MissingAdapterError");
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this7), "code", "EMAIL_REQUIRES_ADAPTER_ERROR");
        return _this7;
    }
    return (0, $c5a5df9eaa9ea7f3$var$_createClass2.default)(MissingAdapter);
}($c5a5df9eaa9ea7f3$var$UnknownError);
module.exports.MissingAdapter = $c5a5df9eaa9ea7f3$var$MissingAdapter;
var $c5a5df9eaa9ea7f3$var$MissingAdapterMethods = function(_UnknownError7) {
    (0, $c5a5df9eaa9ea7f3$var$_inherits2.default)(MissingAdapterMethods, _UnknownError7);
    var _super8 = $c5a5df9eaa9ea7f3$var$_createSuper(MissingAdapterMethods);
    function MissingAdapterMethods() {
        var _this8;
        (0, $c5a5df9eaa9ea7f3$var$_classCallCheck2.default)(this, MissingAdapterMethods);
        for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
        _this8 = _super8.call.apply(_super8, [
            this
        ].concat(args));
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this8), "name", "MissingAdapterMethodsError");
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this8), "code", "MISSING_ADAPTER_METHODS_ERROR");
        return _this8;
    }
    return (0, $c5a5df9eaa9ea7f3$var$_createClass2.default)(MissingAdapterMethods);
}($c5a5df9eaa9ea7f3$var$UnknownError);
module.exports.MissingAdapterMethods = $c5a5df9eaa9ea7f3$var$MissingAdapterMethods;
var $c5a5df9eaa9ea7f3$var$UnsupportedStrategy = function(_UnknownError8) {
    (0, $c5a5df9eaa9ea7f3$var$_inherits2.default)(UnsupportedStrategy, _UnknownError8);
    var _super9 = $c5a5df9eaa9ea7f3$var$_createSuper(UnsupportedStrategy);
    function UnsupportedStrategy() {
        var _this9;
        (0, $c5a5df9eaa9ea7f3$var$_classCallCheck2.default)(this, UnsupportedStrategy);
        for(var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)args[_key8] = arguments[_key8];
        _this9 = _super9.call.apply(_super9, [
            this
        ].concat(args));
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this9), "name", "UnsupportedStrategyError");
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this9), "code", "CALLBACK_CREDENTIALS_JWT_ERROR");
        return _this9;
    }
    return (0, $c5a5df9eaa9ea7f3$var$_createClass2.default)(UnsupportedStrategy);
}($c5a5df9eaa9ea7f3$var$UnknownError);
module.exports.UnsupportedStrategy = $c5a5df9eaa9ea7f3$var$UnsupportedStrategy;
var $c5a5df9eaa9ea7f3$var$InvalidCallbackUrl = function(_UnknownError9) {
    (0, $c5a5df9eaa9ea7f3$var$_inherits2.default)(InvalidCallbackUrl, _UnknownError9);
    var _super10 = $c5a5df9eaa9ea7f3$var$_createSuper(InvalidCallbackUrl);
    function InvalidCallbackUrl() {
        var _this10;
        (0, $c5a5df9eaa9ea7f3$var$_classCallCheck2.default)(this, InvalidCallbackUrl);
        for(var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++)args[_key9] = arguments[_key9];
        _this10 = _super10.call.apply(_super10, [
            this
        ].concat(args));
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this10), "name", "InvalidCallbackUrl");
        (0, $c5a5df9eaa9ea7f3$var$_defineProperty2.default)((0, $c5a5df9eaa9ea7f3$var$_assertThisInitialized2.default)(_this10), "code", "INVALID_CALLBACK_URL_ERROR");
        return _this10;
    }
    return (0, $c5a5df9eaa9ea7f3$var$_createClass2.default)(InvalidCallbackUrl);
}($c5a5df9eaa9ea7f3$var$UnknownError);
module.exports.InvalidCallbackUrl = $c5a5df9eaa9ea7f3$var$InvalidCallbackUrl;
function $c5a5df9eaa9ea7f3$var$upperSnake(s) {
    return s.replace(/([A-Z])/g, "_$1").toUpperCase();
}
function $c5a5df9eaa9ea7f3$var$capitalize(s) {
    return "".concat(s[0].toUpperCase()).concat(s.slice(1));
}
function $c5a5df9eaa9ea7f3$var$eventsErrorHandler(methods, logger) {
    return Object.keys(methods).reduce(function(acc, name) {
        acc[name] = (0, $c5a5df9eaa9ea7f3$var$_asyncToGenerator2.default)($c5a5df9eaa9ea7f3$var$_regenerator.default.mark(function _callee() {
            var method, _args = arguments;
            return $c5a5df9eaa9ea7f3$var$_regenerator.default.wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        method = methods[name];
                        _context.next = 4;
                        return method.apply(void 0, _args);
                    case 4:
                        return _context.abrupt("return", _context.sent);
                    case 7:
                        _context.prev = 7;
                        _context.t0 = _context["catch"](0);
                        logger.error("".concat($c5a5df9eaa9ea7f3$var$upperSnake(name), "_EVENT_ERROR"), _context.t0);
                    case 10:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return acc;
    }, {});
}
function $c5a5df9eaa9ea7f3$var$adapterErrorHandler(adapter, logger) {
    if (!adapter) return;
    return Object.keys(adapter).reduce(function(acc, name) {
        acc[name] = (0, $c5a5df9eaa9ea7f3$var$_asyncToGenerator2.default)($c5a5df9eaa9ea7f3$var$_regenerator.default.mark(function _callee2() {
            var _len10, args, _key10, method, e, _args2 = arguments;
            return $c5a5df9eaa9ea7f3$var$_regenerator.default.wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        _context2.prev = 0;
                        for(_len10 = _args2.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++)args[_key10] = _args2[_key10];
                        logger.debug("adapter_".concat(name), {
                            args: args
                        });
                        method = adapter[name];
                        _context2.next = 6;
                        return method.apply(void 0, args);
                    case 6:
                        return _context2.abrupt("return", _context2.sent);
                    case 9:
                        _context2.prev = 9;
                        _context2.t0 = _context2["catch"](0);
                        logger.error("adapter_error_".concat(name), _context2.t0);
                        e = new $c5a5df9eaa9ea7f3$var$UnknownError(_context2.t0);
                        e.name = "".concat($c5a5df9eaa9ea7f3$var$capitalize(name), "Error");
                        throw e;
                    case 15:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return acc;
    }, {});
}

});
parcelRegister("lU6Jh", function(module, exports) {
function $ff240c40855ba476$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $ff240c40855ba476$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("c9D2Q", function(module, exports) {
function $8d949cc613b4959b$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $8d949cc613b4959b$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lE7J7", function(module, exports) {

var $1TPU5 = parcelRequire("1TPU5");
function $fc2353bdbb1db15f$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $1TPU5(o.key), o);
    }
}
function $fc2353bdbb1db15f$var$_createClass(e, r, t) {
    return r && $fc2353bdbb1db15f$var$_defineProperties(e.prototype, r), t && $fc2353bdbb1db15f$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $fc2353bdbb1db15f$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eBQvp", function(module, exports) {

var $asohR = parcelRequire("asohR");
function $aa2d3feaf2f157c6$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $asohR(t, e);
}
module.exports = $aa2d3feaf2f157c6$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("asohR", function(module, exports) {
function $79cf5bd2024abd0b$var$_setPrototypeOf(t, e) {
    return module.exports = $79cf5bd2024abd0b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $79cf5bd2024abd0b$var$_setPrototypeOf(t, e);
}
module.exports = $79cf5bd2024abd0b$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9r7xm", function(module, exports) {

var $cJzNa = parcelRequire("cJzNa");
var $6dec7b624117bae8$var$_typeof = $cJzNa.default;

var $lU6Jh = parcelRequire("lU6Jh");
function $6dec7b624117bae8$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $6dec7b624117bae8$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $lU6Jh(t);
}
module.exports = $6dec7b624117bae8$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7v5hG", function(module, exports) {
function $575f86f9c696b88e$var$_getPrototypeOf(t) {
    return module.exports = $575f86f9c696b88e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $575f86f9c696b88e$var$_getPrototypeOf(t);
}
module.exports = $575f86f9c696b88e$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("j8Uox", function(module, exports) {

var $7v5hG = parcelRequire("7v5hG");

var $asohR = parcelRequire("asohR");

var $5LEoL = parcelRequire("5LEoL");

var $deGvi = parcelRequire("deGvi");
function $defa82877d943fd4$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $defa82877d943fd4$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$5LEoL(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $deGvi(t, arguments, $7v5hG(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $asohR(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $defa82877d943fd4$var$_wrapNativeSuper(t);
}
module.exports = $defa82877d943fd4$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5LEoL", function(module, exports) {
function $4330adce3c42c19d$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $4330adce3c42c19d$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("deGvi", function(module, exports) {

var $2jZKy = parcelRequire("2jZKy");

var $asohR = parcelRequire("asohR");
function $9a2d8d8712c438fa$var$_construct(t, e, r) {
    if ($2jZKy()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $asohR(p, r.prototype), p;
}
module.exports = $9a2d8d8712c438fa$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2jZKy", function(module, exports) {
function $1b0d4157caa1e973$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $1b0d4157caa1e973$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $1b0d4157caa1e973$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("lfY47", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f799976e7cfb0abe$var$parseUrl;
function $f799976e7cfb0abe$var$parseUrl(url) {
    var _url2;
    const defaultUrl = new URL("http://localhost:3000/api/auth");
    if (url && !url.startsWith("http")) url = `https://${url}`;
    const _url = new URL((_url2 = url) !== null && _url2 !== void 0 ? _url2 : defaultUrl);
    const path = (_url.pathname === "/" ? defaultUrl.pathname : _url.pathname).replace(/\/$/, "");
    const base = `${_url.origin}${path}`;
    return {
        origin: _url.origin,
        host: _url.host,
        path: path,
        base: base,
        toString: ()=>base
    };
}

});

parcelRegister("jZkR6", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $e8d3e44a030e0375$export$ae55be85d98224ed, (v) => $e8d3e44a030e0375$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $e8d3e44a030e0375$export$d39a5bbd09211389, (v) => $e8d3e44a030e0375$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $e8d3e44a030e0375$export$882461b6382ed46c, (v) => $e8d3e44a030e0375$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $e8d3e44a030e0375$export$466bfc07425424d5, (v) => $e8d3e44a030e0375$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $e8d3e44a030e0375$export$cd75ccfd720a3cd4, (v) => $e8d3e44a030e0375$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $e8d3e44a030e0375$export$fa8d919ba61d84db, (v) => $e8d3e44a030e0375$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $e8d3e44a030e0375$export$757ceba2d55c277e, (v) => $e8d3e44a030e0375$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $e8d3e44a030e0375$export$b3890eb0ae9dca99, (v) => $e8d3e44a030e0375$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $e8d3e44a030e0375$export$502457920280e6be, (v) => $e8d3e44a030e0375$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $e8d3e44a030e0375$export$c78a37762a8d58e1, (v) => $e8d3e44a030e0375$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $e8d3e44a030e0375$export$dc54d992c10e8a18, (v) => $e8d3e44a030e0375$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $e8d3e44a030e0375$export$83d89fbfd8236492, (v) => $e8d3e44a030e0375$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e8d3e44a030e0375$export$ae55be85d98224ed;
var $e8d3e44a030e0375$export$d39a5bbd09211389;
var $e8d3e44a030e0375$export$882461b6382ed46c;
var $e8d3e44a030e0375$export$466bfc07425424d5;
var $e8d3e44a030e0375$export$cd75ccfd720a3cd4;
var $e8d3e44a030e0375$export$fa8d919ba61d84db;
var $e8d3e44a030e0375$export$757ceba2d55c277e;
var $e8d3e44a030e0375$export$b3890eb0ae9dca99;
var $e8d3e44a030e0375$export$502457920280e6be;
var $e8d3e44a030e0375$export$c78a37762a8d58e1;
var $e8d3e44a030e0375$export$dc54d992c10e8a18;
var $e8d3e44a030e0375$export$83d89fbfd8236492;
"use strict";

var $1EuC8 = parcelRequire("1EuC8");

var $hTW2z = parcelRequire("hTW2z");
function $e8d3e44a030e0375$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e8d3e44a030e0375$var$da = new Set, $e8d3e44a030e0375$var$ea = {};
function $e8d3e44a030e0375$var$fa(a, b) {
    $e8d3e44a030e0375$var$ha(a, b);
    $e8d3e44a030e0375$var$ha(a + "Capture", b);
}
function $e8d3e44a030e0375$var$ha(a, b) {
    $e8d3e44a030e0375$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e8d3e44a030e0375$var$da.add(b[a]);
}
var $e8d3e44a030e0375$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e8d3e44a030e0375$var$ja = Object.prototype.hasOwnProperty, $e8d3e44a030e0375$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e8d3e44a030e0375$var$la = {}, $e8d3e44a030e0375$var$ma = {};
function $e8d3e44a030e0375$var$oa(a) {
    if ($e8d3e44a030e0375$var$ja.call($e8d3e44a030e0375$var$ma, a)) return !0;
    if ($e8d3e44a030e0375$var$ja.call($e8d3e44a030e0375$var$la, a)) return !1;
    if ($e8d3e44a030e0375$var$ka.test(a)) return $e8d3e44a030e0375$var$ma[a] = !0;
    $e8d3e44a030e0375$var$la[a] = !0;
    return !1;
}
function $e8d3e44a030e0375$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e8d3e44a030e0375$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e8d3e44a030e0375$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e8d3e44a030e0375$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e8d3e44a030e0375$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e8d3e44a030e0375$var$z[a] = new $e8d3e44a030e0375$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e8d3e44a030e0375$var$z[b] = new $e8d3e44a030e0375$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e8d3e44a030e0375$var$z[a] = new $e8d3e44a030e0375$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e8d3e44a030e0375$var$z[a] = new $e8d3e44a030e0375$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e8d3e44a030e0375$var$z[a] = new $e8d3e44a030e0375$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e8d3e44a030e0375$var$z[a] = new $e8d3e44a030e0375$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e8d3e44a030e0375$var$z[a] = new $e8d3e44a030e0375$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e8d3e44a030e0375$var$z[a] = new $e8d3e44a030e0375$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e8d3e44a030e0375$var$z[a] = new $e8d3e44a030e0375$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e8d3e44a030e0375$var$ra = /[\-:]([a-z])/g;
function $e8d3e44a030e0375$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e8d3e44a030e0375$var$ra, $e8d3e44a030e0375$var$sa);
    $e8d3e44a030e0375$var$z[b] = new $e8d3e44a030e0375$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e8d3e44a030e0375$var$ra, $e8d3e44a030e0375$var$sa);
    $e8d3e44a030e0375$var$z[b] = new $e8d3e44a030e0375$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e8d3e44a030e0375$var$ra, $e8d3e44a030e0375$var$sa);
    $e8d3e44a030e0375$var$z[b] = new $e8d3e44a030e0375$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e8d3e44a030e0375$var$z[a] = new $e8d3e44a030e0375$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e8d3e44a030e0375$var$z.xlinkHref = new $e8d3e44a030e0375$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e8d3e44a030e0375$var$z[a] = new $e8d3e44a030e0375$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e8d3e44a030e0375$var$ta(a, b, c, d) {
    var e = $e8d3e44a030e0375$var$z.hasOwnProperty(b) ? $e8d3e44a030e0375$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e8d3e44a030e0375$var$qa(b, c, e, d) && (c = null), d || null === e ? $e8d3e44a030e0375$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e8d3e44a030e0375$var$ua = $1EuC8.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e8d3e44a030e0375$var$va = Symbol.for("react.element"), $e8d3e44a030e0375$var$wa = Symbol.for("react.portal"), $e8d3e44a030e0375$var$ya = Symbol.for("react.fragment"), $e8d3e44a030e0375$var$za = Symbol.for("react.strict_mode"), $e8d3e44a030e0375$var$Aa = Symbol.for("react.profiler"), $e8d3e44a030e0375$var$Ba = Symbol.for("react.provider"), $e8d3e44a030e0375$var$Ca = Symbol.for("react.context"), $e8d3e44a030e0375$var$Da = Symbol.for("react.forward_ref"), $e8d3e44a030e0375$var$Ea = Symbol.for("react.suspense"), $e8d3e44a030e0375$var$Fa = Symbol.for("react.suspense_list"), $e8d3e44a030e0375$var$Ga = Symbol.for("react.memo"), $e8d3e44a030e0375$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e8d3e44a030e0375$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e8d3e44a030e0375$var$Ja = Symbol.iterator;
function $e8d3e44a030e0375$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e8d3e44a030e0375$var$Ja && a[$e8d3e44a030e0375$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e8d3e44a030e0375$var$A = Object.assign, $e8d3e44a030e0375$var$La;
function $e8d3e44a030e0375$var$Ma(a) {
    if (void 0 === $e8d3e44a030e0375$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e8d3e44a030e0375$var$La = b && b[1] || "";
    }
    return "\n" + $e8d3e44a030e0375$var$La + a;
}
var $e8d3e44a030e0375$var$Na = !1;
function $e8d3e44a030e0375$var$Oa(a, b) {
    if (!a || $e8d3e44a030e0375$var$Na) return "";
    $e8d3e44a030e0375$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e8d3e44a030e0375$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e8d3e44a030e0375$var$Ma(a) : "";
}
function $e8d3e44a030e0375$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e8d3e44a030e0375$var$Ma(a.type);
        case 16:
            return $e8d3e44a030e0375$var$Ma("Lazy");
        case 13:
            return $e8d3e44a030e0375$var$Ma("Suspense");
        case 19:
            return $e8d3e44a030e0375$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e8d3e44a030e0375$var$Oa(a.type, !1), a;
        case 11:
            return a = $e8d3e44a030e0375$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e8d3e44a030e0375$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e8d3e44a030e0375$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e8d3e44a030e0375$var$ya:
            return "Fragment";
        case $e8d3e44a030e0375$var$wa:
            return "Portal";
        case $e8d3e44a030e0375$var$Aa:
            return "Profiler";
        case $e8d3e44a030e0375$var$za:
            return "StrictMode";
        case $e8d3e44a030e0375$var$Ea:
            return "Suspense";
        case $e8d3e44a030e0375$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e8d3e44a030e0375$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e8d3e44a030e0375$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e8d3e44a030e0375$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e8d3e44a030e0375$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e8d3e44a030e0375$var$Qa(a.type) || "Memo";
        case $e8d3e44a030e0375$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e8d3e44a030e0375$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e8d3e44a030e0375$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e8d3e44a030e0375$var$Qa(b);
        case 8:
            return b === $e8d3e44a030e0375$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e8d3e44a030e0375$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e8d3e44a030e0375$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e8d3e44a030e0375$var$Ua(a) {
    var b = $e8d3e44a030e0375$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e8d3e44a030e0375$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e8d3e44a030e0375$var$Ua(a));
}
function $e8d3e44a030e0375$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e8d3e44a030e0375$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e8d3e44a030e0375$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e8d3e44a030e0375$var$Ya(a, b) {
    var c = b.checked;
    return $e8d3e44a030e0375$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e8d3e44a030e0375$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e8d3e44a030e0375$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e8d3e44a030e0375$var$ab(a, b) {
    b = b.checked;
    null != b && $e8d3e44a030e0375$var$ta(a, "checked", b, !1);
}
function $e8d3e44a030e0375$var$bb(a, b) {
    $e8d3e44a030e0375$var$ab(a, b);
    var c = $e8d3e44a030e0375$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e8d3e44a030e0375$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e8d3e44a030e0375$var$cb(a, b.type, $e8d3e44a030e0375$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e8d3e44a030e0375$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e8d3e44a030e0375$var$cb(a, b, c) {
    if ("number" !== b || $e8d3e44a030e0375$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e8d3e44a030e0375$var$eb = Array.isArray;
function $e8d3e44a030e0375$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e8d3e44a030e0375$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e8d3e44a030e0375$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e8d3e44a030e0375$var$p(91));
    return $e8d3e44a030e0375$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e8d3e44a030e0375$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e8d3e44a030e0375$var$p(92));
            if ($e8d3e44a030e0375$var$eb(c)) {
                if (1 < c.length) throw Error($e8d3e44a030e0375$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e8d3e44a030e0375$var$Sa(c)
    };
}
function $e8d3e44a030e0375$var$ib(a, b) {
    var c = $e8d3e44a030e0375$var$Sa(b.value), d = $e8d3e44a030e0375$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e8d3e44a030e0375$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e8d3e44a030e0375$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e8d3e44a030e0375$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e8d3e44a030e0375$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e8d3e44a030e0375$var$mb, $e8d3e44a030e0375$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e8d3e44a030e0375$var$mb = $e8d3e44a030e0375$var$mb || document.createElement("div");
        $e8d3e44a030e0375$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e8d3e44a030e0375$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e8d3e44a030e0375$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e8d3e44a030e0375$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e8d3e44a030e0375$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e8d3e44a030e0375$var$pb).forEach(function(a) {
    $e8d3e44a030e0375$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e8d3e44a030e0375$var$pb[b] = $e8d3e44a030e0375$var$pb[a];
    });
});
function $e8d3e44a030e0375$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e8d3e44a030e0375$var$pb.hasOwnProperty(a) && $e8d3e44a030e0375$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e8d3e44a030e0375$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e8d3e44a030e0375$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e8d3e44a030e0375$var$tb = $e8d3e44a030e0375$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e8d3e44a030e0375$var$ub(a, b) {
    if (b) {
        if ($e8d3e44a030e0375$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e8d3e44a030e0375$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e8d3e44a030e0375$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e8d3e44a030e0375$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e8d3e44a030e0375$var$p(62));
    }
}
function $e8d3e44a030e0375$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e8d3e44a030e0375$var$wb = null;
function $e8d3e44a030e0375$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e8d3e44a030e0375$var$yb = null, $e8d3e44a030e0375$var$zb = null, $e8d3e44a030e0375$var$Ab = null;
function $e8d3e44a030e0375$var$Bb(a) {
    if (a = $e8d3e44a030e0375$var$Cb(a)) {
        if ("function" !== typeof $e8d3e44a030e0375$var$yb) throw Error($e8d3e44a030e0375$var$p(280));
        var b = a.stateNode;
        b && (b = $e8d3e44a030e0375$var$Db(b), $e8d3e44a030e0375$var$yb(a.stateNode, a.type, b));
    }
}
function $e8d3e44a030e0375$var$Eb(a) {
    $e8d3e44a030e0375$var$zb ? $e8d3e44a030e0375$var$Ab ? $e8d3e44a030e0375$var$Ab.push(a) : $e8d3e44a030e0375$var$Ab = [
        a
    ] : $e8d3e44a030e0375$var$zb = a;
}
function $e8d3e44a030e0375$var$Fb() {
    if ($e8d3e44a030e0375$var$zb) {
        var a = $e8d3e44a030e0375$var$zb, b = $e8d3e44a030e0375$var$Ab;
        $e8d3e44a030e0375$var$Ab = $e8d3e44a030e0375$var$zb = null;
        $e8d3e44a030e0375$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e8d3e44a030e0375$var$Bb(b[a]);
    }
}
function $e8d3e44a030e0375$var$Gb(a, b) {
    return a(b);
}
function $e8d3e44a030e0375$var$Hb() {}
var $e8d3e44a030e0375$var$Ib = !1;
function $e8d3e44a030e0375$var$Jb(a, b, c) {
    if ($e8d3e44a030e0375$var$Ib) return a(b, c);
    $e8d3e44a030e0375$var$Ib = !0;
    try {
        return $e8d3e44a030e0375$var$Gb(a, b, c);
    } finally{
        if ($e8d3e44a030e0375$var$Ib = !1, null !== $e8d3e44a030e0375$var$zb || null !== $e8d3e44a030e0375$var$Ab) $e8d3e44a030e0375$var$Hb(), $e8d3e44a030e0375$var$Fb();
    }
}
function $e8d3e44a030e0375$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e8d3e44a030e0375$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e8d3e44a030e0375$var$p(231, b, typeof c));
    return c;
}
var $e8d3e44a030e0375$var$Lb = !1;
if ($e8d3e44a030e0375$var$ia) try {
    var $e8d3e44a030e0375$var$Mb = {};
    Object.defineProperty($e8d3e44a030e0375$var$Mb, "passive", {
        get: function() {
            $e8d3e44a030e0375$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e8d3e44a030e0375$var$Mb, $e8d3e44a030e0375$var$Mb);
    window.removeEventListener("test", $e8d3e44a030e0375$var$Mb, $e8d3e44a030e0375$var$Mb);
} catch (a) {
    $e8d3e44a030e0375$var$Lb = !1;
}
function $e8d3e44a030e0375$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e8d3e44a030e0375$var$Ob = !1, $e8d3e44a030e0375$var$Pb = null, $e8d3e44a030e0375$var$Qb = !1, $e8d3e44a030e0375$var$Rb = null, $e8d3e44a030e0375$var$Sb = {
    onError: function(a) {
        $e8d3e44a030e0375$var$Ob = !0;
        $e8d3e44a030e0375$var$Pb = a;
    }
};
function $e8d3e44a030e0375$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e8d3e44a030e0375$var$Ob = !1;
    $e8d3e44a030e0375$var$Pb = null;
    $e8d3e44a030e0375$var$Nb.apply($e8d3e44a030e0375$var$Sb, arguments);
}
function $e8d3e44a030e0375$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e8d3e44a030e0375$var$Tb.apply(this, arguments);
    if ($e8d3e44a030e0375$var$Ob) {
        if ($e8d3e44a030e0375$var$Ob) {
            var l = $e8d3e44a030e0375$var$Pb;
            $e8d3e44a030e0375$var$Ob = !1;
            $e8d3e44a030e0375$var$Pb = null;
        } else throw Error($e8d3e44a030e0375$var$p(198));
        $e8d3e44a030e0375$var$Qb || ($e8d3e44a030e0375$var$Qb = !0, $e8d3e44a030e0375$var$Rb = l);
    }
}
function $e8d3e44a030e0375$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e8d3e44a030e0375$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e8d3e44a030e0375$var$Xb(a) {
    if ($e8d3e44a030e0375$var$Vb(a) !== a) throw Error($e8d3e44a030e0375$var$p(188));
}
function $e8d3e44a030e0375$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e8d3e44a030e0375$var$Vb(a);
        if (null === b) throw Error($e8d3e44a030e0375$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e8d3e44a030e0375$var$Xb(e), a;
                if (f === d) return $e8d3e44a030e0375$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e8d3e44a030e0375$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e8d3e44a030e0375$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e8d3e44a030e0375$var$p(190));
    }
    if (3 !== c.tag) throw Error($e8d3e44a030e0375$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e8d3e44a030e0375$var$Zb(a) {
    a = $e8d3e44a030e0375$var$Yb(a);
    return null !== a ? $e8d3e44a030e0375$var$$b(a) : null;
}
function $e8d3e44a030e0375$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e8d3e44a030e0375$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e8d3e44a030e0375$var$ac = $hTW2z.unstable_scheduleCallback, $e8d3e44a030e0375$var$bc = $hTW2z.unstable_cancelCallback, $e8d3e44a030e0375$var$cc = $hTW2z.unstable_shouldYield, $e8d3e44a030e0375$var$dc = $hTW2z.unstable_requestPaint, $e8d3e44a030e0375$var$B = $hTW2z.unstable_now, $e8d3e44a030e0375$var$ec = $hTW2z.unstable_getCurrentPriorityLevel, $e8d3e44a030e0375$var$fc = $hTW2z.unstable_ImmediatePriority, $e8d3e44a030e0375$var$gc = $hTW2z.unstable_UserBlockingPriority, $e8d3e44a030e0375$var$hc = $hTW2z.unstable_NormalPriority, $e8d3e44a030e0375$var$ic = $hTW2z.unstable_LowPriority, $e8d3e44a030e0375$var$jc = $hTW2z.unstable_IdlePriority, $e8d3e44a030e0375$var$kc = null, $e8d3e44a030e0375$var$lc = null;
function $e8d3e44a030e0375$var$mc(a) {
    if ($e8d3e44a030e0375$var$lc && "function" === typeof $e8d3e44a030e0375$var$lc.onCommitFiberRoot) try {
        $e8d3e44a030e0375$var$lc.onCommitFiberRoot($e8d3e44a030e0375$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e8d3e44a030e0375$var$oc = Math.clz32 ? Math.clz32 : $e8d3e44a030e0375$var$nc, $e8d3e44a030e0375$var$pc = Math.log, $e8d3e44a030e0375$var$qc = Math.LN2;
function $e8d3e44a030e0375$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e8d3e44a030e0375$var$pc(a) / $e8d3e44a030e0375$var$qc | 0) | 0;
}
var $e8d3e44a030e0375$var$rc = 64, $e8d3e44a030e0375$var$sc = 4194304;
function $e8d3e44a030e0375$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e8d3e44a030e0375$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e8d3e44a030e0375$var$tc(h) : (f &= g, 0 !== f && (d = $e8d3e44a030e0375$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e8d3e44a030e0375$var$tc(g) : 0 !== f && (d = $e8d3e44a030e0375$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e8d3e44a030e0375$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e8d3e44a030e0375$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e8d3e44a030e0375$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e8d3e44a030e0375$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e8d3e44a030e0375$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e8d3e44a030e0375$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e8d3e44a030e0375$var$yc() {
    var a = $e8d3e44a030e0375$var$rc;
    $e8d3e44a030e0375$var$rc <<= 1;
    0 === ($e8d3e44a030e0375$var$rc & 4194240) && ($e8d3e44a030e0375$var$rc = 64);
    return a;
}
function $e8d3e44a030e0375$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e8d3e44a030e0375$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e8d3e44a030e0375$var$oc(b);
    a[b] = c;
}
function $e8d3e44a030e0375$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e8d3e44a030e0375$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e8d3e44a030e0375$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e8d3e44a030e0375$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e8d3e44a030e0375$var$C = 0;
function $e8d3e44a030e0375$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e8d3e44a030e0375$var$Ec, $e8d3e44a030e0375$var$Fc, $e8d3e44a030e0375$var$Gc, $e8d3e44a030e0375$var$Hc, $e8d3e44a030e0375$var$Ic, $e8d3e44a030e0375$var$Jc = !1, $e8d3e44a030e0375$var$Kc = [], $e8d3e44a030e0375$var$Lc = null, $e8d3e44a030e0375$var$Mc = null, $e8d3e44a030e0375$var$Nc = null, $e8d3e44a030e0375$var$Oc = new Map, $e8d3e44a030e0375$var$Pc = new Map, $e8d3e44a030e0375$var$Qc = [], $e8d3e44a030e0375$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e8d3e44a030e0375$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e8d3e44a030e0375$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e8d3e44a030e0375$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e8d3e44a030e0375$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e8d3e44a030e0375$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e8d3e44a030e0375$var$Pc.delete(b.pointerId);
    }
}
function $e8d3e44a030e0375$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e8d3e44a030e0375$var$Cb(b), null !== b && $e8d3e44a030e0375$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e8d3e44a030e0375$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e8d3e44a030e0375$var$Lc = $e8d3e44a030e0375$var$Tc($e8d3e44a030e0375$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e8d3e44a030e0375$var$Mc = $e8d3e44a030e0375$var$Tc($e8d3e44a030e0375$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e8d3e44a030e0375$var$Nc = $e8d3e44a030e0375$var$Tc($e8d3e44a030e0375$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e8d3e44a030e0375$var$Oc.set(f, $e8d3e44a030e0375$var$Tc($e8d3e44a030e0375$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e8d3e44a030e0375$var$Pc.set(f, $e8d3e44a030e0375$var$Tc($e8d3e44a030e0375$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e8d3e44a030e0375$var$Vc(a) {
    var b = $e8d3e44a030e0375$var$Wc(a.target);
    if (null !== b) {
        var c = $e8d3e44a030e0375$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e8d3e44a030e0375$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e8d3e44a030e0375$var$Ic(a.priority, function() {
                        $e8d3e44a030e0375$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e8d3e44a030e0375$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e8d3e44a030e0375$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e8d3e44a030e0375$var$wb = d;
            c.target.dispatchEvent(d);
            $e8d3e44a030e0375$var$wb = null;
        } else return b = $e8d3e44a030e0375$var$Cb(c), null !== b && $e8d3e44a030e0375$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e8d3e44a030e0375$var$Zc(a, b, c) {
    $e8d3e44a030e0375$var$Xc(a) && c.delete(b);
}
function $e8d3e44a030e0375$var$$c() {
    $e8d3e44a030e0375$var$Jc = !1;
    null !== $e8d3e44a030e0375$var$Lc && $e8d3e44a030e0375$var$Xc($e8d3e44a030e0375$var$Lc) && ($e8d3e44a030e0375$var$Lc = null);
    null !== $e8d3e44a030e0375$var$Mc && $e8d3e44a030e0375$var$Xc($e8d3e44a030e0375$var$Mc) && ($e8d3e44a030e0375$var$Mc = null);
    null !== $e8d3e44a030e0375$var$Nc && $e8d3e44a030e0375$var$Xc($e8d3e44a030e0375$var$Nc) && ($e8d3e44a030e0375$var$Nc = null);
    $e8d3e44a030e0375$var$Oc.forEach($e8d3e44a030e0375$var$Zc);
    $e8d3e44a030e0375$var$Pc.forEach($e8d3e44a030e0375$var$Zc);
}
function $e8d3e44a030e0375$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e8d3e44a030e0375$var$Jc || ($e8d3e44a030e0375$var$Jc = !0, $hTW2z.unstable_scheduleCallback($hTW2z.unstable_NormalPriority, $e8d3e44a030e0375$var$$c)));
}
function $e8d3e44a030e0375$var$bd(a) {
    function b(b) {
        return $e8d3e44a030e0375$var$ad(b, a);
    }
    if (0 < $e8d3e44a030e0375$var$Kc.length) {
        $e8d3e44a030e0375$var$ad($e8d3e44a030e0375$var$Kc[0], a);
        for(var c = 1; c < $e8d3e44a030e0375$var$Kc.length; c++){
            var d = $e8d3e44a030e0375$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e8d3e44a030e0375$var$Lc && $e8d3e44a030e0375$var$ad($e8d3e44a030e0375$var$Lc, a);
    null !== $e8d3e44a030e0375$var$Mc && $e8d3e44a030e0375$var$ad($e8d3e44a030e0375$var$Mc, a);
    null !== $e8d3e44a030e0375$var$Nc && $e8d3e44a030e0375$var$ad($e8d3e44a030e0375$var$Nc, a);
    $e8d3e44a030e0375$var$Oc.forEach(b);
    $e8d3e44a030e0375$var$Pc.forEach(b);
    for(c = 0; c < $e8d3e44a030e0375$var$Qc.length; c++)d = $e8d3e44a030e0375$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e8d3e44a030e0375$var$Qc.length && (c = $e8d3e44a030e0375$var$Qc[0], null === c.blockedOn);)$e8d3e44a030e0375$var$Vc(c), null === c.blockedOn && $e8d3e44a030e0375$var$Qc.shift();
}
var $e8d3e44a030e0375$var$cd = $e8d3e44a030e0375$var$ua.ReactCurrentBatchConfig, $e8d3e44a030e0375$var$dd = !0;
function $e8d3e44a030e0375$var$ed(a, b, c, d) {
    var e = $e8d3e44a030e0375$var$C, f = $e8d3e44a030e0375$var$cd.transition;
    $e8d3e44a030e0375$var$cd.transition = null;
    try {
        $e8d3e44a030e0375$var$C = 1, $e8d3e44a030e0375$var$fd(a, b, c, d);
    } finally{
        $e8d3e44a030e0375$var$C = e, $e8d3e44a030e0375$var$cd.transition = f;
    }
}
function $e8d3e44a030e0375$var$gd(a, b, c, d) {
    var e = $e8d3e44a030e0375$var$C, f = $e8d3e44a030e0375$var$cd.transition;
    $e8d3e44a030e0375$var$cd.transition = null;
    try {
        $e8d3e44a030e0375$var$C = 4, $e8d3e44a030e0375$var$fd(a, b, c, d);
    } finally{
        $e8d3e44a030e0375$var$C = e, $e8d3e44a030e0375$var$cd.transition = f;
    }
}
function $e8d3e44a030e0375$var$fd(a, b, c, d) {
    if ($e8d3e44a030e0375$var$dd) {
        var e = $e8d3e44a030e0375$var$Yc(a, b, c, d);
        if (null === e) $e8d3e44a030e0375$var$hd(a, b, d, $e8d3e44a030e0375$var$id, c), $e8d3e44a030e0375$var$Sc(a, d);
        else if ($e8d3e44a030e0375$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e8d3e44a030e0375$var$Sc(a, d), b & 4 && -1 < $e8d3e44a030e0375$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e8d3e44a030e0375$var$Cb(e);
                null !== f && $e8d3e44a030e0375$var$Ec(f);
                f = $e8d3e44a030e0375$var$Yc(a, b, c, d);
                null === f && $e8d3e44a030e0375$var$hd(a, b, d, $e8d3e44a030e0375$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e8d3e44a030e0375$var$hd(a, b, d, null, c);
    }
}
var $e8d3e44a030e0375$var$id = null;
function $e8d3e44a030e0375$var$Yc(a, b, c, d) {
    $e8d3e44a030e0375$var$id = null;
    a = $e8d3e44a030e0375$var$xb(d);
    a = $e8d3e44a030e0375$var$Wc(a);
    if (null !== a) {
        if (b = $e8d3e44a030e0375$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e8d3e44a030e0375$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e8d3e44a030e0375$var$id = a;
    return null;
}
function $e8d3e44a030e0375$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e8d3e44a030e0375$var$ec()){
                case $e8d3e44a030e0375$var$fc:
                    return 1;
                case $e8d3e44a030e0375$var$gc:
                    return 4;
                case $e8d3e44a030e0375$var$hc:
                case $e8d3e44a030e0375$var$ic:
                    return 16;
                case $e8d3e44a030e0375$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e8d3e44a030e0375$var$kd = null, $e8d3e44a030e0375$var$ld = null, $e8d3e44a030e0375$var$md = null;
function $e8d3e44a030e0375$var$nd() {
    if ($e8d3e44a030e0375$var$md) return $e8d3e44a030e0375$var$md;
    var a, b = $e8d3e44a030e0375$var$ld, c = b.length, d, e = "value" in $e8d3e44a030e0375$var$kd ? $e8d3e44a030e0375$var$kd.value : $e8d3e44a030e0375$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e8d3e44a030e0375$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e8d3e44a030e0375$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e8d3e44a030e0375$var$pd() {
    return !0;
}
function $e8d3e44a030e0375$var$qd() {
    return !1;
}
function $e8d3e44a030e0375$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e8d3e44a030e0375$var$pd : $e8d3e44a030e0375$var$qd;
        this.isPropagationStopped = $e8d3e44a030e0375$var$qd;
        return this;
    }
    $e8d3e44a030e0375$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e8d3e44a030e0375$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e8d3e44a030e0375$var$pd);
        },
        persist: function() {},
        isPersistent: $e8d3e44a030e0375$var$pd
    });
    return b;
}
var $e8d3e44a030e0375$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e8d3e44a030e0375$var$td = $e8d3e44a030e0375$var$rd($e8d3e44a030e0375$var$sd), $e8d3e44a030e0375$var$ud = $e8d3e44a030e0375$var$A({}, $e8d3e44a030e0375$var$sd, {
    view: 0,
    detail: 0
}), $e8d3e44a030e0375$var$vd = $e8d3e44a030e0375$var$rd($e8d3e44a030e0375$var$ud), $e8d3e44a030e0375$var$wd, $e8d3e44a030e0375$var$xd, $e8d3e44a030e0375$var$yd, $e8d3e44a030e0375$var$Ad = $e8d3e44a030e0375$var$A({}, $e8d3e44a030e0375$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e8d3e44a030e0375$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e8d3e44a030e0375$var$yd && ($e8d3e44a030e0375$var$yd && "mousemove" === a.type ? ($e8d3e44a030e0375$var$wd = a.screenX - $e8d3e44a030e0375$var$yd.screenX, $e8d3e44a030e0375$var$xd = a.screenY - $e8d3e44a030e0375$var$yd.screenY) : $e8d3e44a030e0375$var$xd = $e8d3e44a030e0375$var$wd = 0, $e8d3e44a030e0375$var$yd = a);
        return $e8d3e44a030e0375$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e8d3e44a030e0375$var$xd;
    }
}), $e8d3e44a030e0375$var$Bd = $e8d3e44a030e0375$var$rd($e8d3e44a030e0375$var$Ad), $e8d3e44a030e0375$var$Cd = $e8d3e44a030e0375$var$A({}, $e8d3e44a030e0375$var$Ad, {
    dataTransfer: 0
}), $e8d3e44a030e0375$var$Dd = $e8d3e44a030e0375$var$rd($e8d3e44a030e0375$var$Cd), $e8d3e44a030e0375$var$Ed = $e8d3e44a030e0375$var$A({}, $e8d3e44a030e0375$var$ud, {
    relatedTarget: 0
}), $e8d3e44a030e0375$var$Fd = $e8d3e44a030e0375$var$rd($e8d3e44a030e0375$var$Ed), $e8d3e44a030e0375$var$Gd = $e8d3e44a030e0375$var$A({}, $e8d3e44a030e0375$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8d3e44a030e0375$var$Hd = $e8d3e44a030e0375$var$rd($e8d3e44a030e0375$var$Gd), $e8d3e44a030e0375$var$Id = $e8d3e44a030e0375$var$A({}, $e8d3e44a030e0375$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e8d3e44a030e0375$var$Jd = $e8d3e44a030e0375$var$rd($e8d3e44a030e0375$var$Id), $e8d3e44a030e0375$var$Kd = $e8d3e44a030e0375$var$A({}, $e8d3e44a030e0375$var$sd, {
    data: 0
}), $e8d3e44a030e0375$var$Ld = $e8d3e44a030e0375$var$rd($e8d3e44a030e0375$var$Kd), $e8d3e44a030e0375$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e8d3e44a030e0375$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e8d3e44a030e0375$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e8d3e44a030e0375$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e8d3e44a030e0375$var$Od[a]) ? !!b[a] : !1;
}
function $e8d3e44a030e0375$var$zd() {
    return $e8d3e44a030e0375$var$Pd;
}
var $e8d3e44a030e0375$var$Qd = $e8d3e44a030e0375$var$A({}, $e8d3e44a030e0375$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e8d3e44a030e0375$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e8d3e44a030e0375$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e8d3e44a030e0375$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e8d3e44a030e0375$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e8d3e44a030e0375$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e8d3e44a030e0375$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e8d3e44a030e0375$var$Rd = $e8d3e44a030e0375$var$rd($e8d3e44a030e0375$var$Qd), $e8d3e44a030e0375$var$Sd = $e8d3e44a030e0375$var$A({}, $e8d3e44a030e0375$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e8d3e44a030e0375$var$Td = $e8d3e44a030e0375$var$rd($e8d3e44a030e0375$var$Sd), $e8d3e44a030e0375$var$Ud = $e8d3e44a030e0375$var$A({}, $e8d3e44a030e0375$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e8d3e44a030e0375$var$zd
}), $e8d3e44a030e0375$var$Vd = $e8d3e44a030e0375$var$rd($e8d3e44a030e0375$var$Ud), $e8d3e44a030e0375$var$Wd = $e8d3e44a030e0375$var$A({}, $e8d3e44a030e0375$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8d3e44a030e0375$var$Xd = $e8d3e44a030e0375$var$rd($e8d3e44a030e0375$var$Wd), $e8d3e44a030e0375$var$Yd = $e8d3e44a030e0375$var$A({}, $e8d3e44a030e0375$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e8d3e44a030e0375$var$Zd = $e8d3e44a030e0375$var$rd($e8d3e44a030e0375$var$Yd), $e8d3e44a030e0375$var$$d = [
    9,
    13,
    27,
    32
], $e8d3e44a030e0375$var$ae = $e8d3e44a030e0375$var$ia && "CompositionEvent" in window, $e8d3e44a030e0375$var$be = null;
$e8d3e44a030e0375$var$ia && "documentMode" in document && ($e8d3e44a030e0375$var$be = document.documentMode);
var $e8d3e44a030e0375$var$ce = $e8d3e44a030e0375$var$ia && "TextEvent" in window && !$e8d3e44a030e0375$var$be, $e8d3e44a030e0375$var$de = $e8d3e44a030e0375$var$ia && (!$e8d3e44a030e0375$var$ae || $e8d3e44a030e0375$var$be && 8 < $e8d3e44a030e0375$var$be && 11 >= $e8d3e44a030e0375$var$be), $e8d3e44a030e0375$var$ee = String.fromCharCode(32), $e8d3e44a030e0375$var$fe = !1;
function $e8d3e44a030e0375$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e8d3e44a030e0375$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e8d3e44a030e0375$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e8d3e44a030e0375$var$ie = !1;
function $e8d3e44a030e0375$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e8d3e44a030e0375$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e8d3e44a030e0375$var$fe = !0;
            return $e8d3e44a030e0375$var$ee;
        case "textInput":
            return a = b.data, a === $e8d3e44a030e0375$var$ee && $e8d3e44a030e0375$var$fe ? null : a;
        default:
            return null;
    }
}
function $e8d3e44a030e0375$var$ke(a, b) {
    if ($e8d3e44a030e0375$var$ie) return "compositionend" === a || !$e8d3e44a030e0375$var$ae && $e8d3e44a030e0375$var$ge(a, b) ? (a = $e8d3e44a030e0375$var$nd(), $e8d3e44a030e0375$var$md = $e8d3e44a030e0375$var$ld = $e8d3e44a030e0375$var$kd = null, $e8d3e44a030e0375$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e8d3e44a030e0375$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e8d3e44a030e0375$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e8d3e44a030e0375$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e8d3e44a030e0375$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e8d3e44a030e0375$var$ne(a, b, c, d) {
    $e8d3e44a030e0375$var$Eb(d);
    b = $e8d3e44a030e0375$var$oe(b, "onChange");
    0 < b.length && (c = new $e8d3e44a030e0375$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e8d3e44a030e0375$var$pe = null, $e8d3e44a030e0375$var$qe = null;
function $e8d3e44a030e0375$var$re(a) {
    $e8d3e44a030e0375$var$se(a, 0);
}
function $e8d3e44a030e0375$var$te(a) {
    var b = $e8d3e44a030e0375$var$ue(a);
    if ($e8d3e44a030e0375$var$Wa(b)) return a;
}
function $e8d3e44a030e0375$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e8d3e44a030e0375$var$we = !1;
if ($e8d3e44a030e0375$var$ia) {
    var $e8d3e44a030e0375$var$xe;
    if ($e8d3e44a030e0375$var$ia) {
        var $e8d3e44a030e0375$var$ye = "oninput" in document;
        if (!$e8d3e44a030e0375$var$ye) {
            var $e8d3e44a030e0375$var$ze = document.createElement("div");
            $e8d3e44a030e0375$var$ze.setAttribute("oninput", "return;");
            $e8d3e44a030e0375$var$ye = "function" === typeof $e8d3e44a030e0375$var$ze.oninput;
        }
        $e8d3e44a030e0375$var$xe = $e8d3e44a030e0375$var$ye;
    } else $e8d3e44a030e0375$var$xe = !1;
    $e8d3e44a030e0375$var$we = $e8d3e44a030e0375$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e8d3e44a030e0375$var$Ae() {
    $e8d3e44a030e0375$var$pe && ($e8d3e44a030e0375$var$pe.detachEvent("onpropertychange", $e8d3e44a030e0375$var$Be), $e8d3e44a030e0375$var$qe = $e8d3e44a030e0375$var$pe = null);
}
function $e8d3e44a030e0375$var$Be(a) {
    if ("value" === a.propertyName && $e8d3e44a030e0375$var$te($e8d3e44a030e0375$var$qe)) {
        var b = [];
        $e8d3e44a030e0375$var$ne(b, $e8d3e44a030e0375$var$qe, a, $e8d3e44a030e0375$var$xb(a));
        $e8d3e44a030e0375$var$Jb($e8d3e44a030e0375$var$re, b);
    }
}
function $e8d3e44a030e0375$var$Ce(a, b, c) {
    "focusin" === a ? ($e8d3e44a030e0375$var$Ae(), $e8d3e44a030e0375$var$pe = b, $e8d3e44a030e0375$var$qe = c, $e8d3e44a030e0375$var$pe.attachEvent("onpropertychange", $e8d3e44a030e0375$var$Be)) : "focusout" === a && $e8d3e44a030e0375$var$Ae();
}
function $e8d3e44a030e0375$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e8d3e44a030e0375$var$te($e8d3e44a030e0375$var$qe);
}
function $e8d3e44a030e0375$var$Ee(a, b) {
    if ("click" === a) return $e8d3e44a030e0375$var$te(b);
}
function $e8d3e44a030e0375$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e8d3e44a030e0375$var$te(b);
}
function $e8d3e44a030e0375$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e8d3e44a030e0375$var$He = "function" === typeof Object.is ? Object.is : $e8d3e44a030e0375$var$Ge;
function $e8d3e44a030e0375$var$Ie(a, b) {
    if ($e8d3e44a030e0375$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e8d3e44a030e0375$var$ja.call(b, e) || !$e8d3e44a030e0375$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e8d3e44a030e0375$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e8d3e44a030e0375$var$Ke(a, b) {
    var c = $e8d3e44a030e0375$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e8d3e44a030e0375$var$Je(c);
    }
}
function $e8d3e44a030e0375$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e8d3e44a030e0375$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e8d3e44a030e0375$var$Me() {
    for(var a = window, b = $e8d3e44a030e0375$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e8d3e44a030e0375$var$Xa(a.document);
    }
    return b;
}
function $e8d3e44a030e0375$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e8d3e44a030e0375$var$Oe(a) {
    var b = $e8d3e44a030e0375$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e8d3e44a030e0375$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e8d3e44a030e0375$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e8d3e44a030e0375$var$Ke(c, f);
                var g = $e8d3e44a030e0375$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e8d3e44a030e0375$var$Pe = $e8d3e44a030e0375$var$ia && "documentMode" in document && 11 >= document.documentMode, $e8d3e44a030e0375$var$Qe = null, $e8d3e44a030e0375$var$Re = null, $e8d3e44a030e0375$var$Se = null, $e8d3e44a030e0375$var$Te = !1;
function $e8d3e44a030e0375$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e8d3e44a030e0375$var$Te || null == $e8d3e44a030e0375$var$Qe || $e8d3e44a030e0375$var$Qe !== $e8d3e44a030e0375$var$Xa(d) || (d = $e8d3e44a030e0375$var$Qe, "selectionStart" in d && $e8d3e44a030e0375$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e8d3e44a030e0375$var$Se && $e8d3e44a030e0375$var$Ie($e8d3e44a030e0375$var$Se, d) || ($e8d3e44a030e0375$var$Se = d, d = $e8d3e44a030e0375$var$oe($e8d3e44a030e0375$var$Re, "onSelect"), 0 < d.length && (b = new $e8d3e44a030e0375$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e8d3e44a030e0375$var$Qe)));
}
function $e8d3e44a030e0375$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e8d3e44a030e0375$var$We = {
    animationend: $e8d3e44a030e0375$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e8d3e44a030e0375$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e8d3e44a030e0375$var$Ve("Animation", "AnimationStart"),
    transitionend: $e8d3e44a030e0375$var$Ve("Transition", "TransitionEnd")
}, $e8d3e44a030e0375$var$Xe = {}, $e8d3e44a030e0375$var$Ye = {};
$e8d3e44a030e0375$var$ia && ($e8d3e44a030e0375$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e8d3e44a030e0375$var$We.animationend.animation, delete $e8d3e44a030e0375$var$We.animationiteration.animation, delete $e8d3e44a030e0375$var$We.animationstart.animation), "TransitionEvent" in window || delete $e8d3e44a030e0375$var$We.transitionend.transition);
function $e8d3e44a030e0375$var$Ze(a) {
    if ($e8d3e44a030e0375$var$Xe[a]) return $e8d3e44a030e0375$var$Xe[a];
    if (!$e8d3e44a030e0375$var$We[a]) return a;
    var b = $e8d3e44a030e0375$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e8d3e44a030e0375$var$Ye) return $e8d3e44a030e0375$var$Xe[a] = b[c];
    return a;
}
var $e8d3e44a030e0375$var$$e = $e8d3e44a030e0375$var$Ze("animationend"), $e8d3e44a030e0375$var$af = $e8d3e44a030e0375$var$Ze("animationiteration"), $e8d3e44a030e0375$var$bf = $e8d3e44a030e0375$var$Ze("animationstart"), $e8d3e44a030e0375$var$cf = $e8d3e44a030e0375$var$Ze("transitionend"), $e8d3e44a030e0375$var$df = new Map, $e8d3e44a030e0375$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e8d3e44a030e0375$var$ff(a, b) {
    $e8d3e44a030e0375$var$df.set(a, b);
    $e8d3e44a030e0375$var$fa(b, [
        a
    ]);
}
for(var $e8d3e44a030e0375$var$gf = 0; $e8d3e44a030e0375$var$gf < $e8d3e44a030e0375$var$ef.length; $e8d3e44a030e0375$var$gf++){
    var $e8d3e44a030e0375$var$hf = $e8d3e44a030e0375$var$ef[$e8d3e44a030e0375$var$gf], $e8d3e44a030e0375$var$jf = $e8d3e44a030e0375$var$hf.toLowerCase(), $e8d3e44a030e0375$var$kf = $e8d3e44a030e0375$var$hf[0].toUpperCase() + $e8d3e44a030e0375$var$hf.slice(1);
    $e8d3e44a030e0375$var$ff($e8d3e44a030e0375$var$jf, "on" + $e8d3e44a030e0375$var$kf);
}
$e8d3e44a030e0375$var$ff($e8d3e44a030e0375$var$$e, "onAnimationEnd");
$e8d3e44a030e0375$var$ff($e8d3e44a030e0375$var$af, "onAnimationIteration");
$e8d3e44a030e0375$var$ff($e8d3e44a030e0375$var$bf, "onAnimationStart");
$e8d3e44a030e0375$var$ff("dblclick", "onDoubleClick");
$e8d3e44a030e0375$var$ff("focusin", "onFocus");
$e8d3e44a030e0375$var$ff("focusout", "onBlur");
$e8d3e44a030e0375$var$ff($e8d3e44a030e0375$var$cf, "onTransitionEnd");
$e8d3e44a030e0375$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e8d3e44a030e0375$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e8d3e44a030e0375$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e8d3e44a030e0375$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e8d3e44a030e0375$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e8d3e44a030e0375$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e8d3e44a030e0375$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e8d3e44a030e0375$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e8d3e44a030e0375$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e8d3e44a030e0375$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e8d3e44a030e0375$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e8d3e44a030e0375$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e8d3e44a030e0375$var$lf));
function $e8d3e44a030e0375$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e8d3e44a030e0375$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e8d3e44a030e0375$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8d3e44a030e0375$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8d3e44a030e0375$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e8d3e44a030e0375$var$Qb) throw a = $e8d3e44a030e0375$var$Rb, $e8d3e44a030e0375$var$Qb = !1, $e8d3e44a030e0375$var$Rb = null, a;
}
function $e8d3e44a030e0375$var$D(a, b) {
    var c = b[$e8d3e44a030e0375$var$of];
    void 0 === c && (c = b[$e8d3e44a030e0375$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e8d3e44a030e0375$var$pf(b, a, 2, !1), c.add(d));
}
function $e8d3e44a030e0375$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e8d3e44a030e0375$var$pf(c, a, d, b);
}
var $e8d3e44a030e0375$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e8d3e44a030e0375$var$sf(a) {
    if (!a[$e8d3e44a030e0375$var$rf]) {
        a[$e8d3e44a030e0375$var$rf] = !0;
        $e8d3e44a030e0375$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e8d3e44a030e0375$var$mf.has(b) || $e8d3e44a030e0375$var$qf(b, !1, a), $e8d3e44a030e0375$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e8d3e44a030e0375$var$rf] || (b[$e8d3e44a030e0375$var$rf] = !0, $e8d3e44a030e0375$var$qf("selectionchange", !1, b));
    }
}
function $e8d3e44a030e0375$var$pf(a, b, c, d) {
    switch($e8d3e44a030e0375$var$jd(b)){
        case 1:
            var e = $e8d3e44a030e0375$var$ed;
            break;
        case 4:
            e = $e8d3e44a030e0375$var$gd;
            break;
        default:
            e = $e8d3e44a030e0375$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e8d3e44a030e0375$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e8d3e44a030e0375$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e8d3e44a030e0375$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e8d3e44a030e0375$var$Jb(function() {
        var d = f, e = $e8d3e44a030e0375$var$xb(c), g = [];
        a: {
            var h = $e8d3e44a030e0375$var$df.get(a);
            if (void 0 !== h) {
                var k = $e8d3e44a030e0375$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e8d3e44a030e0375$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e8d3e44a030e0375$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e8d3e44a030e0375$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e8d3e44a030e0375$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e8d3e44a030e0375$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e8d3e44a030e0375$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e8d3e44a030e0375$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e8d3e44a030e0375$var$Vd;
                        break;
                    case $e8d3e44a030e0375$var$$e:
                    case $e8d3e44a030e0375$var$af:
                    case $e8d3e44a030e0375$var$bf:
                        k = $e8d3e44a030e0375$var$Hd;
                        break;
                    case $e8d3e44a030e0375$var$cf:
                        k = $e8d3e44a030e0375$var$Xd;
                        break;
                    case "scroll":
                        k = $e8d3e44a030e0375$var$vd;
                        break;
                    case "wheel":
                        k = $e8d3e44a030e0375$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e8d3e44a030e0375$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e8d3e44a030e0375$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e8d3e44a030e0375$var$Kb(w, x), null != F && t.push($e8d3e44a030e0375$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e8d3e44a030e0375$var$wb && (n = c.relatedTarget || c.fromElement) && ($e8d3e44a030e0375$var$Wc(n) || n[$e8d3e44a030e0375$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e8d3e44a030e0375$var$Wc(n) : null, null !== n && (J = $e8d3e44a030e0375$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e8d3e44a030e0375$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e8d3e44a030e0375$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e8d3e44a030e0375$var$ue(k);
                        u = null == n ? h : $e8d3e44a030e0375$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e8d3e44a030e0375$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e8d3e44a030e0375$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e8d3e44a030e0375$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e8d3e44a030e0375$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e8d3e44a030e0375$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e8d3e44a030e0375$var$vf(t);
                                x = $e8d3e44a030e0375$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e8d3e44a030e0375$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e8d3e44a030e0375$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e8d3e44a030e0375$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e8d3e44a030e0375$var$ve;
                else if ($e8d3e44a030e0375$var$me(h)) {
                    if ($e8d3e44a030e0375$var$we) na = $e8d3e44a030e0375$var$Fe;
                    else {
                        na = $e8d3e44a030e0375$var$De;
                        var xa = $e8d3e44a030e0375$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e8d3e44a030e0375$var$Ee);
                if (na && (na = na(a, d))) {
                    $e8d3e44a030e0375$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e8d3e44a030e0375$var$cb(h, "number", h.value);
            }
            xa = d ? $e8d3e44a030e0375$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e8d3e44a030e0375$var$me(xa) || "true" === xa.contentEditable) $e8d3e44a030e0375$var$Qe = xa, $e8d3e44a030e0375$var$Re = d, $e8d3e44a030e0375$var$Se = null;
                    break;
                case "focusout":
                    $e8d3e44a030e0375$var$Se = $e8d3e44a030e0375$var$Re = $e8d3e44a030e0375$var$Qe = null;
                    break;
                case "mousedown":
                    $e8d3e44a030e0375$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e8d3e44a030e0375$var$Te = !1;
                    $e8d3e44a030e0375$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e8d3e44a030e0375$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e8d3e44a030e0375$var$Ue(g, c, e);
            }
            var $a;
            if ($e8d3e44a030e0375$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e8d3e44a030e0375$var$ie ? $e8d3e44a030e0375$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e8d3e44a030e0375$var$de && "ko" !== c.locale && ($e8d3e44a030e0375$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e8d3e44a030e0375$var$ie && ($a = $e8d3e44a030e0375$var$nd()) : ($e8d3e44a030e0375$var$kd = e, $e8d3e44a030e0375$var$ld = "value" in $e8d3e44a030e0375$var$kd ? $e8d3e44a030e0375$var$kd.value : $e8d3e44a030e0375$var$kd.textContent, $e8d3e44a030e0375$var$ie = !0)), xa = $e8d3e44a030e0375$var$oe(d, ba), 0 < xa.length && (ba = new $e8d3e44a030e0375$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e8d3e44a030e0375$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e8d3e44a030e0375$var$ce ? $e8d3e44a030e0375$var$je(a, c) : $e8d3e44a030e0375$var$ke(a, c)) d = $e8d3e44a030e0375$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e8d3e44a030e0375$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e8d3e44a030e0375$var$se(g, b);
    });
}
function $e8d3e44a030e0375$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e8d3e44a030e0375$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e8d3e44a030e0375$var$Kb(a, c), null != f && d.unshift($e8d3e44a030e0375$var$tf(a, f, e)), f = $e8d3e44a030e0375$var$Kb(a, b), null != f && d.push($e8d3e44a030e0375$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e8d3e44a030e0375$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e8d3e44a030e0375$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e8d3e44a030e0375$var$Kb(c, f), null != k && g.unshift($e8d3e44a030e0375$var$tf(c, k, h))) : e || (k = $e8d3e44a030e0375$var$Kb(c, f), null != k && g.push($e8d3e44a030e0375$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e8d3e44a030e0375$var$xf = /\r\n?/g, $e8d3e44a030e0375$var$yf = /\u0000|\uFFFD/g;
function $e8d3e44a030e0375$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e8d3e44a030e0375$var$xf, "\n").replace($e8d3e44a030e0375$var$yf, "");
}
function $e8d3e44a030e0375$var$Af(a, b, c) {
    b = $e8d3e44a030e0375$var$zf(b);
    if ($e8d3e44a030e0375$var$zf(a) !== b && c) throw Error($e8d3e44a030e0375$var$p(425));
}
function $e8d3e44a030e0375$var$Bf() {}
var $e8d3e44a030e0375$var$Cf = null, $e8d3e44a030e0375$var$Df = null;
function $e8d3e44a030e0375$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e8d3e44a030e0375$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e8d3e44a030e0375$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e8d3e44a030e0375$var$Hf = "function" === typeof Promise ? Promise : void 0, $e8d3e44a030e0375$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e8d3e44a030e0375$var$Hf ? function(a) {
    return $e8d3e44a030e0375$var$Hf.resolve(null).then(a).catch($e8d3e44a030e0375$var$If);
} : $e8d3e44a030e0375$var$Ff;
function $e8d3e44a030e0375$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e8d3e44a030e0375$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e8d3e44a030e0375$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e8d3e44a030e0375$var$bd(b);
}
function $e8d3e44a030e0375$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e8d3e44a030e0375$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e8d3e44a030e0375$var$Nf = Math.random().toString(36).slice(2), $e8d3e44a030e0375$var$Of = "__reactFiber$" + $e8d3e44a030e0375$var$Nf, $e8d3e44a030e0375$var$Pf = "__reactProps$" + $e8d3e44a030e0375$var$Nf, $e8d3e44a030e0375$var$uf = "__reactContainer$" + $e8d3e44a030e0375$var$Nf, $e8d3e44a030e0375$var$of = "__reactEvents$" + $e8d3e44a030e0375$var$Nf, $e8d3e44a030e0375$var$Qf = "__reactListeners$" + $e8d3e44a030e0375$var$Nf, $e8d3e44a030e0375$var$Rf = "__reactHandles$" + $e8d3e44a030e0375$var$Nf;
function $e8d3e44a030e0375$var$Wc(a) {
    var b = a[$e8d3e44a030e0375$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e8d3e44a030e0375$var$uf] || c[$e8d3e44a030e0375$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e8d3e44a030e0375$var$Mf(a); null !== a;){
                if (c = a[$e8d3e44a030e0375$var$Of]) return c;
                a = $e8d3e44a030e0375$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e8d3e44a030e0375$var$Cb(a) {
    a = a[$e8d3e44a030e0375$var$Of] || a[$e8d3e44a030e0375$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e8d3e44a030e0375$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e8d3e44a030e0375$var$p(33));
}
function $e8d3e44a030e0375$var$Db(a) {
    return a[$e8d3e44a030e0375$var$Pf] || null;
}
var $e8d3e44a030e0375$var$Sf = [], $e8d3e44a030e0375$var$Tf = -1;
function $e8d3e44a030e0375$var$Uf(a) {
    return {
        current: a
    };
}
function $e8d3e44a030e0375$var$E(a) {
    0 > $e8d3e44a030e0375$var$Tf || (a.current = $e8d3e44a030e0375$var$Sf[$e8d3e44a030e0375$var$Tf], $e8d3e44a030e0375$var$Sf[$e8d3e44a030e0375$var$Tf] = null, $e8d3e44a030e0375$var$Tf--);
}
function $e8d3e44a030e0375$var$G(a, b) {
    $e8d3e44a030e0375$var$Tf++;
    $e8d3e44a030e0375$var$Sf[$e8d3e44a030e0375$var$Tf] = a.current;
    a.current = b;
}
var $e8d3e44a030e0375$var$Vf = {}, $e8d3e44a030e0375$var$H = $e8d3e44a030e0375$var$Uf($e8d3e44a030e0375$var$Vf), $e8d3e44a030e0375$var$Wf = $e8d3e44a030e0375$var$Uf(!1), $e8d3e44a030e0375$var$Xf = $e8d3e44a030e0375$var$Vf;
function $e8d3e44a030e0375$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e8d3e44a030e0375$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e8d3e44a030e0375$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e8d3e44a030e0375$var$$f() {
    $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$Wf);
    $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$H);
}
function $e8d3e44a030e0375$var$ag(a, b, c) {
    if ($e8d3e44a030e0375$var$H.current !== $e8d3e44a030e0375$var$Vf) throw Error($e8d3e44a030e0375$var$p(168));
    $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$H, b);
    $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$Wf, c);
}
function $e8d3e44a030e0375$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e8d3e44a030e0375$var$p(108, $e8d3e44a030e0375$var$Ra(a) || "Unknown", e));
    return $e8d3e44a030e0375$var$A({}, c, d);
}
function $e8d3e44a030e0375$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e8d3e44a030e0375$var$Vf;
    $e8d3e44a030e0375$var$Xf = $e8d3e44a030e0375$var$H.current;
    $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$H, a);
    $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$Wf, $e8d3e44a030e0375$var$Wf.current);
    return !0;
}
function $e8d3e44a030e0375$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e8d3e44a030e0375$var$p(169));
    c ? (a = $e8d3e44a030e0375$var$bg(a, b, $e8d3e44a030e0375$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$Wf), $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$H), $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$H, a)) : $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$Wf);
    $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$Wf, c);
}
var $e8d3e44a030e0375$var$eg = null, $e8d3e44a030e0375$var$fg = !1, $e8d3e44a030e0375$var$gg = !1;
function $e8d3e44a030e0375$var$hg(a) {
    null === $e8d3e44a030e0375$var$eg ? $e8d3e44a030e0375$var$eg = [
        a
    ] : $e8d3e44a030e0375$var$eg.push(a);
}
function $e8d3e44a030e0375$var$ig(a) {
    $e8d3e44a030e0375$var$fg = !0;
    $e8d3e44a030e0375$var$hg(a);
}
function $e8d3e44a030e0375$var$jg() {
    if (!$e8d3e44a030e0375$var$gg && null !== $e8d3e44a030e0375$var$eg) {
        $e8d3e44a030e0375$var$gg = !0;
        var a = 0, b = $e8d3e44a030e0375$var$C;
        try {
            var c = $e8d3e44a030e0375$var$eg;
            for($e8d3e44a030e0375$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e8d3e44a030e0375$var$eg = null;
            $e8d3e44a030e0375$var$fg = !1;
        } catch (e) {
            throw null !== $e8d3e44a030e0375$var$eg && ($e8d3e44a030e0375$var$eg = $e8d3e44a030e0375$var$eg.slice(a + 1)), $e8d3e44a030e0375$var$ac($e8d3e44a030e0375$var$fc, $e8d3e44a030e0375$var$jg), e;
        } finally{
            $e8d3e44a030e0375$var$C = b, $e8d3e44a030e0375$var$gg = !1;
        }
    }
    return null;
}
var $e8d3e44a030e0375$var$kg = [], $e8d3e44a030e0375$var$lg = 0, $e8d3e44a030e0375$var$mg = null, $e8d3e44a030e0375$var$ng = 0, $e8d3e44a030e0375$var$og = [], $e8d3e44a030e0375$var$pg = 0, $e8d3e44a030e0375$var$qg = null, $e8d3e44a030e0375$var$rg = 1, $e8d3e44a030e0375$var$sg = "";
function $e8d3e44a030e0375$var$tg(a, b) {
    $e8d3e44a030e0375$var$kg[$e8d3e44a030e0375$var$lg++] = $e8d3e44a030e0375$var$ng;
    $e8d3e44a030e0375$var$kg[$e8d3e44a030e0375$var$lg++] = $e8d3e44a030e0375$var$mg;
    $e8d3e44a030e0375$var$mg = a;
    $e8d3e44a030e0375$var$ng = b;
}
function $e8d3e44a030e0375$var$ug(a, b, c) {
    $e8d3e44a030e0375$var$og[$e8d3e44a030e0375$var$pg++] = $e8d3e44a030e0375$var$rg;
    $e8d3e44a030e0375$var$og[$e8d3e44a030e0375$var$pg++] = $e8d3e44a030e0375$var$sg;
    $e8d3e44a030e0375$var$og[$e8d3e44a030e0375$var$pg++] = $e8d3e44a030e0375$var$qg;
    $e8d3e44a030e0375$var$qg = a;
    var d = $e8d3e44a030e0375$var$rg;
    a = $e8d3e44a030e0375$var$sg;
    var e = 32 - $e8d3e44a030e0375$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e8d3e44a030e0375$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e8d3e44a030e0375$var$rg = 1 << 32 - $e8d3e44a030e0375$var$oc(b) + e | c << e | d;
        $e8d3e44a030e0375$var$sg = f + a;
    } else $e8d3e44a030e0375$var$rg = 1 << f | c << e | d, $e8d3e44a030e0375$var$sg = a;
}
function $e8d3e44a030e0375$var$vg(a) {
    null !== a.return && ($e8d3e44a030e0375$var$tg(a, 1), $e8d3e44a030e0375$var$ug(a, 1, 0));
}
function $e8d3e44a030e0375$var$wg(a) {
    for(; a === $e8d3e44a030e0375$var$mg;)$e8d3e44a030e0375$var$mg = $e8d3e44a030e0375$var$kg[--$e8d3e44a030e0375$var$lg], $e8d3e44a030e0375$var$kg[$e8d3e44a030e0375$var$lg] = null, $e8d3e44a030e0375$var$ng = $e8d3e44a030e0375$var$kg[--$e8d3e44a030e0375$var$lg], $e8d3e44a030e0375$var$kg[$e8d3e44a030e0375$var$lg] = null;
    for(; a === $e8d3e44a030e0375$var$qg;)$e8d3e44a030e0375$var$qg = $e8d3e44a030e0375$var$og[--$e8d3e44a030e0375$var$pg], $e8d3e44a030e0375$var$og[$e8d3e44a030e0375$var$pg] = null, $e8d3e44a030e0375$var$sg = $e8d3e44a030e0375$var$og[--$e8d3e44a030e0375$var$pg], $e8d3e44a030e0375$var$og[$e8d3e44a030e0375$var$pg] = null, $e8d3e44a030e0375$var$rg = $e8d3e44a030e0375$var$og[--$e8d3e44a030e0375$var$pg], $e8d3e44a030e0375$var$og[$e8d3e44a030e0375$var$pg] = null;
}
var $e8d3e44a030e0375$var$xg = null, $e8d3e44a030e0375$var$yg = null, $e8d3e44a030e0375$var$I = !1, $e8d3e44a030e0375$var$zg = null;
function $e8d3e44a030e0375$var$Ag(a, b) {
    var c = $e8d3e44a030e0375$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e8d3e44a030e0375$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e8d3e44a030e0375$var$xg = a, $e8d3e44a030e0375$var$yg = $e8d3e44a030e0375$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e8d3e44a030e0375$var$xg = a, $e8d3e44a030e0375$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e8d3e44a030e0375$var$qg ? {
                id: $e8d3e44a030e0375$var$rg,
                overflow: $e8d3e44a030e0375$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e8d3e44a030e0375$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e8d3e44a030e0375$var$xg = a, $e8d3e44a030e0375$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e8d3e44a030e0375$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e8d3e44a030e0375$var$Eg(a) {
    if ($e8d3e44a030e0375$var$I) {
        var b = $e8d3e44a030e0375$var$yg;
        if (b) {
            var c = b;
            if (!$e8d3e44a030e0375$var$Cg(a, b)) {
                if ($e8d3e44a030e0375$var$Dg(a)) throw Error($e8d3e44a030e0375$var$p(418));
                b = $e8d3e44a030e0375$var$Lf(c.nextSibling);
                var d = $e8d3e44a030e0375$var$xg;
                b && $e8d3e44a030e0375$var$Cg(a, b) ? $e8d3e44a030e0375$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e8d3e44a030e0375$var$I = !1, $e8d3e44a030e0375$var$xg = a);
            }
        } else {
            if ($e8d3e44a030e0375$var$Dg(a)) throw Error($e8d3e44a030e0375$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e8d3e44a030e0375$var$I = !1;
            $e8d3e44a030e0375$var$xg = a;
        }
    }
}
function $e8d3e44a030e0375$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e8d3e44a030e0375$var$xg = a;
}
function $e8d3e44a030e0375$var$Gg(a) {
    if (a !== $e8d3e44a030e0375$var$xg) return !1;
    if (!$e8d3e44a030e0375$var$I) return $e8d3e44a030e0375$var$Fg(a), $e8d3e44a030e0375$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e8d3e44a030e0375$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e8d3e44a030e0375$var$yg)) {
        if ($e8d3e44a030e0375$var$Dg(a)) throw $e8d3e44a030e0375$var$Hg(), Error($e8d3e44a030e0375$var$p(418));
        for(; b;)$e8d3e44a030e0375$var$Ag(a, b), b = $e8d3e44a030e0375$var$Lf(b.nextSibling);
    }
    $e8d3e44a030e0375$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e8d3e44a030e0375$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e8d3e44a030e0375$var$yg = $e8d3e44a030e0375$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e8d3e44a030e0375$var$yg = null;
        }
    } else $e8d3e44a030e0375$var$yg = $e8d3e44a030e0375$var$xg ? $e8d3e44a030e0375$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e8d3e44a030e0375$var$Hg() {
    for(var a = $e8d3e44a030e0375$var$yg; a;)a = $e8d3e44a030e0375$var$Lf(a.nextSibling);
}
function $e8d3e44a030e0375$var$Ig() {
    $e8d3e44a030e0375$var$yg = $e8d3e44a030e0375$var$xg = null;
    $e8d3e44a030e0375$var$I = !1;
}
function $e8d3e44a030e0375$var$Jg(a) {
    null === $e8d3e44a030e0375$var$zg ? $e8d3e44a030e0375$var$zg = [
        a
    ] : $e8d3e44a030e0375$var$zg.push(a);
}
var $e8d3e44a030e0375$var$Kg = $e8d3e44a030e0375$var$ua.ReactCurrentBatchConfig;
function $e8d3e44a030e0375$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $e8d3e44a030e0375$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $e8d3e44a030e0375$var$Mg = $e8d3e44a030e0375$var$Uf(null), $e8d3e44a030e0375$var$Ng = null, $e8d3e44a030e0375$var$Og = null, $e8d3e44a030e0375$var$Pg = null;
function $e8d3e44a030e0375$var$Qg() {
    $e8d3e44a030e0375$var$Pg = $e8d3e44a030e0375$var$Og = $e8d3e44a030e0375$var$Ng = null;
}
function $e8d3e44a030e0375$var$Rg(a) {
    var b = $e8d3e44a030e0375$var$Mg.current;
    $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$Mg);
    a._currentValue = b;
}
function $e8d3e44a030e0375$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e8d3e44a030e0375$var$Tg(a, b) {
    $e8d3e44a030e0375$var$Ng = a;
    $e8d3e44a030e0375$var$Pg = $e8d3e44a030e0375$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e8d3e44a030e0375$var$Ug = !0), a.firstContext = null);
}
function $e8d3e44a030e0375$var$Vg(a) {
    var b = a._currentValue;
    if ($e8d3e44a030e0375$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e8d3e44a030e0375$var$Og) {
            if (null === $e8d3e44a030e0375$var$Ng) throw Error($e8d3e44a030e0375$var$p(308));
            $e8d3e44a030e0375$var$Og = a;
            $e8d3e44a030e0375$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e8d3e44a030e0375$var$Og = $e8d3e44a030e0375$var$Og.next = a;
    }
    return b;
}
var $e8d3e44a030e0375$var$Wg = null;
function $e8d3e44a030e0375$var$Xg(a) {
    null === $e8d3e44a030e0375$var$Wg ? $e8d3e44a030e0375$var$Wg = [
        a
    ] : $e8d3e44a030e0375$var$Wg.push(a);
}
function $e8d3e44a030e0375$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e8d3e44a030e0375$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e8d3e44a030e0375$var$Zg(a, d);
}
function $e8d3e44a030e0375$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e8d3e44a030e0375$var$$g = !1;
function $e8d3e44a030e0375$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e8d3e44a030e0375$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e8d3e44a030e0375$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e8d3e44a030e0375$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e8d3e44a030e0375$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e8d3e44a030e0375$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e8d3e44a030e0375$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e8d3e44a030e0375$var$Zg(a, c);
}
function $e8d3e44a030e0375$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8d3e44a030e0375$var$Cc(a, c);
    }
}
function $e8d3e44a030e0375$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e8d3e44a030e0375$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $e8d3e44a030e0375$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e8d3e44a030e0375$var$A({}, q, r);
                            break a;
                        case 2:
                            $e8d3e44a030e0375$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e8d3e44a030e0375$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e8d3e44a030e0375$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e8d3e44a030e0375$var$p(191, e));
            e.call(d);
        }
    }
}
var $e8d3e44a030e0375$var$jh = (new $1EuC8.Component).refs;
function $e8d3e44a030e0375$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e8d3e44a030e0375$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e8d3e44a030e0375$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e8d3e44a030e0375$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8d3e44a030e0375$var$L(), e = $e8d3e44a030e0375$var$lh(a), f = $e8d3e44a030e0375$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8d3e44a030e0375$var$dh(a, f, e);
        null !== b && ($e8d3e44a030e0375$var$mh(b, a, e, d), $e8d3e44a030e0375$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8d3e44a030e0375$var$L(), e = $e8d3e44a030e0375$var$lh(a), f = $e8d3e44a030e0375$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8d3e44a030e0375$var$dh(a, f, e);
        null !== b && ($e8d3e44a030e0375$var$mh(b, a, e, d), $e8d3e44a030e0375$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e8d3e44a030e0375$var$L(), d = $e8d3e44a030e0375$var$lh(a), e = $e8d3e44a030e0375$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e8d3e44a030e0375$var$dh(a, e, d);
        null !== b && ($e8d3e44a030e0375$var$mh(b, a, d, c), $e8d3e44a030e0375$var$eh(b, a, d));
    }
};
function $e8d3e44a030e0375$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e8d3e44a030e0375$var$Ie(c, d) || !$e8d3e44a030e0375$var$Ie(e, f) : !0;
}
function $e8d3e44a030e0375$var$ph(a, b, c) {
    var d = !1, e = $e8d3e44a030e0375$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e8d3e44a030e0375$var$Vg(f) : (e = $e8d3e44a030e0375$var$Zf(b) ? $e8d3e44a030e0375$var$Xf : $e8d3e44a030e0375$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e8d3e44a030e0375$var$Yf(a, e) : $e8d3e44a030e0375$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e8d3e44a030e0375$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e8d3e44a030e0375$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e8d3e44a030e0375$var$nh.enqueueReplaceState(b, b.state, null);
}
function $e8d3e44a030e0375$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $e8d3e44a030e0375$var$jh;
    $e8d3e44a030e0375$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e8d3e44a030e0375$var$Vg(f) : (f = $e8d3e44a030e0375$var$Zf(b) ? $e8d3e44a030e0375$var$Xf : $e8d3e44a030e0375$var$H.current, e.context = $e8d3e44a030e0375$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e8d3e44a030e0375$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e8d3e44a030e0375$var$nh.enqueueReplaceState(e, e.state, null), $e8d3e44a030e0375$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e8d3e44a030e0375$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e8d3e44a030e0375$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e8d3e44a030e0375$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $e8d3e44a030e0375$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e8d3e44a030e0375$var$p(284));
        if (!c._owner) throw Error($e8d3e44a030e0375$var$p(290, a));
    }
    return a;
}
function $e8d3e44a030e0375$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e8d3e44a030e0375$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e8d3e44a030e0375$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $e8d3e44a030e0375$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e8d3e44a030e0375$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e8d3e44a030e0375$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e8d3e44a030e0375$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e8d3e44a030e0375$var$Ha && $e8d3e44a030e0375$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $e8d3e44a030e0375$var$sh(a, b, c), d.return = a, d;
        d = $e8d3e44a030e0375$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e8d3e44a030e0375$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e8d3e44a030e0375$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e8d3e44a030e0375$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e8d3e44a030e0375$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e8d3e44a030e0375$var$va:
                    return c = $e8d3e44a030e0375$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $e8d3e44a030e0375$var$sh(a, null, b), c.return = a, c;
                case $e8d3e44a030e0375$var$wa:
                    return b = $e8d3e44a030e0375$var$zh(b, a.mode, c), b.return = a, b;
                case $e8d3e44a030e0375$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e8d3e44a030e0375$var$eb(b) || $e8d3e44a030e0375$var$Ka(b)) return b = $e8d3e44a030e0375$var$Ah(b, a.mode, c, null), b.return = a, b;
            $e8d3e44a030e0375$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e8d3e44a030e0375$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e8d3e44a030e0375$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e8d3e44a030e0375$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e8d3e44a030e0375$var$eb(c) || $e8d3e44a030e0375$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e8d3e44a030e0375$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e8d3e44a030e0375$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e8d3e44a030e0375$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e8d3e44a030e0375$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e8d3e44a030e0375$var$eb(d) || $e8d3e44a030e0375$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e8d3e44a030e0375$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e8d3e44a030e0375$var$I && $e8d3e44a030e0375$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e8d3e44a030e0375$var$I && $e8d3e44a030e0375$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e8d3e44a030e0375$var$I && $e8d3e44a030e0375$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e8d3e44a030e0375$var$Ka(h);
        if ("function" !== typeof l) throw Error($e8d3e44a030e0375$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e8d3e44a030e0375$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e8d3e44a030e0375$var$I && $e8d3e44a030e0375$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e8d3e44a030e0375$var$I && $e8d3e44a030e0375$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e8d3e44a030e0375$var$I && $e8d3e44a030e0375$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e8d3e44a030e0375$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e8d3e44a030e0375$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e8d3e44a030e0375$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e8d3e44a030e0375$var$Ha && $e8d3e44a030e0375$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e8d3e44a030e0375$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e8d3e44a030e0375$var$ya ? (d = $e8d3e44a030e0375$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e8d3e44a030e0375$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $e8d3e44a030e0375$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e8d3e44a030e0375$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e8d3e44a030e0375$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e8d3e44a030e0375$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e8d3e44a030e0375$var$eb(f)) return n(a, d, f, h);
            if ($e8d3e44a030e0375$var$Ka(f)) return t(a, d, f, h);
            $e8d3e44a030e0375$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e8d3e44a030e0375$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e8d3e44a030e0375$var$Bh = $e8d3e44a030e0375$var$vh(!0), $e8d3e44a030e0375$var$Ch = $e8d3e44a030e0375$var$vh(!1), $e8d3e44a030e0375$var$Dh = {}, $e8d3e44a030e0375$var$Eh = $e8d3e44a030e0375$var$Uf($e8d3e44a030e0375$var$Dh), $e8d3e44a030e0375$var$Fh = $e8d3e44a030e0375$var$Uf($e8d3e44a030e0375$var$Dh), $e8d3e44a030e0375$var$Gh = $e8d3e44a030e0375$var$Uf($e8d3e44a030e0375$var$Dh);
function $e8d3e44a030e0375$var$Hh(a) {
    if (a === $e8d3e44a030e0375$var$Dh) throw Error($e8d3e44a030e0375$var$p(174));
    return a;
}
function $e8d3e44a030e0375$var$Ih(a, b) {
    $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$Gh, b);
    $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$Fh, a);
    $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$Eh, $e8d3e44a030e0375$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e8d3e44a030e0375$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e8d3e44a030e0375$var$lb(b, a);
    }
    $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$Eh);
    $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$Eh, b);
}
function $e8d3e44a030e0375$var$Jh() {
    $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$Eh);
    $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$Fh);
    $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$Gh);
}
function $e8d3e44a030e0375$var$Kh(a) {
    $e8d3e44a030e0375$var$Hh($e8d3e44a030e0375$var$Gh.current);
    var b = $e8d3e44a030e0375$var$Hh($e8d3e44a030e0375$var$Eh.current);
    var c = $e8d3e44a030e0375$var$lb(b, a.type);
    b !== c && ($e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$Fh, a), $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$Eh, c));
}
function $e8d3e44a030e0375$var$Lh(a) {
    $e8d3e44a030e0375$var$Fh.current === a && ($e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$Eh), $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$Fh));
}
var $e8d3e44a030e0375$var$M = $e8d3e44a030e0375$var$Uf(0);
function $e8d3e44a030e0375$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e8d3e44a030e0375$var$Nh = [];
function $e8d3e44a030e0375$var$Oh() {
    for(var a = 0; a < $e8d3e44a030e0375$var$Nh.length; a++)$e8d3e44a030e0375$var$Nh[a]._workInProgressVersionPrimary = null;
    $e8d3e44a030e0375$var$Nh.length = 0;
}
var $e8d3e44a030e0375$var$Ph = $e8d3e44a030e0375$var$ua.ReactCurrentDispatcher, $e8d3e44a030e0375$var$Qh = $e8d3e44a030e0375$var$ua.ReactCurrentBatchConfig, $e8d3e44a030e0375$var$Rh = 0, $e8d3e44a030e0375$var$N = null, $e8d3e44a030e0375$var$O = null, $e8d3e44a030e0375$var$P = null, $e8d3e44a030e0375$var$Sh = !1, $e8d3e44a030e0375$var$Th = !1, $e8d3e44a030e0375$var$Uh = 0, $e8d3e44a030e0375$var$Vh = 0;
function $e8d3e44a030e0375$var$Q() {
    throw Error($e8d3e44a030e0375$var$p(321));
}
function $e8d3e44a030e0375$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e8d3e44a030e0375$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e8d3e44a030e0375$var$Xh(a, b, c, d, e, f) {
    $e8d3e44a030e0375$var$Rh = f;
    $e8d3e44a030e0375$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e8d3e44a030e0375$var$Ph.current = null === a || null === a.memoizedState ? $e8d3e44a030e0375$var$Yh : $e8d3e44a030e0375$var$Zh;
    a = c(d, e);
    if ($e8d3e44a030e0375$var$Th) {
        f = 0;
        do {
            $e8d3e44a030e0375$var$Th = !1;
            $e8d3e44a030e0375$var$Uh = 0;
            if (25 <= f) throw Error($e8d3e44a030e0375$var$p(301));
            f += 1;
            $e8d3e44a030e0375$var$P = $e8d3e44a030e0375$var$O = null;
            b.updateQueue = null;
            $e8d3e44a030e0375$var$Ph.current = $e8d3e44a030e0375$var$$h;
            a = c(d, e);
        }while ($e8d3e44a030e0375$var$Th);
    }
    $e8d3e44a030e0375$var$Ph.current = $e8d3e44a030e0375$var$ai;
    b = null !== $e8d3e44a030e0375$var$O && null !== $e8d3e44a030e0375$var$O.next;
    $e8d3e44a030e0375$var$Rh = 0;
    $e8d3e44a030e0375$var$P = $e8d3e44a030e0375$var$O = $e8d3e44a030e0375$var$N = null;
    $e8d3e44a030e0375$var$Sh = !1;
    if (b) throw Error($e8d3e44a030e0375$var$p(300));
    return a;
}
function $e8d3e44a030e0375$var$bi() {
    var a = 0 !== $e8d3e44a030e0375$var$Uh;
    $e8d3e44a030e0375$var$Uh = 0;
    return a;
}
function $e8d3e44a030e0375$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e8d3e44a030e0375$var$P ? $e8d3e44a030e0375$var$N.memoizedState = $e8d3e44a030e0375$var$P = a : $e8d3e44a030e0375$var$P = $e8d3e44a030e0375$var$P.next = a;
    return $e8d3e44a030e0375$var$P;
}
function $e8d3e44a030e0375$var$di() {
    if (null === $e8d3e44a030e0375$var$O) {
        var a = $e8d3e44a030e0375$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e8d3e44a030e0375$var$O.next;
    var b = null === $e8d3e44a030e0375$var$P ? $e8d3e44a030e0375$var$N.memoizedState : $e8d3e44a030e0375$var$P.next;
    if (null !== b) $e8d3e44a030e0375$var$P = b, $e8d3e44a030e0375$var$O = a;
    else {
        if (null === a) throw Error($e8d3e44a030e0375$var$p(310));
        $e8d3e44a030e0375$var$O = a;
        a = {
            memoizedState: $e8d3e44a030e0375$var$O.memoizedState,
            baseState: $e8d3e44a030e0375$var$O.baseState,
            baseQueue: $e8d3e44a030e0375$var$O.baseQueue,
            queue: $e8d3e44a030e0375$var$O.queue,
            next: null
        };
        null === $e8d3e44a030e0375$var$P ? $e8d3e44a030e0375$var$N.memoizedState = $e8d3e44a030e0375$var$P = a : $e8d3e44a030e0375$var$P = $e8d3e44a030e0375$var$P.next = a;
    }
    return $e8d3e44a030e0375$var$P;
}
function $e8d3e44a030e0375$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e8d3e44a030e0375$var$fi(a) {
    var b = $e8d3e44a030e0375$var$di(), c = b.queue;
    if (null === c) throw Error($e8d3e44a030e0375$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e8d3e44a030e0375$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e8d3e44a030e0375$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e8d3e44a030e0375$var$N.lanes |= m;
                $e8d3e44a030e0375$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e8d3e44a030e0375$var$He(d, b.memoizedState) || ($e8d3e44a030e0375$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e8d3e44a030e0375$var$N.lanes |= f, $e8d3e44a030e0375$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e8d3e44a030e0375$var$gi(a) {
    var b = $e8d3e44a030e0375$var$di(), c = b.queue;
    if (null === c) throw Error($e8d3e44a030e0375$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e8d3e44a030e0375$var$He(f, b.memoizedState) || ($e8d3e44a030e0375$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e8d3e44a030e0375$var$hi() {}
function $e8d3e44a030e0375$var$ii(a, b) {
    var c = $e8d3e44a030e0375$var$N, d = $e8d3e44a030e0375$var$di(), e = b(), f = !$e8d3e44a030e0375$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e8d3e44a030e0375$var$Ug = !0);
    d = d.queue;
    $e8d3e44a030e0375$var$ji($e8d3e44a030e0375$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e8d3e44a030e0375$var$P && $e8d3e44a030e0375$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e8d3e44a030e0375$var$li(9, $e8d3e44a030e0375$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $e8d3e44a030e0375$var$R) throw Error($e8d3e44a030e0375$var$p(349));
        0 !== ($e8d3e44a030e0375$var$Rh & 30) || $e8d3e44a030e0375$var$ni(c, b, e);
    }
    return e;
}
function $e8d3e44a030e0375$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e8d3e44a030e0375$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8d3e44a030e0375$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e8d3e44a030e0375$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e8d3e44a030e0375$var$oi(b) && $e8d3e44a030e0375$var$pi(a);
}
function $e8d3e44a030e0375$var$ki(a, b, c) {
    return c(function() {
        $e8d3e44a030e0375$var$oi(b) && $e8d3e44a030e0375$var$pi(a);
    });
}
function $e8d3e44a030e0375$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e8d3e44a030e0375$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e8d3e44a030e0375$var$pi(a) {
    var b = $e8d3e44a030e0375$var$Zg(a, 1);
    null !== b && $e8d3e44a030e0375$var$mh(b, a, 1, -1);
}
function $e8d3e44a030e0375$var$qi(a) {
    var b = $e8d3e44a030e0375$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e8d3e44a030e0375$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e8d3e44a030e0375$var$ri.bind(null, $e8d3e44a030e0375$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e8d3e44a030e0375$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e8d3e44a030e0375$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8d3e44a030e0375$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e8d3e44a030e0375$var$si() {
    return $e8d3e44a030e0375$var$di().memoizedState;
}
function $e8d3e44a030e0375$var$ti(a, b, c, d) {
    var e = $e8d3e44a030e0375$var$ci();
    $e8d3e44a030e0375$var$N.flags |= a;
    e.memoizedState = $e8d3e44a030e0375$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e8d3e44a030e0375$var$ui(a, b, c, d) {
    var e = $e8d3e44a030e0375$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e8d3e44a030e0375$var$O) {
        var g = $e8d3e44a030e0375$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $e8d3e44a030e0375$var$Wh(d, g.deps)) {
            e.memoizedState = $e8d3e44a030e0375$var$li(b, c, f, d);
            return;
        }
    }
    $e8d3e44a030e0375$var$N.flags |= a;
    e.memoizedState = $e8d3e44a030e0375$var$li(1 | b, c, f, d);
}
function $e8d3e44a030e0375$var$vi(a, b) {
    return $e8d3e44a030e0375$var$ti(8390656, 8, a, b);
}
function $e8d3e44a030e0375$var$ji(a, b) {
    return $e8d3e44a030e0375$var$ui(2048, 8, a, b);
}
function $e8d3e44a030e0375$var$wi(a, b) {
    return $e8d3e44a030e0375$var$ui(4, 2, a, b);
}
function $e8d3e44a030e0375$var$xi(a, b) {
    return $e8d3e44a030e0375$var$ui(4, 4, a, b);
}
function $e8d3e44a030e0375$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e8d3e44a030e0375$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e8d3e44a030e0375$var$ui(4, 4, $e8d3e44a030e0375$var$yi.bind(null, b, a), c);
}
function $e8d3e44a030e0375$var$Ai() {}
function $e8d3e44a030e0375$var$Bi(a, b) {
    var c = $e8d3e44a030e0375$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8d3e44a030e0375$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8d3e44a030e0375$var$Ci(a, b) {
    var c = $e8d3e44a030e0375$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8d3e44a030e0375$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8d3e44a030e0375$var$Di(a, b, c) {
    if (0 === ($e8d3e44a030e0375$var$Rh & 21)) return a.baseState && (a.baseState = !1, $e8d3e44a030e0375$var$Ug = !0), a.memoizedState = c;
    $e8d3e44a030e0375$var$He(c, b) || (c = $e8d3e44a030e0375$var$yc(), $e8d3e44a030e0375$var$N.lanes |= c, $e8d3e44a030e0375$var$hh |= c, a.baseState = !0);
    return b;
}
function $e8d3e44a030e0375$var$Ei(a, b) {
    var c = $e8d3e44a030e0375$var$C;
    $e8d3e44a030e0375$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e8d3e44a030e0375$var$Qh.transition;
    $e8d3e44a030e0375$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e8d3e44a030e0375$var$C = c, $e8d3e44a030e0375$var$Qh.transition = d;
    }
}
function $e8d3e44a030e0375$var$Fi() {
    return $e8d3e44a030e0375$var$di().memoizedState;
}
function $e8d3e44a030e0375$var$Gi(a, b, c) {
    var d = $e8d3e44a030e0375$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8d3e44a030e0375$var$Hi(a)) $e8d3e44a030e0375$var$Ii(b, c);
    else if (c = $e8d3e44a030e0375$var$Yg(a, b, c, d), null !== c) {
        var e = $e8d3e44a030e0375$var$L();
        $e8d3e44a030e0375$var$mh(c, a, d, e);
        $e8d3e44a030e0375$var$Ji(c, b, d);
    }
}
function $e8d3e44a030e0375$var$ri(a, b, c) {
    var d = $e8d3e44a030e0375$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8d3e44a030e0375$var$Hi(a)) $e8d3e44a030e0375$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e8d3e44a030e0375$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e8d3e44a030e0375$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e8d3e44a030e0375$var$Yg(a, b, e, d);
        null !== c && (e = $e8d3e44a030e0375$var$L(), $e8d3e44a030e0375$var$mh(c, a, d, e), $e8d3e44a030e0375$var$Ji(c, b, d));
    }
}
function $e8d3e44a030e0375$var$Hi(a) {
    var b = a.alternate;
    return a === $e8d3e44a030e0375$var$N || null !== b && b === $e8d3e44a030e0375$var$N;
}
function $e8d3e44a030e0375$var$Ii(a, b) {
    $e8d3e44a030e0375$var$Th = $e8d3e44a030e0375$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e8d3e44a030e0375$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8d3e44a030e0375$var$Cc(a, c);
    }
}
var $e8d3e44a030e0375$var$ai = {
    readContext: $e8d3e44a030e0375$var$Vg,
    useCallback: $e8d3e44a030e0375$var$Q,
    useContext: $e8d3e44a030e0375$var$Q,
    useEffect: $e8d3e44a030e0375$var$Q,
    useImperativeHandle: $e8d3e44a030e0375$var$Q,
    useInsertionEffect: $e8d3e44a030e0375$var$Q,
    useLayoutEffect: $e8d3e44a030e0375$var$Q,
    useMemo: $e8d3e44a030e0375$var$Q,
    useReducer: $e8d3e44a030e0375$var$Q,
    useRef: $e8d3e44a030e0375$var$Q,
    useState: $e8d3e44a030e0375$var$Q,
    useDebugValue: $e8d3e44a030e0375$var$Q,
    useDeferredValue: $e8d3e44a030e0375$var$Q,
    useTransition: $e8d3e44a030e0375$var$Q,
    useMutableSource: $e8d3e44a030e0375$var$Q,
    useSyncExternalStore: $e8d3e44a030e0375$var$Q,
    useId: $e8d3e44a030e0375$var$Q,
    unstable_isNewReconciler: !1
}, $e8d3e44a030e0375$var$Yh = {
    readContext: $e8d3e44a030e0375$var$Vg,
    useCallback: function(a, b) {
        $e8d3e44a030e0375$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e8d3e44a030e0375$var$Vg,
    useEffect: $e8d3e44a030e0375$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e8d3e44a030e0375$var$ti(4194308, 4, $e8d3e44a030e0375$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e8d3e44a030e0375$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e8d3e44a030e0375$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e8d3e44a030e0375$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e8d3e44a030e0375$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e8d3e44a030e0375$var$Gi.bind(null, $e8d3e44a030e0375$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e8d3e44a030e0375$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e8d3e44a030e0375$var$qi,
    useDebugValue: $e8d3e44a030e0375$var$Ai,
    useDeferredValue: function(a) {
        return $e8d3e44a030e0375$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $e8d3e44a030e0375$var$qi(!1), b = a[0];
        a = $e8d3e44a030e0375$var$Ei.bind(null, a[1]);
        $e8d3e44a030e0375$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e8d3e44a030e0375$var$N, e = $e8d3e44a030e0375$var$ci();
        if ($e8d3e44a030e0375$var$I) {
            if (void 0 === c) throw Error($e8d3e44a030e0375$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e8d3e44a030e0375$var$R) throw Error($e8d3e44a030e0375$var$p(349));
            0 !== ($e8d3e44a030e0375$var$Rh & 30) || $e8d3e44a030e0375$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e8d3e44a030e0375$var$vi($e8d3e44a030e0375$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e8d3e44a030e0375$var$li(9, $e8d3e44a030e0375$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e8d3e44a030e0375$var$ci(), b = $e8d3e44a030e0375$var$R.identifierPrefix;
        if ($e8d3e44a030e0375$var$I) {
            var c = $e8d3e44a030e0375$var$sg;
            var d = $e8d3e44a030e0375$var$rg;
            c = (d & ~(1 << 32 - $e8d3e44a030e0375$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e8d3e44a030e0375$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e8d3e44a030e0375$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e8d3e44a030e0375$var$Zh = {
    readContext: $e8d3e44a030e0375$var$Vg,
    useCallback: $e8d3e44a030e0375$var$Bi,
    useContext: $e8d3e44a030e0375$var$Vg,
    useEffect: $e8d3e44a030e0375$var$ji,
    useImperativeHandle: $e8d3e44a030e0375$var$zi,
    useInsertionEffect: $e8d3e44a030e0375$var$wi,
    useLayoutEffect: $e8d3e44a030e0375$var$xi,
    useMemo: $e8d3e44a030e0375$var$Ci,
    useReducer: $e8d3e44a030e0375$var$fi,
    useRef: $e8d3e44a030e0375$var$si,
    useState: function() {
        return $e8d3e44a030e0375$var$fi($e8d3e44a030e0375$var$ei);
    },
    useDebugValue: $e8d3e44a030e0375$var$Ai,
    useDeferredValue: function(a) {
        var b = $e8d3e44a030e0375$var$di();
        return $e8d3e44a030e0375$var$Di(b, $e8d3e44a030e0375$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8d3e44a030e0375$var$fi($e8d3e44a030e0375$var$ei)[0], b = $e8d3e44a030e0375$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8d3e44a030e0375$var$hi,
    useSyncExternalStore: $e8d3e44a030e0375$var$ii,
    useId: $e8d3e44a030e0375$var$Fi,
    unstable_isNewReconciler: !1
}, $e8d3e44a030e0375$var$$h = {
    readContext: $e8d3e44a030e0375$var$Vg,
    useCallback: $e8d3e44a030e0375$var$Bi,
    useContext: $e8d3e44a030e0375$var$Vg,
    useEffect: $e8d3e44a030e0375$var$ji,
    useImperativeHandle: $e8d3e44a030e0375$var$zi,
    useInsertionEffect: $e8d3e44a030e0375$var$wi,
    useLayoutEffect: $e8d3e44a030e0375$var$xi,
    useMemo: $e8d3e44a030e0375$var$Ci,
    useReducer: $e8d3e44a030e0375$var$gi,
    useRef: $e8d3e44a030e0375$var$si,
    useState: function() {
        return $e8d3e44a030e0375$var$gi($e8d3e44a030e0375$var$ei);
    },
    useDebugValue: $e8d3e44a030e0375$var$Ai,
    useDeferredValue: function(a) {
        var b = $e8d3e44a030e0375$var$di();
        return null === $e8d3e44a030e0375$var$O ? b.memoizedState = a : $e8d3e44a030e0375$var$Di(b, $e8d3e44a030e0375$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8d3e44a030e0375$var$gi($e8d3e44a030e0375$var$ei)[0], b = $e8d3e44a030e0375$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8d3e44a030e0375$var$hi,
    useSyncExternalStore: $e8d3e44a030e0375$var$ii,
    useId: $e8d3e44a030e0375$var$Fi,
    unstable_isNewReconciler: !1
};
function $e8d3e44a030e0375$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $e8d3e44a030e0375$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e8d3e44a030e0375$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e8d3e44a030e0375$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e8d3e44a030e0375$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $e8d3e44a030e0375$var$Oi(a, b, c) {
    c = $e8d3e44a030e0375$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e8d3e44a030e0375$var$Pi || ($e8d3e44a030e0375$var$Pi = !0, $e8d3e44a030e0375$var$Qi = d);
        $e8d3e44a030e0375$var$Mi(a, b);
    };
    return c;
}
function $e8d3e44a030e0375$var$Ri(a, b, c) {
    c = $e8d3e44a030e0375$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e8d3e44a030e0375$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e8d3e44a030e0375$var$Mi(a, b);
        "function" !== typeof d && (null === $e8d3e44a030e0375$var$Si ? $e8d3e44a030e0375$var$Si = new Set([
            this
        ]) : $e8d3e44a030e0375$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e8d3e44a030e0375$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e8d3e44a030e0375$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e8d3e44a030e0375$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $e8d3e44a030e0375$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e8d3e44a030e0375$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e8d3e44a030e0375$var$ch(-1, 1), b.tag = 2, $e8d3e44a030e0375$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e8d3e44a030e0375$var$Xi = $e8d3e44a030e0375$var$ua.ReactCurrentOwner, $e8d3e44a030e0375$var$Ug = !1;
function $e8d3e44a030e0375$var$Yi(a, b, c, d) {
    b.child = null === a ? $e8d3e44a030e0375$var$Ch(b, null, c, d) : $e8d3e44a030e0375$var$Bh(b, a.child, c, d);
}
function $e8d3e44a030e0375$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e8d3e44a030e0375$var$Tg(b, e);
    d = $e8d3e44a030e0375$var$Xh(a, b, c, d, f, e);
    c = $e8d3e44a030e0375$var$bi();
    if (null !== a && !$e8d3e44a030e0375$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8d3e44a030e0375$var$$i(a, b, e);
    $e8d3e44a030e0375$var$I && c && $e8d3e44a030e0375$var$vg(b);
    b.flags |= 1;
    $e8d3e44a030e0375$var$Yi(a, b, d, e);
    return b.child;
}
function $e8d3e44a030e0375$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e8d3e44a030e0375$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e8d3e44a030e0375$var$cj(a, b, f, d, e);
        a = $e8d3e44a030e0375$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e8d3e44a030e0375$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e8d3e44a030e0375$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $e8d3e44a030e0375$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e8d3e44a030e0375$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e8d3e44a030e0375$var$Ie(f, d) && a.ref === b.ref) {
            if ($e8d3e44a030e0375$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e8d3e44a030e0375$var$Ug = !0);
            else return b.lanes = a.lanes, $e8d3e44a030e0375$var$$i(a, b, e);
        }
    }
    return $e8d3e44a030e0375$var$dj(a, b, c, d, e);
}
function $e8d3e44a030e0375$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$fj, $e8d3e44a030e0375$var$gj), $e8d3e44a030e0375$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$fj, $e8d3e44a030e0375$var$gj), $e8d3e44a030e0375$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$fj, $e8d3e44a030e0375$var$gj);
            $e8d3e44a030e0375$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$fj, $e8d3e44a030e0375$var$gj), $e8d3e44a030e0375$var$gj |= d;
    $e8d3e44a030e0375$var$Yi(a, b, e, c);
    return b.child;
}
function $e8d3e44a030e0375$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e8d3e44a030e0375$var$dj(a, b, c, d, e) {
    var f = $e8d3e44a030e0375$var$Zf(c) ? $e8d3e44a030e0375$var$Xf : $e8d3e44a030e0375$var$H.current;
    f = $e8d3e44a030e0375$var$Yf(b, f);
    $e8d3e44a030e0375$var$Tg(b, e);
    c = $e8d3e44a030e0375$var$Xh(a, b, c, d, f, e);
    d = $e8d3e44a030e0375$var$bi();
    if (null !== a && !$e8d3e44a030e0375$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8d3e44a030e0375$var$$i(a, b, e);
    $e8d3e44a030e0375$var$I && d && $e8d3e44a030e0375$var$vg(b);
    b.flags |= 1;
    $e8d3e44a030e0375$var$Yi(a, b, c, e);
    return b.child;
}
function $e8d3e44a030e0375$var$ij(a, b, c, d, e) {
    if ($e8d3e44a030e0375$var$Zf(c)) {
        var f = !0;
        $e8d3e44a030e0375$var$cg(b);
    } else f = !1;
    $e8d3e44a030e0375$var$Tg(b, e);
    if (null === b.stateNode) $e8d3e44a030e0375$var$jj(a, b), $e8d3e44a030e0375$var$ph(b, c, d), $e8d3e44a030e0375$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e8d3e44a030e0375$var$Vg(l) : (l = $e8d3e44a030e0375$var$Zf(c) ? $e8d3e44a030e0375$var$Xf : $e8d3e44a030e0375$var$H.current, l = $e8d3e44a030e0375$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e8d3e44a030e0375$var$qh(b, g, d, l);
        $e8d3e44a030e0375$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $e8d3e44a030e0375$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e8d3e44a030e0375$var$Wf.current || $e8d3e44a030e0375$var$$g ? ("function" === typeof m && ($e8d3e44a030e0375$var$kh(b, c, m, d), k = b.memoizedState), (h = $e8d3e44a030e0375$var$$g || $e8d3e44a030e0375$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e8d3e44a030e0375$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e8d3e44a030e0375$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e8d3e44a030e0375$var$Vg(k) : (k = $e8d3e44a030e0375$var$Zf(c) ? $e8d3e44a030e0375$var$Xf : $e8d3e44a030e0375$var$H.current, k = $e8d3e44a030e0375$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e8d3e44a030e0375$var$qh(b, g, d, k);
        $e8d3e44a030e0375$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $e8d3e44a030e0375$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e8d3e44a030e0375$var$Wf.current || $e8d3e44a030e0375$var$$g ? ("function" === typeof y && ($e8d3e44a030e0375$var$kh(b, c, y, d), n = b.memoizedState), (l = $e8d3e44a030e0375$var$$g || $e8d3e44a030e0375$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e8d3e44a030e0375$var$kj(a, b, c, d, f, e);
}
function $e8d3e44a030e0375$var$kj(a, b, c, d, e, f) {
    $e8d3e44a030e0375$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e8d3e44a030e0375$var$dg(b, c, !1), $e8d3e44a030e0375$var$$i(a, b, f);
    d = b.stateNode;
    $e8d3e44a030e0375$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e8d3e44a030e0375$var$Bh(b, a.child, null, f), b.child = $e8d3e44a030e0375$var$Bh(b, null, h, f)) : $e8d3e44a030e0375$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e8d3e44a030e0375$var$dg(b, c, !0);
    return b.child;
}
function $e8d3e44a030e0375$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e8d3e44a030e0375$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e8d3e44a030e0375$var$ag(a, b.context, !1);
    $e8d3e44a030e0375$var$Ih(a, b.containerInfo);
}
function $e8d3e44a030e0375$var$mj(a, b, c, d, e) {
    $e8d3e44a030e0375$var$Ig();
    $e8d3e44a030e0375$var$Jg(e);
    b.flags |= 256;
    $e8d3e44a030e0375$var$Yi(a, b, c, d);
    return b.child;
}
var $e8d3e44a030e0375$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e8d3e44a030e0375$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e8d3e44a030e0375$var$pj(a, b, c) {
    var d = b.pendingProps, e = $e8d3e44a030e0375$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$M, e & 1);
    if (null === a) {
        $e8d3e44a030e0375$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e8d3e44a030e0375$var$qj(g, d, 0, null), a = $e8d3e44a030e0375$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e8d3e44a030e0375$var$oj(c), b.memoizedState = $e8d3e44a030e0375$var$nj, a) : $e8d3e44a030e0375$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e8d3e44a030e0375$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e8d3e44a030e0375$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e8d3e44a030e0375$var$wh(h, f) : (f = $e8d3e44a030e0375$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e8d3e44a030e0375$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e8d3e44a030e0375$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e8d3e44a030e0375$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e8d3e44a030e0375$var$rj(a, b) {
    b = $e8d3e44a030e0375$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e8d3e44a030e0375$var$tj(a, b, c, d) {
    null !== d && $e8d3e44a030e0375$var$Jg(d);
    $e8d3e44a030e0375$var$Bh(b, a.child, null, c);
    a = $e8d3e44a030e0375$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e8d3e44a030e0375$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e8d3e44a030e0375$var$Li(Error($e8d3e44a030e0375$var$p(422))), $e8d3e44a030e0375$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e8d3e44a030e0375$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e8d3e44a030e0375$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e8d3e44a030e0375$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $e8d3e44a030e0375$var$oj(g);
        b.memoizedState = $e8d3e44a030e0375$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e8d3e44a030e0375$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e8d3e44a030e0375$var$p(419));
        d = $e8d3e44a030e0375$var$Li(f, d, void 0);
        return $e8d3e44a030e0375$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e8d3e44a030e0375$var$Ug || h) {
        d = $e8d3e44a030e0375$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e8d3e44a030e0375$var$Zg(a, e), $e8d3e44a030e0375$var$mh(d, a, e, -1));
        }
        $e8d3e44a030e0375$var$uj();
        d = $e8d3e44a030e0375$var$Li(Error($e8d3e44a030e0375$var$p(421)));
        return $e8d3e44a030e0375$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e8d3e44a030e0375$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e8d3e44a030e0375$var$yg = $e8d3e44a030e0375$var$Lf(e.nextSibling);
    $e8d3e44a030e0375$var$xg = b;
    $e8d3e44a030e0375$var$I = !0;
    $e8d3e44a030e0375$var$zg = null;
    null !== a && ($e8d3e44a030e0375$var$og[$e8d3e44a030e0375$var$pg++] = $e8d3e44a030e0375$var$rg, $e8d3e44a030e0375$var$og[$e8d3e44a030e0375$var$pg++] = $e8d3e44a030e0375$var$sg, $e8d3e44a030e0375$var$og[$e8d3e44a030e0375$var$pg++] = $e8d3e44a030e0375$var$qg, $e8d3e44a030e0375$var$rg = a.id, $e8d3e44a030e0375$var$sg = a.overflow, $e8d3e44a030e0375$var$qg = b);
    b = $e8d3e44a030e0375$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e8d3e44a030e0375$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e8d3e44a030e0375$var$Sg(a.return, b, c);
}
function $e8d3e44a030e0375$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e8d3e44a030e0375$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e8d3e44a030e0375$var$Yi(a, b, d.children, c);
    d = $e8d3e44a030e0375$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e8d3e44a030e0375$var$wj(a, c, b);
            else if (19 === a.tag) $e8d3e44a030e0375$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e8d3e44a030e0375$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e8d3e44a030e0375$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e8d3e44a030e0375$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e8d3e44a030e0375$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $e8d3e44a030e0375$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e8d3e44a030e0375$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e8d3e44a030e0375$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e8d3e44a030e0375$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e8d3e44a030e0375$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e8d3e44a030e0375$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e8d3e44a030e0375$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e8d3e44a030e0375$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $e8d3e44a030e0375$var$lj(b);
            $e8d3e44a030e0375$var$Ig();
            break;
        case 5:
            $e8d3e44a030e0375$var$Kh(b);
            break;
        case 1:
            $e8d3e44a030e0375$var$Zf(b.type) && $e8d3e44a030e0375$var$cg(b);
            break;
        case 4:
            $e8d3e44a030e0375$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$M, $e8d3e44a030e0375$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e8d3e44a030e0375$var$pj(a, b, c);
                $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$M, $e8d3e44a030e0375$var$M.current & 1);
                a = $e8d3e44a030e0375$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$M, $e8d3e44a030e0375$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e8d3e44a030e0375$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$M, $e8d3e44a030e0375$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e8d3e44a030e0375$var$ej(a, b, c);
    }
    return $e8d3e44a030e0375$var$$i(a, b, c);
}
var $e8d3e44a030e0375$var$Aj, $e8d3e44a030e0375$var$Bj, $e8d3e44a030e0375$var$Cj, $e8d3e44a030e0375$var$Dj;
$e8d3e44a030e0375$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e8d3e44a030e0375$var$Bj = function() {};
$e8d3e44a030e0375$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e8d3e44a030e0375$var$Hh($e8d3e44a030e0375$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e8d3e44a030e0375$var$Ya(a, e);
                d = $e8d3e44a030e0375$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e8d3e44a030e0375$var$A({}, e, {
                    value: void 0
                });
                d = $e8d3e44a030e0375$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e8d3e44a030e0375$var$gb(a, e);
                d = $e8d3e44a030e0375$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e8d3e44a030e0375$var$Bf);
        }
        $e8d3e44a030e0375$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e8d3e44a030e0375$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e8d3e44a030e0375$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e8d3e44a030e0375$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e8d3e44a030e0375$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e8d3e44a030e0375$var$Ej(a, b) {
    if (!$e8d3e44a030e0375$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e8d3e44a030e0375$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e8d3e44a030e0375$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $e8d3e44a030e0375$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e8d3e44a030e0375$var$S(b), null;
        case 1:
            return $e8d3e44a030e0375$var$Zf(b.type) && $e8d3e44a030e0375$var$$f(), $e8d3e44a030e0375$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e8d3e44a030e0375$var$Jh();
            $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$Wf);
            $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$H);
            $e8d3e44a030e0375$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e8d3e44a030e0375$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e8d3e44a030e0375$var$zg && ($e8d3e44a030e0375$var$Gj($e8d3e44a030e0375$var$zg), $e8d3e44a030e0375$var$zg = null));
            $e8d3e44a030e0375$var$Bj(a, b);
            $e8d3e44a030e0375$var$S(b);
            return null;
        case 5:
            $e8d3e44a030e0375$var$Lh(b);
            var e = $e8d3e44a030e0375$var$Hh($e8d3e44a030e0375$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e8d3e44a030e0375$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e8d3e44a030e0375$var$p(166));
                    $e8d3e44a030e0375$var$S(b);
                    return null;
                }
                a = $e8d3e44a030e0375$var$Hh($e8d3e44a030e0375$var$Eh.current);
                if ($e8d3e44a030e0375$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e8d3e44a030e0375$var$Of] = b;
                    d[$e8d3e44a030e0375$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e8d3e44a030e0375$var$D("cancel", d);
                            $e8d3e44a030e0375$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e8d3e44a030e0375$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e8d3e44a030e0375$var$lf.length; e++)$e8d3e44a030e0375$var$D($e8d3e44a030e0375$var$lf[e], d);
                            break;
                        case "source":
                            $e8d3e44a030e0375$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e8d3e44a030e0375$var$D("error", d);
                            $e8d3e44a030e0375$var$D("load", d);
                            break;
                        case "details":
                            $e8d3e44a030e0375$var$D("toggle", d);
                            break;
                        case "input":
                            $e8d3e44a030e0375$var$Za(d, f);
                            $e8d3e44a030e0375$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e8d3e44a030e0375$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e8d3e44a030e0375$var$hb(d, f), $e8d3e44a030e0375$var$D("invalid", d);
                    }
                    $e8d3e44a030e0375$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e8d3e44a030e0375$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e8d3e44a030e0375$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e8d3e44a030e0375$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e8d3e44a030e0375$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e8d3e44a030e0375$var$Va(d);
                            $e8d3e44a030e0375$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e8d3e44a030e0375$var$Va(d);
                            $e8d3e44a030e0375$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e8d3e44a030e0375$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e8d3e44a030e0375$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e8d3e44a030e0375$var$Of] = b;
                    a[$e8d3e44a030e0375$var$Pf] = d;
                    $e8d3e44a030e0375$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e8d3e44a030e0375$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e8d3e44a030e0375$var$D("cancel", a);
                                $e8d3e44a030e0375$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e8d3e44a030e0375$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e8d3e44a030e0375$var$lf.length; e++)$e8d3e44a030e0375$var$D($e8d3e44a030e0375$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e8d3e44a030e0375$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e8d3e44a030e0375$var$D("error", a);
                                $e8d3e44a030e0375$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e8d3e44a030e0375$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e8d3e44a030e0375$var$Za(a, d);
                                e = $e8d3e44a030e0375$var$Ya(a, d);
                                $e8d3e44a030e0375$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e8d3e44a030e0375$var$A({}, d, {
                                    value: void 0
                                });
                                $e8d3e44a030e0375$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e8d3e44a030e0375$var$hb(a, d);
                                e = $e8d3e44a030e0375$var$gb(a, d);
                                $e8d3e44a030e0375$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e8d3e44a030e0375$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e8d3e44a030e0375$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e8d3e44a030e0375$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e8d3e44a030e0375$var$ob(a, k) : "number" === typeof k && $e8d3e44a030e0375$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e8d3e44a030e0375$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e8d3e44a030e0375$var$D("scroll", a) : null != k && $e8d3e44a030e0375$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e8d3e44a030e0375$var$Va(a);
                                $e8d3e44a030e0375$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e8d3e44a030e0375$var$Va(a);
                                $e8d3e44a030e0375$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e8d3e44a030e0375$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e8d3e44a030e0375$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e8d3e44a030e0375$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e8d3e44a030e0375$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e8d3e44a030e0375$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e8d3e44a030e0375$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e8d3e44a030e0375$var$p(166));
                c = $e8d3e44a030e0375$var$Hh($e8d3e44a030e0375$var$Gh.current);
                $e8d3e44a030e0375$var$Hh($e8d3e44a030e0375$var$Eh.current);
                if ($e8d3e44a030e0375$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e8d3e44a030e0375$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e8d3e44a030e0375$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e8d3e44a030e0375$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e8d3e44a030e0375$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e8d3e44a030e0375$var$Of] = b, b.stateNode = d;
            }
            $e8d3e44a030e0375$var$S(b);
            return null;
        case 13:
            $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e8d3e44a030e0375$var$I && null !== $e8d3e44a030e0375$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e8d3e44a030e0375$var$Hg(), $e8d3e44a030e0375$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e8d3e44a030e0375$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e8d3e44a030e0375$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e8d3e44a030e0375$var$p(317));
                        f[$e8d3e44a030e0375$var$Of] = b;
                    } else $e8d3e44a030e0375$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e8d3e44a030e0375$var$S(b);
                    f = !1;
                } else null !== $e8d3e44a030e0375$var$zg && ($e8d3e44a030e0375$var$Gj($e8d3e44a030e0375$var$zg), $e8d3e44a030e0375$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e8d3e44a030e0375$var$M.current & 1) ? 0 === $e8d3e44a030e0375$var$T && ($e8d3e44a030e0375$var$T = 3) : $e8d3e44a030e0375$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e8d3e44a030e0375$var$S(b);
            return null;
        case 4:
            return $e8d3e44a030e0375$var$Jh(), $e8d3e44a030e0375$var$Bj(a, b), null === a && $e8d3e44a030e0375$var$sf(b.stateNode.containerInfo), $e8d3e44a030e0375$var$S(b), null;
        case 10:
            return $e8d3e44a030e0375$var$Rg(b.type._context), $e8d3e44a030e0375$var$S(b), null;
        case 17:
            return $e8d3e44a030e0375$var$Zf(b.type) && $e8d3e44a030e0375$var$$f(), $e8d3e44a030e0375$var$S(b), null;
        case 19:
            $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$M);
            f = b.memoizedState;
            if (null === f) return $e8d3e44a030e0375$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e8d3e44a030e0375$var$Ej(f, !1);
                else {
                    if (0 !== $e8d3e44a030e0375$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e8d3e44a030e0375$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e8d3e44a030e0375$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$M, $e8d3e44a030e0375$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e8d3e44a030e0375$var$B() > $e8d3e44a030e0375$var$Hj && (b.flags |= 128, d = !0, $e8d3e44a030e0375$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e8d3e44a030e0375$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e8d3e44a030e0375$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e8d3e44a030e0375$var$I) return $e8d3e44a030e0375$var$S(b), null;
                    } else 2 * $e8d3e44a030e0375$var$B() - f.renderingStartTime > $e8d3e44a030e0375$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $e8d3e44a030e0375$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e8d3e44a030e0375$var$B(), b.sibling = null, c = $e8d3e44a030e0375$var$M.current, $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$M, d ? c & 1 | 2 : c & 1), b;
            $e8d3e44a030e0375$var$S(b);
            return null;
        case 22:
        case 23:
            return $e8d3e44a030e0375$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e8d3e44a030e0375$var$gj & 1073741824) && ($e8d3e44a030e0375$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e8d3e44a030e0375$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e8d3e44a030e0375$var$p(156, b.tag));
}
function $e8d3e44a030e0375$var$Jj(a, b) {
    $e8d3e44a030e0375$var$wg(b);
    switch(b.tag){
        case 1:
            return $e8d3e44a030e0375$var$Zf(b.type) && $e8d3e44a030e0375$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e8d3e44a030e0375$var$Jh(), $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$Wf), $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$H), $e8d3e44a030e0375$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e8d3e44a030e0375$var$Lh(b), null;
        case 13:
            $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e8d3e44a030e0375$var$p(340));
                $e8d3e44a030e0375$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$M), null;
        case 4:
            return $e8d3e44a030e0375$var$Jh(), null;
        case 10:
            return $e8d3e44a030e0375$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $e8d3e44a030e0375$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e8d3e44a030e0375$var$Kj = !1, $e8d3e44a030e0375$var$U = !1, $e8d3e44a030e0375$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $e8d3e44a030e0375$var$V = null;
function $e8d3e44a030e0375$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e8d3e44a030e0375$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e8d3e44a030e0375$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e8d3e44a030e0375$var$W(a, b, d);
    }
}
var $e8d3e44a030e0375$var$Oj = !1;
function $e8d3e44a030e0375$var$Pj(a, b) {
    $e8d3e44a030e0375$var$Cf = $e8d3e44a030e0375$var$dd;
    a = $e8d3e44a030e0375$var$Me();
    if ($e8d3e44a030e0375$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e8d3e44a030e0375$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e8d3e44a030e0375$var$dd = !1;
    for($e8d3e44a030e0375$var$V = b; null !== $e8d3e44a030e0375$var$V;)if (b = $e8d3e44a030e0375$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e8d3e44a030e0375$var$V = a;
    else for(; null !== $e8d3e44a030e0375$var$V;){
        b = $e8d3e44a030e0375$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e8d3e44a030e0375$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e8d3e44a030e0375$var$p(163));
            }
        } catch (F) {
            $e8d3e44a030e0375$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e8d3e44a030e0375$var$V = a;
            break;
        }
        $e8d3e44a030e0375$var$V = b.return;
    }
    n = $e8d3e44a030e0375$var$Oj;
    $e8d3e44a030e0375$var$Oj = !1;
    return n;
}
function $e8d3e44a030e0375$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e8d3e44a030e0375$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e8d3e44a030e0375$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e8d3e44a030e0375$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e8d3e44a030e0375$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e8d3e44a030e0375$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e8d3e44a030e0375$var$Of], delete b[$e8d3e44a030e0375$var$Pf], delete b[$e8d3e44a030e0375$var$of], delete b[$e8d3e44a030e0375$var$Qf], delete b[$e8d3e44a030e0375$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e8d3e44a030e0375$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e8d3e44a030e0375$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e8d3e44a030e0375$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e8d3e44a030e0375$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e8d3e44a030e0375$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e8d3e44a030e0375$var$Wj(a, b, c), a = a.sibling; null !== a;)$e8d3e44a030e0375$var$Wj(a, b, c), a = a.sibling;
}
function $e8d3e44a030e0375$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e8d3e44a030e0375$var$Xj(a, b, c), a = a.sibling; null !== a;)$e8d3e44a030e0375$var$Xj(a, b, c), a = a.sibling;
}
var $e8d3e44a030e0375$var$X = null, $e8d3e44a030e0375$var$Yj = !1;
function $e8d3e44a030e0375$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$e8d3e44a030e0375$var$ak(a, b, c), c = c.sibling;
}
function $e8d3e44a030e0375$var$ak(a, b, c) {
    if ($e8d3e44a030e0375$var$lc && "function" === typeof $e8d3e44a030e0375$var$lc.onCommitFiberUnmount) try {
        $e8d3e44a030e0375$var$lc.onCommitFiberUnmount($e8d3e44a030e0375$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e8d3e44a030e0375$var$U || $e8d3e44a030e0375$var$Mj(c, b);
        case 6:
            var d = $e8d3e44a030e0375$var$X, e = $e8d3e44a030e0375$var$Yj;
            $e8d3e44a030e0375$var$X = null;
            $e8d3e44a030e0375$var$Zj(a, b, c);
            $e8d3e44a030e0375$var$X = d;
            $e8d3e44a030e0375$var$Yj = e;
            null !== $e8d3e44a030e0375$var$X && ($e8d3e44a030e0375$var$Yj ? (a = $e8d3e44a030e0375$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e8d3e44a030e0375$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e8d3e44a030e0375$var$X && ($e8d3e44a030e0375$var$Yj ? (a = $e8d3e44a030e0375$var$X, c = c.stateNode, 8 === a.nodeType ? $e8d3e44a030e0375$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e8d3e44a030e0375$var$Kf(a, c), $e8d3e44a030e0375$var$bd(a)) : $e8d3e44a030e0375$var$Kf($e8d3e44a030e0375$var$X, c.stateNode));
            break;
        case 4:
            d = $e8d3e44a030e0375$var$X;
            e = $e8d3e44a030e0375$var$Yj;
            $e8d3e44a030e0375$var$X = c.stateNode.containerInfo;
            $e8d3e44a030e0375$var$Yj = !0;
            $e8d3e44a030e0375$var$Zj(a, b, c);
            $e8d3e44a030e0375$var$X = d;
            $e8d3e44a030e0375$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e8d3e44a030e0375$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e8d3e44a030e0375$var$Nj(c, b, g) : 0 !== (f & 4) && $e8d3e44a030e0375$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e8d3e44a030e0375$var$Zj(a, b, c);
            break;
        case 1:
            if (!$e8d3e44a030e0375$var$U && ($e8d3e44a030e0375$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e8d3e44a030e0375$var$W(c, b, h);
            }
            $e8d3e44a030e0375$var$Zj(a, b, c);
            break;
        case 21:
            $e8d3e44a030e0375$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e8d3e44a030e0375$var$U = (d = $e8d3e44a030e0375$var$U) || null !== c.memoizedState, $e8d3e44a030e0375$var$Zj(a, b, c), $e8d3e44a030e0375$var$U = d) : $e8d3e44a030e0375$var$Zj(a, b, c);
            break;
        default:
            $e8d3e44a030e0375$var$Zj(a, b, c);
    }
}
function $e8d3e44a030e0375$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e8d3e44a030e0375$var$Lj);
        b.forEach(function(b) {
            var d = $e8d3e44a030e0375$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e8d3e44a030e0375$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e8d3e44a030e0375$var$X = h.stateNode;
                        $e8d3e44a030e0375$var$Yj = !1;
                        break a;
                    case 3:
                        $e8d3e44a030e0375$var$X = h.stateNode.containerInfo;
                        $e8d3e44a030e0375$var$Yj = !0;
                        break a;
                    case 4:
                        $e8d3e44a030e0375$var$X = h.stateNode.containerInfo;
                        $e8d3e44a030e0375$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e8d3e44a030e0375$var$X) throw Error($e8d3e44a030e0375$var$p(160));
            $e8d3e44a030e0375$var$ak(f, g, e);
            $e8d3e44a030e0375$var$X = null;
            $e8d3e44a030e0375$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e8d3e44a030e0375$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e8d3e44a030e0375$var$ek(b, a), b = b.sibling;
}
function $e8d3e44a030e0375$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e8d3e44a030e0375$var$dk(b, a);
            $e8d3e44a030e0375$var$fk(a);
            if (d & 4) {
                try {
                    $e8d3e44a030e0375$var$Qj(3, a, a.return), $e8d3e44a030e0375$var$Rj(3, a);
                } catch (t) {
                    $e8d3e44a030e0375$var$W(a, a.return, t);
                }
                try {
                    $e8d3e44a030e0375$var$Qj(5, a, a.return);
                } catch (t) {
                    $e8d3e44a030e0375$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e8d3e44a030e0375$var$dk(b, a);
            $e8d3e44a030e0375$var$fk(a);
            d & 512 && null !== c && $e8d3e44a030e0375$var$Mj(c, c.return);
            break;
        case 5:
            $e8d3e44a030e0375$var$dk(b, a);
            $e8d3e44a030e0375$var$fk(a);
            d & 512 && null !== c && $e8d3e44a030e0375$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e8d3e44a030e0375$var$ob(e, "");
                } catch (t) {
                    $e8d3e44a030e0375$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e8d3e44a030e0375$var$ab(e, f);
                    $e8d3e44a030e0375$var$vb(h, g);
                    var l = $e8d3e44a030e0375$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e8d3e44a030e0375$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e8d3e44a030e0375$var$nb(e, q) : "children" === m ? $e8d3e44a030e0375$var$ob(e, q) : $e8d3e44a030e0375$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e8d3e44a030e0375$var$bb(e, f);
                            break;
                        case "textarea":
                            $e8d3e44a030e0375$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e8d3e44a030e0375$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e8d3e44a030e0375$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e8d3e44a030e0375$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e8d3e44a030e0375$var$Pf] = f;
                } catch (t) {
                    $e8d3e44a030e0375$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e8d3e44a030e0375$var$dk(b, a);
            $e8d3e44a030e0375$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e8d3e44a030e0375$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e8d3e44a030e0375$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e8d3e44a030e0375$var$dk(b, a);
            $e8d3e44a030e0375$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e8d3e44a030e0375$var$bd(b.containerInfo);
            } catch (t) {
                $e8d3e44a030e0375$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e8d3e44a030e0375$var$dk(b, a);
            $e8d3e44a030e0375$var$fk(a);
            break;
        case 13:
            $e8d3e44a030e0375$var$dk(b, a);
            $e8d3e44a030e0375$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e8d3e44a030e0375$var$gk = $e8d3e44a030e0375$var$B()));
            d & 4 && $e8d3e44a030e0375$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e8d3e44a030e0375$var$U = (l = $e8d3e44a030e0375$var$U) || m, $e8d3e44a030e0375$var$dk(b, a), $e8d3e44a030e0375$var$U = l) : $e8d3e44a030e0375$var$dk(b, a);
            $e8d3e44a030e0375$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e8d3e44a030e0375$var$V = a, m = a.child; null !== m;){
                    for(q = $e8d3e44a030e0375$var$V = m; null !== $e8d3e44a030e0375$var$V;){
                        r = $e8d3e44a030e0375$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e8d3e44a030e0375$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $e8d3e44a030e0375$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e8d3e44a030e0375$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e8d3e44a030e0375$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e8d3e44a030e0375$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e8d3e44a030e0375$var$V = y) : $e8d3e44a030e0375$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e8d3e44a030e0375$var$rb("display", g));
                            } catch (t) {
                                $e8d3e44a030e0375$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e8d3e44a030e0375$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e8d3e44a030e0375$var$dk(b, a);
            $e8d3e44a030e0375$var$fk(a);
            d & 4 && $e8d3e44a030e0375$var$bk(a);
            break;
        case 21:
            break;
        default:
            $e8d3e44a030e0375$var$dk(b, a), $e8d3e44a030e0375$var$fk(a);
    }
}
function $e8d3e44a030e0375$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e8d3e44a030e0375$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e8d3e44a030e0375$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e8d3e44a030e0375$var$ob(e, ""), d.flags &= -33);
                    var f = $e8d3e44a030e0375$var$Vj(a);
                    $e8d3e44a030e0375$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e8d3e44a030e0375$var$Vj(a);
                    $e8d3e44a030e0375$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($e8d3e44a030e0375$var$p(161));
            }
        } catch (k) {
            $e8d3e44a030e0375$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e8d3e44a030e0375$var$ik(a, b, c) {
    $e8d3e44a030e0375$var$V = a;
    $e8d3e44a030e0375$var$jk(a, b, c);
}
function $e8d3e44a030e0375$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e8d3e44a030e0375$var$V;){
        var e = $e8d3e44a030e0375$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e8d3e44a030e0375$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e8d3e44a030e0375$var$U;
                h = $e8d3e44a030e0375$var$Kj;
                var l = $e8d3e44a030e0375$var$U;
                $e8d3e44a030e0375$var$Kj = g;
                if (($e8d3e44a030e0375$var$U = k) && !l) for($e8d3e44a030e0375$var$V = e; null !== $e8d3e44a030e0375$var$V;)g = $e8d3e44a030e0375$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e8d3e44a030e0375$var$kk(e) : null !== k ? (k.return = g, $e8d3e44a030e0375$var$V = k) : $e8d3e44a030e0375$var$kk(e);
                for(; null !== f;)$e8d3e44a030e0375$var$V = f, $e8d3e44a030e0375$var$jk(f, b, c), f = f.sibling;
                $e8d3e44a030e0375$var$V = e;
                $e8d3e44a030e0375$var$Kj = h;
                $e8d3e44a030e0375$var$U = l;
            }
            $e8d3e44a030e0375$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e8d3e44a030e0375$var$V = f) : $e8d3e44a030e0375$var$lk(a, b, c);
    }
}
function $e8d3e44a030e0375$var$lk(a) {
    for(; null !== $e8d3e44a030e0375$var$V;){
        var b = $e8d3e44a030e0375$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e8d3e44a030e0375$var$U || $e8d3e44a030e0375$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e8d3e44a030e0375$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e8d3e44a030e0375$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e8d3e44a030e0375$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e8d3e44a030e0375$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e8d3e44a030e0375$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e8d3e44a030e0375$var$p(163));
                }
                $e8d3e44a030e0375$var$U || b.flags & 512 && $e8d3e44a030e0375$var$Sj(b);
            } catch (r) {
                $e8d3e44a030e0375$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e8d3e44a030e0375$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8d3e44a030e0375$var$V = c;
            break;
        }
        $e8d3e44a030e0375$var$V = b.return;
    }
}
function $e8d3e44a030e0375$var$hk(a) {
    for(; null !== $e8d3e44a030e0375$var$V;){
        var b = $e8d3e44a030e0375$var$V;
        if (b === a) {
            $e8d3e44a030e0375$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8d3e44a030e0375$var$V = c;
            break;
        }
        $e8d3e44a030e0375$var$V = b.return;
    }
}
function $e8d3e44a030e0375$var$kk(a) {
    for(; null !== $e8d3e44a030e0375$var$V;){
        var b = $e8d3e44a030e0375$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e8d3e44a030e0375$var$Rj(4, b);
                    } catch (k) {
                        $e8d3e44a030e0375$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e8d3e44a030e0375$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e8d3e44a030e0375$var$Sj(b);
                    } catch (k) {
                        $e8d3e44a030e0375$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e8d3e44a030e0375$var$Sj(b);
                    } catch (k) {
                        $e8d3e44a030e0375$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e8d3e44a030e0375$var$W(b, b.return, k);
        }
        if (b === a) {
            $e8d3e44a030e0375$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e8d3e44a030e0375$var$V = h;
            break;
        }
        $e8d3e44a030e0375$var$V = b.return;
    }
}
var $e8d3e44a030e0375$var$mk = Math.ceil, $e8d3e44a030e0375$var$nk = $e8d3e44a030e0375$var$ua.ReactCurrentDispatcher, $e8d3e44a030e0375$var$ok = $e8d3e44a030e0375$var$ua.ReactCurrentOwner, $e8d3e44a030e0375$var$pk = $e8d3e44a030e0375$var$ua.ReactCurrentBatchConfig, $e8d3e44a030e0375$var$K = 0, $e8d3e44a030e0375$var$R = null, $e8d3e44a030e0375$var$Y = null, $e8d3e44a030e0375$var$Z = 0, $e8d3e44a030e0375$var$gj = 0, $e8d3e44a030e0375$var$fj = $e8d3e44a030e0375$var$Uf(0), $e8d3e44a030e0375$var$T = 0, $e8d3e44a030e0375$var$qk = null, $e8d3e44a030e0375$var$hh = 0, $e8d3e44a030e0375$var$rk = 0, $e8d3e44a030e0375$var$sk = 0, $e8d3e44a030e0375$var$tk = null, $e8d3e44a030e0375$var$uk = null, $e8d3e44a030e0375$var$gk = 0, $e8d3e44a030e0375$var$Hj = Infinity, $e8d3e44a030e0375$var$vk = null, $e8d3e44a030e0375$var$Pi = !1, $e8d3e44a030e0375$var$Qi = null, $e8d3e44a030e0375$var$Si = null, $e8d3e44a030e0375$var$wk = !1, $e8d3e44a030e0375$var$xk = null, $e8d3e44a030e0375$var$yk = 0, $e8d3e44a030e0375$var$zk = 0, $e8d3e44a030e0375$var$Ak = null, $e8d3e44a030e0375$var$Bk = -1, $e8d3e44a030e0375$var$Ck = 0;
function $e8d3e44a030e0375$var$L() {
    return 0 !== ($e8d3e44a030e0375$var$K & 6) ? $e8d3e44a030e0375$var$B() : -1 !== $e8d3e44a030e0375$var$Bk ? $e8d3e44a030e0375$var$Bk : $e8d3e44a030e0375$var$Bk = $e8d3e44a030e0375$var$B();
}
function $e8d3e44a030e0375$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e8d3e44a030e0375$var$K & 2) && 0 !== $e8d3e44a030e0375$var$Z) return $e8d3e44a030e0375$var$Z & -$e8d3e44a030e0375$var$Z;
    if (null !== $e8d3e44a030e0375$var$Kg.transition) return 0 === $e8d3e44a030e0375$var$Ck && ($e8d3e44a030e0375$var$Ck = $e8d3e44a030e0375$var$yc()), $e8d3e44a030e0375$var$Ck;
    a = $e8d3e44a030e0375$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e8d3e44a030e0375$var$jd(a.type);
    return a;
}
function $e8d3e44a030e0375$var$mh(a, b, c, d) {
    if (50 < $e8d3e44a030e0375$var$zk) throw $e8d3e44a030e0375$var$zk = 0, $e8d3e44a030e0375$var$Ak = null, Error($e8d3e44a030e0375$var$p(185));
    $e8d3e44a030e0375$var$Ac(a, c, d);
    if (0 === ($e8d3e44a030e0375$var$K & 2) || a !== $e8d3e44a030e0375$var$R) a === $e8d3e44a030e0375$var$R && (0 === ($e8d3e44a030e0375$var$K & 2) && ($e8d3e44a030e0375$var$rk |= c), 4 === $e8d3e44a030e0375$var$T && $e8d3e44a030e0375$var$Dk(a, $e8d3e44a030e0375$var$Z)), $e8d3e44a030e0375$var$Ek(a, d), 1 === c && 0 === $e8d3e44a030e0375$var$K && 0 === (b.mode & 1) && ($e8d3e44a030e0375$var$Hj = $e8d3e44a030e0375$var$B() + 500, $e8d3e44a030e0375$var$fg && $e8d3e44a030e0375$var$jg());
}
function $e8d3e44a030e0375$var$Ek(a, b) {
    var c = a.callbackNode;
    $e8d3e44a030e0375$var$wc(a, b);
    var d = $e8d3e44a030e0375$var$uc(a, a === $e8d3e44a030e0375$var$R ? $e8d3e44a030e0375$var$Z : 0);
    if (0 === d) null !== c && $e8d3e44a030e0375$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e8d3e44a030e0375$var$bc(c);
        if (1 === b) 0 === a.tag ? $e8d3e44a030e0375$var$ig($e8d3e44a030e0375$var$Fk.bind(null, a)) : $e8d3e44a030e0375$var$hg($e8d3e44a030e0375$var$Fk.bind(null, a)), $e8d3e44a030e0375$var$Jf(function() {
            0 === ($e8d3e44a030e0375$var$K & 6) && $e8d3e44a030e0375$var$jg();
        }), c = null;
        else {
            switch($e8d3e44a030e0375$var$Dc(d)){
                case 1:
                    c = $e8d3e44a030e0375$var$fc;
                    break;
                case 4:
                    c = $e8d3e44a030e0375$var$gc;
                    break;
                case 16:
                    c = $e8d3e44a030e0375$var$hc;
                    break;
                case 536870912:
                    c = $e8d3e44a030e0375$var$jc;
                    break;
                default:
                    c = $e8d3e44a030e0375$var$hc;
            }
            c = $e8d3e44a030e0375$var$Gk(c, $e8d3e44a030e0375$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e8d3e44a030e0375$var$Hk(a, b) {
    $e8d3e44a030e0375$var$Bk = -1;
    $e8d3e44a030e0375$var$Ck = 0;
    if (0 !== ($e8d3e44a030e0375$var$K & 6)) throw Error($e8d3e44a030e0375$var$p(327));
    var c = a.callbackNode;
    if ($e8d3e44a030e0375$var$Ik() && a.callbackNode !== c) return null;
    var d = $e8d3e44a030e0375$var$uc(a, a === $e8d3e44a030e0375$var$R ? $e8d3e44a030e0375$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e8d3e44a030e0375$var$Jk(a, d);
    else {
        b = d;
        var e = $e8d3e44a030e0375$var$K;
        $e8d3e44a030e0375$var$K |= 2;
        var f = $e8d3e44a030e0375$var$Kk();
        if ($e8d3e44a030e0375$var$R !== a || $e8d3e44a030e0375$var$Z !== b) $e8d3e44a030e0375$var$vk = null, $e8d3e44a030e0375$var$Hj = $e8d3e44a030e0375$var$B() + 500, $e8d3e44a030e0375$var$Lk(a, b);
        for(;;)try {
            $e8d3e44a030e0375$var$Mk();
            break;
        } catch (h) {
            $e8d3e44a030e0375$var$Nk(a, h);
        }
        $e8d3e44a030e0375$var$Qg();
        $e8d3e44a030e0375$var$nk.current = f;
        $e8d3e44a030e0375$var$K = e;
        null !== $e8d3e44a030e0375$var$Y ? b = 0 : ($e8d3e44a030e0375$var$R = null, $e8d3e44a030e0375$var$Z = 0, b = $e8d3e44a030e0375$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e8d3e44a030e0375$var$xc(a), 0 !== e && (d = e, b = $e8d3e44a030e0375$var$Ok(a, e)));
        if (1 === b) throw c = $e8d3e44a030e0375$var$qk, $e8d3e44a030e0375$var$Lk(a, 0), $e8d3e44a030e0375$var$Dk(a, d), $e8d3e44a030e0375$var$Ek(a, $e8d3e44a030e0375$var$B()), c;
        if (6 === b) $e8d3e44a030e0375$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e8d3e44a030e0375$var$Pk(e) && (b = $e8d3e44a030e0375$var$Jk(a, d), 2 === b && (f = $e8d3e44a030e0375$var$xc(a), 0 !== f && (d = f, b = $e8d3e44a030e0375$var$Ok(a, f))), 1 === b)) throw c = $e8d3e44a030e0375$var$qk, $e8d3e44a030e0375$var$Lk(a, 0), $e8d3e44a030e0375$var$Dk(a, d), $e8d3e44a030e0375$var$Ek(a, $e8d3e44a030e0375$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e8d3e44a030e0375$var$p(345));
                case 2:
                    $e8d3e44a030e0375$var$Qk(a, $e8d3e44a030e0375$var$uk, $e8d3e44a030e0375$var$vk);
                    break;
                case 3:
                    $e8d3e44a030e0375$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $e8d3e44a030e0375$var$gk + 500 - $e8d3e44a030e0375$var$B(), 10 < b)) {
                        if (0 !== $e8d3e44a030e0375$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e8d3e44a030e0375$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e8d3e44a030e0375$var$Ff($e8d3e44a030e0375$var$Qk.bind(null, a, $e8d3e44a030e0375$var$uk, $e8d3e44a030e0375$var$vk), b);
                        break;
                    }
                    $e8d3e44a030e0375$var$Qk(a, $e8d3e44a030e0375$var$uk, $e8d3e44a030e0375$var$vk);
                    break;
                case 4:
                    $e8d3e44a030e0375$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e8d3e44a030e0375$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e8d3e44a030e0375$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e8d3e44a030e0375$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e8d3e44a030e0375$var$Ff($e8d3e44a030e0375$var$Qk.bind(null, a, $e8d3e44a030e0375$var$uk, $e8d3e44a030e0375$var$vk), d);
                        break;
                    }
                    $e8d3e44a030e0375$var$Qk(a, $e8d3e44a030e0375$var$uk, $e8d3e44a030e0375$var$vk);
                    break;
                case 5:
                    $e8d3e44a030e0375$var$Qk(a, $e8d3e44a030e0375$var$uk, $e8d3e44a030e0375$var$vk);
                    break;
                default:
                    throw Error($e8d3e44a030e0375$var$p(329));
            }
        }
    }
    $e8d3e44a030e0375$var$Ek(a, $e8d3e44a030e0375$var$B());
    return a.callbackNode === c ? $e8d3e44a030e0375$var$Hk.bind(null, a) : null;
}
function $e8d3e44a030e0375$var$Ok(a, b) {
    var c = $e8d3e44a030e0375$var$tk;
    a.current.memoizedState.isDehydrated && ($e8d3e44a030e0375$var$Lk(a, b).flags |= 256);
    a = $e8d3e44a030e0375$var$Jk(a, b);
    2 !== a && (b = $e8d3e44a030e0375$var$uk, $e8d3e44a030e0375$var$uk = c, null !== b && $e8d3e44a030e0375$var$Gj(b));
    return a;
}
function $e8d3e44a030e0375$var$Gj(a) {
    null === $e8d3e44a030e0375$var$uk ? $e8d3e44a030e0375$var$uk = a : $e8d3e44a030e0375$var$uk.push.apply($e8d3e44a030e0375$var$uk, a);
}
function $e8d3e44a030e0375$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e8d3e44a030e0375$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e8d3e44a030e0375$var$Dk(a, b) {
    b &= ~$e8d3e44a030e0375$var$sk;
    b &= ~$e8d3e44a030e0375$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e8d3e44a030e0375$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e8d3e44a030e0375$var$Fk(a) {
    if (0 !== ($e8d3e44a030e0375$var$K & 6)) throw Error($e8d3e44a030e0375$var$p(327));
    $e8d3e44a030e0375$var$Ik();
    var b = $e8d3e44a030e0375$var$uc(a, 0);
    if (0 === (b & 1)) return $e8d3e44a030e0375$var$Ek(a, $e8d3e44a030e0375$var$B()), null;
    var c = $e8d3e44a030e0375$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e8d3e44a030e0375$var$xc(a);
        0 !== d && (b = d, c = $e8d3e44a030e0375$var$Ok(a, d));
    }
    if (1 === c) throw c = $e8d3e44a030e0375$var$qk, $e8d3e44a030e0375$var$Lk(a, 0), $e8d3e44a030e0375$var$Dk(a, b), $e8d3e44a030e0375$var$Ek(a, $e8d3e44a030e0375$var$B()), c;
    if (6 === c) throw Error($e8d3e44a030e0375$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e8d3e44a030e0375$var$Qk(a, $e8d3e44a030e0375$var$uk, $e8d3e44a030e0375$var$vk);
    $e8d3e44a030e0375$var$Ek(a, $e8d3e44a030e0375$var$B());
    return null;
}
function $e8d3e44a030e0375$var$Rk(a, b) {
    var c = $e8d3e44a030e0375$var$K;
    $e8d3e44a030e0375$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e8d3e44a030e0375$var$K = c, 0 === $e8d3e44a030e0375$var$K && ($e8d3e44a030e0375$var$Hj = $e8d3e44a030e0375$var$B() + 500, $e8d3e44a030e0375$var$fg && $e8d3e44a030e0375$var$jg());
    }
}
function $e8d3e44a030e0375$var$Sk(a) {
    null !== $e8d3e44a030e0375$var$xk && 0 === $e8d3e44a030e0375$var$xk.tag && 0 === ($e8d3e44a030e0375$var$K & 6) && $e8d3e44a030e0375$var$Ik();
    var b = $e8d3e44a030e0375$var$K;
    $e8d3e44a030e0375$var$K |= 1;
    var c = $e8d3e44a030e0375$var$pk.transition, d = $e8d3e44a030e0375$var$C;
    try {
        if ($e8d3e44a030e0375$var$pk.transition = null, $e8d3e44a030e0375$var$C = 1, a) return a();
    } finally{
        $e8d3e44a030e0375$var$C = d, $e8d3e44a030e0375$var$pk.transition = c, $e8d3e44a030e0375$var$K = b, 0 === ($e8d3e44a030e0375$var$K & 6) && $e8d3e44a030e0375$var$jg();
    }
}
function $e8d3e44a030e0375$var$Ij() {
    $e8d3e44a030e0375$var$gj = $e8d3e44a030e0375$var$fj.current;
    $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$fj);
}
function $e8d3e44a030e0375$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e8d3e44a030e0375$var$Gf(c));
    if (null !== $e8d3e44a030e0375$var$Y) for(c = $e8d3e44a030e0375$var$Y.return; null !== c;){
        var d = c;
        $e8d3e44a030e0375$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e8d3e44a030e0375$var$$f();
                break;
            case 3:
                $e8d3e44a030e0375$var$Jh();
                $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$Wf);
                $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$H);
                $e8d3e44a030e0375$var$Oh();
                break;
            case 5:
                $e8d3e44a030e0375$var$Lh(d);
                break;
            case 4:
                $e8d3e44a030e0375$var$Jh();
                break;
            case 13:
                $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$M);
                break;
            case 19:
                $e8d3e44a030e0375$var$E($e8d3e44a030e0375$var$M);
                break;
            case 10:
                $e8d3e44a030e0375$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $e8d3e44a030e0375$var$Ij();
        }
        c = c.return;
    }
    $e8d3e44a030e0375$var$R = a;
    $e8d3e44a030e0375$var$Y = a = $e8d3e44a030e0375$var$wh(a.current, null);
    $e8d3e44a030e0375$var$Z = $e8d3e44a030e0375$var$gj = b;
    $e8d3e44a030e0375$var$T = 0;
    $e8d3e44a030e0375$var$qk = null;
    $e8d3e44a030e0375$var$sk = $e8d3e44a030e0375$var$rk = $e8d3e44a030e0375$var$hh = 0;
    $e8d3e44a030e0375$var$uk = $e8d3e44a030e0375$var$tk = null;
    if (null !== $e8d3e44a030e0375$var$Wg) {
        for(b = 0; b < $e8d3e44a030e0375$var$Wg.length; b++)if (c = $e8d3e44a030e0375$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e8d3e44a030e0375$var$Wg = null;
    }
    return a;
}
function $e8d3e44a030e0375$var$Nk(a, b) {
    do {
        var c = $e8d3e44a030e0375$var$Y;
        try {
            $e8d3e44a030e0375$var$Qg();
            $e8d3e44a030e0375$var$Ph.current = $e8d3e44a030e0375$var$ai;
            if ($e8d3e44a030e0375$var$Sh) {
                for(var d = $e8d3e44a030e0375$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e8d3e44a030e0375$var$Sh = !1;
            }
            $e8d3e44a030e0375$var$Rh = 0;
            $e8d3e44a030e0375$var$P = $e8d3e44a030e0375$var$O = $e8d3e44a030e0375$var$N = null;
            $e8d3e44a030e0375$var$Th = !1;
            $e8d3e44a030e0375$var$Uh = 0;
            $e8d3e44a030e0375$var$ok.current = null;
            if (null === c || null === c.return) {
                $e8d3e44a030e0375$var$T = 1;
                $e8d3e44a030e0375$var$qk = b;
                $e8d3e44a030e0375$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e8d3e44a030e0375$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e8d3e44a030e0375$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e8d3e44a030e0375$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $e8d3e44a030e0375$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e8d3e44a030e0375$var$Ti(f, l, b);
                            $e8d3e44a030e0375$var$uj();
                            break a;
                        }
                        k = Error($e8d3e44a030e0375$var$p(426));
                    }
                } else if ($e8d3e44a030e0375$var$I && h.mode & 1) {
                    var J = $e8d3e44a030e0375$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e8d3e44a030e0375$var$Wi(J, g, h, f, b);
                        $e8d3e44a030e0375$var$Jg($e8d3e44a030e0375$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $e8d3e44a030e0375$var$Ki(k, h);
                4 !== $e8d3e44a030e0375$var$T && ($e8d3e44a030e0375$var$T = 2);
                null === $e8d3e44a030e0375$var$tk ? $e8d3e44a030e0375$var$tk = [
                    f
                ] : $e8d3e44a030e0375$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e8d3e44a030e0375$var$Oi(f, k, b);
                            $e8d3e44a030e0375$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e8d3e44a030e0375$var$Si || !$e8d3e44a030e0375$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e8d3e44a030e0375$var$Ri(f, h, b);
                                $e8d3e44a030e0375$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e8d3e44a030e0375$var$Tk(c);
        } catch (na) {
            b = na;
            $e8d3e44a030e0375$var$Y === c && null !== c && ($e8d3e44a030e0375$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e8d3e44a030e0375$var$Kk() {
    var a = $e8d3e44a030e0375$var$nk.current;
    $e8d3e44a030e0375$var$nk.current = $e8d3e44a030e0375$var$ai;
    return null === a ? $e8d3e44a030e0375$var$ai : a;
}
function $e8d3e44a030e0375$var$uj() {
    if (0 === $e8d3e44a030e0375$var$T || 3 === $e8d3e44a030e0375$var$T || 2 === $e8d3e44a030e0375$var$T) $e8d3e44a030e0375$var$T = 4;
    null === $e8d3e44a030e0375$var$R || 0 === ($e8d3e44a030e0375$var$hh & 268435455) && 0 === ($e8d3e44a030e0375$var$rk & 268435455) || $e8d3e44a030e0375$var$Dk($e8d3e44a030e0375$var$R, $e8d3e44a030e0375$var$Z);
}
function $e8d3e44a030e0375$var$Jk(a, b) {
    var c = $e8d3e44a030e0375$var$K;
    $e8d3e44a030e0375$var$K |= 2;
    var d = $e8d3e44a030e0375$var$Kk();
    if ($e8d3e44a030e0375$var$R !== a || $e8d3e44a030e0375$var$Z !== b) $e8d3e44a030e0375$var$vk = null, $e8d3e44a030e0375$var$Lk(a, b);
    for(;;)try {
        $e8d3e44a030e0375$var$Uk();
        break;
    } catch (e) {
        $e8d3e44a030e0375$var$Nk(a, e);
    }
    $e8d3e44a030e0375$var$Qg();
    $e8d3e44a030e0375$var$K = c;
    $e8d3e44a030e0375$var$nk.current = d;
    if (null !== $e8d3e44a030e0375$var$Y) throw Error($e8d3e44a030e0375$var$p(261));
    $e8d3e44a030e0375$var$R = null;
    $e8d3e44a030e0375$var$Z = 0;
    return $e8d3e44a030e0375$var$T;
}
function $e8d3e44a030e0375$var$Uk() {
    for(; null !== $e8d3e44a030e0375$var$Y;)$e8d3e44a030e0375$var$Vk($e8d3e44a030e0375$var$Y);
}
function $e8d3e44a030e0375$var$Mk() {
    for(; null !== $e8d3e44a030e0375$var$Y && !$e8d3e44a030e0375$var$cc();)$e8d3e44a030e0375$var$Vk($e8d3e44a030e0375$var$Y);
}
function $e8d3e44a030e0375$var$Vk(a) {
    var b = $e8d3e44a030e0375$var$Wk(a.alternate, a, $e8d3e44a030e0375$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e8d3e44a030e0375$var$Tk(a) : $e8d3e44a030e0375$var$Y = b;
    $e8d3e44a030e0375$var$ok.current = null;
}
function $e8d3e44a030e0375$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e8d3e44a030e0375$var$Fj(c, b, $e8d3e44a030e0375$var$gj), null !== c) {
                $e8d3e44a030e0375$var$Y = c;
                return;
            }
        } else {
            c = $e8d3e44a030e0375$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e8d3e44a030e0375$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e8d3e44a030e0375$var$T = 6;
                $e8d3e44a030e0375$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e8d3e44a030e0375$var$Y = b;
            return;
        }
        $e8d3e44a030e0375$var$Y = b = a;
    }while (null !== b);
    0 === $e8d3e44a030e0375$var$T && ($e8d3e44a030e0375$var$T = 5);
}
function $e8d3e44a030e0375$var$Qk(a, b, c) {
    var d = $e8d3e44a030e0375$var$C, e = $e8d3e44a030e0375$var$pk.transition;
    try {
        $e8d3e44a030e0375$var$pk.transition = null, $e8d3e44a030e0375$var$C = 1, $e8d3e44a030e0375$var$Xk(a, b, c, d);
    } finally{
        $e8d3e44a030e0375$var$pk.transition = e, $e8d3e44a030e0375$var$C = d;
    }
    return null;
}
function $e8d3e44a030e0375$var$Xk(a, b, c, d) {
    do $e8d3e44a030e0375$var$Ik();
    while (null !== $e8d3e44a030e0375$var$xk);
    if (0 !== ($e8d3e44a030e0375$var$K & 6)) throw Error($e8d3e44a030e0375$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e8d3e44a030e0375$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e8d3e44a030e0375$var$Bc(a, f);
    a === $e8d3e44a030e0375$var$R && ($e8d3e44a030e0375$var$Y = $e8d3e44a030e0375$var$R = null, $e8d3e44a030e0375$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e8d3e44a030e0375$var$wk || ($e8d3e44a030e0375$var$wk = !0, $e8d3e44a030e0375$var$Gk($e8d3e44a030e0375$var$hc, function() {
        $e8d3e44a030e0375$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e8d3e44a030e0375$var$pk.transition;
        $e8d3e44a030e0375$var$pk.transition = null;
        var g = $e8d3e44a030e0375$var$C;
        $e8d3e44a030e0375$var$C = 1;
        var h = $e8d3e44a030e0375$var$K;
        $e8d3e44a030e0375$var$K |= 4;
        $e8d3e44a030e0375$var$ok.current = null;
        $e8d3e44a030e0375$var$Pj(a, c);
        $e8d3e44a030e0375$var$ek(c, a);
        $e8d3e44a030e0375$var$Oe($e8d3e44a030e0375$var$Df);
        $e8d3e44a030e0375$var$dd = !!$e8d3e44a030e0375$var$Cf;
        $e8d3e44a030e0375$var$Df = $e8d3e44a030e0375$var$Cf = null;
        a.current = c;
        $e8d3e44a030e0375$var$ik(c, a, e);
        $e8d3e44a030e0375$var$dc();
        $e8d3e44a030e0375$var$K = h;
        $e8d3e44a030e0375$var$C = g;
        $e8d3e44a030e0375$var$pk.transition = f;
    } else a.current = c;
    $e8d3e44a030e0375$var$wk && ($e8d3e44a030e0375$var$wk = !1, $e8d3e44a030e0375$var$xk = a, $e8d3e44a030e0375$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($e8d3e44a030e0375$var$Si = null);
    $e8d3e44a030e0375$var$mc(c.stateNode, d);
    $e8d3e44a030e0375$var$Ek(a, $e8d3e44a030e0375$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e8d3e44a030e0375$var$Pi) throw $e8d3e44a030e0375$var$Pi = !1, a = $e8d3e44a030e0375$var$Qi, $e8d3e44a030e0375$var$Qi = null, a;
    0 !== ($e8d3e44a030e0375$var$yk & 1) && 0 !== a.tag && $e8d3e44a030e0375$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e8d3e44a030e0375$var$Ak ? $e8d3e44a030e0375$var$zk++ : ($e8d3e44a030e0375$var$zk = 0, $e8d3e44a030e0375$var$Ak = a) : $e8d3e44a030e0375$var$zk = 0;
    $e8d3e44a030e0375$var$jg();
    return null;
}
function $e8d3e44a030e0375$var$Ik() {
    if (null !== $e8d3e44a030e0375$var$xk) {
        var a = $e8d3e44a030e0375$var$Dc($e8d3e44a030e0375$var$yk), b = $e8d3e44a030e0375$var$pk.transition, c = $e8d3e44a030e0375$var$C;
        try {
            $e8d3e44a030e0375$var$pk.transition = null;
            $e8d3e44a030e0375$var$C = 16 > a ? 16 : a;
            if (null === $e8d3e44a030e0375$var$xk) var d = !1;
            else {
                a = $e8d3e44a030e0375$var$xk;
                $e8d3e44a030e0375$var$xk = null;
                $e8d3e44a030e0375$var$yk = 0;
                if (0 !== ($e8d3e44a030e0375$var$K & 6)) throw Error($e8d3e44a030e0375$var$p(331));
                var e = $e8d3e44a030e0375$var$K;
                $e8d3e44a030e0375$var$K |= 4;
                for($e8d3e44a030e0375$var$V = a.current; null !== $e8d3e44a030e0375$var$V;){
                    var f = $e8d3e44a030e0375$var$V, g = f.child;
                    if (0 !== ($e8d3e44a030e0375$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e8d3e44a030e0375$var$V = l; null !== $e8d3e44a030e0375$var$V;){
                                    var m = $e8d3e44a030e0375$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e8d3e44a030e0375$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e8d3e44a030e0375$var$V = q;
                                    else for(; null !== $e8d3e44a030e0375$var$V;){
                                        m = $e8d3e44a030e0375$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e8d3e44a030e0375$var$Tj(m);
                                        if (m === l) {
                                            $e8d3e44a030e0375$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e8d3e44a030e0375$var$V = r;
                                            break;
                                        }
                                        $e8d3e44a030e0375$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e8d3e44a030e0375$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e8d3e44a030e0375$var$V = g;
                    else b: for(; null !== $e8d3e44a030e0375$var$V;){
                        f = $e8d3e44a030e0375$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e8d3e44a030e0375$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e8d3e44a030e0375$var$V = x;
                            break b;
                        }
                        $e8d3e44a030e0375$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e8d3e44a030e0375$var$V = w; null !== $e8d3e44a030e0375$var$V;){
                    g = $e8d3e44a030e0375$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e8d3e44a030e0375$var$V = u;
                    else b: for(g = w; null !== $e8d3e44a030e0375$var$V;){
                        h = $e8d3e44a030e0375$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e8d3e44a030e0375$var$Rj(9, h);
                            }
                        } catch (na) {
                            $e8d3e44a030e0375$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e8d3e44a030e0375$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e8d3e44a030e0375$var$V = F;
                            break b;
                        }
                        $e8d3e44a030e0375$var$V = h.return;
                    }
                }
                $e8d3e44a030e0375$var$K = e;
                $e8d3e44a030e0375$var$jg();
                if ($e8d3e44a030e0375$var$lc && "function" === typeof $e8d3e44a030e0375$var$lc.onPostCommitFiberRoot) try {
                    $e8d3e44a030e0375$var$lc.onPostCommitFiberRoot($e8d3e44a030e0375$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e8d3e44a030e0375$var$C = c, $e8d3e44a030e0375$var$pk.transition = b;
        }
    }
    return !1;
}
function $e8d3e44a030e0375$var$Yk(a, b, c) {
    b = $e8d3e44a030e0375$var$Ki(c, b);
    b = $e8d3e44a030e0375$var$Oi(a, b, 1);
    a = $e8d3e44a030e0375$var$dh(a, b, 1);
    b = $e8d3e44a030e0375$var$L();
    null !== a && ($e8d3e44a030e0375$var$Ac(a, 1, b), $e8d3e44a030e0375$var$Ek(a, b));
}
function $e8d3e44a030e0375$var$W(a, b, c) {
    if (3 === a.tag) $e8d3e44a030e0375$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e8d3e44a030e0375$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e8d3e44a030e0375$var$Si || !$e8d3e44a030e0375$var$Si.has(d))) {
                a = $e8d3e44a030e0375$var$Ki(c, a);
                a = $e8d3e44a030e0375$var$Ri(b, a, 1);
                b = $e8d3e44a030e0375$var$dh(b, a, 1);
                a = $e8d3e44a030e0375$var$L();
                null !== b && ($e8d3e44a030e0375$var$Ac(b, 1, a), $e8d3e44a030e0375$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e8d3e44a030e0375$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e8d3e44a030e0375$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $e8d3e44a030e0375$var$R === a && ($e8d3e44a030e0375$var$Z & c) === c && (4 === $e8d3e44a030e0375$var$T || 3 === $e8d3e44a030e0375$var$T && ($e8d3e44a030e0375$var$Z & 130023424) === $e8d3e44a030e0375$var$Z && 500 > $e8d3e44a030e0375$var$B() - $e8d3e44a030e0375$var$gk ? $e8d3e44a030e0375$var$Lk(a, 0) : $e8d3e44a030e0375$var$sk |= c);
    $e8d3e44a030e0375$var$Ek(a, b);
}
function $e8d3e44a030e0375$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e8d3e44a030e0375$var$sc, $e8d3e44a030e0375$var$sc <<= 1, 0 === ($e8d3e44a030e0375$var$sc & 130023424) && ($e8d3e44a030e0375$var$sc = 4194304)));
    var c = $e8d3e44a030e0375$var$L();
    a = $e8d3e44a030e0375$var$Zg(a, b);
    null !== a && ($e8d3e44a030e0375$var$Ac(a, b, c), $e8d3e44a030e0375$var$Ek(a, c));
}
function $e8d3e44a030e0375$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e8d3e44a030e0375$var$Zk(a, c);
}
function $e8d3e44a030e0375$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e8d3e44a030e0375$var$p(314));
    }
    null !== d && d.delete(b);
    $e8d3e44a030e0375$var$Zk(a, c);
}
var $e8d3e44a030e0375$var$Wk;
$e8d3e44a030e0375$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e8d3e44a030e0375$var$Wf.current) $e8d3e44a030e0375$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e8d3e44a030e0375$var$Ug = !1, $e8d3e44a030e0375$var$zj(a, b, c);
            $e8d3e44a030e0375$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e8d3e44a030e0375$var$Ug = !1, $e8d3e44a030e0375$var$I && 0 !== (b.flags & 1048576) && $e8d3e44a030e0375$var$ug(b, $e8d3e44a030e0375$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e8d3e44a030e0375$var$jj(a, b);
            a = b.pendingProps;
            var e = $e8d3e44a030e0375$var$Yf(b, $e8d3e44a030e0375$var$H.current);
            $e8d3e44a030e0375$var$Tg(b, c);
            e = $e8d3e44a030e0375$var$Xh(null, b, d, a, e, c);
            var f = $e8d3e44a030e0375$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e8d3e44a030e0375$var$Zf(d) ? (f = !0, $e8d3e44a030e0375$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e8d3e44a030e0375$var$ah(b), e.updater = $e8d3e44a030e0375$var$nh, b.stateNode = e, e._reactInternals = b, $e8d3e44a030e0375$var$rh(b, d, a, c), b = $e8d3e44a030e0375$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $e8d3e44a030e0375$var$I && f && $e8d3e44a030e0375$var$vg(b), $e8d3e44a030e0375$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e8d3e44a030e0375$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e8d3e44a030e0375$var$$k(d);
                a = $e8d3e44a030e0375$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $e8d3e44a030e0375$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e8d3e44a030e0375$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e8d3e44a030e0375$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e8d3e44a030e0375$var$aj(null, b, d, $e8d3e44a030e0375$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($e8d3e44a030e0375$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8d3e44a030e0375$var$Lg(d, e), $e8d3e44a030e0375$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8d3e44a030e0375$var$Lg(d, e), $e8d3e44a030e0375$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $e8d3e44a030e0375$var$lj(b);
                if (null === a) throw Error($e8d3e44a030e0375$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e8d3e44a030e0375$var$bh(a, b);
                $e8d3e44a030e0375$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e8d3e44a030e0375$var$Ki(Error($e8d3e44a030e0375$var$p(423)), b);
                        b = $e8d3e44a030e0375$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e8d3e44a030e0375$var$Ki(Error($e8d3e44a030e0375$var$p(424)), b);
                        b = $e8d3e44a030e0375$var$mj(a, b, d, c, e);
                        break a;
                    } else for($e8d3e44a030e0375$var$yg = $e8d3e44a030e0375$var$Lf(b.stateNode.containerInfo.firstChild), $e8d3e44a030e0375$var$xg = b, $e8d3e44a030e0375$var$I = !0, $e8d3e44a030e0375$var$zg = null, c = $e8d3e44a030e0375$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e8d3e44a030e0375$var$Ig();
                    if (d === e) {
                        b = $e8d3e44a030e0375$var$$i(a, b, c);
                        break a;
                    }
                    $e8d3e44a030e0375$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e8d3e44a030e0375$var$Kh(b), null === a && $e8d3e44a030e0375$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e8d3e44a030e0375$var$Ef(d, e) ? g = null : null !== f && $e8d3e44a030e0375$var$Ef(d, f) && (b.flags |= 32), $e8d3e44a030e0375$var$hj(a, b), $e8d3e44a030e0375$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $e8d3e44a030e0375$var$Eg(b), null;
        case 13:
            return $e8d3e44a030e0375$var$pj(a, b, c);
        case 4:
            return $e8d3e44a030e0375$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e8d3e44a030e0375$var$Bh(b, null, d, c) : $e8d3e44a030e0375$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8d3e44a030e0375$var$Lg(d, e), $e8d3e44a030e0375$var$Zi(a, b, d, e, c);
        case 7:
            return $e8d3e44a030e0375$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e8d3e44a030e0375$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e8d3e44a030e0375$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e8d3e44a030e0375$var$G($e8d3e44a030e0375$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e8d3e44a030e0375$var$He(f.value, g)) {
                        if (f.children === e.children && !$e8d3e44a030e0375$var$Wf.current) {
                            b = $e8d3e44a030e0375$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e8d3e44a030e0375$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e8d3e44a030e0375$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e8d3e44a030e0375$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e8d3e44a030e0375$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e8d3e44a030e0375$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e8d3e44a030e0375$var$Tg(b, c), e = $e8d3e44a030e0375$var$Vg(e), d = d(e), b.flags |= 1, $e8d3e44a030e0375$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e8d3e44a030e0375$var$Lg(d, b.pendingProps), e = $e8d3e44a030e0375$var$Lg(d.type, e), $e8d3e44a030e0375$var$aj(a, b, d, e, c);
        case 15:
            return $e8d3e44a030e0375$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8d3e44a030e0375$var$Lg(d, e), $e8d3e44a030e0375$var$jj(a, b), b.tag = 1, $e8d3e44a030e0375$var$Zf(d) ? (a = !0, $e8d3e44a030e0375$var$cg(b)) : a = !1, $e8d3e44a030e0375$var$Tg(b, c), $e8d3e44a030e0375$var$ph(b, d, e), $e8d3e44a030e0375$var$rh(b, d, e, c), $e8d3e44a030e0375$var$kj(null, b, d, !0, a, c);
        case 19:
            return $e8d3e44a030e0375$var$yj(a, b, c);
        case 22:
            return $e8d3e44a030e0375$var$ej(a, b, c);
    }
    throw Error($e8d3e44a030e0375$var$p(156, b.tag));
};
function $e8d3e44a030e0375$var$Gk(a, b) {
    return $e8d3e44a030e0375$var$ac(a, b);
}
function $e8d3e44a030e0375$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e8d3e44a030e0375$var$Bg(a, b, c, d) {
    return new $e8d3e44a030e0375$var$al(a, b, c, d);
}
function $e8d3e44a030e0375$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e8d3e44a030e0375$var$$k(a) {
    if ("function" === typeof a) return $e8d3e44a030e0375$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e8d3e44a030e0375$var$Da) return 11;
        if (a === $e8d3e44a030e0375$var$Ga) return 14;
    }
    return 2;
}
function $e8d3e44a030e0375$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $e8d3e44a030e0375$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e8d3e44a030e0375$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e8d3e44a030e0375$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e8d3e44a030e0375$var$ya:
            return $e8d3e44a030e0375$var$Ah(c.children, e, f, b);
        case $e8d3e44a030e0375$var$za:
            g = 8;
            e |= 8;
            break;
        case $e8d3e44a030e0375$var$Aa:
            return a = $e8d3e44a030e0375$var$Bg(12, c, b, e | 2), a.elementType = $e8d3e44a030e0375$var$Aa, a.lanes = f, a;
        case $e8d3e44a030e0375$var$Ea:
            return a = $e8d3e44a030e0375$var$Bg(13, c, b, e), a.elementType = $e8d3e44a030e0375$var$Ea, a.lanes = f, a;
        case $e8d3e44a030e0375$var$Fa:
            return a = $e8d3e44a030e0375$var$Bg(19, c, b, e), a.elementType = $e8d3e44a030e0375$var$Fa, a.lanes = f, a;
        case $e8d3e44a030e0375$var$Ia:
            return $e8d3e44a030e0375$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e8d3e44a030e0375$var$Ba:
                    g = 10;
                    break a;
                case $e8d3e44a030e0375$var$Ca:
                    g = 9;
                    break a;
                case $e8d3e44a030e0375$var$Da:
                    g = 11;
                    break a;
                case $e8d3e44a030e0375$var$Ga:
                    g = 14;
                    break a;
                case $e8d3e44a030e0375$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e8d3e44a030e0375$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e8d3e44a030e0375$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e8d3e44a030e0375$var$Ah(a, b, c, d) {
    a = $e8d3e44a030e0375$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e8d3e44a030e0375$var$qj(a, b, c, d) {
    a = $e8d3e44a030e0375$var$Bg(22, a, d, b);
    a.elementType = $e8d3e44a030e0375$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e8d3e44a030e0375$var$xh(a, b, c) {
    a = $e8d3e44a030e0375$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e8d3e44a030e0375$var$zh(a, b, c) {
    b = $e8d3e44a030e0375$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e8d3e44a030e0375$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e8d3e44a030e0375$var$zc(0);
    this.expirationTimes = $e8d3e44a030e0375$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e8d3e44a030e0375$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e8d3e44a030e0375$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $e8d3e44a030e0375$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e8d3e44a030e0375$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e8d3e44a030e0375$var$ah(f);
    return a;
}
function $e8d3e44a030e0375$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e8d3e44a030e0375$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e8d3e44a030e0375$var$el(a) {
    if (!a) return $e8d3e44a030e0375$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e8d3e44a030e0375$var$Vb(a) !== a || 1 !== a.tag) throw Error($e8d3e44a030e0375$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e8d3e44a030e0375$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e8d3e44a030e0375$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e8d3e44a030e0375$var$Zf(c)) return $e8d3e44a030e0375$var$bg(a, c, b);
    }
    return b;
}
function $e8d3e44a030e0375$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $e8d3e44a030e0375$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $e8d3e44a030e0375$var$el(null);
    c = a.current;
    d = $e8d3e44a030e0375$var$L();
    e = $e8d3e44a030e0375$var$lh(c);
    f = $e8d3e44a030e0375$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e8d3e44a030e0375$var$dh(c, f, e);
    a.current.lanes = e;
    $e8d3e44a030e0375$var$Ac(a, e, d);
    $e8d3e44a030e0375$var$Ek(a, d);
    return a;
}
function $e8d3e44a030e0375$var$gl(a, b, c, d) {
    var e = b.current, f = $e8d3e44a030e0375$var$L(), g = $e8d3e44a030e0375$var$lh(e);
    c = $e8d3e44a030e0375$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e8d3e44a030e0375$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e8d3e44a030e0375$var$dh(e, b, g);
    null !== a && ($e8d3e44a030e0375$var$mh(a, e, g, f), $e8d3e44a030e0375$var$eh(a, e, g));
    return g;
}
function $e8d3e44a030e0375$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e8d3e44a030e0375$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e8d3e44a030e0375$var$jl(a, b) {
    $e8d3e44a030e0375$var$il(a, b);
    (a = a.alternate) && $e8d3e44a030e0375$var$il(a, b);
}
function $e8d3e44a030e0375$var$kl() {
    return null;
}
var $e8d3e44a030e0375$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e8d3e44a030e0375$var$ml(a) {
    this._internalRoot = a;
}
$e8d3e44a030e0375$var$nl.prototype.render = $e8d3e44a030e0375$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e8d3e44a030e0375$var$p(409));
    $e8d3e44a030e0375$var$gl(a, b, null, null);
};
$e8d3e44a030e0375$var$nl.prototype.unmount = $e8d3e44a030e0375$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e8d3e44a030e0375$var$Sk(function() {
            $e8d3e44a030e0375$var$gl(null, a, null, null);
        });
        b[$e8d3e44a030e0375$var$uf] = null;
    }
};
function $e8d3e44a030e0375$var$nl(a) {
    this._internalRoot = a;
}
$e8d3e44a030e0375$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e8d3e44a030e0375$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e8d3e44a030e0375$var$Qc.length && 0 !== b && b < $e8d3e44a030e0375$var$Qc[c].priority; c++);
        $e8d3e44a030e0375$var$Qc.splice(c, 0, a);
        0 === c && $e8d3e44a030e0375$var$Vc(a);
    }
};
function $e8d3e44a030e0375$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e8d3e44a030e0375$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e8d3e44a030e0375$var$ql() {}
function $e8d3e44a030e0375$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e8d3e44a030e0375$var$hl(g);
                f.call(a);
            };
        }
        var g = $e8d3e44a030e0375$var$fl(b, d, a, 0, null, !1, !1, "", $e8d3e44a030e0375$var$ql);
        a._reactRootContainer = g;
        a[$e8d3e44a030e0375$var$uf] = g.current;
        $e8d3e44a030e0375$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e8d3e44a030e0375$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e8d3e44a030e0375$var$hl(k);
            h.call(a);
        };
    }
    var k = $e8d3e44a030e0375$var$cl(a, 0, !1, null, null, !1, !1, "", $e8d3e44a030e0375$var$ql);
    a._reactRootContainer = k;
    a[$e8d3e44a030e0375$var$uf] = k.current;
    $e8d3e44a030e0375$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e8d3e44a030e0375$var$Sk(function() {
        $e8d3e44a030e0375$var$gl(b, k, c, d);
    });
    return k;
}
function $e8d3e44a030e0375$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e8d3e44a030e0375$var$hl(g);
                h.call(a);
            };
        }
        $e8d3e44a030e0375$var$gl(b, g, a, e);
    } else g = $e8d3e44a030e0375$var$rl(c, b, a, e, d);
    return $e8d3e44a030e0375$var$hl(g);
}
$e8d3e44a030e0375$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e8d3e44a030e0375$var$tc(b.pendingLanes);
                0 !== c && ($e8d3e44a030e0375$var$Cc(b, c | 1), $e8d3e44a030e0375$var$Ek(b, $e8d3e44a030e0375$var$B()), 0 === ($e8d3e44a030e0375$var$K & 6) && ($e8d3e44a030e0375$var$Hj = $e8d3e44a030e0375$var$B() + 500, $e8d3e44a030e0375$var$jg()));
            }
            break;
        case 13:
            $e8d3e44a030e0375$var$Sk(function() {
                var b = $e8d3e44a030e0375$var$Zg(a, 1);
                if (null !== b) {
                    var c = $e8d3e44a030e0375$var$L();
                    $e8d3e44a030e0375$var$mh(b, a, 1, c);
                }
            }), $e8d3e44a030e0375$var$jl(a, 1);
    }
};
$e8d3e44a030e0375$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e8d3e44a030e0375$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $e8d3e44a030e0375$var$L();
            $e8d3e44a030e0375$var$mh(b, a, 134217728, c);
        }
        $e8d3e44a030e0375$var$jl(a, 134217728);
    }
};
$e8d3e44a030e0375$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e8d3e44a030e0375$var$lh(a), c = $e8d3e44a030e0375$var$Zg(a, b);
        if (null !== c) {
            var d = $e8d3e44a030e0375$var$L();
            $e8d3e44a030e0375$var$mh(c, a, b, d);
        }
        $e8d3e44a030e0375$var$jl(a, b);
    }
};
$e8d3e44a030e0375$var$Hc = function() {
    return $e8d3e44a030e0375$var$C;
};
$e8d3e44a030e0375$var$Ic = function(a, b) {
    var c = $e8d3e44a030e0375$var$C;
    try {
        return $e8d3e44a030e0375$var$C = a, b();
    } finally{
        $e8d3e44a030e0375$var$C = c;
    }
};
$e8d3e44a030e0375$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e8d3e44a030e0375$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e8d3e44a030e0375$var$Db(d);
                        if (!e) throw Error($e8d3e44a030e0375$var$p(90));
                        $e8d3e44a030e0375$var$Wa(d);
                        $e8d3e44a030e0375$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e8d3e44a030e0375$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e8d3e44a030e0375$var$fb(a, !!c.multiple, b, !1);
    }
};
$e8d3e44a030e0375$var$Gb = $e8d3e44a030e0375$var$Rk;
$e8d3e44a030e0375$var$Hb = $e8d3e44a030e0375$var$Sk;
var $e8d3e44a030e0375$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $e8d3e44a030e0375$var$Cb,
        $e8d3e44a030e0375$var$ue,
        $e8d3e44a030e0375$var$Db,
        $e8d3e44a030e0375$var$Eb,
        $e8d3e44a030e0375$var$Fb,
        $e8d3e44a030e0375$var$Rk
    ]
}, $e8d3e44a030e0375$var$ul = {
    findFiberByHostInstance: $e8d3e44a030e0375$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $e8d3e44a030e0375$var$vl = {
    bundleType: $e8d3e44a030e0375$var$ul.bundleType,
    version: $e8d3e44a030e0375$var$ul.version,
    rendererPackageName: $e8d3e44a030e0375$var$ul.rendererPackageName,
    rendererConfig: $e8d3e44a030e0375$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e8d3e44a030e0375$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e8d3e44a030e0375$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e8d3e44a030e0375$var$ul.findFiberByHostInstance || $e8d3e44a030e0375$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e8d3e44a030e0375$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e8d3e44a030e0375$var$wl.isDisabled && $e8d3e44a030e0375$var$wl.supportsFiber) try {
        $e8d3e44a030e0375$var$kc = $e8d3e44a030e0375$var$wl.inject($e8d3e44a030e0375$var$vl), $e8d3e44a030e0375$var$lc = $e8d3e44a030e0375$var$wl;
    } catch (a) {}
}
$e8d3e44a030e0375$export$ae55be85d98224ed = $e8d3e44a030e0375$var$tl;
$e8d3e44a030e0375$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e8d3e44a030e0375$var$ol(b)) throw Error($e8d3e44a030e0375$var$p(200));
    return $e8d3e44a030e0375$var$dl(a, b, null, c);
};
$e8d3e44a030e0375$export$882461b6382ed46c = function(a, b) {
    if (!$e8d3e44a030e0375$var$ol(a)) throw Error($e8d3e44a030e0375$var$p(299));
    var c = !1, d = "", e = $e8d3e44a030e0375$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e8d3e44a030e0375$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$e8d3e44a030e0375$var$uf] = b.current;
    $e8d3e44a030e0375$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e8d3e44a030e0375$var$ml(b);
};
$e8d3e44a030e0375$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e8d3e44a030e0375$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e8d3e44a030e0375$var$p(268, a));
    }
    a = $e8d3e44a030e0375$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e8d3e44a030e0375$export$cd75ccfd720a3cd4 = function(a) {
    return $e8d3e44a030e0375$var$Sk(a);
};
$e8d3e44a030e0375$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e8d3e44a030e0375$var$pl(b)) throw Error($e8d3e44a030e0375$var$p(200));
    return $e8d3e44a030e0375$var$sl(null, a, b, !0, c);
};
$e8d3e44a030e0375$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e8d3e44a030e0375$var$ol(a)) throw Error($e8d3e44a030e0375$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e8d3e44a030e0375$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e8d3e44a030e0375$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e8d3e44a030e0375$var$uf] = b.current;
    $e8d3e44a030e0375$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e8d3e44a030e0375$var$nl(b);
};
$e8d3e44a030e0375$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e8d3e44a030e0375$var$pl(b)) throw Error($e8d3e44a030e0375$var$p(200));
    return $e8d3e44a030e0375$var$sl(null, a, b, !1, c);
};
$e8d3e44a030e0375$export$502457920280e6be = function(a) {
    if (!$e8d3e44a030e0375$var$pl(a)) throw Error($e8d3e44a030e0375$var$p(40));
    return a._reactRootContainer ? ($e8d3e44a030e0375$var$Sk(function() {
        $e8d3e44a030e0375$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e8d3e44a030e0375$var$uf] = null;
        });
    }), !0) : !1;
};
$e8d3e44a030e0375$export$c78a37762a8d58e1 = $e8d3e44a030e0375$var$Rk;
$e8d3e44a030e0375$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e8d3e44a030e0375$var$pl(c)) throw Error($e8d3e44a030e0375$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e8d3e44a030e0375$var$p(38));
    return $e8d3e44a030e0375$var$sl(a, b, c, !1, d);
};
$e8d3e44a030e0375$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("hTW2z", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ezSh3"));

});
parcelRegister("ezSh3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $a9ce6f492fe9a394$export$c4744153514ff05d, (v) => $a9ce6f492fe9a394$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $a9ce6f492fe9a394$export$3e506c1ccc9cc1a7, (v) => $a9ce6f492fe9a394$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $a9ce6f492fe9a394$export$e26fe2ed2fa76875, (v) => $a9ce6f492fe9a394$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $a9ce6f492fe9a394$export$502329bbf4b505b1, (v) => $a9ce6f492fe9a394$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $a9ce6f492fe9a394$export$6e3807111c4874c4, (v) => $a9ce6f492fe9a394$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $a9ce6f492fe9a394$export$c27134553091fb3a, (v) => $a9ce6f492fe9a394$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $a9ce6f492fe9a394$export$33ee1acdc04fd2a2, (v) => $a9ce6f492fe9a394$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $a9ce6f492fe9a394$export$b00a404bbd5edef2, (v) => $a9ce6f492fe9a394$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $a9ce6f492fe9a394$export$8352ce38b91d0c62, (v) => $a9ce6f492fe9a394$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $a9ce6f492fe9a394$export$d66a1c1c77bd778b, (v) => $a9ce6f492fe9a394$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $a9ce6f492fe9a394$export$d3dfb8e4810cb555, (v) => $a9ce6f492fe9a394$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $a9ce6f492fe9a394$export$839f9183b0465a69, (v) => $a9ce6f492fe9a394$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $a9ce6f492fe9a394$export$72fdf0e06517287b, (v) => $a9ce6f492fe9a394$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $a9ce6f492fe9a394$export$4b844e58a3e414b4, (v) => $a9ce6f492fe9a394$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $a9ce6f492fe9a394$export$816d2913ae6b83b1, (v) => $a9ce6f492fe9a394$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $a9ce6f492fe9a394$export$61bcfe829111a1d0, (v) => $a9ce6f492fe9a394$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $a9ce6f492fe9a394$export$7ee8c9beb337bc3f, (v) => $a9ce6f492fe9a394$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $a9ce6f492fe9a394$export$b5836b71941fa3ed, (v) => $a9ce6f492fe9a394$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $a9ce6f492fe9a394$export$cf845f2c119da08a, (v) => $a9ce6f492fe9a394$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a9ce6f492fe9a394$export$c4744153514ff05d;
var $a9ce6f492fe9a394$export$3e506c1ccc9cc1a7;
var $a9ce6f492fe9a394$export$e26fe2ed2fa76875;
var $a9ce6f492fe9a394$export$502329bbf4b505b1;
var $a9ce6f492fe9a394$export$6e3807111c4874c4;
var $a9ce6f492fe9a394$export$c27134553091fb3a;
var $a9ce6f492fe9a394$export$33ee1acdc04fd2a2;
var $a9ce6f492fe9a394$export$b00a404bbd5edef2;
var $a9ce6f492fe9a394$export$8352ce38b91d0c62;
var $a9ce6f492fe9a394$export$d66a1c1c77bd778b;
var $a9ce6f492fe9a394$export$d3dfb8e4810cb555;
var $a9ce6f492fe9a394$export$839f9183b0465a69;
var $a9ce6f492fe9a394$export$72fdf0e06517287b;
var $a9ce6f492fe9a394$export$4b844e58a3e414b4;
var $a9ce6f492fe9a394$export$816d2913ae6b83b1;
var $a9ce6f492fe9a394$export$61bcfe829111a1d0;
var $a9ce6f492fe9a394$export$7ee8c9beb337bc3f;
var $a9ce6f492fe9a394$export$b5836b71941fa3ed;
var $a9ce6f492fe9a394$export$cf845f2c119da08a;
"use strict";
function $a9ce6f492fe9a394$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a9ce6f492fe9a394$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a9ce6f492fe9a394$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a9ce6f492fe9a394$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a9ce6f492fe9a394$var$g(C, c)) n < e && 0 > $a9ce6f492fe9a394$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a9ce6f492fe9a394$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a9ce6f492fe9a394$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a9ce6f492fe9a394$var$l = performance;
    $a9ce6f492fe9a394$export$c4744153514ff05d = function() {
        return $a9ce6f492fe9a394$var$l.now();
    };
} else {
    var $a9ce6f492fe9a394$var$p = Date, $a9ce6f492fe9a394$var$q = $a9ce6f492fe9a394$var$p.now();
    $a9ce6f492fe9a394$export$c4744153514ff05d = function() {
        return $a9ce6f492fe9a394$var$p.now() - $a9ce6f492fe9a394$var$q;
    };
}
var $a9ce6f492fe9a394$var$r = [], $a9ce6f492fe9a394$var$t = [], $a9ce6f492fe9a394$var$u = 1, $a9ce6f492fe9a394$var$v = null, $a9ce6f492fe9a394$var$y = 3, $a9ce6f492fe9a394$var$z = !1, $a9ce6f492fe9a394$var$A = !1, $a9ce6f492fe9a394$var$B = !1, $a9ce6f492fe9a394$var$D = "function" === typeof setTimeout ? setTimeout : null, $a9ce6f492fe9a394$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a9ce6f492fe9a394$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a9ce6f492fe9a394$var$G(a) {
    for(var b = $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$t); null !== b;){
        if (null === b.callback) $a9ce6f492fe9a394$var$k($a9ce6f492fe9a394$var$t);
        else if (b.startTime <= a) $a9ce6f492fe9a394$var$k($a9ce6f492fe9a394$var$t), b.sortIndex = b.expirationTime, $a9ce6f492fe9a394$var$f($a9ce6f492fe9a394$var$r, b);
        else break;
        b = $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$t);
    }
}
function $a9ce6f492fe9a394$var$H(a) {
    $a9ce6f492fe9a394$var$B = !1;
    $a9ce6f492fe9a394$var$G(a);
    if (!$a9ce6f492fe9a394$var$A) {
        if (null !== $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$r)) $a9ce6f492fe9a394$var$A = !0, $a9ce6f492fe9a394$var$I($a9ce6f492fe9a394$var$J);
        else {
            var b = $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$t);
            null !== b && $a9ce6f492fe9a394$var$K($a9ce6f492fe9a394$var$H, b.startTime - a);
        }
    }
}
function $a9ce6f492fe9a394$var$J(a, b) {
    $a9ce6f492fe9a394$var$A = !1;
    $a9ce6f492fe9a394$var$B && ($a9ce6f492fe9a394$var$B = !1, $a9ce6f492fe9a394$var$E($a9ce6f492fe9a394$var$L), $a9ce6f492fe9a394$var$L = -1);
    $a9ce6f492fe9a394$var$z = !0;
    var c = $a9ce6f492fe9a394$var$y;
    try {
        $a9ce6f492fe9a394$var$G(b);
        for($a9ce6f492fe9a394$var$v = $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$r); null !== $a9ce6f492fe9a394$var$v && (!($a9ce6f492fe9a394$var$v.expirationTime > b) || a && !$a9ce6f492fe9a394$var$M());){
            var d = $a9ce6f492fe9a394$var$v.callback;
            if ("function" === typeof d) {
                $a9ce6f492fe9a394$var$v.callback = null;
                $a9ce6f492fe9a394$var$y = $a9ce6f492fe9a394$var$v.priorityLevel;
                var e = d($a9ce6f492fe9a394$var$v.expirationTime <= b);
                b = $a9ce6f492fe9a394$export$c4744153514ff05d();
                "function" === typeof e ? $a9ce6f492fe9a394$var$v.callback = e : $a9ce6f492fe9a394$var$v === $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$r) && $a9ce6f492fe9a394$var$k($a9ce6f492fe9a394$var$r);
                $a9ce6f492fe9a394$var$G(b);
            } else $a9ce6f492fe9a394$var$k($a9ce6f492fe9a394$var$r);
            $a9ce6f492fe9a394$var$v = $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$r);
        }
        if (null !== $a9ce6f492fe9a394$var$v) var w = !0;
        else {
            var m = $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$t);
            null !== m && $a9ce6f492fe9a394$var$K($a9ce6f492fe9a394$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a9ce6f492fe9a394$var$v = null, $a9ce6f492fe9a394$var$y = c, $a9ce6f492fe9a394$var$z = !1;
    }
}
var $a9ce6f492fe9a394$var$N = !1, $a9ce6f492fe9a394$var$O = null, $a9ce6f492fe9a394$var$L = -1, $a9ce6f492fe9a394$var$P = 5, $a9ce6f492fe9a394$var$Q = -1;
function $a9ce6f492fe9a394$var$M() {
    return $a9ce6f492fe9a394$export$c4744153514ff05d() - $a9ce6f492fe9a394$var$Q < $a9ce6f492fe9a394$var$P ? !1 : !0;
}
function $a9ce6f492fe9a394$var$R() {
    if (null !== $a9ce6f492fe9a394$var$O) {
        var a = $a9ce6f492fe9a394$export$c4744153514ff05d();
        $a9ce6f492fe9a394$var$Q = a;
        var b = !0;
        try {
            b = $a9ce6f492fe9a394$var$O(!0, a);
        } finally{
            b ? $a9ce6f492fe9a394$var$S() : ($a9ce6f492fe9a394$var$N = !1, $a9ce6f492fe9a394$var$O = null);
        }
    } else $a9ce6f492fe9a394$var$N = !1;
}
var $a9ce6f492fe9a394$var$S;
if ("function" === typeof $a9ce6f492fe9a394$var$F) $a9ce6f492fe9a394$var$S = function() {
    $a9ce6f492fe9a394$var$F($a9ce6f492fe9a394$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a9ce6f492fe9a394$var$T = new MessageChannel, $a9ce6f492fe9a394$var$U = $a9ce6f492fe9a394$var$T.port2;
    $a9ce6f492fe9a394$var$T.port1.onmessage = $a9ce6f492fe9a394$var$R;
    $a9ce6f492fe9a394$var$S = function() {
        $a9ce6f492fe9a394$var$U.postMessage(null);
    };
} else $a9ce6f492fe9a394$var$S = function() {
    $a9ce6f492fe9a394$var$D($a9ce6f492fe9a394$var$R, 0);
};
function $a9ce6f492fe9a394$var$I(a) {
    $a9ce6f492fe9a394$var$O = a;
    $a9ce6f492fe9a394$var$N || ($a9ce6f492fe9a394$var$N = !0, $a9ce6f492fe9a394$var$S());
}
function $a9ce6f492fe9a394$var$K(a, b) {
    $a9ce6f492fe9a394$var$L = $a9ce6f492fe9a394$var$D(function() {
        a($a9ce6f492fe9a394$export$c4744153514ff05d());
    }, b);
}
$a9ce6f492fe9a394$export$3e506c1ccc9cc1a7 = 5;
$a9ce6f492fe9a394$export$e26fe2ed2fa76875 = 1;
$a9ce6f492fe9a394$export$502329bbf4b505b1 = 4;
$a9ce6f492fe9a394$export$6e3807111c4874c4 = 3;
$a9ce6f492fe9a394$export$c27134553091fb3a = null;
$a9ce6f492fe9a394$export$33ee1acdc04fd2a2 = 2;
$a9ce6f492fe9a394$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a9ce6f492fe9a394$export$8352ce38b91d0c62 = function() {
    $a9ce6f492fe9a394$var$A || $a9ce6f492fe9a394$var$z || ($a9ce6f492fe9a394$var$A = !0, $a9ce6f492fe9a394$var$I($a9ce6f492fe9a394$var$J));
};
$a9ce6f492fe9a394$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a9ce6f492fe9a394$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a9ce6f492fe9a394$export$d3dfb8e4810cb555 = function() {
    return $a9ce6f492fe9a394$var$y;
};
$a9ce6f492fe9a394$export$839f9183b0465a69 = function() {
    return $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$r);
};
$a9ce6f492fe9a394$export$72fdf0e06517287b = function(a) {
    switch($a9ce6f492fe9a394$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a9ce6f492fe9a394$var$y;
    }
    var c = $a9ce6f492fe9a394$var$y;
    $a9ce6f492fe9a394$var$y = b;
    try {
        return a();
    } finally{
        $a9ce6f492fe9a394$var$y = c;
    }
};
$a9ce6f492fe9a394$export$4b844e58a3e414b4 = function() {};
$a9ce6f492fe9a394$export$816d2913ae6b83b1 = function() {};
$a9ce6f492fe9a394$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a9ce6f492fe9a394$var$y;
    $a9ce6f492fe9a394$var$y = a;
    try {
        return b();
    } finally{
        $a9ce6f492fe9a394$var$y = c;
    }
};
$a9ce6f492fe9a394$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a9ce6f492fe9a394$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a9ce6f492fe9a394$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a9ce6f492fe9a394$var$f($a9ce6f492fe9a394$var$t, a), null === $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$r) && a === $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$t) && ($a9ce6f492fe9a394$var$B ? ($a9ce6f492fe9a394$var$E($a9ce6f492fe9a394$var$L), $a9ce6f492fe9a394$var$L = -1) : $a9ce6f492fe9a394$var$B = !0, $a9ce6f492fe9a394$var$K($a9ce6f492fe9a394$var$H, c - d))) : (a.sortIndex = e, $a9ce6f492fe9a394$var$f($a9ce6f492fe9a394$var$r, a), $a9ce6f492fe9a394$var$A || $a9ce6f492fe9a394$var$z || ($a9ce6f492fe9a394$var$A = !0, $a9ce6f492fe9a394$var$I($a9ce6f492fe9a394$var$J)));
    return a;
};
$a9ce6f492fe9a394$export$b5836b71941fa3ed = $a9ce6f492fe9a394$var$M;
$a9ce6f492fe9a394$export$cf845f2c119da08a = function(a) {
    var b = $a9ce6f492fe9a394$var$y;
    return function() {
        var c = $a9ce6f492fe9a394$var$y;
        $a9ce6f492fe9a394$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a9ce6f492fe9a394$var$y = c;
        }
    };
};

});



parcelRegister("ec9mM", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ewHf8.default;
    }
});

var $ewHf8 = parcelRequire("ewHf8");

});
parcelRegister("ewHf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9359902569910ae$export$2e2bcd8739ae039);

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");

var $fMTGm = parcelRequire("fMTGm");

var $6iAGf = parcelRequire("6iAGf");
"use client";
function $a9359902569910ae$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $6iAGf.jsx)((0, $fMTGm.default), (0, $cPOSH.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $fMTGm.default).muiName;
    return /*#__PURE__*/ $1EuC8.memo(/*#__PURE__*/ $1EuC8.forwardRef(Component));
}

});
parcelRegister("cPOSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9581b76a13bfc3f6$export$2e2bcd8739ae039);
function $9581b76a13bfc3f6$export$2e2bcd8739ae039() {
    return $9581b76a13bfc3f6$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9581b76a13bfc3f6$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("fMTGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7e6880e0c7dddba$export$2e2bcd8739ae039);

var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");

var $1EuC8 = parcelRequire("1EuC8");


var $gioqn = parcelRequire("gioqn");

var $3Upoa = parcelRequire("3Upoa");

var $6VOnu = parcelRequire("6VOnu");

var $2Nt3t = parcelRequire("2Nt3t");

var $PAjMj = parcelRequire("PAjMj");

var $6BcoE = parcelRequire("6BcoE");

var $6iAGf = parcelRequire("6iAGf");
"use client";
const $b7e6880e0c7dddba$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $b7e6880e0c7dddba$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $6VOnu.default)(color)}`,
            `fontSize${(0, $6VOnu.default)(fontSize)}`
        ]
    };
    return (0, $3Upoa.default)(slots, (0, $6BcoE.getSvgIconUtilityClass), classes);
};
const $b7e6880e0c7dddba$var$SvgIconRoot = (0, $PAjMj.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $6VOnu.default)(ownerState.color)}`],
            styles[`fontSize${(0, $6VOnu.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $b7e6880e0c7dddba$var$SvgIcon = /*#__PURE__*/ $1EuC8.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $2Nt3t.useDefaultProps)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $aT5bD.default)(props, $b7e6880e0c7dddba$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $1EuC8.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $cPOSH.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $b7e6880e0c7dddba$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $6iAGf.jsxs)($b7e6880e0c7dddba$var$SvgIconRoot, (0, $cPOSH.default)({
        as: component,
        className: (0, $gioqn.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $6iAGf.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$b7e6880e0c7dddba$var$SvgIcon.muiName = "SvgIcon";
var $b7e6880e0c7dddba$export$2e2bcd8739ae039 = $b7e6880e0c7dddba$var$SvgIcon;

});
parcelRegister("aT5bD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ed310640b5c7b99$export$2e2bcd8739ae039);
function $7ed310640b5c7b99$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("gioqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1e5114649ba314$export$2e2bcd8739ae039);
function $ea1e5114649ba314$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ea1e5114649ba314$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ea1e5114649ba314$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ea1e5114649ba314$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ea1e5114649ba314$export$2e2bcd8739ae039 = $ea1e5114649ba314$export$4f5d2d50c9deca37;

});

parcelRegister("3Upoa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d8a4bc4c1d345e1$export$2e2bcd8739ae039);
function $2d8a4bc4c1d345e1$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("6VOnu", function(module, exports) {

$parcel$export(module.exports, "default", () => $50bf24eeb3acac3b$export$2e2bcd8739ae039);

var $cwrhp = parcelRequire("cwrhp");
var $50bf24eeb3acac3b$export$2e2bcd8739ae039 = (0, $cwrhp.default);

});
parcelRegister("cwrhp", function(module, exports) {

$parcel$export(module.exports, "default", () => $91dda2620269c445$export$2e2bcd8739ae039);

var $49nsw = parcelRequire("49nsw");
function $91dda2620269c445$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $49nsw.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("49nsw", function(module, exports) {

$parcel$export(module.exports, "default", () => $305a3328c1347c23$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $305a3328c1347c23$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("2Nt3t", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $2096b219aebed703$export$2440da353cedad43);

var $cPOSH = parcelRequire("cPOSH");
parcelRequire("1EuC8");


var $363eg = parcelRequire("363eg");

var $6iAGf = parcelRequire("6iAGf");
"use client";
function $2096b219aebed703$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $6iAGf.jsx)((0, $363eg.default), (0, $cPOSH.default)({}, props));
}
var $2096b219aebed703$export$2e2bcd8739ae039 = $2096b219aebed703$var$DefaultPropsProvider;
function $2096b219aebed703$export$2440da353cedad43(params) {
    return (0, $363eg.useDefaultProps)(params);
}

});
parcelRegister("363eg", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $24146fda80cc2146$export$2440da353cedad43);
$parcel$export(module.exports, "default", () => $24146fda80cc2146$export$2e2bcd8739ae039);

var $1EuC8 = parcelRequire("1EuC8");


var $gGyf9 = parcelRequire("gGyf9");

var $6iAGf = parcelRequire("6iAGf");
"use client";
const $24146fda80cc2146$var$PropsContext = /*#__PURE__*/ $1EuC8.createContext(undefined);
function $24146fda80cc2146$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $6iAGf.jsx)($24146fda80cc2146$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $24146fda80cc2146$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $gGyf9.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $gGyf9.default)(config, props);
    return props;
}
function $24146fda80cc2146$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $1EuC8.useContext($24146fda80cc2146$var$PropsContext);
    return $24146fda80cc2146$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $24146fda80cc2146$export$2e2bcd8739ae039 = $24146fda80cc2146$var$DefaultPropsProvider;

});
parcelRegister("gGyf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c25b219f4230e138$export$2e2bcd8739ae039);

var $cPOSH = parcelRequire("cPOSH");
function $c25b219f4230e138$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $cPOSH.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $cPOSH.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $cPOSH.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $c25b219f4230e138$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});

parcelRegister("6iAGf", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fgQxl"));

});



parcelRegister("PAjMj", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b0ef88b0ba971f$export$2e2bcd8739ae039);

var $atuzP = parcelRequire("atuzP");

var $dMi6u = parcelRequire("dMi6u");

var $2l07H = parcelRequire("2l07H");

var $51gfd = parcelRequire("51gfd");

"use client";
const $09b0ef88b0ba971f$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($atuzP)))({
    themeId: (0, $2l07H.default),
    defaultTheme: $dMi6u.default,
    rootShouldForwardProp: $51gfd.default
});
var $09b0ef88b0ba971f$export$2e2bcd8739ae039 = $09b0ef88b0ba971f$var$styled;

});
parcelRegister("atuzP", function(module, exports) {
"use strict";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7a0454c107c2354f$var$createStyled;
module.exports.shouldForwardProp = $7a0454c107c2354f$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $7a0454c107c2354f$var$_extends2 = $4n9Eb((parcelRequire("clnOu")));

var $7a0454c107c2354f$var$_objectWithoutPropertiesLoose2 = $4n9Eb((parcelRequire("8PHKA")));

var $7a0454c107c2354f$var$_styledEngine = $7a0454c107c2354f$var$_interopRequireWildcard((parcelRequire("2xnzr")));

var $i5l0f = parcelRequire("i5l0f");

var $7a0454c107c2354f$var$_capitalize = $4n9Eb((parcelRequire("ksL8y")));

var $7a0454c107c2354f$var$_getDisplayName = $4n9Eb((parcelRequire("k1J5h")));

var $7a0454c107c2354f$var$_createTheme = $4n9Eb((parcelRequire("jhC20")));

var $7a0454c107c2354f$var$_styleFunctionSx = $4n9Eb((parcelRequire("alN9C")));
const $7a0454c107c2354f$var$_excluded = [
    "ownerState"
], $7a0454c107c2354f$var$_excluded2 = [
    "variants"
], $7a0454c107c2354f$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $7a0454c107c2354f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7a0454c107c2354f$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $7a0454c107c2354f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $7a0454c107c2354f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $7a0454c107c2354f$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $7a0454c107c2354f$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $7a0454c107c2354f$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $7a0454c107c2354f$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $7a0454c107c2354f$var$_createTheme.default)();
const $7a0454c107c2354f$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $7a0454c107c2354f$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $7a0454c107c2354f$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $7a0454c107c2354f$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $7a0454c107c2354f$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $7a0454c107c2354f$var$_objectWithoutPropertiesLoose2.default)(_ref, $7a0454c107c2354f$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $7a0454c107c2354f$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$7a0454c107c2354f$var$processStyleArg(resolvedStyle, (0, $7a0454c107c2354f$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $7a0454c107c2354f$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $7a0454c107c2354f$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $7a0454c107c2354f$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $7a0454c107c2354f$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $7a0454c107c2354f$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $7a0454c107c2354f$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $7a0454c107c2354f$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $7a0454c107c2354f$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $7a0454c107c2354f$var$_styleFunctionSx.default)((0, $7a0454c107c2354f$var$_extends2.default)({}, props, {
            theme: $7a0454c107c2354f$var$resolveTheme((0, $7a0454c107c2354f$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $7a0454c107c2354f$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $7a0454c107c2354f$var$defaultOverridesResolver($7a0454c107c2354f$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $7a0454c107c2354f$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $7a0454c107c2354f$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $7a0454c107c2354f$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($7a0454c107c2354f$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $7a0454c107c2354f$var$_styledEngine.default)(tag, (0, $7a0454c107c2354f$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $i5l0f.isPlainObject)(stylesArg)) return (props)=>$7a0454c107c2354f$var$processStyleArg(stylesArg, (0, $7a0454c107c2354f$var$_extends2.default)({}, props, {
                    theme: $7a0454c107c2354f$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $7a0454c107c2354f$var$resolveTheme((0, $7a0454c107c2354f$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $7a0454c107c2354f$var$processStyleArg(slotStyle, (0, $7a0454c107c2354f$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $7a0454c107c2354f$var$resolveTheme((0, $7a0454c107c2354f$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $7a0454c107c2354f$var$processStyleArg({
                    variants: themeVariants
                }, (0, $7a0454c107c2354f$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("8PHKA", function(module, exports) {
function $66e5060f09c39b32$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $66e5060f09c39b32$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2xnzr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1d90f27863e23e26$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $1d90f27863e23e26$export$e00380445f2b9e0c);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("69fRv")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("cOeZu")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("cOeZu")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("j2qx3")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("kzzTv")).default);
/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $adN6K = parcelRequire("adN6K");

var $cOeZu = parcelRequire("cOeZu");
var $69fRv = parcelRequire("69fRv");

var $j2qx3 = parcelRequire("j2qx3");

var $kzzTv = parcelRequire("kzzTv");
"use client";
function $1d90f27863e23e26$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $adN6K.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $1d90f27863e23e26$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("adN6K", function(module, exports) {

$parcel$export(module.exports, "default", () => $7711360d995601c1$export$2e2bcd8739ae039);

var $q95vf = parcelRequire("q95vf");
parcelRequire("clnOu");
parcelRequire("1EuC8");
parcelRequire("5zhxs");

parcelRequire("kcFkT");
parcelRequire("aXANZ");
parcelRequire("aOJix");
var $7711360d995601c1$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $7711360d995601c1$export$2e2bcd8739ae039 = (0, $q95vf.default).bind();
$7711360d995601c1$var$tags.forEach(function(tagName) {
    $7711360d995601c1$export$2e2bcd8739ae039[tagName] = $7711360d995601c1$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("q95vf", function(module, exports) {

$parcel$export(module.exports, "default", () => $04e97a763b2ee13e$export$2e2bcd8739ae039);

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");

var $5zhxs = parcelRequire("5zhxs");
parcelRequire("cOeZu");
var $69fRv = parcelRequire("69fRv");

var $kcFkT = parcelRequire("kcFkT");

var $aXANZ = parcelRequire("aXANZ");

var $aOJix = parcelRequire("aOJix");
/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */ /*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/ var $04e97a763b2ee13e$var$testOmitPropsOnStringTag = (0, $5zhxs.default);
var $04e97a763b2ee13e$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $04e97a763b2ee13e$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $04e97a763b2ee13e$var$testOmitPropsOnStringTag : $04e97a763b2ee13e$var$testOmitPropsOnComponent;
};
var $04e97a763b2ee13e$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/ var $04e97a763b2ee13e$var$isDevelopment = false;
var $04e97a763b2ee13e$var$isBrowser = typeof document !== "undefined";
var $04e97a763b2ee13e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $kcFkT.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $aOJix.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $kcFkT.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$04e97a763b2ee13e$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $1EuC8.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $04e97a763b2ee13e$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $04e97a763b2ee13e$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $04e97a763b2ee13e$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    /* return function<Props>(): PrivateStyledComponent<Props> { */ return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        }
        var Styled = (0, $69fRv.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $1EuC8.useContext((0, $69fRv.T));
            }
            if (typeof props.className === "string") className = (0, $kcFkT.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $aXANZ.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $04e97a763b2ee13e$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $1EuC8.createElement($1EuC8.Fragment, null, /*#__PURE__*/ $1EuC8.createElement($04e97a763b2ee13e$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $1EuC8.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                if (targetClassName === undefined && $04e97a763b2ee13e$var$isDevelopment) return "NO_COMPONENT_SELECTOR";
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $cPOSH.default)({}, options, nextOptions, {
                shouldForwardProp: $04e97a763b2ee13e$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("5zhxs", function(module, exports) {

$parcel$export(module.exports, "default", () => $40ddd376d89a8988$export$2e2bcd8739ae039);

var $3ItXd = parcelRequire("3ItXd");
// eslint-disable-next-line no-undef
var $40ddd376d89a8988$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $40ddd376d89a8988$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $3ItXd.default)(function(prop) {
    return $40ddd376d89a8988$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("3ItXd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b4cb76cbeedcb5f$export$2e2bcd8739ae039);
function $2b4cb76cbeedcb5f$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("cOeZu", function(module, exports) {

$parcel$export(module.exports, "Global", () => $9535c8626836d306$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $9535c8626836d306$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $9535c8626836d306$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("69fRv")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("69fRv")).w);

var $69fRv = parcelRequire("69fRv");

var $1EuC8 = parcelRequire("1EuC8");

var $kcFkT = parcelRequire("kcFkT");

var $aOJix = parcelRequire("aOJix");

var $aXANZ = parcelRequire("aXANZ");
parcelRequire("4tJ1W");
parcelRequire("clnOu");
parcelRequire("788CG");

parcelRequire("gKCu6");
var $9535c8626836d306$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $69fRv.h).call(props, "css")) return $1EuC8.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $69fRv.E);
    createElementArgArray[1] = (0, $69fRv.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $1EuC8.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $9535c8626836d306$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $69fRv.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $aXANZ.serializeStyles)([
        styles
    ], undefined, $1EuC8.useContext((0, $69fRv.T)));
    if (!(0, $69fRv.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $1EuC8.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $1EuC8.useRef();
    (0, $aOJix.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $aOJix.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $kcFkT.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $9535c8626836d306$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $aXANZ.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $9535c8626836d306$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $9535c8626836d306$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $9535c8626836d306$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $9535c8626836d306$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $kcFkT.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $9535c8626836d306$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $aOJix.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $kcFkT.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $69fRv.i) && res !== undefined) rules += res;
        }
        if (!(0, $69fRv.i)) return rules;
    });
    if (!(0, $69fRv.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $1EuC8.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $9535c8626836d306$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $69fRv.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $69fRv.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $aXANZ.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $kcFkT.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $69fRv.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $9535c8626836d306$var$merge(cache.registered, css, $9535c8626836d306$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $1EuC8.useContext((0, $69fRv.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $1EuC8.createElement($1EuC8.Fragment, null, /*#__PURE__*/ $1EuC8.createElement($9535c8626836d306$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("69fRv", function(module, exports) {

$parcel$export(module.exports, "a", () => $479fe338721fb4d0$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $479fe338721fb4d0$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $479fe338721fb4d0$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $479fe338721fb4d0$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $479fe338721fb4d0$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $479fe338721fb4d0$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $479fe338721fb4d0$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $479fe338721fb4d0$export$a9c23c6ac3fc3eca);

var $1EuC8 = parcelRequire("1EuC8");

var $4tJ1W = parcelRequire("4tJ1W");

var $cPOSH = parcelRequire("cPOSH");

var $788CG = parcelRequire("788CG");

var $j83fk = parcelRequire("j83fk");

var $kcFkT = parcelRequire("kcFkT");

var $aXANZ = parcelRequire("aXANZ");

var $aOJix = parcelRequire("aOJix");
var $479fe338721fb4d0$export$407448d2b89b1813 = false;
var $479fe338721fb4d0$export$23f2a1d2818174ef = typeof document !== "undefined";
/* import { type EmotionCache } from '@emotion/utils' */ var $479fe338721fb4d0$var$EmotionCacheContext = /* #__PURE__ */ $1EuC8.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $4tJ1W.default)({
    key: "css"
}) : null);
var $479fe338721fb4d0$export$e7094788287c5e9b = $479fe338721fb4d0$var$EmotionCacheContext.Provider;
var $479fe338721fb4d0$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $1EuC8.useContext)($479fe338721fb4d0$var$EmotionCacheContext);
};
var $479fe338721fb4d0$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $1EuC8.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $1EuC8.useContext)($479fe338721fb4d0$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$479fe338721fb4d0$export$23f2a1d2818174ef) $479fe338721fb4d0$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, $1EuC8.useContext)($479fe338721fb4d0$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $4tJ1W.default)({
                key: "css"
            });
            return /*#__PURE__*/ $1EuC8.createElement($479fe338721fb4d0$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $479fe338721fb4d0$export$971d5caa766a69d7 = /* #__PURE__ */ $1EuC8.createContext({});
var $479fe338721fb4d0$export$3b14a55fb2447963 = function useTheme() {
    return $1EuC8.useContext($479fe338721fb4d0$export$971d5caa766a69d7);
};
var $479fe338721fb4d0$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $cPOSH.default)({}, outerTheme, theme);
};
var $479fe338721fb4d0$var$createCacheWithTheme = /* #__PURE__ */ (0, $788CG.default)(function(outerTheme) {
    return (0, $788CG.default)(function(theme) {
        return $479fe338721fb4d0$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $479fe338721fb4d0$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $1EuC8.useContext($479fe338721fb4d0$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $479fe338721fb4d0$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $1EuC8.createElement($479fe338721fb4d0$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $479fe338721fb4d0$export$4368d992c4eafac0(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $1EuC8.useContext($479fe338721fb4d0$export$971d5caa766a69d7);
        return /*#__PURE__*/ $1EuC8.createElement(Component, (0, $cPOSH.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $1EuC8.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $j83fk.default)(WithTheme, Component);
}
var $479fe338721fb4d0$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $479fe338721fb4d0$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $479fe338721fb4d0$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($479fe338721fb4d0$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$479fe338721fb4d0$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $479fe338721fb4d0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $kcFkT.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $aOJix.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $kcFkT.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$479fe338721fb4d0$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $1EuC8.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $479fe338721fb4d0$var$Emotion = /* #__PURE__ */ $479fe338721fb4d0$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$479fe338721fb4d0$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $kcFkT.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $aXANZ.serializeStyles)(registeredStyles, undefined, $1EuC8.useContext($479fe338721fb4d0$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($479fe338721fb4d0$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $479fe338721fb4d0$var$typePropName && !$479fe338721fb4d0$export$407448d2b89b1813) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $1EuC8.createElement($1EuC8.Fragment, null, /*#__PURE__*/ $1EuC8.createElement($479fe338721fb4d0$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $1EuC8.createElement(WrappedComponent, newProps));
});
var $479fe338721fb4d0$export$a9c23c6ac3fc3eca = $479fe338721fb4d0$var$Emotion;

});
parcelRegister("4tJ1W", function(module, exports) {

$parcel$export(module.exports, "default", () => $342cccf5c05e3250$export$2e2bcd8739ae039);

var $bLhVk = parcelRequire("bLhVk");

var $atvqU = parcelRequire("atvqU");

var $788CG = parcelRequire("788CG");

var $3ItXd = parcelRequire("3ItXd");
var $342cccf5c05e3250$var$isBrowser = typeof document !== "undefined";
var $342cccf5c05e3250$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $atvqU.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $atvqU.token)(character)) break;
        (0, $atvqU.next)();
    }
    return (0, $atvqU.slice)(begin, (0, $atvqU.position));
};
var $342cccf5c05e3250$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $atvqU.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $atvqU.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $342cccf5c05e3250$var$identifierWithPointTracking((0, $atvqU.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $atvqU.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $atvqU.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $atvqU.from)(character);
    }
    while (character = (0, $atvqU.next)());
    return parsed;
};
var $342cccf5c05e3250$var$getRules = function getRules(value, points) {
    return (0, $atvqU.dealloc)($342cccf5c05e3250$var$toRules((0, $atvqU.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $342cccf5c05e3250$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $342cccf5c05e3250$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$342cccf5c05e3250$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $342cccf5c05e3250$var$fixedElements.set(element, true);
    var points = [];
    var rules = $342cccf5c05e3250$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $342cccf5c05e3250$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $342cccf5c05e3250$var$prefix(value, length) {
    switch((0, $atvqU.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $atvqU.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $atvqU.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $atvqU.WEBKIT) + value + (0, $atvqU.MOZ) + value + (0, $atvqU.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $atvqU.WEBKIT) + value + (0, $atvqU.MS) + value + value;
        // order
        case 6165:
            return (0, $atvqU.WEBKIT) + value + (0, $atvqU.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $atvqU.WEBKIT) + value + (0, $atvqU.replace)(value, /(\w+).+(:[^]+)/, (0, $atvqU.WEBKIT) + "box-$1$2" + (0, $atvqU.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $atvqU.WEBKIT) + value + (0, $atvqU.MS) + "flex-item-" + (0, $atvqU.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $atvqU.WEBKIT) + value + (0, $atvqU.MS) + "flex-line-pack" + (0, $atvqU.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $atvqU.WEBKIT) + value + (0, $atvqU.MS) + (0, $atvqU.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $atvqU.WEBKIT) + value + (0, $atvqU.MS) + (0, $atvqU.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $atvqU.WEBKIT) + "box-" + (0, $atvqU.replace)(value, "-grow", "") + (0, $atvqU.WEBKIT) + value + (0, $atvqU.MS) + (0, $atvqU.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $atvqU.WEBKIT) + (0, $atvqU.replace)(value, /([^-])(transform)/g, "$1" + (0, $atvqU.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $atvqU.replace)((0, $atvqU.replace)((0, $atvqU.replace)(value, /(zoom-|grab)/, (0, $atvqU.WEBKIT) + "$1"), /(image-set)/, (0, $atvqU.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $atvqU.replace)(value, /(image-set\([^]*)/, (0, $atvqU.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $atvqU.replace)((0, $atvqU.replace)(value, /(.+:)(flex-)?(.*)/, (0, $atvqU.WEBKIT) + "box-pack:$3" + (0, $atvqU.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $atvqU.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $atvqU.replace)(value, /(.+)-inline(.+)/, (0, $atvqU.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $atvqU.strlen)(value) - 1 - length > 6) switch((0, $atvqU.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $atvqU.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $atvqU.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $atvqU.WEBKIT) + "$2-$3" + "$1" + (0, $atvqU.MOZ) + ((0, $atvqU.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $atvqU.indexof)(value, "stretch") ? $342cccf5c05e3250$var$prefix((0, $atvqU.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $atvqU.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $atvqU.charat)(value, (0, $atvqU.strlen)(value) - 3 - (~(0, $atvqU.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $atvqU.replace)(value, ":", ":" + (0, $atvqU.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $atvqU.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $atvqU.WEBKIT) + ((0, $atvqU.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $atvqU.WEBKIT) + "$2$3" + "$1" + (0, $atvqU.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $atvqU.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $atvqU.WEBKIT) + value + (0, $atvqU.MS) + (0, $atvqU.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $atvqU.WEBKIT) + value + (0, $atvqU.MS) + (0, $atvqU.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $atvqU.WEBKIT) + value + (0, $atvqU.MS) + (0, $atvqU.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $atvqU.WEBKIT) + value + (0, $atvqU.MS) + value + value;
    }
    return value;
}
var $342cccf5c05e3250$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $atvqU.DECLARATION:
                element["return"] = $342cccf5c05e3250$var$prefix(element.value, element.length);
                break;
            case 0, $atvqU.KEYFRAMES:
                return (0, $atvqU.serialize)([
                    (0, $atvqU.copy)(element, {
                        value: (0, $atvqU.replace)(element.value, "@", "@" + (0, $atvqU.WEBKIT))
                    })
                ], callback);
            case 0, $atvqU.RULESET:
                if (element.length) return (0, $atvqU.combine)(element.props, function(value) {
                    switch((0, $atvqU.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $atvqU.serialize)([
                                (0, $atvqU.copy)(element, {
                                    props: [
                                        (0, $atvqU.replace)(value, /:(read-\w+)/, ":" + (0, $atvqU.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $atvqU.serialize)([
                                (0, $atvqU.copy)(element, {
                                    props: [
                                        (0, $atvqU.replace)(value, /:(plac\w+)/, ":" + (0, $atvqU.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $atvqU.copy)(element, {
                                    props: [
                                        (0, $atvqU.replace)(value, /:(plac\w+)/, ":" + (0, $atvqU.MOZ) + "$1")
                                    ]
                                }),
                                (0, $atvqU.copy)(element, {
                                    props: [
                                        (0, $atvqU.replace)(value, /:(plac\w+)/, (0, $atvqU.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
/* import type { StylisPlugin } from './types' */ /*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/ var $342cccf5c05e3250$var$getServerStylisCache = $342cccf5c05e3250$var$isBrowser ? undefined : (0, $788CG.default)(function() {
    return (0, $3ItXd.default)(function() {
        var cache = {};
        return function(name) {
            return cache[name];
        };
    });
});
var $342cccf5c05e3250$var$defaultStylisPlugins = [
    $342cccf5c05e3250$var$prefixer
];
var $342cccf5c05e3250$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if ($342cccf5c05e3250$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $342cccf5c05e3250$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    if ($342cccf5c05e3250$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $342cccf5c05e3250$var$compat,
        $342cccf5c05e3250$var$removeLabel
    ];
    if ($342cccf5c05e3250$var$isBrowser) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $atvqU.stringify),
            (0, $atvqU.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $atvqU.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $atvqU.serialize)((0, $atvqU.compile)(styles), serializer);
        };
        _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $atvqU.stringify)
        ];
        var _serializer = (0, $atvqU.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $atvqU.serialize)((0, $atvqU.compile)(styles), _serializer);
        };
        var serverStylisCache = $342cccf5c05e3250$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function /*: string */ getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function /*: string | void */ _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $bLhVk.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("bLhVk", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $8901fcc38b1a3368$export$9d753cd7ae895cce);
var $8901fcc38b1a3368$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $8901fcc38b1a3368$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $8901fcc38b1a3368$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $8901fcc38b1a3368$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$8901fcc38b1a3368$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($8901fcc38b1a3368$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $8901fcc38b1a3368$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("atvqU", function(module, exports) {

$parcel$export(module.exports, "MS", () => $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $fbf5f8a8b86b1afc$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $fbf5f8a8b86b1afc$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $fbf5f8a8b86b1afc$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $fbf5f8a8b86b1afc$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $fbf5f8a8b86b1afc$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $fbf5f8a8b86b1afc$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $fbf5f8a8b86b1afc$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $fbf5f8a8b86b1afc$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $fbf5f8a8b86b1afc$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $fbf5f8a8b86b1afc$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $fbf5f8a8b86b1afc$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $fbf5f8a8b86b1afc$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $fbf5f8a8b86b1afc$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $fbf5f8a8b86b1afc$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $fbf5f8a8b86b1afc$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $fbf5f8a8b86b1afc$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $fbf5f8a8b86b1afc$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $fbf5f8a8b86b1afc$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $fbf5f8a8b86b1afc$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $fbf5f8a8b86b1afc$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $fbf5f8a8b86b1afc$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $fbf5f8a8b86b1afc$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $fbf5f8a8b86b1afc$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $fbf5f8a8b86b1afc$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $fbf5f8a8b86b1afc$export$38bcb760f1d4871c);
var $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 = "-ms-";
var $fbf5f8a8b86b1afc$export$2c0f367103c8d01c = "-moz-";
var $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 = "-webkit-";
var $fbf5f8a8b86b1afc$export$a29989082612d0d9 = "comm";
var $fbf5f8a8b86b1afc$export$aa3a2e812ca8570d = "rule";
var $fbf5f8a8b86b1afc$export$527d108ccf083c2b = "decl";
var $fbf5f8a8b86b1afc$export$d3d35020fa5b54f0 = "@page";
var $fbf5f8a8b86b1afc$export$500415a86c544f73 = "@media";
var $fbf5f8a8b86b1afc$export$a763edbf796b780a = "@import";
var $fbf5f8a8b86b1afc$export$2790aeb8b4e5c826 = "@charset";
var $fbf5f8a8b86b1afc$export$1cc683e23b84b133 = "@viewport";
var $fbf5f8a8b86b1afc$export$9447a5efea57e862 = "@supports";
var $fbf5f8a8b86b1afc$export$ef011b4e114b1fba = "@document";
var $fbf5f8a8b86b1afc$export$6aad947bda0f3f46 = "@namespace";
var $fbf5f8a8b86b1afc$export$b44a8529a35fcb60 = "@keyframes";
var $fbf5f8a8b86b1afc$export$2c16de31893252e6 = "@font-face";
var $fbf5f8a8b86b1afc$export$3d846dd52e150c6f = "@counter-style";
var $fbf5f8a8b86b1afc$export$22314bfbb57653fe = "@font-feature-values";
var $fbf5f8a8b86b1afc$export$d773506282b3cfe6 = "@layer";
var $fbf5f8a8b86b1afc$export$2335f513bbd82c6d = Math.abs;
var $fbf5f8a8b86b1afc$export$6788812c4e6611e6 = String.fromCharCode;
var $fbf5f8a8b86b1afc$export$e6e34fd1f2686227 = Object.assign;
function $fbf5f8a8b86b1afc$export$d6af199866bfb566(e, r) {
    return $fbf5f8a8b86b1afc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $fbf5f8a8b86b1afc$export$a9db5e087081082d(e, 0)) << 2 ^ $fbf5f8a8b86b1afc$export$a9db5e087081082d(e, 1)) << 2 ^ $fbf5f8a8b86b1afc$export$a9db5e087081082d(e, 2)) << 2 ^ $fbf5f8a8b86b1afc$export$a9db5e087081082d(e, 3) : 0;
}
function $fbf5f8a8b86b1afc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $fbf5f8a8b86b1afc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $fbf5f8a8b86b1afc$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $fbf5f8a8b86b1afc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $fbf5f8a8b86b1afc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $fbf5f8a8b86b1afc$export$36776f635604f274(e) {
    return e.length;
}
function $fbf5f8a8b86b1afc$export$f9084667e487ed46(e) {
    return e.length;
}
function $fbf5f8a8b86b1afc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $fbf5f8a8b86b1afc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $fbf5f8a8b86b1afc$export$53f1d5ea8de3d7c = 1;
var $fbf5f8a8b86b1afc$export$4e0c71f277ca26b3 = 1;
var $fbf5f8a8b86b1afc$export$f24224f1c91d8156 = 0;
var $fbf5f8a8b86b1afc$export$5880b8b5730aff45 = 0;
var $fbf5f8a8b86b1afc$export$c0306caf338ac095 = 0;
var $fbf5f8a8b86b1afc$export$30a86d91af8ff6e6 = "";
function $fbf5f8a8b86b1afc$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $fbf5f8a8b86b1afc$export$53f1d5ea8de3d7c,
        column: $fbf5f8a8b86b1afc$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $fbf5f8a8b86b1afc$export$784d13d8ee351f07(e, r) {
    return $fbf5f8a8b86b1afc$export$e6e34fd1f2686227($fbf5f8a8b86b1afc$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $fbf5f8a8b86b1afc$export$eba6f6f03b0a92e7() {
    return $fbf5f8a8b86b1afc$export$c0306caf338ac095;
}
function $fbf5f8a8b86b1afc$export$232faf9add678146() {
    $fbf5f8a8b86b1afc$export$c0306caf338ac095 = $fbf5f8a8b86b1afc$export$5880b8b5730aff45 > 0 ? $fbf5f8a8b86b1afc$export$a9db5e087081082d($fbf5f8a8b86b1afc$export$30a86d91af8ff6e6, --$fbf5f8a8b86b1afc$export$5880b8b5730aff45) : 0;
    if ($fbf5f8a8b86b1afc$export$4e0c71f277ca26b3--, $fbf5f8a8b86b1afc$export$c0306caf338ac095 === 10) $fbf5f8a8b86b1afc$export$4e0c71f277ca26b3 = 1, $fbf5f8a8b86b1afc$export$53f1d5ea8de3d7c--;
    return $fbf5f8a8b86b1afc$export$c0306caf338ac095;
}
function $fbf5f8a8b86b1afc$export$48cfd1e771a65c4f() {
    $fbf5f8a8b86b1afc$export$c0306caf338ac095 = $fbf5f8a8b86b1afc$export$5880b8b5730aff45 < $fbf5f8a8b86b1afc$export$f24224f1c91d8156 ? $fbf5f8a8b86b1afc$export$a9db5e087081082d($fbf5f8a8b86b1afc$export$30a86d91af8ff6e6, $fbf5f8a8b86b1afc$export$5880b8b5730aff45++) : 0;
    if ($fbf5f8a8b86b1afc$export$4e0c71f277ca26b3++, $fbf5f8a8b86b1afc$export$c0306caf338ac095 === 10) $fbf5f8a8b86b1afc$export$4e0c71f277ca26b3 = 1, $fbf5f8a8b86b1afc$export$53f1d5ea8de3d7c++;
    return $fbf5f8a8b86b1afc$export$c0306caf338ac095;
}
function $fbf5f8a8b86b1afc$export$4d3fb11e950abb9e() {
    return $fbf5f8a8b86b1afc$export$a9db5e087081082d($fbf5f8a8b86b1afc$export$30a86d91af8ff6e6, $fbf5f8a8b86b1afc$export$5880b8b5730aff45);
}
function $fbf5f8a8b86b1afc$export$e88cb2efb12ae807() {
    return $fbf5f8a8b86b1afc$export$5880b8b5730aff45;
}
function $fbf5f8a8b86b1afc$export$58adb3bec8346d0f(e, r) {
    return $fbf5f8a8b86b1afc$export$2f35ab04d2335697($fbf5f8a8b86b1afc$export$30a86d91af8ff6e6, e, r);
}
function $fbf5f8a8b86b1afc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $fbf5f8a8b86b1afc$export$2de70f21292aac9e(e) {
    return $fbf5f8a8b86b1afc$export$53f1d5ea8de3d7c = $fbf5f8a8b86b1afc$export$4e0c71f277ca26b3 = 1, $fbf5f8a8b86b1afc$export$f24224f1c91d8156 = $fbf5f8a8b86b1afc$export$36776f635604f274($fbf5f8a8b86b1afc$export$30a86d91af8ff6e6 = e), $fbf5f8a8b86b1afc$export$5880b8b5730aff45 = 0, [];
}
function $fbf5f8a8b86b1afc$export$45918ac1574455b1(e) {
    return $fbf5f8a8b86b1afc$export$30a86d91af8ff6e6 = "", e;
}
function $fbf5f8a8b86b1afc$export$410ac95b9ec204b8(e) {
    return $fbf5f8a8b86b1afc$export$87c2784dc9fc4ab($fbf5f8a8b86b1afc$export$58adb3bec8346d0f($fbf5f8a8b86b1afc$export$5880b8b5730aff45 - 1, $fbf5f8a8b86b1afc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $fbf5f8a8b86b1afc$export$660b2ee2d4fb4eff(e) {
    return $fbf5f8a8b86b1afc$export$45918ac1574455b1($fbf5f8a8b86b1afc$export$5f8c09e3ae6f64e1($fbf5f8a8b86b1afc$export$2de70f21292aac9e(e)));
}
function $fbf5f8a8b86b1afc$export$7af1228ff777d175(e) {
    while($fbf5f8a8b86b1afc$export$c0306caf338ac095 = $fbf5f8a8b86b1afc$export$4d3fb11e950abb9e())if ($fbf5f8a8b86b1afc$export$c0306caf338ac095 < 33) $fbf5f8a8b86b1afc$export$48cfd1e771a65c4f();
    else break;
    return $fbf5f8a8b86b1afc$export$9e1725a4cfeada27(e) > 2 || $fbf5f8a8b86b1afc$export$9e1725a4cfeada27($fbf5f8a8b86b1afc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $fbf5f8a8b86b1afc$export$5f8c09e3ae6f64e1(e) {
    while($fbf5f8a8b86b1afc$export$48cfd1e771a65c4f())switch($fbf5f8a8b86b1afc$export$9e1725a4cfeada27($fbf5f8a8b86b1afc$export$c0306caf338ac095)){
        case 0:
            $fbf5f8a8b86b1afc$export$10d8903dec122b9d($fbf5f8a8b86b1afc$export$c2ab62c7bf24634($fbf5f8a8b86b1afc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $fbf5f8a8b86b1afc$export$10d8903dec122b9d($fbf5f8a8b86b1afc$export$410ac95b9ec204b8($fbf5f8a8b86b1afc$export$c0306caf338ac095), e);
            break;
        default:
            $fbf5f8a8b86b1afc$export$10d8903dec122b9d($fbf5f8a8b86b1afc$export$6788812c4e6611e6($fbf5f8a8b86b1afc$export$c0306caf338ac095), e);
    }
    return e;
}
function $fbf5f8a8b86b1afc$export$955ba06d119e085e(e, r) {
    while(--r && $fbf5f8a8b86b1afc$export$48cfd1e771a65c4f())if ($fbf5f8a8b86b1afc$export$c0306caf338ac095 < 48 || $fbf5f8a8b86b1afc$export$c0306caf338ac095 > 102 || $fbf5f8a8b86b1afc$export$c0306caf338ac095 > 57 && $fbf5f8a8b86b1afc$export$c0306caf338ac095 < 65 || $fbf5f8a8b86b1afc$export$c0306caf338ac095 > 70 && $fbf5f8a8b86b1afc$export$c0306caf338ac095 < 97) break;
    return $fbf5f8a8b86b1afc$export$58adb3bec8346d0f(e, $fbf5f8a8b86b1afc$export$e88cb2efb12ae807() + (r < 6 && $fbf5f8a8b86b1afc$export$4d3fb11e950abb9e() == 32 && $fbf5f8a8b86b1afc$export$48cfd1e771a65c4f() == 32));
}
function $fbf5f8a8b86b1afc$export$c889f2fcc19dbf12(e) {
    while($fbf5f8a8b86b1afc$export$48cfd1e771a65c4f())switch($fbf5f8a8b86b1afc$export$c0306caf338ac095){
        case e:
            return $fbf5f8a8b86b1afc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $fbf5f8a8b86b1afc$export$c889f2fcc19dbf12($fbf5f8a8b86b1afc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $fbf5f8a8b86b1afc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $fbf5f8a8b86b1afc$export$48cfd1e771a65c4f();
            break;
    }
    return $fbf5f8a8b86b1afc$export$5880b8b5730aff45;
}
function $fbf5f8a8b86b1afc$export$4254d4e2b3745c4c(e, r) {
    while($fbf5f8a8b86b1afc$export$48cfd1e771a65c4f())if (e + $fbf5f8a8b86b1afc$export$c0306caf338ac095 === 57) break;
    else if (e + $fbf5f8a8b86b1afc$export$c0306caf338ac095 === 84 && $fbf5f8a8b86b1afc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $fbf5f8a8b86b1afc$export$58adb3bec8346d0f(r, $fbf5f8a8b86b1afc$export$5880b8b5730aff45 - 1) + "*" + $fbf5f8a8b86b1afc$export$6788812c4e6611e6(e === 47 ? e : $fbf5f8a8b86b1afc$export$48cfd1e771a65c4f());
}
function $fbf5f8a8b86b1afc$export$c2ab62c7bf24634(e) {
    while(!$fbf5f8a8b86b1afc$export$9e1725a4cfeada27($fbf5f8a8b86b1afc$export$4d3fb11e950abb9e()))$fbf5f8a8b86b1afc$export$48cfd1e771a65c4f();
    return $fbf5f8a8b86b1afc$export$58adb3bec8346d0f(e, $fbf5f8a8b86b1afc$export$5880b8b5730aff45);
}
function $fbf5f8a8b86b1afc$export$ef7acd7185315e22(e) {
    return $fbf5f8a8b86b1afc$export$45918ac1574455b1($fbf5f8a8b86b1afc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $fbf5f8a8b86b1afc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $fbf5f8a8b86b1afc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $fbf5f8a8b86b1afc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $fbf5f8a8b86b1afc$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($fbf5f8a8b86b1afc$export$f8e21b1e77979a08(j += $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed($fbf5f8a8b86b1afc$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $fbf5f8a8b86b1afc$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $fbf5f8a8b86b1afc$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $fbf5f8a8b86b1afc$export$955ba06d119e085e($fbf5f8a8b86b1afc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($fbf5f8a8b86b1afc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $fbf5f8a8b86b1afc$export$10d8903dec122b9d($fbf5f8a8b86b1afc$export$4a34f930e789283c($fbf5f8a8b86b1afc$export$4254d4e2b3745c4c($fbf5f8a8b86b1afc$export$48cfd1e771a65c4f(), $fbf5f8a8b86b1afc$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $fbf5f8a8b86b1afc$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $fbf5f8a8b86b1afc$export$36776f635604f274(j) - l) $fbf5f8a8b86b1afc$export$10d8903dec122b9d(p > 32 ? $fbf5f8a8b86b1afc$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $fbf5f8a8b86b1afc$export$f8483753829ec8f3($fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $fbf5f8a8b86b1afc$export$10d8903dec122b9d(y = $fbf5f8a8b86b1afc$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $fbf5f8a8b86b1afc$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $fbf5f8a8b86b1afc$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $fbf5f8a8b86b1afc$export$98e6a39c04603d36(e, y, y, n && $fbf5f8a8b86b1afc$export$10d8903dec122b9d($fbf5f8a8b86b1afc$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $fbf5f8a8b86b1afc$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $fbf5f8a8b86b1afc$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $fbf5f8a8b86b1afc$export$232faf9add678146() == 125) continue;
            }
            switch(j += $fbf5f8a8b86b1afc$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($fbf5f8a8b86b1afc$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($fbf5f8a8b86b1afc$export$4d3fb11e950abb9e() === 45) j += $fbf5f8a8b86b1afc$export$410ac95b9ec204b8($fbf5f8a8b86b1afc$export$48cfd1e771a65c4f());
                    v = $fbf5f8a8b86b1afc$export$4d3fb11e950abb9e(), o = l = $fbf5f8a8b86b1afc$export$36776f635604f274(g = j += $fbf5f8a8b86b1afc$export$c2ab62c7bf24634($fbf5f8a8b86b1afc$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $fbf5f8a8b86b1afc$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $fbf5f8a8b86b1afc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $fbf5f8a8b86b1afc$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $fbf5f8a8b86b1afc$export$2f35ab04d2335697(e, v + 1, v = $fbf5f8a8b86b1afc$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $fbf5f8a8b86b1afc$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $fbf5f8a8b86b1afc$export$35059013cd4a06db(e, r, a, s === 0 ? $fbf5f8a8b86b1afc$export$aa3a2e812ca8570d : i, f, o, l);
}
function $fbf5f8a8b86b1afc$export$4a34f930e789283c(e, r, a) {
    return $fbf5f8a8b86b1afc$export$35059013cd4a06db(e, r, a, $fbf5f8a8b86b1afc$export$a29989082612d0d9, $fbf5f8a8b86b1afc$export$6788812c4e6611e6($fbf5f8a8b86b1afc$export$eba6f6f03b0a92e7()), $fbf5f8a8b86b1afc$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $fbf5f8a8b86b1afc$export$f8483753829ec8f3(e, r, a, n) {
    return $fbf5f8a8b86b1afc$export$35059013cd4a06db(e, r, a, $fbf5f8a8b86b1afc$export$527d108ccf083c2b, $fbf5f8a8b86b1afc$export$2f35ab04d2335697(e, 0, n), $fbf5f8a8b86b1afc$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $fbf5f8a8b86b1afc$export$82e9f45cca5ba907(n, c, s) {
    switch($fbf5f8a8b86b1afc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $fbf5f8a8b86b1afc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + n + $fbf5f8a8b86b1afc$export$2c0f367103c8d01c + n + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($fbf5f8a8b86b1afc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + n + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + n + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + n + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + n + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + n + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + n + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + "box-$1$2" + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + n + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + "flex-item-" + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$fbf5f8a8b86b1afc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + "grid-row-" + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + n + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + "flex-line-pack" + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + n + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + n + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + "box-" + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + n + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed($fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed($fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed($fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + "box-pack:$3" + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$fbf5f8a8b86b1afc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + "grid-column-align" + $fbf5f8a8b86b1afc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $fbf5f8a8b86b1afc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$fbf5f8a8b86b1afc$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$fbf5f8a8b86b1afc$export$f8e21b1e77979a08(s, "span") ? $fbf5f8a8b86b1afc$export$4659b591c19bdf3d(s, /\d+/) : +$fbf5f8a8b86b1afc$export$4659b591c19bdf3d(s, /\d+/) - +$fbf5f8a8b86b1afc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $fbf5f8a8b86b1afc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed($fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($fbf5f8a8b86b1afc$export$36776f635604f274(n) - 1 - c > 6) switch($fbf5f8a8b86b1afc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($fbf5f8a8b86b1afc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $fbf5f8a8b86b1afc$export$2c0f367103c8d01c + ($fbf5f8a8b86b1afc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$fbf5f8a8b86b1afc$export$f8e21b1e77979a08(n, "stretch") ? $fbf5f8a8b86b1afc$export$82e9f45cca5ba907($fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($fbf5f8a8b86b1afc$export$a9db5e087081082d(n, c + 6) === 121) return $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, ":", ":" + $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($fbf5f8a8b86b1afc$export$a9db5e087081082d(n, $fbf5f8a8b86b1afc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + ($fbf5f8a8b86b1afc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, ":", ":" + $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $fbf5f8a8b86b1afc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $fbf5f8a8b86b1afc$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $fbf5f8a8b86b1afc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $fbf5f8a8b86b1afc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $fbf5f8a8b86b1afc$export$a763edbf796b780a:
        case $fbf5f8a8b86b1afc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $fbf5f8a8b86b1afc$export$a29989082612d0d9:
            return "";
        case $fbf5f8a8b86b1afc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $fbf5f8a8b86b1afc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $fbf5f8a8b86b1afc$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $fbf5f8a8b86b1afc$export$36776f635604f274(a = $fbf5f8a8b86b1afc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $fbf5f8a8b86b1afc$export$5a7767152ae0305f(e) {
    var r = $fbf5f8a8b86b1afc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $fbf5f8a8b86b1afc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $fbf5f8a8b86b1afc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $fbf5f8a8b86b1afc$export$527d108ccf083c2b:
                n.return = $fbf5f8a8b86b1afc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $fbf5f8a8b86b1afc$export$b44a8529a35fcb60:
                return $fbf5f8a8b86b1afc$export$dfdc1655ccc5b9cb([
                    $fbf5f8a8b86b1afc$export$784d13d8ee351f07(n, {
                        value: $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $fbf5f8a8b86b1afc$export$aa3a2e812ca8570d:
                if (n.length) return $fbf5f8a8b86b1afc$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($fbf5f8a8b86b1afc$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $fbf5f8a8b86b1afc$export$dfdc1655ccc5b9cb([
                                $fbf5f8a8b86b1afc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $fbf5f8a8b86b1afc$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $fbf5f8a8b86b1afc$export$dfdc1655ccc5b9cb([
                                $fbf5f8a8b86b1afc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $fbf5f8a8b86b1afc$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $fbf5f8a8b86b1afc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $fbf5f8a8b86b1afc$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $fbf5f8a8b86b1afc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $fbf5f8a8b86b1afc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $fbf5f8a8b86b1afc$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $fbf5f8a8b86b1afc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $fbf5f8a8b86b1afc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $fbf5f8a8b86b1afc$export$1be1fc439b849fdf($fbf5f8a8b86b1afc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($fbf5f8a8b86b1afc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $fbf5f8a8b86b1afc$export$2f35ab04d2335697(r, 1, $fbf5f8a8b86b1afc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $fbf5f8a8b86b1afc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $fbf5f8a8b86b1afc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $fbf5f8a8b86b1afc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("788CG", function(module, exports) {

$parcel$export(module.exports, "default", () => $530ff8166cce7224$export$2e2bcd8739ae039);
var $530ff8166cce7224$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("j83fk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ded1484dafe55897$export$2e2bcd8739ae039);

var $gKCu6 = parcelRequire("gKCu6");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $ded1484dafe55897$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gKCu6)))(targetComponent, sourceComponent);
};

});
parcelRegister("gKCu6", function(module, exports) {
"use strict";

var $1cYr6 = parcelRequire("1cYr6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $c31ecb719aa99c71$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $c31ecb719aa99c71$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $c31ecb719aa99c71$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $c31ecb719aa99c71$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $c31ecb719aa99c71$var$TYPE_STATICS = {};
$c31ecb719aa99c71$var$TYPE_STATICS[$1cYr6.ForwardRef] = $c31ecb719aa99c71$var$FORWARD_REF_STATICS;
$c31ecb719aa99c71$var$TYPE_STATICS[$1cYr6.Memo] = $c31ecb719aa99c71$var$MEMO_STATICS;
function $c31ecb719aa99c71$var$getStatics(component) {
    // React v16.11 and below
    if ($1cYr6.isMemo(component)) return $c31ecb719aa99c71$var$MEMO_STATICS;
     // React v16.12 and above
    return $c31ecb719aa99c71$var$TYPE_STATICS[component["$$typeof"]] || $c31ecb719aa99c71$var$REACT_STATICS;
}
var $c31ecb719aa99c71$var$defineProperty = Object.defineProperty;
var $c31ecb719aa99c71$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $c31ecb719aa99c71$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $c31ecb719aa99c71$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $c31ecb719aa99c71$var$getPrototypeOf = Object.getPrototypeOf;
var $c31ecb719aa99c71$var$objectPrototype = Object.prototype;
function $c31ecb719aa99c71$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($c31ecb719aa99c71$var$objectPrototype) {
            var inheritedComponent = $c31ecb719aa99c71$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $c31ecb719aa99c71$var$objectPrototype) $c31ecb719aa99c71$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $c31ecb719aa99c71$var$getOwnPropertyNames(sourceComponent);
        if ($c31ecb719aa99c71$var$getOwnPropertySymbols) keys = keys.concat($c31ecb719aa99c71$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $c31ecb719aa99c71$var$getStatics(targetComponent);
        var sourceStatics = $c31ecb719aa99c71$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$c31ecb719aa99c71$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $c31ecb719aa99c71$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $c31ecb719aa99c71$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $c31ecb719aa99c71$var$hoistNonReactStatics;

});
parcelRegister("1cYr6", function(module, exports) {
"use strict";

module.exports = (parcelRequire("k9STf"));

});



parcelRegister("kcFkT", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $eb54fe159d841213$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $eb54fe159d841213$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $eb54fe159d841213$export$6f077d94b33a01aa);
var $eb54fe159d841213$var$isBrowser = typeof document !== "undefined";
function $eb54fe159d841213$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $eb54fe159d841213$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $eb54fe159d841213$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $eb54fe159d841213$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $eb54fe159d841213$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$eb54fe159d841213$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$eb54fe159d841213$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("aXANZ", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $7fabf6db84704e8d$export$6321afa313b251b5);

var $1JTW1 = parcelRequire("1JTW1");

var $fw9H8 = parcelRequire("fw9H8");

var $3ItXd = parcelRequire("3ItXd");
var $7fabf6db84704e8d$var$isDevelopment = false;
var $7fabf6db84704e8d$var$hyphenateRegex = /[A-Z]|^ms/g;
var $7fabf6db84704e8d$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $7fabf6db84704e8d$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $7fabf6db84704e8d$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $7fabf6db84704e8d$var$processStyleName = /* #__PURE__ */ (0, $3ItXd.default)(function(styleName) {
    return $7fabf6db84704e8d$var$isCustomProperty(styleName) ? styleName : styleName.replace($7fabf6db84704e8d$var$hyphenateRegex, "-$&").toLowerCase();
});
var $7fabf6db84704e8d$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($7fabf6db84704e8d$var$animationRegex, function(match, p1, p2) {
                $7fabf6db84704e8d$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $7fabf6db84704e8d$var$cursor
                };
                return p1;
            });
    }
    if ((0, $fw9H8.default)[key] !== 1 && !$7fabf6db84704e8d$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $7fabf6db84704e8d$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $7fabf6db84704e8d$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $7fabf6db84704e8d$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $7fabf6db84704e8d$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $7fabf6db84704e8d$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $7fabf6db84704e8d$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $7fabf6db84704e8d$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $7fabf6db84704e8d$var$cursor;
                var result = interpolation(mergedProps);
                $7fabf6db84704e8d$var$cursor = previousCursor;
                return $7fabf6db84704e8d$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $7fabf6db84704e8d$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $7fabf6db84704e8d$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($7fabf6db84704e8d$var$isProcessableValue(asString)) string += $7fabf6db84704e8d$var$processStyleName(key) + ":" + $7fabf6db84704e8d$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $7fabf6db84704e8d$var$isDevelopment) throw new Error($7fabf6db84704e8d$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($7fabf6db84704e8d$var$isProcessableValue(value[_i])) string += $7fabf6db84704e8d$var$processStyleName(key) + ":" + $7fabf6db84704e8d$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $7fabf6db84704e8d$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $7fabf6db84704e8d$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $7fabf6db84704e8d$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $7fabf6db84704e8d$var$cursor;
function $7fabf6db84704e8d$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $7fabf6db84704e8d$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $7fabf6db84704e8d$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $7fabf6db84704e8d$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $7fabf6db84704e8d$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $7fabf6db84704e8d$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $1JTW1.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $7fabf6db84704e8d$var$cursor
    };
}

});
parcelRegister("1JTW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $144561e886449d9a$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $144561e886449d9a$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("fw9H8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4c15d5bc3246f5c$export$2e2bcd8739ae039);
var $b4c15d5bc3246f5c$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("aOJix", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $7e01b61c55eb4b2e$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $7e01b61c55eb4b2e$export$811a713a7276cb9d);

var $1EuC8 = parcelRequire("1EuC8");
var $7e01b61c55eb4b2e$var$isBrowser = typeof document !== "undefined";
var $7e01b61c55eb4b2e$var$syncFallback = function syncFallback(create) {
    return create();
};
var $7e01b61c55eb4b2e$var$useInsertionEffect = $1EuC8.useInsertionEffect ? $1EuC8.useInsertionEffect : false;
var $7e01b61c55eb4b2e$export$db21c7ffa21794e7 = !$7e01b61c55eb4b2e$var$isBrowser ? $7e01b61c55eb4b2e$var$syncFallback : $7e01b61c55eb4b2e$var$useInsertionEffect || $7e01b61c55eb4b2e$var$syncFallback;
var $7e01b61c55eb4b2e$export$811a713a7276cb9d = $7e01b61c55eb4b2e$var$useInsertionEffect || $1EuC8.useLayoutEffect;

});





parcelRegister("j2qx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc2c8f41be546f8$export$2e2bcd8739ae039);
parcelRequire("1EuC8");


var $69fRv = parcelRequire("69fRv");

var $4tJ1W = parcelRequire("4tJ1W");

var $6iAGf = parcelRequire("6iAGf");
"use client";
let $ddc2c8f41be546f8$var$cache;
if (typeof document === "object") $ddc2c8f41be546f8$var$cache = (0, $4tJ1W.default)({
    key: "css",
    prepend: true
});
function $ddc2c8f41be546f8$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $ddc2c8f41be546f8$var$cache ? /*#__PURE__*/ (0, $6iAGf.jsx)((0, $69fRv.C), {
        value: $ddc2c8f41be546f8$var$cache,
        children: children
    }) : children;
}

});

parcelRegister("kzzTv", function(module, exports) {

$parcel$export(module.exports, "default", () => $efa2eb67f6025f89$export$2e2bcd8739ae039);
parcelRequire("1EuC8");


var $cOeZu = parcelRequire("cOeZu");

var $6iAGf = parcelRequire("6iAGf");
"use client";
function $efa2eb67f6025f89$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $efa2eb67f6025f89$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($efa2eb67f6025f89$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $6iAGf.jsx)((0, $cOeZu.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("i5l0f", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $d2a8fc67b42f63e7$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $d2a8fc67b42f63e7$export$2e2bcd8739ae039);

var $cPOSH = parcelRequire("cPOSH");
function $d2a8fc67b42f63e7$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $d2a8fc67b42f63e7$var$deepClone(source) {
    if (!$d2a8fc67b42f63e7$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $d2a8fc67b42f63e7$var$deepClone(source[key]);
    });
    return output;
}
function $d2a8fc67b42f63e7$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $cPOSH.default)({}, target) : target;
    if ($d2a8fc67b42f63e7$export$53b83ca8eaab0383(target) && $d2a8fc67b42f63e7$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($d2a8fc67b42f63e7$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $d2a8fc67b42f63e7$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $d2a8fc67b42f63e7$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $d2a8fc67b42f63e7$export$53b83ca8eaab0383(source[key]) ? $d2a8fc67b42f63e7$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("ksL8y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("cwrhp")).default);

var $cwrhp = parcelRequire("cwrhp");

});

parcelRegister("k1J5h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("eRrPx")).default);

var $eRrPx = parcelRequire("eRrPx");
$parcel$exportWildcard(module.exports, $eRrPx);

});
parcelRegister("eRrPx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", () => $ad1b9a72e2b464d5$export$aad197c7121a6651);
$parcel$export(module.exports, "default", () => $ad1b9a72e2b464d5$export$2e2bcd8739ae039);

var $7xTXF = parcelRequire("7xTXF");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $ad1b9a72e2b464d5$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $ad1b9a72e2b464d5$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($ad1b9a72e2b464d5$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $ad1b9a72e2b464d5$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $ad1b9a72e2b464d5$export$aad197c7121a6651(Component) || fallback;
}
function $ad1b9a72e2b464d5$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ad1b9a72e2b464d5$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ad1b9a72e2b464d5$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $ad1b9a72e2b464d5$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $7xTXF.ForwardRef:
            return $ad1b9a72e2b464d5$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $7xTXF.Memo:
            return $ad1b9a72e2b464d5$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("7xTXF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ez86l"));

});
parcelRegister("ez86l", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $a9aa9e59a67bc594$export$a7c73072b1a182ae, (v) => $a9aa9e59a67bc594$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a9aa9e59a67bc594$export$9f27bc3417b4524d, (v) => $a9aa9e59a67bc594$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a9aa9e59a67bc594$export$db77ccec0bb4ccac, (v) => $a9aa9e59a67bc594$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a9aa9e59a67bc594$export$8392c0c9d3dcbd35, (v) => $a9aa9e59a67bc594$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a9aa9e59a67bc594$export$ffb0004e005737fa, (v) => $a9aa9e59a67bc594$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a9aa9e59a67bc594$export$b624eff549462981, (v) => $a9aa9e59a67bc594$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a9aa9e59a67bc594$export$7897aa7841a5380c, (v) => $a9aa9e59a67bc594$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a9aa9e59a67bc594$export$602eac185826482c, (v) => $a9aa9e59a67bc594$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a9aa9e59a67bc594$export$e2c29f18771995cb, (v) => $a9aa9e59a67bc594$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a9aa9e59a67bc594$export$5f8d39834fd61797, (v) => $a9aa9e59a67bc594$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a9aa9e59a67bc594$export$74bf444e3cd11ea5, (v) => $a9aa9e59a67bc594$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $a9aa9e59a67bc594$export$998bcd577473dd93, (v) => $a9aa9e59a67bc594$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a9aa9e59a67bc594$export$92387174baf9b227, (v) => $a9aa9e59a67bc594$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a9aa9e59a67bc594$export$ec112efeb987d9c6, (v) => $a9aa9e59a67bc594$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a9aa9e59a67bc594$export$b706b080d889d2c9, (v) => $a9aa9e59a67bc594$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a9aa9e59a67bc594$export$5be5a87408f70ddc, (v) => $a9aa9e59a67bc594$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a9aa9e59a67bc594$export$45a5e7f76e0caa8d, (v) => $a9aa9e59a67bc594$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a9aa9e59a67bc594$export$455c2e768291efa6, (v) => $a9aa9e59a67bc594$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a9aa9e59a67bc594$export$9522e17588c12572, (v) => $a9aa9e59a67bc594$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a9aa9e59a67bc594$export$2110ac352bb060b9, (v) => $a9aa9e59a67bc594$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a9aa9e59a67bc594$export$56885ab8b9c456ab, (v) => $a9aa9e59a67bc594$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a9aa9e59a67bc594$export$d927fcb6adf8f9de, (v) => $a9aa9e59a67bc594$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a9aa9e59a67bc594$export$b82d16f27459e05a, (v) => $a9aa9e59a67bc594$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a9aa9e59a67bc594$export$522c17b4f5e123e8, (v) => $a9aa9e59a67bc594$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a9aa9e59a67bc594$export$1aabd8a0274ecfd6, (v) => $a9aa9e59a67bc594$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $a9aa9e59a67bc594$export$3d6c20d97e46b957, (v) => $a9aa9e59a67bc594$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $a9aa9e59a67bc594$export$9b621391a187a31a, (v) => $a9aa9e59a67bc594$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a9aa9e59a67bc594$export$f5bbd400c2f4426f, (v) => $a9aa9e59a67bc594$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a9aa9e59a67bc594$export$a7c73072b1a182ae;
var $a9aa9e59a67bc594$export$9f27bc3417b4524d;
var $a9aa9e59a67bc594$export$db77ccec0bb4ccac;
var $a9aa9e59a67bc594$export$8392c0c9d3dcbd35;
var $a9aa9e59a67bc594$export$ffb0004e005737fa;
var $a9aa9e59a67bc594$export$b624eff549462981;
var $a9aa9e59a67bc594$export$7897aa7841a5380c;
var $a9aa9e59a67bc594$export$602eac185826482c;
var $a9aa9e59a67bc594$export$e2c29f18771995cb;
var $a9aa9e59a67bc594$export$5f8d39834fd61797;
var $a9aa9e59a67bc594$export$74bf444e3cd11ea5;
var $a9aa9e59a67bc594$export$998bcd577473dd93;
var $a9aa9e59a67bc594$export$92387174baf9b227;
var $a9aa9e59a67bc594$export$ec112efeb987d9c6;
var $a9aa9e59a67bc594$export$b706b080d889d2c9;
var $a9aa9e59a67bc594$export$5be5a87408f70ddc;
var $a9aa9e59a67bc594$export$45a5e7f76e0caa8d;
var $a9aa9e59a67bc594$export$455c2e768291efa6;
var $a9aa9e59a67bc594$export$9522e17588c12572;
var $a9aa9e59a67bc594$export$2110ac352bb060b9;
var $a9aa9e59a67bc594$export$56885ab8b9c456ab;
var $a9aa9e59a67bc594$export$d927fcb6adf8f9de;
var $a9aa9e59a67bc594$export$b82d16f27459e05a;
var $a9aa9e59a67bc594$export$522c17b4f5e123e8;
var $a9aa9e59a67bc594$export$1aabd8a0274ecfd6;
var $a9aa9e59a67bc594$export$3d6c20d97e46b957;
var $a9aa9e59a67bc594$export$9b621391a187a31a;
var $a9aa9e59a67bc594$export$f5bbd400c2f4426f;
"use strict";
var $a9aa9e59a67bc594$var$b = Symbol.for("react.element"), $a9aa9e59a67bc594$var$c = Symbol.for("react.portal"), $a9aa9e59a67bc594$var$d = Symbol.for("react.fragment"), $a9aa9e59a67bc594$var$e = Symbol.for("react.strict_mode"), $a9aa9e59a67bc594$var$f = Symbol.for("react.profiler"), $a9aa9e59a67bc594$var$g = Symbol.for("react.provider"), $a9aa9e59a67bc594$var$h = Symbol.for("react.context"), $a9aa9e59a67bc594$var$k = Symbol.for("react.server_context"), $a9aa9e59a67bc594$var$l = Symbol.for("react.forward_ref"), $a9aa9e59a67bc594$var$m = Symbol.for("react.suspense"), $a9aa9e59a67bc594$var$n = Symbol.for("react.suspense_list"), $a9aa9e59a67bc594$var$p = Symbol.for("react.memo"), $a9aa9e59a67bc594$var$q = Symbol.for("react.lazy"), $a9aa9e59a67bc594$var$t = Symbol.for("react.offscreen"), $a9aa9e59a67bc594$var$u;
$a9aa9e59a67bc594$var$u = Symbol.for("react.module.reference");
function $a9aa9e59a67bc594$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $a9aa9e59a67bc594$var$b:
                switch(a = a.type, a){
                    case $a9aa9e59a67bc594$var$d:
                    case $a9aa9e59a67bc594$var$f:
                    case $a9aa9e59a67bc594$var$e:
                    case $a9aa9e59a67bc594$var$m:
                    case $a9aa9e59a67bc594$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a9aa9e59a67bc594$var$k:
                            case $a9aa9e59a67bc594$var$h:
                            case $a9aa9e59a67bc594$var$l:
                            case $a9aa9e59a67bc594$var$q:
                            case $a9aa9e59a67bc594$var$p:
                            case $a9aa9e59a67bc594$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $a9aa9e59a67bc594$var$c:
                return r;
        }
    }
}
$a9aa9e59a67bc594$export$a7c73072b1a182ae = $a9aa9e59a67bc594$var$h;
$a9aa9e59a67bc594$export$9f27bc3417b4524d = $a9aa9e59a67bc594$var$g;
$a9aa9e59a67bc594$export$db77ccec0bb4ccac = $a9aa9e59a67bc594$var$b;
$a9aa9e59a67bc594$export$8392c0c9d3dcbd35 = $a9aa9e59a67bc594$var$l;
$a9aa9e59a67bc594$export$ffb0004e005737fa = $a9aa9e59a67bc594$var$d;
$a9aa9e59a67bc594$export$b624eff549462981 = $a9aa9e59a67bc594$var$q;
$a9aa9e59a67bc594$export$7897aa7841a5380c = $a9aa9e59a67bc594$var$p;
$a9aa9e59a67bc594$export$602eac185826482c = $a9aa9e59a67bc594$var$c;
$a9aa9e59a67bc594$export$e2c29f18771995cb = $a9aa9e59a67bc594$var$f;
$a9aa9e59a67bc594$export$5f8d39834fd61797 = $a9aa9e59a67bc594$var$e;
$a9aa9e59a67bc594$export$74bf444e3cd11ea5 = $a9aa9e59a67bc594$var$m;
$a9aa9e59a67bc594$export$998bcd577473dd93 = $a9aa9e59a67bc594$var$n;
$a9aa9e59a67bc594$export$92387174baf9b227 = function() {
    return !1;
};
$a9aa9e59a67bc594$export$ec112efeb987d9c6 = function() {
    return !1;
};
$a9aa9e59a67bc594$export$b706b080d889d2c9 = function(a) {
    return $a9aa9e59a67bc594$var$v(a) === $a9aa9e59a67bc594$var$h;
};
$a9aa9e59a67bc594$export$5be5a87408f70ddc = function(a) {
    return $a9aa9e59a67bc594$var$v(a) === $a9aa9e59a67bc594$var$g;
};
$a9aa9e59a67bc594$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a9aa9e59a67bc594$var$b;
};
$a9aa9e59a67bc594$export$455c2e768291efa6 = function(a) {
    return $a9aa9e59a67bc594$var$v(a) === $a9aa9e59a67bc594$var$l;
};
$a9aa9e59a67bc594$export$9522e17588c12572 = function(a) {
    return $a9aa9e59a67bc594$var$v(a) === $a9aa9e59a67bc594$var$d;
};
$a9aa9e59a67bc594$export$2110ac352bb060b9 = function(a) {
    return $a9aa9e59a67bc594$var$v(a) === $a9aa9e59a67bc594$var$q;
};
$a9aa9e59a67bc594$export$56885ab8b9c456ab = function(a) {
    return $a9aa9e59a67bc594$var$v(a) === $a9aa9e59a67bc594$var$p;
};
$a9aa9e59a67bc594$export$d927fcb6adf8f9de = function(a) {
    return $a9aa9e59a67bc594$var$v(a) === $a9aa9e59a67bc594$var$c;
};
$a9aa9e59a67bc594$export$b82d16f27459e05a = function(a) {
    return $a9aa9e59a67bc594$var$v(a) === $a9aa9e59a67bc594$var$f;
};
$a9aa9e59a67bc594$export$522c17b4f5e123e8 = function(a) {
    return $a9aa9e59a67bc594$var$v(a) === $a9aa9e59a67bc594$var$e;
};
$a9aa9e59a67bc594$export$1aabd8a0274ecfd6 = function(a) {
    return $a9aa9e59a67bc594$var$v(a) === $a9aa9e59a67bc594$var$m;
};
$a9aa9e59a67bc594$export$3d6c20d97e46b957 = function(a) {
    return $a9aa9e59a67bc594$var$v(a) === $a9aa9e59a67bc594$var$n;
};
$a9aa9e59a67bc594$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a9aa9e59a67bc594$var$d || a === $a9aa9e59a67bc594$var$f || a === $a9aa9e59a67bc594$var$e || a === $a9aa9e59a67bc594$var$m || a === $a9aa9e59a67bc594$var$n || a === $a9aa9e59a67bc594$var$t || "object" === typeof a && null !== a && (a.$$typeof === $a9aa9e59a67bc594$var$q || a.$$typeof === $a9aa9e59a67bc594$var$p || a.$$typeof === $a9aa9e59a67bc594$var$g || a.$$typeof === $a9aa9e59a67bc594$var$h || a.$$typeof === $a9aa9e59a67bc594$var$l || a.$$typeof === $a9aa9e59a67bc594$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$a9aa9e59a67bc594$export$f5bbd400c2f4426f = $a9aa9e59a67bc594$var$v;

});




parcelRegister("jhC20", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("cteiL")).default);
$parcel$export(module.exports, "private_createBreakpoints", () => (parcelRequire("6N804")).default);
$parcel$export(module.exports, "unstable_applyStyles", () => (parcelRequire("etL0v")).default);

var $cteiL = parcelRequire("cteiL");

var $6N804 = parcelRequire("6N804");

var $etL0v = parcelRequire("etL0v");

});
parcelRegister("cteiL", function(module, exports) {

$parcel$export(module.exports, "default", () => $91434974848a3d76$export$2e2bcd8739ae039);

var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");

var $i5l0f = parcelRequire("i5l0f");

var $6N804 = parcelRequire("6N804");

var $7eXp8 = parcelRequire("7eXp8");

var $edNcL = parcelRequire("edNcL");

var $cLzOx = parcelRequire("cLzOx");

var $6Pmr1 = parcelRequire("6Pmr1");

var $etL0v = parcelRequire("etL0v");
const $91434974848a3d76$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $91434974848a3d76$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $aT5bD.default)(options, $91434974848a3d76$var$_excluded);
    const breakpoints = (0, $6N804.default)(breakpointsInput);
    const spacing = (0, $edNcL.default)(spacingInput);
    let muiTheme = (0, $i5l0f.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $cPOSH.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $cPOSH.default)({}, (0, $7eXp8.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $etL0v.default);
    muiTheme = args.reduce((acc, argument)=>(0, $i5l0f.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $cPOSH.default)({}, (0, $6Pmr1.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $cLzOx.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $91434974848a3d76$export$2e2bcd8739ae039 = $91434974848a3d76$var$createTheme;

});
parcelRegister("6N804", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f1d8652fd6aad80$export$2e2bcd8739ae039);

var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");
const $4f1d8652fd6aad80$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $4f1d8652fd6aad80$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $4f1d8652fd6aad80$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $cPOSH.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $4f1d8652fd6aad80$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $aT5bD.default)(breakpoints, $4f1d8652fd6aad80$var$_excluded);
    const sortedValues = $4f1d8652fd6aad80$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $cPOSH.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("7eXp8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5457ebb34547b9a0$export$2e2bcd8739ae039);
const $5457ebb34547b9a0$var$shape = {
    borderRadius: 4
};
var $5457ebb34547b9a0$export$2e2bcd8739ae039 = $5457ebb34547b9a0$var$shape;

});

parcelRegister("edNcL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5a872a4bd9bb433$export$2e2bcd8739ae039);

var $kQBDD = parcelRequire("kQBDD");
function $a5a872a4bd9bb433$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $kQBDD.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("kQBDD", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $f2d5dc251fe389d1$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $f2d5dc251fe389d1$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $f2d5dc251fe389d1$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $f2d5dc251fe389d1$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $f2d5dc251fe389d1$export$6f98e8eaf0be1996);


var $hY8gn = parcelRequire("hY8gn");

var $7bUH9 = parcelRequire("7bUH9");

var $K1nMk = parcelRequire("K1nMk");

var $jwc8d = parcelRequire("jwc8d");
const $f2d5dc251fe389d1$var$properties = {
    m: "margin",
    p: "padding"
};
const $f2d5dc251fe389d1$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $f2d5dc251fe389d1$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $f2d5dc251fe389d1$var$getCssProperties = (0, $jwc8d.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($f2d5dc251fe389d1$var$aliases[prop]) prop = $f2d5dc251fe389d1$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $f2d5dc251fe389d1$var$properties[a];
    const direction = $f2d5dc251fe389d1$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $f2d5dc251fe389d1$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $f2d5dc251fe389d1$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $f2d5dc251fe389d1$var$spacingKeys = [
    ...$f2d5dc251fe389d1$export$aab52a0dde05ad8a,
    ...$f2d5dc251fe389d1$export$f8397d44f03ab6ad
];
function $f2d5dc251fe389d1$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $7bUH9.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $f2d5dc251fe389d1$export$1def6f833384e3d1(theme) {
    return $f2d5dc251fe389d1$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $f2d5dc251fe389d1$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $f2d5dc251fe389d1$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $f2d5dc251fe389d1$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $f2d5dc251fe389d1$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $f2d5dc251fe389d1$var$getCssProperties(prop);
    const styleFromPropValue = $f2d5dc251fe389d1$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $hY8gn.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $f2d5dc251fe389d1$var$style(props, keys) {
    const transformer = $f2d5dc251fe389d1$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$f2d5dc251fe389d1$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $K1nMk.default), {});
}
function $f2d5dc251fe389d1$export$7ede87f9b603dd3c(props) {
    return $f2d5dc251fe389d1$var$style(props, $f2d5dc251fe389d1$export$aab52a0dde05ad8a);
}
$f2d5dc251fe389d1$export$7ede87f9b603dd3c.propTypes = {};
$f2d5dc251fe389d1$export$7ede87f9b603dd3c.filterProps = $f2d5dc251fe389d1$export$aab52a0dde05ad8a;
function $f2d5dc251fe389d1$export$6f98e8eaf0be1996(props) {
    return $f2d5dc251fe389d1$var$style(props, $f2d5dc251fe389d1$export$f8397d44f03ab6ad);
}
$f2d5dc251fe389d1$export$6f98e8eaf0be1996.propTypes = {};
$f2d5dc251fe389d1$export$6f98e8eaf0be1996.filterProps = $f2d5dc251fe389d1$export$f8397d44f03ab6ad;
function $f2d5dc251fe389d1$var$spacing(props) {
    return $f2d5dc251fe389d1$var$style(props, $f2d5dc251fe389d1$var$spacingKeys);
}
$f2d5dc251fe389d1$var$spacing.propTypes = {};
$f2d5dc251fe389d1$var$spacing.filterProps = $f2d5dc251fe389d1$var$spacingKeys;
var $f2d5dc251fe389d1$export$2e2bcd8739ae039 = $f2d5dc251fe389d1$var$spacing;

});
parcelRegister("hY8gn", function(module, exports) {

$parcel$export(module.exports, "values", () => $d14e732bc396a6bf$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $d14e732bc396a6bf$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $d14e732bc396a6bf$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $d14e732bc396a6bf$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $d14e732bc396a6bf$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $d14e732bc396a6bf$export$980e6a259d807490);

var $cPOSH = parcelRequire("cPOSH");


var $i5l0f = parcelRequire("i5l0f");

var $K1nMk = parcelRequire("K1nMk");
const $d14e732bc396a6bf$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $d14e732bc396a6bf$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$d14e732bc396a6bf$export$68c286be0e7e55b7[key]}px)`
};
function $d14e732bc396a6bf$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $d14e732bc396a6bf$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $d14e732bc396a6bf$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $d14e732bc396a6bf$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $d14e732bc396a6bf$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $d14e732bc396a6bf$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $cPOSH.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $K1nMk.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $d14e732bc396a6bf$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $d14e732bc396a6bf$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $d14e732bc396a6bf$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $d14e732bc396a6bf$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $i5l0f.default)(prev, next), {});
    return $d14e732bc396a6bf$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $d14e732bc396a6bf$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $d14e732bc396a6bf$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $d14e732bc396a6bf$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $d14e732bc396a6bf$export$2e2bcd8739ae039 = $d14e732bc396a6bf$var$breakpoints;

});
parcelRegister("K1nMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $08a55e885c573f63$export$2e2bcd8739ae039);

var $i5l0f = parcelRequire("i5l0f");
function $08a55e885c573f63$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $i5l0f.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $08a55e885c573f63$export$2e2bcd8739ae039 = $08a55e885c573f63$var$merge;

});


parcelRegister("7bUH9", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $53c589f082d6475b$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $53c589f082d6475b$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $53c589f082d6475b$export$2e2bcd8739ae039);

var $cwrhp = parcelRequire("cwrhp");


var $hY8gn = parcelRequire("hY8gn");
function $53c589f082d6475b$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $53c589f082d6475b$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $53c589f082d6475b$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $53c589f082d6475b$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $53c589f082d6475b$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $53c589f082d6475b$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $53c589f082d6475b$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $cwrhp.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $hY8gn.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $53c589f082d6475b$export$2e2bcd8739ae039 = $53c589f082d6475b$var$style;

});

parcelRegister("jwc8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $e35a6a920552a9d0$export$2e2bcd8739ae039);
function $e35a6a920552a9d0$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("cLzOx", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => $94b5a7c2ec7c5fee$export$7d53d8bf2911e013);
$parcel$export(module.exports, "default", () => $94b5a7c2ec7c5fee$export$2e2bcd8739ae039);

var $cwrhp = parcelRequire("cwrhp");

var $K1nMk = parcelRequire("K1nMk");

var $7bUH9 = parcelRequire("7bUH9");

var $hY8gn = parcelRequire("hY8gn");

var $6Pmr1 = parcelRequire("6Pmr1");
function $94b5a7c2ec7c5fee$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $94b5a7c2ec7c5fee$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $94b5a7c2ec7c5fee$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $7bUH9.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $7bUH9.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $7bUH9.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $cwrhp.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $hY8gn.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $6Pmr1.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $hY8gn.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $94b5a7c2ec7c5fee$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $K1nMk.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $hY8gn.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($94b5a7c2ec7c5fee$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $K1nMk.default)(css, breakpointsValues);
                        }
                    } else css = (0, $K1nMk.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $hY8gn.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $94b5a7c2ec7c5fee$var$styleFunctionSx = $94b5a7c2ec7c5fee$export$7d53d8bf2911e013();
$94b5a7c2ec7c5fee$var$styleFunctionSx.filterProps = [
    "sx"
];
var $94b5a7c2ec7c5fee$export$2e2bcd8739ae039 = $94b5a7c2ec7c5fee$var$styleFunctionSx;

});
parcelRegister("6Pmr1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f88e89531c0cc02$export$2e2bcd8739ae039);

var $kQBDD = parcelRequire("kQBDD");

var $3CXYn = parcelRequire("3CXYn");

var $clESe = parcelRequire("clESe");

var $krmFx = parcelRequire("krmFx");

var $e1NET = parcelRequire("e1NET");
const $4f88e89531c0cc02$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $3CXYn.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $3CXYn.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $3CXYn.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $3CXYn.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $3CXYn.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $3CXYn.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $3CXYn.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $krmFx.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $krmFx.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $krmFx.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $kQBDD.padding)
    },
    pt: {
        style: (0, $kQBDD.padding)
    },
    pr: {
        style: (0, $kQBDD.padding)
    },
    pb: {
        style: (0, $kQBDD.padding)
    },
    pl: {
        style: (0, $kQBDD.padding)
    },
    px: {
        style: (0, $kQBDD.padding)
    },
    py: {
        style: (0, $kQBDD.padding)
    },
    padding: {
        style: (0, $kQBDD.padding)
    },
    paddingTop: {
        style: (0, $kQBDD.padding)
    },
    paddingRight: {
        style: (0, $kQBDD.padding)
    },
    paddingBottom: {
        style: (0, $kQBDD.padding)
    },
    paddingLeft: {
        style: (0, $kQBDD.padding)
    },
    paddingX: {
        style: (0, $kQBDD.padding)
    },
    paddingY: {
        style: (0, $kQBDD.padding)
    },
    paddingInline: {
        style: (0, $kQBDD.padding)
    },
    paddingInlineStart: {
        style: (0, $kQBDD.padding)
    },
    paddingInlineEnd: {
        style: (0, $kQBDD.padding)
    },
    paddingBlock: {
        style: (0, $kQBDD.padding)
    },
    paddingBlockStart: {
        style: (0, $kQBDD.padding)
    },
    paddingBlockEnd: {
        style: (0, $kQBDD.padding)
    },
    m: {
        style: (0, $kQBDD.margin)
    },
    mt: {
        style: (0, $kQBDD.margin)
    },
    mr: {
        style: (0, $kQBDD.margin)
    },
    mb: {
        style: (0, $kQBDD.margin)
    },
    ml: {
        style: (0, $kQBDD.margin)
    },
    mx: {
        style: (0, $kQBDD.margin)
    },
    my: {
        style: (0, $kQBDD.margin)
    },
    margin: {
        style: (0, $kQBDD.margin)
    },
    marginTop: {
        style: (0, $kQBDD.margin)
    },
    marginRight: {
        style: (0, $kQBDD.margin)
    },
    marginBottom: {
        style: (0, $kQBDD.margin)
    },
    marginLeft: {
        style: (0, $kQBDD.margin)
    },
    marginX: {
        style: (0, $kQBDD.margin)
    },
    marginY: {
        style: (0, $kQBDD.margin)
    },
    marginInline: {
        style: (0, $kQBDD.margin)
    },
    marginInlineStart: {
        style: (0, $kQBDD.margin)
    },
    marginInlineEnd: {
        style: (0, $kQBDD.margin)
    },
    marginBlock: {
        style: (0, $kQBDD.margin)
    },
    marginBlockStart: {
        style: (0, $kQBDD.margin)
    },
    marginBlockEnd: {
        style: (0, $kQBDD.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $clESe.gap)
    },
    rowGap: {
        style: (0, $clESe.rowGap)
    },
    columnGap: {
        style: (0, $clESe.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $e1NET.sizingTransform)
    },
    maxWidth: {
        style: (0, $e1NET.maxWidth)
    },
    minWidth: {
        transform: (0, $e1NET.sizingTransform)
    },
    height: {
        transform: (0, $e1NET.sizingTransform)
    },
    maxHeight: {
        transform: (0, $e1NET.sizingTransform)
    },
    minHeight: {
        transform: (0, $e1NET.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $4f88e89531c0cc02$export$2e2bcd8739ae039 = $4f88e89531c0cc02$var$defaultSxConfig;

});
parcelRegister("3CXYn", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $2a43710a7d66ede2$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $2a43710a7d66ede2$export$7a57f79000377ca2);


var $7bUH9 = parcelRequire("7bUH9");

var $ie4RV = parcelRequire("ie4RV");

var $kQBDD = parcelRequire("kQBDD");

var $hY8gn = parcelRequire("hY8gn");
function $2a43710a7d66ede2$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $2a43710a7d66ede2$var$createBorderStyle(prop, transform) {
    return (0, $7bUH9.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $2a43710a7d66ede2$export$1edee58a52776cd9 = $2a43710a7d66ede2$var$createBorderStyle("border", $2a43710a7d66ede2$export$34e2febe53ae29cc);
const $2a43710a7d66ede2$export$f9a7b6bd24892946 = $2a43710a7d66ede2$var$createBorderStyle("borderTop", $2a43710a7d66ede2$export$34e2febe53ae29cc);
const $2a43710a7d66ede2$export$5abca33e6be905d2 = $2a43710a7d66ede2$var$createBorderStyle("borderRight", $2a43710a7d66ede2$export$34e2febe53ae29cc);
const $2a43710a7d66ede2$export$e2ce9f12a980a822 = $2a43710a7d66ede2$var$createBorderStyle("borderBottom", $2a43710a7d66ede2$export$34e2febe53ae29cc);
const $2a43710a7d66ede2$export$47658cca1a909427 = $2a43710a7d66ede2$var$createBorderStyle("borderLeft", $2a43710a7d66ede2$export$34e2febe53ae29cc);
const $2a43710a7d66ede2$export$e7fb0694ba2404fc = $2a43710a7d66ede2$var$createBorderStyle("borderColor");
const $2a43710a7d66ede2$export$126a92c968acdb85 = $2a43710a7d66ede2$var$createBorderStyle("borderTopColor");
const $2a43710a7d66ede2$export$85cc51cb8fbb8c0e = $2a43710a7d66ede2$var$createBorderStyle("borderRightColor");
const $2a43710a7d66ede2$export$340b0327727f6d1a = $2a43710a7d66ede2$var$createBorderStyle("borderBottomColor");
const $2a43710a7d66ede2$export$60beef91a985b4bf = $2a43710a7d66ede2$var$createBorderStyle("borderLeftColor");
const $2a43710a7d66ede2$export$f9258c55612cbed7 = $2a43710a7d66ede2$var$createBorderStyle("outline", $2a43710a7d66ede2$export$34e2febe53ae29cc);
const $2a43710a7d66ede2$export$621fe586efeb64b9 = $2a43710a7d66ede2$var$createBorderStyle("outlineColor");
const $2a43710a7d66ede2$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $kQBDD.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $kQBDD.getValue)(transformer, propValue)
            });
        return (0, $hY8gn.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$2a43710a7d66ede2$export$7a57f79000377ca2.propTypes = {};
$2a43710a7d66ede2$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $2a43710a7d66ede2$var$borders = (0, $ie4RV.default)($2a43710a7d66ede2$export$1edee58a52776cd9, $2a43710a7d66ede2$export$f9a7b6bd24892946, $2a43710a7d66ede2$export$5abca33e6be905d2, $2a43710a7d66ede2$export$e2ce9f12a980a822, $2a43710a7d66ede2$export$47658cca1a909427, $2a43710a7d66ede2$export$e7fb0694ba2404fc, $2a43710a7d66ede2$export$126a92c968acdb85, $2a43710a7d66ede2$export$85cc51cb8fbb8c0e, $2a43710a7d66ede2$export$340b0327727f6d1a, $2a43710a7d66ede2$export$60beef91a985b4bf, $2a43710a7d66ede2$export$7a57f79000377ca2, $2a43710a7d66ede2$export$f9258c55612cbed7, $2a43710a7d66ede2$export$621fe586efeb64b9);
var $2a43710a7d66ede2$export$2e2bcd8739ae039 = $2a43710a7d66ede2$var$borders;

});
parcelRegister("ie4RV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d44d4fa07649c8db$export$2e2bcd8739ae039);

var $K1nMk = parcelRequire("K1nMk");
function $d44d4fa07649c8db$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $K1nMk.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $d44d4fa07649c8db$export$2e2bcd8739ae039 = $d44d4fa07649c8db$var$compose;

});


parcelRegister("clESe", function(module, exports) {

$parcel$export(module.exports, "gap", () => $8fd726dd30369bf4$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $8fd726dd30369bf4$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $8fd726dd30369bf4$export$8a833ffa5f5dbeda);

var $7bUH9 = parcelRequire("7bUH9");

var $ie4RV = parcelRequire("ie4RV");

var $kQBDD = parcelRequire("kQBDD");

var $hY8gn = parcelRequire("hY8gn");

const $8fd726dd30369bf4$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $kQBDD.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $kQBDD.getValue)(transformer, propValue)
            });
        return (0, $hY8gn.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$8fd726dd30369bf4$export$5df9adcb0db95e1e.propTypes = {};
$8fd726dd30369bf4$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $8fd726dd30369bf4$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $kQBDD.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $kQBDD.getValue)(transformer, propValue)
            });
        return (0, $hY8gn.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$8fd726dd30369bf4$export$ec60d70ff941a580.propTypes = {};
$8fd726dd30369bf4$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $8fd726dd30369bf4$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $kQBDD.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $kQBDD.getValue)(transformer, propValue)
            });
        return (0, $hY8gn.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$8fd726dd30369bf4$export$8a833ffa5f5dbeda.propTypes = {};
$8fd726dd30369bf4$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $8fd726dd30369bf4$export$baf44164ca3a34e8 = (0, $7bUH9.default)({
    prop: "gridColumn"
});
const $8fd726dd30369bf4$export$8f7213a1cd01e832 = (0, $7bUH9.default)({
    prop: "gridRow"
});
const $8fd726dd30369bf4$export$b0e0abbc49ba668 = (0, $7bUH9.default)({
    prop: "gridAutoFlow"
});
const $8fd726dd30369bf4$export$bcd8b929d4b4142 = (0, $7bUH9.default)({
    prop: "gridAutoColumns"
});
const $8fd726dd30369bf4$export$e5039a674e14c828 = (0, $7bUH9.default)({
    prop: "gridAutoRows"
});
const $8fd726dd30369bf4$export$42bd9088661ffb03 = (0, $7bUH9.default)({
    prop: "gridTemplateColumns"
});
const $8fd726dd30369bf4$export$920682ae05b999bc = (0, $7bUH9.default)({
    prop: "gridTemplateRows"
});
const $8fd726dd30369bf4$export$1b88fbdd482fd33a = (0, $7bUH9.default)({
    prop: "gridTemplateAreas"
});
const $8fd726dd30369bf4$export$bdb486e40d52d26f = (0, $7bUH9.default)({
    prop: "gridArea"
});
const $8fd726dd30369bf4$var$grid = (0, $ie4RV.default)($8fd726dd30369bf4$export$5df9adcb0db95e1e, $8fd726dd30369bf4$export$ec60d70ff941a580, $8fd726dd30369bf4$export$8a833ffa5f5dbeda, $8fd726dd30369bf4$export$baf44164ca3a34e8, $8fd726dd30369bf4$export$8f7213a1cd01e832, $8fd726dd30369bf4$export$b0e0abbc49ba668, $8fd726dd30369bf4$export$bcd8b929d4b4142, $8fd726dd30369bf4$export$e5039a674e14c828, $8fd726dd30369bf4$export$42bd9088661ffb03, $8fd726dd30369bf4$export$920682ae05b999bc, $8fd726dd30369bf4$export$1b88fbdd482fd33a, $8fd726dd30369bf4$export$bdb486e40d52d26f);
var $8fd726dd30369bf4$export$2e2bcd8739ae039 = $8fd726dd30369bf4$var$grid;

});

parcelRegister("krmFx", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $ee17e9d3f8bf23f4$export$dbaffd4420ea0ac6);

var $7bUH9 = parcelRequire("7bUH9");

var $ie4RV = parcelRequire("ie4RV");
function $ee17e9d3f8bf23f4$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $ee17e9d3f8bf23f4$export$35e9368ef982300f = (0, $7bUH9.default)({
    prop: "color",
    themeKey: "palette",
    transform: $ee17e9d3f8bf23f4$export$dbaffd4420ea0ac6
});
const $ee17e9d3f8bf23f4$export$2506f56c10355b33 = (0, $7bUH9.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $ee17e9d3f8bf23f4$export$dbaffd4420ea0ac6
});
const $ee17e9d3f8bf23f4$export$8c5a050822fd698c = (0, $7bUH9.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $ee17e9d3f8bf23f4$export$dbaffd4420ea0ac6
});
const $ee17e9d3f8bf23f4$var$palette = (0, $ie4RV.default)($ee17e9d3f8bf23f4$export$35e9368ef982300f, $ee17e9d3f8bf23f4$export$2506f56c10355b33, $ee17e9d3f8bf23f4$export$8c5a050822fd698c);
var $ee17e9d3f8bf23f4$export$2e2bcd8739ae039 = $ee17e9d3f8bf23f4$var$palette;

});

parcelRegister("e1NET", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $a367add2602a3028$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $a367add2602a3028$export$488fda99655ff65a);

var $7bUH9 = parcelRequire("7bUH9");

var $ie4RV = parcelRequire("ie4RV");

var $hY8gn = parcelRequire("hY8gn");
function $a367add2602a3028$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $a367add2602a3028$export$7e3df82ee760448c = (0, $7bUH9.default)({
    prop: "width",
    transform: $a367add2602a3028$export$8afece71750ec241
});
const $a367add2602a3028$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $hY8gn.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $a367add2602a3028$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $hY8gn.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$a367add2602a3028$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $a367add2602a3028$export$ee148fbbe8357dd2 = (0, $7bUH9.default)({
    prop: "minWidth",
    transform: $a367add2602a3028$export$8afece71750ec241
});
const $a367add2602a3028$export$ac607276a8fe9f0a = (0, $7bUH9.default)({
    prop: "height",
    transform: $a367add2602a3028$export$8afece71750ec241
});
const $a367add2602a3028$export$dc0d8bd0b94f8570 = (0, $7bUH9.default)({
    prop: "maxHeight",
    transform: $a367add2602a3028$export$8afece71750ec241
});
const $a367add2602a3028$export$a43cf604e12f3b17 = (0, $7bUH9.default)({
    prop: "minHeight",
    transform: $a367add2602a3028$export$8afece71750ec241
});
const $a367add2602a3028$export$ffed9f14fb65e276 = (0, $7bUH9.default)({
    prop: "size",
    cssProperty: "width",
    transform: $a367add2602a3028$export$8afece71750ec241
});
const $a367add2602a3028$export$905076ed6620e671 = (0, $7bUH9.default)({
    prop: "size",
    cssProperty: "height",
    transform: $a367add2602a3028$export$8afece71750ec241
});
const $a367add2602a3028$export$6ccc93f785106a58 = (0, $7bUH9.default)({
    prop: "boxSizing"
});
const $a367add2602a3028$var$sizing = (0, $ie4RV.default)($a367add2602a3028$export$7e3df82ee760448c, $a367add2602a3028$export$488fda99655ff65a, $a367add2602a3028$export$ee148fbbe8357dd2, $a367add2602a3028$export$ac607276a8fe9f0a, $a367add2602a3028$export$dc0d8bd0b94f8570, $a367add2602a3028$export$a43cf604e12f3b17, $a367add2602a3028$export$6ccc93f785106a58);
var $a367add2602a3028$export$2e2bcd8739ae039 = $a367add2602a3028$var$sizing;

});



parcelRegister("etL0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8a83cc7008eb926$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $a8a83cc7008eb926$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("alN9C", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("cLzOx")).default);
$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => (parcelRequire("cLzOx")).unstable_createStyleFunctionSx);
$parcel$export(module.exports, "extendSxProp", () => (parcelRequire("b2hnc")).default);
$parcel$export(module.exports, "unstable_defaultSxConfig", () => (parcelRequire("6Pmr1")).default);

var $cLzOx = parcelRequire("cLzOx");

var $b2hnc = parcelRequire("b2hnc");

var $6Pmr1 = parcelRequire("6Pmr1");

});
parcelRegister("b2hnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $808d5b92cb206286$export$2e2bcd8739ae039);

var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");

var $i5l0f = parcelRequire("i5l0f");

var $6Pmr1 = parcelRequire("6Pmr1");
const $808d5b92cb206286$var$_excluded = [
    "sx"
];
const $808d5b92cb206286$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $6Pmr1.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $808d5b92cb206286$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $aT5bD.default)(props, $808d5b92cb206286$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $808d5b92cb206286$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $i5l0f.isPlainObject)(result)) return systemProps;
        return (0, $cPOSH.default)({}, systemProps, result);
    };
    else finalSx = (0, $cPOSH.default)({}, systemProps, inSx);
    return (0, $cPOSH.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRegister("dMi6u", function(module, exports) {

$parcel$export(module.exports, "default", () => $a07dcd0ba2c5e1ed$export$2e2bcd8739ae039);

var $3t47A = parcelRequire("3t47A");
"use client";
const $a07dcd0ba2c5e1ed$var$defaultTheme = (0, $3t47A.default)();
var $a07dcd0ba2c5e1ed$export$2e2bcd8739ae039 = $a07dcd0ba2c5e1ed$var$defaultTheme;

});
parcelRegister("3t47A", function(module, exports) {

$parcel$export(module.exports, "default", () => $286746f338a438b4$export$2e2bcd8739ae039);

var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");

var $49nsw = parcelRequire("49nsw");

var $i5l0f = parcelRequire("i5l0f");

var $cLzOx = parcelRequire("cLzOx");
var $6Pmr1 = parcelRequire("6Pmr1");

var $cteiL = parcelRequire("cteiL");


var $3Mj6h = parcelRequire("3Mj6h");

var $g95kK = parcelRequire("g95kK");

var $g4McL = parcelRequire("g4McL");

var $bugcU = parcelRequire("bugcU");

var $6bwUv = parcelRequire("6bwUv");

var $5naSk = parcelRequire("5naSk");
const $286746f338a438b4$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $286746f338a438b4$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $aT5bD.default)(options, $286746f338a438b4$var$_excluded);
    if (options.vars) throw new Error((0, $49nsw.default)(18));
    const palette = (0, $g95kK.default)(paletteInput);
    const systemTheme = (0, $cteiL.default)(options);
    let muiTheme = (0, $i5l0f.default)(systemTheme, {
        mixins: (0, $3Mj6h.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $bugcU.default).slice(),
        typography: (0, $g4McL.default)(palette, typographyInput),
        transitions: (0, $6bwUv.default)(transitionsInput),
        zIndex: (0, $cPOSH.default)({}, (0, $5naSk.default))
    });
    muiTheme = (0, $i5l0f.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $i5l0f.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $cPOSH.default)({}, (0, $6Pmr1.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $cLzOx.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $286746f338a438b4$var$warnedOnce = false;
function $286746f338a438b4$export$c469355549431d9b(...args) {
    return $286746f338a438b4$var$createTheme(...args);
}
var $286746f338a438b4$export$2e2bcd8739ae039 = $286746f338a438b4$var$createTheme;

});
parcelRegister("3Mj6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c04abb2fe3fa59d$export$2e2bcd8739ae039);

var $cPOSH = parcelRequire("cPOSH");
function $2c04abb2fe3fa59d$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $cPOSH.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("g95kK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc119fc6ae7305b3$export$2e2bcd8739ae039);

var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");

var $49nsw = parcelRequire("49nsw");

var $i5l0f = parcelRequire("i5l0f");

var $9k0Gk = parcelRequire("9k0Gk");

var $4YEtK = parcelRequire("4YEtK");

var $jkmKw = parcelRequire("jkmKw");

var $g7VyW = parcelRequire("g7VyW");

var $kFaf0 = parcelRequire("kFaf0");

var $bxcfL = parcelRequire("bxcfL");

var $9EpCn = parcelRequire("9EpCn");

var $n9I8u = parcelRequire("n9I8u");

var $7jEKT = parcelRequire("7jEKT");
const $bc119fc6ae7305b3$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $bc119fc6ae7305b3$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $4YEtK.default).white,
        default: (0, $4YEtK.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $bc119fc6ae7305b3$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $4YEtK.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $4YEtK.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $bc119fc6ae7305b3$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $9k0Gk.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $9k0Gk.darken)(intent.main, tonalOffsetDark);
    }
}
function $bc119fc6ae7305b3$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $9EpCn.default)[200],
        light: (0, $9EpCn.default)[50],
        dark: (0, $9EpCn.default)[400]
    };
    return {
        main: (0, $9EpCn.default)[700],
        light: (0, $9EpCn.default)[400],
        dark: (0, $9EpCn.default)[800]
    };
}
function $bc119fc6ae7305b3$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $g7VyW.default)[200],
        light: (0, $g7VyW.default)[50],
        dark: (0, $g7VyW.default)[400]
    };
    return {
        main: (0, $g7VyW.default)[500],
        light: (0, $g7VyW.default)[300],
        dark: (0, $g7VyW.default)[700]
    };
}
function $bc119fc6ae7305b3$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $kFaf0.default)[500],
        light: (0, $kFaf0.default)[300],
        dark: (0, $kFaf0.default)[700]
    };
    return {
        main: (0, $kFaf0.default)[700],
        light: (0, $kFaf0.default)[400],
        dark: (0, $kFaf0.default)[800]
    };
}
function $bc119fc6ae7305b3$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $n9I8u.default)[400],
        light: (0, $n9I8u.default)[300],
        dark: (0, $n9I8u.default)[700]
    };
    return {
        main: (0, $n9I8u.default)[700],
        light: (0, $n9I8u.default)[500],
        dark: (0, $n9I8u.default)[900]
    };
}
function $bc119fc6ae7305b3$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $7jEKT.default)[400],
        light: (0, $7jEKT.default)[300],
        dark: (0, $7jEKT.default)[700]
    };
    return {
        main: (0, $7jEKT.default)[800],
        light: (0, $7jEKT.default)[500],
        dark: (0, $7jEKT.default)[900]
    };
}
function $bc119fc6ae7305b3$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bxcfL.default)[400],
        light: (0, $bxcfL.default)[300],
        dark: (0, $bxcfL.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $bxcfL.default)[500],
        dark: (0, $bxcfL.default)[900]
    };
}
function $bc119fc6ae7305b3$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $aT5bD.default)(palette, $bc119fc6ae7305b3$var$_excluded);
    const primary = palette.primary || $bc119fc6ae7305b3$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $bc119fc6ae7305b3$var$getDefaultSecondary(mode);
    const error = palette.error || $bc119fc6ae7305b3$var$getDefaultError(mode);
    const info = palette.info || $bc119fc6ae7305b3$var$getDefaultInfo(mode);
    const success = palette.success || $bc119fc6ae7305b3$var$getDefaultSuccess(mode);
    const warning = palette.warning || $bc119fc6ae7305b3$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $9k0Gk.getContrastRatio)(background, $bc119fc6ae7305b3$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $bc119fc6ae7305b3$export$55ce6f3a06c59543.text.primary : $bc119fc6ae7305b3$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $cPOSH.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $49nsw.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $49nsw.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $bc119fc6ae7305b3$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $bc119fc6ae7305b3$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $bc119fc6ae7305b3$export$55ce6f3a06c59543,
        light: $bc119fc6ae7305b3$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $i5l0f.default)((0, $cPOSH.default)({
        // A collection of common colors.
        common: (0, $cPOSH.default)({}, (0, $4YEtK.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $jkmKw.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("9k0Gk", function(module, exports) {
"use strict";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $6c9682b571b416d8$var$alpha;
module.exports.blend = $6c9682b571b416d8$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $6c9682b571b416d8$var$darken;
module.exports.decomposeColor = $6c9682b571b416d8$var$decomposeColor;
module.exports.emphasize = $6c9682b571b416d8$var$emphasize;
module.exports.getContrastRatio = $6c9682b571b416d8$var$getContrastRatio;
module.exports.getLuminance = $6c9682b571b416d8$var$getLuminance;
module.exports.hexToRgb = $6c9682b571b416d8$var$hexToRgb;
module.exports.hslToRgb = $6c9682b571b416d8$var$hslToRgb;
module.exports.lighten = $6c9682b571b416d8$var$lighten;
module.exports.private_safeAlpha = $6c9682b571b416d8$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $6c9682b571b416d8$var$private_safeDarken;
module.exports.private_safeEmphasize = $6c9682b571b416d8$var$private_safeEmphasize;
module.exports.private_safeLighten = $6c9682b571b416d8$var$private_safeLighten;
module.exports.recomposeColor = $6c9682b571b416d8$var$recomposeColor;
module.exports.rgbToHex = $6c9682b571b416d8$var$rgbToHex;

var $6c9682b571b416d8$var$_formatMuiErrorMessage2 = $4n9Eb((parcelRequire("97KE1")));

var $6c9682b571b416d8$var$_clamp = $4n9Eb((parcelRequire("brFkX")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $6c9682b571b416d8$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $6c9682b571b416d8$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $6c9682b571b416d8$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $6c9682b571b416d8$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $6c9682b571b416d8$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $6c9682b571b416d8$var$decomposeColor($6c9682b571b416d8$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $6c9682b571b416d8$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $6c9682b571b416d8$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $6c9682b571b416d8$var$colorChannel = (color)=>{
    const decomposedColor = $6c9682b571b416d8$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
module.exports.colorChannel = $6c9682b571b416d8$var$colorChannel;
const $6c9682b571b416d8$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $6c9682b571b416d8$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $6c9682b571b416d8$var$private_safeColorChannel;
function $6c9682b571b416d8$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $6c9682b571b416d8$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $6c9682b571b416d8$var$decomposeColor(color);
    return `#${values.map((n, i)=>$6c9682b571b416d8$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $6c9682b571b416d8$var$hslToRgb(color) {
    color = $6c9682b571b416d8$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $6c9682b571b416d8$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $6c9682b571b416d8$var$getLuminance(color) {
    color = $6c9682b571b416d8$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $6c9682b571b416d8$var$decomposeColor($6c9682b571b416d8$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $6c9682b571b416d8$var$getContrastRatio(foreground, background) {
    const lumA = $6c9682b571b416d8$var$getLuminance(foreground);
    const lumB = $6c9682b571b416d8$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6c9682b571b416d8$var$alpha(color, value) {
    color = $6c9682b571b416d8$var$decomposeColor(color);
    value = $6c9682b571b416d8$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $6c9682b571b416d8$var$recomposeColor(color);
}
function $6c9682b571b416d8$var$private_safeAlpha(color, value, warning) {
    try {
        return $6c9682b571b416d8$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6c9682b571b416d8$var$darken(color, coefficient) {
    color = $6c9682b571b416d8$var$decomposeColor(color);
    coefficient = $6c9682b571b416d8$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $6c9682b571b416d8$var$recomposeColor(color);
}
function $6c9682b571b416d8$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $6c9682b571b416d8$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6c9682b571b416d8$var$lighten(color, coefficient) {
    color = $6c9682b571b416d8$var$decomposeColor(color);
    coefficient = $6c9682b571b416d8$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $6c9682b571b416d8$var$recomposeColor(color);
}
function $6c9682b571b416d8$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $6c9682b571b416d8$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6c9682b571b416d8$var$emphasize(color, coefficient = 0.15) {
    return $6c9682b571b416d8$var$getLuminance(color) > 0.5 ? $6c9682b571b416d8$var$darken(color, coefficient) : $6c9682b571b416d8$var$lighten(color, coefficient);
}
function $6c9682b571b416d8$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $6c9682b571b416d8$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $6c9682b571b416d8$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $6c9682b571b416d8$var$decomposeColor(background);
    const overlayColor = $6c9682b571b416d8$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $6c9682b571b416d8$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("97KE1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("49nsw")).default);

var $49nsw = parcelRequire("49nsw");

});

parcelRegister("brFkX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("3LZgY")).default);

var $3LZgY = parcelRequire("3LZgY");

});
parcelRegister("3LZgY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bf54a6222b30082$export$2e2bcd8739ae039);
function $2bf54a6222b30082$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $2bf54a6222b30082$export$2e2bcd8739ae039 = $2bf54a6222b30082$var$clamp;

});



parcelRegister("4YEtK", function(module, exports) {

$parcel$export(module.exports, "default", () => $39fc2a4034fb014b$export$2e2bcd8739ae039);
const $39fc2a4034fb014b$var$common = {
    black: "#000",
    white: "#fff"
};
var $39fc2a4034fb014b$export$2e2bcd8739ae039 = $39fc2a4034fb014b$var$common;

});

parcelRegister("jkmKw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e12188264aa5877a$export$2e2bcd8739ae039);
const $e12188264aa5877a$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $e12188264aa5877a$export$2e2bcd8739ae039 = $e12188264aa5877a$var$grey;

});

parcelRegister("g7VyW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbd9f38196bac535$export$2e2bcd8739ae039);
const $bbd9f38196bac535$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $bbd9f38196bac535$export$2e2bcd8739ae039 = $bbd9f38196bac535$var$purple;

});

parcelRegister("kFaf0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0af94a2cea61ab4$export$2e2bcd8739ae039);
const $f0af94a2cea61ab4$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $f0af94a2cea61ab4$export$2e2bcd8739ae039 = $f0af94a2cea61ab4$var$red;

});

parcelRegister("bxcfL", function(module, exports) {

$parcel$export(module.exports, "default", () => $865c4803072193bb$export$2e2bcd8739ae039);
const $865c4803072193bb$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $865c4803072193bb$export$2e2bcd8739ae039 = $865c4803072193bb$var$orange;

});

parcelRegister("9EpCn", function(module, exports) {

$parcel$export(module.exports, "default", () => $706bb8a9fb339181$export$2e2bcd8739ae039);
const $706bb8a9fb339181$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $706bb8a9fb339181$export$2e2bcd8739ae039 = $706bb8a9fb339181$var$blue;

});

parcelRegister("n9I8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $0459ae7950402e47$export$2e2bcd8739ae039);
const $0459ae7950402e47$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $0459ae7950402e47$export$2e2bcd8739ae039 = $0459ae7950402e47$var$lightBlue;

});

parcelRegister("7jEKT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5539ebebfd0efc39$export$2e2bcd8739ae039);
const $5539ebebfd0efc39$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $5539ebebfd0efc39$export$2e2bcd8739ae039 = $5539ebebfd0efc39$var$green;

});


parcelRegister("g4McL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb42698f29857aa2$export$2e2bcd8739ae039);

var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");

var $i5l0f = parcelRequire("i5l0f");
const $bb42698f29857aa2$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $bb42698f29857aa2$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $bb42698f29857aa2$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $bb42698f29857aa2$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $bb42698f29857aa2$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $bb42698f29857aa2$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $aT5bD.default)(_ref, $bb42698f29857aa2$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $cPOSH.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $bb42698f29857aa2$var$defaultFontFamily ? {
            letterSpacing: `${$bb42698f29857aa2$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $bb42698f29857aa2$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $bb42698f29857aa2$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $i5l0f.default)((0, $cPOSH.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("bugcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $85cf1172fc052bc2$export$2e2bcd8739ae039);
const $85cf1172fc052bc2$var$shadowKeyUmbraOpacity = 0.2;
const $85cf1172fc052bc2$var$shadowKeyPenumbraOpacity = 0.14;
const $85cf1172fc052bc2$var$shadowAmbientShadowOpacity = 0.12;
function $85cf1172fc052bc2$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$85cf1172fc052bc2$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$85cf1172fc052bc2$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$85cf1172fc052bc2$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $85cf1172fc052bc2$var$shadows = [
    "none",
    $85cf1172fc052bc2$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $85cf1172fc052bc2$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $85cf1172fc052bc2$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $85cf1172fc052bc2$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $85cf1172fc052bc2$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $85cf1172fc052bc2$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $85cf1172fc052bc2$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $85cf1172fc052bc2$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $85cf1172fc052bc2$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $85cf1172fc052bc2$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $85cf1172fc052bc2$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $85cf1172fc052bc2$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $85cf1172fc052bc2$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $85cf1172fc052bc2$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $85cf1172fc052bc2$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $85cf1172fc052bc2$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $85cf1172fc052bc2$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $85cf1172fc052bc2$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $85cf1172fc052bc2$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $85cf1172fc052bc2$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $85cf1172fc052bc2$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $85cf1172fc052bc2$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $85cf1172fc052bc2$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $85cf1172fc052bc2$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $85cf1172fc052bc2$export$2e2bcd8739ae039 = $85cf1172fc052bc2$var$shadows;

});

parcelRegister("6bwUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $480d4c78defed136$export$2e2bcd8739ae039);

var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");
const $480d4c78defed136$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $480d4c78defed136$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $480d4c78defed136$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $480d4c78defed136$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $480d4c78defed136$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $480d4c78defed136$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $cPOSH.default)({}, $480d4c78defed136$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $cPOSH.default)({}, $480d4c78defed136$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $aT5bD.default)(options, $480d4c78defed136$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $480d4c78defed136$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $480d4c78defed136$var$formatMs(delay)}`).join(",");
    };
    return (0, $cPOSH.default)({
        getAutoHeightDuration: $480d4c78defed136$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("5naSk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e978955c945cf4c$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $3e978955c945cf4c$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $3e978955c945cf4c$export$2e2bcd8739ae039 = $3e978955c945cf4c$var$zIndex;

});



parcelRegister("2l07H", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b3da366f6ce4c10$export$2e2bcd8739ae039);
var $1b3da366f6ce4c10$export$2e2bcd8739ae039 = "$$material";

});

parcelRegister("51gfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a79a58693d364ed$export$2e2bcd8739ae039);

var $5nxqf = parcelRequire("5nxqf");
const $3a79a58693d364ed$var$rootShouldForwardProp = (prop)=>(0, $5nxqf.default)(prop) && prop !== "classes";
var $3a79a58693d364ed$export$2e2bcd8739ae039 = $3a79a58693d364ed$var$rootShouldForwardProp;

});
parcelRegister("5nxqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ea906b5a4534ced$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $3ea906b5a4534ced$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $3ea906b5a4534ced$export$2e2bcd8739ae039 = $3ea906b5a4534ced$var$slotShouldForwardProp;

});



parcelRegister("6BcoE", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $4cdfd07773c75ef8$export$c7c50641356bdfa5);

var $58RS4 = parcelRequire("58RS4");

var $2jicN = parcelRequire("2jicN");
function $4cdfd07773c75ef8$export$c7c50641356bdfa5(slot) {
    return (0, $2jicN.default)("MuiSvgIcon", slot);
}
const $4cdfd07773c75ef8$var$svgIconClasses = (0, $58RS4.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $4cdfd07773c75ef8$export$2e2bcd8739ae039 = $4cdfd07773c75ef8$var$svgIconClasses;

});
parcelRegister("58RS4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3be77cc4dd1aa507$export$2e2bcd8739ae039);

var $2jicN = parcelRequire("2jicN");
function $3be77cc4dd1aa507$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $2jicN.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("2jicN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1aeb7a54f87593f9$export$2e2bcd8739ae039);

var $ar8ZD = parcelRequire("ar8ZD");
const $1aeb7a54f87593f9$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $1aeb7a54f87593f9$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $1aeb7a54f87593f9$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $ar8ZD.default).generate(componentName)}-${slot}`;
}
function $1aeb7a54f87593f9$export$34c0130b1f3e8ae3(slot) {
    return $1aeb7a54f87593f9$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("ar8ZD", function(module, exports) {

$parcel$export(module.exports, "default", () => $799366d880b1b4e0$export$2e2bcd8739ae039);
const $799366d880b1b4e0$var$defaultGenerator = (componentName)=>componentName;
const $799366d880b1b4e0$var$createClassNameGenerator = ()=>{
    let generate = $799366d880b1b4e0$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $799366d880b1b4e0$var$defaultGenerator;
        }
    };
};
const $799366d880b1b4e0$var$ClassNameGenerator = $799366d880b1b4e0$var$createClassNameGenerator();
var $799366d880b1b4e0$export$2e2bcd8739ae039 = $799366d880b1b4e0$var$ClassNameGenerator;

});







parcelRegister("co4Jd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $904b64dbe91be2d0$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $1EuC8 = parcelRequire("1EuC8");
var $904b64dbe91be2d0$var$_react2 = $904b64dbe91be2d0$var$_interopRequireDefault($1EuC8);

var $2TkGT = parcelRequire("2TkGT");
var $904b64dbe91be2d0$var$_propTypes2 = $904b64dbe91be2d0$var$_interopRequireDefault($2TkGT);
function $904b64dbe91be2d0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $904b64dbe91be2d0$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $904b64dbe91be2d0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $904b64dbe91be2d0$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $904b64dbe91be2d0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $904b64dbe91be2d0$var$InfiniteScroll = function(_Component) {
    $904b64dbe91be2d0$var$_inherits(InfiniteScroll, _Component);
    function InfiniteScroll(props) {
        $904b64dbe91be2d0$var$_classCallCheck(this, InfiniteScroll);
        var _this = $904b64dbe91be2d0$var$_possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));
        _this.scrollListener = _this.scrollListener.bind(_this);
        _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
        _this.mousewheelListener = _this.mousewheelListener.bind(_this);
        return _this;
    }
    $904b64dbe91be2d0$var$_createClass(InfiniteScroll, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.pageLoaded = this.props.pageStart;
                this.options = this.eventListenerOptions();
                this.attachScrollListener();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.props.isReverse && this.loadMore) {
                    var parentElement = this.getParentElement(this.scrollComponent);
                    parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
                    this.loadMore = false;
                }
                this.attachScrollListener();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.detachScrollListener();
                this.detachMousewheelListener();
            }
        },
        {
            key: "isPassiveSupported",
            value: function isPassiveSupported() {
                var passive = false;
                var testOptions = {
                    get passive () {
                        passive = true;
                    }
                };
                try {
                    document.addEventListener("test", null, testOptions);
                    document.removeEventListener("test", null, testOptions);
                } catch (e) {
                // ignore
                }
                return passive;
            }
        },
        {
            key: "eventListenerOptions",
            value: function eventListenerOptions() {
                var options = this.props.useCapture;
                if (this.isPassiveSupported()) options = {
                    useCapture: this.props.useCapture,
                    passive: true
                };
                else options = {
                    passive: false
                };
                return options;
            }
        },
        {
            key: "setDefaultLoader",
            value: function setDefaultLoader(loader) {
                this.defaultLoader = loader;
            }
        },
        {
            key: "detachMousewheelListener",
            value: function detachMousewheelListener() {
                var scrollEl = window;
                if (this.props.useWindow === false) scrollEl = this.scrollComponent.parentNode;
                scrollEl.removeEventListener("mousewheel", this.mousewheelListener, this.options ? this.options : this.props.useCapture);
            }
        },
        {
            key: "detachScrollListener",
            value: function detachScrollListener() {
                var scrollEl = window;
                if (this.props.useWindow === false) scrollEl = this.getParentElement(this.scrollComponent);
                scrollEl.removeEventListener("scroll", this.scrollListener, this.options ? this.options : this.props.useCapture);
                scrollEl.removeEventListener("resize", this.scrollListener, this.options ? this.options : this.props.useCapture);
            }
        },
        {
            key: "getParentElement",
            value: function getParentElement(el) {
                var scrollParent = this.props.getScrollParent && this.props.getScrollParent();
                if (scrollParent != null) return scrollParent;
                return el && el.parentNode;
            }
        },
        {
            key: "filterProps",
            value: function filterProps(props) {
                return props;
            }
        },
        {
            key: "attachScrollListener",
            value: function attachScrollListener() {
                var parentElement = this.getParentElement(this.scrollComponent);
                if (!this.props.hasMore || !parentElement) return;
                var scrollEl = window;
                if (this.props.useWindow === false) scrollEl = parentElement;
                scrollEl.addEventListener("mousewheel", this.mousewheelListener, this.options ? this.options : this.props.useCapture);
                scrollEl.addEventListener("scroll", this.scrollListener, this.options ? this.options : this.props.useCapture);
                scrollEl.addEventListener("resize", this.scrollListener, this.options ? this.options : this.props.useCapture);
                if (this.props.initialLoad) this.scrollListener();
            }
        },
        {
            key: "mousewheelListener",
            value: function mousewheelListener(e) {
                // Prevents Chrome hangups
                // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
                if (e.deltaY === 1 && !this.isPassiveSupported()) e.preventDefault();
            }
        },
        {
            key: "scrollListener",
            value: function scrollListener() {
                var el = this.scrollComponent;
                var scrollEl = window;
                var parentNode = this.getParentElement(el);
                var offset = void 0;
                if (this.props.useWindow) {
                    var doc = document.documentElement || document.body.parentNode || document.body;
                    var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;
                    if (this.props.isReverse) offset = scrollTop;
                    else offset = this.calculateOffset(el, scrollTop);
                } else if (this.props.isReverse) offset = parentNode.scrollTop;
                else offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
                // Here we make sure the element is visible as well as checking the offset
                if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
                    this.detachScrollListener();
                    this.beforeScrollHeight = parentNode.scrollHeight;
                    this.beforeScrollTop = parentNode.scrollTop;
                    // Call loadMore after detachScrollListener to allow for non-async loadMore functions
                    if (typeof this.props.loadMore === "function") {
                        this.props.loadMore(this.pageLoaded += 1);
                        this.loadMore = true;
                    }
                }
            }
        },
        {
            key: "calculateOffset",
            value: function calculateOffset(el, scrollTop) {
                if (!el) return 0;
                return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
            }
        },
        {
            key: "calculateTopPosition",
            value: function calculateTopPosition(el) {
                if (!el) return 0;
                return el.offsetTop + this.calculateTopPosition(el.offsetParent);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var renderProps = this.filterProps(this.props);
                var children = renderProps.children, element = renderProps.element, hasMore = renderProps.hasMore, initialLoad = renderProps.initialLoad, isReverse = renderProps.isReverse, loader = renderProps.loader, loadMore = renderProps.loadMore, pageStart = renderProps.pageStart, ref = renderProps.ref, threshold = renderProps.threshold, useCapture = renderProps.useCapture, useWindow = renderProps.useWindow, getScrollParent = renderProps.getScrollParent, props = $904b64dbe91be2d0$var$_objectWithoutProperties(renderProps, [
                    "children",
                    "element",
                    "hasMore",
                    "initialLoad",
                    "isReverse",
                    "loader",
                    "loadMore",
                    "pageStart",
                    "ref",
                    "threshold",
                    "useCapture",
                    "useWindow",
                    "getScrollParent"
                ]);
                props.ref = function(node) {
                    _this2.scrollComponent = node;
                    if (ref) ref(node);
                };
                var childrenArray = [
                    children
                ];
                if (hasMore) {
                    if (loader) isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
                    else if (this.defaultLoader) isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
                }
                return $904b64dbe91be2d0$var$_react2.default.createElement(element, props, childrenArray);
            }
        }
    ]);
    return InfiniteScroll;
}($1EuC8.Component);
$904b64dbe91be2d0$var$InfiniteScroll.propTypes = {
    children: $904b64dbe91be2d0$var$_propTypes2.default.node.isRequired,
    element: $904b64dbe91be2d0$var$_propTypes2.default.node,
    hasMore: $904b64dbe91be2d0$var$_propTypes2.default.bool,
    initialLoad: $904b64dbe91be2d0$var$_propTypes2.default.bool,
    isReverse: $904b64dbe91be2d0$var$_propTypes2.default.bool,
    loader: $904b64dbe91be2d0$var$_propTypes2.default.node,
    loadMore: $904b64dbe91be2d0$var$_propTypes2.default.func.isRequired,
    pageStart: $904b64dbe91be2d0$var$_propTypes2.default.number,
    ref: $904b64dbe91be2d0$var$_propTypes2.default.func,
    getScrollParent: $904b64dbe91be2d0$var$_propTypes2.default.func,
    threshold: $904b64dbe91be2d0$var$_propTypes2.default.number,
    useCapture: $904b64dbe91be2d0$var$_propTypes2.default.bool,
    useWindow: $904b64dbe91be2d0$var$_propTypes2.default.bool
};
$904b64dbe91be2d0$var$InfiniteScroll.defaultProps = {
    element: "div",
    hasMore: false,
    initialLoad: true,
    pageStart: 0,
    ref: null,
    threshold: 250,
    useWindow: true,
    isReverse: false,
    useCapture: false,
    loader: null,
    getScrollParent: null
};
module.exports.default = $904b64dbe91be2d0$var$InfiniteScroll;
module.exports = module.exports["default"];

});
parcelRegister("2TkGT", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $21b0c492a0eacdfe$var$ReactIs, $21b0c492a0eacdfe$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("8MUNR"))();

});


parcelRegister("cUUdJ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $96765338f7b4ae04$export$306c0aa65ff9ec16, (v) => $96765338f7b4ae04$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $96765338f7b4ae04$export$306c0aa65ff9ec16;
"use strict";

var $1EuC8 = parcelRequire("1EuC8");
function $96765338f7b4ae04$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $96765338f7b4ae04$var$k = "function" === typeof Object.is ? Object.is : $96765338f7b4ae04$var$h, $96765338f7b4ae04$var$l = $1EuC8.useState, $96765338f7b4ae04$var$m = $1EuC8.useEffect, $96765338f7b4ae04$var$n = $1EuC8.useLayoutEffect, $96765338f7b4ae04$var$p = $1EuC8.useDebugValue;
function $96765338f7b4ae04$var$q(a, b) {
    var d = b(), f = $96765338f7b4ae04$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $96765338f7b4ae04$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $96765338f7b4ae04$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $96765338f7b4ae04$var$m(function() {
        $96765338f7b4ae04$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $96765338f7b4ae04$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $96765338f7b4ae04$var$p(d);
    return d;
}
function $96765338f7b4ae04$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$96765338f7b4ae04$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $96765338f7b4ae04$var$t(a, b) {
    return b();
}
var $96765338f7b4ae04$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $96765338f7b4ae04$var$t : $96765338f7b4ae04$var$q;
$96765338f7b4ae04$export$306c0aa65ff9ec16 = void 0 !== $1EuC8.useSyncExternalStore ? $1EuC8.useSyncExternalStore : $96765338f7b4ae04$var$u;

});


var $6iAGf = parcelRequire("6iAGf");



var $4tJ1W = parcelRequire("4tJ1W");

var $69fRv = parcelRequire("69fRv");

var $i5l0f = parcelRequire("i5l0f");

var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");

var $49nsw = parcelRequire("49nsw");

var $1EuC8 = parcelRequire("1EuC8");


var $i5l0f = parcelRequire("i5l0f");

var $kzzTv = parcelRequire("kzzTv");

var $1EuC8 = parcelRequire("1EuC8");

var $1EuC8 = parcelRequire("1EuC8");
const $9efd8ff0f257250c$var$ThemeContext = /*#__PURE__*/ $1EuC8.createContext(null);
var $9efd8ff0f257250c$export$2e2bcd8739ae039 = $9efd8ff0f257250c$var$ThemeContext;


function $713f7eb23f06e717$export$2e2bcd8739ae039() {
    const theme = $1EuC8.useContext((0, $9efd8ff0f257250c$export$2e2bcd8739ae039));
    return theme;
}



var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");


var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");




const $6d24ea75fbe0f3d7$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $6d24ea75fbe0f3d7$export$2e2bcd8739ae039 = $6d24ea75fbe0f3d7$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $6iAGf = parcelRequire("6iAGf");
function $2ddf0f577abd6c85$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $cPOSH.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $2ddf0f577abd6c85$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $713f7eb23f06e717$export$2e2bcd8739ae039)();
    const theme = $1EuC8.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $2ddf0f577abd6c85$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $6d24ea75fbe0f3d7$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $6iAGf.jsx)((0, $9efd8ff0f257250c$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $2ddf0f577abd6c85$export$2e2bcd8739ae039 = $2ddf0f577abd6c85$var$ThemeProvider;



parcelRequire("cOeZu");
var $69fRv = parcelRequire("69fRv");

var $1EuC8 = parcelRequire("1EuC8");
parcelRequire("cOeZu");
var $69fRv = parcelRequire("69fRv");
"use client";
function $b9c977420be7e805$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $b9c977420be7e805$var$useTheme(defaultTheme = null) {
    const contextTheme = $1EuC8.useContext((0, $69fRv.T));
    return !contextTheme || $b9c977420be7e805$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $b9c977420be7e805$export$2e2bcd8739ae039 = $b9c977420be7e805$var$useTheme;



var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");

var $1EuC8 = parcelRequire("1EuC8");


var $6iAGf = parcelRequire("6iAGf");
const $a9fed4e9e22e15e3$var$_excluded = [
    "value"
];
const $a9fed4e9e22e15e3$var$RtlContext = /*#__PURE__*/ $1EuC8.createContext();
function $a9fed4e9e22e15e3$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $aT5bD.default)(_ref, $a9fed4e9e22e15e3$var$_excluded);
    return /*#__PURE__*/ (0, $6iAGf.jsx)($a9fed4e9e22e15e3$var$RtlContext.Provider, (0, $cPOSH.default)({
        value: value != null ? value : true
    }, props));
}
const $a9fed4e9e22e15e3$export$b2dd014b6c321cb = ()=>{
    const value = $1EuC8.useContext($a9fed4e9e22e15e3$var$RtlContext);
    return value != null ? value : false;
};
var $a9fed4e9e22e15e3$export$2e2bcd8739ae039 = $a9fed4e9e22e15e3$var$RtlProvider;



var $363eg = parcelRequire("363eg");

var $6iAGf = parcelRequire("6iAGf");
"use client";
const $c921fd42c44cb580$var$EMPTY_THEME = {};
function $c921fd42c44cb580$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $1EuC8.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $cPOSH.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $cPOSH.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $cPOSH.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $c921fd42c44cb580$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $b9c977420be7e805$export$2e2bcd8739ae039)($c921fd42c44cb580$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $713f7eb23f06e717$export$2e2bcd8739ae039)() || $c921fd42c44cb580$var$EMPTY_THEME;
    const engineTheme = $c921fd42c44cb580$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $c921fd42c44cb580$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === "rtl";
    return /*#__PURE__*/ (0, $6iAGf.jsx)((0, $2ddf0f577abd6c85$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $69fRv.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $a9fed4e9e22e15e3$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $363eg.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $c921fd42c44cb580$export$2e2bcd8739ae039 = $c921fd42c44cb580$var$ThemeProvider;


/**
 * Split this component for RSC import
 */ parcelRequire("1EuC8");

var $6iAGf = parcelRequire("6iAGf");
const $0bbf403053a228ec$export$ff0fa3047d11164c = "mode";
const $0bbf403053a228ec$export$665054ea9d94dab9 = "color-scheme";
const $0bbf403053a228ec$export$14ebe5b26ee7fb38 = "data-color-scheme";
function $0bbf403053a228ec$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = "light", defaultLightColorScheme: defaultLightColorScheme = "light", defaultDarkColorScheme: defaultDarkColorScheme = "dark", modeStorageKey: modeStorageKey = $0bbf403053a228ec$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $0bbf403053a228ec$export$665054ea9d94dab9, attribute: attribute = $0bbf403053a228ec$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = "document.documentElement", nonce: nonce } = options || {};
    return /*#__PURE__*/ (0, $6iAGf.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === "undefined" ? nonce : "",
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  var mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  var colorScheme = '';
  if (mode === 'system') {
    // handle system mode
    var mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
    } else {
      colorScheme = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
    }
  }
  if (mode === 'light') {
    colorScheme = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  }
  if (mode === 'dark') {
    colorScheme = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  }
  if (colorScheme) {
    ${colorSchemeNode}.setAttribute('${attribute}', colorScheme);
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}



var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");

"use client";
function $c1dbc2b3552be791$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== "undefined" && mode === "system") {
        const mql = window.matchMedia("(prefers-color-scheme: dark)");
        if (mql.matches) return "dark";
        return "light";
    }
    return undefined;
}
function $c1dbc2b3552be791$var$processState(state, callback) {
    if (state.mode === "light" || state.mode === "system" && state.systemMode === "light") return callback("light");
    if (state.mode === "dark" || state.mode === "system" && state.systemMode === "dark") return callback("dark");
    return undefined;
}
function $c1dbc2b3552be791$export$3caa7590cc1987bd(state) {
    return $c1dbc2b3552be791$var$processState(state, (mode)=>{
        if (mode === "light") return state.lightColorScheme;
        if (mode === "dark") return state.darkColorScheme;
        return undefined;
    });
}
function $c1dbc2b3552be791$var$initializeValue(key, defaultValue) {
    if (typeof window === "undefined") return undefined;
    let value;
    try {
        value = localStorage.getItem(key) || undefined;
        if (!value) // the first time that user enters the site.
        localStorage.setItem(key, defaultValue);
    } catch (e) {
    // Unsupported
    }
    return value || defaultValue;
}
function $c1dbc2b3552be791$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = "light", defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $0bbf403053a228ec$export$ff0fa3047d11164c), colorSchemeStorageKey: colorSchemeStorageKey = (0, $0bbf403053a228ec$export$665054ea9d94dab9), storageWindow: storageWindow = typeof window === "undefined" ? undefined : window } = options;
    const joinedColorSchemes = supportedColorSchemes.join(",");
    const [state, setState] = $1EuC8.useState(()=>{
        const initialMode = $c1dbc2b3552be791$var$initializeValue(modeStorageKey, defaultMode);
        const lightColorScheme = $c1dbc2b3552be791$var$initializeValue(`${colorSchemeStorageKey}-light`, defaultLightColorScheme);
        const darkColorScheme = $c1dbc2b3552be791$var$initializeValue(`${colorSchemeStorageKey}-dark`, defaultDarkColorScheme);
        return {
            mode: initialMode,
            systemMode: $c1dbc2b3552be791$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const colorScheme = $c1dbc2b3552be791$export$3caa7590cc1987bd(state);
    const setMode = $1EuC8.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode != null ? mode : defaultMode;
            try {
                localStorage.setItem(modeStorageKey, newMode);
            } catch (e) {
            // Unsupported
            }
            return (0, $cPOSH.default)({}, currentState, {
                mode: newMode,
                systemMode: $c1dbc2b3552be791$export$ab3d447356dfa3e5(newMode)
            });
        });
    }, [
        modeStorageKey,
        defaultMode
    ]);
    const setColorScheme = $1EuC8.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            try {
                localStorage.setItem(`${colorSchemeStorageKey}-light`, defaultLightColorScheme);
                localStorage.setItem(`${colorSchemeStorageKey}-dark`, defaultDarkColorScheme);
            } catch (e) {
            // Unsupported
            }
            return (0, $cPOSH.default)({}, currentState, {
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            });
        });
        else if (typeof value === "string") {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = (0, $cPOSH.default)({}, currentState);
                $c1dbc2b3552be791$var$processState(currentState, (mode)=>{
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-${mode}`, value);
                    } catch (e) {
                    // Unsupported
                    }
                    if (mode === "light") newState.lightColorScheme = value;
                    if (mode === "dark") newState.darkColorScheme = value;
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = (0, $cPOSH.default)({}, currentState);
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-light`, newLightColorScheme);
                    } catch (error) {
                    // Unsupported
                    }
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-dark`, newDarkColorScheme);
                    } catch (error) {
                    // Unsupported
                    }
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        colorSchemeStorageKey,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $1EuC8.useCallback((event)=>{
        if (state.mode === "system") setState((currentState)=>{
            const systemMode = event != null && event.matches ? "dark" : "light";
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return (0, $cPOSH.default)({}, currentState, {
                systemMode: systemMode
            });
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $1EuC8.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $1EuC8.useEffect(()=>{
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia("(prefers-color-scheme: dark)");
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, []);
    // Handle when localStorage has changed
    $1EuC8.useEffect(()=>{
        if (storageWindow) {
            const handleStorage = (event)=>{
                const value = event.newValue;
                if (typeof event.key === "string" && event.key.startsWith(colorSchemeStorageKey) && (!value || joinedColorSchemes.match(value))) {
                    // If the key is deleted, value will be null then reset color scheme to the default one.
                    if (event.key.endsWith("light")) setColorScheme({
                        light: value
                    });
                    if (event.key.endsWith("dark")) setColorScheme({
                        dark: value
                    });
                }
                if (event.key === modeStorageKey && (!value || [
                    "light",
                    "dark",
                    "system"
                ].includes(value))) setMode(value || defaultMode);
            };
            // For syncing color-scheme changes between iframes
            storageWindow.addEventListener("storage", handleStorage);
            return ()=>{
                storageWindow.removeEventListener("storage", handleStorage);
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        modeStorageKey,
        colorSchemeStorageKey,
        joinedColorSchemes,
        defaultMode,
        storageWindow
    ]);
    return (0, $cPOSH.default)({}, state, {
        colorScheme: colorScheme,
        setMode: setMode,
        setColorScheme: setColorScheme
    });
}



var $6iAGf = parcelRequire("6iAGf");
const $8cf81ff17303da8e$var$_excluded = [
    "colorSchemes",
    "components",
    "generateCssVars",
    "cssVarPrefix"
];
const $8cf81ff17303da8e$export$c09f426c4535c3ec = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function $8cf81ff17303da8e$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, attribute: defaultAttribute = (0, $0bbf403053a228ec$export$14ebe5b26ee7fb38), modeStorageKey: defaultModeStorageKey = (0, $0bbf403053a228ec$export$ff0fa3047d11164c), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $0bbf403053a228ec$export$665054ea9d94dab9), defaultMode: designSystemMode = "light", defaultColorScheme: designSystemColorScheme, disableTransitionOnChange: designSystemTransitionOnChange = false, resolveTheme: resolveTheme, excludeVariablesFromRoot: excludeVariablesFromRoot } = options;
    if (!defaultTheme.colorSchemes || typeof designSystemColorScheme === "string" && !defaultTheme.colorSchemes[designSystemColorScheme] || typeof designSystemColorScheme === "object" && !defaultTheme.colorSchemes[designSystemColorScheme == null ? void 0 : designSystemColorScheme.light] || typeof designSystemColorScheme === "object" && !defaultTheme.colorSchemes[designSystemColorScheme == null ? void 0 : designSystemColorScheme.dark]) console.error(`MUI: \`${designSystemColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
    const ColorSchemeContext = /*#__PURE__*/ $1EuC8.createContext(undefined);
    const useColorScheme = ()=>{
        const value = $1EuC8.useContext(ColorSchemeContext);
        if (!value) throw new Error((0, $49nsw.default)(19));
        return value;
    };
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp = defaultTheme, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, attribute: attribute = defaultAttribute, defaultMode: defaultMode = designSystemMode, defaultColorScheme: defaultColorScheme = designSystemColorScheme, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageWindow: storageWindow = typeof window === "undefined" ? undefined : window, documentNode: documentNode = typeof document === "undefined" ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === "undefined" ? undefined : document.documentElement, colorSchemeSelector: colorSchemeSelector = ":root", disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false } = props;
        const hasMounted = $1EuC8.useRef(false);
        const upperTheme = (0, $713f7eb23f06e717$export$2e2bcd8739ae039)();
        const ctx = $1EuC8.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const scopedTheme = themeProp[themeId];
        const _ref = scopedTheme || themeProp, { colorSchemes: colorSchemes = {}, components: components = {}, generateCssVars: generateCssVars = ()=>({
                vars: {},
                css: {}
            }), cssVarPrefix: cssVarPrefix } = _ref, restThemeProp = (0, $aT5bD.default)(_ref, $8cf81ff17303da8e$var$_excluded);
        const allColorSchemes = Object.keys(colorSchemes);
        const defaultLightColorScheme = typeof defaultColorScheme === "string" ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === "string" ? defaultColorScheme : defaultColorScheme.dark;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $c1dbc2b3552be791$export$2e2bcd8739ae039)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageWindow: storageWindow
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        const calculatedMode = (()=>{
            if (mode) return mode;
            // This scope occurs on the server
            if (defaultMode === "system") return designSystemMode;
            return defaultMode;
        })();
        const calculatedColorScheme = (()=>{
            if (!colorScheme) {
                // This scope occurs on the server
                if (calculatedMode === "dark") return defaultDarkColorScheme;
                // use light color scheme, if default mode is 'light' | 'system'
                return defaultLightColorScheme;
            }
            return colorScheme;
        })();
        // 2. Create CSS variables and store them in objects (to be generated in stylesheets in the final step)
        const { css: rootCss, vars: rootVars } = generateCssVars();
        // 3. Start composing the theme object
        const theme = (0, $cPOSH.default)({}, restThemeProp, {
            components: components,
            colorSchemes: colorSchemes,
            cssVarPrefix: cssVarPrefix,
            vars: rootVars,
            getColorSchemeSelector: (targetColorScheme)=>`[${attribute}="${targetColorScheme}"] &`
        });
        // 4. Create color CSS variables and store them in objects (to be generated in stylesheets in the final step)
        //    The default color scheme stylesheet is constructed to have the least CSS specificity.
        //    The other color schemes uses selector, default as data attribute, to increase the CSS specificity so that they can override the default color scheme stylesheet.
        const defaultColorSchemeStyleSheet = {};
        const otherColorSchemesStyleSheet = {};
        Object.entries(colorSchemes).forEach(([key, scheme])=>{
            const { css: css, vars: vars } = generateCssVars(key);
            theme.vars = (0, $i5l0f.default)(theme.vars, vars);
            if (key === calculatedColorScheme) {
                // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === "object") // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = (0, $cPOSH.default)({}, theme[schemeKey], scheme[schemeKey]);
                    else theme[schemeKey] = scheme[schemeKey];
                });
                if (theme.palette) theme.palette.colorScheme = key;
            }
            const resolvedDefaultColorScheme = (()=>{
                if (typeof defaultColorScheme === "string") return defaultColorScheme;
                if (defaultMode === "dark") return defaultColorScheme.dark;
                return defaultColorScheme.light;
            })();
            if (key === resolvedDefaultColorScheme) {
                if (excludeVariablesFromRoot) {
                    const excludedVariables = {};
                    excludeVariablesFromRoot(cssVarPrefix).forEach((cssVar)=>{
                        excludedVariables[cssVar] = css[cssVar];
                        delete css[cssVar];
                    });
                    defaultColorSchemeStyleSheet[`[${attribute}="${key}"]`] = excludedVariables;
                }
                defaultColorSchemeStyleSheet[`${colorSchemeSelector}, [${attribute}="${key}"]`] = css;
            } else otherColorSchemesStyleSheet[`${colorSchemeSelector === ":root" ? "" : colorSchemeSelector}[${attribute}="${key}"]`] = css;
        });
        theme.vars = (0, $i5l0f.default)(theme.vars, rootVars);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        $1EuC8.useEffect(()=>{
            if (colorScheme && colorSchemeNode) // attaches attribute to <html> because the css variables are attached to :root (html)
            colorSchemeNode.setAttribute(attribute, colorScheme);
        }, [
            colorScheme,
            attribute,
            colorSchemeNode
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $1EuC8.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement("style");
                css.appendChild(documentNode.createTextNode($8cf81ff17303da8e$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $1EuC8.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $1EuC8.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || nested && (upperTheme == null ? void 0 : upperTheme.cssVarPrefix) === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $6iAGf.jsxs)($1EuC8.Fragment, {
            children: [
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $6iAGf.jsxs)($1EuC8.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $6iAGf.jsx)((0, $kzzTv.default), {
                            styles: {
                                [colorSchemeSelector]: rootCss
                            }
                        }),
                        /*#__PURE__*/ (0, $6iAGf.jsx)((0, $kzzTv.default), {
                            styles: defaultColorSchemeStyleSheet
                        }),
                        /*#__PURE__*/ (0, $6iAGf.jsx)((0, $kzzTv.default), {
                            styles: otherColorSchemesStyleSheet
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c921fd42c44cb580$export$2e2bcd8739ae039), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: resolveTheme ? resolveTheme(theme) : theme,
                    children: children
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $6iAGf.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof designSystemColorScheme === "string" ? designSystemColorScheme : designSystemColorScheme.light;
    const defaultDarkColorScheme = typeof designSystemColorScheme === "string" ? designSystemColorScheme : designSystemColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $0bbf403053a228ec$export$2e2bcd8739ae039)((0, $cPOSH.default)({
            attribute: defaultAttribute,
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultMode: designSystemMode,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey
        }, params));
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}



var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");

var $i5l0f = parcelRequire("i5l0f");

var $49nsw = parcelRequire("49nsw");

var $3LZgY = parcelRequire("3LZgY");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $112c38b294022bf0$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $3LZgY.default)(value, min, max);
}
function $112c38b294022bf0$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $112c38b294022bf0$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $112c38b294022bf0$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $112c38b294022bf0$export$677b39864803984e($112c38b294022bf0$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $49nsw.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $49nsw.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $112c38b294022bf0$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $112c38b294022bf0$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $112c38b294022bf0$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $112c38b294022bf0$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $112c38b294022bf0$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $112c38b294022bf0$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $112c38b294022bf0$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$112c38b294022bf0$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $112c38b294022bf0$export$29fb7152bd3f781a(color) {
    color = $112c38b294022bf0$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $112c38b294022bf0$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $112c38b294022bf0$export$c852d90bf7403b62(color) {
    color = $112c38b294022bf0$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $112c38b294022bf0$export$677b39864803984e($112c38b294022bf0$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $112c38b294022bf0$export$d061e26956a60b0a(foreground, background) {
    const lumA = $112c38b294022bf0$export$c852d90bf7403b62(foreground);
    const lumB = $112c38b294022bf0$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $112c38b294022bf0$export$58f0f39f63f3cf42(color, value) {
    color = $112c38b294022bf0$export$677b39864803984e(color);
    value = $112c38b294022bf0$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $112c38b294022bf0$export$211a73f2b8c10ce4(color);
}
function $112c38b294022bf0$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $112c38b294022bf0$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $112c38b294022bf0$export$4b073707ff63303(color, coefficient) {
    color = $112c38b294022bf0$export$677b39864803984e(color);
    coefficient = $112c38b294022bf0$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $112c38b294022bf0$export$211a73f2b8c10ce4(color);
}
function $112c38b294022bf0$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $112c38b294022bf0$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $112c38b294022bf0$export$c0816ed86df316af(color, coefficient) {
    color = $112c38b294022bf0$export$677b39864803984e(color);
    coefficient = $112c38b294022bf0$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $112c38b294022bf0$export$211a73f2b8c10ce4(color);
}
function $112c38b294022bf0$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $112c38b294022bf0$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $112c38b294022bf0$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $112c38b294022bf0$export$c852d90bf7403b62(color) > 0.5 ? $112c38b294022bf0$export$4b073707ff63303(color, coefficient) : $112c38b294022bf0$export$c0816ed86df316af(color, coefficient);
}
function $112c38b294022bf0$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $112c38b294022bf0$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $112c38b294022bf0$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $112c38b294022bf0$export$677b39864803984e(background);
    const overlayColor = $112c38b294022bf0$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $112c38b294022bf0$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}


var $6N804 = parcelRequire("6N804");
var $edNcL = parcelRequire("edNcL");/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $fda71d8a719249a8$export$2e2bcd8739ae039(prefix = "") {
    function appendVar(...vars) {
        if (!vars.length) return "";
        const value = vars[0];
        if (typeof value === "string" && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ""}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ""}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}


var $cPOSH = parcelRequire("cPOSH");
function $89d65d2600fe8e72$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $89d65d2600fe8e72$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $89d65d2600fe8e72$export$2e2bcd8739ae039(o);
}



function $f1b7d48843c8df39$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $89d65d2600fe8e72$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $89d65d2600fe8e72$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $d48bcf077432478b$export$2e2bcd8739ae039(t) {
    var i = (0, $f1b7d48843c8df39$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $89d65d2600fe8e72$export$2e2bcd8739ae039)(i) ? i : i + "";
}



var $aT5bD = parcelRequire("aT5bD");

var $i5l0f = parcelRequire("i5l0f");
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $4f926f41ff70355a$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === "object") temp[k] = value;
        } else if (temp && typeof temp === "object") {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $4f926f41ff70355a$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === "object" && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $4f926f41ff70355a$var$getCssValue = (keys, value)=>{
    if (typeof value === "number") {
        if ([
            "lineHeight",
            "fontWeight",
            "opacity",
            "zIndex"
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().indexOf("opacity") >= 0) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $4f926f41ff70355a$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $4f926f41ff70355a$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === "string" || typeof value === "number") {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ""}${keys.join("-")}`;
                Object.assign(css, {
                    [cssVar]: $4f926f41ff70355a$var$getCssValue(keys, value)
                });
                $4f926f41ff70355a$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $4f926f41ff70355a$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${value})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === "vars" // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}


const $d78034c4c3d15967$var$_excluded = [
    "colorSchemes",
    "components",
    "defaultColorScheme"
];
function $d78034c4c3d15967$var$prepareCssVars(theme, parserConfig) {
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, defaultColorScheme: defaultColorScheme = "light" } = theme, otherTheme = (0, $aT5bD.default)(theme, $d78034c4c3d15967$var$_excluded);
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $4f926f41ff70355a$export$2e2bcd8739ae039)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: light } = colorSchemes, otherColorSchemes = (0, $aT5bD.default)(colorSchemes, [
        defaultColorScheme
    ].map((0, $d48bcf077432478b$export$2e2bcd8739ae039)));
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $4f926f41ff70355a$export$2e2bcd8739ae039)(scheme, parserConfig);
        themeVars = (0, $i5l0f.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (light) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $4f926f41ff70355a$export$2e2bcd8739ae039)(light, parserConfig);
        themeVars = (0, $i5l0f.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    const generateCssVars = (colorScheme)=>{
        var _parserConfig$getSele2;
        if (!colorScheme) {
            var _parserConfig$getSele;
            const css = (0, $cPOSH.default)({}, rootCss);
            return {
                css: css,
                vars: rootVars,
                selector: (parserConfig == null || (_parserConfig$getSele = parserConfig.getSelector) == null ? void 0 : _parserConfig$getSele.call(parserConfig, colorScheme, css)) || ":root"
            };
        }
        const css = (0, $cPOSH.default)({}, colorSchemesMap[colorScheme].css);
        return {
            css: css,
            vars: colorSchemesMap[colorScheme].vars,
            selector: (parserConfig == null || (_parserConfig$getSele2 = parserConfig.getSelector) == null ? void 0 : _parserConfig$getSele2.call(parserConfig, colorScheme, css)) || ":root"
        };
    };
    return {
        vars: themeVars,
        generateCssVars: generateCssVars
    };
}
var $d78034c4c3d15967$export$2e2bcd8739ae039 = $d78034c4c3d15967$var$prepareCssVars;


var $cLzOx = parcelRequire("cLzOx");

var $cPOSH = parcelRequire("cPOSH");

var $6Pmr1 = parcelRequire("6Pmr1");
const $5efe951f88c39f81$var$sxConfig = (0, $cPOSH.default)({}, (0, $6Pmr1.default), {
    // The default system themeKey is shape
    borderRadius: {
        themeKey: "radius"
    },
    // The default system themeKey is shadows
    boxShadow: {
        themeKey: "shadow"
    },
    // The default system themeKey is typography
    fontFamily: {
        themeKey: "fontFamily"
    },
    // The default system themeKey is typography
    fontSize: {
        themeKey: "fontSize"
    },
    // The default system themeKey is typography
    fontWeight: {
        themeKey: "fontWeight"
    },
    // The default system themeKey is typography
    letterSpacing: {
        themeKey: "letterSpacing"
    },
    // The default system themeKey is typography
    lineHeight: {
        themeKey: "lineHeight"
    }
});
var $5efe951f88c39f81$export$2e2bcd8739ae039 = $5efe951f88c39f81$var$sxConfig;


const $8bd845dd04c3d933$var$colors = {
    grey: {
        50: "#F7F7F8",
        100: "#EBEBEF",
        200: "#D8D8DF",
        300: "#B9B9C6",
        400: "#8F8FA3",
        500: "#73738C",
        600: "#5A5A72",
        700: "#434356",
        800: "#25252D",
        900: "#131318"
    },
    blue: {
        50: "#F4FAFF",
        100: "#DDF1FF",
        200: "#ADDBFF",
        300: "#6FB6FF",
        400: "#3990FF",
        500: "#096BDE",
        600: "#054DA7",
        700: "#02367D",
        800: "#072859",
        900: "#00153C"
    },
    yellow: {
        50: "#FFF8C5",
        100: "#FAE17D",
        200: "#EAC54F",
        300: "#D4A72C",
        400: "#BF8700",
        500: "#9A6700",
        600: "#7D4E00",
        700: "#633C01",
        800: "#4D2D00",
        900: "#3B2300"
    },
    red: {
        50: "#FFF8F6",
        100: "#FFE9E8",
        200: "#FFC7C5",
        300: "#FF9192",
        400: "#FA5255",
        500: "#D3232F",
        600: "#A10E25",
        700: "#77061B",
        800: "#580013",
        900: "#39000D"
    },
    green: {
        50: "#F3FEF5",
        100: "#D7F5DD",
        200: "#77EC95",
        300: "#4CC76E",
        400: "#2CA24D",
        500: "#1A7D36",
        600: "#0F5D26",
        700: "#034318",
        800: "#002F0F",
        900: "#001D09"
    },
    purple: {
        50: "#FDF7FF",
        100: "#F4EAFF",
        200: "#E1CBFF",
        300: "#C69EFF",
        400: "#A374F9",
        500: "#814DDE",
        600: "#5F35AE",
        700: "#452382",
        800: "#301761",
        900: "#1D0A42"
    }
};
var $8bd845dd04c3d933$export$2e2bcd8739ae039 = $8bd845dd04c3d933$var$colors;


function $a4075eb2a48354bd$export$2e2bcd8739ae039(keys) {
    var _keys$;
    return !!keys[0].match(/^(typography|variants|breakpoints|colorInversion|colorInversionConfig)$/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === "palette" && !!((_keys$ = keys[1]) != null && _keys$.match(/^(mode)$/)) || keys[0] === "focus" && keys[1] !== "thickness";
}



var $ar8ZD = parcelRequire("ar8ZD");
var $2jicN = parcelRequire("2jicN");
var $58RS4 = parcelRequire("58RS4");
const $bd48de20fb876697$export$1d132570e11858b0 = (componentName, slot)=>(0, $2jicN.default)(componentName, slot, "Joy");
const $bd48de20fb876697$export$de4f15803c389669 = (componentName, slots)=>(0, $58RS4.default)(componentName, slots, "Joy");



var $cPOSH = parcelRequire("cPOSH");

const $8bb3a7873572990d$export$67cb6fb2dce0d42c = (colorPalette)=>colorPalette && typeof colorPalette === "object" && Object.keys(colorPalette).some((value)=>{
        var _value$match;
        return (_value$match = value.match) == null ? void 0 : _value$match.call(value, /^(plain(Hover|Active|Disabled)?(Color|Bg)|outlined(Hover|Active|Disabled)?(Color|Border|Bg)|soft(Hover|Active|Disabled)?(Color|Bg)|solid(Hover|Active|Disabled)?(Color|Bg))$/);
    });
const $8bb3a7873572990d$var$assignCss = (target, variantVar, value)=>{
    if (variantVar.includes("Color")) target.color = value;
    if (variantVar.includes("Bg")) target.backgroundColor = value;
    if (variantVar.includes("Border")) target.borderColor = value;
};
const $8bb3a7873572990d$export$3e5fa1738702067e = (name, palette, getCssVar)=>{
    const result = {};
    Object.entries(palette || {}).forEach(([variantVar, value])=>{
        if (variantVar.match(new RegExp(`${name}(color|bg|border)`, "i")) && !!value) {
            const cssVar = getCssVar ? getCssVar(variantVar) : value;
            if (variantVar.includes("Disabled")) {
                result.pointerEvents = "none";
                result.cursor = "default";
            }
            if (variantVar.match(/(Hover|Active|Disabled)/)) $8bb3a7873572990d$var$assignCss(result, variantVar, cssVar);
            else {
                // initial state
                if (!result["--variant-borderWidth"]) // important to prevent inheritance, otherwise the children will have the wrong styles e.g.
                //   <Card variant="outlined">
                //     <Typography variant="soft">
                result["--variant-borderWidth"] = "0px";
                if (variantVar.includes("Border")) {
                    result["--variant-borderWidth"] = "1px";
                    result.border = "var(--variant-borderWidth) solid";
                }
                // border color should come later
                $8bb3a7873572990d$var$assignCss(result, variantVar, cssVar);
            }
        }
    });
    return result;
};
const $8bb3a7873572990d$var$createPrefixVar = (cssVarPrefix)=>{
    return (cssVar)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ""}${cssVar.replace(/^--/, "")}`;
};
const $8bb3a7873572990d$export$acb4c136ee475234 = (variant, theme)=>{
    let result = {};
    if (theme) {
        const { getCssVar: getCssVar, palette: palette } = theme;
        Object.entries(palette).forEach((entry)=>{
            const [color, colorPalette] = entry;
            if ($8bb3a7873572990d$export$67cb6fb2dce0d42c(colorPalette) && typeof colorPalette === "object") result = (0, $cPOSH.default)({}, result, {
                [color]: $8bb3a7873572990d$export$3e5fa1738702067e(variant, colorPalette, (variantVar)=>getCssVar(`palette-${color}-${variantVar}`, palette[color][variantVar]))
            });
        });
    }
    result.context = $8bb3a7873572990d$export$3e5fa1738702067e(variant, {
        plainColor: "var(--variant-plainColor)",
        plainHoverColor: `var(--variant-plainHoverColor)`,
        plainHoverBg: "var(--variant-plainHoverBg)",
        plainActiveBg: "var(--variant-plainActiveBg)",
        plainDisabledColor: "var(--variant-plainDisabledColor)",
        outlinedColor: "var(--variant-outlinedColor)",
        outlinedBorder: "var(--variant-outlinedBorder)",
        outlinedHoverColor: `var(--variant-outlinedHoverColor)`,
        outlinedHoverBorder: `var(--variant-outlinedHoverBorder)`,
        outlinedHoverBg: `var(--variant-outlinedHoverBg)`,
        outlinedActiveBg: `var(--variant-outlinedActiveBg)`,
        outlinedDisabledColor: `var(--variant-outlinedDisabledColor)`,
        outlinedDisabledBorder: `var(--variant-outlinedDisabledBorder)`,
        softColor: "var(--variant-softColor)",
        softBg: "var(--variant-softBg)",
        softHoverColor: "var(--variant-softHoverColor)",
        softHoverBg: "var(--variant-softHoverBg)",
        softActiveBg: "var(--variant-softActiveBg)",
        softDisabledColor: "var(--variant-softDisabledColor)",
        softDisabledBg: "var(--variant-softDisabledBg)",
        solidColor: "var(--variant-solidColor)",
        solidBg: "var(--variant-solidBg)",
        solidHoverColor: "var(--variant-solidHoverColor)",
        solidHoverBg: "var(--variant-solidHoverBg)",
        solidActiveBg: "var(--variant-solidActiveBg)",
        solidDisabledColor: "var(--variant-solidDisabledColor)",
        solidDisabledBg: "var(--variant-solidDisabledBg)"
    });
    return result;
};
const $8bb3a7873572990d$export$76ac256e9decb5cc = (theme, addDefaultValues)=>{
    const getCssVarDefault = (0, $fda71d8a719249a8$export$2e2bcd8739ae039)(theme.cssVarPrefix);
    const prefixVar = $8bb3a7873572990d$var$createPrefixVar(theme.cssVarPrefix);
    const result = {};
    const getCssVar = addDefaultValues ? (cssVar)=>{
        var _theme$palette;
        const tokens = cssVar.split("-");
        const color = tokens[1];
        const value = tokens[2];
        return getCssVarDefault(cssVar, (_theme$palette = theme.palette) == null || (_theme$palette = _theme$palette[color]) == null ? void 0 : _theme$palette[value]);
    } : getCssVarDefault;
    Object.entries(theme.palette).forEach((entry)=>{
        const [color, colorPalette] = entry;
        if ($8bb3a7873572990d$export$67cb6fb2dce0d42c(colorPalette)) result[color] = {
            "--Badge-ringColor": getCssVar(`palette-${color}-softBg`),
            [prefixVar("--shadowChannel")]: getCssVar(`palette-${color}-darkChannel`),
            [theme.getColorSchemeSelector("dark")]: {
                [prefixVar("--palette-focusVisible")]: getCssVar(`palette-${color}-300`),
                [prefixVar("--palette-background-body")]: `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.1)`,
                [prefixVar("--palette-background-surface")]: `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.08)`,
                [prefixVar("--palette-background-level1")]: `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.2)`,
                [prefixVar("--palette-background-level2")]: `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.4)`,
                [prefixVar("--palette-background-level3")]: `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.6)`,
                [prefixVar("--palette-text-primary")]: getCssVar(`palette-${color}-100`),
                [prefixVar("--palette-text-secondary")]: `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.72)`,
                [prefixVar("--palette-text-tertiary")]: `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.6)`,
                [prefixVar("--palette-divider")]: `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.2)`,
                "--variant-plainColor": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 1)`,
                "--variant-plainHoverColor": getCssVar(`palette-${color}-50`),
                "--variant-plainHoverBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.16)`,
                "--variant-plainActiveBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.32)`,
                "--variant-plainDisabledColor": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.72)`,
                "--variant-outlinedColor": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 1)`,
                "--variant-outlinedHoverColor": getCssVar(`palette-${color}-50`),
                "--variant-outlinedBg": "initial",
                "--variant-outlinedBorder": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.4)`,
                "--variant-outlinedHoverBorder": getCssVar(`palette-${color}-600`),
                "--variant-outlinedHoverBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.16)`,
                "--variant-outlinedActiveBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.32)`,
                "--variant-outlinedDisabledColor": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.72)`,
                "--variant-outlinedDisabledBorder": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.2)`,
                "--variant-softColor": getCssVar(`palette-${color}-100`),
                "--variant-softBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.24)`,
                "--variant-softHoverColor": "#fff",
                "--variant-softHoverBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.32)`,
                "--variant-softActiveBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.48)`,
                "--variant-softDisabledColor": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.72)`,
                "--variant-softDisabledBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.12)`,
                "--variant-solidColor": "#fff",
                "--variant-solidBg": getCssVar(`palette-${color}-500`),
                "--variant-solidHoverColor": "#fff",
                "--variant-solidHoverBg": getCssVar(`palette-${color}-400`),
                "--variant-solidActiveBg": getCssVar(`palette-${color}-400`),
                "--variant-solidDisabledColor": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.72)`,
                "--variant-solidDisabledBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.12)`
            },
            // `light` (default color scheme) should come last in case that `theme.getColorSchemeSelector()` return the same value
            [theme.getColorSchemeSelector("light")]: {
                [prefixVar("--palette-focusVisible")]: getCssVar(`palette-${color}-500`),
                [prefixVar("--palette-background-body")]: `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.1)`,
                [prefixVar("--palette-background-surface")]: `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.08)`,
                [prefixVar("--palette-background-level1")]: `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.2)`,
                [prefixVar("--palette-background-level2")]: `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.32)`,
                [prefixVar("--palette-background-level3")]: `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.48)`,
                [prefixVar("--palette-text-primary")]: getCssVar(`palette-${color}-700`),
                [prefixVar("--palette-text-secondary")]: `rgba(${getCssVar(`palette-${color}-darkChannel`)} / 0.8)`,
                [prefixVar("--palette-text-tertiary")]: `rgba(${getCssVar(`palette-${color}-darkChannel`)} / 0.68)`,
                [prefixVar("--palette-divider")]: `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.32)`,
                "--variant-plainColor": `rgba(${getCssVar(`palette-${color}-darkChannel`)} / 0.8)`,
                "--variant-plainHoverColor": `rgba(${getCssVar(`palette-${color}-darkChannel`)} / 1)`,
                "--variant-plainHoverBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.12)`,
                "--variant-plainActiveBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.24)`,
                "--variant-plainDisabledColor": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.6)`,
                "--variant-outlinedColor": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 1)`,
                "--variant-outlinedBorder": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.4)`,
                "--variant-outlinedHoverColor": getCssVar(`palette-${color}-600`),
                "--variant-outlinedHoverBorder": getCssVar(`palette-${color}-300`),
                "--variant-outlinedHoverBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.12)`,
                "--variant-outlinedActiveBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.24)`,
                "--variant-outlinedDisabledColor": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.6)`,
                "--variant-outlinedDisabledBorder": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.12)`,
                "--variant-softColor": getCssVar(`palette-${color}-600`),
                "--variant-softBg": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.72)`,
                "--variant-softHoverColor": getCssVar(`palette-${color}-700`),
                "--variant-softHoverBg": getCssVar(`palette-${color}-200`),
                "--variant-softActiveBg": getCssVar(`palette-${color}-300`),
                "--variant-softDisabledColor": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.6)`,
                "--variant-softDisabledBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.08)`,
                "--variant-solidColor": getCssVar("palette-common-white"),
                "--variant-solidBg": getCssVar(`palette-${color}-600`),
                "--variant-solidHoverColor": getCssVar("palette-common-white"),
                "--variant-solidHoverBg": getCssVar(`palette-${color}-500`),
                "--variant-solidActiveBg": getCssVar(`palette-${color}-500`),
                "--variant-solidDisabledColor": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.6)`,
                "--variant-solidDisabledBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.08)`
            }
        };
    });
    return result;
};
const $8bb3a7873572990d$export$785f1b9b17061606 = (theme, addDefaultValues)=>{
    const getCssVarDefault = (0, $fda71d8a719249a8$export$2e2bcd8739ae039)(theme.cssVarPrefix);
    const prefixVar = $8bb3a7873572990d$var$createPrefixVar(theme.cssVarPrefix);
    const result = {};
    const getCssVar = addDefaultValues ? (cssVar)=>{
        const tokens = cssVar.split("-");
        const color = tokens[1];
        const value = tokens[2];
        return getCssVarDefault(cssVar, theme.palette[color][value]);
    } : getCssVarDefault;
    Object.entries(theme.palette).forEach((entry)=>{
        const [color, colorPalette] = entry;
        if ($8bb3a7873572990d$export$67cb6fb2dce0d42c(colorPalette)) {
            if (color === "warning") result.warning = {
                "--Badge-ringColor": getCssVar(`palette-${color}-solidBg`),
                [prefixVar("--shadowChannel")]: getCssVar(`palette-${color}-darkChannel`),
                [prefixVar("--palette-focusVisible")]: getCssVar(`palette-${color}-700`),
                [prefixVar("--palette-background-body")]: `rgba(${getCssVar(`palette-${color}-darkChannel`)} / 0.16)`,
                [prefixVar("--palette-background-surface")]: `rgba(${getCssVar(`palette-${color}-darkChannel`)} / 0.1)`,
                [prefixVar("--palette-background-popup")]: getCssVar(`palette-${color}-100`),
                [prefixVar("--palette-background-level1")]: `rgba(${getCssVar(`palette-${color}-darkChannel`)} / 0.2)`,
                [prefixVar("--palette-background-level2")]: `rgba(${getCssVar(`palette-${color}-darkChannel`)} / 0.36)`,
                [prefixVar("--palette-background-level3")]: `rgba(${getCssVar(`palette-${color}-darkChannel`)} / 0.6)`,
                [prefixVar("--palette-text-primary")]: getCssVar(`palette-${color}-900`),
                [prefixVar("--palette-text-secondary")]: getCssVar(`palette-${color}-700`),
                [prefixVar("--palette-text-tertiary")]: getCssVar(`palette-${color}-500`),
                [prefixVar("--palette-divider")]: `rgba(${getCssVar(`palette-${color}-darkChannel`)} / 0.2)`,
                "--variant-plainColor": getCssVar(`palette-${color}-700`),
                "--variant-plainHoverColor": getCssVar(`palette-${color}-800`),
                "--variant-plainHoverBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.12)`,
                "--variant-plainActiveBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.32)`,
                "--variant-plainDisabledColor": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.72)`,
                "--variant-outlinedColor": getCssVar(`palette-${color}-700`),
                "--variant-outlinedBorder": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.5)`,
                "--variant-outlinedHoverColor": getCssVar(`palette-${color}-800`),
                "--variant-outlinedHoverBorder": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.6)`,
                "--variant-outlinedHoverBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.12)`,
                "--variant-outlinedActiveBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.32)`,
                "--variant-outlinedDisabledColor": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.72)`,
                "--variant-outlinedDisabledBorder": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.2)`,
                "--variant-softColor": getCssVar(`palette-${color}-800`),
                "--variant-softHoverColor": getCssVar(`palette-${color}-900`),
                "--variant-softBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.2)`,
                "--variant-softHoverBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.28)`,
                "--variant-softActiveBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.12)`,
                "--variant-softDisabledColor": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.72)`,
                "--variant-softDisabledBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.08)`,
                "--variant-solidColor": "#fff",
                "--variant-solidBg": getCssVar(`palette-${color}-600`),
                "--variant-solidHoverColor": "#fff",
                "--variant-solidHoverBg": getCssVar(`palette-${color}-700`),
                "--variant-solidActiveBg": getCssVar(`palette-${color}-800`),
                "--variant-solidDisabledColor": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.72)`,
                "--variant-solidDisabledBg": `rgba(${getCssVar(`palette-${color}-mainChannel`)} / 0.08)`
            };
            else result[color] = {
                colorScheme: "dark",
                "--Badge-ringColor": getCssVar(`palette-${color}-solidBg`),
                [prefixVar("--shadowChannel")]: getCssVar(`palette-${color}-darkChannel`),
                [prefixVar("--palette-focusVisible")]: getCssVar(`palette-${color}-200`),
                [prefixVar("--palette-background-body")]: "rgba(0 0 0 / 0.1)",
                [prefixVar("--palette-background-surface")]: "rgba(0 0 0 / 0.06)",
                [prefixVar("--palette-background-popup")]: getCssVar(`palette-${color}-700`),
                [prefixVar("--palette-background-level1")]: `rgba(${getCssVar(`palette-${color}-darkChannel`)} / 0.2)`,
                [prefixVar("--palette-background-level2")]: `rgba(${getCssVar(`palette-${color}-darkChannel`)} / 0.36)`,
                [prefixVar("--palette-background-level3")]: `rgba(${getCssVar(`palette-${color}-darkChannel`)} / 0.6)`,
                [prefixVar("--palette-text-primary")]: getCssVar(`palette-common-white`),
                [prefixVar("--palette-text-secondary")]: getCssVar(`palette-${color}-100`),
                [prefixVar("--palette-text-tertiary")]: getCssVar(`palette-${color}-200`),
                [prefixVar("--palette-divider")]: `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.32)`,
                "--variant-plainColor": getCssVar(`palette-${color}-50`),
                "--variant-plainHoverColor": `#fff`,
                "--variant-plainHoverBg": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.12)`,
                "--variant-plainActiveBg": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.32)`,
                "--variant-plainDisabledColor": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.72)`,
                "--variant-outlinedColor": getCssVar(`palette-${color}-50`),
                "--variant-outlinedBorder": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.5)`,
                "--variant-outlinedHoverColor": `#fff`,
                "--variant-outlinedHoverBorder": getCssVar(`palette-${color}-300`),
                "--variant-outlinedHoverBg": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.12)`,
                "--variant-outlinedActiveBg": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.32)`,
                "--variant-outlinedDisabledColor": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.72)`,
                "--variant-outlinedDisabledBorder": `rgba(255 255 255 / 0.2)`,
                "--variant-softColor": getCssVar(`palette-common-white`),
                "--variant-softHoverColor": getCssVar(`palette-common-white`),
                "--variant-softBg": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.24)`,
                "--variant-softHoverBg": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.36)`,
                "--variant-softActiveBg": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.16)`,
                "--variant-softDisabledColor": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.72)`,
                "--variant-softDisabledBg": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.1)`,
                "--variant-solidColor": getCssVar(`palette-${color}-${color === "neutral" ? "600" : "500"}`),
                "--variant-solidBg": getCssVar(`palette-common-white`),
                "--variant-solidHoverColor": getCssVar(`palette-${color}-700`),
                "--variant-solidHoverBg": getCssVar(`palette-common-white`),
                "--variant-solidActiveBg": getCssVar(`palette-${color}-200`),
                "--variant-solidDisabledColor": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.72)`,
                "--variant-solidDisabledBg": `rgba(${getCssVar(`palette-${color}-lightChannel`)} / 0.1)`
            };
        }
    });
    return result;
};


const $f99a3103be8f6dd5$var$_excluded = [
    "cssVarPrefix",
    "breakpoints",
    "spacing",
    "components",
    "variants",
    "colorInversion",
    "shouldSkipGeneratingVar"
], $f99a3103be8f6dd5$var$_excluded2 = [
    "colorSchemes"
];
const $f99a3103be8f6dd5$export$65418b4d9082cc44 = (cssVarPrefix = "joy")=>(0, $fda71d8a719249a8$export$2e2bcd8739ae039)(cssVarPrefix);
function $f99a3103be8f6dd5$export$2e2bcd8739ae039(themeOptions) {
    var _scalesInput$focus$th, _scalesInput$focus, _scalesInput$focus$th2, _scalesInput$focus2, _scalesInput$colorSch, _scalesInput$colorSch2, _scalesInput$colorSch3, _scalesInput$colorSch4, _scalesInput$colorSch5, _scalesInput$colorSch6, _scalesInput$colorSch7, _scalesInput$colorSch8, _scalesInput$colorSch9, _scalesInput$colorSch10, _scalesInput$colorSch11, _scalesInput$colorSch12, _scalesInput$colorSch13, _scalesInput$colorSch14, _scalesInput$colorSch15, _scalesInput$colorSch16, _scalesInput$colorSch17, _scalesInput$colorSch18, _scalesInput$colorSch19, _scalesInput$colorSch20, _scalesInput$colorSch21, _scalesInput$colorSch22, _scalesInput$colorSch23, _scalesInput$colorSch24, _scalesInput$colorSch25, _scalesInput$colorSch26, _scalesInput$colorSch27, _scalesInput$colorSch28, _scalesInput$colorSch29, _scalesInput$colorSch30, _scalesInput$colorSch31, _scalesInput$colorSch32, _scalesInput$colorSch33, _scalesInput$colorSch34, _scalesInput$colorSch35, _scalesInput$colorSch36, _scalesInput$colorSch37, _scalesInput$colorSch38, _scalesInput$colorSch39, _scalesInput$colorSch40, _scalesInput$colorSch41, _scalesInput$colorSch42, _scalesInput$colorSch43, _scalesInput$colorSch44, _scalesInput$colorSch45, _scalesInput$colorSch46, _scalesInput$colorSch47, _scalesInput$colorSch48, _scalesInput$colorSch49, _scalesInput$colorSch50, _scalesInput$colorSch51, _scalesInput$colorSch52;
    const _ref = themeOptions || {}, { cssVarPrefix: cssVarPrefix = "joy", breakpoints: breakpoints, spacing: spacing, components: componentsInput, variants: variantsInput, colorInversion: colorInversionInput, shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $a4075eb2a48354bd$export$2e2bcd8739ae039) } = _ref, scalesInput = (0, $aT5bD.default)(_ref, $f99a3103be8f6dd5$var$_excluded);
    const getCssVar = $f99a3103be8f6dd5$export$65418b4d9082cc44(cssVarPrefix);
    const defaultColors = {
        primary: (0, $8bd845dd04c3d933$export$2e2bcd8739ae039).blue,
        neutral: (0, $8bd845dd04c3d933$export$2e2bcd8739ae039).grey,
        danger: (0, $8bd845dd04c3d933$export$2e2bcd8739ae039).red,
        info: (0, $8bd845dd04c3d933$export$2e2bcd8739ae039).purple,
        success: (0, $8bd845dd04c3d933$export$2e2bcd8739ae039).green,
        warning: (0, $8bd845dd04c3d933$export$2e2bcd8739ae039).yellow,
        common: {
            white: "#FFF",
            black: "#09090D"
        }
    };
    const getCssVarColor = (cssVar)=>{
        var _defaultColors$color;
        const tokens = cssVar.split("-");
        const color = tokens[1];
        const index = tokens[2];
        // @ts-ignore
        return getCssVar(cssVar, (_defaultColors$color = defaultColors[color]) == null ? void 0 : _defaultColors$color[index]);
    };
    const createLightModeVariantVariables = (color)=>({
            plainColor: getCssVarColor(`palette-${color}-600`),
            plainHoverBg: getCssVarColor(`palette-${color}-100`),
            plainActiveBg: getCssVarColor(`palette-${color}-200`),
            plainDisabledColor: getCssVarColor(`palette-${color}-200`),
            outlinedColor: getCssVarColor(`palette-${color}-500`),
            outlinedBorder: getCssVarColor(`palette-${color}-200`),
            outlinedHoverBg: getCssVarColor(`palette-${color}-100`),
            outlinedHoverBorder: getCssVarColor(`palette-${color}-300`),
            outlinedActiveBg: getCssVarColor(`palette-${color}-200`),
            outlinedDisabledColor: getCssVarColor(`palette-${color}-100`),
            outlinedDisabledBorder: getCssVarColor(`palette-${color}-100`),
            softColor: getCssVarColor(`palette-${color}-600`),
            softBg: getCssVarColor(`palette-${color}-100`),
            softHoverBg: getCssVarColor(`palette-${color}-200`),
            softActiveBg: getCssVarColor(`palette-${color}-300`),
            softDisabledColor: getCssVarColor(`palette-${color}-300`),
            softDisabledBg: getCssVarColor(`palette-${color}-50`),
            solidColor: "#fff",
            solidBg: getCssVarColor(`palette-${color}-500`),
            solidHoverBg: getCssVarColor(`palette-${color}-600`),
            solidActiveBg: getCssVarColor(`palette-${color}-700`),
            solidDisabledColor: `#fff`,
            solidDisabledBg: getCssVarColor(`palette-${color}-200`)
        });
    const createDarkModeVariantVariables = (color)=>({
            plainColor: getCssVarColor(`palette-${color}-300`),
            plainHoverBg: getCssVarColor(`palette-${color}-800`),
            plainActiveBg: getCssVarColor(`palette-${color}-700`),
            plainDisabledColor: getCssVarColor(`palette-${color}-800`),
            outlinedColor: getCssVarColor(`palette-${color}-200`),
            outlinedBorder: getCssVarColor(`palette-${color}-700`),
            outlinedHoverBg: getCssVarColor(`palette-${color}-800`),
            outlinedHoverBorder: getCssVarColor(`palette-${color}-600`),
            outlinedActiveBg: getCssVarColor(`palette-${color}-900`),
            outlinedDisabledColor: getCssVarColor(`palette-${color}-800`),
            outlinedDisabledBorder: getCssVarColor(`palette-${color}-800`),
            softColor: getCssVarColor(`palette-${color}-200`),
            softBg: getCssVarColor(`palette-${color}-900`),
            softHoverBg: getCssVarColor(`palette-${color}-800`),
            softActiveBg: getCssVarColor(`palette-${color}-700`),
            softDisabledColor: getCssVarColor(`palette-${color}-800`),
            softDisabledBg: getCssVarColor(`palette-${color}-900`),
            solidColor: `#fff`,
            solidBg: getCssVarColor(`palette-${color}-600`),
            solidHoverBg: getCssVarColor(`palette-${color}-700`),
            solidActiveBg: getCssVarColor(`palette-${color}-800`),
            solidDisabledColor: getCssVarColor(`palette-${color}-700`),
            solidDisabledBg: getCssVarColor(`palette-${color}-900`)
        });
    const lightColorSystem = {
        palette: {
            mode: "light",
            primary: (0, $cPOSH.default)({}, defaultColors.primary, createLightModeVariantVariables("primary")),
            neutral: (0, $cPOSH.default)({}, defaultColors.neutral, {
                plainColor: getCssVarColor(`palette-neutral-800`),
                plainHoverColor: getCssVarColor(`palette-neutral-900`),
                plainHoverBg: getCssVarColor(`palette-neutral-100`),
                plainActiveBg: getCssVarColor(`palette-neutral-200`),
                plainDisabledColor: getCssVarColor(`palette-neutral-300`),
                outlinedColor: getCssVarColor(`palette-neutral-800`),
                outlinedBorder: getCssVarColor(`palette-neutral-200`),
                outlinedHoverColor: getCssVarColor(`palette-neutral-900`),
                outlinedHoverBg: getCssVarColor(`palette-neutral-100`),
                outlinedHoverBorder: getCssVarColor(`palette-neutral-300`),
                outlinedActiveBg: getCssVarColor(`palette-neutral-200`),
                outlinedDisabledColor: getCssVarColor(`palette-neutral-300`),
                outlinedDisabledBorder: getCssVarColor(`palette-neutral-100`),
                softColor: getCssVarColor(`palette-neutral-800`),
                softBg: getCssVarColor(`palette-neutral-100`),
                softHoverColor: getCssVarColor(`palette-neutral-900`),
                softHoverBg: getCssVarColor(`palette-neutral-200`),
                softActiveBg: getCssVarColor(`palette-neutral-300`),
                softDisabledColor: getCssVarColor(`palette-neutral-300`),
                softDisabledBg: getCssVarColor(`palette-neutral-50`),
                solidColor: getCssVarColor(`palette-common-white`),
                solidBg: getCssVarColor(`palette-neutral-600`),
                solidHoverBg: getCssVarColor(`palette-neutral-700`),
                solidActiveBg: getCssVarColor(`palette-neutral-800`),
                solidDisabledColor: getCssVarColor(`palette-neutral-300`),
                solidDisabledBg: getCssVarColor(`palette-neutral-50`)
            }),
            danger: (0, $cPOSH.default)({}, defaultColors.danger, createLightModeVariantVariables("danger")),
            info: (0, $cPOSH.default)({}, defaultColors.info, createLightModeVariantVariables("info")),
            success: (0, $cPOSH.default)({}, defaultColors.success, createLightModeVariantVariables("success")),
            warning: (0, $cPOSH.default)({}, defaultColors.warning, createLightModeVariantVariables("warning"), {
                solidColor: getCssVarColor(`palette-warning-800`),
                solidBg: getCssVarColor(`palette-warning-200`),
                solidHoverBg: getCssVarColor(`palette-warning-300`),
                solidActiveBg: getCssVarColor(`palette-warning-400`),
                solidDisabledColor: getCssVarColor(`palette-warning-200`),
                solidDisabledBg: getCssVarColor(`palette-warning-50`),
                softColor: getCssVarColor(`palette-warning-800`),
                softBg: getCssVarColor(`palette-warning-50`),
                softHoverBg: getCssVarColor(`palette-warning-100`),
                softActiveBg: getCssVarColor(`palette-warning-200`),
                softDisabledColor: getCssVarColor(`palette-warning-200`),
                softDisabledBg: getCssVarColor(`palette-warning-50`),
                outlinedColor: getCssVarColor(`palette-warning-800`),
                outlinedHoverBg: getCssVarColor(`palette-warning-50`),
                plainColor: getCssVarColor(`palette-warning-800`),
                plainHoverBg: getCssVarColor(`palette-warning-50`)
            }),
            common: {
                white: "#FFF",
                black: "#09090D"
            },
            text: {
                primary: getCssVarColor("palette-neutral-800"),
                secondary: getCssVarColor("palette-neutral-600"),
                tertiary: getCssVarColor("palette-neutral-500")
            },
            background: {
                body: getCssVarColor("palette-common-white"),
                surface: getCssVarColor("palette-common-white"),
                popup: getCssVarColor("palette-common-white"),
                level1: getCssVarColor("palette-neutral-50"),
                level2: getCssVarColor("palette-neutral-100"),
                level3: getCssVarColor("palette-neutral-200"),
                tooltip: getCssVarColor("palette-neutral-800"),
                backdrop: "rgba(255 255 255 / 0.5)"
            },
            divider: `rgba(${getCssVar("palette-neutral-mainChannel", (0, $112c38b294022bf0$export$1b91fc959f7ee5a7)(defaultColors.neutral[500]) // should be the same index as in `attachColorChannels`
            )} / 0.28)`,
            focusVisible: getCssVarColor("palette-primary-500")
        },
        shadowRing: "0 0 #000",
        shadowChannel: "187 187 187"
    };
    const darkColorSystem = {
        palette: {
            mode: "dark",
            primary: (0, $cPOSH.default)({}, defaultColors.primary, createDarkModeVariantVariables("primary")),
            neutral: (0, $cPOSH.default)({}, defaultColors.neutral, {
                plainColor: getCssVarColor(`palette-neutral-200`),
                plainHoverColor: getCssVarColor(`palette-neutral-50`),
                plainHoverBg: getCssVarColor(`palette-neutral-800`),
                plainActiveBg: getCssVarColor(`palette-neutral-700`),
                plainDisabledColor: getCssVarColor(`palette-neutral-700`),
                outlinedColor: getCssVarColor(`palette-neutral-200`),
                outlinedBorder: getCssVarColor(`palette-neutral-800`),
                outlinedHoverColor: getCssVarColor(`palette-neutral-50`),
                outlinedHoverBg: getCssVarColor(`palette-neutral-800`),
                outlinedHoverBorder: getCssVarColor(`palette-neutral-700`),
                outlinedActiveBg: getCssVarColor(`palette-neutral-800`),
                outlinedDisabledColor: getCssVarColor(`palette-neutral-800`),
                outlinedDisabledBorder: getCssVarColor(`palette-neutral-800`),
                softColor: getCssVarColor(`palette-neutral-200`),
                softBg: getCssVarColor(`palette-neutral-800`),
                softHoverColor: getCssVarColor(`palette-neutral-50`),
                softHoverBg: getCssVarColor(`palette-neutral-700`),
                softActiveBg: getCssVarColor(`palette-neutral-600`),
                softDisabledColor: getCssVarColor(`palette-neutral-700`),
                softDisabledBg: getCssVarColor(`palette-neutral-900`),
                solidColor: getCssVarColor(`palette-common-white`),
                solidBg: getCssVarColor(`palette-neutral-600`),
                solidHoverBg: getCssVarColor(`palette-neutral-700`),
                solidActiveBg: getCssVarColor(`palette-neutral-800`),
                solidDisabledColor: getCssVarColor(`palette-neutral-700`),
                solidDisabledBg: getCssVarColor(`palette-neutral-900`)
            }),
            danger: (0, $cPOSH.default)({}, defaultColors.danger, createDarkModeVariantVariables("danger")),
            info: (0, $cPOSH.default)({}, defaultColors.info, createDarkModeVariantVariables("info")),
            success: (0, $cPOSH.default)({}, defaultColors.success, createDarkModeVariantVariables("success"), {
                solidColor: "#fff",
                solidBg: getCssVarColor(`palette-success-600`),
                solidHoverBg: getCssVarColor(`palette-success-700`),
                solidActiveBg: getCssVarColor(`palette-success-800`)
            }),
            warning: (0, $cPOSH.default)({}, defaultColors.warning, createDarkModeVariantVariables("warning"), {
                solidColor: getCssVarColor(`palette-common-black`),
                solidBg: getCssVarColor(`palette-warning-300`),
                solidHoverBg: getCssVarColor(`palette-warning-400`),
                solidActiveBg: getCssVarColor(`palette-warning-500`)
            }),
            common: {
                white: "#FFF",
                black: "#09090D"
            },
            text: {
                primary: getCssVarColor("palette-neutral-100"),
                secondary: getCssVarColor("palette-neutral-300"),
                tertiary: getCssVarColor("palette-neutral-400")
            },
            background: {
                body: getCssVarColor("palette-neutral-900"),
                surface: getCssVarColor("palette-common-black"),
                popup: getCssVarColor("palette-neutral-900"),
                level1: getCssVarColor("palette-neutral-800"),
                level2: getCssVarColor("palette-neutral-700"),
                level3: getCssVarColor("palette-neutral-600"),
                tooltip: getCssVarColor("palette-neutral-600"),
                backdrop: `rgba(${getCssVar("palette-neutral-darkChannel", (0, $112c38b294022bf0$export$1b91fc959f7ee5a7)(defaultColors.neutral[800]) // should be the same index as in `attachColorChannels`
                )} / 0.5)`
            },
            divider: `rgba(${getCssVar("palette-neutral-mainChannel", (0, $112c38b294022bf0$export$1b91fc959f7ee5a7)(defaultColors.neutral[500]) // should be the same index as in `attachColorChannels`
            )} / 0.24)`,
            focusVisible: getCssVarColor("palette-primary-500")
        },
        shadowRing: "0 0 #000",
        shadowChannel: "0 0 0"
    };
    const fontFamilyFallback = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';
    const fontFamily = (0, $cPOSH.default)({
        body: `"Public Sans", ${getCssVar(`fontFamily-fallback, ${fontFamilyFallback}`)}`,
        display: `"Public Sans", ${getCssVar(`fontFamily-fallback, ${fontFamilyFallback}`)}`,
        code: "Source Code Pro,ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace",
        fallback: fontFamilyFallback
    }, scalesInput.fontFamily);
    const fontWeight = (0, $cPOSH.default)({
        xs: 200,
        sm: 300,
        md: 500,
        lg: 600,
        xl: 700,
        xl2: 800,
        xl3: 900
    }, scalesInput.fontWeight);
    const fontSize = (0, $cPOSH.default)({
        xs3: "0.5rem",
        xs2: "0.625rem",
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem",
        xl2: "1.5rem",
        xl3: "1.875rem",
        xl4: "2.25rem",
        xl5: "3rem",
        xl6: "3.75rem",
        xl7: "4.5rem"
    }, scalesInput.fontSize);
    const lineHeight = (0, $cPOSH.default)({
        sm: 1.25,
        md: 1.5,
        lg: 1.7
    }, scalesInput.lineHeight);
    const letterSpacing = (0, $cPOSH.default)({
        sm: "-0.01em",
        md: "0.083em",
        lg: "0.125em"
    }, scalesInput.letterSpacing);
    const defaultScales = {
        colorSchemes: {
            light: lightColorSystem,
            dark: darkColorSystem
        },
        fontSize: fontSize,
        fontFamily: fontFamily,
        fontWeight: fontWeight,
        focus: {
            thickness: "2px",
            selector: `&.${(0, $bd48de20fb876697$export$1d132570e11858b0)("", "focusVisible")}, &:focus-visible`,
            default: {
                outlineOffset: `var(--focus-outline-offset, ${getCssVar("focus-thickness", (_scalesInput$focus$th = (_scalesInput$focus = scalesInput.focus) == null ? void 0 : _scalesInput$focus.thickness) != null ? _scalesInput$focus$th : "2px")})`,
                outline: `${getCssVar("focus-thickness", (_scalesInput$focus$th2 = (_scalesInput$focus2 = scalesInput.focus) == null ? void 0 : _scalesInput$focus2.thickness) != null ? _scalesInput$focus$th2 : "2px")} solid ${getCssVar("palette-focusVisible", defaultColors.primary[500])}`
            }
        },
        lineHeight: lineHeight,
        letterSpacing: letterSpacing,
        radius: {
            xs: "4px",
            sm: "8px",
            md: "12px",
            lg: "16px",
            xl: "20px"
        },
        shadow: {
            xs: `${getCssVar("shadowRing", (_scalesInput$colorSch = (_scalesInput$colorSch2 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch2 = _scalesInput$colorSch2.light) == null ? void 0 : _scalesInput$colorSch2.shadowRing) != null ? _scalesInput$colorSch : lightColorSystem.shadowRing)}, 0 1px 2px 0 rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch3 = (_scalesInput$colorSch4 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch4 = _scalesInput$colorSch4.light) == null ? void 0 : _scalesInput$colorSch4.shadowChannel) != null ? _scalesInput$colorSch3 : lightColorSystem.shadowChannel)} / 0.12)`,
            sm: `${getCssVar("shadowRing", (_scalesInput$colorSch5 = (_scalesInput$colorSch6 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch6 = _scalesInput$colorSch6.light) == null ? void 0 : _scalesInput$colorSch6.shadowRing) != null ? _scalesInput$colorSch5 : lightColorSystem.shadowRing)}, 0.3px 0.8px 1.1px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch7 = (_scalesInput$colorSch8 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch8 = _scalesInput$colorSch8.light) == null ? void 0 : _scalesInput$colorSch8.shadowChannel) != null ? _scalesInput$colorSch7 : lightColorSystem.shadowChannel)} / 0.11), 0.5px 1.3px 1.8px -0.6px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch9 = (_scalesInput$colorSch10 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch10 = _scalesInput$colorSch10.light) == null ? void 0 : _scalesInput$colorSch10.shadowChannel) != null ? _scalesInput$colorSch9 : lightColorSystem.shadowChannel)} / 0.18), 1.1px 2.7px 3.8px -1.2px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch11 = (_scalesInput$colorSch12 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch12 = _scalesInput$colorSch12.light) == null ? void 0 : _scalesInput$colorSch12.shadowChannel) != null ? _scalesInput$colorSch11 : lightColorSystem.shadowChannel)} / 0.26)`,
            md: `${getCssVar("shadowRing", (_scalesInput$colorSch13 = (_scalesInput$colorSch14 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch14 = _scalesInput$colorSch14.light) == null ? void 0 : _scalesInput$colorSch14.shadowRing) != null ? _scalesInput$colorSch13 : lightColorSystem.shadowRing)}, 0.3px 0.8px 1.1px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch15 = (_scalesInput$colorSch16 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch16 = _scalesInput$colorSch16.light) == null ? void 0 : _scalesInput$colorSch16.shadowChannel) != null ? _scalesInput$colorSch15 : lightColorSystem.shadowChannel)} / 0.12), 1.1px 2.8px 3.9px -0.4px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch17 = (_scalesInput$colorSch18 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch18 = _scalesInput$colorSch18.light) == null ? void 0 : _scalesInput$colorSch18.shadowChannel) != null ? _scalesInput$colorSch17 : lightColorSystem.shadowChannel)} / 0.17), 2.4px 6.1px 8.6px -0.8px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch19 = (_scalesInput$colorSch20 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch20 = _scalesInput$colorSch20.light) == null ? void 0 : _scalesInput$colorSch20.shadowChannel) != null ? _scalesInput$colorSch19 : lightColorSystem.shadowChannel)} / 0.23), 5.3px 13.3px 18.8px -1.2px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch21 = (_scalesInput$colorSch22 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch22 = _scalesInput$colorSch22.light) == null ? void 0 : _scalesInput$colorSch22.shadowChannel) != null ? _scalesInput$colorSch21 : lightColorSystem.shadowChannel)} / 0.29)`,
            lg: `${getCssVar("shadowRing", (_scalesInput$colorSch23 = (_scalesInput$colorSch24 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch24 = _scalesInput$colorSch24.light) == null ? void 0 : _scalesInput$colorSch24.shadowRing) != null ? _scalesInput$colorSch23 : lightColorSystem.shadowRing)}, 0.3px 0.8px 1.1px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch25 = (_scalesInput$colorSch26 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch26 = _scalesInput$colorSch26.light) == null ? void 0 : _scalesInput$colorSch26.shadowChannel) != null ? _scalesInput$colorSch25 : lightColorSystem.shadowChannel)} / 0.11), 1.8px 4.5px 6.4px -0.2px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch27 = (_scalesInput$colorSch28 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch28 = _scalesInput$colorSch28.light) == null ? void 0 : _scalesInput$colorSch28.shadowChannel) != null ? _scalesInput$colorSch27 : lightColorSystem.shadowChannel)} / 0.13), 3.2px 7.9px 11.2px -0.4px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch29 = (_scalesInput$colorSch30 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch30 = _scalesInput$colorSch30.light) == null ? void 0 : _scalesInput$colorSch30.shadowChannel) != null ? _scalesInput$colorSch29 : lightColorSystem.shadowChannel)} / 0.16), 4.8px 12px 17px -0.5px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch31 = (_scalesInput$colorSch32 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch32 = _scalesInput$colorSch32.light) == null ? void 0 : _scalesInput$colorSch32.shadowChannel) != null ? _scalesInput$colorSch31 : lightColorSystem.shadowChannel)} / 0.19), 7px 17.5px 24.7px -0.7px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch33 = (_scalesInput$colorSch34 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch34 = _scalesInput$colorSch34.light) == null ? void 0 : _scalesInput$colorSch34.shadowChannel) != null ? _scalesInput$colorSch33 : lightColorSystem.shadowChannel)} / 0.21)`,
            xl: `${getCssVar("shadowRing", (_scalesInput$colorSch35 = (_scalesInput$colorSch36 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch36 = _scalesInput$colorSch36.light) == null ? void 0 : _scalesInput$colorSch36.shadowRing) != null ? _scalesInput$colorSch35 : lightColorSystem.shadowRing)}, 0.3px 0.8px 1.1px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch37 = (_scalesInput$colorSch38 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch38 = _scalesInput$colorSch38.light) == null ? void 0 : _scalesInput$colorSch38.shadowChannel) != null ? _scalesInput$colorSch37 : lightColorSystem.shadowChannel)} / 0.11), 1.8px 4.5px 6.4px -0.2px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch39 = (_scalesInput$colorSch40 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch40 = _scalesInput$colorSch40.light) == null ? void 0 : _scalesInput$colorSch40.shadowChannel) != null ? _scalesInput$colorSch39 : lightColorSystem.shadowChannel)} / 0.13), 3.2px 7.9px 11.2px -0.4px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch41 = (_scalesInput$colorSch42 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch42 = _scalesInput$colorSch42.light) == null ? void 0 : _scalesInput$colorSch42.shadowChannel) != null ? _scalesInput$colorSch41 : lightColorSystem.shadowChannel)} / 0.16), 4.8px 12px 17px -0.5px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch43 = (_scalesInput$colorSch44 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch44 = _scalesInput$colorSch44.light) == null ? void 0 : _scalesInput$colorSch44.shadowChannel) != null ? _scalesInput$colorSch43 : lightColorSystem.shadowChannel)} / 0.19), 7px 17.5px 24.7px -0.7px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch45 = (_scalesInput$colorSch46 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch46 = _scalesInput$colorSch46.light) == null ? void 0 : _scalesInput$colorSch46.shadowChannel) != null ? _scalesInput$colorSch45 : lightColorSystem.shadowChannel)} / 0.21), 10.2px 25.5px 36px -0.9px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch47 = (_scalesInput$colorSch48 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch48 = _scalesInput$colorSch48.light) == null ? void 0 : _scalesInput$colorSch48.shadowChannel) != null ? _scalesInput$colorSch47 : lightColorSystem.shadowChannel)} / 0.24), 14.8px 36.8px 52.1px -1.1px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch49 = (_scalesInput$colorSch50 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch50 = _scalesInput$colorSch50.light) == null ? void 0 : _scalesInput$colorSch50.shadowChannel) != null ? _scalesInput$colorSch49 : lightColorSystem.shadowChannel)} / 0.27), 21px 52.3px 74px -1.2px rgba(${getCssVar("shadowChannel", (_scalesInput$colorSch51 = (_scalesInput$colorSch52 = scalesInput.colorSchemes) == null || (_scalesInput$colorSch52 = _scalesInput$colorSch52.light) == null ? void 0 : _scalesInput$colorSch52.shadowChannel) != null ? _scalesInput$colorSch51 : lightColorSystem.shadowChannel)} / 0.29)`
        },
        zIndex: {
            badge: 1,
            table: 10,
            popup: 1000,
            modal: 1300,
            tooltip: 1500
        },
        typography: {
            display1: {
                fontFamily: getCssVar(`fontFamily-display, ${fontFamily.display}`),
                fontWeight: getCssVar(`fontWeight-xl, ${fontWeight.xl}`),
                fontSize: getCssVar(`fontSize-xl7, ${fontSize.xl7}`),
                lineHeight: getCssVar(`lineHeight-sm, ${lineHeight.sm}`),
                letterSpacing: getCssVar(`letterSpacing-sm, ${letterSpacing.sm}`),
                color: getCssVar("palette-text-primary", lightColorSystem.palette.text.primary)
            },
            display2: {
                fontFamily: getCssVar(`fontFamily-display, ${fontFamily.display}`),
                fontWeight: getCssVar(`fontWeight-xl, ${fontWeight.xl}`),
                fontSize: getCssVar(`fontSize-xl6, ${fontSize.xl6}`),
                lineHeight: getCssVar(`lineHeight-sm, ${lineHeight.sm}`),
                letterSpacing: getCssVar(`letterSpacing-sm, ${letterSpacing.sm}`),
                color: getCssVar("palette-text-primary", lightColorSystem.palette.text.primary)
            },
            h1: {
                fontFamily: getCssVar(`fontFamily-display, ${fontFamily.display}`),
                fontWeight: getCssVar(`fontWeight-lg, ${fontWeight.lg}`),
                fontSize: getCssVar(`fontSize-xl5, ${fontSize.xl5}`),
                lineHeight: getCssVar(`lineHeight-sm, ${lineHeight.sm}`),
                letterSpacing: getCssVar(`letterSpacing-sm, ${letterSpacing.sm}`),
                color: getCssVar("palette-text-primary", lightColorSystem.palette.text.primary)
            },
            h2: {
                fontFamily: getCssVar(`fontFamily-display, ${fontFamily.display}`),
                fontWeight: getCssVar(`fontWeight-lg, ${fontWeight.lg}`),
                fontSize: getCssVar(`fontSize-xl4, ${fontSize.xl4}`),
                lineHeight: getCssVar(`lineHeight-sm, ${lineHeight.sm}`),
                letterSpacing: getCssVar(`letterSpacing-sm, ${letterSpacing.sm}`),
                color: getCssVar("palette-text-primary", lightColorSystem.palette.text.primary)
            },
            h3: {
                fontFamily: getCssVar(`fontFamily-body, ${fontFamily.body}`),
                fontWeight: getCssVar(`fontWeight-md, ${fontWeight.md}`),
                fontSize: getCssVar(`fontSize-xl3, ${fontSize.xl3}`),
                lineHeight: getCssVar(`lineHeight-sm, ${lineHeight.sm}`),
                color: getCssVar("palette-text-primary", lightColorSystem.palette.text.primary)
            },
            h4: {
                fontFamily: getCssVar(`fontFamily-body, ${fontFamily.body}`),
                fontWeight: getCssVar(`fontWeight-md, ${fontWeight.md}`),
                fontSize: getCssVar(`fontSize-xl2, ${fontSize.xl2}`),
                lineHeight: getCssVar(`lineHeight-md, ${lineHeight.md}`),
                color: getCssVar("palette-text-primary", lightColorSystem.palette.text.primary)
            },
            h5: {
                fontFamily: getCssVar(`fontFamily-body, ${fontFamily.body}`),
                fontWeight: getCssVar(`fontWeight-md, ${fontWeight.md}`),
                fontSize: getCssVar(`fontSize-xl, ${fontSize.xl}`),
                lineHeight: getCssVar(`lineHeight-md, ${lineHeight.md}`),
                color: getCssVar("palette-text-primary", lightColorSystem.palette.text.primary)
            },
            h6: {
                fontFamily: getCssVar(`fontFamily-body, ${fontFamily.body}`),
                fontWeight: getCssVar(`fontWeight-md, ${fontWeight.md}`),
                fontSize: getCssVar(`fontSize-lg, ${fontSize.lg}`),
                lineHeight: getCssVar(`lineHeight-md, ${lineHeight.md}`),
                color: getCssVar("palette-text-primary", lightColorSystem.palette.text.primary)
            },
            body1: {
                fontFamily: getCssVar(`fontFamily-body, ${fontFamily.body}`),
                fontSize: getCssVar(`fontSize-md, ${fontSize.md}`),
                lineHeight: getCssVar(`lineHeight-md, ${lineHeight.md}`),
                color: getCssVar("palette-text-primary", lightColorSystem.palette.text.primary)
            },
            body2: {
                fontFamily: getCssVar(`fontFamily-body, ${fontFamily.body}`),
                fontSize: getCssVar(`fontSize-sm, ${fontSize.sm}`),
                lineHeight: getCssVar(`lineHeight-md, ${lineHeight.md}`),
                color: getCssVar("palette-text-secondary", lightColorSystem.palette.text.secondary)
            },
            body3: {
                fontFamily: getCssVar(`fontFamily-body, ${fontFamily.body}`),
                fontSize: getCssVar(`fontSize-xs, ${fontSize.xs}`),
                lineHeight: getCssVar(`lineHeight-md, ${lineHeight.md}`),
                color: getCssVar("palette-text-tertiary", lightColorSystem.palette.text.tertiary)
            },
            body4: {
                fontFamily: getCssVar(`fontFamily-body, ${fontFamily.body}`),
                fontSize: getCssVar(`fontSize-xs2, ${fontSize.xs2}`),
                lineHeight: getCssVar(`lineHeight-md, ${lineHeight.md}`),
                color: getCssVar("palette-text-tertiary", lightColorSystem.palette.text.tertiary)
            },
            body5: {
                fontFamily: getCssVar(`fontFamily-body, ${fontFamily.body}`),
                fontSize: getCssVar(`fontSize-xs3, ${fontSize.xs3}`),
                lineHeight: getCssVar(`lineHeight-md, ${lineHeight.md}`),
                color: getCssVar("palette-text-tertiary", lightColorSystem.palette.text.tertiary)
            }
        }
    };
    const _ref2 = scalesInput ? (0, $i5l0f.default)(defaultScales, scalesInput) : defaultScales, { colorSchemes: colorSchemes } = _ref2, mergedScales = (0, $aT5bD.default)(_ref2, $f99a3103be8f6dd5$var$_excluded2);
    const theme = (0, $cPOSH.default)({
        colorSchemes: colorSchemes
    }, mergedScales, {
        breakpoints: (0, $6N804.default)(breakpoints != null ? breakpoints : {}),
        components: (0, $i5l0f.default)({
            // TODO: find a way to abstract SvgIcon out of @mui/material
            MuiSvgIcon: {
                defaultProps: {
                    fontSize: "xl"
                },
                styleOverrides: {
                    root: ({ ownerState: ownerState, theme: themeProp })=>{
                        var _themeProp$vars$palet;
                        const instanceFontSize = ownerState.instanceFontSize;
                        return (0, $cPOSH.default)({
                            color: "var(--Icon-color)",
                            margin: "var(--Icon-margin)"
                        }, ownerState.fontSize && ownerState.fontSize !== "inherit" && {
                            fontSize: `var(--Icon-fontSize, ${themeProp.vars.fontSize[ownerState.fontSize]})`
                        }, ownerState.color && ownerState.color !== "inherit" && ownerState.color !== "context" && themeProp.vars.palette[ownerState.color] && {
                            color: `rgba(${(_themeProp$vars$palet = themeProp.vars.palette[ownerState.color]) == null ? void 0 : _themeProp$vars$palet.mainChannel} / 1)`
                        }, ownerState.color === "context" && {
                            color: themeProp.vars.palette.text.secondary
                        }, instanceFontSize && instanceFontSize !== "inherit" && {
                            "--Icon-fontSize": themeProp.vars.fontSize[instanceFontSize]
                        });
                    }
                }
            }
        }, componentsInput),
        cssVarPrefix: cssVarPrefix,
        getCssVar: getCssVar,
        spacing: (0, $edNcL.default)(spacing),
        colorInversionConfig: {
            soft: [
                "plain",
                "outlined",
                "soft",
                "solid"
            ],
            solid: [
                "plain",
                "outlined",
                "soft",
                "solid"
            ]
        }
    }); // Need type casting due to module augmentation inside the repo
    /**
   Color channels generation
  */ function attachColorChannels(supportedColorScheme, palette) {
        Object.keys(palette).forEach((key)=>{
            const channelMapping = {
                main: "500",
                light: "200",
                dark: "800"
            };
            if (supportedColorScheme === "dark") // @ts-ignore internal
            channelMapping.main = 400;
            if (!palette[key].mainChannel && palette[key][channelMapping.main]) palette[key].mainChannel = (0, $112c38b294022bf0$export$1b91fc959f7ee5a7)(palette[key][channelMapping.main]);
            if (!palette[key].lightChannel && palette[key][channelMapping.light]) palette[key].lightChannel = (0, $112c38b294022bf0$export$1b91fc959f7ee5a7)(palette[key][channelMapping.light]);
            if (!palette[key].darkChannel && palette[key][channelMapping.dark]) palette[key].darkChannel = (0, $112c38b294022bf0$export$1b91fc959f7ee5a7)(palette[key][channelMapping.dark]);
        });
    }
    // Set the channels
    Object.entries(theme.colorSchemes).forEach(([supportedColorScheme, colorSystem])=>{
        attachColorChannels(supportedColorScheme, colorSystem.palette);
    });
    // ===============================================================
    // Create `theme.vars` that contain `var(--*)` as values
    // ===============================================================
    const parserConfig = {
        prefix: cssVarPrefix,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar
    };
    const { vars: themeVars, generateCssVars: generateCssVars } = (0, $d78034c4c3d15967$export$2e2bcd8739ae039)((0, $cPOSH.default)({
        colorSchemes: colorSchemes
    }, mergedScales), parserConfig);
    theme.vars = themeVars;
    theme.generateCssVars = generateCssVars;
    theme.unstable_sxConfig = (0, $cPOSH.default)({}, (0, $5efe951f88c39f81$export$2e2bcd8739ae039), themeOptions == null ? void 0 : themeOptions.unstable_sxConfig);
    theme.unstable_sx = function sx(props) {
        return (0, $cLzOx.default)({
            sx: props,
            theme: this
        });
    };
    theme.getColorSchemeSelector = (colorScheme)=>colorScheme === "light" ? "&" : `&[data-joy-color-scheme="${colorScheme}"], [data-joy-color-scheme="${colorScheme}"] &`;
    const createVariantInput = {
        getCssVar: getCssVar,
        palette: theme.colorSchemes.light.palette
    };
    theme.variants = (0, $i5l0f.default)({
        plain: (0, $8bb3a7873572990d$export$acb4c136ee475234)("plain", createVariantInput),
        plainHover: (0, $8bb3a7873572990d$export$acb4c136ee475234)("plainHover", createVariantInput),
        plainActive: (0, $8bb3a7873572990d$export$acb4c136ee475234)("plainActive", createVariantInput),
        plainDisabled: (0, $8bb3a7873572990d$export$acb4c136ee475234)("plainDisabled", createVariantInput),
        outlined: (0, $8bb3a7873572990d$export$acb4c136ee475234)("outlined", createVariantInput),
        outlinedHover: (0, $8bb3a7873572990d$export$acb4c136ee475234)("outlinedHover", createVariantInput),
        outlinedActive: (0, $8bb3a7873572990d$export$acb4c136ee475234)("outlinedActive", createVariantInput),
        outlinedDisabled: (0, $8bb3a7873572990d$export$acb4c136ee475234)("outlinedDisabled", createVariantInput),
        soft: (0, $8bb3a7873572990d$export$acb4c136ee475234)("soft", createVariantInput),
        softHover: (0, $8bb3a7873572990d$export$acb4c136ee475234)("softHover", createVariantInput),
        softActive: (0, $8bb3a7873572990d$export$acb4c136ee475234)("softActive", createVariantInput),
        softDisabled: (0, $8bb3a7873572990d$export$acb4c136ee475234)("softDisabled", createVariantInput),
        solid: (0, $8bb3a7873572990d$export$acb4c136ee475234)("solid", createVariantInput),
        solidHover: (0, $8bb3a7873572990d$export$acb4c136ee475234)("solidHover", createVariantInput),
        solidActive: (0, $8bb3a7873572990d$export$acb4c136ee475234)("solidActive", createVariantInput),
        solidDisabled: (0, $8bb3a7873572990d$export$acb4c136ee475234)("solidDisabled", createVariantInput)
    }, variantsInput);
    theme.palette = (0, $cPOSH.default)({}, theme.colorSchemes.light.palette, {
        colorScheme: "light"
    });
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    // @ts-ignore if the colorInversion is provided as callbacks, it needs to be resolved in the CssVarsProvider
    theme.colorInversion = typeof colorInversionInput === "function" ? colorInversionInput : (0, $i5l0f.default)({
        soft: (0, $8bb3a7873572990d$export$76ac256e9decb5cc)(theme, true),
        solid: (0, $8bb3a7873572990d$export$785f1b9b17061606)(theme, true)
    }, colorInversionInput || {}, {
        clone: false
    });
    return theme;
}


const $9940f683f801a8a4$var$defaultTheme = (0, $f99a3103be8f6dd5$export$2e2bcd8739ae039)();
var $9940f683f801a8a4$export$2e2bcd8739ae039 = $9940f683f801a8a4$var$defaultTheme;



var $d37a791f4994804c$export$2e2bcd8739ae039 = "$$joy";


"use client";
const { CssVarsProvider: $cfb032a577a9592a$export$50ec01b133c61652, useColorScheme: $cfb032a577a9592a$export$6343629ee1b29116, getInitColorSchemeScript: $cfb032a577a9592a$export$f9a57b4a2abf8ed } = (0, $8cf81ff17303da8e$export$2e2bcd8739ae039)({
    themeId: (0, $d37a791f4994804c$export$2e2bcd8739ae039),
    theme: (0, $9940f683f801a8a4$export$2e2bcd8739ae039),
    attribute: "data-joy-color-scheme",
    modeStorageKey: "joy-mode",
    colorSchemeStorageKey: "joy-color-scheme",
    defaultColorScheme: {
        light: "light",
        dark: "dark"
    },
    resolveTheme: (mergedTheme)=>{
        const colorInversionInput = mergedTheme.colorInversion;
        mergedTheme.colorInversion = (0, $i5l0f.default)({
            soft: (0, $8bb3a7873572990d$export$76ac256e9decb5cc)(mergedTheme),
            solid: (0, $8bb3a7873572990d$export$785f1b9b17061606)(mergedTheme)
        }, typeof colorInversionInput === "function" ? colorInversionInput(mergedTheme) : colorInversionInput, {
            clone: false
        });
        return mergedTheme;
    }
});


var $j2qx3 = parcelRequire("j2qx3");parcelRequire("1EuC8");

var $cteiL = parcelRequire("cteiL");

"use client";
const $65b5429f0b31aa48$export$35e57303dbd8a66 = (0, $cteiL.default)();
function $65b5429f0b31aa48$var$useTheme(defaultTheme = $65b5429f0b31aa48$export$35e57303dbd8a66) {
    return (0, $b9c977420be7e805$export$2e2bcd8739ae039)(defaultTheme);
}
var $65b5429f0b31aa48$export$2e2bcd8739ae039 = $65b5429f0b31aa48$var$useTheme;






var $6iAGf = parcelRequire("6iAGf");
"use client";
const $e4321228e0a5ec0b$export$93d4e7f90805808f = ()=>{
    const theme = (0, $65b5429f0b31aa48$export$2e2bcd8739ae039)((0, $9940f683f801a8a4$export$2e2bcd8739ae039));
    // @ts-ignore internal logic
    return theme[0, $d37a791f4994804c$export$2e2bcd8739ae039] || theme;
};
function $e4321228e0a5ec0b$export$2e2bcd8739ae039({ children: children, theme: themeInput }) {
    let theme = (0, $9940f683f801a8a4$export$2e2bcd8739ae039);
    if (themeInput) theme = (0, $f99a3103be8f6dd5$export$2e2bcd8739ae039)((0, $d37a791f4994804c$export$2e2bcd8739ae039) in themeInput ? themeInput[0, $d37a791f4994804c$export$2e2bcd8739ae039] : themeInput);
    return /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c921fd42c44cb580$export$2e2bcd8739ae039), {
        theme: theme,
        themeId: themeInput && (0, $d37a791f4994804c$export$2e2bcd8739ae039) in themeInput ? (0, $d37a791f4994804c$export$2e2bcd8739ae039) : undefined,
        children: children
    });
}


var $e0ddeeb9e921301b$exports = {};
"use strict";

var $4n9Eb = parcelRequire("4n9Eb");

var $cJzNa = parcelRequire("cJzNa");
Object.defineProperty($e0ddeeb9e921301b$exports, "__esModule", {
    value: true
});
var $e0ddeeb9e921301b$var$_exportNames = {
    SessionContext: true,
    useSession: true,
    getSession: true,
    getCsrfToken: true,
    getProviders: true,
    signIn: true,
    signOut: true,
    SessionProvider: true
};
$e0ddeeb9e921301b$exports.SessionContext = void 0;
$e0ddeeb9e921301b$exports.SessionProvider = $e0ddeeb9e921301b$var$SessionProvider;
$e0ddeeb9e921301b$exports.getCsrfToken = $e0ddeeb9e921301b$var$getCsrfToken;
$e0ddeeb9e921301b$exports.getProviders = $e0ddeeb9e921301b$var$getProviders;
$e0ddeeb9e921301b$exports.getSession = $e0ddeeb9e921301b$var$getSession;
$e0ddeeb9e921301b$exports.signIn = $e0ddeeb9e921301b$var$signIn;
$e0ddeeb9e921301b$exports.signOut = $e0ddeeb9e921301b$var$signOut;
$e0ddeeb9e921301b$exports.useSession = $e0ddeeb9e921301b$var$useSession;

var $e0ddeeb9e921301b$var$_regenerator = $4n9Eb((parcelRequire("e8KCL")));

var $e0ddeeb9e921301b$var$_defineProperty2 = $4n9Eb((parcelRequire("afboQ")));

var $e0ddeeb9e921301b$var$_asyncToGenerator2 = $4n9Eb((parcelRequire("3ir6W")));

var $e0ddeeb9e921301b$var$_slicedToArray2 = $4n9Eb((parcelRequire("epA29")));

var $e0ddeeb9e921301b$var$React = $e0ddeeb9e921301b$var$_interopRequireWildcard((parcelRequire("1EuC8")));

var $e0ddeeb9e921301b$var$_logger2 = $e0ddeeb9e921301b$var$_interopRequireWildcard((parcelRequire("5Qinz")));

var $e0ddeeb9e921301b$var$_parseUrl = $4n9Eb((parcelRequire("lfY47")));
var $4d31eb204d70414a$exports = {};
"use strict";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($4d31eb204d70414a$exports, "__esModule", {
    value: true
});
$4d31eb204d70414a$exports.BroadcastChannel = $4d31eb204d70414a$var$BroadcastChannel;
$4d31eb204d70414a$exports.apiBaseUrl = $4d31eb204d70414a$var$apiBaseUrl;
$4d31eb204d70414a$exports.fetchData = $4d31eb204d70414a$var$fetchData;
$4d31eb204d70414a$exports.now = $4d31eb204d70414a$var$now;

var $4d31eb204d70414a$var$_regenerator = $4n9Eb((parcelRequire("e8KCL")));

var $4d31eb204d70414a$var$_defineProperty2 = $4n9Eb((parcelRequire("afboQ")));

var $4d31eb204d70414a$var$_asyncToGenerator2 = $4n9Eb((parcelRequire("3ir6W")));
function $4d31eb204d70414a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4d31eb204d70414a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4d31eb204d70414a$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $4d31eb204d70414a$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4d31eb204d70414a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4d31eb204d70414a$var$fetchData(_x, _x2, _x3) {
    return $4d31eb204d70414a$var$_fetchData.apply(this, arguments);
}
function $4d31eb204d70414a$var$_fetchData() {
    $4d31eb204d70414a$var$_fetchData = (0, $4d31eb204d70414a$var$_asyncToGenerator2.default)($4d31eb204d70414a$var$_regenerator.default.mark(function _callee(path, __NEXTAUTH, logger) {
        var _ref, ctx, _ref$req, req, url, _req$headers, options, res, data, _args = arguments;
        return $4d31eb204d70414a$var$_regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _ref = _args.length > 3 && _args[3] !== undefined ? _args[3] : {}, ctx = _ref.ctx, _ref$req = _ref.req, req = _ref$req === void 0 ? ctx === null || ctx === void 0 ? void 0 : ctx.req : _ref$req;
                    url = "".concat($4d31eb204d70414a$var$apiBaseUrl(__NEXTAUTH), "/").concat(path);
                    _context.prev = 2;
                    options = {
                        headers: $4d31eb204d70414a$var$_objectSpread({
                            "Content-Type": "application/json"
                        }, req !== null && req !== void 0 && (_req$headers = req.headers) !== null && _req$headers !== void 0 && _req$headers.cookie ? {
                            cookie: req.headers.cookie
                        } : {})
                    };
                    if (req !== null && req !== void 0 && req.body) {
                        options.body = JSON.stringify(req.body);
                        options.method = "POST";
                    }
                    _context.next = 7;
                    return fetch(url, options);
                case 7:
                    res = _context.sent;
                    _context.next = 10;
                    return res.json();
                case 10:
                    data = _context.sent;
                    if (res.ok) {
                        _context.next = 13;
                        break;
                    }
                    throw data;
                case 13:
                    return _context.abrupt("return", Object.keys(data).length > 0 ? data : null);
                case 16:
                    _context.prev = 16;
                    _context.t0 = _context["catch"](2);
                    logger.error("CLIENT_FETCH_ERROR", {
                        error: _context.t0,
                        url: url
                    });
                    return _context.abrupt("return", null);
                case 20:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                2,
                16
            ]
        ]);
    }));
    return $4d31eb204d70414a$var$_fetchData.apply(this, arguments);
}
function $4d31eb204d70414a$var$apiBaseUrl(__NEXTAUTH) {
    if (typeof window === "undefined") return "".concat(__NEXTAUTH.baseUrlServer).concat(__NEXTAUTH.basePathServer);
    return __NEXTAUTH.basePath;
}
function $4d31eb204d70414a$var$now() {
    return Math.floor(Date.now() / 1000);
}
function $4d31eb204d70414a$var$BroadcastChannel() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "nextauth.message";
    return {
        receive: function receive(onReceive) {
            var handler = function handler(event) {
                var _event$newValue;
                if (event.key !== name) return;
                var message = JSON.parse((_event$newValue = event.newValue) !== null && _event$newValue !== void 0 ? _event$newValue : "{}");
                if ((message === null || message === void 0 ? void 0 : message.event) !== "session" || !(message !== null && message !== void 0 && message.data)) return;
                onReceive(message);
            };
            window.addEventListener("storage", handler);
            return function() {
                return window.removeEventListener("storage", handler);
            };
        },
        post: function post(message) {
            if (typeof window === "undefined") return;
            try {
                localStorage.setItem(name, JSON.stringify($4d31eb204d70414a$var$_objectSpread($4d31eb204d70414a$var$_objectSpread({}, message), {}, {
                    timestamp: $4d31eb204d70414a$var$now()
                })));
            } catch (_unused) {}
        }
    };
}



var $6iAGf = parcelRequire("6iAGf");
var $363eb83c060fc1d7$exports = {};
"use strict";
Object.defineProperty($363eb83c060fc1d7$exports, "__esModule", {
    value: true
});


Object.keys($363eb83c060fc1d7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e0ddeeb9e921301b$var$_exportNames, key)) return;
    if (key in $e0ddeeb9e921301b$exports && $e0ddeeb9e921301b$exports[key] === $363eb83c060fc1d7$exports[key]) return;
    Object.defineProperty($e0ddeeb9e921301b$exports, key, {
        enumerable: true,
        get: function get() {
            return $363eb83c060fc1d7$exports[key];
        }
    });
});
var $e0ddeeb9e921301b$var$_process$env$NEXTAUTH, $e0ddeeb9e921301b$var$_ref, $e0ddeeb9e921301b$var$_process$env$NEXTAUTH2, $e0ddeeb9e921301b$var$_process$env$NEXTAUTH3, $e0ddeeb9e921301b$var$_React$createContext;
function $e0ddeeb9e921301b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e0ddeeb9e921301b$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e0ddeeb9e921301b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $cJzNa(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e0ddeeb9e921301b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e0ddeeb9e921301b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e0ddeeb9e921301b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e0ddeeb9e921301b$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $e0ddeeb9e921301b$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e0ddeeb9e921301b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $e0ddeeb9e921301b$var$__NEXTAUTH = {
    baseUrl: (0, $e0ddeeb9e921301b$var$_parseUrl.default)(($e0ddeeb9e921301b$var$_process$env$NEXTAUTH = undefined, $e0ddeeb9e921301b$var$_process$env$NEXTAUTH !== void 0) ? $e0ddeeb9e921301b$var$_process$env$NEXTAUTH : undefined).origin,
    basePath: (0, $e0ddeeb9e921301b$var$_parseUrl.default)(undefined).path,
    baseUrlServer: (0, $e0ddeeb9e921301b$var$_parseUrl.default)(($e0ddeeb9e921301b$var$_ref = ($e0ddeeb9e921301b$var$_process$env$NEXTAUTH2 = undefined, $e0ddeeb9e921301b$var$_process$env$NEXTAUTH2 !== void 0) ? $e0ddeeb9e921301b$var$_process$env$NEXTAUTH2 : undefined) !== null && $e0ddeeb9e921301b$var$_ref !== void 0 ? $e0ddeeb9e921301b$var$_ref : undefined).origin,
    basePathServer: (0, $e0ddeeb9e921301b$var$_parseUrl.default)(($e0ddeeb9e921301b$var$_process$env$NEXTAUTH3 = undefined, $e0ddeeb9e921301b$var$_process$env$NEXTAUTH3 !== void 0) ? $e0ddeeb9e921301b$var$_process$env$NEXTAUTH3 : undefined).path,
    _lastSync: 0,
    _session: undefined,
    _getSession: function _getSession() {}
};
var $e0ddeeb9e921301b$var$broadcast = (0, $4d31eb204d70414a$exports.BroadcastChannel)();
var $e0ddeeb9e921301b$var$logger = (0, $e0ddeeb9e921301b$var$_logger2.proxyLogger)($e0ddeeb9e921301b$var$_logger2.default, $e0ddeeb9e921301b$var$__NEXTAUTH.basePath);
function $e0ddeeb9e921301b$var$useOnline() {
    var _React$useState = $e0ddeeb9e921301b$var$React.useState(typeof navigator !== "undefined" ? navigator.onLine : false), _React$useState2 = (0, $e0ddeeb9e921301b$var$_slicedToArray2.default)(_React$useState, 2), isOnline = _React$useState2[0], setIsOnline = _React$useState2[1];
    var setOnline = function setOnline() {
        return setIsOnline(true);
    };
    var setOffline = function setOffline() {
        return setIsOnline(false);
    };
    $e0ddeeb9e921301b$var$React.useEffect(function() {
        window.addEventListener("online", setOnline);
        window.addEventListener("offline", setOffline);
        return function() {
            window.removeEventListener("online", setOnline);
            window.removeEventListener("offline", setOffline);
        };
    }, []);
    return isOnline;
}
var $e0ddeeb9e921301b$var$SessionContext = ($e0ddeeb9e921301b$var$_React$createContext = $e0ddeeb9e921301b$var$React.createContext) === null || $e0ddeeb9e921301b$var$_React$createContext === void 0 ? void 0 : $e0ddeeb9e921301b$var$_React$createContext.call($e0ddeeb9e921301b$var$React, undefined);
$e0ddeeb9e921301b$exports.SessionContext = $e0ddeeb9e921301b$var$SessionContext;
function $e0ddeeb9e921301b$var$useSession(options) {
    if (!$e0ddeeb9e921301b$var$SessionContext) throw new Error("React Context is unavailable in Server Components");
    var value = $e0ddeeb9e921301b$var$React.useContext($e0ddeeb9e921301b$var$SessionContext);
    var _ref2 = options !== null && options !== void 0 ? options : {}, required = _ref2.required, onUnauthenticated = _ref2.onUnauthenticated;
    var requiredAndNotLoading = required && value.status === "unauthenticated";
    $e0ddeeb9e921301b$var$React.useEffect(function() {
        if (requiredAndNotLoading) {
            var url = "/api/auth/signin?".concat(new URLSearchParams({
                error: "SessionRequired",
                callbackUrl: window.location.href
            }));
            if (onUnauthenticated) onUnauthenticated();
            else window.location.href = url;
        }
    }, [
        requiredAndNotLoading,
        onUnauthenticated
    ]);
    if (requiredAndNotLoading) return {
        data: value.data,
        update: value.update,
        status: "loading"
    };
    return value;
}
function $e0ddeeb9e921301b$var$getSession(_x) {
    return $e0ddeeb9e921301b$var$_getSession2.apply(this, arguments);
}
function $e0ddeeb9e921301b$var$_getSession2() {
    $e0ddeeb9e921301b$var$_getSession2 = (0, $e0ddeeb9e921301b$var$_asyncToGenerator2.default)($e0ddeeb9e921301b$var$_regenerator.default.mark(function _callee3(params) {
        var _params$broadcast;
        var session;
        return $e0ddeeb9e921301b$var$_regenerator.default.wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return (0, $4d31eb204d70414a$exports.fetchData)("session", $e0ddeeb9e921301b$var$__NEXTAUTH, $e0ddeeb9e921301b$var$logger, params);
                case 2:
                    session = _context3.sent;
                    if ((_params$broadcast = params === null || params === void 0 ? void 0 : params.broadcast) !== null && _params$broadcast !== void 0 ? _params$broadcast : true) $e0ddeeb9e921301b$var$broadcast.post({
                        event: "session",
                        data: {
                            trigger: "getSession"
                        }
                    });
                    return _context3.abrupt("return", session);
                case 5:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $e0ddeeb9e921301b$var$_getSession2.apply(this, arguments);
}
function $e0ddeeb9e921301b$var$getCsrfToken(_x2) {
    return $e0ddeeb9e921301b$var$_getCsrfToken.apply(this, arguments);
}
function $e0ddeeb9e921301b$var$_getCsrfToken() {
    $e0ddeeb9e921301b$var$_getCsrfToken = (0, $e0ddeeb9e921301b$var$_asyncToGenerator2.default)($e0ddeeb9e921301b$var$_regenerator.default.mark(function _callee4(params) {
        var response;
        return $e0ddeeb9e921301b$var$_regenerator.default.wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.next = 2;
                    return (0, $4d31eb204d70414a$exports.fetchData)("csrf", $e0ddeeb9e921301b$var$__NEXTAUTH, $e0ddeeb9e921301b$var$logger, params);
                case 2:
                    response = _context4.sent;
                    return _context4.abrupt("return", response === null || response === void 0 ? void 0 : response.csrfToken);
                case 4:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return $e0ddeeb9e921301b$var$_getCsrfToken.apply(this, arguments);
}
function $e0ddeeb9e921301b$var$getProviders() {
    return $e0ddeeb9e921301b$var$_getProviders.apply(this, arguments);
}
function $e0ddeeb9e921301b$var$_getProviders() {
    $e0ddeeb9e921301b$var$_getProviders = (0, $e0ddeeb9e921301b$var$_asyncToGenerator2.default)($e0ddeeb9e921301b$var$_regenerator.default.mark(function _callee5() {
        return $e0ddeeb9e921301b$var$_regenerator.default.wrap(function _callee5$(_context5) {
            while(true)switch(_context5.prev = _context5.next){
                case 0:
                    _context5.next = 2;
                    return (0, $4d31eb204d70414a$exports.fetchData)("providers", $e0ddeeb9e921301b$var$__NEXTAUTH, $e0ddeeb9e921301b$var$logger);
                case 2:
                    return _context5.abrupt("return", _context5.sent);
                case 3:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return $e0ddeeb9e921301b$var$_getProviders.apply(this, arguments);
}
function $e0ddeeb9e921301b$var$signIn(_x3, _x4, _x5) {
    return $e0ddeeb9e921301b$var$_signIn.apply(this, arguments);
}
function $e0ddeeb9e921301b$var$_signIn() {
    $e0ddeeb9e921301b$var$_signIn = (0, $e0ddeeb9e921301b$var$_asyncToGenerator2.default)($e0ddeeb9e921301b$var$_regenerator.default.mark(function _callee6(provider, options, authorizationParams) {
        var _ref5, _ref5$callbackUrl, callbackUrl, _ref5$redirect, redirect, baseUrl, providers, isCredentials, isEmail, isSupportingReturn, signInUrl, _signInUrl, res, data, _data$url, url, error;
        return $e0ddeeb9e921301b$var$_regenerator.default.wrap(function _callee6$(_context6) {
            while(true)switch(_context6.prev = _context6.next){
                case 0:
                    _ref5 = options !== null && options !== void 0 ? options : {}, _ref5$callbackUrl = _ref5.callbackUrl, callbackUrl = _ref5$callbackUrl === void 0 ? window.location.href : _ref5$callbackUrl, _ref5$redirect = _ref5.redirect, redirect = _ref5$redirect === void 0 ? true : _ref5$redirect;
                    baseUrl = (0, $4d31eb204d70414a$exports.apiBaseUrl)($e0ddeeb9e921301b$var$__NEXTAUTH);
                    _context6.next = 4;
                    return $e0ddeeb9e921301b$var$getProviders();
                case 4:
                    providers = _context6.sent;
                    if (providers) {
                        _context6.next = 8;
                        break;
                    }
                    window.location.href = "".concat(baseUrl, "/error");
                    return _context6.abrupt("return");
                case 8:
                    if (!(!provider || !(provider in providers))) {
                        _context6.next = 11;
                        break;
                    }
                    window.location.href = "".concat(baseUrl, "/signin?").concat(new URLSearchParams({
                        callbackUrl: callbackUrl
                    }));
                    return _context6.abrupt("return");
                case 11:
                    isCredentials = providers[provider].type === "credentials";
                    isEmail = providers[provider].type === "email";
                    isSupportingReturn = isCredentials || isEmail;
                    signInUrl = "".concat(baseUrl, "/").concat(isCredentials ? "callback" : "signin", "/").concat(provider);
                    _signInUrl = "".concat(signInUrl).concat(authorizationParams ? "?".concat(new URLSearchParams(authorizationParams)) : "");
                    _context6.t0 = fetch;
                    _context6.t1 = _signInUrl;
                    _context6.t2 = {
                        "Content-Type": "application/x-www-form-urlencoded"
                    };
                    _context6.t3 = URLSearchParams;
                    _context6.t4 = $e0ddeeb9e921301b$var$_objectSpread;
                    _context6.t5 = $e0ddeeb9e921301b$var$_objectSpread({}, options);
                    _context6.t6 = {};
                    _context6.next = 25;
                    return $e0ddeeb9e921301b$var$getCsrfToken();
                case 25:
                    _context6.t7 = _context6.sent;
                    _context6.t8 = callbackUrl;
                    _context6.t9 = {
                        csrfToken: _context6.t7,
                        callbackUrl: _context6.t8,
                        json: true
                    };
                    _context6.t10 = (0, _context6.t4)(_context6.t5, _context6.t6, _context6.t9);
                    _context6.t11 = new _context6.t3(_context6.t10);
                    _context6.t12 = {
                        method: "post",
                        headers: _context6.t2,
                        body: _context6.t11
                    };
                    _context6.next = 33;
                    return (0, _context6.t0)(_context6.t1, _context6.t12);
                case 33:
                    res = _context6.sent;
                    _context6.next = 36;
                    return res.json();
                case 36:
                    data = _context6.sent;
                    if (!(redirect || !isSupportingReturn)) {
                        _context6.next = 42;
                        break;
                    }
                    url = (_data$url = data.url) !== null && _data$url !== void 0 ? _data$url : callbackUrl;
                    window.location.href = url;
                    if (url.includes("#")) window.location.reload();
                    return _context6.abrupt("return");
                case 42:
                    error = new URL(data.url).searchParams.get("error");
                    if (!res.ok) {
                        _context6.next = 46;
                        break;
                    }
                    _context6.next = 46;
                    return $e0ddeeb9e921301b$var$__NEXTAUTH._getSession({
                        event: "storage"
                    });
                case 46:
                    return _context6.abrupt("return", {
                        error: error,
                        status: res.status,
                        ok: res.ok,
                        url: error ? null : data.url
                    });
                case 47:
                case "end":
                    return _context6.stop();
            }
        }, _callee6);
    }));
    return $e0ddeeb9e921301b$var$_signIn.apply(this, arguments);
}
function $e0ddeeb9e921301b$var$signOut(_x6) {
    return $e0ddeeb9e921301b$var$_signOut.apply(this, arguments);
}
function $e0ddeeb9e921301b$var$_signOut() {
    $e0ddeeb9e921301b$var$_signOut = (0, $e0ddeeb9e921301b$var$_asyncToGenerator2.default)($e0ddeeb9e921301b$var$_regenerator.default.mark(function _callee7(options) {
        var _options$redirect;
        var _ref6, _ref6$callbackUrl, callbackUrl, baseUrl, fetchOptions, res, data, _data$url2, url;
        return $e0ddeeb9e921301b$var$_regenerator.default.wrap(function _callee7$(_context7) {
            while(true)switch(_context7.prev = _context7.next){
                case 0:
                    _ref6 = options !== null && options !== void 0 ? options : {}, _ref6$callbackUrl = _ref6.callbackUrl, callbackUrl = _ref6$callbackUrl === void 0 ? window.location.href : _ref6$callbackUrl;
                    baseUrl = (0, $4d31eb204d70414a$exports.apiBaseUrl)($e0ddeeb9e921301b$var$__NEXTAUTH);
                    _context7.t0 = {
                        "Content-Type": "application/x-www-form-urlencoded"
                    };
                    _context7.t1 = URLSearchParams;
                    _context7.next = 6;
                    return $e0ddeeb9e921301b$var$getCsrfToken();
                case 6:
                    _context7.t2 = _context7.sent;
                    _context7.t3 = callbackUrl;
                    _context7.t4 = {
                        csrfToken: _context7.t2,
                        callbackUrl: _context7.t3,
                        json: true
                    };
                    _context7.t5 = new _context7.t1(_context7.t4);
                    fetchOptions = {
                        method: "post",
                        headers: _context7.t0,
                        body: _context7.t5
                    };
                    _context7.next = 13;
                    return fetch("".concat(baseUrl, "/signout"), fetchOptions);
                case 13:
                    res = _context7.sent;
                    _context7.next = 16;
                    return res.json();
                case 16:
                    data = _context7.sent;
                    $e0ddeeb9e921301b$var$broadcast.post({
                        event: "session",
                        data: {
                            trigger: "signout"
                        }
                    });
                    if (!((_options$redirect = options === null || options === void 0 ? void 0 : options.redirect) !== null && _options$redirect !== void 0 ? _options$redirect : true)) {
                        _context7.next = 23;
                        break;
                    }
                    url = (_data$url2 = data.url) !== null && _data$url2 !== void 0 ? _data$url2 : callbackUrl;
                    window.location.href = url;
                    if (url.includes("#")) window.location.reload();
                    return _context7.abrupt("return");
                case 23:
                    _context7.next = 25;
                    return $e0ddeeb9e921301b$var$__NEXTAUTH._getSession({
                        event: "storage"
                    });
                case 25:
                    return _context7.abrupt("return", data);
                case 26:
                case "end":
                    return _context7.stop();
            }
        }, _callee7);
    }));
    return $e0ddeeb9e921301b$var$_signOut.apply(this, arguments);
}
function $e0ddeeb9e921301b$var$SessionProvider(props) {
    if (!$e0ddeeb9e921301b$var$SessionContext) throw new Error("React Context is unavailable in Server Components");
    var children = props.children, basePath = props.basePath, refetchInterval = props.refetchInterval, refetchWhenOffline = props.refetchWhenOffline;
    if (basePath) $e0ddeeb9e921301b$var$__NEXTAUTH.basePath = basePath;
    var hasInitialSession = props.session !== undefined;
    $e0ddeeb9e921301b$var$__NEXTAUTH._lastSync = hasInitialSession ? (0, $4d31eb204d70414a$exports.now)() : 0;
    var _React$useState3 = $e0ddeeb9e921301b$var$React.useState(function() {
        if (hasInitialSession) $e0ddeeb9e921301b$var$__NEXTAUTH._session = props.session;
        return props.session;
    }), _React$useState4 = (0, $e0ddeeb9e921301b$var$_slicedToArray2.default)(_React$useState3, 2), session = _React$useState4[0], setSession = _React$useState4[1];
    var _React$useState5 = $e0ddeeb9e921301b$var$React.useState(!hasInitialSession), _React$useState6 = (0, $e0ddeeb9e921301b$var$_slicedToArray2.default)(_React$useState5, 2), loading = _React$useState6[0], setLoading = _React$useState6[1];
    $e0ddeeb9e921301b$var$React.useEffect(function() {
        $e0ddeeb9e921301b$var$__NEXTAUTH._getSession = (0, $e0ddeeb9e921301b$var$_asyncToGenerator2.default)($e0ddeeb9e921301b$var$_regenerator.default.mark(function _callee() {
            var _ref4, event, storageEvent, _args = arguments;
            return $e0ddeeb9e921301b$var$_regenerator.default.wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _ref4 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, event = _ref4.event;
                        _context.prev = 1;
                        storageEvent = event === "storage";
                        if (!(storageEvent || $e0ddeeb9e921301b$var$__NEXTAUTH._session === undefined)) {
                            _context.next = 10;
                            break;
                        }
                        $e0ddeeb9e921301b$var$__NEXTAUTH._lastSync = (0, $4d31eb204d70414a$exports.now)();
                        _context.next = 7;
                        return $e0ddeeb9e921301b$var$getSession({
                            broadcast: !storageEvent
                        });
                    case 7:
                        $e0ddeeb9e921301b$var$__NEXTAUTH._session = _context.sent;
                        setSession($e0ddeeb9e921301b$var$__NEXTAUTH._session);
                        return _context.abrupt("return");
                    case 10:
                        if (!(!event || $e0ddeeb9e921301b$var$__NEXTAUTH._session === null || (0, $4d31eb204d70414a$exports.now)() < $e0ddeeb9e921301b$var$__NEXTAUTH._lastSync)) {
                            _context.next = 12;
                            break;
                        }
                        return _context.abrupt("return");
                    case 12:
                        $e0ddeeb9e921301b$var$__NEXTAUTH._lastSync = (0, $4d31eb204d70414a$exports.now)();
                        _context.next = 15;
                        return $e0ddeeb9e921301b$var$getSession();
                    case 15:
                        $e0ddeeb9e921301b$var$__NEXTAUTH._session = _context.sent;
                        setSession($e0ddeeb9e921301b$var$__NEXTAUTH._session);
                        _context.next = 22;
                        break;
                    case 19:
                        _context.prev = 19;
                        _context.t0 = _context["catch"](1);
                        $e0ddeeb9e921301b$var$logger.error("CLIENT_SESSION_ERROR", _context.t0);
                    case 22:
                        _context.prev = 22;
                        setLoading(false);
                        return _context.finish(22);
                    case 25:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    1,
                    19,
                    22,
                    25
                ]
            ]);
        }));
        $e0ddeeb9e921301b$var$__NEXTAUTH._getSession();
        return function() {
            $e0ddeeb9e921301b$var$__NEXTAUTH._lastSync = 0;
            $e0ddeeb9e921301b$var$__NEXTAUTH._session = undefined;
            $e0ddeeb9e921301b$var$__NEXTAUTH._getSession = function() {};
        };
    }, []);
    $e0ddeeb9e921301b$var$React.useEffect(function() {
        var unsubscribe = $e0ddeeb9e921301b$var$broadcast.receive(function() {
            return $e0ddeeb9e921301b$var$__NEXTAUTH._getSession({
                event: "storage"
            });
        });
        return function() {
            return unsubscribe();
        };
    }, []);
    $e0ddeeb9e921301b$var$React.useEffect(function() {
        var _props$refetchOnWindo = props.refetchOnWindowFocus, refetchOnWindowFocus = _props$refetchOnWindo === void 0 ? true : _props$refetchOnWindo;
        var visibilityHandler = function visibilityHandler() {
            if (refetchOnWindowFocus && document.visibilityState === "visible") $e0ddeeb9e921301b$var$__NEXTAUTH._getSession({
                event: "visibilitychange"
            });
        };
        document.addEventListener("visibilitychange", visibilityHandler, false);
        return function() {
            return document.removeEventListener("visibilitychange", visibilityHandler, false);
        };
    }, [
        props.refetchOnWindowFocus
    ]);
    var isOnline = $e0ddeeb9e921301b$var$useOnline();
    var shouldRefetch = refetchWhenOffline !== false || isOnline;
    $e0ddeeb9e921301b$var$React.useEffect(function() {
        if (refetchInterval && shouldRefetch) {
            var refetchIntervalTimer = setInterval(function() {
                if ($e0ddeeb9e921301b$var$__NEXTAUTH._session) $e0ddeeb9e921301b$var$__NEXTAUTH._getSession({
                    event: "poll"
                });
            }, refetchInterval * 1000);
            return function() {
                return clearInterval(refetchIntervalTimer);
            };
        }
    }, [
        refetchInterval,
        shouldRefetch
    ]);
    var value = $e0ddeeb9e921301b$var$React.useMemo(function() {
        return {
            data: session,
            status: loading ? "loading" : session ? "authenticated" : "unauthenticated",
            update: function update(data) {
                return (0, $e0ddeeb9e921301b$var$_asyncToGenerator2.default)($e0ddeeb9e921301b$var$_regenerator.default.mark(function _callee2() {
                    var newSession;
                    return $e0ddeeb9e921301b$var$_regenerator.default.wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (!(loading || !session)) {
                                    _context2.next = 2;
                                    break;
                                }
                                return _context2.abrupt("return");
                            case 2:
                                setLoading(true);
                                _context2.t0 = $4d31eb204d70414a$exports.fetchData;
                                _context2.t1 = $e0ddeeb9e921301b$var$__NEXTAUTH;
                                _context2.t2 = $e0ddeeb9e921301b$var$logger;
                                _context2.next = 8;
                                return $e0ddeeb9e921301b$var$getCsrfToken();
                            case 8:
                                _context2.t3 = _context2.sent;
                                _context2.t4 = data;
                                _context2.t5 = {
                                    csrfToken: _context2.t3,
                                    data: _context2.t4
                                };
                                _context2.t6 = {
                                    body: _context2.t5
                                };
                                _context2.t7 = {
                                    req: _context2.t6
                                };
                                _context2.next = 15;
                                return (0, _context2.t0)("session", _context2.t1, _context2.t2, _context2.t7);
                            case 15:
                                newSession = _context2.sent;
                                setLoading(false);
                                if (newSession) {
                                    setSession(newSession);
                                    $e0ddeeb9e921301b$var$broadcast.post({
                                        event: "session",
                                        data: {
                                            trigger: "getSession"
                                        }
                                    });
                                }
                                return _context2.abrupt("return", newSession);
                            case 19:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }))();
            }
        };
    }, [
        session,
        loading
    ]);
    return (0, $6iAGf.jsx)($e0ddeeb9e921301b$var$SessionContext.Provider, {
        value: value,
        children: children
    });
}



var $1EuC8 = parcelRequire("1EuC8");
var $6fb24a13c371e5cf$export$882461b6382ed46c;
var $6fb24a13c371e5cf$export$757ceba2d55c277e;
"use strict";
var $243da7855fb30689$exports = {};
"use strict";
function $243da7855fb30689$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($243da7855fb30689$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$243da7855fb30689$var$checkDCE();

$243da7855fb30689$exports = (parcelRequire("jZkR6"));


var $6fb24a13c371e5cf$var$i;
$6fb24a13c371e5cf$export$882461b6382ed46c = $243da7855fb30689$exports.createRoot;
$6fb24a13c371e5cf$export$757ceba2d55c277e = $243da7855fb30689$exports.hydrateRoot;



var $6iAGf = parcelRequire("6iAGf");
var $f99d326ceed242e9$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($f99d326ceed242e9$exports, "__esModule", {
    value: true
});
$f99d326ceed242e9$exports.default = void 0;

var $f99d326ceed242e9$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $f99d326ceed242e9$var$_default = $f99d326ceed242e9$exports.default = (0, $f99d326ceed242e9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42a.9959.9959 0 0 0-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1"
}), "ArrowBackRounded");


var $e5384f96e1af87bb$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($e5384f96e1af87bb$exports, "__esModule", {
    value: true
});
$e5384f96e1af87bb$exports.default = void 0;

var $e5384f96e1af87bb$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $e5384f96e1af87bb$var$_default = $e5384f96e1af87bb$exports.default = (0, $e5384f96e1af87bb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25z"
}), "AutoAwesome");


var $cb8ae238302d8481$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($cb8ae238302d8481$exports, "__esModule", {
    value: true
});
$cb8ae238302d8481$exports.default = void 0;

var $cb8ae238302d8481$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $cb8ae238302d8481$var$_default = $cb8ae238302d8481$exports.default = (0, $cb8ae238302d8481$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "M9 16.17 5.53 12.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71c.39-.39.39-1.02 0-1.41a.9959.9959 0 0 0-1.41 0z"
}), "CheckRounded");


var $2bcc20a60ebe1ea3$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($2bcc20a60ebe1ea3$exports, "__esModule", {
    value: true
});
$2bcc20a60ebe1ea3$exports.default = void 0;

var $2bcc20a60ebe1ea3$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $2bcc20a60ebe1ea3$var$_default = $2bcc20a60ebe1ea3$exports.default = (0, $2bcc20a60ebe1ea3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "M18.3 5.71a.9959.9959 0 0 0-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
}), "ClearRounded");


var $a88209f7b217d9e7$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($a88209f7b217d9e7$exports, "__esModule", {
    value: true
});
$a88209f7b217d9e7$exports.default = void 0;

var $a88209f7b217d9e7$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $a88209f7b217d9e7$var$_default = $a88209f7b217d9e7$exports.default = (0, $a88209f7b217d9e7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "M18.3 5.71a.9959.9959 0 0 0-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
}), "CloseRounded");


var $2272c2abf146540d$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($2272c2abf146540d$exports, "__esModule", {
    value: true
});
$2272c2abf146540d$exports.default = void 0;

var $2272c2abf146540d$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $2272c2abf146540d$var$_default = $2272c2abf146540d$exports.default = (0, $2272c2abf146540d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "M20 2H4.01c-1.1 0-2 .9-2 2L2 19.58c0 .89 1.08 1.34 1.71.71L6 18h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-8 4c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m4 8H8v-.57c0-.81.48-1.53 1.22-1.85.85-.37 1.79-.58 2.78-.58.99 0 1.93.21 2.78.58.74.32 1.22 1.04 1.22 1.85z"
}), "ThreePRounded");



var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");

var $1EuC8 = parcelRequire("1EuC8");

var $gioqn = parcelRequire("gioqn");

var $2xnzr = parcelRequire("2xnzr");

var $cLzOx = parcelRequire("cLzOx");
var $b2hnc = parcelRequire("b2hnc");


var $6iAGf = parcelRequire("6iAGf");
"use client";
const $e3ce72c6bcc950d8$var$_excluded = [
    "className",
    "component"
];
function $e3ce72c6bcc950d8$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $2xnzr.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $cLzOx.default));
    const Box = /*#__PURE__*/ $1EuC8.forwardRef(function Box(inProps, ref) {
        const theme = (0, $65b5429f0b31aa48$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $b2hnc.default)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $aT5bD.default)(_extendSxProp, $e3ce72c6bcc950d8$var$_excluded);
        return /*#__PURE__*/ (0, $6iAGf.jsx)(BoxRoot, (0, $cPOSH.default)({
            as: component,
            ref: ref,
            className: (0, $gioqn.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $ar8ZD = parcelRequire("ar8ZD");


"use client";
const $d6bc128423f5f36a$var$Box = (0, $e3ce72c6bcc950d8$export$2e2bcd8739ae039)({
    themeId: (0, $d37a791f4994804c$export$2e2bcd8739ae039),
    defaultTheme: $9940f683f801a8a4$export$2e2bcd8739ae039,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $ar8ZD.default).generate
});
var $d6bc128423f5f36a$export$2e2bcd8739ae039 = $d6bc128423f5f36a$var$Box;



var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");


var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");

var $1EuC8 = parcelRequire("1EuC8");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $fccbd5cb99bfd838$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $ca3242a650a8aafe$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $1EuC8.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $fccbd5cb99bfd838$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


var $1EuC8 = parcelRequire("1EuC8");

var $1EuC8 = parcelRequire("1EuC8");
"use client";
const $472af4e8a1a25d18$var$UNINITIALIZED = {};
function $472af4e8a1a25d18$export$2e2bcd8739ae039(init, initArg) {
    const ref = $1EuC8.useRef($472af4e8a1a25d18$var$UNINITIALIZED);
    if (ref.current === $472af4e8a1a25d18$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $1EuC8 = parcelRequire("1EuC8");
"use client";
const $a8c2133c9e9cc1f0$var$EMPTY = [];
function $a8c2133c9e9cc1f0$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $1EuC8.useEffect(fn, $a8c2133c9e9cc1f0$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


"use client";
class $b24fceca847a6eb8$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $b24fceca847a6eb8$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $b24fceca847a6eb8$export$2e2bcd8739ae039() {
    const timeout = (0, $472af4e8a1a25d18$export$2e2bcd8739ae039)($b24fceca847a6eb8$export$786b4da70f00938b.create).current;
    (0, $a8c2133c9e9cc1f0$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


"use client";
let $27204afc9050af9f$var$hadKeyboardEvent = true;
let $27204afc9050af9f$var$hadFocusVisibleRecently = false;
const $27204afc9050af9f$var$hadFocusVisibleRecentlyTimeout = new (0, $b24fceca847a6eb8$export$786b4da70f00938b)();
const $27204afc9050af9f$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $27204afc9050af9f$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $27204afc9050af9f$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $27204afc9050af9f$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $27204afc9050af9f$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $27204afc9050af9f$var$handlePointerDown() {
    $27204afc9050af9f$var$hadKeyboardEvent = false;
}
function $27204afc9050af9f$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($27204afc9050af9f$var$hadFocusVisibleRecently) $27204afc9050af9f$var$hadKeyboardEvent = true;
    }
}
function $27204afc9050af9f$var$prepare(doc) {
    doc.addEventListener("keydown", $27204afc9050af9f$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $27204afc9050af9f$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $27204afc9050af9f$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $27204afc9050af9f$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $27204afc9050af9f$var$handleVisibilityChange, true);
}
function $27204afc9050af9f$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $27204afc9050af9f$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $27204afc9050af9f$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $27204afc9050af9f$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $27204afc9050af9f$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $27204afc9050af9f$var$handleVisibilityChange, true);
}
function $27204afc9050af9f$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $27204afc9050af9f$var$hadKeyboardEvent || $27204afc9050af9f$var$focusTriggersKeyboardModality(target);
}
function $27204afc9050af9f$export$2e2bcd8739ae039() {
    const ref = $1EuC8.useCallback((node)=>{
        if (node != null) $27204afc9050af9f$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $1EuC8.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $27204afc9050af9f$var$hadFocusVisibleRecently = true;
            $27204afc9050af9f$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $27204afc9050af9f$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($27204afc9050af9f$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $8235f986c8d7b99b$export$2e2bcd8739ae039(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


"use client";
function $394c5beb21a0dde3$export$2e2bcd8739ae039(parameters = {}) {
    const { disabled: disabled = false, focusableWhenDisabled: focusableWhenDisabled, href: href, rootRef: externalRef, tabIndex: tabIndex, to: to, type: type } = parameters;
    const buttonRef = $1EuC8.useRef();
    const [active, setActive] = $1EuC8.useState(false);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $27204afc9050af9f$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $1EuC8.useState(false);
    if (disabled && !focusableWhenDisabled && focusVisible) setFocusVisible(false);
    $1EuC8.useEffect(()=>{
        isFocusVisibleRef.current = focusVisible;
    }, [
        focusVisible,
        isFocusVisibleRef
    ]);
    const [hostElementName, setHostElementName] = $1EuC8.useState("");
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous;
            if (focusVisible) event.preventDefault();
            (_otherHandlers$onMous = otherHandlers.onMouseLeave) == null || _otherHandlers$onMous.call(otherHandlers, event);
        };
    const createHandleBlur = (otherHandlers)=>(event)=>{
            var _otherHandlers$onBlur;
            handleBlurVisible(event);
            if (isFocusVisibleRef.current === false) setFocusVisible(false);
            (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            var _otherHandlers$onFocu2;
            // Fix for https://github.com/facebook/react/issues/7769
            if (!buttonRef.current) buttonRef.current = event.currentTarget;
            handleFocusVisible(event);
            if (isFocusVisibleRef.current === true) {
                var _otherHandlers$onFocu;
                setFocusVisible(true);
                (_otherHandlers$onFocu = otherHandlers.onFocusVisible) == null || _otherHandlers$onFocu.call(otherHandlers, event);
            }
            (_otherHandlers$onFocu2 = otherHandlers.onFocus) == null || _otherHandlers$onFocu2.call(otherHandlers, event);
        };
    const isNativeButton = ()=>{
        const button = buttonRef.current;
        return hostElementName === "BUTTON" || hostElementName === "INPUT" && [
            "button",
            "submit",
            "reset"
        ].includes(button == null ? void 0 : button.type) || hostElementName === "A" && (button == null ? void 0 : button.href);
    };
    const createHandleClick = (otherHandlers)=>(event)=>{
            if (!disabled) {
                var _otherHandlers$onClic;
                (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            }
        };
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous2;
            if (!disabled) {
                setActive(true);
                document.addEventListener("mouseup", ()=>{
                    setActive(false);
                }, {
                    once: true
                });
            }
            (_otherHandlers$onMous2 = otherHandlers.onMouseDown) == null || _otherHandlers$onMous2.call(otherHandlers, event);
        };
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            if (event.defaultMuiPrevented) return;
            if (event.target === event.currentTarget && !isNativeButton() && event.key === " ") event.preventDefault();
            if (event.target === event.currentTarget && event.key === " " && !disabled) setActive(true);
            // Keyboard accessibility for non interactive elements
            if (event.target === event.currentTarget && !isNativeButton() && event.key === "Enter" && !disabled) {
                var _otherHandlers$onClic2;
                (_otherHandlers$onClic2 = otherHandlers.onClick) == null || _otherHandlers$onClic2.call(otherHandlers, event);
                event.preventDefault();
            }
        };
    const createHandleKeyUp = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyU;
            // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
            // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
            if (event.target === event.currentTarget) setActive(false);
            (_otherHandlers$onKeyU = otherHandlers.onKeyUp) == null || _otherHandlers$onKeyU.call(otherHandlers, event);
            // Keyboard accessibility for non interactive elements
            if (event.target === event.currentTarget && !isNativeButton() && !disabled && event.key === " " && !event.defaultMuiPrevented) {
                var _otherHandlers$onClic3;
                (_otherHandlers$onClic3 = otherHandlers.onClick) == null || _otherHandlers$onClic3.call(otherHandlers, event);
            }
        };
    const updateHostElementName = $1EuC8.useCallback((instance)=>{
        var _instance$tagName;
        setHostElementName((_instance$tagName = instance == null ? void 0 : instance.tagName) != null ? _instance$tagName : "");
    }, []);
    const handleRef = (0, $ca3242a650a8aafe$export$2e2bcd8739ae039)(updateHostElementName, externalRef, focusVisibleRef, buttonRef);
    const buttonProps = {};
    if (hostElementName === "BUTTON") {
        buttonProps.type = type != null ? type : "button";
        if (focusableWhenDisabled) buttonProps["aria-disabled"] = disabled;
        else buttonProps.disabled = disabled;
    } else if (hostElementName !== "") {
        if (!href && !to) {
            buttonProps.role = "button";
            buttonProps.tabIndex = tabIndex != null ? tabIndex : 0;
        }
        if (disabled) {
            buttonProps["aria-disabled"] = disabled;
            buttonProps.tabIndex = focusableWhenDisabled ? tabIndex != null ? tabIndex : 0 : -1;
        }
    }
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $8235f986c8d7b99b$export$2e2bcd8739ae039)(parameters);
        const externalEventHandlers = (0, $cPOSH.default)({}, propsEventHandlers, otherHandlers);
        // onFocusVisible can be present on the props, but since it's not a valid React event handler,
        // it must not be forwarded to the inner component.
        delete externalEventHandlers.onFocusVisible;
        return (0, $cPOSH.default)({
            type: type
        }, externalEventHandlers, buttonProps, {
            onBlur: createHandleBlur(externalEventHandlers),
            onClick: createHandleClick(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            onKeyUp: createHandleKeyUp(externalEventHandlers),
            onMouseDown: createHandleMouseDown(externalEventHandlers),
            onMouseLeave: createHandleMouseLeave(externalEventHandlers),
            ref: handleRef
        });
    };
    return {
        getRootProps: getRootProps,
        focusVisible: focusVisible,
        setFocusVisible: setFocusVisible,
        active: active,
        rootRef: handleRef
    };
}



var $3Upoa = parcelRequire("3Upoa");

var $cwrhp = parcelRequire("cwrhp");

var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");

var $2xnzr = parcelRequire("2xnzr");

var $i5l0f = parcelRequire("i5l0f");



var $cteiL = parcelRequire("cteiL");

var $cLzOx = parcelRequire("cLzOx");
const $dbf7c9c83795547b$var$_excluded = [
    "ownerState"
], $dbf7c9c83795547b$var$_excluded2 = [
    "variants"
], $dbf7c9c83795547b$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $dbf7c9c83795547b$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $dbf7c9c83795547b$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $dbf7c9c83795547b$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $dbf7c9c83795547b$export$35e57303dbd8a66 = (0, $cteiL.default)();
const $dbf7c9c83795547b$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $dbf7c9c83795547b$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $dbf7c9c83795547b$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $dbf7c9c83795547b$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $dbf7c9c83795547b$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $aT5bD.default)(_ref, $dbf7c9c83795547b$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $cPOSH.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$dbf7c9c83795547b$var$processStyleArg(resolvedStyle, (0, $cPOSH.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $aT5bD.default)(resolvedStylesArg, $dbf7c9c83795547b$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $cPOSH.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $cPOSH.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $dbf7c9c83795547b$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $dbf7c9c83795547b$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $dbf7c9c83795547b$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $dbf7c9c83795547b$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $cLzOx.default)((0, $cPOSH.default)({}, props, {
            theme: $dbf7c9c83795547b$var$resolveTheme((0, $cPOSH.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $2xnzr.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $dbf7c9c83795547b$var$defaultOverridesResolver($dbf7c9c83795547b$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $aT5bD.default)(inputOptions, $dbf7c9c83795547b$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $dbf7c9c83795547b$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($dbf7c9c83795547b$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $2xnzr.default)(tag, (0, $cPOSH.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $i5l0f.isPlainObject)(stylesArg)) return (props)=>$dbf7c9c83795547b$var$processStyleArg(stylesArg, (0, $cPOSH.default)({}, props, {
                    theme: $dbf7c9c83795547b$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $dbf7c9c83795547b$var$resolveTheme((0, $cPOSH.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $dbf7c9c83795547b$var$processStyleArg(slotStyle, (0, $cPOSH.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $dbf7c9c83795547b$var$resolveTheme((0, $cPOSH.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $dbf7c9c83795547b$var$processStyleArg({
                    variants: themeVariants
                }, (0, $cPOSH.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}




const $6659d5459ae858ea$var$styled = (0, $dbf7c9c83795547b$export$2e2bcd8739ae039)({
    defaultTheme: $9940f683f801a8a4$export$2e2bcd8739ae039,
    themeId: (0, $d37a791f4994804c$export$2e2bcd8739ae039)
});
var $6659d5459ae858ea$export$2e2bcd8739ae039 = $6659d5459ae858ea$var$styled;


var $cPOSH = parcelRequire("cPOSH");

var $gGyf9 = parcelRequire("gGyf9");
function $c4d041f09a8dcf0e$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $gGyf9.default)(theme.components[name].defaultProps, props);
}



"use client";
function $117abe31cc6e24a1$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $65b5429f0b31aa48$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $c4d041f09a8dcf0e$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}




"use client";
function $171c82576b265f00$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $117abe31cc6e24a1$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: (0, $cPOSH.default)({}, (0, $9940f683f801a8a4$export$2e2bcd8739ae039), {
            components: {}
        }),
        themeId: (0, $d37a791f4994804c$export$2e2bcd8739ae039)
    });
}



var $1EuC8 = parcelRequire("1EuC8");



var $6iAGf = parcelRequire("6iAGf");
"use client";
const $45219fd0b0701701$var$ColorInversion = /*#__PURE__*/ $1EuC8.createContext(undefined);
const $45219fd0b0701701$export$83a9a651654e258f = (childVariant)=>{
    const overridableVariants = $1EuC8.useContext($45219fd0b0701701$var$ColorInversion);
    return {
        /**
     * Resolve the `color` value for the component.
     * @param {ColorPaletteProp | 'inherit' | undefined} instanceColorProp The color defined on the instance.
     * @param {ColorPaletteProp | 'inherit' | undefined} defaultColorProp The default color to use when variant inversion is not enabled.
     */ getColor: (instanceColorProp, defaultColorProp)=>{
            if (overridableVariants && childVariant) {
                if (overridableVariants.includes(childVariant)) // @ts-ignore internal logic
                return instanceColorProp || "context";
            }
            // @ts-ignore internal logic
            return instanceColorProp || defaultColorProp;
        }
    };
};
function $45219fd0b0701701$export$5bb76c950295560a({ children: children, variant: variant }) {
    var _theme$colorInversion;
    const theme = (0, $e4321228e0a5ec0b$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $6iAGf.jsx)($45219fd0b0701701$var$ColorInversion.Provider, {
        value: variant ? // `theme` could come from other emotion/styled-components context.
        ((_theme$colorInversion = theme.colorInversionConfig) != null ? _theme$colorInversion : (0, $9940f683f801a8a4$export$2e2bcd8739ae039).colorInversionConfig)[variant] : undefined,
        children: children
    });
}
var $45219fd0b0701701$export$2e2bcd8739ae039 = $45219fd0b0701701$var$ColorInversion;



var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");


var $cPOSH = parcelRequire("cPOSH");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $11568234ed50ba2b$export$2e2bcd8739ae039(element) {
    return typeof element === "string";
}


function $9f38751075f34162$export$2e2bcd8739ae039(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $11568234ed50ba2b$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $cPOSH.default)({}, otherProps, {
        ownerState: (0, $cPOSH.default)({}, otherProps.ownerState, ownerState)
    });
}


var $cPOSH = parcelRequire("cPOSH");
function $f8208f51eaf9f9e6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $f8208f51eaf9f9e6$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $f8208f51eaf9f9e6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $f8208f51eaf9f9e6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f8208f51eaf9f9e6$export$2e2bcd8739ae039 = $f8208f51eaf9f9e6$export$4f5d2d50c9deca37;



/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $216018a1e9199035$export$2e2bcd8739ae039(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $c276cb72d8885c90$export$2e2bcd8739ae039(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $f8208f51eaf9f9e6$export$2e2bcd8739ae039)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $cPOSH.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $cPOSH.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $8235f986c8d7b99b$export$2e2bcd8739ae039)((0, $cPOSH.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $216018a1e9199035$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $216018a1e9199035$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $f8208f51eaf9f9e6$export$2e2bcd8739ae039)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $cPOSH.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $cPOSH.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}

/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $a27a783719004546$export$2e2bcd8739ae039(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}



"use client";
const $dc17f7d5f2f13533$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $dc17f7d5f2f13533$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $dc17f7d5f2f13533$var$_excluded3 = [
    "component"
], $dc17f7d5f2f13533$var$_excluded4 = [
    "disableColorInversion"
];
function $dc17f7d5f2f13533$export$2e2bcd8739ae039(/**
 * The slot's name. All Joy UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $aT5bD.default)(parameters, $dc17f7d5f2f13533$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $aT5bD.default)(externalForwardedProps, $dc17f7d5f2f13533$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $a27a783719004546$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $c276cb72d8885c90$export$2e2bcd8739ae039)((0, $cPOSH.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === "root" ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $aT5bD.default)(_mergeSlotProps.props, $dc17f7d5f2f13533$var$_excluded3);
    const ref = (0, $ca3242a650a8aafe$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    // @ts-ignore internal logic
    const _ref = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {}, { disableColorInversion: disableColorInversion = false } = _ref, slotOwnerState = (0, $aT5bD.default)(_ref, $dc17f7d5f2f13533$var$_excluded4);
    const finalOwnerState = (0, $cPOSH.default)({}, ownerState, slotOwnerState);
    const { getColor: getColor } = (0, $45219fd0b0701701$export$83a9a651654e258f)(finalOwnerState.variant);
    if (name === "root") {
        var _color;
        // for the root slot, color inversion is calculated before the `useSlot` and pass through `ownerState`.
        finalOwnerState.color = (_color = mergedProps.color) != null ? _color : ownerState.color;
    } else if (!disableColorInversion) finalOwnerState.color = getColor(mergedProps.color, finalOwnerState.color);
    const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
    const props = (0, $9f38751075f34162$export$2e2bcd8739ae039)(elementType, (0, $cPOSH.default)({}, name === "root" && !rootComponent && !slots[name] && internalForwardedProps, name !== "root" && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");


var $1EuC8 = parcelRequire("1EuC8");


var $cwrhp = parcelRequire("cwrhp");

var $3Upoa = parcelRequire("3Upoa");

var $cOeZu = parcelRequire("cOeZu");





function $520b8c935faba83b$export$29cad1383b3f235d(slot) {
    return (0, $bd48de20fb876697$export$1d132570e11858b0)("MuiCircularProgress", slot);
}
const $520b8c935faba83b$var$circularProgressClasses = (0, $bd48de20fb876697$export$de4f15803c389669)("MuiCircularProgress", [
    "root",
    "determinate",
    "svg",
    "track",
    "progress",
    "colorPrimary",
    "colorNeutral",
    "colorDanger",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "colorContext",
    "sizeSm",
    "sizeMd",
    "sizeLg",
    "variantPlain",
    "variantOutlined",
    "variantSoft",
    "variantSolid"
]);
var $520b8c935faba83b$export$2e2bcd8739ae039 = $520b8c935faba83b$var$circularProgressClasses;



var $6iAGf = parcelRequire("6iAGf");
"use client";
let $fe3d69a7e20c10a9$var$_ = (t)=>t, $fe3d69a7e20c10a9$var$_t;
const $fe3d69a7e20c10a9$var$_excluded = [
    "color",
    "backgroundColor"
], $fe3d69a7e20c10a9$var$_excluded2 = [
    "children",
    "className",
    "color",
    "size",
    "variant",
    "thickness",
    "determinate",
    "value",
    "component",
    "slots",
    "slotProps"
];
const $fe3d69a7e20c10a9$var$circulate = (0, $cOeZu.keyframes)({
    "0%": {
        // let the progress start at the top of the ring
        transform: "rotate(-90deg)"
    },
    "100%": {
        transform: "rotate(270deg)"
    }
});
const $fe3d69a7e20c10a9$var$useUtilityClasses = (ownerState)=>{
    const { determinate: determinate, color: color, variant: variant, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            determinate && "determinate",
            color && `color${(0, $cwrhp.default)(color)}`,
            variant && `variant${(0, $cwrhp.default)(variant)}`,
            size && `size${(0, $cwrhp.default)(size)}`
        ],
        svg: [
            "svg"
        ],
        track: [
            "track"
        ],
        progress: [
            "progress"
        ]
    };
    return (0, $3Upoa.default)(slots, (0, $520b8c935faba83b$export$29cad1383b3f235d), {});
};
const $fe3d69a7e20c10a9$var$CircularProgressRoot = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("span", {
    name: "JoyCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ ownerState: ownerState, theme: theme })=>{
    var _theme$variants;
    const _ref = ((_theme$variants = theme.variants[ownerState.variant]) == null ? void 0 : _theme$variants[ownerState.color]) || {}, { color: color, backgroundColor: backgroundColor } = _ref, rest = (0, $aT5bD.default)(_ref, $fe3d69a7e20c10a9$var$_excluded);
    return (0, $cPOSH.default)({
        // integration with icon
        "--Icon-fontSize": "calc(0.4 * var(--_root-size))",
        // public variables
        "--CircularProgress-trackColor": backgroundColor,
        "--CircularProgress-progressColor": color,
        "--CircularProgress-percent": ownerState.value,
        // 0 - 100
        "--CircularProgress-linecap": "round"
    }, ownerState.size === "sm" && {
        "--CircularProgress-trackThickness": "3px",
        "--CircularProgress-progressThickness": "3px",
        "--_root-size": "var(--CircularProgress-size, 24px)" // use --_root-size to let other components overrides via --CircularProgress-size
    }, ownerState.instanceSize === "sm" && {
        "--CircularProgress-size": "24px"
    }, ownerState.size === "md" && {
        "--CircularProgress-trackThickness": "6px",
        "--CircularProgress-progressThickness": "6px",
        "--_root-size": "var(--CircularProgress-size, 40px)"
    }, ownerState.instanceSize === "md" && {
        "--CircularProgress-size": "40px"
    }, ownerState.size === "lg" && {
        "--CircularProgress-trackThickness": "8px",
        "--CircularProgress-progressThickness": "8px",
        "--_root-size": "var(--CircularProgress-size, 64px)"
    }, ownerState.instanceSize === "lg" && {
        "--CircularProgress-size": "64px"
    }, ownerState.thickness && {
        "--CircularProgress-trackThickness": `${ownerState.thickness}px`,
        "--CircularProgress-progressThickness": `${ownerState.thickness}px`
    }, {
        // internal variables
        "--_thickness-diff": "calc(var(--CircularProgress-trackThickness) - var(--CircularProgress-progressThickness))",
        "--_inner-size": "calc(var(--_root-size) - 2 * var(--variant-borderWidth, 0px))",
        "--_outlined-inset": "max(var(--CircularProgress-trackThickness), var(--CircularProgress-progressThickness))",
        width: "var(--_root-size)",
        height: "var(--_root-size)",
        borderRadius: "var(--_root-size)",
        margin: "var(--CircularProgress-margin)",
        boxSizing: "border-box",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        // prevent from shrinking when CircularProgress is in a flex container.
        position: "relative",
        color: color
    }, ownerState.children && {
        // only add font related properties when there is a child.
        // so that when there is no child, the size can be controlled by the parent font-size e.g. Link
        fontFamily: theme.vars.fontFamily.body,
        fontWeight: theme.vars.fontWeight.md,
        fontSize: "calc(0.2 * var(--_root-size))"
    }, rest, ownerState.variant === "outlined" && {
        "&:before": (0, $cPOSH.default)({
            content: '""',
            display: "block",
            position: "absolute",
            borderRadius: "inherit",
            top: "var(--_outlined-inset)",
            left: "var(--_outlined-inset)",
            right: "var(--_outlined-inset)",
            bottom: "var(--_outlined-inset)"
        }, rest)
    });
});
const $fe3d69a7e20c10a9$var$CircularProgressSvg = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("svg", {
    name: "JoyCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    width: "inherit",
    height: "inherit",
    display: "inherit",
    boxSizing: "inherit",
    position: "absolute",
    top: "calc(-1 * var(--variant-borderWidth, 0px))",
    // centered align
    left: "calc(-1 * var(--variant-borderWidth, 0px))" // centered align
});
const $fe3d69a7e20c10a9$var$CircularProgressTrack = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("circle", {
    name: "JoyCircularProgress",
    slot: "track",
    overridesResolver: (props, styles)=>styles.track
})({
    cx: "50%",
    cy: "50%",
    r: "calc(var(--_inner-size) / 2 - var(--CircularProgress-trackThickness) / 2 + min(0px, var(--_thickness-diff) / 2))",
    fill: "transparent",
    strokeWidth: "var(--CircularProgress-trackThickness)",
    stroke: "var(--CircularProgress-trackColor)"
});
const $fe3d69a7e20c10a9$var$CircularProgressProgress = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("circle", {
    name: "JoyCircularProgress",
    slot: "progress",
    overridesResolver: (props, styles)=>styles.progress
})({
    "--_progress-radius": "calc(var(--_inner-size) / 2 - var(--CircularProgress-progressThickness) / 2 - max(0px, var(--_thickness-diff) / 2))",
    "--_progress-length": "calc(2 * 3.1415926535 * var(--_progress-radius))",
    // the circumference around the progress
    cx: "50%",
    cy: "50%",
    r: "var(--_progress-radius)",
    fill: "transparent",
    strokeWidth: "var(--CircularProgress-progressThickness)",
    stroke: "var(--CircularProgress-progressColor)",
    strokeLinecap: "var(--CircularProgress-linecap, round)",
    // can't use CSS variable directly, need to cast type.
    strokeDasharray: "var(--_progress-length)",
    strokeDashoffset: "calc(var(--_progress-length) - var(--CircularProgress-percent) * var(--_progress-length) / 100)",
    transformOrigin: "center",
    transform: "rotate(-90deg)" // to initially appear at the top-center of the circle.
}, ({ ownerState: ownerState })=>!ownerState.determinate && (0, $cOeZu.css)($fe3d69a7e20c10a9$var$_t || ($fe3d69a7e20c10a9$var$_t = $fe3d69a7e20c10a9$var$_`
      animation: var(--CircularProgress-circulation, 0.8s linear 0s infinite normal none running)
        ${0};
    `), $fe3d69a7e20c10a9$var$circulate));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 *
 * Demos:
 *
 * - [Circular Progress](https://mui.com/joy-ui/react-circular-progress/)
 *
 * API:
 *
 * - [CircularProgress API](https://mui.com/joy-ui/api/circular-progress/)
 */ const $fe3d69a7e20c10a9$var$CircularProgress = /*#__PURE__*/ $1EuC8.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $171c82576b265f00$export$2e2bcd8739ae039)({
        props: inProps,
        name: "JoyCircularProgress"
    });
    const { children: children, className: className, color: colorProp = "primary", size: size = "md", variant: variant = "soft", thickness: thickness, determinate: determinate = false, value: value = determinate ? 0 : 25, component: // `25` is the 1/4 of the circle.
    component, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $aT5bD.default)(props, $fe3d69a7e20c10a9$var$_excluded2);
    const { getColor: getColor } = (0, $45219fd0b0701701$export$83a9a651654e258f)(variant);
    const color = getColor(inProps.color, colorProp);
    const ownerState = (0, $cPOSH.default)({}, props, {
        color: color,
        size: size,
        variant: variant,
        thickness: thickness,
        value: value,
        determinate: determinate,
        instanceSize: inProps.size
    });
    const classes = $fe3d69a7e20c10a9$var$useUtilityClasses(ownerState);
    const externalForwardedProps = (0, $cPOSH.default)({}, other, {
        component: component,
        slots: slots,
        slotProps: slotProps
    });
    const [SlotRoot, rootProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("root", {
        ref: ref,
        className: (0, $f8208f51eaf9f9e6$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $fe3d69a7e20c10a9$var$CircularProgressRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: (0, $cPOSH.default)({
            role: "progressbar",
            style: {
                // Setting this CSS variable via inline-style
                // prevents the generation of new CSS every time
                // `value` prop updates
                "--CircularProgress-percent": value
            }
        }, value && determinate && {
            "aria-valuenow": typeof value === "number" ? Math.round(value) : Math.round(Number(value || 0))
        })
    });
    const [SlotSvg, svgProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("svg", {
        className: classes.svg,
        elementType: $fe3d69a7e20c10a9$var$CircularProgressSvg,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SlotTrack, trackProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("track", {
        className: classes.track,
        elementType: $fe3d69a7e20c10a9$var$CircularProgressTrack,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SlotProgress, progressProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("progress", {
        className: classes.progress,
        elementType: $fe3d69a7e20c10a9$var$CircularProgressProgress,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $6iAGf.jsxs)(SlotRoot, (0, $cPOSH.default)({}, rootProps, {
        children: [
            /*#__PURE__*/ (0, $6iAGf.jsxs)(SlotSvg, (0, $cPOSH.default)({}, svgProps, {
                children: [
                    /*#__PURE__*/ (0, $6iAGf.jsx)(SlotTrack, (0, $cPOSH.default)({}, trackProps)),
                    /*#__PURE__*/ (0, $6iAGf.jsx)(SlotProgress, (0, $cPOSH.default)({}, progressProps))
                ]
            })),
            children
        ]
    }));
});
var $fe3d69a7e20c10a9$export$2e2bcd8739ae039 = $fe3d69a7e20c10a9$var$CircularProgress;



function $fedeaf294cbb40ed$export$5a6f9035944c8119(slot) {
    return (0, $bd48de20fb876697$export$1d132570e11858b0)("MuiButton", slot);
}
const $fedeaf294cbb40ed$var$buttonClasses = (0, $bd48de20fb876697$export$de4f15803c389669)("MuiButton", [
    "root",
    "colorPrimary",
    "colorNeutral",
    "colorDanger",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "colorContext",
    "variantPlain",
    "variantOutlined",
    "variantSoft",
    "variantSolid",
    "focusVisible",
    "disabled",
    "sizeSm",
    "sizeMd",
    "sizeLg",
    "fullWidth",
    "startDecorator",
    "endDecorator",
    "loading",
    "loadingIndicatorCenter"
]);
var $fedeaf294cbb40ed$export$2e2bcd8739ae039 = $fedeaf294cbb40ed$var$buttonClasses;



var $1EuC8 = parcelRequire("1EuC8");
/**
 * @ignore - internal component.
 */ const $10aba8d5e60e359c$var$ButtonGroupContext = /*#__PURE__*/ $1EuC8.createContext({});
var $10aba8d5e60e359c$export$2e2bcd8739ae039 = $10aba8d5e60e359c$var$ButtonGroupContext;



var $6iAGf = parcelRequire("6iAGf");
"use client";
const $19d5cd0cd935946e$var$_excluded = [
    "children",
    "action",
    "color",
    "variant",
    "size",
    "fullWidth",
    "startDecorator",
    "endDecorator",
    "loading",
    "loadingPosition",
    "loadingIndicator",
    "disabled",
    "component",
    "slots",
    "slotProps"
];
const $19d5cd0cd935946e$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth, size: size, variant: variant, loading: loading } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible",
            fullWidth && "fullWidth",
            variant && `variant${(0, $cwrhp.default)(variant)}`,
            color && `color${(0, $cwrhp.default)(color)}`,
            size && `size${(0, $cwrhp.default)(size)}`,
            loading && "loading"
        ],
        startDecorator: [
            "startDecorator"
        ],
        endDecorator: [
            "endDecorator"
        ],
        loadingIndicatorCenter: [
            "loadingIndicatorCenter"
        ]
    };
    const composedClasses = (0, $3Upoa.default)(slots, (0, $fedeaf294cbb40ed$export$5a6f9035944c8119), {});
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $19d5cd0cd935946e$var$ButtonStartDecorator = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("span", {
    name: "JoyButton",
    slot: "StartDecorator",
    overridesResolver: (props, styles)=>styles.startDecorator
})({
    "--Icon-margin": "0 0 0 calc(var(--Button-gap) / -2)",
    "--CircularProgress-margin": "0 0 0 calc(var(--Button-gap) / -2)",
    display: "inherit",
    marginRight: "var(--Button-gap)"
});
const $19d5cd0cd935946e$var$ButtonEndDecorator = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("span", {
    name: "JoyButton",
    slot: "EndDecorator",
    overridesResolver: (props, styles)=>styles.endDecorator
})({
    "--Icon-margin": "0 calc(var(--Button-gap) / -2) 0 0",
    "--CircularProgress-margin": "0 calc(var(--Button-gap) / -2) 0 0",
    display: "inherit",
    marginLeft: "var(--Button-gap)"
});
const $19d5cd0cd935946e$var$ButtonLoadingCenter = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("span", {
    name: "JoyButton",
    slot: "LoadingCenter",
    overridesResolver: (props, styles)=>styles.loadingIndicatorCenter
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$variants, _theme$variants2;
    return (0, $cPOSH.default)({
        display: "inherit",
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        color: (_theme$variants = theme.variants[ownerState.variant]) == null || (_theme$variants = _theme$variants[ownerState.color]) == null ? void 0 : _theme$variants.color
    }, ownerState.disabled && {
        color: (_theme$variants2 = theme.variants[`${ownerState.variant}Disabled`]) == null || (_theme$variants2 = _theme$variants2[ownerState.color]) == null ? void 0 : _theme$variants2.color
    });
});
const $19d5cd0cd935946e$export$9fff8ed8b5c249d = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("button", {
    name: "JoyButton",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$variants3, _theme$variants4, _theme$variants5, _theme$variants6;
    return [
        (0, $cPOSH.default)({
            "--Icon-margin": "initial"
        }, ownerState.size === "sm" && {
            "--Icon-fontSize": "1.25rem",
            "--CircularProgress-size": "20px",
            // must be `px` unit, otherwise the CircularProgress is broken in Safari
            "--Button-gap": "0.375rem",
            minHeight: "var(--Button-minHeight, 2rem)",
            fontSize: theme.vars.fontSize.sm,
            paddingBlock: "2px",
            paddingInline: "0.75rem"
        }, ownerState.size === "md" && {
            "--Icon-fontSize": "1.5rem",
            // control the SvgIcon font-size
            "--CircularProgress-size": "24px",
            // must be `px` unit, otherwise the CircularProgress is broken in Safari
            "--Button-gap": "0.5rem",
            minHeight: "var(--Button-minHeight, 2.5rem)",
            // use min-height instead of height to make the button resilient to its content
            fontSize: theme.vars.fontSize.sm,
            paddingBlock: "0.25rem",
            // the padding-block act as a minimum spacing between content and root element
            paddingInline: "1rem"
        }, ownerState.size === "lg" && {
            "--Icon-fontSize": "1.75rem",
            "--CircularProgress-size": "28px",
            // must be `px` unit, otherwise the CircularProgress is broken in Safari
            "--Button-gap": "0.75rem",
            minHeight: "var(--Button-minHeight, 3rem)",
            fontSize: theme.vars.fontSize.md,
            paddingBlock: "0.375rem",
            paddingInline: "1.5rem"
        }, {
            WebkitTapHighlightColor: "transparent",
            borderRadius: `var(--Button-radius, ${theme.vars.radius.sm})`,
            // to be controlled by other components, eg. Input
            margin: `var(--Button-margin)`,
            // to be controlled by other components, eg. Input
            border: "none",
            backgroundColor: "transparent",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            textDecoration: "none",
            // prevent user agent underline when used as anchor
            fontFamily: theme.vars.fontFamily.body,
            fontWeight: theme.vars.fontWeight.lg,
            lineHeight: 1
        }, ownerState.fullWidth && {
            width: "100%"
        }, {
            [theme.focus.selector]: theme.focus.default
        }),
        (_theme$variants3 = theme.variants[ownerState.variant]) == null ? void 0 : _theme$variants3[ownerState.color],
        {
            "&:hover": {
                "@media (hover: hover)": (_theme$variants4 = theme.variants[`${ownerState.variant}Hover`]) == null ? void 0 : _theme$variants4[ownerState.color]
            }
        },
        {
            "&:active": (_theme$variants5 = theme.variants[`${ownerState.variant}Active`]) == null ? void 0 : _theme$variants5[ownerState.color]
        },
        (0, $cPOSH.default)({
            [`&.${(0, $fedeaf294cbb40ed$export$2e2bcd8739ae039).disabled}`]: (_theme$variants6 = theme.variants[`${ownerState.variant}Disabled`]) == null ? void 0 : _theme$variants6[ownerState.color]
        }, ownerState.loadingPosition === "center" && {
            [`&.${(0, $fedeaf294cbb40ed$export$2e2bcd8739ae039).loading}`]: {
                color: "transparent"
            }
        })
    ];
});
/**
 *
 * Demos:
 *
 * - [Button](https://mui.com/joy-ui/react-button/)
 * - [Button Group](https://mui.com/joy-ui/react-button-group/)
 * - [Toggle Button Group](https://mui.com/joy-ui/react-toggle-button-group/)
 *
 * API:
 *
 * - [Button API](https://mui.com/joy-ui/api/button/)
 */ const $19d5cd0cd935946e$var$Button = /*#__PURE__*/ $1EuC8.forwardRef(function Button(inProps, ref) {
    var _inProps$disabled;
    const props = (0, $171c82576b265f00$export$2e2bcd8739ae039)({
        props: inProps,
        name: "JoyButton"
    });
    const { children: children, action: action, color: colorProp = "primary", variant: variantProp = "solid", size: sizeProp = "md", fullWidth: fullWidth = false, startDecorator: startDecorator, endDecorator: endDecorator, loading: loading = false, loadingPosition: loadingPosition = "center", loadingIndicator: loadingIndicatorProp, disabled: disabledProp, component: component, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $aT5bD.default)(props, $19d5cd0cd935946e$var$_excluded);
    const buttonGroup = $1EuC8.useContext((0, $10aba8d5e60e359c$export$2e2bcd8739ae039));
    const variant = inProps.variant || buttonGroup.variant || variantProp;
    const size = inProps.size || buttonGroup.size || sizeProp;
    const { getColor: getColor } = (0, $45219fd0b0701701$export$83a9a651654e258f)(variant);
    const color = getColor(inProps.color, buttonGroup.color || colorProp);
    const disabled = (_inProps$disabled = inProps.disabled) != null ? _inProps$disabled : buttonGroup.disabled || disabledProp || loading;
    const buttonRef = $1EuC8.useRef(null);
    const handleRef = (0, $ca3242a650a8aafe$export$2e2bcd8739ae039)(buttonRef, ref);
    const { focusVisible: focusVisible, setFocusVisible: setFocusVisible, getRootProps: getRootProps } = (0, $394c5beb21a0dde3$export$2e2bcd8739ae039)((0, $cPOSH.default)({}, props, {
        disabled: disabled,
        rootRef: handleRef
    }));
    const loadingIndicator = loadingIndicatorProp != null ? loadingIndicatorProp : /*#__PURE__*/ (0, $6iAGf.jsx)((0, $fe3d69a7e20c10a9$export$2e2bcd8739ae039), (0, $cPOSH.default)({}, color !== "context" && {
        color: color
    }, {
        thickness: {
            sm: 2,
            md: 3,
            lg: 4
        }[size] || 3
    }));
    $1EuC8.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                var _buttonRef$current;
                setFocusVisible(true);
                (_buttonRef$current = buttonRef.current) == null || _buttonRef$current.focus();
            }
        }), [
        setFocusVisible
    ]);
    const ownerState = (0, $cPOSH.default)({}, props, {
        color: color,
        fullWidth: fullWidth,
        variant: variant,
        size: size,
        focusVisible: focusVisible,
        loading: loading,
        loadingPosition: loadingPosition,
        disabled: disabled
    });
    const classes = $19d5cd0cd935946e$var$useUtilityClasses(ownerState);
    const externalForwardedProps = (0, $cPOSH.default)({}, other, {
        component: component,
        slots: slots,
        slotProps: slotProps
    });
    const [SlotRoot, rootProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("root", {
        ref: ref,
        className: classes.root,
        elementType: $19d5cd0cd935946e$export$9fff8ed8b5c249d,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: getRootProps,
        ownerState: ownerState
    });
    const [SlotStartDecorator, startDecoratorProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("startDecorator", {
        className: classes.startDecorator,
        elementType: $19d5cd0cd935946e$var$ButtonStartDecorator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SlotEndDecorator, endDecoratorProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("endDecorator", {
        className: classes.endDecorator,
        elementType: $19d5cd0cd935946e$var$ButtonEndDecorator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SlotLoadingIndicatorCenter, loadingIndicatorCenterProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("loadingIndicatorCenter", {
        className: classes.loadingIndicatorCenter,
        elementType: $19d5cd0cd935946e$var$ButtonLoadingCenter,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $6iAGf.jsxs)(SlotRoot, (0, $cPOSH.default)({}, rootProps, {
        children: [
            (startDecorator || loading && loadingPosition === "start") && /*#__PURE__*/ (0, $6iAGf.jsx)(SlotStartDecorator, (0, $cPOSH.default)({}, startDecoratorProps, {
                children: loading && loadingPosition === "start" ? loadingIndicator : startDecorator
            })),
            children,
            loading && loadingPosition === "center" && /*#__PURE__*/ (0, $6iAGf.jsx)(SlotLoadingIndicatorCenter, (0, $cPOSH.default)({}, loadingIndicatorCenterProps, {
                children: loadingIndicator
            })),
            (endDecorator || loading && loadingPosition === "end") && /*#__PURE__*/ (0, $6iAGf.jsx)(SlotEndDecorator, (0, $cPOSH.default)({}, endDecoratorProps, {
                children: loading && loadingPosition === "end" ? loadingIndicator : endDecorator
            }))
        ]
    }));
});
// @ts-ignore internal logic for ToggleButtonGroup
$19d5cd0cd935946e$var$Button.muiName = "Button";
var $19d5cd0cd935946e$export$2e2bcd8739ae039 = $19d5cd0cd935946e$var$Button;



var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");



var $3Upoa = parcelRequire("3Upoa");

var $cwrhp = parcelRequire("cwrhp");
var $1EuC8 = parcelRequire("1EuC8");
function $35516c82881350e3$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $1EuC8.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}






function $aaca991230063f1e$export$f3b76d2cce458caa(slot) {
    return (0, $bd48de20fb876697$export$1d132570e11858b0)("MuiCard", slot);
}
const $aaca991230063f1e$var$cardClasses = (0, $bd48de20fb876697$export$de4f15803c389669)("MuiCard", [
    "root",
    "colorPrimary",
    "colorNeutral",
    "colorDanger",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "colorContext",
    "variantPlain",
    "variantOutlined",
    "variantSoft",
    "variantSolid",
    "sizeSm",
    "sizeMd",
    "sizeLg",
    "horizontal",
    "vertical"
]);
var $aaca991230063f1e$export$2e2bcd8739ae039 = $aaca991230063f1e$var$cardClasses;



var $cPOSH = parcelRequire("cPOSH");
const $4991093a7311b3d0$export$e2527164e5bc67cc = ({ theme: theme, ownerState: ownerState }, key, defaultValue)=>{
    let parsedValue;
    let sxObject = {};
    function resolveSx(sxProp) {
        if (typeof sxProp === "function") {
            const result = sxProp(theme);
            resolveSx(result);
        } else if (Array.isArray(sxProp)) sxProp.forEach((sxItem)=>{
            if (typeof sxItem !== "boolean") resolveSx(sxItem);
        });
        else if (typeof sxProp === "object") sxObject = (0, $cPOSH.default)({}, sxObject, sxProp);
    }
    if (ownerState.sx) {
        resolveSx(ownerState.sx);
        const value = sxObject[key];
        if (typeof value === "string" || typeof value === "number") {
            if (key === "borderRadius") {
                var _theme$vars;
                if (typeof value === "number") return `${value}px`;
                parsedValue = ((_theme$vars = theme.vars) == null ? void 0 : _theme$vars.radius[value]) || value;
            } else parsedValue = value;
        }
        if (typeof value === "function") parsedValue = value(theme);
    }
    return parsedValue || defaultValue;
};




var $6iAGf = parcelRequire("6iAGf");
"use client";
const $7a200f4c9addd534$var$_excluded = [
    "className",
    "color",
    "component",
    "invertedColors",
    "size",
    "variant",
    "children",
    "orientation",
    "slots",
    "slotProps"
];
const $7a200f4c9addd534$var$useUtilityClasses = (ownerState)=>{
    const { size: size, variant: variant, color: color, orientation: orientation } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            variant && `variant${(0, $cwrhp.default)(variant)}`,
            color && `color${(0, $cwrhp.default)(color)}`,
            size && `size${(0, $cwrhp.default)(size)}`
        ]
    };
    return (0, $3Upoa.default)(slots, (0, $aaca991230063f1e$export$f3b76d2cce458caa), {});
};
const $7a200f4c9addd534$var$CardRoot = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("div", {
    name: "JoyCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$variants, _theme$colorInversion;
    return [
        (0, $cPOSH.default)({
            // a context variable for any child component
            "--Card-childRadius": "max((var(--Card-radius) - var(--variant-borderWidth, 0px)) - var(--Card-padding), min(var(--Card-padding) / 2, (var(--Card-radius) - var(--variant-borderWidth, 0px)) / 2))",
            // AspectRatio integration
            "--AspectRatio-radius": "var(--Card-childRadius)",
            // Link integration
            "--unstable_actionMargin": "calc(-1 * var(--variant-borderWidth, 0px))",
            // Link, Radio, Checkbox integration
            "--unstable_actionRadius": (0, $4991093a7311b3d0$export$e2527164e5bc67cc)({
                theme: theme,
                ownerState: ownerState
            }, "borderRadius", "var(--Card-radius)"),
            // CardCover integration
            "--CardCover-radius": "calc(var(--Card-radius) - var(--variant-borderWidth, 0px))",
            // CardOverflow integration
            "--CardOverflow-offset": `calc(-1 * var(--Card-padding))`,
            "--CardOverflow-radius": "calc(var(--Card-radius) - var(--variant-borderWidth, 0px))",
            // Divider integration
            "--Divider-inset": "calc(-1 * var(--Card-padding))"
        }, ownerState.size === "sm" && {
            "--Card-radius": theme.vars.radius.sm,
            "--Card-padding": "0.5rem",
            gap: "0.375rem 0.5rem"
        }, ownerState.size === "md" && {
            "--Card-radius": theme.vars.radius.md,
            "--Card-padding": "1rem",
            gap: "0.75rem 1rem"
        }, ownerState.size === "lg" && {
            "--Card-radius": theme.vars.radius.lg,
            "--Card-padding": "1.5rem",
            gap: "1rem 1.5rem"
        }, {
            padding: "var(--Card-padding)",
            borderRadius: "var(--Card-radius)",
            boxShadow: theme.shadow.sm,
            backgroundColor: theme.vars.palette.background.surface,
            fontFamily: theme.vars.fontFamily.body,
            fontSize: theme.vars.fontSize.md,
            position: "relative",
            display: "flex",
            flexDirection: ownerState.orientation === "horizontal" ? "row" : "column"
        }),
        (_theme$variants = theme.variants[ownerState.variant]) == null ? void 0 : _theme$variants[ownerState.color],
        ownerState.color !== "context" && ownerState.invertedColors && ((_theme$colorInversion = theme.colorInversion[ownerState.variant]) == null ? void 0 : _theme$colorInversion[ownerState.color])
    ];
});
/**
 *
 * Demos:
 *
 * - [Card](https://mui.com/joy-ui/react-card/)
 *
 * API:
 *
 * - [Card API](https://mui.com/joy-ui/api/card/)
 */ const $7a200f4c9addd534$var$Card = /*#__PURE__*/ $1EuC8.forwardRef(function Card(inProps, ref) {
    const props = (0, $171c82576b265f00$export$2e2bcd8739ae039)({
        props: inProps,
        name: "JoyCard"
    });
    const { className: className, color: colorProp = "neutral", component: component = "div", invertedColors: invertedColors = false, size: size = "md", variant: variant = "plain", children: children, orientation: orientation = "vertical", slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $aT5bD.default)(props, $7a200f4c9addd534$var$_excluded);
    const { getColor: getColor } = (0, $45219fd0b0701701$export$83a9a651654e258f)(variant);
    const color = getColor(inProps.color, colorProp);
    const ownerState = (0, $cPOSH.default)({}, props, {
        color: color,
        component: component,
        orientation: orientation,
        size: size,
        variant: variant
    });
    const classes = $7a200f4c9addd534$var$useUtilityClasses(ownerState);
    const externalForwardedProps = (0, $cPOSH.default)({}, other, {
        component: component,
        slots: slots,
        slotProps: slotProps
    });
    const [SlotRoot, rootProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("root", {
        ref: ref,
        className: (0, $f8208f51eaf9f9e6$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $7a200f4c9addd534$var$CardRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const result = /*#__PURE__*/ (0, $6iAGf.jsx)(SlotRoot, (0, $cPOSH.default)({}, rootProps, {
        children: $1EuC8.Children.map(children, (child, index)=>{
            if (!/*#__PURE__*/ $1EuC8.isValidElement(child)) return child;
            const extraProps = {};
            if ((0, $35516c82881350e3$export$2e2bcd8739ae039)(child, [
                "Divider"
            ])) {
                extraProps.inset = "inset" in child.props ? child.props.inset : "context";
                const dividerOrientation = orientation === "vertical" ? "horizontal" : "vertical";
                extraProps.orientation = "orientation" in child.props ? child.props.orientation : dividerOrientation;
            }
            if ((0, $35516c82881350e3$export$2e2bcd8739ae039)(child, [
                "CardOverflow"
            ])) {
                if (orientation === "horizontal") extraProps["data-parent"] = "Card-horizontal";
                if (orientation === "vertical") extraProps["data-parent"] = "Card-vertical";
            }
            if (index === 0) extraProps["data-first-child"] = "";
            if (index === $1EuC8.Children.count(children) - 1) extraProps["data-last-child"] = "";
            return /*#__PURE__*/ $1EuC8.cloneElement(child, extraProps);
        })
    }));
    if (invertedColors) return /*#__PURE__*/ (0, $6iAGf.jsx)((0, $45219fd0b0701701$export$5bb76c950295560a), {
        variant: variant,
        children: result
    });
    return result;
});
var $7a200f4c9addd534$export$2e2bcd8739ae039 = $7a200f4c9addd534$var$Card;



var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");



var $3Upoa = parcelRequire("3Upoa");


var $cwrhp = parcelRequire("cwrhp");
var $1EuC8 = parcelRequire("1EuC8");
"use client";
let $12e442d407fa9c9a$var$globalId = 0;
function $12e442d407fa9c9a$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $1EuC8.useState(idOverride);
    const id = idOverride || defaultId;
    $1EuC8.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $12e442d407fa9c9a$var$globalId += 1;
            setDefaultId(`mui-${$12e442d407fa9c9a$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $12e442d407fa9c9a$var$maybeReactUseId = $1EuC8["useId".toString()];
function $12e442d407fa9c9a$export$2e2bcd8739ae039(idOverride) {
    if ($12e442d407fa9c9a$var$maybeReactUseId !== undefined) {
        const reactId = $12e442d407fa9c9a$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $12e442d407fa9c9a$var$useGlobalId(idOverride);
}






function $b0c7952eb6188f20$export$31444911e4ee6fdd(slot) {
    return (0, $bd48de20fb876697$export$1d132570e11858b0)("MuiChip", slot);
}
const $b0c7952eb6188f20$var$chipClasses = (0, $bd48de20fb876697$export$de4f15803c389669)("MuiChip", [
    "root",
    "clickable",
    "colorPrimary",
    "colorNeutral",
    "colorDanger",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "colorContext",
    "disabled",
    "endDecorator",
    "focusVisible",
    "label",
    "labelSm",
    "labelMd",
    "labelLg",
    "sizeSm",
    "sizeMd",
    "sizeLg",
    "startDecorator",
    "variantPlain",
    "variantSolid",
    "variantSoft",
    "variantOutlined"
]);
var $b0c7952eb6188f20$export$2e2bcd8739ae039 = $b0c7952eb6188f20$var$chipClasses;



var $1EuC8 = parcelRequire("1EuC8");
const $55fa5a1aaf51ad41$var$ChipColorContext = /*#__PURE__*/ $1EuC8.createContext({
    disabled: undefined,
    variant: undefined,
    color: undefined
});
var $55fa5a1aaf51ad41$export$2e2bcd8739ae039 = $55fa5a1aaf51ad41$var$ChipColorContext;




var $6iAGf = parcelRequire("6iAGf");
"use client";
const $c221795da3cfda3d$var$_excluded = [
    "children",
    "className",
    "color",
    "onClick",
    "disabled",
    "size",
    "variant",
    "startDecorator",
    "endDecorator",
    "component",
    "slots",
    "slotProps"
];
const $c221795da3cfda3d$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, size: size, color: color, clickable: clickable, variant: variant, focusVisible: focusVisible } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color && `color${(0, $cwrhp.default)(color)}`,
            size && `size${(0, $cwrhp.default)(size)}`,
            variant && `variant${(0, $cwrhp.default)(variant)}`,
            clickable && "clickable"
        ],
        action: [
            "action",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ],
        label: [
            "label",
            size && `label${(0, $cwrhp.default)(size)}`
        ],
        startDecorator: [
            "startDecorator"
        ],
        endDecorator: [
            "endDecorator"
        ]
    };
    return (0, $3Upoa.default)(slots, (0, $b0c7952eb6188f20$export$31444911e4ee6fdd), {});
};
const $c221795da3cfda3d$var$ChipRoot = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("div", {
    name: "JoyChip",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$variants, _theme$variants2, _theme$variants3, _theme$variants4;
    return [
        (0, $cPOSH.default)({
            // for controlling chip delete margin offset
            "--Chip-decoratorChildOffset": "min(calc(var(--Chip-paddingInline) - (var(--_Chip-minHeight) - 2 * var(--variant-borderWidth, 0px) - var(--Chip-decoratorChildHeight)) / 2), var(--Chip-paddingInline))",
            "--Chip-decoratorChildRadius": "max(var(--_Chip-radius) - var(--variant-borderWidth, 0px) - var(--_Chip-paddingBlock), min(var(--_Chip-paddingBlock) + var(--variant-borderWidth, 0px), var(--_Chip-radius) / 2))",
            "--Chip-deleteRadius": "var(--Chip-decoratorChildRadius)",
            "--Chip-deleteSize": "var(--Chip-decoratorChildHeight)",
            "--Avatar-radius": "var(--Chip-decoratorChildRadius)",
            "--Avatar-size": "var(--Chip-decoratorChildHeight)",
            "--Icon-margin": "initial",
            // reset the icon's margin.
            "--unstable_actionRadius": "var(--_Chip-radius)"
        }, ownerState.size === "sm" && {
            "--Chip-gap": "0.25rem",
            "--Chip-paddingInline": "0.5rem",
            "--Chip-decoratorChildHeight": "calc(min(1.125rem, var(--_Chip-minHeight)) - 2 * var(--variant-borderWidth, 0px))",
            "--Icon-fontSize": "calc(var(--_Chip-minHeight) / 1.714)",
            // 0.875rem by default
            "--_Chip-minHeight": "var(--Chip-minHeight, 1.5rem)",
            fontSize: theme.vars.fontSize.xs
        }, ownerState.size === "md" && {
            "--Chip-gap": "0.375rem",
            "--Chip-paddingInline": "0.75rem",
            "--Chip-decoratorChildHeight": "min(1.375rem, var(--_Chip-minHeight))",
            "--Icon-fontSize": "calc(var(--_Chip-minHeight) / 1.778)",
            // 1.125rem by default
            "--_Chip-minHeight": "var(--Chip-minHeight, 2rem)",
            fontSize: theme.vars.fontSize.sm
        }, ownerState.size === "lg" && {
            "--Chip-gap": "0.5rem",
            "--Chip-paddingInline": "1rem",
            "--Chip-decoratorChildHeight": "min(1.75rem, var(--_Chip-minHeight))",
            "--Icon-fontSize": "calc(var(--_Chip-minHeight) / 2)",
            // 1.25rem by default
            "--_Chip-minHeight": "var(--Chip-minHeight, 2.5rem)",
            fontSize: theme.vars.fontSize.md
        }, {
            "--_Chip-radius": "var(--Chip-radius, 1.5rem)",
            "--_Chip-paddingBlock": "max((var(--_Chip-minHeight) - 2 * var(--variant-borderWidth, 0px) - var(--Chip-decoratorChildHeight)) / 2, 0px)",
            minHeight: "var(--_Chip-minHeight)",
            maxWidth: "max-content",
            // to prevent Chip from stretching to full width when used with flexbox
            paddingInline: "var(--Chip-paddingInline)",
            borderRadius: "var(--_Chip-radius)",
            position: "relative",
            fontWeight: theme.vars.fontWeight.md,
            fontFamily: theme.vars.fontFamily.body,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            whiteSpace: "nowrap",
            textDecoration: "none",
            verticalAlign: "middle",
            boxSizing: "border-box",
            [`&.${(0, $b0c7952eb6188f20$export$2e2bcd8739ae039).disabled}`]: {
                color: (_theme$variants = theme.variants[`${ownerState.variant}Disabled`]) == null || (_theme$variants = _theme$variants[ownerState.color]) == null ? void 0 : _theme$variants.color
            }
        }),
        ...!ownerState.clickable ? [
            (_theme$variants2 = theme.variants[ownerState.variant]) == null ? void 0 : _theme$variants2[ownerState.color],
            {
                [`&.${(0, $b0c7952eb6188f20$export$2e2bcd8739ae039).disabled}`]: (_theme$variants3 = theme.variants[`${ownerState.variant}Disabled`]) == null ? void 0 : _theme$variants3[ownerState.color]
            }
        ] : [
            {
                "--variant-borderWidth": "0px",
                color: (_theme$variants4 = theme.variants[ownerState.variant]) == null || (_theme$variants4 = _theme$variants4[ownerState.color]) == null ? void 0 : _theme$variants4.color
            }
        ]
    ];
});
const $c221795da3cfda3d$var$ChipLabel = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("span", {
    name: "JoyChip",
    slot: "Label",
    overridesResolver: (props, styles)=>styles.label
})(({ ownerState: ownerState })=>(0, $cPOSH.default)({
        display: "inline-block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        order: 1,
        minInlineSize: 0,
        flexGrow: 1
    }, ownerState.clickable && {
        zIndex: 1,
        pointerEvents: "none"
    }));
const $c221795da3cfda3d$var$ChipAction = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("button", {
    name: "JoyChip",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$variants5, _theme$variants6, _theme$variants7, _theme$variants8;
    return [
        {
            position: "absolute",
            zIndex: 0,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            width: "100%",
            // To fix Firefox issue (https://github.com/mui/material-ui/issues/36877)
            border: "none",
            cursor: "pointer",
            padding: "initial",
            margin: "initial",
            backgroundColor: "initial",
            textDecoration: "none",
            borderRadius: "inherit",
            [theme.focus.selector]: theme.focus.default
        },
        (_theme$variants5 = theme.variants[ownerState.variant]) == null ? void 0 : _theme$variants5[ownerState.color],
        {
            "&:hover": (_theme$variants6 = theme.variants[`${ownerState.variant}Hover`]) == null ? void 0 : _theme$variants6[ownerState.color]
        },
        {
            "&:active": (_theme$variants7 = theme.variants[`${ownerState.variant}Active`]) == null ? void 0 : _theme$variants7[ownerState.color]
        },
        {
            [`&.${(0, $b0c7952eb6188f20$export$2e2bcd8739ae039).disabled}`]: (_theme$variants8 = theme.variants[`${ownerState.variant}Disabled`]) == null ? void 0 : _theme$variants8[ownerState.color]
        }
    ];
});
const $c221795da3cfda3d$var$ChipStartDecorator = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("span", {
    name: "JoyChip",
    slot: "StartDecorator",
    overridesResolver: (props, styles)=>styles.startDecorator
})({
    "--Avatar-marginInlineStart": "calc(var(--Chip-decoratorChildOffset) * -1)",
    "--Chip-deleteMargin": "0 0 0 calc(var(--Chip-decoratorChildOffset) * -1)",
    "--Icon-margin": "0 0 0 calc(var(--Chip-paddingInline) / -4)",
    display: "inherit",
    marginInlineEnd: "var(--Chip-gap)",
    // set zIndex to 1 with order to stay on top of other controls, eg. Checkbox, Radio
    order: 0,
    zIndex: 1,
    pointerEvents: "none"
});
const $c221795da3cfda3d$var$ChipEndDecorator = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("span", {
    name: "JoyChip",
    slot: "EndDecorator",
    overridesResolver: (props, styles)=>styles.endDecorator
})({
    "--Chip-deleteMargin": "0 calc(var(--Chip-decoratorChildOffset) * -1) 0 0",
    "--Icon-margin": "0 calc(var(--Chip-paddingInline) / -4) 0 0",
    display: "inherit",
    marginInlineStart: "var(--Chip-gap)",
    // set zIndex to 1 with order to stay on top of other controls, eg. Checkbox, Radio
    order: 2,
    zIndex: 1,
    pointerEvents: "none"
});
/**
 * Chips represent complex entities in small blocks, such as a contact.
 *
 * Demos:
 *
 * - [Chip](https://mui.com/joy-ui/react-chip/)
 *
 * API:
 *
 * - [Chip API](https://mui.com/joy-ui/api/chip/)
 */ const $c221795da3cfda3d$var$Chip = /*#__PURE__*/ $1EuC8.forwardRef(function Chip(inProps, ref) {
    const props = (0, $171c82576b265f00$export$2e2bcd8739ae039)({
        props: inProps,
        name: "JoyChip"
    });
    const { children: children, className: className, color: colorProp = "primary", onClick: onClick, disabled: disabled = false, size: size = "md", variant: variant = "solid", startDecorator: startDecorator, endDecorator: endDecorator, component: component, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $aT5bD.default)(props, $c221795da3cfda3d$var$_excluded);
    const { getColor: getColor } = (0, $45219fd0b0701701$export$83a9a651654e258f)(variant);
    const color = getColor(inProps.color, colorProp);
    const clickable = !!onClick || !!slotProps.action;
    const ownerState = (0, $cPOSH.default)({}, props, {
        disabled: disabled,
        size: size,
        color: color,
        variant: variant,
        clickable: clickable,
        focusVisible: false
    });
    const resolvedActionProps = typeof slotProps.action === "function" ? slotProps.action(ownerState) : slotProps.action;
    const actionRef = $1EuC8.useRef(null);
    const { focusVisible: focusVisible, getRootProps: getRootProps } = (0, $394c5beb21a0dde3$export$2e2bcd8739ae039)((0, $cPOSH.default)({}, resolvedActionProps, {
        disabled: disabled,
        rootRef: actionRef
    }));
    ownerState.focusVisible = focusVisible;
    const classes = $c221795da3cfda3d$var$useUtilityClasses(ownerState);
    const externalForwardedProps = (0, $cPOSH.default)({}, other, {
        component: component,
        slots: slots,
        slotProps: slotProps
    });
    const [SlotRoot, rootProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("root", {
        ref: ref,
        className: (0, $f8208f51eaf9f9e6$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $c221795da3cfda3d$var$ChipRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SlotLabel, labelProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("label", {
        className: classes.label,
        elementType: $c221795da3cfda3d$var$ChipLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    // @ts-ignore internal logic.
    const id = (0, $12e442d407fa9c9a$export$2e2bcd8739ae039)(labelProps.id);
    const [SlotAction, actionProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("action", {
        className: classes.action,
        elementType: $c221795da3cfda3d$var$ChipAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: getRootProps,
        additionalProps: {
            "aria-labelledby": id,
            as: resolvedActionProps == null ? void 0 : resolvedActionProps.component,
            onClick: onClick
        }
    });
    const [SlotStartDecorator, startDecoratorProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("startDecorator", {
        className: classes.startDecorator,
        elementType: $c221795da3cfda3d$var$ChipStartDecorator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SlotEndDecorator, endDecoratorProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("endDecorator", {
        className: classes.endDecorator,
        elementType: $c221795da3cfda3d$var$ChipEndDecorator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const chipContextValue = $1EuC8.useMemo(()=>({
            disabled: disabled,
            variant: variant,
            color: color === "context" ? undefined : color
        }), [
        color,
        disabled,
        variant
    ]);
    return /*#__PURE__*/ (0, $6iAGf.jsx)((0, $55fa5a1aaf51ad41$export$2e2bcd8739ae039).Provider, {
        value: chipContextValue,
        children: /*#__PURE__*/ (0, $6iAGf.jsxs)(SlotRoot, (0, $cPOSH.default)({}, rootProps, {
            children: [
                clickable && /*#__PURE__*/ (0, $6iAGf.jsx)(SlotAction, (0, $cPOSH.default)({}, actionProps)),
                /*#__PURE__*/ (0, $6iAGf.jsx)(SlotLabel, (0, $cPOSH.default)({}, labelProps, {
                    id: id,
                    children: children
                })),
                startDecorator && /*#__PURE__*/ (0, $6iAGf.jsx)(SlotStartDecorator, (0, $cPOSH.default)({}, startDecoratorProps, {
                    children: startDecorator
                })),
                endDecorator && /*#__PURE__*/ (0, $6iAGf.jsx)(SlotEndDecorator, (0, $cPOSH.default)({}, endDecoratorProps, {
                    children: endDecorator
                }))
            ]
        }))
    });
});
var $c221795da3cfda3d$export$2e2bcd8739ae039 = $c221795da3cfda3d$var$Chip;





var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");



var $cwrhp = parcelRequire("cwrhp");

var $3Upoa = parcelRequire("3Upoa");


function $4c68c825b25c6975$export$46f01d01378ec5a2(slot) {
    return (0, $bd48de20fb876697$export$1d132570e11858b0)("MuiDivider", slot);
}
const $4c68c825b25c6975$var$dividerClasses = (0, $bd48de20fb876697$export$de4f15803c389669)("MuiDivider", [
    "root",
    "horizontal",
    "vertical",
    "insetContext",
    "insetNone"
]);
var $4c68c825b25c6975$export$2e2bcd8739ae039 = $4c68c825b25c6975$var$dividerClasses;




var $6iAGf = parcelRequire("6iAGf");
"use client";
const $7494f686b33c5859$var$_excluded = [
    "className",
    "children",
    "component",
    "inset",
    "orientation",
    "role",
    "slots",
    "slotProps"
];
const $7494f686b33c5859$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, inset: inset } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            inset && `inset${(0, $cwrhp.default)(inset)}`
        ]
    };
    return (0, $3Upoa.default)(slots, (0, $4c68c825b25c6975$export$46f01d01378ec5a2), {});
};
const $7494f686b33c5859$export$2abe4bff6b8d30f3 = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("hr", {
    name: "JoyDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $cPOSH.default)({
        "--Divider-thickness": "1px",
        "--Divider-lineColor": theme.vars.palette.divider
    }, ownerState.inset === "none" && {
        "--_Divider-inset": "0px"
    }, ownerState.inset === "context" && {
        "--_Divider-inset": "var(--Divider-inset, 0px)"
    }, {
        margin: "initial",
        // reset margin for `hr` tag
        marginInline: ownerState.orientation === "vertical" ? "initial" : "var(--_Divider-inset)",
        marginBlock: ownerState.orientation === "vertical" ? "var(--_Divider-inset)" : "initial",
        position: "relative",
        alignSelf: "stretch",
        flexShrink: 0
    }, ownerState.children ? {
        "--Divider-gap": theme.spacing(1),
        "--Divider-childPosition": "50%",
        display: "flex",
        flexDirection: ownerState.orientation === "vertical" ? "column" : "row",
        alignItems: "center",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        fontFamily: theme.vars.fontFamily.body,
        fontSize: theme.vars.fontSize.sm,
        "&::before, &::after": {
            position: "relative",
            inlineSize: ownerState.orientation === "vertical" ? "var(--Divider-thickness)" : "initial",
            blockSize: ownerState.orientation === "vertical" ? "initial" : "var(--Divider-thickness)",
            backgroundColor: "var(--Divider-lineColor)",
            // use logical size + background is better than border because they work with gradient.
            content: '""'
        },
        "&::before": {
            marginInlineEnd: ownerState.orientation === "vertical" ? "initial" : "min(var(--Divider-childPosition) * 999, var(--Divider-gap))",
            marginBlockEnd: ownerState.orientation === "vertical" ? "min(var(--Divider-childPosition) * 999, var(--Divider-gap))" : "initial",
            flexBasis: "var(--Divider-childPosition)"
        },
        "&::after": {
            marginInlineStart: ownerState.orientation === "vertical" ? "initial" : "min((100% - var(--Divider-childPosition)) * 999, var(--Divider-gap))",
            marginBlockStart: ownerState.orientation === "vertical" ? "min((100% - var(--Divider-childPosition)) * 999, var(--Divider-gap))" : "initial",
            flexBasis: "calc(100% - var(--Divider-childPosition))"
        }
    } : {
        border: "none",
        // reset the border for `hr` tag
        listStyle: "none",
        backgroundColor: "var(--Divider-lineColor)",
        // use logical size + background is better than border because they work with gradient.
        inlineSize: ownerState.orientation === "vertical" ? "var(--Divider-thickness)" : "initial",
        blockSize: ownerState.orientation === "vertical" ? "initial" : "var(--Divider-thickness)"
    }));
/**
 *
 * Demos:
 *
 * - [Divider](https://mui.com/joy-ui/react-divider/)
 *
 * API:
 *
 * - [Divider API](https://mui.com/joy-ui/api/divider/)
 */ const $7494f686b33c5859$var$Divider = /*#__PURE__*/ $1EuC8.forwardRef(function Divider(inProps, ref) {
    const props = (0, $171c82576b265f00$export$2e2bcd8739ae039)({
        props: inProps,
        name: "JoyDivider"
    });
    const { className: className, children: children, component: component = children !== undefined && children !== null ? "div" : "hr", inset: inset, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $aT5bD.default)(props, $7494f686b33c5859$var$_excluded);
    const ownerState = (0, $cPOSH.default)({}, props, {
        inset: inset,
        role: role,
        orientation: orientation,
        component: component
    });
    const classes = $7494f686b33c5859$var$useUtilityClasses(ownerState);
    const externalForwardedProps = (0, $cPOSH.default)({}, other, {
        component: component,
        slots: slots,
        slotProps: slotProps
    });
    const [SlotRoot, rootProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("root", {
        ref: ref,
        className: (0, $f8208f51eaf9f9e6$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $7494f686b33c5859$export$2abe4bff6b8d30f3,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: (0, $cPOSH.default)({
            as: component,
            role: role
        }, role === "separator" && orientation === "vertical" && {
            // The implicit aria-orientation of separator is 'horizontal'
            // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/separator_role
            "aria-orientation": "vertical"
        })
    });
    return /*#__PURE__*/ (0, $6iAGf.jsx)(SlotRoot, (0, $cPOSH.default)({}, rootProps, {
        children: children
    }));
});
// @ts-ignore internal logic
$7494f686b33c5859$var$Divider.muiName = "Divider";
var $7494f686b33c5859$export$2e2bcd8739ae039 = $7494f686b33c5859$var$Divider;



var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");


var $cwrhp = parcelRequire("cwrhp");


var $3Upoa = parcelRequire("3Upoa");




function $022558a17f0acc63$export$5e8702d71474f093(slot) {
    return (0, $bd48de20fb876697$export$1d132570e11858b0)("MuiIconButton", slot);
}
const $022558a17f0acc63$var$iconButtonClasses = (0, $bd48de20fb876697$export$de4f15803c389669)("MuiIconButton", [
    "root",
    "colorPrimary",
    "colorNeutral",
    "colorDanger",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "colorContext",
    "variantPlain",
    "variantOutlined",
    "variantSoft",
    "variantSolid",
    "focusVisible",
    "disabled",
    "sizeSm",
    "sizeMd",
    "sizeLg"
]);
var $022558a17f0acc63$export$2e2bcd8739ae039 = $022558a17f0acc63$var$iconButtonClasses;




var $6iAGf = parcelRequire("6iAGf");
"use client";
const $c33af7c22d14ddc1$var$_excluded = [
    "children",
    "action",
    "component",
    "color",
    "disabled",
    "variant",
    "size",
    "slots",
    "slotProps"
];
const $c33af7c22d14ddc1$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible",
            variant && `variant${(0, $cwrhp.default)(variant)}`,
            color && `color${(0, $cwrhp.default)(color)}`,
            size && `size${(0, $cwrhp.default)(size)}`
        ]
    };
    const composedClasses = (0, $3Upoa.default)(slots, (0, $022558a17f0acc63$export$5e8702d71474f093), {});
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $c33af7c22d14ddc1$export$2e4108fd8c581ed2 = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("button")(({ theme: theme, ownerState: ownerState })=>{
    var _theme$variants, _theme$variants2, _theme$variants3, _theme$variants4;
    return [
        (0, $cPOSH.default)({
            "--Icon-margin": "initial"
        }, ownerState.instanceSize && {
            "--IconButton-size": ({
                sm: "2rem",
                md: "2.5rem",
                lg: "3rem"
            })[ownerState.instanceSize]
        }, ownerState.size === "sm" && {
            "--Icon-fontSize": "calc(var(--IconButton-size, 2rem) / 1.6)",
            // 1.25rem by default
            "--CircularProgress-size": "20px",
            minWidth: "var(--IconButton-size, 2rem)",
            // use min-width instead of height to make the button resilient to its content
            minHeight: "var(--IconButton-size, 2rem)",
            // use min-height instead of height to make the button resilient to its content
            fontSize: theme.vars.fontSize.sm,
            paddingInline: "2px" // add a gap, in case the content is long, e.g. multiple icons
        }, ownerState.size === "md" && {
            "--Icon-fontSize": "calc(var(--IconButton-size, 2.5rem) / 1.667)",
            // 1.5rem by default
            "--CircularProgress-size": "24px",
            minWidth: "var(--IconButton-size, 2.5rem)",
            minHeight: "var(--IconButton-size, 2.5rem)",
            fontSize: theme.vars.fontSize.md,
            paddingInline: "0.25rem"
        }, ownerState.size === "lg" && {
            "--Icon-fontSize": "calc(var(--IconButton-size, 3rem) / 1.714)",
            // 1.75rem by default
            "--CircularProgress-size": "28px",
            minWidth: "var(--IconButton-size, 3rem)",
            minHeight: "var(--IconButton-size, 3rem)",
            fontSize: theme.vars.fontSize.lg,
            paddingInline: "0.375rem"
        }, {
            WebkitTapHighlightColor: "transparent",
            paddingBlock: 0,
            fontFamily: theme.vars.fontFamily.body,
            fontWeight: theme.vars.fontWeight.md,
            margin: `var(--IconButton-margin)`,
            // to be controlled by other components, eg. Input
            borderRadius: `var(--IconButton-radius, ${theme.vars.radius.sm})`,
            // to be controlled by other components, eg. Input
            border: "none",
            boxSizing: "border-box",
            backgroundColor: "transparent",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            [theme.focus.selector]: theme.focus.default
        }),
        (_theme$variants = theme.variants[ownerState.variant]) == null ? void 0 : _theme$variants[ownerState.color],
        {
            "&:hover": {
                "@media (hover: hover)": (_theme$variants2 = theme.variants[`${ownerState.variant}Hover`]) == null ? void 0 : _theme$variants2[ownerState.color]
            }
        },
        {
            "&:active": (_theme$variants3 = theme.variants[`${ownerState.variant}Active`]) == null ? void 0 : _theme$variants3[ownerState.color]
        },
        {
            [`&.${(0, $022558a17f0acc63$export$2e2bcd8739ae039).disabled}`]: (_theme$variants4 = theme.variants[`${ownerState.variant}Disabled`]) == null ? void 0 : _theme$variants4[ownerState.color]
        }
    ];
});
const $c33af7c22d14ddc1$export$7b82842428427ccc = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)($c33af7c22d14ddc1$export$2e4108fd8c581ed2, {
    name: "JoyIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Button](https://mui.com/joy-ui/react-button/)
 * - [Button Group](https://mui.com/joy-ui/react-button-group/)
 * - [Toggle Button Group](https://mui.com/joy-ui/react-toggle-button-group/)
 *
 * API:
 *
 * - [IconButton API](https://mui.com/joy-ui/api/icon-button/)
 */ const $c33af7c22d14ddc1$var$IconButton = /*#__PURE__*/ $1EuC8.forwardRef(function IconButton(inProps, ref) {
    var _inProps$disabled;
    const props = (0, $171c82576b265f00$export$2e2bcd8739ae039)({
        props: inProps,
        name: "JoyIconButton"
    });
    const { children: children, action: action, component: component = "button", color: colorProp = "primary", disabled: disabledProp, variant: variantProp = "soft", size: sizeProp = "md", slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $aT5bD.default)(props, $c33af7c22d14ddc1$var$_excluded);
    const buttonGroup = $1EuC8.useContext((0, $10aba8d5e60e359c$export$2e2bcd8739ae039));
    const variant = inProps.variant || buttonGroup.variant || variantProp;
    const size = inProps.size || buttonGroup.size || sizeProp;
    const { getColor: getColor } = (0, $45219fd0b0701701$export$83a9a651654e258f)(variant);
    const color = getColor(inProps.color, buttonGroup.color || colorProp);
    const disabled = (_inProps$disabled = inProps.disabled) != null ? _inProps$disabled : buttonGroup.disabled || disabledProp;
    const buttonRef = $1EuC8.useRef(null);
    const handleRef = (0, $ca3242a650a8aafe$export$2e2bcd8739ae039)(buttonRef, ref);
    const { focusVisible: focusVisible, setFocusVisible: setFocusVisible, getRootProps: getRootProps } = (0, $394c5beb21a0dde3$export$2e2bcd8739ae039)((0, $cPOSH.default)({}, props, {
        disabled: disabled,
        rootRef: handleRef
    }));
    $1EuC8.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                var _buttonRef$current;
                setFocusVisible(true);
                (_buttonRef$current = buttonRef.current) == null || _buttonRef$current.focus();
            }
        }), [
        setFocusVisible
    ]);
    const ownerState = (0, $cPOSH.default)({}, props, {
        component: component,
        color: color,
        disabled: disabled,
        variant: variant,
        size: size,
        focusVisible: focusVisible,
        instanceSize: inProps.size
    });
    const classes = $c33af7c22d14ddc1$var$useUtilityClasses(ownerState);
    const externalForwardedProps = (0, $cPOSH.default)({}, other, {
        component: component,
        slots: slots,
        slotProps: slotProps
    });
    const [SlotRoot, rootProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("root", {
        ref: ref,
        className: classes.root,
        elementType: $c33af7c22d14ddc1$export$7b82842428427ccc,
        getSlotProps: getRootProps,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $6iAGf.jsx)(SlotRoot, (0, $cPOSH.default)({}, rootProps, {
        children: children
    }));
});
// @ts-ignore internal logic for ToggleButtonGroup
$c33af7c22d14ddc1$var$IconButton.muiName = "IconButton";
var $c33af7c22d14ddc1$export$2e2bcd8739ae039 = $c33af7c22d14ddc1$var$IconButton;



var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");


var $cwrhp = parcelRequire("cwrhp");

var $3Upoa = parcelRequire("3Upoa");




function $4b0026a77aa5ace9$export$cdb270390122322b(slot) {
    return (0, $bd48de20fb876697$export$1d132570e11858b0)("MuiInput", slot);
}
const $4b0026a77aa5ace9$var$inputClasses = (0, $bd48de20fb876697$export$de4f15803c389669)("MuiInput", [
    "root",
    "input",
    "formControl",
    "focused",
    "disabled",
    "error",
    "adornedStart",
    "adornedEnd",
    "colorPrimary",
    "colorNeutral",
    "colorDanger",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "colorContext",
    "sizeSm",
    "sizeMd",
    "sizeLg",
    "variantPlain",
    "variantOutlined",
    "variantSoft",
    "variantSolid",
    "fullWidth",
    "startDecorator",
    "endDecorator"
]);
var $4b0026a77aa5ace9$export$2e2bcd8739ae039 = $4b0026a77aa5ace9$var$inputClasses;



var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");

var $1EuC8 = parcelRequire("1EuC8");

var $cPOSH = parcelRequire("cPOSH");

var $49nsw = parcelRequire("49nsw");

var $1EuC8 = parcelRequire("1EuC8");

var $1EuC8 = parcelRequire("1EuC8");

var $1EuC8 = parcelRequire("1EuC8");
/**
 * @ignore - internal component.
 */ const $cf564c4850b3705d$var$FormControlContext = /*#__PURE__*/ $1EuC8.createContext(undefined);
var $cf564c4850b3705d$export$2e2bcd8739ae039 = $cf564c4850b3705d$var$FormControlContext;


"use client";
function $3552ff9f7922049d$export$2e2bcd8739ae039() {
    return $1EuC8.useContext((0, $cf564c4850b3705d$export$2e2bcd8739ae039));
}



"use client";
function $cf72909041d9414e$export$2e2bcd8739ae039(parameters) {
    const { defaultValue: defaultValueProp, disabled: disabledProp = false, error: errorProp = false, onBlur: onBlur, onChange: onChange, onFocus: onFocus, required: requiredProp = false, value: valueProp, inputRef: inputRefProp } = parameters;
    const formControlContext = (0, $3552ff9f7922049d$export$2e2bcd8739ae039)();
    let defaultValue;
    let disabled;
    let error;
    let required;
    let value;
    if (formControlContext) {
        var _formControlContext$d, _formControlContext$e, _formControlContext$r;
        defaultValue = undefined;
        disabled = (_formControlContext$d = formControlContext.disabled) != null ? _formControlContext$d : false;
        error = (_formControlContext$e = formControlContext.error) != null ? _formControlContext$e : false;
        required = (_formControlContext$r = formControlContext.required) != null ? _formControlContext$r : false;
        value = formControlContext.value;
    } else {
        defaultValue = defaultValueProp;
        disabled = disabledProp;
        error = errorProp;
        required = requiredProp;
        value = valueProp;
    }
    const { current: isControlled } = $1EuC8.useRef(value != null);
    const handleInputRefWarning = $1EuC8.useCallback((instance)=>{}, []);
    const inputRef = $1EuC8.useRef(null);
    const handleInputRef = (0, $ca3242a650a8aafe$export$2e2bcd8739ae039)(inputRef, inputRefProp, handleInputRefWarning);
    const [focused, setFocused] = $1EuC8.useState(false);
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $1EuC8.useEffect(()=>{
        if (!formControlContext && disabled && focused) {
            setFocused(false);
            // @ts-ignore
            onBlur == null || onBlur();
        }
    }, [
        formControlContext,
        disabled,
        focused,
        onBlur
    ]);
    const handleFocus = (otherHandlers)=>(event)=>{
            var _otherHandlers$onFocu;
            // Fix a bug with IE11 where the focus/blur events are triggered
            // while the component is disabled.
            if (formControlContext != null && formControlContext.disabled) {
                event.stopPropagation();
                return;
            }
            (_otherHandlers$onFocu = otherHandlers.onFocus) == null || _otherHandlers$onFocu.call(otherHandlers, event);
            if (formControlContext && formControlContext.onFocus) {
                var _formControlContext$o;
                formControlContext == null || (_formControlContext$o = formControlContext.onFocus) == null || _formControlContext$o.call(formControlContext);
            } else setFocused(true);
        };
    const handleBlur = (otherHandlers)=>(event)=>{
            var _otherHandlers$onBlur;
            (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
            if (formControlContext && formControlContext.onBlur) formControlContext.onBlur();
            else setFocused(false);
        };
    const handleChange = (otherHandlers)=>(event, ...args)=>{
            var _formControlContext$o2, _otherHandlers$onChan;
            if (!isControlled) {
                const element = event.target || inputRef.current;
                if (element == null) throw new Error((0, $49nsw.default)(17));
            }
            formControlContext == null || (_formControlContext$o2 = formControlContext.onChange) == null || _formControlContext$o2.call(formControlContext, event);
            // @ts-ignore
            (_otherHandlers$onChan = otherHandlers.onChange) == null || _otherHandlers$onChan.call(otherHandlers, event, ...args);
        };
    const handleClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
        };
    const getRootProps = (externalProps = {})=>{
        // onBlur, onChange and onFocus are forwarded to the input slot.
        const propsEventHandlers = (0, $8235f986c8d7b99b$export$2e2bcd8739ae039)(parameters, [
            "onBlur",
            "onChange",
            "onFocus"
        ]);
        const externalEventHandlers = (0, $cPOSH.default)({}, propsEventHandlers, (0, $8235f986c8d7b99b$export$2e2bcd8739ae039)(externalProps));
        return (0, $cPOSH.default)({}, externalProps, externalEventHandlers, {
            onClick: handleClick(externalEventHandlers)
        });
    };
    const getInputProps = (externalProps = {})=>{
        const propsEventHandlers = {
            onBlur: onBlur,
            onChange: onChange,
            onFocus: onFocus
        };
        const externalEventHandlers = (0, $cPOSH.default)({}, propsEventHandlers, (0, $8235f986c8d7b99b$export$2e2bcd8739ae039)(externalProps));
        const mergedEventHandlers = (0, $cPOSH.default)({}, externalProps, externalEventHandlers, {
            onBlur: handleBlur(externalEventHandlers),
            onChange: handleChange(externalEventHandlers),
            onFocus: handleFocus(externalEventHandlers)
        });
        return (0, $cPOSH.default)({}, mergedEventHandlers, {
            "aria-invalid": error || undefined,
            defaultValue: defaultValue,
            ref: handleInputRef,
            value: value,
            required: required,
            disabled: disabled
        });
    };
    return {
        disabled: disabled,
        error: error,
        focused: focused,
        formControlContext: formControlContext,
        getInputProps: getInputProps,
        getRootProps: getRootProps,
        inputRef: handleInputRef,
        required: required,
        value: value
    };
}



var $1EuC8 = parcelRequire("1EuC8");
/**
 * @internal
 */ const $44eef2669daae111$var$FormControlContext = /*#__PURE__*/ $1EuC8.createContext(undefined);
var $44eef2669daae111$export$2e2bcd8739ae039 = $44eef2669daae111$var$FormControlContext;


"use client";
const $3182e84f5a1ecea4$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "aria-labelledby",
    "autoComplete",
    "autoFocus",
    "className",
    "defaultValue",
    "disabled",
    "error",
    "id",
    "name",
    "onClick",
    "onChange",
    "onKeyDown",
    "onKeyUp",
    "onFocus",
    "onBlur",
    "placeholder",
    "readOnly",
    "required",
    "type",
    "value"
];
function $3182e84f5a1ecea4$export$2e2bcd8739ae039(props, classes) {
    const formControl = $1EuC8.useContext((0, $44eef2669daae111$export$2e2bcd8739ae039));
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, defaultValue: defaultValue, disabled: disabledProp, error: errorProp, id: id, name: name, onClick: onClick, onChange: onChange, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder, readOnly: readOnly, required: required, type: type, value: value } = props, other = (0, $aT5bD.default)(props, $3182e84f5a1ecea4$var$_excluded);
    const { getRootProps: getRootProps, getInputProps: getInputProps, focused: focused, error: error, disabled: disabled } = (0, $cf72909041d9414e$export$2e2bcd8739ae039)({
        disabled: disabledProp != null ? disabledProp : formControl == null ? void 0 : formControl.disabled,
        defaultValue: defaultValue,
        error: errorProp,
        onBlur: onBlur,
        onClick: onClick,
        onChange: onChange,
        onFocus: onFocus,
        required: required != null ? required : formControl == null ? void 0 : formControl.required,
        value: value
    });
    const rootStateClasses = {
        [classes.disabled]: disabled,
        [classes.error]: error,
        [classes.focused]: focused,
        [classes.formControl]: Boolean(formControl),
        [className]: className
    };
    const inputStateClasses = {
        [classes.disabled]: disabled
    };
    const propsToForward = {
        "aria-describedby": ariaDescribedby,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        disabled: disabled,
        id: id,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        name: name,
        placeholder: placeholder,
        readOnly: readOnly,
        type: type
    };
    return (0, $cPOSH.default)({
        formControl: formControl,
        propsToForward: propsToForward,
        rootStateClasses: rootStateClasses,
        inputStateClasses: inputStateClasses,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        focused: focused,
        error: error,
        disabled: disabled
    }, other);
}



var $6iAGf = parcelRequire("6iAGf");
"use client";
const $f049161e9712eaba$var$_excluded = [
    "propsToForward",
    "rootStateClasses",
    "inputStateClasses",
    "getRootProps",
    "getInputProps",
    "formControl",
    "focused",
    "error",
    "disabled",
    "fullWidth",
    "size",
    "color",
    "variant",
    "startDecorator",
    "endDecorator",
    "component",
    "slots",
    "slotProps"
];
const $f049161e9712eaba$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, fullWidth: fullWidth, variant: variant, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            fullWidth && "fullWidth",
            variant && `variant${(0, $cwrhp.default)(variant)}`,
            color && `color${(0, $cwrhp.default)(color)}`,
            size && `size${(0, $cwrhp.default)(size)}`
        ],
        input: [
            "input"
        ],
        startDecorator: [
            "startDecorator"
        ],
        endDecorator: [
            "endDecorator"
        ]
    };
    return (0, $3Upoa.default)(slots, (0, $4b0026a77aa5ace9$export$cdb270390122322b), {});
};
const $f049161e9712eaba$export$bbbd086689f6e686 = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("div")(({ theme: theme, ownerState: ownerState })=>{
    var _theme$variants, _theme$vars$palette, _variantStyle$backgro, _theme$variants2, _theme$variants3;
    const variantStyle = (_theme$variants = theme.variants[`${ownerState.variant}`]) == null ? void 0 : _theme$variants[ownerState.color];
    return [
        (0, $cPOSH.default)({
            "--Input-radius": theme.vars.radius.sm,
            "--Input-gap": "0.5rem",
            "--Input-placeholderColor": "inherit",
            "--Input-placeholderOpacity": 0.5,
            "--Input-focused": "0",
            "--Input-focusedThickness": theme.vars.focus.thickness
        }, ownerState.color === "context" ? {
            "--Input-focusedHighlight": theme.vars.palette.focusVisible
        } : {
            "--Input-focusedHighlight": (_theme$vars$palette = theme.vars.palette[ownerState.color === "neutral" ? "primary" : ownerState.color]) == null ? void 0 : _theme$vars$palette[500]
        }, ownerState.size === "sm" && {
            "--Input-minHeight": "2rem",
            "--Input-paddingInline": "0.5rem",
            "--Input-decoratorChildHeight": "min(1.5rem, var(--Input-minHeight))",
            "--Icon-fontSize": "1.25rem"
        }, ownerState.size === "md" && {
            "--Input-minHeight": "2.5rem",
            "--Input-paddingInline": "0.75rem",
            "--Input-decoratorChildHeight": "min(2rem, var(--Input-minHeight))",
            "--Icon-fontSize": "1.5rem"
        }, ownerState.size === "lg" && {
            "--Input-minHeight": "3rem",
            "--Input-paddingInline": "1rem",
            "--Input-gap": "0.75rem",
            "--Input-decoratorChildHeight": "min(2.375rem, var(--Input-minHeight))",
            "--Icon-fontSize": "1.75rem"
        }, {
            // variables for controlling child components
            "--Input-decoratorChildOffset": "min(calc(var(--Input-paddingInline) - (var(--Input-minHeight) - 2 * var(--variant-borderWidth, 0px) - var(--Input-decoratorChildHeight)) / 2), var(--Input-paddingInline))",
            "--_Input-paddingBlock": "max((var(--Input-minHeight) - 2 * var(--variant-borderWidth, 0px) - var(--Input-decoratorChildHeight)) / 2, 0px)",
            "--Input-decoratorChildRadius": "max(var(--Input-radius) - var(--variant-borderWidth, 0px) - var(--_Input-paddingBlock), min(var(--_Input-paddingBlock) + var(--variant-borderWidth, 0px), var(--Input-radius) / 2))",
            "--Button-minHeight": "var(--Input-decoratorChildHeight)",
            "--IconButton-size": "var(--Input-decoratorChildHeight)",
            "--Button-radius": "var(--Input-decoratorChildRadius)",
            "--IconButton-radius": "var(--Input-decoratorChildRadius)",
            boxSizing: "border-box",
            minWidth: 0,
            minHeight: "var(--Input-minHeight)"
        }, ownerState.fullWidth && {
            width: "100%"
        }, {
            cursor: "text",
            position: "relative",
            display: "flex",
            paddingInline: `var(--Input-paddingInline)`,
            borderRadius: "var(--Input-radius)",
            fontFamily: theme.vars.fontFamily.body,
            fontSize: theme.vars.fontSize.md
        }, ownerState.size === "sm" && {
            fontSize: theme.vars.fontSize.sm
        }, {
            "&:before": {
                boxSizing: "border-box",
                content: '""',
                display: "block",
                position: "absolute",
                pointerEvents: "none",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                borderRadius: "inherit",
                margin: "calc(var(--variant-borderWidth, 0px) * -1)",
                // for outlined variant
                boxShadow: `var(--Input-focusedInset, inset) 0 0 0 calc(var(--Input-focused) * var(--Input-focusedThickness)) var(--Input-focusedHighlight)`
            }
        }),
        (0, $cPOSH.default)({}, variantStyle, {
            backgroundColor: (_variantStyle$backgro = variantStyle == null ? void 0 : variantStyle.backgroundColor) != null ? _variantStyle$backgro : theme.vars.palette.background.surface,
            "&:hover": (0, $cPOSH.default)({}, (_theme$variants2 = theme.variants[`${ownerState.variant}Hover`]) == null ? void 0 : _theme$variants2[ownerState.color], {
                backgroundColor: null // it is not common to change background on hover for Input
            }),
            [`&.${(0, $4b0026a77aa5ace9$export$2e2bcd8739ae039).disabled}`]: (_theme$variants3 = theme.variants[`${ownerState.variant}Disabled`]) == null ? void 0 : _theme$variants3[ownerState.color],
            "&:focus-within::before": {
                "--Input-focused": "1"
            }
        })
    ];
});
const $f049161e9712eaba$export$5f7a63778d028fa4 = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("input")(({ ownerState: ownerState })=>({
        border: "none",
        // remove the native input width
        minWidth: 0,
        // remove the native input width
        outline: 0,
        // remove the native input outline
        padding: 0,
        // remove the native input padding
        flex: 1,
        color: "inherit",
        backgroundColor: "transparent",
        fontFamily: "inherit",
        fontSize: "inherit",
        fontStyle: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit",
        textOverflow: "ellipsis",
        "&:-webkit-autofill": (0, $cPOSH.default)({
            paddingInline: "var(--Input-paddingInline)"
        }, !ownerState.startDecorator && {
            marginInlineStart: "calc(-1 * var(--Input-paddingInline))",
            paddingInlineStart: "var(--Input-paddingInline)",
            borderTopLeftRadius: "calc(var(--Input-radius) - var(--variant-borderWidth, 0px))",
            borderBottomLeftRadius: "calc(var(--Input-radius) - var(--variant-borderWidth, 0px))"
        }, !ownerState.endDecorator && {
            marginInlineEnd: "calc(-1 * var(--Input-paddingInline))",
            paddingInlineEnd: "var(--Input-paddingInline)",
            borderTopRightRadius: "calc(var(--Input-radius) - var(--variant-borderWidth, 0px))",
            borderBottomRightRadius: "calc(var(--Input-radius) - var(--variant-borderWidth, 0px))"
        }),
        "&::-webkit-input-placeholder": {
            color: "var(--Input-placeholderColor)",
            opacity: "var(--Input-placeholderOpacity)"
        },
        "&::-moz-placeholder": {
            // Firefox 19+
            color: "var(--Input-placeholderColor)",
            opacity: "var(--Input-placeholderOpacity)"
        },
        "&:-ms-input-placeholder": {
            // IE11
            color: "var(--Input-placeholderColor)",
            opacity: "var(--Input-placeholderOpacity)"
        },
        "&::-ms-input-placeholder": {
            // Edge
            color: "var(--Input-placeholderColor)",
            opacity: "var(--Input-placeholderOpacity)"
        }
    }));
const $f049161e9712eaba$export$d3abc89681d35598 = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("div")(({ theme: theme, ownerState: ownerState })=>{
    var _theme$variants4, _theme$variants5;
    return (0, $cPOSH.default)({
        "--Button-margin": "0 0 0 calc(var(--Input-decoratorChildOffset) * -1)",
        "--IconButton-margin": "0 0 0 calc(var(--Input-decoratorChildOffset) * -1)",
        "--Icon-margin": "0 0 0 calc(var(--Input-paddingInline) / -4)",
        display: "inherit",
        alignItems: "center",
        paddingBlock: "var(--unstable_InputPaddingBlock)",
        // for wrapping Autocomplete's tags
        flexWrap: "wrap",
        // for wrapping Autocomplete's tags
        marginInlineEnd: "var(--Input-gap)",
        color: theme.vars.palette.text.tertiary,
        cursor: "initial"
    }, ownerState.focused && {
        color: (_theme$variants4 = theme.variants[ownerState.variant]) == null || (_theme$variants4 = _theme$variants4[ownerState.color]) == null ? void 0 : _theme$variants4.color
    }, ownerState.disabled && {
        color: (_theme$variants5 = theme.variants[`${ownerState.variant}Disabled`]) == null || (_theme$variants5 = _theme$variants5[ownerState.color]) == null ? void 0 : _theme$variants5.color
    });
});
const $f049161e9712eaba$export$d7d0ef982c187bdc = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("div")(({ theme: theme, ownerState: ownerState })=>{
    var _theme$variants6, _theme$variants7;
    return (0, $cPOSH.default)({
        "--Button-margin": "0 calc(var(--Input-decoratorChildOffset) * -1) 0 0",
        "--IconButton-margin": "0 calc(var(--Input-decoratorChildOffset) * -1) 0 0",
        "--Icon-margin": "0 calc(var(--Input-paddingInline) / -4) 0 0",
        display: "inherit",
        alignItems: "center",
        marginInlineStart: "var(--Input-gap)",
        color: (_theme$variants6 = theme.variants[ownerState.variant]) == null || (_theme$variants6 = _theme$variants6[ownerState.color]) == null ? void 0 : _theme$variants6.color,
        cursor: "initial"
    }, ownerState.disabled && {
        color: (_theme$variants7 = theme.variants[`${ownerState.variant}Disabled`]) == null || (_theme$variants7 = _theme$variants7[ownerState.color]) == null ? void 0 : _theme$variants7.color
    });
});
const $f049161e9712eaba$var$InputRoot = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)($f049161e9712eaba$export$bbbd086689f6e686, {
    name: "JoyInput",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $f049161e9712eaba$var$InputInput = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)($f049161e9712eaba$export$5f7a63778d028fa4, {
    name: "JoyInput",
    slot: "Input",
    overridesResolver: (props, styles)=>styles.input
})({});
const $f049161e9712eaba$var$InputStartDecorator = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)($f049161e9712eaba$export$d3abc89681d35598, {
    name: "JoyInput",
    slot: "StartDecorator",
    overridesResolver: (props, styles)=>styles.startDecorator
})({});
const $f049161e9712eaba$var$InputEndDecorator = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)($f049161e9712eaba$export$d7d0ef982c187bdc, {
    name: "JoyInput",
    slot: "EndDecorator",
    overridesResolver: (props, styles)=>styles.endDecorator
})({});
/**
 *
 * Demos:
 *
 * - [Input](https://mui.com/joy-ui/react-input/)
 *
 * API:
 *
 * - [Input API](https://mui.com/joy-ui/api/input/)
 */ const $f049161e9712eaba$var$Input = /*#__PURE__*/ $1EuC8.forwardRef(function Input(inProps, ref) {
    var _ref, _inProps$error, _ref2, _inProps$size, _formControl$color;
    const props = (0, $171c82576b265f00$export$2e2bcd8739ae039)({
        props: inProps,
        name: "JoyInput"
    });
    const _useForwardedInput = (0, $3182e84f5a1ecea4$export$2e2bcd8739ae039)(props, (0, $4b0026a77aa5ace9$export$2e2bcd8739ae039)), { propsToForward: propsToForward, rootStateClasses: rootStateClasses, inputStateClasses: inputStateClasses, getRootProps: getRootProps, getInputProps: getInputProps, formControl: formControl, focused: focused, error: errorProp = false, disabled: disabled, fullWidth: fullWidth = false, size: sizeProp = "md", color: colorProp = "neutral", variant: variant = "outlined", startDecorator: startDecorator, endDecorator: endDecorator, component: component, slots: slots = {}, slotProps: slotProps = {} } = _useForwardedInput, other = (0, $aT5bD.default)(_useForwardedInput, $f049161e9712eaba$var$_excluded);
    const error = (_ref = (_inProps$error = inProps.error) != null ? _inProps$error : formControl == null ? void 0 : formControl.error) != null ? _ref : errorProp;
    const size = (_ref2 = (_inProps$size = inProps.size) != null ? _inProps$size : formControl == null ? void 0 : formControl.size) != null ? _ref2 : sizeProp;
    const { getColor: getColor } = (0, $45219fd0b0701701$export$83a9a651654e258f)(variant);
    const color = getColor(inProps.color, error ? "danger" : (_formControl$color = formControl == null ? void 0 : formControl.color) != null ? _formControl$color : colorProp);
    const ownerState = (0, $cPOSH.default)({}, props, {
        fullWidth: fullWidth,
        color: color,
        disabled: disabled,
        error: error,
        focused: focused,
        size: size,
        variant: variant
    });
    const classes = $f049161e9712eaba$var$useUtilityClasses(ownerState);
    const externalForwardedProps = (0, $cPOSH.default)({}, other, {
        component: component,
        slots: slots,
        slotProps: slotProps
    });
    const [SlotRoot, rootProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("root", {
        ref: ref,
        className: [
            classes.root,
            rootStateClasses
        ],
        elementType: $f049161e9712eaba$var$InputRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SlotInput, inputProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("input", (0, $cPOSH.default)({}, formControl && {
        additionalProps: {
            id: formControl.htmlFor,
            "aria-describedby": formControl["aria-describedby"]
        }
    }, {
        className: [
            classes.input,
            inputStateClasses
        ],
        elementType: $f049161e9712eaba$var$InputInput,
        getSlotProps: getInputProps,
        internalForwardedProps: propsToForward,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }));
    const [SlotStartDecorator, startDecoratorProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("startDecorator", {
        className: classes.startDecorator,
        elementType: $f049161e9712eaba$var$InputStartDecorator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SlotEndDecorator, endDecoratorProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("endDecorator", {
        className: classes.endDecorator,
        elementType: $f049161e9712eaba$var$InputEndDecorator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $6iAGf.jsxs)(SlotRoot, (0, $cPOSH.default)({}, rootProps, {
        children: [
            startDecorator && /*#__PURE__*/ (0, $6iAGf.jsx)(SlotStartDecorator, (0, $cPOSH.default)({}, startDecoratorProps, {
                children: startDecorator
            })),
            /*#__PURE__*/ (0, $6iAGf.jsx)(SlotInput, (0, $cPOSH.default)({}, inputProps)),
            endDecorator && /*#__PURE__*/ (0, $6iAGf.jsx)(SlotEndDecorator, (0, $cPOSH.default)({}, endDecoratorProps, {
                children: endDecorator
            }))
        ]
    }));
});
var $f049161e9712eaba$export$2e2bcd8739ae039 = $f049161e9712eaba$var$Input;



var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");


var $gioqn = parcelRequire("gioqn");

var $i5l0f = parcelRequire("i5l0f");

var $2jicN = parcelRequire("2jicN");

var $3Upoa = parcelRequire("3Upoa");

const $8272e17a91af59f2$var$styled = (0, $dbf7c9c83795547b$export$2e2bcd8739ae039)();
var $8272e17a91af59f2$export$2e2bcd8739ae039 = $8272e17a91af59f2$var$styled;




var $b2hnc = parcelRequire("b2hnc");

var $cteiL = parcelRequire("cteiL");

var $hY8gn = parcelRequire("hY8gn");

var $kQBDD = parcelRequire("kQBDD");

var $6iAGf = parcelRequire("6iAGf");
const $d28ddc4b025d112c$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $d28ddc4b025d112c$var$defaultTheme = (0, $cteiL.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $d28ddc4b025d112c$var$defaultCreateStyledComponent = (0, $8272e17a91af59f2$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $d28ddc4b025d112c$var$useThemePropsDefault(props) {
    return (0, $117abe31cc6e24a1$export$2e2bcd8739ae039)({
        props: props,
        name: "MuiStack",
        defaultTheme: $d28ddc4b025d112c$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $d28ddc4b025d112c$var$joinChildren(children, separator) {
    const childrenArray = $1EuC8.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $1EuC8.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $d28ddc4b025d112c$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $d28ddc4b025d112c$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $cPOSH.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $hY8gn.handleBreakpoints)({
        theme: theme
    }, (0, $hY8gn.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $kQBDD.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $hY8gn.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $hY8gn.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $kQBDD.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$d28ddc4b025d112c$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $kQBDD.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $i5l0f.default)(styles, (0, $hY8gn.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $hY8gn.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $d28ddc4b025d112c$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $d28ddc4b025d112c$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $d28ddc4b025d112c$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $3Upoa.default)(slots, (slot)=>(0, $2jicN.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($d28ddc4b025d112c$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $1EuC8.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $b2hnc.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $aT5bD.default)(props, $d28ddc4b025d112c$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $6iAGf.jsx)(StackRoot, (0, $cPOSH.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $gioqn.default)(classes.root, className)
        }, other, {
            children: divider ? $d28ddc4b025d112c$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}





"use client";
/**
 *
 * Demos:
 *
 * - [Stack](https://mui.com/joy-ui/react-stack/)
 *
 * API:
 *
 * - [Stack API](https://mui.com/joy-ui/api/stack/)
 */ const $97ef477f809727ed$var$Stack = (0, $d28ddc4b025d112c$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("div", {
        name: "JoyStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $171c82576b265f00$export$2e2bcd8739ae039)({
            props: inProps,
            name: "JoyStack"
        })
});
var $97ef477f809727ed$export$2e2bcd8739ae039 = $97ef477f809727ed$var$Stack;




var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");


var $cwrhp = parcelRequire("cwrhp");

var $b2hnc = parcelRequire("b2hnc");

var $3Upoa = parcelRequire("3Upoa");





function $75d54b7a08717d52$export$24c1f8f60cbac79e(slot) {
    return (0, $bd48de20fb876697$export$1d132570e11858b0)("MuiTypography", slot);
}
const $75d54b7a08717d52$var$typographyClasses = (0, $bd48de20fb876697$export$de4f15803c389669)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "body1",
    "body2",
    "body3",
    "noWrap",
    "gutterBottom",
    "startDecorator",
    "endDecorator",
    "colorPrimary",
    "colorNeutral",
    "colorDanger",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "colorContext",
    "variantPlain",
    "variantOutlined",
    "variantSoft",
    "variantSolid"
]);
var $75d54b7a08717d52$export$2e2bcd8739ae039 = $75d54b7a08717d52$var$typographyClasses;



var $6iAGf = parcelRequire("6iAGf");
"use client";
const $c51e530d5ca68d95$var$_excluded = [
    "color",
    "textColor"
], $c51e530d5ca68d95$var$_excluded2 = [
    "component",
    "gutterBottom",
    "noWrap",
    "level",
    "levelMapping",
    "children",
    "endDecorator",
    "startDecorator",
    "variant",
    "slots",
    "slotProps"
];
const $c51e530d5ca68d95$export$42360d4e564f583f = /*#__PURE__*/ $1EuC8.createContext(false);
const $c51e530d5ca68d95$export$90e16d743f7223b = /*#__PURE__*/ $1EuC8.createContext(false);
const $c51e530d5ca68d95$var$useUtilityClasses = (ownerState)=>{
    const { gutterBottom: gutterBottom, noWrap: noWrap, level: level, color: color, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            level,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            color && `color${(0, $cwrhp.default)(color)}`,
            variant && `variant${(0, $cwrhp.default)(variant)}`
        ],
        startDecorator: [
            "startDecorator"
        ],
        endDecorator: [
            "endDecorator"
        ]
    };
    return (0, $3Upoa.default)(slots, (0, $75d54b7a08717d52$export$24c1f8f60cbac79e), {});
};
const $c51e530d5ca68d95$var$StartDecorator = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("span", {
    name: "JoyTypography",
    slot: "StartDecorator",
    overridesResolver: (props, styles)=>styles.startDecorator
})(({ ownerState: ownerState })=>{
    var _ownerState$sx;
    return (0, $cPOSH.default)({
        display: "inline-flex",
        marginInlineEnd: "clamp(4px, var(--Typography-gap, 0.375em), 0.75rem)"
    }, typeof ownerState.startDecorator !== "string" && (ownerState.alignItems === "flex-start" || ((_ownerState$sx = ownerState.sx) == null ? void 0 : _ownerState$sx.alignItems) === "flex-start") && {
        marginTop: "2px" // this makes the alignment perfect in most cases
    });
});
const $c51e530d5ca68d95$var$EndDecorator = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("span", {
    name: "JoyTypography",
    slot: "endDecorator",
    overridesResolver: (props, styles)=>styles.endDecorator
})(({ ownerState: ownerState })=>{
    var _ownerState$sx2;
    return (0, $cPOSH.default)({
        display: "inline-flex",
        marginInlineStart: "clamp(4px, var(--Typography-gap, 0.375em), 0.75rem)"
    }, typeof ownerState.endDecorator !== "string" && (ownerState.alignItems === "flex-start" || ((_ownerState$sx2 = ownerState.sx) == null ? void 0 : _ownerState$sx2.alignItems) === "flex-start") && {
        marginTop: "2px" // this makes the alignment perfect in most cases
    });
});
const $c51e530d5ca68d95$var$TypographyRoot = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("span", {
    name: "JoyTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$typography$own, _theme$typography$own2, _theme$vars$palette$o, _theme$variants$owner;
    return (0, $cPOSH.default)({
        "--Icon-fontSize": "1.25em",
        margin: "var(--Typography-margin, 0px)"
    }, ownerState.nesting ? {
        display: "inline" // looks better than `inline-block` when using with `variant` prop.
    } : {
        fontFamily: theme.vars.fontFamily.body,
        // for nested typography, the font family will be inheriting.
        display: "block" // don't rely on user agent, always `block`.
    }, (ownerState.startDecorator || ownerState.endDecorator) && (0, $cPOSH.default)({
        display: "flex",
        // should not be used as a default because it does not work well with `noWrap`.
        alignItems: "center"
    }, ownerState.nesting && (0, $cPOSH.default)({
        display: "inline-flex"
    }, ownerState.startDecorator && {
        verticalAlign: "bottom" // to make the text align with the parent's content
    })), ownerState.level && ownerState.level !== "inherit" && theme.typography[ownerState.level], {
        fontSize: `var(--Typography-fontSize, ${ownerState.level && ownerState.level !== "inherit" ? (_theme$typography$own = (_theme$typography$own2 = theme.typography[ownerState.level]) == null ? void 0 : _theme$typography$own2.fontSize) != null ? _theme$typography$own : "inherit" : "inherit"})`
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.color && ownerState.color !== "context" && {
        color: `rgba(${(_theme$vars$palette$o = theme.vars.palette[ownerState.color]) == null ? void 0 : _theme$vars$palette$o.mainChannel} / 1)`
    }, ownerState.variant && (0, $cPOSH.default)({
        borderRadius: theme.vars.radius.xs,
        paddingBlock: "min(0.15em, 4px)",
        paddingInline: "0.375em"
    }, !ownerState.nesting && {
        marginInline: "-0.375em"
    }, (_theme$variants$owner = theme.variants[ownerState.variant]) == null ? void 0 : _theme$variants$owner[ownerState.color]));
});
const $c51e530d5ca68d95$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    display1: "h1",
    display2: "h2",
    body1: "p",
    body2: "p",
    body3: "span",
    body4: "span",
    body5: "span",
    inherit: "p"
};
/**
 *
 * Demos:
 *
 * - [Skeleton](https://mui.com/joy-ui/react-skeleton/)
 * - [Typography](https://mui.com/joy-ui/react-typography/)
 *
 * API:
 *
 * - [Typography API](https://mui.com/joy-ui/api/typography/)
 */ const $c51e530d5ca68d95$var$Typography = /*#__PURE__*/ $1EuC8.forwardRef(function Typography(inProps, ref) {
    const _useThemeProps = (0, $171c82576b265f00$export$2e2bcd8739ae039)({
        props: inProps,
        name: "JoyTypography"
    }), { color: colorProp, textColor: textColor } = _useThemeProps, themeProps = (0, $aT5bD.default)(_useThemeProps, $c51e530d5ca68d95$var$_excluded);
    const nesting = $1EuC8.useContext($c51e530d5ca68d95$export$42360d4e564f583f);
    const inheriting = $1EuC8.useContext($c51e530d5ca68d95$export$90e16d743f7223b);
    const props = (0, $b2hnc.default)((0, $cPOSH.default)({}, themeProps, {
        color: textColor
    }));
    const { component: componentProp, gutterBottom: gutterBottom = false, noWrap: noWrap = false, level: levelProp = "body1", levelMapping: levelMapping = {
        h1: "h1",
        h2: "h2",
        h3: "h3",
        h4: "h4",
        h5: "h5",
        h6: "h6",
        body1: "p",
        body2: "p",
        body3: "p",
        inherit: "p"
    }, children: children, endDecorator: endDecorator, startDecorator: startDecorator, variant: variant, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $aT5bD.default)(props, $c51e530d5ca68d95$var$_excluded2);
    const { getColor: getColor } = (0, $45219fd0b0701701$export$83a9a651654e258f)(variant);
    const color = getColor(inProps.color, variant ? colorProp != null ? colorProp : "neutral" : colorProp);
    const level = nesting || inheriting ? inProps.level || "inherit" : levelProp;
    const component = componentProp || (nesting ? "span" : levelMapping[level] || $c51e530d5ca68d95$var$defaultVariantMapping[level] || "span");
    const ownerState = (0, $cPOSH.default)({}, props, {
        level: level,
        component: component,
        color: color,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        nesting: nesting,
        variant: variant
    });
    const classes = $c51e530d5ca68d95$var$useUtilityClasses(ownerState);
    const externalForwardedProps = (0, $cPOSH.default)({}, other, {
        component: component,
        slots: slots,
        slotProps: slotProps
    });
    const [SlotRoot, rootProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("root", {
        ref: ref,
        className: classes.root,
        elementType: $c51e530d5ca68d95$var$TypographyRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SlotStartDecorator, startDecoratorProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("startDecorator", {
        className: classes.startDecorator,
        elementType: $c51e530d5ca68d95$var$StartDecorator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SlotEndDecorator, endDecoratorProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("endDecorator", {
        className: classes.endDecorator,
        elementType: $c51e530d5ca68d95$var$EndDecorator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $6iAGf.jsx)($c51e530d5ca68d95$export$42360d4e564f583f.Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $6iAGf.jsxs)(SlotRoot, (0, $cPOSH.default)({}, rootProps, {
            children: [
                startDecorator && /*#__PURE__*/ (0, $6iAGf.jsx)(SlotStartDecorator, (0, $cPOSH.default)({}, startDecoratorProps, {
                    children: startDecorator
                })),
                (0, $35516c82881350e3$export$2e2bcd8739ae039)(children, [
                    "Skeleton"
                ]) ? /*#__PURE__*/ $1EuC8.cloneElement(children, {
                    variant: children.props.variant || "inline"
                }) : children,
                endDecorator && /*#__PURE__*/ (0, $6iAGf.jsx)(SlotEndDecorator, (0, $cPOSH.default)({}, endDecoratorProps, {
                    children: endDecorator
                }))
            ]
        }))
    });
});
var $c51e530d5ca68d95$export$2e2bcd8739ae039 = $c51e530d5ca68d95$var$Typography;



var $1EuC8 = parcelRequire("1EuC8");

var $aT5bD = parcelRequire("aT5bD");
function $adb28f7070211072$export$2e2bcd8739ae039(t, e) {
    return $adb28f7070211072$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $adb28f7070211072$export$2e2bcd8739ae039(t, e);
}


function $d5d48d591095db69$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $adb28f7070211072$export$2e2bcd8739ae039)(t, o);
}




var $1EuC8 = parcelRequire("1EuC8");

var $6c75d803f19705cb$export$2e2bcd8739ae039 = {
    disabled: false
};




var $1EuC8 = parcelRequire("1EuC8");
var $d39749f43ecf8691$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).createContext(null);


var $0f2a8e9aaa1a080f$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $6651db035ad6809a$export$bb38bb9a1161268 = "unmounted";
var $6651db035ad6809a$export$84cbff306f539230 = "exited";
var $6651db035ad6809a$export$df38205c966be359 = "entering";
var $6651db035ad6809a$export$78e9e6e3e014d60a = "entered";
var $6651db035ad6809a$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $6651db035ad6809a$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $d5d48d591095db69$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $6651db035ad6809a$export$84cbff306f539230;
                _this.appearStatus = $6651db035ad6809a$export$df38205c966be359;
            } else initialStatus = $6651db035ad6809a$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $6651db035ad6809a$export$bb38bb9a1161268;
        else initialStatus = $6651db035ad6809a$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $6651db035ad6809a$export$bb38bb9a1161268) return {
            status: $6651db035ad6809a$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $6651db035ad6809a$export$df38205c966be359 && status !== $6651db035ad6809a$export$78e9e6e3e014d60a) nextStatus = $6651db035ad6809a$export$df38205c966be359;
            } else if (status === $6651db035ad6809a$export$df38205c966be359 || status === $6651db035ad6809a$export$78e9e6e3e014d60a) nextStatus = $6651db035ad6809a$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $6651db035ad6809a$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($243da7855fb30689$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $0f2a8e9aaa1a080f$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $6651db035ad6809a$export$84cbff306f539230) this.setState({
            status: $6651db035ad6809a$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($243da7855fb30689$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $6c75d803f19705cb$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $6651db035ad6809a$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $6651db035ad6809a$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $6651db035ad6809a$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($243da7855fb30689$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $6c75d803f19705cb$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $6651db035ad6809a$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $6651db035ad6809a$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $6651db035ad6809a$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($243da7855fb30689$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $6651db035ad6809a$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $aT5bD.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).createElement((0, $d39749f43ecf8691$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).Component);
$6651db035ad6809a$var$Transition.contextType = (0, $d39749f43ecf8691$export$2e2bcd8739ae039);
$6651db035ad6809a$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $6651db035ad6809a$var$noop() {}
$6651db035ad6809a$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $6651db035ad6809a$var$noop,
    onEntering: $6651db035ad6809a$var$noop,
    onEntered: $6651db035ad6809a$var$noop,
    onExit: $6651db035ad6809a$var$noop,
    onExiting: $6651db035ad6809a$var$noop,
    onExited: $6651db035ad6809a$var$noop
};
$6651db035ad6809a$var$Transition.UNMOUNTED = $6651db035ad6809a$export$bb38bb9a1161268;
$6651db035ad6809a$var$Transition.EXITED = $6651db035ad6809a$export$84cbff306f539230;
$6651db035ad6809a$var$Transition.ENTERING = $6651db035ad6809a$export$df38205c966be359;
$6651db035ad6809a$var$Transition.ENTERED = $6651db035ad6809a$export$78e9e6e3e014d60a;
$6651db035ad6809a$var$Transition.EXITING = $6651db035ad6809a$export$4aacc83d4d59139f;
var $6651db035ad6809a$export$2e2bcd8739ae039 = $6651db035ad6809a$var$Transition;



var $6iAGf = parcelRequire("6iAGf");

var $1EuC8 = parcelRequire("1EuC8");
var $7f239c261aab7111$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $7f239c261aab7111$var$isDateObject = (value1)=>value1 instanceof Date;
var $7f239c261aab7111$var$isNullOrUndefined = (value1)=>value1 == null;
const $7f239c261aab7111$var$isObjectType = (value1)=>typeof value1 === "object";
var $7f239c261aab7111$var$isObject = (value1)=>!$7f239c261aab7111$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $7f239c261aab7111$var$isObjectType(value1) && !$7f239c261aab7111$var$isDateObject(value1);
var $7f239c261aab7111$var$getEventValue = (event)=>$7f239c261aab7111$var$isObject(event) && event.target ? $7f239c261aab7111$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $7f239c261aab7111$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $7f239c261aab7111$var$isNameInFieldArray = (names, name)=>names.has($7f239c261aab7111$var$getNodeParentName(name));
var $7f239c261aab7111$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $7f239c261aab7111$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $7f239c261aab7111$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $7f239c261aab7111$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($7f239c261aab7111$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $7f239c261aab7111$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$7f239c261aab7111$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $7f239c261aab7111$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $7f239c261aab7111$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $7f239c261aab7111$var$isUndefined = (val)=>val === undefined;
var $7f239c261aab7111$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$7f239c261aab7111$var$isObject(object)) return defaultValue;
    const result = $7f239c261aab7111$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$7f239c261aab7111$var$isNullOrUndefined(result) ? result : result[key], object);
    return $7f239c261aab7111$var$isUndefined(result) || result === object ? $7f239c261aab7111$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $7f239c261aab7111$var$isBoolean = (value1)=>typeof value1 === "boolean";
var $7f239c261aab7111$var$isKey = (value1)=>/^\w*$/.test(value1);
var $7f239c261aab7111$var$stringToPath = (input)=>$7f239c261aab7111$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var $7f239c261aab7111$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $7f239c261aab7111$var$isKey(path) ? [
        path
    ] : $7f239c261aab7111$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $7f239c261aab7111$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === "__proto__") return;
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
const $7f239c261aab7111$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $7f239c261aab7111$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $7f239c261aab7111$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $7f239c261aab7111$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $7f239c261aab7111$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useContext($7f239c261aab7111$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $7f239c261aab7111$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).createElement($7f239c261aab7111$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $7f239c261aab7111$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $7f239c261aab7111$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $7f239c261aab7111$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $7f239c261aab7111$var$isEmptyObject = (value1)=>$7f239c261aab7111$var$isObject(value1) && !Object.keys(value1).length;
var $7f239c261aab7111$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $7f239c261aab7111$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $7f239c261aab7111$var$VALIDATION_MODE.all));
};
var $7f239c261aab7111$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $7f239c261aab7111$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $7f239c261aab7111$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $7f239c261aab7111$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $7f239c261aab7111$export$606f11b2eb45ecc6(props) {
    const methods = $7f239c261aab7111$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useRef(name);
    _name.current = name;
    $7f239c261aab7111$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $7f239c261aab7111$var$shouldSubscribeByName(_name.current, value1.name, exact) && $7f239c261aab7111$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $7f239c261aab7111$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $7f239c261aab7111$var$isString = (value1)=>typeof value1 === "string";
var $7f239c261aab7111$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($7f239c261aab7111$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $7f239c261aab7111$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $7f239c261aab7111$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $7f239c261aab7111$export$3c773aa2b84f29e0(props) {
    const methods = $7f239c261aab7111$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useRef(name);
    _name.current = name;
    $7f239c261aab7111$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($7f239c261aab7111$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($7f239c261aab7111$var$cloneObject($7f239c261aab7111$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $7f239c261aab7111$export$e8c786024a2b0a79(props) {
    const methods = $7f239c261aab7111$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $7f239c261aab7111$var$isNameInFieldArray(control._names.array, name);
    const value1 = $7f239c261aab7111$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $7f239c261aab7111$export$3988ae62b71be9a3(control._formValues, name, $7f239c261aab7111$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $7f239c261aab7111$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$7f239c261aab7111$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $7f239c261aab7111$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $7f239c261aab7111$var$cloneObject($7f239c261aab7111$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $7f239c261aab7111$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($7f239c261aab7111$var$isUndefined($7f239c261aab7111$export$3988ae62b71be9a3(control._formValues, name))) $7f239c261aab7111$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>{
        if ($7f239c261aab7111$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $7f239c261aab7111$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$7f239c261aab7111$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $7f239c261aab7111$var$getEventValue(event),
                        name: name
                    },
                    type: $7f239c261aab7111$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $7f239c261aab7111$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $7f239c261aab7111$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useCallback((elm)=>{
                const field = $7f239c261aab7111$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }, [
                control._fields,
                name
            ])
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$7f239c261aab7111$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$7f239c261aab7111$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$7f239c261aab7111$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$7f239c261aab7111$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$7f239c261aab7111$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $7f239c261aab7111$export$bd0bf19f25da8474 = (props)=>props.render($7f239c261aab7111$export$e8c786024a2b0a79(props));
const $7f239c261aab7111$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $7f239c261aab7111$export$a7fed597f4b8afd8(props) {
    const methods = $7f239c261aab7111$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $7f239c261aab7111$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, $7f239c261aab7111$export$3988ae62b71be9a3(data, name));
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $7f239c261aab7111$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $7f239c261aab7111$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $7f239c261aab7111$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $7f239c261aab7111$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$7f239c261aab7111$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $7f239c261aab7111$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $7f239c261aab7111$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $7f239c261aab7111$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $7f239c261aab7111$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $7f239c261aab7111$var$VALIDATION_MODE.all,
        isOnTouch: mode === $7f239c261aab7111$var$VALIDATION_MODE.onTouched
    });
var $7f239c261aab7111$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $7f239c261aab7111$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $7f239c261aab7111$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($7f239c261aab7111$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($7f239c261aab7111$var$isObject(currentField)) {
                if ($7f239c261aab7111$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
var $7f239c261aab7111$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $7f239c261aab7111$var$convertToArrayPayload($7f239c261aab7111$export$3988ae62b71be9a3(errors, name));
    $7f239c261aab7111$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $7f239c261aab7111$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $7f239c261aab7111$var$isFileInput = (element)=>element.type === "file";
var $7f239c261aab7111$var$isFunction = (value1)=>typeof value1 === "function";
var $7f239c261aab7111$var$isHTMLElement = (value1)=>{
    if (!$7f239c261aab7111$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $7f239c261aab7111$var$isMessage = (value1)=>$7f239c261aab7111$var$isString(value1);
var $7f239c261aab7111$var$isRadioInput = (element)=>element.type === "radio";
var $7f239c261aab7111$var$isRegex = (value1)=>value1 instanceof RegExp;
const $7f239c261aab7111$var$defaultResult = {
    value: false,
    isValid: false
};
const $7f239c261aab7111$var$validResult = {
    value: true,
    isValid: true
};
var $7f239c261aab7111$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$7f239c261aab7111$var$isUndefined(options[0].attributes.value) ? $7f239c261aab7111$var$isUndefined(options[0].value) || options[0].value === "" ? $7f239c261aab7111$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $7f239c261aab7111$var$validResult : $7f239c261aab7111$var$defaultResult;
    }
    return $7f239c261aab7111$var$defaultResult;
};
const $7f239c261aab7111$var$defaultReturn = {
    isValid: false,
    value: null
};
var $7f239c261aab7111$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $7f239c261aab7111$var$defaultReturn) : $7f239c261aab7111$var$defaultReturn;
function $7f239c261aab7111$var$getValidateError(result, ref, type = "validate") {
    if ($7f239c261aab7111$var$isMessage(result) || Array.isArray(result) && result.every($7f239c261aab7111$var$isMessage) || $7f239c261aab7111$var$isBoolean(result) && !result) return {
        type: type,
        message: $7f239c261aab7111$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $7f239c261aab7111$var$getValueAndMessage = (validationData)=>$7f239c261aab7111$var$isObject(validationData) && !$7f239c261aab7111$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $7f239c261aab7111$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $7f239c261aab7111$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($7f239c261aab7111$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $7f239c261aab7111$var$isRadioInput(ref);
    const isCheckBox = $7f239c261aab7111$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $7f239c261aab7111$var$isFileInput(ref)) && $7f239c261aab7111$var$isUndefined(ref.value) && $7f239c261aab7111$var$isUndefined(inputValue) || $7f239c261aab7111$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $7f239c261aab7111$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $7f239c261aab7111$var$INPUT_VALIDATION_RULES.maxLength, minType = $7f239c261aab7111$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $7f239c261aab7111$var$isNullOrUndefined(inputValue)) || $7f239c261aab7111$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$7f239c261aab7111$var$getCheckboxValue(refs).isValid || isRadio && !$7f239c261aab7111$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $7f239c261aab7111$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $7f239c261aab7111$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $7f239c261aab7111$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($7f239c261aab7111$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$7f239c261aab7111$var$isNullOrUndefined(min) || !$7f239c261aab7111$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $7f239c261aab7111$var$getValueAndMessage(max);
        const minOutput = $7f239c261aab7111$var$getValueAndMessage(min);
        if (!$7f239c261aab7111$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$7f239c261aab7111$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$7f239c261aab7111$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($7f239c261aab7111$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($7f239c261aab7111$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $7f239c261aab7111$var$INPUT_VALIDATION_RULES.max, $7f239c261aab7111$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($7f239c261aab7111$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $7f239c261aab7111$var$getValueAndMessage(maxLength);
        const minLengthOutput = $7f239c261aab7111$var$getValueAndMessage(minLength);
        const exceedMax = !$7f239c261aab7111$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$7f239c261aab7111$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $7f239c261aab7111$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $7f239c261aab7111$var$getValueAndMessage(pattern);
        if ($7f239c261aab7111$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $7f239c261aab7111$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($7f239c261aab7111$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($7f239c261aab7111$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $7f239c261aab7111$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($7f239c261aab7111$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($7f239c261aab7111$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$7f239c261aab7111$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $7f239c261aab7111$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$7f239c261aab7111$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var $7f239c261aab7111$var$appendAt = (data, value1)=>[
        ...data,
        ...$7f239c261aab7111$var$convertToArrayPayload(value1)
    ];
var $7f239c261aab7111$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $7f239c261aab7111$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$7f239c261aab7111$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $7f239c261aab7111$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($7f239c261aab7111$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $7f239c261aab7111$var$prependAt = (data, value1)=>[
        ...$7f239c261aab7111$var$convertToArrayPayload(value1),
        ...$7f239c261aab7111$var$convertToArrayPayload(data)
    ];
function $7f239c261aab7111$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $7f239c261aab7111$var$compact(temp).length ? temp : [];
}
var $7f239c261aab7111$var$removeArrayAt = (data, index)=>$7f239c261aab7111$var$isUndefined(index) ? [] : $7f239c261aab7111$var$removeAtIndexes(data, $7f239c261aab7111$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $7f239c261aab7111$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $7f239c261aab7111$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $7f239c261aab7111$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $7f239c261aab7111$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$7f239c261aab7111$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $7f239c261aab7111$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $7f239c261aab7111$var$isKey(path) ? [
        path
    ] : $7f239c261aab7111$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $7f239c261aab7111$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($7f239c261aab7111$var$isObject(childObject) && $7f239c261aab7111$var$isEmptyObject(childObject) || Array.isArray(childObject) && $7f239c261aab7111$var$isEmptyArray(childObject))) $7f239c261aab7111$var$unset(object, paths.slice(0, -1));
    return object;
}
var $7f239c261aab7111$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $7f239c261aab7111$export$310131896651d559(props) {
    const methods = $7f239c261aab7111$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useRef(control._getFieldArray(name).map($7f239c261aab7111$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $7f239c261aab7111$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $7f239c261aab7111$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($7f239c261aab7111$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $7f239c261aab7111$var$convertToArrayPayload($7f239c261aab7111$var$cloneObject(value1));
        const updatedFieldArrayValues = $7f239c261aab7111$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $7f239c261aab7111$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $7f239c261aab7111$var$appendAt(ids.current, appendValue.map($7f239c261aab7111$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $7f239c261aab7111$var$appendAt, {
            argA: $7f239c261aab7111$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $7f239c261aab7111$var$convertToArrayPayload($7f239c261aab7111$var$cloneObject(value1));
        const updatedFieldArrayValues = $7f239c261aab7111$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $7f239c261aab7111$var$getFocusFieldName(name, 0, options);
        ids.current = $7f239c261aab7111$var$prependAt(ids.current, prependValue.map($7f239c261aab7111$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $7f239c261aab7111$var$prependAt, {
            argA: $7f239c261aab7111$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $7f239c261aab7111$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $7f239c261aab7111$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $7f239c261aab7111$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $7f239c261aab7111$var$convertToArrayPayload($7f239c261aab7111$var$cloneObject(value1));
        const updatedFieldArrayValues = $7f239c261aab7111$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $7f239c261aab7111$var$getFocusFieldName(name, index, options);
        ids.current = $7f239c261aab7111$var$insert(ids.current, index, insertValue.map($7f239c261aab7111$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $7f239c261aab7111$var$insert, {
            argA: index,
            argB: $7f239c261aab7111$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $7f239c261aab7111$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $7f239c261aab7111$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $7f239c261aab7111$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $7f239c261aab7111$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $7f239c261aab7111$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $7f239c261aab7111$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $7f239c261aab7111$var$cloneObject(value1);
        const updatedFieldArrayValues = $7f239c261aab7111$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $7f239c261aab7111$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $7f239c261aab7111$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $7f239c261aab7111$var$convertToArrayPayload($7f239c261aab7111$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($7f239c261aab7111$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>{
        control._state.action = false;
        $7f239c261aab7111$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$7f239c261aab7111$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $7f239c261aab7111$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $7f239c261aab7111$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $7f239c261aab7111$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $7f239c261aab7111$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $7f239c261aab7111$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($7f239c261aab7111$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $7f239c261aab7111$var$getValidationModes(control._options.mode).isOnSubmit)) $7f239c261aab7111$var$validateField(field, control._formValues, control._options.criteriaMode === $7f239c261aab7111$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$7f239c261aab7111$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $7f239c261aab7111$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $7f239c261aab7111$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>{
        !$7f239c261aab7111$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $7f239c261aab7111$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var $7f239c261aab7111$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $7f239c261aab7111$var$isPrimitive = (value1)=>$7f239c261aab7111$var$isNullOrUndefined(value1) || !$7f239c261aab7111$var$isObjectType(value1);
function $7f239c261aab7111$var$deepEqual(object1, object2) {
    if ($7f239c261aab7111$var$isPrimitive(object1) || $7f239c261aab7111$var$isPrimitive(object2)) return object1 === object2;
    if ($7f239c261aab7111$var$isDateObject(object1) && $7f239c261aab7111$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($7f239c261aab7111$var$isDateObject(val1) && $7f239c261aab7111$var$isDateObject(val2) || $7f239c261aab7111$var$isObject(val1) && $7f239c261aab7111$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$7f239c261aab7111$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $7f239c261aab7111$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $7f239c261aab7111$var$isRadioOrCheckbox = (ref)=>$7f239c261aab7111$var$isRadioInput(ref) || $7f239c261aab7111$var$isCheckBoxInput(ref);
var $7f239c261aab7111$var$live = (ref)=>$7f239c261aab7111$var$isHTMLElement(ref) && ref.isConnected;
var $7f239c261aab7111$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($7f239c261aab7111$var$isFunction(data[key])) return true;
    }
    return false;
};
function $7f239c261aab7111$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($7f239c261aab7111$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $7f239c261aab7111$var$isObject(data[key]) && !$7f239c261aab7111$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $7f239c261aab7111$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$7f239c261aab7111$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $7f239c261aab7111$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($7f239c261aab7111$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $7f239c261aab7111$var$isObject(data[key]) && !$7f239c261aab7111$var$objectHasFunction(data[key])) {
            if ($7f239c261aab7111$var$isUndefined(formValues) || $7f239c261aab7111$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $7f239c261aab7111$var$markFieldsDirty(data[key], []) : {
                ...$7f239c261aab7111$var$markFieldsDirty(data[key])
            };
            else $7f239c261aab7111$var$getDirtyFieldsFromDefaultValues(data[key], $7f239c261aab7111$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$7f239c261aab7111$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $7f239c261aab7111$var$getDirtyFields = (defaultValues, formValues)=>$7f239c261aab7111$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $7f239c261aab7111$var$markFieldsDirty(formValues));
var $7f239c261aab7111$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$7f239c261aab7111$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $7f239c261aab7111$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $7f239c261aab7111$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($7f239c261aab7111$var$isFileInput(ref)) return ref.files;
    if ($7f239c261aab7111$var$isRadioInput(ref)) return $7f239c261aab7111$var$getRadioValue(_f.refs).value;
    if ($7f239c261aab7111$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($7f239c261aab7111$var$isCheckBoxInput(ref)) return $7f239c261aab7111$var$getCheckboxValue(_f.refs).value;
    return $7f239c261aab7111$var$getFieldValueAs($7f239c261aab7111$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $7f239c261aab7111$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, name);
        field && $7f239c261aab7111$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $7f239c261aab7111$var$getRuleValue = (rule)=>$7f239c261aab7111$var$isUndefined(rule) ? rule : $7f239c261aab7111$var$isRegex(rule) ? rule.source : $7f239c261aab7111$var$isObject(rule) ? $7f239c261aab7111$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
const $7f239c261aab7111$var$ASYNC_FUNCTION = "AsyncFunction";
var $7f239c261aab7111$var$hasPromiseValidation = (fieldReference)=>(!fieldReference || !fieldReference.validate) && !!($7f239c261aab7111$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $7f239c261aab7111$var$ASYNC_FUNCTION || $7f239c261aab7111$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $7f239c261aab7111$var$ASYNC_FUNCTION));
var $7f239c261aab7111$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $7f239c261aab7111$var$schemaErrorLookup(errors, _fields, name) {
    const error = $7f239c261aab7111$export$3988ae62b71be9a3(errors, name);
    if (error || $7f239c261aab7111$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $7f239c261aab7111$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $7f239c261aab7111$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $7f239c261aab7111$var$unsetEmptyArray = (ref, name)=>!$7f239c261aab7111$var$compact($7f239c261aab7111$export$3988ae62b71be9a3(ref, name)).length && $7f239c261aab7111$var$unset(ref, name);
const $7f239c261aab7111$var$defaultOptions = {
    mode: $7f239c261aab7111$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $7f239c261aab7111$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $7f239c261aab7111$var$createFormControl(props = {}) {
    let _options = {
        ...$7f239c261aab7111$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $7f239c261aab7111$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $7f239c261aab7111$var$isObject(_options.defaultValues) || $7f239c261aab7111$var$isObject(_options.values) ? $7f239c261aab7111$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $7f239c261aab7111$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $7f239c261aab7111$var$createSubject(),
        array: $7f239c261aab7111$var$createSubject(),
        state: $7f239c261aab7111$var$createSubject()
    };
    const validationModeBeforeSubmit = $7f239c261aab7111$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $7f239c261aab7111$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $7f239c261aab7111$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $7f239c261aab7111$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (_proxyFormState.isValidating || _proxyFormState.validatingFields) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $7f239c261aab7111$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $7f239c261aab7111$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$7f239c261aab7111$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($7f239c261aab7111$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($7f239c261aab7111$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $7f239c261aab7111$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($7f239c261aab7111$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($7f239c261aab7111$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $7f239c261aab7111$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $7f239c261aab7111$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($7f239c261aab7111$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($7f239c261aab7111$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $7f239c261aab7111$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $7f239c261aab7111$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $7f239c261aab7111$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $7f239c261aab7111$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $7f239c261aab7111$export$3988ae62b71be9a3(_formValues, name, $7f239c261aab7111$var$isUndefined(value1) ? $7f239c261aab7111$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $7f239c261aab7111$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $7f239c261aab7111$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $7f239c261aab7111$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        const disabledField = !!($7f239c261aab7111$export$3988ae62b71be9a3(_fields, name) && $7f239c261aab7111$export$3988ae62b71be9a3(_fields, name)._f && $7f239c261aab7111$export$3988ae62b71be9a3(_fields, name)._f.disabled);
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = disabledField || $7f239c261aab7111$var$deepEqual($7f239c261aab7111$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = !!(!disabledField && $7f239c261aab7111$export$3988ae62b71be9a3(_formState.dirtyFields, name));
            isCurrentFieldPristine || disabledField ? $7f239c261aab7111$var$unset(_formState.dirtyFields, name) : $7f239c261aab7111$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $7f239c261aab7111$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $7f239c261aab7111$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $7f239c261aab7111$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $7f239c261aab7111$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $7f239c261aab7111$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $7f239c261aab7111$var$unset(_formState.errors, name);
        }
        if ((error ? !$7f239c261aab7111$var$deepEqual(previousFieldError, error) : previousFieldError) || !$7f239c261aab7111$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $7f239c261aab7111$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _executeSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $7f239c261aab7111$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $7f239c261aab7111$export$3988ae62b71be9a3(errors, name);
            error ? $7f239c261aab7111$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $7f239c261aab7111$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $7f239c261aab7111$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $7f239c261aab7111$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($7f239c261aab7111$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $7f239c261aab7111$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $7f239c261aab7111$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $7f239c261aab7111$var$unset(_formState.errors, _f.name));
                }
                !$7f239c261aab7111$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$7f239c261aab7111$var$live(ref)) : !$7f239c261aab7111$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $7f239c261aab7111$export$adaa4cf7ef1b65be(_formValues, name, data), !$7f239c261aab7111$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$7f239c261aab7111$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $7f239c261aab7111$var$isUndefined(defaultValue) ? _defaultValues : $7f239c261aab7111$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$7f239c261aab7111$var$compact($7f239c261aab7111$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $7f239c261aab7111$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $7f239c261aab7111$export$adaa4cf7ef1b65be(_formValues, name, $7f239c261aab7111$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $7f239c261aab7111$var$isHTMLElement(fieldReference.ref) && $7f239c261aab7111$var$isNullOrUndefined(value1) ? "" : value1;
                if ($7f239c261aab7111$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($7f239c261aab7111$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($7f239c261aab7111$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$7f239c261aab7111$var$isPrimitive(fieldValue) || field && !field._f) && !$7f239c261aab7111$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $7f239c261aab7111$var$cloneObject(value1);
        $7f239c261aab7111$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $7f239c261aab7111$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$7f239c261aab7111$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $7f239c261aab7111$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: {
                ..._formValues
            }
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $7f239c261aab7111$var$getFieldValue(field._f) : $7f239c261aab7111$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $7f239c261aab7111$var$deepEqual(fieldValue, $7f239c261aab7111$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $7f239c261aab7111$var$EVENTS.BLUR || event.type === $7f239c261aab7111$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$7f239c261aab7111$var$hasValidation(field._f) && !_options.resolver && !$7f239c261aab7111$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $7f239c261aab7111$var$skipValidation(isBlurEvent, $7f239c261aab7111$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $7f239c261aab7111$var$isWatched(name, _names, isBlurEvent);
            $7f239c261aab7111$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$7f239c261aab7111$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid) {
                    if (props.mode === "onBlur") {
                        if (isBlurEvent) _updateValid();
                    } else _updateValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $7f239c261aab7111$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $7f239c261aab7111$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $7f239c261aab7111$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $7f239c261aab7111$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($7f239c261aab7111$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $7f239c261aab7111$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($7f239c261aab7111$var$isUndefined(name) ? name : fieldNames);
            isValid = $7f239c261aab7111$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$7f239c261aab7111$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$7f239c261aab7111$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $7f239c261aab7111$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        return $7f239c261aab7111$var$isUndefined(fieldNames) ? values : $7f239c261aab7111$var$isString(fieldNames) ? $7f239c261aab7111$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$7f239c261aab7111$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$7f239c261aab7111$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$7f239c261aab7111$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $7f239c261aab7111$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$7f239c261aab7111$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$7f239c261aab7111$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $7f239c261aab7111$var$convertToArrayPayload(name).forEach((inputName)=>$7f239c261aab7111$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($7f239c261aab7111$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $7f239c261aab7111$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $7f239c261aab7111$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$7f239c261aab7111$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $7f239c261aab7111$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $7f239c261aab7111$var$unset(_fields, fieldName);
                $7f239c261aab7111$var$unset(_formValues, fieldName);
            }
            !options.keepError && $7f239c261aab7111$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $7f239c261aab7111$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $7f239c261aab7111$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $7f239c261aab7111$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $7f239c261aab7111$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields, value: value1 })=>{
        if ($7f239c261aab7111$var$isBoolean(disabled) && _state.mount || !!disabled) {
            const inputValue = disabled ? undefined : $7f239c261aab7111$var$isUndefined(value1) ? $7f239c261aab7111$var$getFieldValue(field ? field._f : $7f239c261aab7111$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $7f239c261aab7111$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $7f239c261aab7111$var$isBoolean(options.disabled) || $7f239c261aab7111$var$isBoolean(props.disabled);
        $7f239c261aab7111$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: $7f239c261aab7111$var$isBoolean(options.disabled) ? options.disabled : props.disabled,
            name: name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || props.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $7f239c261aab7111$var$getRuleValue(options.min),
                max: $7f239c261aab7111$var$getRuleValue(options.max),
                minLength: $7f239c261aab7111$var$getRuleValue(options.minLength),
                maxLength: $7f239c261aab7111$var$getRuleValue(options.maxLength),
                pattern: $7f239c261aab7111$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $7f239c261aab7111$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $7f239c261aab7111$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $7f239c261aab7111$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($7f239c261aab7111$var$live),
                                    fieldRef,
                                    ...Array.isArray($7f239c261aab7111$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($7f239c261aab7111$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $7f239c261aab7111$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($7f239c261aab7111$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $7f239c261aab7111$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $7f239c261aab7111$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $7f239c261aab7111$var$unset(_formState.errors, "root");
            if ($7f239c261aab7111$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $7f239c261aab7111$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($7f239c261aab7111$export$3988ae62b71be9a3(_fields, name)) {
            if ($7f239c261aab7111$var$isUndefined(options.defaultValue)) setValue(name, $7f239c261aab7111$var$cloneObject($7f239c261aab7111$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $7f239c261aab7111$export$adaa4cf7ef1b65be(_defaultValues, name, $7f239c261aab7111$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $7f239c261aab7111$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $7f239c261aab7111$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $7f239c261aab7111$var$cloneObject($7f239c261aab7111$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $7f239c261aab7111$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $7f239c261aab7111$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $7f239c261aab7111$var$cloneObject(updatedValues);
        const isEmptyResetValues = $7f239c261aab7111$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) for (const fieldName of _names.mount)$7f239c261aab7111$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $7f239c261aab7111$export$adaa4cf7ef1b65be(values, fieldName, $7f239c261aab7111$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $7f239c261aab7111$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($7f239c261aab7111$var$isWeb && $7f239c261aab7111$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($7f239c261aab7111$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $7f239c261aab7111$var$cloneObject(_defaultValues) : {} : $7f239c261aab7111$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$7f239c261aab7111$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $7f239c261aab7111$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $7f239c261aab7111$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($7f239c261aab7111$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $7f239c261aab7111$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$7f239c261aab7111$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            _setErrors: _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $7f239c261aab7111$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $7f239c261aab7111$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: $7f239c261aab7111$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$7f239c261aab7111$var$createFormControl(props),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $7f239c261aab7111$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($7f239c261aab7111$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>{
        if (props.values && !$7f239c261aab7111$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    _formControl.current.formState = $7f239c261aab7111$var$getProxyFormState(formState, control);
    return _formControl.current;
}


var $ef0b1f75c84d9295$var$t = function(e, t, i) {
    if (e && "reportValidity" in e) {
        var n = (0, $7f239c261aab7111$export$3988ae62b71be9a3)(i, t);
        e.setCustomValidity(n && n.message || ""), e.reportValidity();
    }
}, $ef0b1f75c84d9295$export$6bd436d70894afff = function(r, e) {
    var i = function(i) {
        var n = e.fields[i];
        n && n.ref && "reportValidity" in n.ref ? $ef0b1f75c84d9295$var$t(n.ref, i, r) : n.refs && n.refs.forEach(function(e) {
            return $ef0b1f75c84d9295$var$t(e, i, r);
        });
    };
    for(var n in e.fields)i(n);
}, $ef0b1f75c84d9295$export$f0545b73a179e3a2 = function(t, n) {
    n.shouldUseNativeValidation && $ef0b1f75c84d9295$export$6bd436d70894afff(t, n);
    var f = {};
    for(var a in t){
        var s = (0, $7f239c261aab7111$export$3988ae62b71be9a3)(n.fields, a), u = Object.assign(t[a] || {}, {
            ref: s && s.ref
        });
        if ($ef0b1f75c84d9295$var$o(n.names || Object.keys(t), a)) {
            var c = Object.assign({}, (0, $7f239c261aab7111$export$3988ae62b71be9a3)(f, a));
            (0, $7f239c261aab7111$export$adaa4cf7ef1b65be)(c, "root", u), (0, $7f239c261aab7111$export$adaa4cf7ef1b65be)(f, a, c);
        } else (0, $7f239c261aab7111$export$adaa4cf7ef1b65be)(f, a, u);
    }
    return f;
}, $ef0b1f75c84d9295$var$o = function(r, e) {
    return r.some(function(r) {
        return r.startsWith(e + ".");
    });
};



var $c93e1755686e840b$var$n = function(r, e) {
    for(var n = {}; r.length;){
        var t = r[0], s = t.code, i = t.message, a = t.path.join(".");
        if (!n[a]) {
            if ("unionErrors" in t) {
                var u = t.unionErrors[0].errors[0];
                n[a] = {
                    message: u.message,
                    type: u.code
                };
            } else n[a] = {
                message: i,
                type: s
            };
        }
        if ("unionErrors" in t && t.unionErrors.forEach(function(e) {
            return e.errors.forEach(function(e) {
                return r.push(e);
            });
        }), e) {
            var c = n[a].types, f = c && c[t.code];
            n[a] = (0, $7f239c261aab7111$export$b196c2a4f765bd30)(a, e, n, s, f ? [].concat(f, t.message) : t.message);
        }
        r.shift();
    }
    return n;
}, $c93e1755686e840b$export$66b7b5879c70f722 = function(o, t, s) {
    return void 0 === s && (s = {}), function(i, a, u) {
        try {
            return Promise.resolve(function(e, n) {
                try {
                    var a = Promise.resolve(o["sync" === s.mode ? "parse" : "parseAsync"](i, t)).then(function(e) {
                        return u.shouldUseNativeValidation && (0, $ef0b1f75c84d9295$export$6bd436d70894afff)({}, u), {
                            errors: {},
                            values: s.raw ? i : e
                        };
                    });
                } catch (r) {
                    return n(r);
                }
                return a && a.then ? a.then(void 0, n) : a;
            }(0, function(r) {
                if (function(r) {
                    return Array.isArray(null == r ? void 0 : r.errors);
                }(r)) return {
                    values: {},
                    errors: (0, $ef0b1f75c84d9295$export$f0545b73a179e3a2)($c93e1755686e840b$var$n(r.errors, !u.shouldUseNativeValidation && "all" === u.criteriaMode), u)
                };
                throw r;
            }));
        } catch (r) {
            return Promise.reject(r);
        }
    };
};


var $9c34a6e94ffc2707$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($9c34a6e94ffc2707$exports, "__esModule", {
    value: true
});
$9c34a6e94ffc2707$exports.default = void 0;

var $9c34a6e94ffc2707$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $9c34a6e94ffc2707$var$_default = $9c34a6e94ffc2707$exports.default = (0, $9c34a6e94ffc2707$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "M19 2h-4.18C14.4.84 13.3 0 12 0S9.6.84 9.18 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m6 18H6c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h1v1c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V4h1c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1"
}), "ContentPasteRounded");


var $19feae430f2998b0$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($19feae430f2998b0$exports, "__esModule", {
    value: true
});
$19feae430f2998b0$exports.default = void 0;

var $19feae430f2998b0$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $19feae430f2998b0$var$_default = $19feae430f2998b0$exports.default = (0, $19feae430f2998b0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "m9 16.2-3.5-3.5a.9839.9839 0 0 0-1.4 0c-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4a.9839.9839 0 0 0-1.4 0z"
}), "DoneRounded");


var $dc17c59b2b003b31$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($dc17c59b2b003b31$exports, "__esModule", {
    value: true
});
$dc17c59b2b003b31$exports.default = void 0;

var $dc17c59b2b003b31$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $dc17c59b2b003b31$var$_default = $dc17c59b2b003b31$exports.default = (0, $dc17c59b2b003b31$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $6iAGf.jsx)("path", {
        d: "M7 12.27v3.72l5 2.73 5-2.73v-3.72L12 15zM5.18 9 12 12.72 18.82 9 12 5.28z",
        opacity: ".3"
    }, "0"),
    /*#__PURE__*/ (0, $6iAGf.jsx)("path", {
        d: "M12 3 1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9zm5 12.99-5 2.73-5-2.73v-3.72L12 15l5-2.73zm-5-3.27L5.18 9 12 5.28 18.82 9z"
    }, "1")
], "SchoolTwoTone");


var $ae0bb7cfd9538ddc$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($ae0bb7cfd9538ddc$exports, "__esModule", {
    value: true
});
$ae0bb7cfd9538ddc$exports.default = void 0;

var $ae0bb7cfd9538ddc$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $ae0bb7cfd9538ddc$var$_default = $ae0bb7cfd9538ddc$exports.default = (0, $ae0bb7cfd9538ddc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "m3.4 20.4 17.45-7.48c.81-.35.81-1.49 0-1.84L3.4 3.6c-.66-.29-1.39.2-1.39.91L2 9.12c0 .5.37.93.87.99L17 12 2.87 13.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91"
}), "SendRounded");


var $b38c869611eac6db$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($b38c869611eac6db$exports, "__esModule", {
    value: true
});
$b38c869611eac6db$exports.default = void 0;

var $b38c869611eac6db$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $b38c869611eac6db$var$_default = $b38c869611eac6db$exports.default = (0, $b38c869611eac6db$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "M8 6h8c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2"
}), "StopRounded");


var $1553ce48ecd80991$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($1553ce48ecd80991$exports, "__esModule", {
    value: true
});
$1553ce48ecd80991$exports.default = void 0;

var $1553ce48ecd80991$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $1553ce48ecd80991$var$_default = $1553ce48ecd80991$exports.default = (0, $1553ce48ecd80991$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "m10.88 21.94 5.53-5.54c.37-.37.58-.88.58-1.41V5c0-1.1-.9-2-2-2H6c-.8 0-1.52.48-1.83 1.21L.91 11.82C.06 13.8 1.51 16 3.66 16h5.65l-.95 4.58c-.1.5.05 1.01.41 1.37.59.58 1.53.58 2.11-.01M21 3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2"
}), "ThumbDownAltRounded");


var $976bbbd90af325f8$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($976bbbd90af325f8$exports, "__esModule", {
    value: true
});
$976bbbd90af325f8$exports.default = void 0;

var $976bbbd90af325f8$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $976bbbd90af325f8$var$_default = $976bbbd90af325f8$exports.default = (0, $976bbbd90af325f8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "M13.12 2.06 7.58 7.6c-.37.37-.58.88-.58 1.41V19c0 1.1.9 2 2 2h9c.8 0 1.52-.48 1.84-1.21l3.26-7.61C23.94 10.2 22.49 8 20.34 8h-5.65l.95-4.58c.1-.5-.05-1.01-.41-1.37-.59-.58-1.53-.58-2.11.01M3 21c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2s-2 .9-2 2v8c0 1.1.9 2 2 2"
}), "ThumbUpAltRounded");



var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");


var $3Upoa = parcelRequire("3Upoa");

var $cwrhp = parcelRequire("cwrhp");




parcelRequire("1EuC8");

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");

var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");

var $3Upoa = parcelRequire("3Upoa");

var $cwrhp = parcelRequire("cwrhp");



var $1EuC8 = parcelRequire("1EuC8");




function $975a0d82bb04313a$export$c7c50641356bdfa5(slot) {
    return (0, $bd48de20fb876697$export$1d132570e11858b0)("MuiSvgIcon", slot);
}
const $975a0d82bb04313a$var$svgIconClasses = (0, $bd48de20fb876697$export$de4f15803c389669)("MuiSvgIcon", [
    "root",
    "colorInherit",
    "colorPrimary",
    "colorNeutral",
    "colorDanger",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "fontSizeInherit",
    "fontSizeXs",
    "fontSizeSm",
    "fontSizeMd",
    "fontSizeLg",
    "fontSizeXl",
    "fontSizeXl2",
    "fontSizeXl3",
    "fontSizeXl4",
    "fontSizeXl5",
    "fontSizeXl6"
]);
var $975a0d82bb04313a$export$2e2bcd8739ae039 = $975a0d82bb04313a$var$svgIconClasses;



var $6iAGf = parcelRequire("6iAGf");
"use client";
const $4e4eda6aa86eecab$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox",
    "slots",
    "slotProps"
];
const $4e4eda6aa86eecab$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize } = ownerState;
    const slots = {
        root: [
            "root",
            color && `color${(0, $cwrhp.default)(color)}`,
            fontSize && `fontSize${(0, $cwrhp.default)(fontSize)}`
        ]
    };
    return (0, $3Upoa.default)(slots, (0, $975a0d82bb04313a$export$c7c50641356bdfa5), {});
};
const $4e4eda6aa86eecab$var$SvgIconRoot = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("svg", {
    name: "JoySvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$variants$plain;
    return (0, $cPOSH.default)({}, ownerState.instanceFontSize && ownerState.instanceFontSize !== "inherit" && {
        "--Icon-fontSize": theme.vars.fontSize[ownerState.instanceFontSize]
    }, {
        userSelect: "none",
        margin: "var(--Icon-margin)",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0
    }, ownerState.fontSize && ownerState.fontSize !== "inherit" && {
        fontSize: `var(--Icon-fontSize, ${theme.fontSize[ownerState.fontSize]})`
    }, {
        color: "var(--Icon-color)"
    }, ownerState.color !== "inherit" && ownerState.color !== "context" && theme.vars.palette[ownerState.color] && {
        color: theme.vars.palette[ownerState.color].plainColor
    }, ownerState.color === "context" && {
        color: (_theme$variants$plain = theme.variants.plain) == null || (_theme$variants$plain = _theme$variants$plain[ownerState.color]) == null ? void 0 : _theme$variants$plain.color
    });
});
/**
 *
 * Demos:
 *
 * - [Avatar](https://mui.com/joy-ui/react-avatar/)
 *
 * API:
 *
 * - [SvgIcon API](https://mui.com/joy-ui/api/svg-icon/)
 */ const $4e4eda6aa86eecab$var$SvgIcon = /*#__PURE__*/ $1EuC8.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $171c82576b265f00$export$2e2bcd8739ae039)({
        props: inProps,
        name: "JoySvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "xl", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24", slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $aT5bD.default)(props, $4e4eda6aa86eecab$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $1EuC8.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $cPOSH.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const classes = $4e4eda6aa86eecab$var$useUtilityClasses(ownerState);
    const externalForwardedProps = (0, $cPOSH.default)({}, other, {
        component: component,
        slots: slots,
        slotProps: slotProps
    });
    const [SlotRoot, rootProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("root", {
        ref: ref,
        className: (0, $f8208f51eaf9f9e6$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $4e4eda6aa86eecab$var$SvgIconRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: (0, $cPOSH.default)({
            color: htmlColor,
            focusable: false
        }, titleAccess && {
            role: "img"
        }, !titleAccess && {
            "aria-hidden": true
        }, !inheritViewBox && {
            viewBox: viewBox
        }, hasSvgAsChild && children.props)
    });
    return /*#__PURE__*/ (0, $6iAGf.jsxs)(SlotRoot, (0, $cPOSH.default)({}, rootProps, {
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $6iAGf.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
var $4e4eda6aa86eecab$export$2e2bcd8739ae039 = $4e4eda6aa86eecab$var$SvgIcon;



var $6iAGf = parcelRequire("6iAGf");
function $5be712047abd00b8$export$2e2bcd8739ae039(path, displayName) {
    // @ts-ignore internal component
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $6iAGf.jsx)((0, $4e4eda6aa86eecab$export$2e2bcd8739ae039), (0, $cPOSH.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    // @ts-ignore internal component
    Component.muiName = (0, $4e4eda6aa86eecab$export$2e2bcd8739ae039).muiName;
    // @ts-ignore internal component
    return /*#__PURE__*/ $1EuC8.memo(/*#__PURE__*/ $1EuC8.forwardRef(Component));
}



var $6iAGf = parcelRequire("6iAGf");
"use client";
var $f5e39f5dfcb4cf73$export$2e2bcd8739ae039 = (0, $5be712047abd00b8$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");



function $040a5cd5a53fb8b4$export$ffd560f22c0ecf04(slot) {
    return (0, $bd48de20fb876697$export$1d132570e11858b0)("MuiAvatar", slot);
}
const $040a5cd5a53fb8b4$var$avatarClasses = (0, $bd48de20fb876697$export$de4f15803c389669)("MuiAvatar", [
    "root",
    "colorPrimary",
    "colorNeutral",
    "colorDanger",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "colorContext",
    "fallback",
    "sizeSm",
    "sizeMd",
    "sizeLg",
    "img",
    "variantOutlined",
    "variantSoft",
    "variantSolid"
]);
var $040a5cd5a53fb8b4$export$2e2bcd8739ae039 = $040a5cd5a53fb8b4$var$avatarClasses;



var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");



var $3Upoa = parcelRequire("3Upoa");



function $bd04cef2b8e0f211$export$e278541d928aee3a(slot) {
    return (0, $bd48de20fb876697$export$1d132570e11858b0)("MuiAvatarGroup", slot);
}
const $bd04cef2b8e0f211$var$avatarGroupClasses = (0, $bd48de20fb876697$export$de4f15803c389669)("MuiAvatarGroup", [
    "root"
]);
var $bd04cef2b8e0f211$export$2e2bcd8739ae039 = $bd04cef2b8e0f211$var$avatarGroupClasses;




var $6iAGf = parcelRequire("6iAGf");
"use client";
const $77caed1939fa4cb8$var$_excluded = [
    "className",
    "color",
    "component",
    "size",
    "variant",
    "children",
    "slots",
    "slotProps"
];
const $77caed1939fa4cb8$export$4f18251748129091 = /*#__PURE__*/ $1EuC8.createContext(undefined);
const $77caed1939fa4cb8$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $3Upoa.default)(slots, (0, $bd04cef2b8e0f211$export$e278541d928aee3a), {});
};
const $77caed1939fa4cb8$var$AvatarGroupGroupRoot = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("div", {
    name: "JoyAvatarGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ ownerState: ownerState, theme: theme })=>(0, $cPOSH.default)({}, ownerState.size === "sm" && {
        "--AvatarGroup-gap": "-0.375rem",
        "--Avatar-ringSize": "2px"
    }, ownerState.size === "md" && {
        "--AvatarGroup-gap": "-0.5rem",
        "--Avatar-ringSize": "2px"
    }, ownerState.size === "lg" && {
        "--AvatarGroup-gap": "-0.625rem",
        "--Avatar-ringSize": "4px"
    }, {
        "--Avatar-ring": `0 0 0 var(--Avatar-ringSize) var(--Avatar-ringColor, ${theme.vars.palette.background.surface})`,
        "--Avatar-marginInlineStart": "var(--AvatarGroup-gap)",
        display: "flex",
        marginInlineStart: "calc(-1 * var(--AvatarGroup-gap))"
    }));
/**
 *
 * Demos:
 *
 * - [Avatar](https://mui.com/joy-ui/react-avatar/)
 *
 * API:
 *
 * - [AvatarGroup API](https://mui.com/joy-ui/api/avatar-group/)
 */ const $77caed1939fa4cb8$var$AvatarGroup = /*#__PURE__*/ $1EuC8.forwardRef(function AvatarGroup(inProps, ref) {
    const props = (0, $171c82576b265f00$export$2e2bcd8739ae039)({
        props: inProps,
        name: "JoyAvatarGroup"
    });
    const { className: className, color: color, component: component = "div", size: size = "md", variant: variant, children: children, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $aT5bD.default)(props, $77caed1939fa4cb8$var$_excluded);
    const ownerState = $1EuC8.useMemo(()=>(0, $cPOSH.default)({}, props, {
            color: color,
            component: component,
            size: size,
            variant: variant
        }), [
        color,
        component,
        props,
        size,
        variant
    ]);
    const classes = $77caed1939fa4cb8$var$useUtilityClasses();
    const [SlotRoot, rootProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("root", {
        ref: ref,
        className: (0, $f8208f51eaf9f9e6$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $77caed1939fa4cb8$var$AvatarGroupGroupRoot,
        externalForwardedProps: (0, $cPOSH.default)({}, other, {
            component: component,
            slots: slots,
            slotProps: slotProps
        }),
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $6iAGf.jsx)($77caed1939fa4cb8$export$4f18251748129091.Provider, {
        value: ownerState,
        children: /*#__PURE__*/ (0, $6iAGf.jsx)(SlotRoot, (0, $cPOSH.default)({}, rootProps, {
            children: children
        }))
    });
});
var $77caed1939fa4cb8$export$2e2bcd8739ae039 = $77caed1939fa4cb8$var$AvatarGroup;



var $6iAGf = parcelRequire("6iAGf");
"use client";
const $016b7e45bbf1bcde$var$_excluded = [
    "alt",
    "color",
    "size",
    "variant",
    "src",
    "srcSet",
    "children",
    "component",
    "slots",
    "slotProps"
];
const $016b7e45bbf1bcde$var$useUtilityClasses = (ownerState)=>{
    const { size: size, variant: variant, color: color, src: src, srcSet: srcSet } = ownerState;
    const slots = {
        root: [
            "root",
            variant && `variant${(0, $cwrhp.default)(variant)}`,
            color && `color${(0, $cwrhp.default)(color)}`,
            size && `size${(0, $cwrhp.default)(size)}`
        ],
        img: [
            (src || srcSet) && "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $3Upoa.default)(slots, (0, $040a5cd5a53fb8b4$export$ffd560f22c0ecf04), {});
};
const $016b7e45bbf1bcde$var$AvatarRoot = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("div", {
    name: "JoyAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$variants;
    return [
        (0, $cPOSH.default)({}, ownerState.size === "sm" && {
            width: `var(--Avatar-size, 2rem)`,
            height: `var(--Avatar-size, 2rem)`,
            fontSize: `calc(var(--Avatar-size, 2rem) * 0.4375)` // default as 14px
        }, ownerState.size === "md" && {
            width: `var(--Avatar-size, 2.5rem)`,
            height: `var(--Avatar-size, 2.5rem)`,
            fontSize: `calc(var(--Avatar-size, 2.5rem) * 0.4)` // default as 16px
        }, ownerState.size === "lg" && {
            width: `var(--Avatar-size, 3rem)`,
            height: `var(--Avatar-size, 3rem)`,
            fontSize: `calc(var(--Avatar-size, 3rem) * 0.375)` // default as 18px
        }, {
            marginInlineStart: "var(--Avatar-marginInlineStart)",
            boxShadow: `var(--Avatar-ring)`,
            fontFamily: theme.vars.fontFamily.body,
            fontWeight: theme.vars.fontWeight.md,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            lineHeight: 1,
            overflow: "hidden",
            borderRadius: "var(--Avatar-radius, 50%)",
            userSelect: "none"
        }),
        (_theme$variants = theme.variants[ownerState.variant]) == null ? void 0 : _theme$variants[ownerState.color]
    ];
});
const $016b7e45bbf1bcde$var$AvatarImg = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("img", {
    name: "JoyAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $016b7e45bbf1bcde$var$AvatarFallback = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)((0, $f5e39f5dfcb4cf73$export$2e2bcd8739ae039), {
    name: "JoyAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "64%",
    height: "64%"
});
function $016b7e45bbf1bcde$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $1EuC8.useState(false);
    $1EuC8.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        if (src) image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
/**
 *
 * Demos:
 *
 * - [Avatar](https://mui.com/joy-ui/react-avatar/)
 * - [Skeleton](https://mui.com/joy-ui/react-skeleton/)
 *
 * API:
 *
 * - [Avatar API](https://mui.com/joy-ui/api/avatar/)
 */ const $016b7e45bbf1bcde$var$Avatar = /*#__PURE__*/ $1EuC8.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $171c82576b265f00$export$2e2bcd8739ae039)({
        props: inProps,
        name: "JoyAvatar"
    });
    const groupContext = $1EuC8.useContext((0, $77caed1939fa4cb8$export$4f18251748129091));
    const { alt: alt, color: colorProp = "neutral", size: sizeProp = "md", variant: variantProp = "soft", src: src, srcSet: srcSet, children: childrenProp, component: component, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $aT5bD.default)(props, $016b7e45bbf1bcde$var$_excluded);
    const variant = inProps.variant || (groupContext == null ? void 0 : groupContext.variant) || variantProp;
    const { getColor: getColor } = (0, $45219fd0b0701701$export$83a9a651654e258f)(variant);
    const colorFromContext = inProps.color || (groupContext == null ? void 0 : groupContext.color);
    const color = colorFromContext !== "context" ? getColor(colorFromContext, colorProp) : colorProp;
    const size = inProps.size || (groupContext == null ? void 0 : groupContext.size) || sizeProp;
    let children = null;
    const ownerState = (0, $cPOSH.default)({}, props, {
        color: color,
        size: size,
        variant: variant,
        grouped: !!groupContext
    });
    const classes = $016b7e45bbf1bcde$var$useUtilityClasses(ownerState);
    const externalForwardedProps = (0, $cPOSH.default)({}, other, {
        component: component,
        slots: slots,
        slotProps: slotProps
    });
    const [SlotRoot, rootProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("root", {
        ref: ref,
        className: classes.root,
        elementType: $016b7e45bbf1bcde$var$AvatarRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SlotImg, imageProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("img", {
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet
        },
        className: classes.img,
        elementType: $016b7e45bbf1bcde$var$AvatarImg,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SlotFallback, fallbackProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("fallback", {
        className: classes.fallback,
        elementType: $016b7e45bbf1bcde$var$AvatarFallback,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $016b7e45bbf1bcde$var$useLoaded((0, $cPOSH.default)({}, imageProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $6iAGf.jsx)(SlotImg, (0, $cPOSH.default)({}, imageProps));
    else if (childrenProp != null) children = childrenProp;
    else if (alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $6iAGf.jsx)(SlotFallback, (0, $cPOSH.default)({}, fallbackProps));
    return /*#__PURE__*/ (0, $6iAGf.jsx)(SlotRoot, (0, $cPOSH.default)({}, rootProps, {
        children: children
    }));
});
var $016b7e45bbf1bcde$export$2e2bcd8739ae039 = $016b7e45bbf1bcde$var$Avatar;








var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");



var $cwrhp = parcelRequire("cwrhp");

var $cOeZu = parcelRequire("cOeZu");

var $3Upoa = parcelRequire("3Upoa");



function $4575425b497cf2de$export$c987db9fc844f86(slot) {
    return (0, $bd48de20fb876697$export$1d132570e11858b0)("MuiSkeleton", slot);
}
const $4575425b497cf2de$var$skeletonClasses = (0, $bd48de20fb876697$export$de4f15803c389669)("MuiSkeleton", [
    "root",
    "variantOverlay",
    "variantCircular",
    "variantRectangular",
    "variantText",
    "variantInline",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "body1",
    "body2",
    "body3"
]);
var $4575425b497cf2de$export$2e2bcd8739ae039 = $4575425b497cf2de$var$skeletonClasses;




var $6iAGf = parcelRequire("6iAGf");
"use client";
const $9c99723ec254925f$var$_excluded = [
    "className",
    "component",
    "children",
    "animation",
    "overlay",
    "loading",
    "variant",
    "level",
    "height",
    "width",
    "sx",
    "slots",
    "slotProps"
];
let $9c99723ec254925f$var$_ = (t)=>t, $9c99723ec254925f$var$_t, $9c99723ec254925f$var$_t2, $9c99723ec254925f$var$_t3, $9c99723ec254925f$var$_t4, $9c99723ec254925f$var$_t5;
const $9c99723ec254925f$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, level: level } = ownerState;
    const slots = {
        root: [
            "root",
            variant && `variant${(0, $cwrhp.default)(variant)}`,
            level && `level${(0, $cwrhp.default)(level)}`
        ]
    };
    return (0, $3Upoa.default)(slots, (0, $4575425b497cf2de$export$c987db9fc844f86), {});
};
// Add solid background for masking the component that has the same background.
// Otherwise, the pulse animation will not work properly.
const $9c99723ec254925f$var$pulseKeyframe = (0, $cOeZu.keyframes)($9c99723ec254925f$var$_t || ($9c99723ec254925f$var$_t = $9c99723ec254925f$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.8;
    background: var(--unstable_pulse-bg);
  }

  100% {
    opacity: 1;
  }
`));
const $9c99723ec254925f$var$waveKeyframe = (0, $cOeZu.keyframes)($9c99723ec254925f$var$_t2 || ($9c99723ec254925f$var$_t2 = $9c99723ec254925f$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const $9c99723ec254925f$var$SkeletonRoot = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("span", {
    name: "JoySkeleton",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(/**
 * Animations
 */ ({ ownerState: ownerState, theme: theme })=>ownerState.animation === "pulse" && ownerState.variant !== "inline" && (0, $cOeZu.css)($9c99723ec254925f$var$_t3 || ($9c99723ec254925f$var$_t3 = $9c99723ec254925f$var$_`
      &::before {
        animation: ${0} 1.5s ease-in-out 0.5s infinite;
        background: ${0};
      }
    `), $9c99723ec254925f$var$pulseKeyframe, theme.vars.palette.background.level2), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === "pulse" && ownerState.variant === "inline" && (0, $cOeZu.css)($9c99723ec254925f$var$_t4 || ($9c99723ec254925f$var$_t4 = $9c99723ec254925f$var$_`
      &::after {
        animation: ${0} 1.5s ease-in-out 0.5s infinite;
        background: ${0};
      }
    `), $9c99723ec254925f$var$pulseKeyframe, theme.vars.palette.background.level2), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === "wave" && (0, $cOeZu.css)($9c99723ec254925f$var$_t5 || ($9c99723ec254925f$var$_t5 = $9c99723ec254925f$var$_`
      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);
      background: ${0};

      &::after {
        content: ' ';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: var(--unstable_pseudo-zIndex);
        animation: ${0} 1.6s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          var(--unstable_wave-bg, rgba(0 0 0 / 0.08)),
          transparent
        );
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
      }
    `), theme.vars.palette.background.level2, $9c99723ec254925f$var$waveKeyframe), /**
 * Implementation notes:
 * 1. The `Skeleton` has 3 parts:
 *  - the root (span) element as a container
 *  - the ::before pseudo-element for covering the content
 *  - the ::after pseudo-element for animation on top of the ::before pseudo-element
 *
 * 2. The root element and ::before will change to absolute position when shape="overlay" to cover the parent's content.
 *
 * 3. For geometry shape (rectangular, circular), the typography styles are applied to the root element so that width, height can be customized based on the font-size.
 */ ({ ownerState: ownerState, theme: theme })=>{
    var _components, _theme$typography, _theme$typography2, _theme$typography3;
    const defaultLevel = ((_components = theme.components) == null || (_components = _components.JoyTypography) == null || (_components = _components.defaultProps) == null ? void 0 : _components.level) || "body1";
    return [
        {
            display: "block",
            position: "relative",
            "--unstable_pseudo-zIndex": 9,
            "--unstable_pulse-bg": theme.vars.palette.background.level1,
            overflow: "hidden",
            cursor: "default",
            "& *": {
                visibility: "hidden"
            },
            "&::before": {
                display: "block",
                content: '" "',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: "var(--unstable_pseudo-zIndex)",
                borderRadius: "inherit"
            },
            [theme.getColorSchemeSelector("dark")]: {
                "--unstable_wave-bg": "rgba(255 255 255 / 0.1)"
            }
        },
        ownerState.variant === "rectangular" && (0, $cPOSH.default)({
            borderRadius: "min(0.15em, 6px)",
            height: "auto",
            width: "100%",
            "&::before": {
                position: "absolute"
            }
        }, !ownerState.animation && {
            backgroundColor: theme.vars.palette.background.level2
        }, ownerState.level !== "inherit" && (0, $cPOSH.default)({}, theme.typography[ownerState.level])),
        ownerState.variant === "circular" && (0, $cPOSH.default)({
            borderRadius: "50%",
            width: "100%",
            height: "100%",
            "&::before": {
                position: "absolute"
            }
        }, !ownerState.animation && {
            backgroundColor: theme.vars.palette.background.level2
        }, ownerState.level !== "inherit" && (0, $cPOSH.default)({}, theme.typography[ownerState.level])),
        ownerState.variant === "text" && (0, $cPOSH.default)({
            borderRadius: "min(0.15em, 6px)",
            background: "transparent",
            width: "100%"
        }, ownerState.level !== "inherit" && (0, $cPOSH.default)({}, theme.typography[ownerState.level || defaultLevel], {
            paddingBlockStart: `calc((${((_theme$typography = theme.typography[ownerState.level || defaultLevel]) == null ? void 0 : _theme$typography.lineHeight) || 1} - 1) * 0.56em)`,
            paddingBlockEnd: `calc((${((_theme$typography2 = theme.typography[ownerState.level || defaultLevel]) == null ? void 0 : _theme$typography2.lineHeight) || 1} - 1) * 0.44em)`,
            "&::before": (0, $cPOSH.default)({
                height: "1em"
            }, theme.typography[ownerState.level || defaultLevel], ownerState.animation === "wave" && {
                backgroundColor: theme.vars.palette.background.level2
            }, !ownerState.animation && {
                backgroundColor: theme.vars.palette.background.level2
            }),
            "&::after": (0, $cPOSH.default)({
                height: "1em",
                top: `calc((${((_theme$typography3 = theme.typography[ownerState.level || defaultLevel]) == null ? void 0 : _theme$typography3.lineHeight) || 1} - 1) * 0.56em)`
            }, theme.typography[ownerState.level || defaultLevel])
        })),
        ownerState.variant === "inline" && (0, $cPOSH.default)({
            display: "inline",
            position: "initial",
            borderRadius: "min(0.15em, 6px)"
        }, !ownerState.animation && {
            backgroundColor: theme.vars.palette.background.level2
        }, ownerState.level !== "inherit" && (0, $cPOSH.default)({}, theme.typography[ownerState.level]), {
            "-webkit-mask-image": "-webkit-radial-gradient(white, black)",
            "&::before": {
                position: "absolute",
                zIndex: "var(--unstable_pseudo-zIndex)",
                backgroundColor: theme.vars.palette.background.level2
            }
        }, ownerState.animation === "pulse" && {
            "&::after": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: "var(--unstable_pseudo-zIndex)",
                backgroundColor: theme.vars.palette.background.level2
            }
        }),
        ownerState.variant === "overlay" && (0, $cPOSH.default)({
            borderRadius: theme.vars.radius.xs,
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: "var(--unstable_pseudo-zIndex)"
        }, ownerState.animation === "pulse" && {
            backgroundColor: theme.vars.palette.background.surface
        }, ownerState.level !== "inherit" && (0, $cPOSH.default)({}, theme.typography[ownerState.level]), {
            "&::before": {
                position: "absolute"
            }
        })
    ];
});
/**
 *
 * Demos:
 *
 * - [Skeleton](https://mui.com/joy-ui/react-skeleton/)
 *
 * API:
 *
 * - [Skeleton API](https://mui.com/joy-ui/api/skeleton/)
 */ const $9c99723ec254925f$var$Skeleton = /*#__PURE__*/ $1EuC8.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $171c82576b265f00$export$2e2bcd8739ae039)({
        props: inProps,
        name: "JoySkeleton"
    });
    const { className: className, component: component = "span", children: children, animation: animation = "pulse", overlay: overlay = false, loading: loading = true, variant: variant = "overlay", level: level = variant === "text" ? "body1" : "inherit", height: height, width: width, sx: sx, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $aT5bD.default)(props, $9c99723ec254925f$var$_excluded);
    const externalForwardedProps = (0, $cPOSH.default)({}, other, {
        component: component,
        slots: slots,
        slotProps: slotProps,
        sx: [
            {
                width: width,
                height: height
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    });
    const ownerState = (0, $cPOSH.default)({}, props, {
        animation: animation,
        component: component,
        level: level,
        loading: loading,
        overlay: overlay,
        variant: variant,
        width: width,
        height: height
    });
    const classes = $9c99723ec254925f$var$useUtilityClasses(ownerState);
    const [SlotRoot, rootProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("root", {
        ref: ref,
        className: (0, $f8208f51eaf9f9e6$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $9c99723ec254925f$var$SkeletonRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return loading ? /*#__PURE__*/ (0, $6iAGf.jsx)(SlotRoot, (0, $cPOSH.default)({}, rootProps, {
        children: children
    })) : /*#__PURE__*/ (0, $6iAGf.jsx)($1EuC8.Fragment, {
        children: $1EuC8.Children.map(children, (child, index)=>index === 0 && /*#__PURE__*/ $1EuC8.isValidElement(child) ? /*#__PURE__*/ $1EuC8.cloneElement(child, {
                "data-first-child": ""
            }) : child)
    });
});
// @ts-ignore internal usage only with Typography and Link
$9c99723ec254925f$var$Skeleton.muiName = "Skeleton";
var $9c99723ec254925f$export$2e2bcd8739ae039 = $9c99723ec254925f$var$Skeleton;




var $aT5bD = parcelRequire("aT5bD");

var $cPOSH = parcelRequire("cPOSH");

var $1EuC8 = parcelRequire("1EuC8");


var $cwrhp = parcelRequire("cwrhp");

var $3Upoa = parcelRequire("3Upoa");

var $cPOSH = parcelRequire("cPOSH");

var $aT5bD = parcelRequire("aT5bD");

var $1EuC8 = parcelRequire("1EuC8");


// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $eee73f87f54c98ed$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

function $843103b3a6b029c6$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $a0cff4e71ef393df$export$2e2bcd8739ae039(node) {
    const doc = (0, $843103b3a6b029c6$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $1EuC8 = parcelRequire("1EuC8");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $0addfc8188300cf7$var$useEnhancedEffect = typeof window !== "undefined" ? $1EuC8.useLayoutEffect : $1EuC8.useEffect;
var $0addfc8188300cf7$export$2e2bcd8739ae039 = $0addfc8188300cf7$var$useEnhancedEffect;



var $6iAGf = parcelRequire("6iAGf");
"use client";
const $2dc88ad9c36c741b$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $2dc88ad9c36c741b$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $2dc88ad9c36c741b$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $2dc88ad9c36c741b$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $2dc88ad9c36c741b$var$TextareaAutosize = /*#__PURE__*/ $1EuC8.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $aT5bD.default)(props, $2dc88ad9c36c741b$var$_excluded);
    const { current: isControlled } = $1EuC8.useRef(value != null);
    const inputRef = $1EuC8.useRef(null);
    const handleRef = (0, $ca3242a650a8aafe$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $1EuC8.useRef(null);
    const renders = $1EuC8.useRef(0);
    const [state, setState] = $1EuC8.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = $1EuC8.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $a0cff4e71ef393df$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $2dc88ad9c36c741b$var$getStyleValue(computedStyle.paddingBottom) + $2dc88ad9c36c741b$var$getStyleValue(computedStyle.paddingTop);
        const border = $2dc88ad9c36c741b$var$getStyleValue(computedStyle.borderBottomWidth) + $2dc88ad9c36c741b$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle, overflow: overflow } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $1EuC8.useCallback(()=>{
        const newState = getUpdatedState();
        if ($2dc88ad9c36c741b$var$isEmpty(newState)) return;
        setState((prevState)=>{
            return updateState(prevState, newState);
        });
    }, [
        getUpdatedState
    ]);
    const syncHeightWithFlushSync = ()=>{
        const newState = getUpdatedState();
        if ($2dc88ad9c36c741b$var$isEmpty(newState)) return;
        // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
        // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
        // Related issue - https://github.com/facebook/react/issues/24331
        $243da7855fb30689$exports.flushSync(()=>{
            setState((prevState)=>{
                return updateState(prevState, newState);
            });
        });
    };
    $1EuC8.useEffect(()=>{
        const handleResize = (0, $eee73f87f54c98ed$export$2e2bcd8739ae039)(()=>{
            renders.current = 0;
            // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/32640
            if (inputRef.current) syncHeightWithFlushSync();
        });
        let resizeObserver;
        const input = inputRef.current;
        const containerWindow = (0, $a0cff4e71ef393df$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", handleResize);
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    });
    (0, $0addfc8188300cf7$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    $1EuC8.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $6iAGf.jsxs)($1EuC8.Fragment, {
        children: [
            /*#__PURE__*/ (0, $6iAGf.jsx)("textarea", (0, $cPOSH.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $cPOSH.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $6iAGf.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $cPOSH.default)({}, $2dc88ad9c36c741b$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $2dc88ad9c36c741b$export$2e2bcd8739ae039 = $2dc88ad9c36c741b$var$TextareaAutosize;






function $e63588f60b9cc250$export$4c63b9df29112228(slot) {
    return (0, $bd48de20fb876697$export$1d132570e11858b0)("MuiTextarea", slot);
}
const $e63588f60b9cc250$var$textareaClasses = (0, $bd48de20fb876697$export$de4f15803c389669)("MuiTextarea", [
    "root",
    "textarea",
    "startDecorator",
    "endDecorator",
    "formControl",
    "disabled",
    "error",
    "focused",
    "colorPrimary",
    "colorNeutral",
    "colorDanger",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "colorContext",
    "sizeSm",
    "sizeMd",
    "sizeLg",
    "variantPlain",
    "variantOutlined",
    "variantSoft"
]);
var $e63588f60b9cc250$export$2e2bcd8739ae039 = $e63588f60b9cc250$var$textareaClasses;




var $6iAGf = parcelRequire("6iAGf");
"use client";
const $166bff791ea1ea3d$var$_excluded = [
    "propsToForward",
    "rootStateClasses",
    "inputStateClasses",
    "getRootProps",
    "getInputProps",
    "formControl",
    "focused",
    "error",
    "disabled",
    "size",
    "color",
    "variant",
    "startDecorator",
    "endDecorator",
    "minRows",
    "maxRows",
    "component",
    "slots",
    "slotProps"
];
const $166bff791ea1ea3d$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, variant: variant, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            variant && `variant${(0, $cwrhp.default)(variant)}`,
            color && `color${(0, $cwrhp.default)(color)}`,
            size && `size${(0, $cwrhp.default)(size)}`
        ],
        textarea: [
            "textarea"
        ],
        startDecorator: [
            "startDecorator"
        ],
        endDecorator: [
            "endDecorator"
        ]
    };
    return (0, $3Upoa.default)(slots, (0, $e63588f60b9cc250$export$4c63b9df29112228), {});
};
const $166bff791ea1ea3d$var$TextareaRoot = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("div", {
    name: "JoyTextarea",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$variants, _theme$vars$palette, _variantStyle$backgro, _theme$variants2, _theme$variants3;
    const variantStyle = (_theme$variants = theme.variants[`${ownerState.variant}`]) == null ? void 0 : _theme$variants[ownerState.color];
    return [
        (0, $cPOSH.default)({
            "--Textarea-radius": theme.vars.radius.sm,
            "--Textarea-gap": "0.5rem",
            "--Textarea-placeholderColor": "inherit",
            "--Textarea-placeholderOpacity": 0.5,
            "--Textarea-focused": "0",
            "--Textarea-focusedThickness": theme.vars.focus.thickness
        }, ownerState.color === "context" ? {
            "--Textarea-focusedHighlight": theme.vars.palette.focusVisible
        } : {
            "--Textarea-focusedHighlight": (_theme$vars$palette = theme.vars.palette[ownerState.color === "neutral" ? "primary" : ownerState.color]) == null ? void 0 : _theme$vars$palette[500]
        }, ownerState.size === "sm" && {
            "--Textarea-minHeight": "2rem",
            "--Textarea-paddingBlock": "calc(0.5rem - var(--variant-borderWidth, 0px))",
            // to match Input because <textarea> does not center the text at the middle like <input>
            "--Textarea-paddingInline": "0.5rem",
            "--Textarea-decoratorChildHeight": "min(1.5rem, var(--Textarea-minHeight))",
            "--Icon-fontSize": "1.25rem"
        }, ownerState.size === "md" && {
            "--Textarea-minHeight": "2.5rem",
            "--Textarea-paddingBlock": "calc(0.5rem - var(--variant-borderWidth, 0px))",
            "--Textarea-paddingInline": "0.75rem",
            "--Textarea-decoratorChildHeight": "min(2rem, var(--Textarea-minHeight))",
            "--Icon-fontSize": "1.5rem"
        }, ownerState.size === "lg" && {
            "--Textarea-minHeight": "3rem",
            "--Textarea-paddingBlock": "calc(0.75rem - var(--variant-borderWidth, 0px))",
            "--Textarea-paddingInline": "1rem",
            "--Textarea-gap": "0.75rem",
            "--Textarea-decoratorChildHeight": "min(2.375rem, var(--Textarea-minHeight))",
            "--Icon-fontSize": "1.75rem"
        }, {
            // variables for controlling child components
            "--_Textarea-paddingBlock": "max((var(--Textarea-minHeight) - 2 * var(--variant-borderWidth, 0px) - var(--Textarea-decoratorChildHeight)) / 2, 0px)",
            "--Textarea-decoratorChildRadius": "max(var(--Textarea-radius) - var(--variant-borderWidth, 0px) - var(--_Textarea-paddingBlock), min(var(--_Textarea-paddingBlock) + var(--variant-borderWidth, 0px), var(--Textarea-radius) / 2))",
            "--Button-minHeight": "var(--Textarea-decoratorChildHeight)",
            "--IconButton-size": "var(--Textarea-decoratorChildHeight)",
            "--Button-radius": "var(--Textarea-decoratorChildRadius)",
            "--IconButton-radius": "var(--Textarea-decoratorChildRadius)",
            boxSizing: "border-box",
            minWidth: 0,
            minHeight: "var(--Textarea-minHeight)",
            cursor: "text",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            paddingInlineStart: `var(--Textarea-paddingInline)`,
            // the paddingInlineEnd is added to the textarea. It looks better when the scrollbar appears.
            paddingBlock: "var(--Textarea-paddingBlock)",
            borderRadius: "var(--Textarea-radius)",
            fontFamily: theme.vars.fontFamily.body,
            fontSize: theme.vars.fontSize.md,
            lineHeight: theme.vars.lineHeight.md
        }, ownerState.size === "sm" && {
            fontSize: theme.vars.fontSize.sm,
            lineHeight: theme.vars.lineHeight.sm
        }, {
            "&:before": {
                boxSizing: "border-box",
                content: '""',
                display: "block",
                position: "absolute",
                pointerEvents: "none",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                borderRadius: "inherit",
                margin: "calc(var(--variant-borderWidth, 0px) * -1)",
                // for outlined variant
                boxShadow: `var(--Textarea-focusedInset, inset) 0 0 0 calc(var(--Textarea-focused) * var(--Textarea-focusedThickness)) var(--Textarea-focusedHighlight)`
            }
        }),
        (0, $cPOSH.default)({}, variantStyle, {
            backgroundColor: (_variantStyle$backgro = variantStyle == null ? void 0 : variantStyle.backgroundColor) != null ? _variantStyle$backgro : theme.vars.palette.background.surface,
            "&:hover": (0, $cPOSH.default)({}, (_theme$variants2 = theme.variants[`${ownerState.variant}Hover`]) == null ? void 0 : _theme$variants2[ownerState.color], {
                backgroundColor: null,
                // it is not common to change background on hover for Textarea
                cursor: "text"
            }),
            [`&.${(0, $e63588f60b9cc250$export$2e2bcd8739ae039).disabled}`]: (_theme$variants3 = theme.variants[`${ownerState.variant}Disabled`]) == null ? void 0 : _theme$variants3[ownerState.color],
            "&:focus-within::before": {
                "--Textarea-focused": "1"
            }
        })
    ];
});
const $166bff791ea1ea3d$var$TextareaInput = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)((0, $2dc88ad9c36c741b$export$2e2bcd8739ae039), {
    name: "JoyTextarea",
    slot: "Textarea",
    overridesResolver: (props, styles)=>styles.textarea
})({
    resize: "none",
    border: "none",
    // remove the native textarea width
    minWidth: 0,
    // remove the native textarea width
    outline: 0,
    // remove the native textarea outline
    padding: 0,
    // remove the native textarea padding
    paddingInlineEnd: `var(--Textarea-paddingInline)`,
    flex: "auto",
    alignSelf: "stretch",
    color: "inherit",
    backgroundColor: "transparent",
    fontFamily: "inherit",
    fontSize: "inherit",
    fontStyle: "inherit",
    fontWeight: "inherit",
    lineHeight: "inherit",
    "&::-webkit-input-placeholder": {
        color: "var(--Textarea-placeholderColor)",
        opacity: "var(--Textarea-placeholderOpacity)"
    },
    "&::-moz-placeholder": {
        // Firefox 19+
        color: "var(--Textarea-placeholderColor)",
        opacity: "var(--Textarea-placeholderOpacity)"
    },
    "&:-ms-input-placeholder": {
        // IE11
        color: "var(--Textarea-placeholderColor)",
        opacity: "var(--Textarea-placeholderOpacity)"
    },
    "&::-ms-input-placeholder": {
        // Edge
        color: "var(--Textarea-placeholderColor)",
        opacity: "var(--Textarea-placeholderOpacity)"
    }
});
const $166bff791ea1ea3d$var$TextareaStartDecorator = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("div", {
    name: "JoyTextarea",
    slot: "StartDecorator",
    overridesResolver: (props, styles)=>styles.startDecorator
})(({ theme: theme })=>({
        display: "flex",
        marginInlineStart: "calc(var(--Textarea-paddingBlock) - var(--Textarea-paddingInline))",
        marginInlineEnd: "var(--Textarea-paddingBlock)",
        marginBlockEnd: "var(--Textarea-gap)",
        color: theme.vars.palette.text.tertiary,
        cursor: "initial"
    }));
const $166bff791ea1ea3d$var$TextareaEndDecorator = (0, $6659d5459ae858ea$export$2e2bcd8739ae039)("div", {
    name: "JoyTextarea",
    slot: "EndDecorator",
    overridesResolver: (props, styles)=>styles.endDecorator
})(({ theme: theme })=>({
        display: "flex",
        marginInlineStart: "calc(var(--Textarea-paddingBlock) - var(--Textarea-paddingInline))",
        marginInlineEnd: "var(--Textarea-paddingBlock)",
        marginBlockStart: "var(--Textarea-gap)",
        color: theme.vars.palette.text.tertiary,
        cursor: "initial"
    }));
/**
 *
 * Demos:
 *
 * - [Textarea](https://mui.com/joy-ui/react-textarea/)
 *
 * API:
 *
 * - [Textarea API](https://mui.com/joy-ui/api/textarea/)
 */ const $166bff791ea1ea3d$var$Textarea = /*#__PURE__*/ $1EuC8.forwardRef(function Textarea(inProps, ref) {
    var _ref, _inProps$disabled, _ref2, _inProps$error, _ref3, _inProps$size, _formControl$color;
    const props = (0, $171c82576b265f00$export$2e2bcd8739ae039)({
        props: inProps,
        name: "JoyTextarea"
    });
    const _useForwardedInput = (0, $3182e84f5a1ecea4$export$2e2bcd8739ae039)(props, (0, $e63588f60b9cc250$export$2e2bcd8739ae039)), { propsToForward: propsToForward, rootStateClasses: rootStateClasses, inputStateClasses: inputStateClasses, getRootProps: getRootProps, getInputProps: getInputProps, formControl: formControl, focused: focused, error: errorProp = false, disabled: disabledProp = false, size: sizeProp = "md", color: colorProp = "neutral", variant: variant = "outlined", startDecorator: startDecorator, endDecorator: endDecorator, minRows: minRows, maxRows: maxRows, component: component, slots: slots = {}, slotProps: slotProps = {} } = _useForwardedInput, other = (0, $aT5bD.default)(_useForwardedInput, $166bff791ea1ea3d$var$_excluded);
    const disabled = (_ref = (_inProps$disabled = inProps.disabled) != null ? _inProps$disabled : formControl == null ? void 0 : formControl.disabled) != null ? _ref : disabledProp;
    const error = (_ref2 = (_inProps$error = inProps.error) != null ? _inProps$error : formControl == null ? void 0 : formControl.error) != null ? _ref2 : errorProp;
    const size = (_ref3 = (_inProps$size = inProps.size) != null ? _inProps$size : formControl == null ? void 0 : formControl.size) != null ? _ref3 : sizeProp;
    const { getColor: getColor } = (0, $45219fd0b0701701$export$83a9a651654e258f)(variant);
    const color = getColor(inProps.color, error ? "danger" : (_formControl$color = formControl == null ? void 0 : formControl.color) != null ? _formControl$color : colorProp);
    const ownerState = (0, $cPOSH.default)({}, props, {
        color: color,
        disabled: disabled,
        error: error,
        focused: focused,
        size: size,
        variant: variant
    });
    const classes = $166bff791ea1ea3d$var$useUtilityClasses(ownerState);
    const externalForwardedProps = (0, $cPOSH.default)({}, other, {
        component: component,
        slots: slots,
        slotProps: slotProps
    });
    const [SlotRoot, rootProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("root", {
        ref: ref,
        className: [
            classes.root,
            rootStateClasses
        ],
        elementType: $166bff791ea1ea3d$var$TextareaRoot,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: getRootProps,
        ownerState: ownerState
    });
    const [SlotTextarea, textareaProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("textarea", {
        additionalProps: {
            id: formControl == null ? void 0 : formControl.htmlFor,
            "aria-describedby": formControl == null ? void 0 : formControl["aria-describedby"]
        },
        className: [
            classes.textarea,
            inputStateClasses
        ],
        elementType: $166bff791ea1ea3d$var$TextareaInput,
        internalForwardedProps: (0, $cPOSH.default)({}, propsToForward, {
            minRows: minRows,
            maxRows: maxRows
        }),
        externalForwardedProps: externalForwardedProps,
        getSlotProps: getInputProps,
        ownerState: ownerState
    });
    const [SlotStartDecorator, startDecoratorProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("startDecorator", {
        className: classes.startDecorator,
        elementType: $166bff791ea1ea3d$var$TextareaStartDecorator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SlotEndDecorator, endDecoratorProps] = (0, $dc17f7d5f2f13533$export$2e2bcd8739ae039)("endDecorator", {
        className: classes.endDecorator,
        elementType: $166bff791ea1ea3d$var$TextareaEndDecorator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $6iAGf.jsxs)(SlotRoot, (0, $cPOSH.default)({}, rootProps, {
        children: [
            startDecorator && /*#__PURE__*/ (0, $6iAGf.jsx)(SlotStartDecorator, (0, $cPOSH.default)({}, startDecoratorProps, {
                children: startDecorator
            })),
            /*#__PURE__*/ (0, $6iAGf.jsx)(SlotTextarea, (0, $cPOSH.default)({}, textareaProps)),
            endDecorator && /*#__PURE__*/ (0, $6iAGf.jsx)(SlotEndDecorator, (0, $cPOSH.default)({}, endDecoratorProps, {
                children: endDecorator
            }))
        ]
    }));
});
var $166bff791ea1ea3d$export$2e2bcd8739ae039 = $166bff791ea1ea3d$var$Textarea;






var $1EuC8 = parcelRequire("1EuC8");

var $e07878b5de1c0516$exports = {};

$e07878b5de1c0516$exports = (parcelRequire("co4Jd"));


/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ 
var $1EuC8 = parcelRequire("1EuC8");
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {Record<string, unknown> & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {'ascii' | 'utf8' | 'utf-8' | 'utf16le' | 'ucs2' | 'ucs-2' | 'base64' | 'base64url' | 'latin1' | 'binary' | 'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *
 *   This is a copy of the types from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Options | URL | Value | VFile} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {Value | null | undefined} [value]
 *   Set `value`.
 * @property {string | null | undefined} [cwd]
 *   Set `cwd`.
 * @property {Array<string> | null | undefined} [history]
 *   Set `history`.
 * @property {URL | string | null | undefined} [path]
 *   Set `path`.
 * @property {string | null | undefined} [basename]
 *   Set `basename`.
 * @property {string | null | undefined} [stem]
 *   Set `stem`.
 * @property {string | null | undefined} [extname]
 *   Set `extname`.
 * @property {string | null | undefined} [dirname]
 *   Set `dirname`.
 * @property {Data | null | undefined} [data]
 *   Set `data`.
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template {ReporterSettings} Settings
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ var $be778845eba7d433$exports = {};
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ $be778845eba7d433$exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Position | PositionLike | Point | PointLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $a2a7c01371f2271b$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ("position" in value || "type" in value) return $a2a7c01371f2271b$var$position(value.position);
    // Position.
    if ("start" in value || "end" in value) return $a2a7c01371f2271b$var$position(value);
    // Point.
    if ("line" in value || "column" in value) return $a2a7c01371f2271b$var$point(value);
    // ?
    return "";
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $a2a7c01371f2271b$var$point(point) {
    return $a2a7c01371f2271b$var$index(point && point.line) + ":" + $a2a7c01371f2271b$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $a2a7c01371f2271b$var$position(pos) {
    return $a2a7c01371f2271b$var$point(pos && pos.start) + "-" + $a2a7c01371f2271b$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $a2a7c01371f2271b$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}


class $dededebcad330b8c$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // To do: next major: expose `undefined` everywhere instead of `null`.
    constructor(reason, place, origin){
        /** @type {[string | null, string | null]} */ const parts = [
            null,
            null
        ];
        /** @type {Position} */ let position = {
            // @ts-expect-error: we always follows the structure of `position`.
            start: {
                line: null,
                column: null
            },
            // @ts-expect-error: "
            end: {
                line: null,
                column: null
            }
        };
        super();
        if (typeof place === "string") {
            origin = place;
            place = undefined;
        }
        if (typeof origin === "string") {
            const index = origin.indexOf(":");
            if (index === -1) parts[1] = origin;
            else {
                parts[0] = origin.slice(0, index);
                parts[1] = origin.slice(index + 1);
            }
        }
        if (place) {
            // Node.
            if ("type" in place || "position" in place) {
                if (place.position) // To do: next major: deep clone.
                // @ts-expect-error: looks like a position.
                position = place.position;
            } else if ("start" in place || "end" in place) // @ts-expect-error: looks like a position.
            // To do: next major: deep clone.
            position = place;
            else if ("line" in place || "column" in place) // To do: next major: deep clone.
            position.start = place;
        }
        // Fields from `Error`.
        /**
     * Serialized positional info of error.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $a2a7c01371f2271b$export$c304dd45fe166145)(place) || "1:1";
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = typeof reason === "object" ? reason.message : reason;
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = "";
        if (typeof reason === "object" && reason.stack) this.stack = reason.stack;
        /**
     * Reason for message.
     *
     * > 👉 **Note**: you should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /* eslint-disable no-unused-expressions */ /**
     * State of problem.
     *
     * * `true` — marks associated file as no longer processable (error)
     * * `false` — necessitates a (potential) change (warning)
     * * `null | undefined` — for things that might not need changing (info)
     *
     * @type {boolean | null | undefined}
     */ this.fatal;
        /**
     * Starting line of error.
     *
     * @type {number | null}
     */ this.line = position.start.line;
        /**
     * Starting column of error.
     *
     * @type {number | null}
     */ this.column = position.start.column;
        /**
     * Full unist position.
     *
     * @type {Position | null}
     */ this.position = position;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | null}
     */ this.source = parts[0];
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | null}
     */ this.ruleId = parts[1];
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | null}
     */ this.file;
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | null}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | null}
     */ this.expected;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | null}
     */ this.url;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | null}
     */ this.note;
    /* eslint-enable no-unused-expressions */ }
}
$dededebcad330b8c$export$752e5c445fe834ef.prototype.file = "";
$dededebcad330b8c$export$752e5c445fe834ef.prototype.name = "";
$dededebcad330b8c$export$752e5c445fe834ef.prototype.reason = "";
$dededebcad330b8c$export$752e5c445fe834ef.prototype.message = "";
$dededebcad330b8c$export$752e5c445fe834ef.prototype.stack = "";
$dededebcad330b8c$export$752e5c445fe834ef.prototype.fatal = null;
$dededebcad330b8c$export$752e5c445fe834ef.prototype.column = null;
$dededebcad330b8c$export$752e5c445fe834ef.prototype.line = null;
$dededebcad330b8c$export$752e5c445fe834ef.prototype.source = null;
$dededebcad330b8c$export$752e5c445fe834ef.prototype.ruleId = null;
$dededebcad330b8c$export$752e5c445fe834ef.prototype.position = null;


// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $68b7bcf0e1cb835f$export$bb654e07daaf8c3a = {
    basename: $68b7bcf0e1cb835f$var$basename,
    dirname: $68b7bcf0e1cb835f$var$dirname,
    extname: $68b7bcf0e1cb835f$var$extname,
    join: $68b7bcf0e1cb835f$var$join,
    sep: "/"
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $68b7bcf0e1cb835f$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $68b7bcf0e1cb835f$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $68b7bcf0e1cb835f$var$dirname(path) {
    $68b7bcf0e1cb835f$var$assertPath(path);
    if (path.length === 0) return ".";
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $68b7bcf0e1cb835f$var$extname(path) {
    $68b7bcf0e1cb835f$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $68b7bcf0e1cb835f$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $68b7bcf0e1cb835f$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + "/" + segments[index];
    }
    return joined === undefined ? "." : $68b7bcf0e1cb835f$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $68b7bcf0e1cb835f$var$normalize(path) {
    $68b7bcf0e1cb835f$var$assertPath(path);
    const absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $68b7bcf0e1cb835f$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = ".";
    if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $68b7bcf0e1cb835f$var$normalizeString(path, allowAboveRoot) {
    let result = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $68b7bcf0e1cb835f$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $09a28c30ee0c76c5$export$97a5aaf482767187 = {
    cwd: $09a28c30ee0c76c5$var$cwd
};
function $09a28c30ee0c76c5$var$cwd() {
    return "/";
}


/// <reference lib="dom" />
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */ /**
 * Check if `fileUrlOrPath` looks like a URL.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function $bf94882f7feee435$export$8304a22d431f958(fileUrlOrPath) {
    return fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && // @ts-expect-error: indexable.
    fileUrlOrPath.href && // @ts-expect-error: indexable.
    fileUrlOrPath.origin;
}


function $2667ae8a00c5d30b$export$9b2b676c902de799(path) {
    if (typeof path === "string") path = new URL(path);
    else if (!(0, $bf94882f7feee435$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + "`");
        error.code = "ERR_INVALID_ARG_TYPE";
        throw error;
    }
    if (path.protocol !== "file:") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError("The URL must be of scheme file");
        error.code = "ERR_INVALID_URL_SCHEME";
        throw error;
    }
    return $2667ae8a00c5d30b$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $2667ae8a00c5d30b$var$getPathFromURLPosix(url) {
    if (url.hostname !== "") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = "ERR_INVALID_FILE_URL_HOST";
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.charCodeAt(index) === 37 /* `%` */  && pathname.charCodeAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.charCodeAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError("File URL path must not include encoded / characters");
            error.code = "ERR_INVALID_FILE_URL_PATH";
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 *
 * @type {Array<'basename' | 'dirname' | 'extname' | 'history' | 'path' | 'stem'>}
 */ const $f49d062054ceb833$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
class $f49d062054ceb833$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if (typeof value === "string" || $f49d062054ceb833$var$buffer(value)) options = {
            value: value
        };
        else if ((0, $bf94882f7feee435$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else options = value;
        /**
     * Place to store custom information (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * List of filepaths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $09a28c30ee0c76c5$export$97a5aaf482767187).cwd();
        /* eslint-disable no-unused-expressions */ /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $f49d062054ceb833$var$order.length){
            const prop = $f49d062054ceb833$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === "history" ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$f49d062054ceb833$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */ set path(path) {
        if ((0, $bf94882f7feee435$export$8304a22d431f958)(path)) path = (0, $2667ae8a00c5d30b$export$9b2b676c902de799)(path);
        $f49d062054ceb833$var$assertNonEmpty(path, "path");
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the parent path (example: `'~'`).
   */ get dirname() {
        return typeof this.path === "string" ? (0, $68b7bcf0e1cb835f$export$bb654e07daaf8c3a).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */ set dirname(dirname) {
        $f49d062054ceb833$var$assertPath(this.basename, "dirname");
        this.path = (0, $68b7bcf0e1cb835f$export$bb654e07daaf8c3a).join(dirname || "", this.basename);
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */ get basename() {
        return typeof this.path === "string" ? (0, $68b7bcf0e1cb835f$export$bb654e07daaf8c3a).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set basename(basename) {
        $f49d062054ceb833$var$assertNonEmpty(basename, "basename");
        $f49d062054ceb833$var$assertPart(basename, "basename");
        this.path = (0, $68b7bcf0e1cb835f$export$bb654e07daaf8c3a).join(this.dirname || "", basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   */ get extname() {
        return typeof this.path === "string" ? (0, $68b7bcf0e1cb835f$export$bb654e07daaf8c3a).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */ set extname(extname) {
        $f49d062054ceb833$var$assertPart(extname, "extname");
        $f49d062054ceb833$var$assertPath(this.dirname, "extname");
        if (extname) {
            if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
            if (extname.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = (0, $68b7bcf0e1cb835f$export$bb654e07daaf8c3a).join(this.dirname, this.stem + (extname || ""));
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */ get stem() {
        return typeof this.path === "string" ? (0, $68b7bcf0e1cb835f$export$bb654e07daaf8c3a).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set stem(stem) {
        $f49d062054ceb833$var$assertNonEmpty(stem, "stem");
        $f49d062054ceb833$var$assertPart(stem, "stem");
        this.path = (0, $68b7bcf0e1cb835f$export$bb654e07daaf8c3a).join(this.dirname || "", stem + (this.extname || ""));
    }
    /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        return (this.value || "").toString(encoding || undefined);
    }
    /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(reason, place, origin) {
        const message = new (0, $dededebcad330b8c$export$752e5c445fe834ef)(reason, place, origin);
        if (this.path) {
            message.name = this.path + ":" + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = null;
        return message;
    }
    /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */ fail(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = true;
        throw message;
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {void}
 *   Nothing.
 */ function $f49d062054ceb833$var$assertPart(part, name) {
    if (part && part.includes((0, $68b7bcf0e1cb835f$export$bb654e07daaf8c3a).sep)) throw new Error("`" + name + "` cannot be a path: did not expect `" + (0, $68b7bcf0e1cb835f$export$bb654e07daaf8c3a).sep + "`");
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $f49d062054ceb833$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $f49d062054ceb833$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}
/**
 * Assert `value` is a buffer.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Buffer}
 *   Whether `value` is a Node.js buffer.
 */ function $f49d062054ceb833$var$buffer(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($be778845eba7d433$exports)))(value);
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $c6f9dfec8a21d669$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}



var $a87d9be41f51f593$exports = {};
"use strict";
var $a87d9be41f51f593$var$hasOwn = Object.prototype.hasOwnProperty;
var $a87d9be41f51f593$var$toStr = Object.prototype.toString;
var $a87d9be41f51f593$var$defineProperty = Object.defineProperty;
var $a87d9be41f51f593$var$gOPD = Object.getOwnPropertyDescriptor;
var $a87d9be41f51f593$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $a87d9be41f51f593$var$toStr.call(arr) === "[object Array]";
};
var $a87d9be41f51f593$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $a87d9be41f51f593$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $a87d9be41f51f593$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $a87d9be41f51f593$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $a87d9be41f51f593$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $a87d9be41f51f593$var$setProperty = function setProperty(target, options) {
    if ($a87d9be41f51f593$var$defineProperty && options.name === "__proto__") $a87d9be41f51f593$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $a87d9be41f51f593$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$a87d9be41f51f593$var$hasOwn.call(obj, name)) return void 0;
        else if ($a87d9be41f51f593$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $a87d9be41f51f593$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$a87d9be41f51f593$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $a87d9be41f51f593$var$getProperty(target, name);
            copy = $a87d9be41f51f593$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($a87d9be41f51f593$var$isPlainObject(copy) || (copyIsArray = $a87d9be41f51f593$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $a87d9be41f51f593$var$isArray(src) ? src : [];
                    } else clone = src && $a87d9be41f51f593$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $a87d9be41f51f593$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $a87d9be41f51f593$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


function $cc63b80fb73d80cc$export$2e2bcd8739ae039(value) {
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $b029869fff08a067$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== "function") throw new TypeError("Expected function as last argument, not " + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $b029869fff08a067$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== "function") throw new TypeError("Expected `middelware` to be a function, not " + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $b029869fff08a067$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === "function") result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}



const $2d1177fd06828c6f$export$7cc1b2fe10c52bb = $2d1177fd06828c6f$var$base().freeze();
const $2d1177fd06828c6f$var$own = {}.hasOwnProperty;
// Function to create the first processor.
/**
 * @returns {Processor}
 */ function $2d1177fd06828c6f$var$base() {
    const transformers = (0, $b029869fff08a067$export$91b56f5ca106aa43)();
    /** @type {Processor['attachers']} */ const attachers = [];
    /** @type {Record<string, unknown>} */ let namespace = {};
    /** @type {boolean|undefined} */ let frozen;
    let freezeIndex = -1;
    // Data management.
    // @ts-expect-error: overloads are handled.
    processor.data = data;
    processor.Parser = undefined;
    processor.Compiler = undefined;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    // @ts-expect-error: overloads are handled.
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    // @ts-expect-error: overloads are handled.
    processor.run = run;
    processor.runSync = runSync;
    // @ts-expect-error: overloads are handled.
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    /** @type {Processor} */ function processor() {
        const destination = $2d1177fd06828c6f$var$base();
        let index = -1;
        while(++index < attachers.length)destination.use(...attachers[index]);
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($a87d9be41f51f593$exports)))(true, {}, namespace));
        return destination;
    }
    /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */ function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $2d1177fd06828c6f$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $2d1177fd06828c6f$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $2d1177fd06828c6f$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    /** @type {Processor['freeze']} */ function freeze() {
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            const [attacher, ...options] = attachers[freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            /** @type {Transformer|void} */ const transformer = attacher.call(processor, ...options);
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Number.POSITIVE_INFINITY;
        return processor;
    }
    /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */ function use(value, ...options) {
        /** @type {Record<string, unknown>|undefined} */ let settings;
        $2d1177fd06828c6f$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin(value, ...options);
        else if (typeof value === "object") {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = Object.assign(namespace.settings || {}, settings);
        return processor;
        /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */ function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if (Array.isArray(value)) {
                    const [plugin, ...options] = value;
                    addPlugin(plugin, ...options);
                } else addPreset(value);
            } else throw new TypeError("Expected usable value, not `" + value + "`");
        }
        /**
     * @param {Preset} result
     * @returns {void}
     */ function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = Object.assign(settings || {}, result.settings);
        }
        /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
        }
        /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */ function addPlugin(plugin, value) {
            let index = -1;
            /** @type {Processor['attachers'][number]|undefined} */ let entry;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entry = attachers[index];
                break;
            }
            if (entry) {
                if ((0, $cc63b80fb73d80cc$export$2e2bcd8739ae039)(entry[1]) && (0, $cc63b80fb73d80cc$export$2e2bcd8739ae039)(value)) value = (0, (/*@__PURE__*/$parcel$interopDefault($a87d9be41f51f593$exports)))(true, entry[1], value);
                entry[1] = value;
            } else // @ts-expect-error: fine.
            attachers.push([
                ...arguments
            ]);
        }
    }
    /** @type {Processor['parse']} */ function parse(doc) {
        processor.freeze();
        const file = $2d1177fd06828c6f$var$vfile(doc);
        const Parser = processor.Parser;
        $2d1177fd06828c6f$var$assertParser("parse", Parser);
        if ($2d1177fd06828c6f$var$newable(Parser, "parse")) // @ts-expect-error: `newable` checks this.
        return new Parser(String(file), file).parse();
        // @ts-expect-error: `newable` checks this.
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    /** @type {Processor['stringify']} */ function stringify(node, doc) {
        processor.freeze();
        const file = $2d1177fd06828c6f$var$vfile(doc);
        const Compiler = processor.Compiler;
        $2d1177fd06828c6f$var$assertCompiler("stringify", Compiler);
        $2d1177fd06828c6f$var$assertNode(node);
        if ($2d1177fd06828c6f$var$newable(Compiler, "compile")) // @ts-expect-error: `newable` checks this.
        return new Compiler(node, file).compile();
        // @ts-expect-error: `newable` checks this.
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */ function run(node, doc, callback) {
        $2d1177fd06828c6f$var$assertNode(node);
        processor.freeze();
        if (!callback && typeof doc === "function") {
            callback = doc;
            doc = undefined;
        }
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
            transformers.run(node, $2d1177fd06828c6f$var$vfile(doc), done);
            /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */ function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, tree, file);
            }
        }
    }
    /** @type {Processor['runSync']} */ function runSync(node, file) {
        /** @type {Node|undefined} */ let result;
        /** @type {boolean|undefined} */ let complete;
        processor.run(node, file, done);
        $2d1177fd06828c6f$var$assertDone("runSync", "run", complete);
        // @ts-expect-error: we either bailed on an error or have a tree.
        return result;
        /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */ function done(error, tree) {
            (0, $c6f9dfec8a21d669$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */ function process(doc, callback) {
        processor.freeze();
        $2d1177fd06828c6f$var$assertParser("process", processor.Parser);
        $2d1177fd06828c6f$var$assertCompiler("process", processor.Compiler);
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            const file = $2d1177fd06828c6f$var$vfile(doc);
            processor.run(processor.parse(file), file, (error, tree, file)=>{
                if (error || !tree || !file) done(error);
                else {
                    /** @type {unknown} */ const result = processor.stringify(tree, file);
                    if (result === undefined || result === null) ;
                    else if ($2d1177fd06828c6f$var$looksLikeAVFileValue(result)) file.value = result;
                    else file.result = result;
                    done(error, file);
                }
            });
            /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */ function done(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, file);
            }
        }
    }
    /** @type {Processor['processSync']} */ function processSync(doc) {
        /** @type {boolean|undefined} */ let complete;
        processor.freeze();
        $2d1177fd06828c6f$var$assertParser("processSync", processor.Parser);
        $2d1177fd06828c6f$var$assertCompiler("processSync", processor.Compiler);
        const file = $2d1177fd06828c6f$var$vfile(doc);
        processor.process(file, done);
        $2d1177fd06828c6f$var$assertDone("processSync", "process", complete);
        return file;
        /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */ function done(error) {
            complete = true;
            (0, $c6f9dfec8a21d669$export$dd911e13ecb11e05)(error);
        }
    }
}
/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */ function $2d1177fd06828c6f$var$newable(value, name) {
    return typeof value === "function" && // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    ($2d1177fd06828c6f$var$keys(value.prototype) || name in value.prototype);
}
/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */ function $2d1177fd06828c6f$var$keys(value) {
    /** @type {string} */ let key;
    for(key in value){
        if ($2d1177fd06828c6f$var$own.call(value, key)) return true;
    }
    return false;
}
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $2d1177fd06828c6f$var$assertParser(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Parser`");
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $2d1177fd06828c6f$var$assertCompiler(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Compiler`");
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $2d1177fd06828c6f$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot call `" + name + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $2d1177fd06828c6f$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $cc63b80fb73d80cc$export$2e2bcd8739ae039)(node) || typeof node.type !== "string") throw new TypeError("Expected node, got `" + node + "`");
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $2d1177fd06828c6f$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}
/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */ function $2d1177fd06828c6f$var$vfile(value) {
    return $2d1177fd06828c6f$var$looksLikeAVFile(value) ? value : new (0, $f49d062054ceb833$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */ function $2d1177fd06828c6f$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === "object" && "message" in value && "messages" in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */ function $2d1177fd06828c6f$var$looksLikeAVFileValue(value) {
    return typeof value === "string" || (0, (/*@__PURE__*/$parcel$interopDefault($be778845eba7d433$exports)))(value);
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */ /**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').StaticPhrasingContent} StaticPhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Root | Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 *
 * @typedef {Omit<UnistParent, 'type' | 'children'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | undefined | null | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Node | Fragment>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {<Key extends keyof CompileData>(key: Key) => CompileData[Key]} getData
 *   Get data from the key/value store.
 * @property {<Key extends keyof CompileData>(key: Key, value?: CompileData[Key]) => void} setData
 *   Set data into the key/value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<Kind extends Node>(this: CompileContext, node: Kind, token: Token, onError?: OnEnterError) => Kind} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ // To do: micromark: create a registry of tokens?
// To do: next major: don’t return given `Node` from `enter`.
// To do: next major: remove setter/getter.
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s.
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML.
 */ /** @type {Options} */ const $b9ece42a41fc01d8$var$emptyOptions = {};
function $b9ece42a41fc01d8$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $b9ece42a41fc01d8$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
    return $b9ece42a41fc01d8$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $b9ece42a41fc01d8$var$one(value, includeImageAlt, includeHtml) {
    if ($b9ece42a41fc01d8$var$node(value)) {
        if ("value" in value) return value.type === "html" && !includeHtml ? "" : value.value;
        if (includeImageAlt && "alt" in value && value.alt) return value.alt;
        if ("children" in value) return $b9ece42a41fc01d8$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $b9ece42a41fc01d8$var$all(value, includeImageAlt, includeHtml);
    return "";
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $b9ece42a41fc01d8$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $b9ece42a41fc01d8$var$one(values[index], includeImageAlt, includeHtml);
    return result.join("");
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Node}
 *   Whether `value` is a node.
 */ function $b9ece42a41fc01d8$var$node(value) {
    return Boolean(value && typeof value === "object");
}


/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ /**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ /**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {void}
 *   Nothing.
 */ function $d243901ff94656bd$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $d243901ff94656bd$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $d243901ff94656bd$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


const $845c4ed1478b7476$var$hasOwnProperty = {}.hasOwnProperty;
function $845c4ed1478b7476$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$845c4ed1478b7476$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $845c4ed1478b7476$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $845c4ed1478b7476$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$845c4ed1478b7476$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $845c4ed1478b7476$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {void}
 */ function $845c4ed1478b7476$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    (0, $d243901ff94656bd$export$869882364835d202)(existing, 0, 0, before);
}
function $845c4ed1478b7476$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$845c4ed1478b7476$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $845c4ed1478b7476$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $845c4ed1478b7476$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 */ // This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
/**
 * Regular expression that matches a unicode punctuation character.
 */ const $5827717a218fe5e6$export$85b5101f24802e8c = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;


const $bcbf19ba9aa2a126$export$d65d6b62c24d5436 = $bcbf19ba9aa2a126$var$regexCheck(/[A-Za-z]/);
const $bcbf19ba9aa2a126$export$75c76db11865a9f4 = $bcbf19ba9aa2a126$var$regexCheck(/[\dA-Za-z]/);
const $bcbf19ba9aa2a126$export$4397998b34fe597d = $bcbf19ba9aa2a126$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $bcbf19ba9aa2a126$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $bcbf19ba9aa2a126$export$ca8b5b1a6c320e6e = $bcbf19ba9aa2a126$var$regexCheck(/\d/);
const $bcbf19ba9aa2a126$export$eca2752363989806 = $bcbf19ba9aa2a126$var$regexCheck(/[\dA-Fa-f]/);
const $bcbf19ba9aa2a126$export$35794a7d1db99380 = $bcbf19ba9aa2a126$var$regexCheck(/[!-/:-@[-`{-~]/);
function $bcbf19ba9aa2a126$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $bcbf19ba9aa2a126$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $bcbf19ba9aa2a126$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $bcbf19ba9aa2a126$export$aa04114dd888a7a0 = $bcbf19ba9aa2a126$var$regexCheck((0, $5827717a218fe5e6$export$85b5101f24802e8c));
const $bcbf19ba9aa2a126$export$a0ff789c034ffdf4 = $bcbf19ba9aa2a126$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $bcbf19ba9aa2a126$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && regex.test(String.fromCharCode(code));
    }
}


function $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $25303a4c0844eb43$export$a7db06668cad9adb = {
    tokenize: $25303a4c0844eb43$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $25303a4c0844eb43$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 


const $b426159d995f9b34$export$5a7bfc01df82fcd1 = {
    tokenize: $b426159d995f9b34$var$initializeDocument
};
/** @type {Construct} */ const $b426159d995f9b34$var$containerConstruct = {
    tokenize: $b426159d995f9b34$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $b426159d995f9b34$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $d243901ff94656bd$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($b426159d995f9b34$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($b426159d995f9b34$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {void}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $d243901ff94656bd$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {void}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b426159d995f9b34$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $8219420e5fbadbac$export$d50d28ce3ab2a612 = {
    tokenize: $8219420e5fbadbac$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8219420e5fbadbac$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code) ? (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
function $934548b5e713202a$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                Object.assign(jumps, $934548b5e713202a$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $d243901ff94656bd$export$869882364835d202)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $934548b5e713202a$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $d243901ff94656bd$export$869882364835d202)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $3f9bdf5afcc5cddd$export$a7db06668cad9adb = {
    tokenize: $3f9bdf5afcc5cddd$var$tokenizeContent,
    resolve: $3f9bdf5afcc5cddd$var$resolveContent
};
/** @type {Construct} */ const $3f9bdf5afcc5cddd$var$continuationConstruct = {
    tokenize: $3f9bdf5afcc5cddd$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $3f9bdf5afcc5cddd$var$resolveContent(events) {
    (0, $934548b5e713202a$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $3f9bdf5afcc5cddd$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) return effects.check($3f9bdf5afcc5cddd$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $3f9bdf5afcc5cddd$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $ed4255c315853078$export$ccc7b0636abaffc3 = {
    tokenize: $ed4255c315853078$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $ed4255c315853078$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $8219420e5fbadbac$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $3f9bdf5afcc5cddd$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $db742e43420ffd8f$export$50397835cbfdbc24 = {
    resolveAll: $db742e43420ffd8f$var$createResolver()
};
const $db742e43420ffd8f$export$22b082955e083ec3 = $db742e43420ffd8f$var$initializeFactory("string");
const $db742e43420ffd8f$export$6f093cfa640b7166 = $db742e43420ffd8f$var$initializeFactory("text");
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $db742e43420ffd8f$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $db742e43420ffd8f$var$createResolver(field === "text" ? $db742e43420ffd8f$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $db742e43420ffd8f$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $db742e43420ffd8f$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {void}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $34133fc7a9cfcf1e$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $7e89c312a872674d$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | void}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $d243901ff94656bd$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $34133fc7a9cfcf1e$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $7e89c312a872674d$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $7e89c312a872674d$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : "tokenize" in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $d243901ff94656bd$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {void}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $7e89c312a872674d$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === "string") view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $7e89c312a872674d$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === "string") value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "	";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}


var $1125308a6c24c434$exports = {};

$parcel$export($1125308a6c24c434$exports, "document", () => $1125308a6c24c434$export$5a7bfc01df82fcd1);
$parcel$export($1125308a6c24c434$exports, "contentInitial", () => $1125308a6c24c434$export$5a2181fb44b58173);
$parcel$export($1125308a6c24c434$exports, "flowInitial", () => $1125308a6c24c434$export$cf8bead395eff824);
$parcel$export($1125308a6c24c434$exports, "flow", () => $1125308a6c24c434$export$ccc7b0636abaffc3);
$parcel$export($1125308a6c24c434$exports, "string", () => $1125308a6c24c434$export$22b082955e083ec3);
$parcel$export($1125308a6c24c434$exports, "text", () => $1125308a6c24c434$export$6f093cfa640b7166);
$parcel$export($1125308a6c24c434$exports, "insideSpan", () => $1125308a6c24c434$export$d44f260a3f9b69f5);
$parcel$export($1125308a6c24c434$exports, "attentionMarkers", () => $1125308a6c24c434$export$b9c0b60d74426aea);
$parcel$export($1125308a6c24c434$exports, "disable", () => $1125308a6c24c434$export$e20fbacbb41798b);
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
function $924261223d5276fa$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code) || (0, $bcbf19ba9aa2a126$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $bcbf19ba9aa2a126$export$aa04114dd888a7a0)(code)) return 2;
}



const $f120b340c30f26d3$export$45b92471da762af7 = {
    name: "attention",
    tokenize: $f120b340c30f26d3$var$tokenizeAttention,
    resolveAll: $f120b340c30f26d3$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ function $f120b340c30f26d3$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $f120b340c30f26d3$var$movePoint(start, -use);
            $f120b340c30f26d3$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $d243901ff94656bd$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $d243901ff94656bd$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $d243901ff94656bd$export$4cbf152802aa238)(nextEvents, (0, $34133fc7a9cfcf1e$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $d243901ff94656bd$export$4cbf152802aa238)(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $d243901ff94656bd$export$4cbf152802aa238)(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $d243901ff94656bd$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f120b340c30f26d3$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $924261223d5276fa$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter("attentionSequence");
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit("attentionSequence");
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $924261223d5276fa$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */ function $f120b340c30f26d3$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $0b9e2da48b68f3c9$export$17ddf85e4c916ad6 = {
    name: "autolink",
    tokenize: $0b9e2da48b68f3c9$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0b9e2da48b68f3c9$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $bcbf19ba9aa2a126$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $bcbf19ba9aa2a126$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $d61fe1eac19e8761$export$200dcd0a5903c968 = {
    name: "blockQuote",
    tokenize: $d61fe1eac19e8761$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $d61fe1eac19e8761$var$tokenizeBlockQuoteContinuation
    },
    exit: $d61fe1eac19e8761$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d61fe1eac19e8761$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d61fe1eac19e8761$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($d61fe1eac19e8761$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $d61fe1eac19e8761$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $028c9ae6a663e8f9$export$2005478564e78d96 = {
    name: "characterEscape",
    tokenize: $028c9ae6a663e8f9$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $028c9ae6a663e8f9$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $bcbf19ba9aa2a126$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */ const $d29e14c097a0f21f$export$ec810d1aafce79a7 = {
    AElig: "\xc6",
    AMP: "&",
    Aacute: "\xc1",
    Abreve: "\u0102",
    Acirc: "\xc2",
    Acy: "\u0410",
    Afr: "\uD835\uDD04",
    Agrave: "\xc0",
    Alpha: "\u0391",
    Amacr: "\u0100",
    And: "\u2A53",
    Aogon: "\u0104",
    Aopf: "\uD835\uDD38",
    ApplyFunction: "\u2061",
    Aring: "\xc5",
    Ascr: "\uD835\uDC9C",
    Assign: "\u2254",
    Atilde: "\xc3",
    Auml: "\xc4",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    Barwed: "\u2306",
    Bcy: "\u0411",
    Because: "\u2235",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Breve: "\u02D8",
    Bscr: "\u212C",
    Bumpeq: "\u224E",
    CHcy: "\u0427",
    COPY: "\xa9",
    Cacute: "\u0106",
    Cap: "\u22D2",
    CapitalDifferentialD: "\u2145",
    Cayleys: "\u212D",
    Ccaron: "\u010C",
    Ccedil: "\xc7",
    Ccirc: "\u0108",
    Cconint: "\u2230",
    Cdot: "\u010A",
    Cedilla: "\xb8",
    CenterDot: "\xb7",
    Cfr: "\u212D",
    Chi: "\u03A7",
    CircleDot: "\u2299",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    Colon: "\u2237",
    Colone: "\u2A74",
    Congruent: "\u2261",
    Conint: "\u222F",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    Coproduct: "\u2210",
    CounterClockwiseContourIntegral: "\u2233",
    Cross: "\u2A2F",
    Cscr: "\uD835\uDC9E",
    Cup: "\u22D3",
    CupCap: "\u224D",
    DD: "\u2145",
    DDotrahd: "\u2911",
    DJcy: "\u0402",
    DScy: "\u0405",
    DZcy: "\u040F",
    Dagger: "\u2021",
    Darr: "\u21A1",
    Dashv: "\u2AE4",
    Dcaron: "\u010E",
    Dcy: "\u0414",
    Del: "\u2207",
    Delta: "\u0394",
    Dfr: "\uD835\uDD07",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: "`",
    DiacriticalTilde: "\u02DC",
    Diamond: "\u22C4",
    DifferentialD: "\u2146",
    Dopf: "\uD835\uDD3B",
    Dot: "\xa8",
    DotDot: "\u20DC",
    DotEqual: "\u2250",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    Downarrow: "\u21D3",
    Dscr: "\uD835\uDC9F",
    Dstrok: "\u0110",
    ENG: "\u014A",
    ETH: "\xd0",
    Eacute: "\xc9",
    Ecaron: "\u011A",
    Ecirc: "\xca",
    Ecy: "\u042D",
    Edot: "\u0116",
    Efr: "\uD835\uDD08",
    Egrave: "\xc8",
    Element: "\u2208",
    Emacr: "\u0112",
    EmptySmallSquare: "\u25FB",
    EmptyVerySmallSquare: "\u25AB",
    Eogon: "\u0118",
    Eopf: "\uD835\uDD3C",
    Epsilon: "\u0395",
    Equal: "\u2A75",
    EqualTilde: "\u2242",
    Equilibrium: "\u21CC",
    Escr: "\u2130",
    Esim: "\u2A73",
    Eta: "\u0397",
    Euml: "\xcb",
    Exists: "\u2203",
    ExponentialE: "\u2147",
    Fcy: "\u0424",
    Ffr: "\uD835\uDD09",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    Fopf: "\uD835\uDD3D",
    ForAll: "\u2200",
    Fouriertrf: "\u2131",
    Fscr: "\u2131",
    GJcy: "\u0403",
    GT: ">",
    Gamma: "\u0393",
    Gammad: "\u03DC",
    Gbreve: "\u011E",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    Gcy: "\u0413",
    Gdot: "\u0120",
    Gfr: "\uD835\uDD0A",
    Gg: "\u22D9",
    Gopf: "\uD835\uDD3E",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    Gt: "\u226B",
    HARDcy: "\u042A",
    Hacek: "\u02C7",
    Hat: "^",
    Hcirc: "\u0124",
    Hfr: "\u210C",
    HilbertSpace: "\u210B",
    Hopf: "\u210D",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    Hstrok: "\u0126",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    IEcy: "\u0415",
    IJlig: "\u0132",
    IOcy: "\u0401",
    Iacute: "\xcd",
    Icirc: "\xce",
    Icy: "\u0418",
    Idot: "\u0130",
    Ifr: "\u2111",
    Igrave: "\xcc",
    Im: "\u2111",
    Imacr: "\u012A",
    ImaginaryI: "\u2148",
    Implies: "\u21D2",
    Int: "\u222C",
    Integral: "\u222B",
    Intersection: "\u22C2",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    Iogon: "\u012E",
    Iopf: "\uD835\uDD40",
    Iota: "\u0399",
    Iscr: "\u2110",
    Itilde: "\u0128",
    Iukcy: "\u0406",
    Iuml: "\xcf",
    Jcirc: "\u0134",
    Jcy: "\u0419",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    Jsercy: "\u0408",
    Jukcy: "\u0404",
    KHcy: "\u0425",
    KJcy: "\u040C",
    Kappa: "\u039A",
    Kcedil: "\u0136",
    Kcy: "\u041A",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    LJcy: "\u0409",
    LT: "<",
    Lacute: "\u0139",
    Lambda: "\u039B",
    Lang: "\u27EA",
    Laplacetrf: "\u2112",
    Larr: "\u219E",
    Lcaron: "\u013D",
    Lcedil: "\u013B",
    Lcy: "\u041B",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    LeftRightArrow: "\u2194",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    Leftarrow: "\u21D0",
    Leftrightarrow: "\u21D4",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    LessLess: "\u2AA1",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    Lfr: "\uD835\uDD0F",
    Ll: "\u22D8",
    Lleftarrow: "\u21DA",
    Lmidot: "\u013F",
    LongLeftArrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    LongRightArrow: "\u27F6",
    Longleftarrow: "\u27F8",
    Longleftrightarrow: "\u27FA",
    Longrightarrow: "\u27F9",
    Lopf: "\uD835\uDD43",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    Lscr: "\u2112",
    Lsh: "\u21B0",
    Lstrok: "\u0141",
    Lt: "\u226A",
    Map: "\u2905",
    Mcy: "\u041C",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    MinusPlus: "\u2213",
    Mopf: "\uD835\uDD44",
    Mscr: "\u2133",
    Mu: "\u039C",
    NJcy: "\u040A",
    Nacute: "\u0143",
    Ncaron: "\u0147",
    Ncedil: "\u0145",
    Ncy: "\u041D",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: "\n",
    Nfr: "\uD835\uDD11",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    Not: "\u2AEC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    Nscr: "\uD835\uDCA9",
    Ntilde: "\xd1",
    Nu: "\u039D",
    OElig: "\u0152",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Ocy: "\u041E",
    Odblac: "\u0150",
    Ofr: "\uD835\uDD12",
    Ograve: "\xd2",
    Omacr: "\u014C",
    Omega: "\u03A9",
    Omicron: "\u039F",
    Oopf: "\uD835\uDD46",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    Or: "\u2A54",
    Oscr: "\uD835\uDCAA",
    Oslash: "\xd8",
    Otilde: "\xd5",
    Otimes: "\u2A37",
    Ouml: "\xd6",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    PartialD: "\u2202",
    Pcy: "\u041F",
    Pfr: "\uD835\uDD13",
    Phi: "\u03A6",
    Pi: "\u03A0",
    PlusMinus: "\xb1",
    Poincareplane: "\u210C",
    Popf: "\u2119",
    Pr: "\u2ABB",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    Prime: "\u2033",
    Product: "\u220F",
    Proportion: "\u2237",
    Proportional: "\u221D",
    Pscr: "\uD835\uDCAB",
    Psi: "\u03A8",
    QUOT: '"',
    Qfr: "\uD835\uDD14",
    Qopf: "\u211A",
    Qscr: "\uD835\uDCAC",
    RBarr: "\u2910",
    REG: "\xae",
    Racute: "\u0154",
    Rang: "\u27EB",
    Rarr: "\u21A0",
    Rarrtl: "\u2916",
    Rcaron: "\u0158",
    Rcedil: "\u0156",
    Rcy: "\u0420",
    Re: "\u211C",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    Rfr: "\u211C",
    Rho: "\u03A1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    Rightarrow: "\u21D2",
    Ropf: "\u211D",
    RoundImplies: "\u2970",
    Rrightarrow: "\u21DB",
    Rscr: "\u211B",
    Rsh: "\u21B1",
    RuleDelayed: "\u29F4",
    SHCHcy: "\u0429",
    SHcy: "\u0428",
    SOFTcy: "\u042C",
    Sacute: "\u015A",
    Sc: "\u2ABC",
    Scaron: "\u0160",
    Scedil: "\u015E",
    Scirc: "\u015C",
    Scy: "\u0421",
    Sfr: "\uD835\uDD16",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    Sigma: "\u03A3",
    SmallCircle: "\u2218",
    Sopf: "\uD835\uDD4A",
    Sqrt: "\u221A",
    Square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    Sscr: "\uD835\uDCAE",
    Star: "\u22C6",
    Sub: "\u22D0",
    Subset: "\u22D0",
    SubsetEqual: "\u2286",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    Sup: "\u22D1",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    Supset: "\u22D1",
    THORN: "\xde",
    TRADE: "\u2122",
    TSHcy: "\u040B",
    TScy: "\u0426",
    Tab: "	",
    Tau: "\u03A4",
    Tcaron: "\u0164",
    Tcedil: "\u0162",
    Tcy: "\u0422",
    Tfr: "\uD835\uDD17",
    Therefore: "\u2234",
    Theta: "\u0398",
    ThickSpace: "\u205F\u200A",
    ThinSpace: "\u2009",
    Tilde: "\u223C",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    Topf: "\uD835\uDD4B",
    TripleDot: "\u20DB",
    Tscr: "\uD835\uDCAF",
    Tstrok: "\u0166",
    Uacute: "\xda",
    Uarr: "\u219F",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    Ubreve: "\u016C",
    Ucirc: "\xdb",
    Ucy: "\u0423",
    Udblac: "\u0170",
    Ufr: "\uD835\uDD18",
    Ugrave: "\xd9",
    Umacr: "\u016A",
    UnderBar: "_",
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    Uopf: "\uD835\uDD4C",
    UpArrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    UpEquilibrium: "\u296E",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    Uparrow: "\u21D1",
    Updownarrow: "\u21D5",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    Upsilon: "\u03A5",
    Uring: "\u016E",
    Uscr: "\uD835\uDCB0",
    Utilde: "\u0168",
    Uuml: "\xdc",
    VDash: "\u22AB",
    Vbar: "\u2AEB",
    Vcy: "\u0412",
    Vdash: "\u22A9",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    Verbar: "\u2016",
    Vert: "\u2016",
    VerticalBar: "\u2223",
    VerticalLine: "|",
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    Vvdash: "\u22AA",
    Wcirc: "\u0174",
    Wedge: "\u22C0",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    Xfr: "\uD835\uDD1B",
    Xi: "\u039E",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    YAcy: "\u042F",
    YIcy: "\u0407",
    YUcy: "\u042E",
    Yacute: "\xdd",
    Ycirc: "\u0176",
    Ycy: "\u042B",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    Yuml: "\u0178",
    ZHcy: "\u0416",
    Zacute: "\u0179",
    Zcaron: "\u017D",
    Zcy: "\u0417",
    Zdot: "\u017B",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    Zfr: "\u2128",
    Zopf: "\u2124",
    Zscr: "\uD835\uDCB5",
    aacute: "\xe1",
    abreve: "\u0103",
    ac: "\u223E",
    acE: "\u223E\u0333",
    acd: "\u223F",
    acirc: "\xe2",
    acute: "\xb4",
    acy: "\u0430",
    aelig: "\xe6",
    af: "\u2061",
    afr: "\uD835\uDD1E",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    alpha: "\u03B1",
    amacr: "\u0101",
    amalg: "\u2A3F",
    amp: "&",
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    aogon: "\u0105",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apE: "\u2A70",
    apacir: "\u2A6F",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    approx: "\u2248",
    approxeq: "\u224A",
    aring: "\xe5",
    ascr: "\uD835\uDCB6",
    ast: "*",
    asymp: "\u2248",
    asympeq: "\u224D",
    atilde: "\xe3",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    bNot: "\u2AED",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    barvee: "\u22BD",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bnot: "\u2310",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxDL: "\u2557",
    boxDR: "\u2554",
    boxDl: "\u2556",
    boxDr: "\u2553",
    boxH: "\u2550",
    boxHD: "\u2566",
    boxHU: "\u2569",
    boxHd: "\u2564",
    boxHu: "\u2567",
    boxUL: "\u255D",
    boxUR: "\u255A",
    boxUl: "\u255C",
    boxUr: "\u2559",
    boxV: "\u2551",
    boxVH: "\u256C",
    boxVL: "\u2563",
    boxVR: "\u2560",
    boxVh: "\u256B",
    boxVl: "\u2562",
    boxVr: "\u255F",
    boxbox: "\u29C9",
    boxdL: "\u2555",
    boxdR: "\u2552",
    boxdl: "\u2510",
    boxdr: "\u250C",
    boxh: "\u2500",
    boxhD: "\u2565",
    boxhU: "\u2568",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxuL: "\u255B",
    boxuR: "\u2558",
    boxul: "\u2518",
    boxur: "\u2514",
    boxv: "\u2502",
    boxvH: "\u256A",
    boxvL: "\u2561",
    boxvR: "\u255E",
    boxvh: "\u253C",
    boxvl: "\u2524",
    boxvr: "\u251C",
    bprime: "\u2035",
    breve: "\u02D8",
    brvbar: "\xa6",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: "\\",
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    cacute: "\u0107",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    ccaps: "\u2A4D",
    ccaron: "\u010D",
    ccedil: "\xe7",
    ccirc: "\u0109",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    cdot: "\u010B",
    cedil: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    centerdot: "\xb7",
    cfr: "\uD835\uDD20",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    chi: "\u03C7",
    cir: "\u25CB",
    cirE: "\u29C3",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledR: "\xae",
    circledS: "\u24C8",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    clubs: "\u2663",
    clubsuit: "\u2663",
    colon: ":",
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ",",
    commat: "@",
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    conint: "\u222E",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    copy: "\xa9",
    copysr: "\u2117",
    crarr: "\u21B5",
    cross: "\u2717",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    dArr: "\u21D3",
    dHar: "\u2965",
    dagger: "\u2020",
    daleth: "\u2138",
    darr: "\u2193",
    dash: "\u2010",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    dcaron: "\u010F",
    dcy: "\u0434",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    ddotseq: "\u2A77",
    deg: "\xb0",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    dfr: "\uD835\uDD21",
    dharl: "\u21C3",
    dharr: "\u21C2",
    diam: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: "$",
    dopf: "\uD835\uDD55",
    dot: "\u02D9",
    doteq: "\u2250",
    doteqdot: "\u2251",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    downarrow: "\u2193",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    dscr: "\uD835\uDCB9",
    dscy: "\u0455",
    dsol: "\u29F6",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    eDDot: "\u2A77",
    eDot: "\u2251",
    eacute: "\xe9",
    easter: "\u2A6E",
    ecaron: "\u011B",
    ecir: "\u2256",
    ecirc: "\xea",
    ecolon: "\u2255",
    ecy: "\u044D",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    emsp13: "\u2004",
    emsp14: "\u2005",
    emsp: "\u2003",
    eng: "\u014B",
    ensp: "\u2002",
    eogon: "\u0119",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    equals: "=",
    equest: "\u225F",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erDot: "\u2253",
    erarr: "\u2971",
    escr: "\u212F",
    esdot: "\u2250",
    esim: "\u2242",
    eta: "\u03B7",
    eth: "\xf0",
    euml: "\xeb",
    euro: "\u20AC",
    excl: "!",
    exist: "\u2203",
    expectation: "\u2130",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    fjlig: "fj",
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    fopf: "\uD835\uDD57",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    fscr: "\uD835\uDCBB",
    gE: "\u2267",
    gEl: "\u2A8C",
    gacute: "\u01F5",
    gamma: "\u03B3",
    gammad: "\u03DD",
    gap: "\u2A86",
    gbreve: "\u011F",
    gcirc: "\u011D",
    gcy: "\u0433",
    gdot: "\u0121",
    ge: "\u2265",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    gfr: "\uD835\uDD24",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    gjcy: "\u0453",
    gl: "\u2277",
    glE: "\u2A92",
    gla: "\u2AA5",
    glj: "\u2AA4",
    gnE: "\u2269",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    gopf: "\uD835\uDD58",
    grave: "`",
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    gt: ">",
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    hArr: "\u21D4",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    hardcy: "\u044A",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    hbar: "\u210F",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    hfr: "\uD835\uDD25",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    hstrok: "\u0127",
    hybull: "\u2043",
    hyphen: "\u2010",
    iacute: "\xed",
    ic: "\u2063",
    icirc: "\xee",
    icy: "\u0438",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    ifr: "\uD835\uDD26",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    ijlig: "\u0133",
    imacr: "\u012B",
    image: "\u2111",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    intercal: "\u22BA",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    iocy: "\u0451",
    iogon: "\u012F",
    iopf: "\uD835\uDD5A",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isinE: "\u22F9",
    isindot: "\u22F5",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    itilde: "\u0129",
    iukcy: "\u0456",
    iuml: "\xef",
    jcirc: "\u0135",
    jcy: "\u0439",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    jsercy: "\u0458",
    jukcy: "\u0454",
    kappa: "\u03BA",
    kappav: "\u03F0",
    kcedil: "\u0137",
    kcy: "\u043A",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    khcy: "\u0445",
    kjcy: "\u045C",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    lArr: "\u21D0",
    lAtail: "\u291B",
    lBarr: "\u290E",
    lE: "\u2266",
    lEg: "\u2A8B",
    lHar: "\u2962",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    lambda: "\u03BB",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    laquo: "\xab",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: "{",
    lbrack: "[",
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    lcaron: "\u013E",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: "{",
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    le: "\u2264",
    leftarrow: "\u2190",
    leftarrowtail: "\u21A2",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    leftthreetimes: "\u22CB",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    lessgtr: "\u2276",
    lesssim: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    ljcy: "\u0459",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    llhard: "\u296B",
    lltri: "\u25FA",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnE: "\u2268",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    longleftarrow: "\u27F5",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: "_",
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: "(",
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    lscr: "\uD835\uDCC1",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: "[",
    lsquo: "\u2018",
    lsquor: "\u201A",
    lstrok: "\u0142",
    lt: "<",
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltrPar: "\u2996",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    mDDot: "\u223A",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    mcy: "\u043C",
    mdash: "\u2014",
    measuredangle: "\u2221",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: "*",
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nGg: "\u22D9\u0338",
    nGt: "\u226B\u20D2",
    nGtv: "\u226B\u0338",
    nLeftarrow: "\u21CD",
    nLeftrightarrow: "\u21CE",
    nLl: "\u22D8\u0338",
    nLt: "\u226A\u20D2",
    nLtv: "\u226A\u0338",
    nRightarrow: "\u21CF",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nabla: "\u2207",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    ncaron: "\u0148",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    neArr: "\u21D7",
    nearhk: "\u2924",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    nexist: "\u2204",
    nexists: "\u2204",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    ngsim: "\u2275",
    ngt: "\u226F",
    ngtr: "\u226F",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlE: "\u2266\u0338",
    nlarr: "\u219A",
    nldr: "\u2025",
    nle: "\u2270",
    nleftarrow: "\u219A",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nlsim: "\u2274",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nmid: "\u2224",
    nopf: "\uD835\uDD5F",
    not: "\xac",
    notin: "\u2209",
    notinE: "\u22F9\u0338",
    notindot: "\u22F5\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    nu: "\u03BD",
    num: "#",
    numero: "\u2116",
    numsp: "\u2007",
    nvDash: "\u22AD",
    nvHarr: "\u2904",
    nvap: "\u224D\u20D2",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwArr: "\u21D6",
    nwarhk: "\u2923",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    oS: "\u24C8",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    ocirc: "\xf4",
    ocy: "\u043E",
    odash: "\u229D",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    oelig: "\u0153",
    ofcir: "\u29BF",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    omacr: "\u014D",
    omega: "\u03C9",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    operp: "\u29B9",
    oplus: "\u2295",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oscr: "\u2134",
    oslash: "\xf8",
    osol: "\u2298",
    otilde: "\xf5",
    otimes: "\u2297",
    otimesas: "\u2A36",
    ouml: "\xf6",
    ovbar: "\u233D",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    pcy: "\u043F",
    percnt: "%",
    period: ".",
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    pfr: "\uD835\uDD2D",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: "+",
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    pointint: "\u2A15",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    pr: "\u227A",
    prE: "\u2AB3",
    prap: "\u2AB7",
    prcue: "\u227C",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    prime: "\u2032",
    primes: "\u2119",
    prnE: "\u2AB5",
    prnap: "\u2AB9",
    prnsim: "\u22E8",
    prod: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    pscr: "\uD835\uDCC5",
    psi: "\u03C8",
    puncsp: "\u2008",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: "?",
    questeq: "\u225F",
    quot: '"',
    rAarr: "\u21DB",
    rArr: "\u21D2",
    rAtail: "\u291C",
    rBarr: "\u290F",
    rHar: "\u2964",
    race: "\u223D\u0331",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: "}",
    rbrack: "]",
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    rcaron: "\u0159",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: "}",
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    reg: "\xae",
    rfisht: "\u297D",
    rfloor: "\u230B",
    rfr: "\uD835\uDD2F",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    rho: "\u03C1",
    rhov: "\u03F1",
    rightarrow: "\u2192",
    rightarrowtail: "\u21A3",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    rightthreetimes: "\u22CC",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    rpar: ")",
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    rsaquo: "\u203A",
    rscr: "\uD835\uDCC7",
    rsh: "\u21B1",
    rsqb: "]",
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    ruluhar: "\u2968",
    rx: "\u211E",
    sacute: "\u015B",
    sbquo: "\u201A",
    sc: "\u227B",
    scE: "\u2AB4",
    scap: "\u2AB8",
    scaron: "\u0161",
    sccue: "\u227D",
    sce: "\u2AB0",
    scedil: "\u015F",
    scirc: "\u015D",
    scnE: "\u2AB6",
    scnap: "\u2ABA",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    seArr: "\u21D8",
    searhk: "\u2925",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ";",
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    shchcy: "\u0449",
    shcy: "\u0448",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    shy: "\xad",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    softcy: "\u044C",
    sol: "/",
    solb: "\u29C4",
    solbar: "\u233F",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    square: "\u25A1",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    sub: "\u2282",
    subE: "\u2AC5",
    subdot: "\u2ABD",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    sum: "\u2211",
    sung: "\u266A",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    sup: "\u2283",
    supE: "\u2AC6",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supe: "\u2287",
    supedot: "\u2AC4",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swArr: "\u21D9",
    swarhk: "\u2926",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    target: "\u2316",
    tau: "\u03C4",
    tbrk: "\u23B4",
    tcaron: "\u0165",
    tcedil: "\u0163",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    therefore: "\u2234",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    thinsp: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    thorn: "\xfe",
    tilde: "\u02DC",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    tscr: "\uD835\uDCC9",
    tscy: "\u0446",
    tshcy: "\u045B",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    uArr: "\u21D1",
    uHar: "\u2963",
    uacute: "\xfa",
    uarr: "\u2191",
    ubrcy: "\u045E",
    ubreve: "\u016D",
    ucirc: "\xfb",
    ucy: "\u0443",
    udarr: "\u21C5",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    ufr: "\uD835\uDD32",
    ugrave: "\xf9",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    umacr: "\u016B",
    uml: "\xa8",
    uogon: "\u0173",
    uopf: "\uD835\uDD66",
    uparrow: "\u2191",
    updownarrow: "\u2195",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    upsi: "\u03C5",
    upsih: "\u03D2",
    upsilon: "\u03C5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    uring: "\u016F",
    urtri: "\u25F9",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vArr: "\u21D5",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    vDash: "\u22A8",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    vcy: "\u0432",
    vdash: "\u22A2",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    verbar: "|",
    vert: "|",
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    vzigzag: "\u299A",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    yacute: "\xfd",
    yacy: "\u044F",
    ycirc: "\u0177",
    ycy: "\u044B",
    yen: "\xa5",
    yfr: "\uD835\uDD36",
    yicy: "\u0457",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    yucy: "\u044E",
    yuml: "\xff",
    zacute: "\u017A",
    zcaron: "\u017E",
    zcy: "\u0437",
    zdot: "\u017C",
    zeetrf: "\u2128",
    zeta: "\u03B6",
    zfr: "\uD835\uDD37",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
};


const $3b0f8de8dd9bf3d7$var$own = {}.hasOwnProperty;
function $3b0f8de8dd9bf3d7$export$289b6a6320f709b4(value) {
    return $3b0f8de8dd9bf3d7$var$own.call((0, $d29e14c097a0f21f$export$ec810d1aafce79a7), value) ? (0, $d29e14c097a0f21f$export$ec810d1aafce79a7)[value] : false;
}



const $9b6c053df4c2a770$export$e31905600aaf3d8e = {
    name: "characterReference",
    tokenize: $9b6c053df4c2a770$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9b6c053df4c2a770$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $bcbf19ba9aa2a126$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $bcbf19ba9aa2a126$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4) && !(0, $3b0f8de8dd9bf3d7$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/** @type {Construct} */ const $2c1eae53b80e25cd$var$nonLazyContinuation = {
    tokenize: $2c1eae53b80e25cd$var$tokenizeNonLazyContinuation,
    partial: true
};
const $2c1eae53b80e25cd$export$c23e4921f8d87e7c = {
    name: "codeFenced",
    tokenize: $2c1eae53b80e25cd$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c1eae53b80e25cd$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code) ? (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($2c1eae53b80e25cd$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code) ? (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) return effects.check($2c1eae53b80e25cd$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code) ? (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code) ? (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c1eae53b80e25cd$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $e9c4fe5f4fb40bc2$export$47910b7ab28d1853 = {
    name: "codeIndented",
    tokenize: $e9c4fe5f4fb40bc2$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $e9c4fe5f4fb40bc2$var$furtherStart = {
    tokenize: $e9c4fe5f4fb40bc2$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e9c4fe5f4fb40bc2$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) return effects.attempt($e9c4fe5f4fb40bc2$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e9c4fe5f4fb40bc2$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $a540eb9071ad7377$export$d24f93e715f9df88 = {
    name: "codeText",
    tokenize: $a540eb9071ad7377$var$tokenizeCodeText,
    resolve: $a540eb9071ad7377$var$resolveCodeText,
    previous: $a540eb9071ad7377$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $a540eb9071ad7377$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $a540eb9071ad7377$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a540eb9071ad7377$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $eebf79b6792b39ec$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $bcbf19ba9aa2a126$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $bcbf19ba9aa2a126$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $0a3e341395750acf$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && "_hiddenFootnoteSupport" in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 

function $0defc1351544eb80$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 

function $1ecbdbe7e32163b9$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}



/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $e3ffbc1ff2da7d5d$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, "")// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


const $c2901500ced72f3b$export$69f215ed977cdb73 = {
    name: "definition",
    tokenize: $c2901500ced72f3b$var$tokenizeDefinition
};
/** @type {Construct} */ const $c2901500ced72f3b$var$titleBefore = {
    tokenize: $c2901500ced72f3b$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c2901500ced72f3b$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $0a3e341395750acf$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $e3ffbc1ff2da7d5d$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code) ? (0, $1ecbdbe7e32163b9$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $eebf79b6792b39ec$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($c2901500ced72f3b$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code) ? (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c2901500ced72f3b$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code) ? (0, $1ecbdbe7e32163b9$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $0defc1351544eb80$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code) ? (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $174b0bf67ca44931$export$86c573ab9e06f418 = {
    name: "hardBreakEscape",
    tokenize: $174b0bf67ca44931$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $174b0bf67ca44931$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $90f845ad9ea0df13$export$3871e9deb360695c = {
    name: "headingAtx",
    tokenize: $90f845ad9ea0df13$var$tokenizeHeadingAtx,
    resolve: $90f845ad9ea0df13$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $90f845ad9ea0df13$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $d243901ff94656bd$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $90f845ad9ea0df13$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $6a07ad491e11567b$export$7364aee1c59d1879 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
const $6a07ad491e11567b$export$948e66da505d080 = [
    "pre",
    "script",
    "style",
    "textarea"
];



const $fbf9b5040503a534$export$476ac411cb7d0d8f = {
    name: "htmlFlow",
    tokenize: $fbf9b5040503a534$var$tokenizeHtmlFlow,
    resolveTo: $fbf9b5040503a534$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $fbf9b5040503a534$var$blankLineBefore = {
    tokenize: $fbf9b5040503a534$var$tokenizeBlankLineBefore,
    partial: true
};
const $fbf9b5040503a534$var$nonLazyContinuationStart = {
    tokenize: $fbf9b5040503a534$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $fbf9b5040503a534$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fbf9b5040503a534$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $6a07ad491e11567b$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $6a07ad491e11567b$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($fbf9b5040503a534$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($fbf9b5040503a534$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $6a07ad491e11567b$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fbf9b5040503a534$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fbf9b5040503a534$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $8219420e5fbadbac$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $718f051be43549ce$export$398af27f284914fe = {
    name: "htmlText",
    tokenize: $718f051be43549ce$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $718f051be43549ce$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code) ? (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 







const $75517f76b8ed40ab$export$470a5dafbbf62654 = {
    name: "labelEnd",
    tokenize: $75517f76b8ed40ab$var$tokenizeLabelEnd,
    resolveTo: $75517f76b8ed40ab$var$resolveToLabelEnd,
    resolveAll: $75517f76b8ed40ab$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $75517f76b8ed40ab$var$resourceConstruct = {
    tokenize: $75517f76b8ed40ab$var$tokenizeResource
};
/** @type {Construct} */ const $75517f76b8ed40ab$var$referenceFullConstruct = {
    tokenize: $75517f76b8ed40ab$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $75517f76b8ed40ab$var$referenceCollapsedConstruct = {
    tokenize: $75517f76b8ed40ab$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $75517f76b8ed40ab$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $75517f76b8ed40ab$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $d243901ff94656bd$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $d243901ff94656bd$export$4cbf152802aa238)(media, [
        [
            "enter",
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $d243901ff94656bd$export$4cbf152802aa238)(media, (0, $34133fc7a9cfcf1e$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $d243901ff94656bd$export$4cbf152802aa238)(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $d243901ff94656bd$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $d243901ff94656bd$export$4cbf152802aa238)(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    (0, $d243901ff94656bd$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $75517f76b8ed40ab$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $e3ffbc1ff2da7d5d$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($75517f76b8ed40ab$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($75517f76b8ed40ab$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($75517f76b8ed40ab$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $75517f76b8ed40ab$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code) ? (0, $1ecbdbe7e32163b9$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $eebf79b6792b39ec$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code) ? (0, $1ecbdbe7e32163b9$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $0defc1351544eb80$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code) ? (0, $1ecbdbe7e32163b9$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $75517f76b8ed40ab$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $0a3e341395750acf$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $e3ffbc1ff2da7d5d$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $75517f76b8ed40ab$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $bdfa0e5d02c5315b$export$3d754936e25aa5f5 = {
    name: "labelStartImage",
    tokenize: $bdfa0e5d02c5315b$var$tokenizeLabelStartImage,
    resolveAll: (0, $75517f76b8ed40ab$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $bdfa0e5d02c5315b$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $e0b3afc9eccd699c$export$5c0cee0701a3b584 = {
    name: "labelStartLink",
    tokenize: $e0b3afc9eccd699c$var$tokenizeLabelStartLink,
    resolveAll: (0, $75517f76b8ed40ab$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e0b3afc9eccd699c$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $82104322c742272a$export$8e62e0ad51c97b2 = {
    name: "lineEnding",
    tokenize: $82104322c742272a$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $82104322c742272a$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $4cb54c9317d087e5$export$ba7b13e047416c03 = {
    name: "thematicBreak",
    tokenize: $4cb54c9317d087e5$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4cb54c9317d087e5$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code) ? (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $457801f4d7423b6d$export$8837f4fc672e936d = {
    name: "list",
    tokenize: $457801f4d7423b6d$var$tokenizeListStart,
    continuation: {
        tokenize: $457801f4d7423b6d$var$tokenizeListContinuation
    },
    exit: $457801f4d7423b6d$var$tokenizeListEnd
};
/** @type {Construct} */ const $457801f4d7423b6d$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $457801f4d7423b6d$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $457801f4d7423b6d$var$indentConstruct = {
    tokenize: $457801f4d7423b6d$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $457801f4d7423b6d$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $bcbf19ba9aa2a126$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $4cb54c9317d087e5$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $bcbf19ba9aa2a126$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $8219420e5fbadbac$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($457801f4d7423b6d$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $457801f4d7423b6d$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $8219420e5fbadbac$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($457801f4d7423b6d$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, effects.attempt($457801f4d7423b6d$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $457801f4d7423b6d$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $457801f4d7423b6d$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $457801f4d7423b6d$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $a88333001de28e6a$export$e104e2de391dfde9 = {
    name: "setextUnderline",
    tokenize: $a88333001de28e6a$var$tokenizeSetextUnderline,
    resolveTo: $a88333001de28e6a$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $a88333001de28e6a$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a88333001de28e6a$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code) ? (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $1125308a6c24c434$export$5a7bfc01df82fcd1 = {
    [42]: (0, $457801f4d7423b6d$export$8837f4fc672e936d),
    [43]: (0, $457801f4d7423b6d$export$8837f4fc672e936d),
    [45]: (0, $457801f4d7423b6d$export$8837f4fc672e936d),
    [48]: (0, $457801f4d7423b6d$export$8837f4fc672e936d),
    [49]: (0, $457801f4d7423b6d$export$8837f4fc672e936d),
    [50]: (0, $457801f4d7423b6d$export$8837f4fc672e936d),
    [51]: (0, $457801f4d7423b6d$export$8837f4fc672e936d),
    [52]: (0, $457801f4d7423b6d$export$8837f4fc672e936d),
    [53]: (0, $457801f4d7423b6d$export$8837f4fc672e936d),
    [54]: (0, $457801f4d7423b6d$export$8837f4fc672e936d),
    [55]: (0, $457801f4d7423b6d$export$8837f4fc672e936d),
    [56]: (0, $457801f4d7423b6d$export$8837f4fc672e936d),
    [57]: (0, $457801f4d7423b6d$export$8837f4fc672e936d),
    [62]: (0, $d61fe1eac19e8761$export$200dcd0a5903c968)
};
const $1125308a6c24c434$export$5a2181fb44b58173 = {
    [91]: (0, $c2901500ced72f3b$export$69f215ed977cdb73)
};
const $1125308a6c24c434$export$cf8bead395eff824 = {
    [-2]: (0, $e9c4fe5f4fb40bc2$export$47910b7ab28d1853),
    [-1]: (0, $e9c4fe5f4fb40bc2$export$47910b7ab28d1853),
    [32]: (0, $e9c4fe5f4fb40bc2$export$47910b7ab28d1853)
};
const $1125308a6c24c434$export$ccc7b0636abaffc3 = {
    [35]: (0, $90f845ad9ea0df13$export$3871e9deb360695c),
    [42]: (0, $4cb54c9317d087e5$export$ba7b13e047416c03),
    [45]: [
        (0, $a88333001de28e6a$export$e104e2de391dfde9),
        (0, $4cb54c9317d087e5$export$ba7b13e047416c03)
    ],
    [60]: (0, $fbf9b5040503a534$export$476ac411cb7d0d8f),
    [61]: (0, $a88333001de28e6a$export$e104e2de391dfde9),
    [95]: (0, $4cb54c9317d087e5$export$ba7b13e047416c03),
    [96]: (0, $2c1eae53b80e25cd$export$c23e4921f8d87e7c),
    [126]: (0, $2c1eae53b80e25cd$export$c23e4921f8d87e7c)
};
const $1125308a6c24c434$export$22b082955e083ec3 = {
    [38]: (0, $9b6c053df4c2a770$export$e31905600aaf3d8e),
    [92]: (0, $028c9ae6a663e8f9$export$2005478564e78d96)
};
const $1125308a6c24c434$export$6f093cfa640b7166 = {
    [-5]: (0, $82104322c742272a$export$8e62e0ad51c97b2),
    [-4]: (0, $82104322c742272a$export$8e62e0ad51c97b2),
    [-3]: (0, $82104322c742272a$export$8e62e0ad51c97b2),
    [33]: (0, $bdfa0e5d02c5315b$export$3d754936e25aa5f5),
    [38]: (0, $9b6c053df4c2a770$export$e31905600aaf3d8e),
    [42]: (0, $f120b340c30f26d3$export$45b92471da762af7),
    [60]: [
        (0, $0b9e2da48b68f3c9$export$17ddf85e4c916ad6),
        (0, $718f051be43549ce$export$398af27f284914fe)
    ],
    [91]: (0, $e0b3afc9eccd699c$export$5c0cee0701a3b584),
    [92]: [
        (0, $174b0bf67ca44931$export$86c573ab9e06f418),
        (0, $028c9ae6a663e8f9$export$2005478564e78d96)
    ],
    [93]: (0, $75517f76b8ed40ab$export$470a5dafbbf62654),
    [95]: (0, $f120b340c30f26d3$export$45b92471da762af7),
    [96]: (0, $a540eb9071ad7377$export$d24f93e715f9df88)
};
const $1125308a6c24c434$export$d44f260a3f9b69f5 = {
    null: [
        (0, $f120b340c30f26d3$export$45b92471da762af7),
        (0, $db742e43420ffd8f$export$50397835cbfdbc24)
    ]
};
const $1125308a6c24c434$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $1125308a6c24c434$export$e20fbacbb41798b = {
    null: []
};


function $e9a7f9214a7c16db$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $845c4ed1478b7476$export$86a865d89ef3c690)([
        $1125308a6c24c434$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $25303a4c0844eb43$export$a7db06668cad9adb)),
        document: create((0, $b426159d995f9b34$export$5a7bfc01df82fcd1)),
        flow: create((0, $ed4255c315853078$export$ccc7b0636abaffc3)),
        string: create((0, $db742e43420ffd8f$export$22b082955e083ec3)),
        text: create((0, $db742e43420ffd8f$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $7e89c312a872674d$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $9fd6ea0638b59eed$var$search = /[\0\t\n\r]/g;
function $9fd6ea0638b59eed$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = "";
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        // @ts-expect-error `Buffer` does allow an encoding.
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = "";
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $9fd6ea0638b59eed$var$search.lastIndex = startPosition;
            match = $9fd6ea0638b59eed$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $93cae3e8d344d318$export$bd0e6e1378a871d7(events) {
    while(!(0, $934548b5e713202a$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $3907134f2e72c20a$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 /* eslint-enable no-bitwise */  || // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCharCode(code);
}




const $b24137254738ca7e$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $b24137254738ca7e$export$a0fb664af7d0cc44(value) {
    return value.replace($b24137254738ca7e$var$characterEscapeOrReference, $b24137254738ca7e$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $b24137254738ca7e$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $3907134f2e72c20a$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $3b0f8de8dd9bf3d7$export$289b6a6320f709b4)($2) || $0;
}





const $66bb122f5d35c64b$var$own = {}.hasOwnProperty;
const $66bb122f5d35c64b$export$d744d789c09bfde6 = /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */ /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */ function(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $66bb122f5d35c64b$var$compiler(options)((0, $93cae3e8d344d318$export$bd0e6e1378a871d7)((0, $e9a7f9214a7c16db$export$98e6a39c04603d36)(options).document().write((0, $9fd6ea0638b59eed$export$fc37fe19dfda43ee)()(value, encoding, true))));
};
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $66bb122f5d35c64b$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $66bb122f5d35c64b$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: "root",
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($66bb122f5d35c64b$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $66bb122f5d35c64b$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $66bb122f5d35c64b$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $66bb122f5d35c64b$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === "lineEndingBlank") {
                if (event[0] === "enter") {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace") ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    listItem = {
                        type: "listItem",
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    // @ts-expect-error: `listItem` is most definitely defined, TS...
                    events.splice(index, 0, [
                        "enter",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Set data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @param {CompileData[Key]} [value]
   *   New value.
   * @returns {void}
   *   Nothing.
   */ function setData(key, value) {
        data[key] = value;
    }
    /**
   * Get data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @returns {CompileData[Key]}
   *   Value.
   */ function getData(key) {
        return data[key];
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Node} create
   *   Create a node.
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {void}
   */ function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    /**
   * @template {Node} Kind
   *   Node type.
   * @this {CompileContext}
   *   Context.
   * @param {Kind} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {Kind}
   *   The given node.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
        parent.children.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        // @ts-expect-error: `end` will be patched later.
        node.position = {
            start: $66bb122f5d35c64b$var$point(token.start)
        };
        return node;
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {Node}
   *   The closed node.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + (0, $a2a7c01371f2271b$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $66bb122f5d35c64b$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $66bb122f5d35c64b$var$point(token.end);
        return node;
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $b9ece42a41fc01d8$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        setData("expectingFirstListItemValue", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData("expectingFirstListItemValue")) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            setData("expectingFirstListItemValue");
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData("flowCodeInside")) return;
        this.buffer();
        setData("flowCodeInside", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        setData("flowCodeInside");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, "");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $e3ffbc1ff2da7d5d$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData("setextHeadingSlurpLineEnding", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        setData("setextHeadingSlurpLineEnding");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        let tail = node.children[node.children.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            // @ts-expect-error: we’ll add `end` later.
            tail.position = {
                start: $66bb122f5d35c64b$var$point(token.start)
            };
            // @ts-expect-error: Assume `parent` accepts `text`.
            node.children.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $66bb122f5d35c64b$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData("atHardBreak")) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $66bb122f5d35c64b$var$point(token.end);
            setData("atHardBreak");
            return;
        }
        if (!getData("setextHeadingSlurpLineEnding") && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        setData("atHardBreak", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $b24137254738ca7e$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $e3ffbc1ff2da7d5d$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        setData("inReference", true);
        if (node.type === "link") {
            /** @type {Array<StaticPhrasingContent>} */ // @ts-expect-error: Assume static phrasing content.
            const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        setData("inReference");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        setData("referenceType", "collapsed");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $e3ffbc1ff2da7d5d$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        setData("referenceType", "full");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = getData("characterReferenceType");
        /** @type {string} */ let value;
        if (type) {
            value = (0, $3907134f2e72c20a$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            setData("characterReferenceType");
        } else {
            const result = (0, $3b0f8de8dd9bf3d7$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $66bb122f5d35c64b$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        // @ts-expect-error `depth` will be set later.
        return {
            type: "heading",
            depth: undefined,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: "break"
        };
    }
    /** @returns {HTML} */ function html() {
        return {
            type: "html",
            value: ""
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: "text",
            value: ""
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $66bb122f5d35c64b$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Extension | Array<Extension>>} extensions
 * @returns {void}
 */ function $66bb122f5d35c64b$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $66bb122f5d35c64b$var$configure(combined, value);
        else $66bb122f5d35c64b$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {void}
 */ function $66bb122f5d35c64b$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($66bb122f5d35c64b$var$own.call(extension, key)) {
        if (key === "canContainEols") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "transforms") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "enter" || key === "exit") {
            const right = extension[key];
            if (right) Object.assign(combined[key], right);
        }
    }
}
/** @type {OnEnterError} */ function $66bb122f5d35c64b$var$defaultOnError(left, right) {
    if (left) throw new Error("Cannot close `" + left.type + "` (" + (0, $a2a7c01371f2271b$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + "): a different token (`" + right.type + "`, " + (0, $a2a7c01371f2271b$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is open");
    else throw new Error("Cannot close document, a token (`" + right.type + "`, " + (0, $a2a7c01371f2271b$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is still open");
}


function $5c41691a86fad5ee$export$2e2bcd8739ae039(options) {
    /** @type {import('unified').ParserFunction<Root>} */ const parser = (doc)=>{
        // Assume options.
        const settings = /** @type {Options} */ this.data("settings");
        return (0, $66bb122f5d35c64b$export$d744d789c09bfde6)(doc, Object.assign({}, settings, options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: this.data("micromarkExtensions") || [],
            mdastExtensions: this.data("fromMarkdownExtensions") || []
        }));
    };
    Object.assign(this, {
        Parser: parser
    });
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */ /**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Root} HastRoot
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Root} MdastRoot
 *
 * @typedef {import('./state.js').Options} Options
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 */ /**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ 
const $52cadf8c2e8aaa44$var$characterReferences = {
    '"': "quot",
    "&": "amp",
    "<": "lt",
    ">": "gt"
};
function $52cadf8c2e8aaa44$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return "&" + $52cadf8c2e8aaa44$var$characterReferences[value] + ";";
    }
}


function $d3ce3b13b8721472$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $52cadf8c2e8aaa44$export$c564cdbbe6da493)($d3ce3b13b8721472$export$e42a3e39590d28b5(url || ""));
    if (!protocol) return value;
    const colon = value.indexOf(":");
    const questionMark = value.indexOf("?");
    const numberSign = value.indexOf("#");
    const slash = value.indexOf("/");
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return "";
}
function $d3ce3b13b8721472$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = "";
        // A correct percent encoded value.
        if (code === 37 && (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = "";
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join("") + value.slice(start);
}


function $219eedda29ca8e2a$export$adb608be33961c98(state) {
    /** @type {Array<ElementContent>} */ const listItems = [];
    let index = -1;
    while(++index < state.footnoteOrder.length){
        const def = state.footnoteById[state.footnoteOrder[index]];
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $d3ce3b13b8721472$export$e42a3e39590d28b5)(id.toLowerCase());
        let referenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        while(++referenceIndex <= state.footnoteCounts[id]){
            /** @type {Element} */ const backReference = {
                type: "element",
                tagName: "a",
                properties: {
                    href: "#" + state.clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : ""),
                    dataFootnoteBackref: true,
                    className: [
                        "data-footnote-backref"
                    ],
                    ariaLabel: state.footnoteBackLabel
                },
                children: [
                    {
                        type: "text",
                        value: "\u21A9"
                    }
                ]
            };
            if (referenceIndex > 1) backReference.children.push({
                type: "element",
                tagName: "sup",
                children: [
                    {
                        type: "text",
                        value: String(referenceIndex)
                    }
                ]
            });
            if (backReferences.length > 0) backReferences.push({
                type: "text",
                value: " "
            });
            backReferences.push(backReference);
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === "element" && tail.tagName === "p") {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === "text") tailTail.value += " ";
            else tail.children.push({
                type: "text",
                value: " "
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: "element",
            tagName: "li",
            properties: {
                id: state.clobberPrefix + "fn-" + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: "element",
        tagName: "section",
        properties: {
            dataFootnotes: true,
            className: [
                "footnotes"
            ]
        },
        children: [
            {
                type: "element",
                tagName: state.footnoteLabelTagName,
                properties: {
                    // To do: use structured clone.
                    ...JSON.parse(JSON.stringify(state.footnoteLabelProperties)),
                    id: "footnote-label"
                },
                children: [
                    {
                        type: "text",
                        value: state.footnoteLabel
                    }
                ]
            },
            {
                type: "text",
                value: "\n"
            },
            {
                type: "element",
                tagName: "ol",
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: "text",
                value: "\n"
            }
        ]
    };
}


/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} MdastRoot
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 * @typedef {Extract<MdastNodes, MdastParent>} MdastParents
 *
 * @typedef EmbeddedHastFields
 *   hast fields.
 * @property {string | null | undefined} [hName]
 *   Generate a specific element with this tag name instead.
 * @property {HastProperties | null | undefined} [hProperties]
 *   Generate an element with these properties instead.
 * @property {Array<HastElementContent> | null | undefined} [hChildren]
 *   Generate an element with this content instead.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} MdastData
 *   mdast data with embedded hast fields.
 *
 * @typedef {MdastNodes & {data?: MdastData | null | undefined}} MdastNodeWithData
 *   mdast node with embedded hast data.
 *
 * @typedef PointLike
 *   Point-like value.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @typedef PositionLike
 *   Position-like value.
 * @property {PointLike | null | undefined} [start]
 *   Point-like value.
 * @property {PointLike | null | undefined} [end]
 *   Point-like value.
 *
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | null | undefined} parent
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 *   Signature of `state` for when props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {HastProperties} props
 *   Properties.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 *   Signature of `state` for when no props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @typedef HFields
 *   Info on `state`.
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {HastProperties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use from backreferences back to their footnote call.
 * @property {(identifier: string) => MdastDefinition | null} definition
 *   Definition cache.
 * @property {Record<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Record<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(from: MdastNodes, node: HastNodes) => void} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => Type | HastElement} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {(node: MdastNodes, parent: MdastParents | null | undefined) => HastElementContent | Array<HastElementContent> | null | undefined} one
 *   Transform an mdast node to hast.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastContent>(nodes: Array<Type>, loose?: boolean | null | undefined) => Array<Type | HastText>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 * @property {(left: MdastNodeWithData | PositionLike | null | undefined, right: HastElementContent) => HastElementContent} augment
 *   Like `state` but lower-level and usable on non-elements.
 *   Deprecated: use `patch` and `applyData`.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent it from
 *   *clobbering*.
 * @property {string | null | undefined} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call (affects
 *   screen readers).
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section (affects screen readers).
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (note that `id: 'footnote-label'`
 *   is always added as footnote calls use it with `aria-describedby` to
 *   provide an accessible label).
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   Tag name to use for the footnote label.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes.
 * @property {Array<string> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Handle nodes.
 *
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} State
 *   Info passed around.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * Check if `Child` can be a child of `Ancestor`.
 *
 * Returns the ancestor when `Child` can be a child of `Ancestor`, or returns
 * `never`.
 *
 * @template {Node} Ancestor
 *   Node type.
 * @template {Node} Child
 *   Node type.
 * @typedef {(
 *   Ancestor extends Parent
 *     ? Child extends Ancestor['children'][number]
 *       ? Ancestor
 *       : never
 *     : never
 * )} ParentsOf
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends Node ? number | null : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends Node ? Ancestor | null : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * Build a typed `Visitor` function from a node and all possible parents.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Visited
 *   Node type.
 * @template {Parent} Ancestor
 *   Parent type.
 * @typedef {Visitor<Visited, ParentsOf<Ancestor, Visited>>} BuildVisitorFromMatch
 */ /**
 * Build a typed `Visitor` function from a list of descendants and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     import('unist-util-visit-parents/complex-types.js').Matches<Descendant, Check>,
 *     Extract<Descendant, Parent>
 *   >
 * )} BuildVisitorFromDescendants
 */ /**
 * Build a typed `Visitor` function from a tree and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} [Tree=Node]
 *   Node type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     import('unist-util-visit-parents/complex-types.js').InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */ /**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @typedef {Record<string, unknown>} Props
 * @typedef {null | undefined | string | Props | TestFunctionAnything | Array<string | Props | TestFunctionAnything>} Test
 *   Check for an arbitrary node, unaware of TypeScript inferral.
 *
 * @callback TestFunctionAnything
 *   Check if a node passes a test, unaware of TypeScript inferral.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | void}
 *   Whether this node passes the test.
 */ /**
 * @template {Node} Kind
 *   Node type.
 * @typedef {Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind> | Array<Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind>>} PredicateTest
 *   Check for a node that can be inferred by TypeScript.
 */ /**
 * Check if a node passes a certain test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback TestFunctionPredicate
 *   Complex test function for a node that can be inferred by TypeScript.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this node passes the test.
 */ /**
 * @callback AssertAnything
 *   Check that an arbitrary value is a node, unaware of TypeScript inferral.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if a node is a node and passes a certain node test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback AssertPredicate
 *   Check that an arbitrary value is a specific node, aware of TypeScript.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @param test
 *   A check for a specific node.
 * @param index
 *   The node’s position in its parent.
 * @param parent
 *   The node’s parent.
 * @returns
 *   Whether `node` is a node and passes a test.
 */ const $6f0c7d19bfb186b2$export$226b3eccf92c9ed9 = /**
   * @type {(
   *   (() => false) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index: number, parent: Parent, context?: unknown) => node is Kind) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index?: null | undefined, parent?: null | undefined, context?: unknown) => node is Kind) &
   *   ((node: unknown, test: Test, index: number, parent: Parent, context?: unknown) => boolean) &
   *   ((node: unknown, test?: Test, index?: null | undefined, parent?: null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function is(node, test, index, parent, context) {
    const check = $6f0c7d19bfb186b2$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== "number" || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite index");
    if (parent !== undefined && parent !== null && (!is(parent) || !parent.children)) throw new Error("Expected parent node");
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error("Expected both parent and index");
    // @ts-expect-error Looks like a node.
    return node && node.type && typeof node.type === "string" ? Boolean(check.call(context, node, index, parent)) : false;
};
const $6f0c7d19bfb186b2$export$9c68d69a4c5bbcf9 = /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */ function(test) {
    if (test === undefined || test === null) return $6f0c7d19bfb186b2$var$ok;
    if (typeof test === "string") return $6f0c7d19bfb186b2$var$typeFactory(test);
    if (typeof test === "object") return Array.isArray(test) ? $6f0c7d19bfb186b2$var$anyFactory(test) : $6f0c7d19bfb186b2$var$propsFactory(test);
    if (typeof test === "function") return $6f0c7d19bfb186b2$var$castFactory(test);
    throw new Error("Expected function, string, or object as test");
};
/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */ function $6f0c7d19bfb186b2$var$anyFactory(tests) {
    /** @type {Array<AssertAnything>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $6f0c7d19bfb186b2$export$9c68d69a4c5bbcf9(tests[index]);
    return $6f0c7d19bfb186b2$var$castFactory(any);
    /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].call(this, ...parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */ function $6f0c7d19bfb186b2$var$propsFactory(check) {
    return $6f0c7d19bfb186b2$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        /** @type {string} */ let key;
        for(key in check){
            // @ts-expect-error: hush, it sure works as an index.
            if (node[key] !== check[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */ function $6f0c7d19bfb186b2$var$typeFactory(check) {
    return $6f0c7d19bfb186b2$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */ function $6f0c7d19bfb186b2$var$castFactory(check) {
    return assertion;
    /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function assertion(node, ...parameters) {
        return Boolean(node && typeof node === "object" && "type" in node && // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters)));
    }
}
function $6f0c7d19bfb186b2$var$ok() {
    return true;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $8d1201c258cbc054$export$35e9368ef982300f(d) {
    return d;
}


const $371d9ea3e9a3c1b5$export$f4d8133c446fe484 = true;
const $371d9ea3e9a3c1b5$export$7f100f842f565dc9 = false;
const $371d9ea3e9a3c1b5$export$8773f85c2fb2c116 = "skip";
const $371d9ea3e9a3c1b5$export$70008a21eb6de899 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
    }
    const is = (0, $6f0c7d19bfb186b2$export$9c68d69a4c5bbcf9)(test);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */ function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */ // @ts-expect-error: hush
        const value = node && typeof node === "object" ? node : {};
        if (typeof value.type === "string") {
            const name = // `hast`
            typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            Object.defineProperty(visit, "name", {
                value: "node (" + (0, $8d1201c258cbc054$export$35e9368ef982300f)(node.type + (name ? "<" + name + ">" : "")) + ")"
            });
        }
        return visit;
        function visit() {
            /** @type {ActionTuple} */ let result = [];
            /** @type {ActionTuple} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<Parent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $371d9ea3e9a3c1b5$var$toResult(visitor(node, parents));
                if (result[0] === $371d9ea3e9a3c1b5$export$7f100f842f565dc9) return result;
            }
            // @ts-expect-error looks like a parent.
            if (node.children && result[0] !== $371d9ea3e9a3c1b5$export$8773f85c2fb2c116) {
                // @ts-expect-error looks like a parent.
                offset = (reverse ? node.children.length : -1) + step;
                // @ts-expect-error looks like a parent.
                grandparents = parents.concat(node);
                // @ts-expect-error looks like a parent.
                while(offset > -1 && offset < node.children.length){
                    // @ts-expect-error looks like a parent.
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $371d9ea3e9a3c1b5$export$7f100f842f565dc9) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
};
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */ function $371d9ea3e9a3c1b5$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "number") return [
        $371d9ea3e9a3c1b5$export$f4d8133c446fe484,
        value
    ];
    return [
        value
    ];
}


const $c2aea4b6e52090f1$export$bf638b60ea8b89b7 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    (0, $371d9ea3e9a3c1b5$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(node, parent ? parent.children.indexOf(node) : null, parent);
    }
};


/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $3f2d203466255ecf$export$771bf3e4949bfbee = $3f2d203466255ecf$var$point("start");
const $3f2d203466255ecf$export$da309cdce9dc2a25 = $3f2d203466255ecf$var$point("end");
function $3f2d203466255ecf$export$5880b8b5730aff45(node) {
    return {
        start: $3f2d203466255ecf$export$771bf3e4949bfbee(node),
        end: $3f2d203466255ecf$export$da309cdce9dc2a25(node)
    };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $3f2d203466255ecf$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        // To do: next major: don’t return points when invalid.
        return {
            // @ts-expect-error: in practice, null is allowed.
            line: point.line || null,
            // @ts-expect-error: in practice, null is allowed.
            column: point.column || null,
            // @ts-expect-error: in practice, null is allowed.
            offset: point.offset > -1 ? point.offset : null
        };
    }
}


/**
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {PositionLike | null | undefined} [position]
 */ /**
 * Check if `node` is generated.
 *
 * @param {NodeLike | null | undefined} [node]
 *   Node to check.
 * @returns {boolean}
 *   Whether `node` is generated (does not have positional info).
 */ function $2afa62ca857a7e9f$export$41ad1363166ec91a(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Definition} Definition
 */ /**
 * @typedef {Root | Content} Node
 *
 * @callback GetDefinition
 *   Get a definition by identifier.
 * @param {string | null | undefined} [identifier]
 *   Identifier of definition.
 * @returns {Definition | null}
 *   Definition corresponding to `identifier` or `null`.
 */ 
const $d0d9f24b4d726d50$var$own = {}.hasOwnProperty;
function $d0d9f24b4d726d50$export$d79264f26953ec1(tree) {
    /** @type {Record<string, Definition>} */ const cache = Object.create(null);
    if (!tree || !tree.type) throw new Error("mdast-util-definitions expected node");
    (0, $c2aea4b6e52090f1$export$bf638b60ea8b89b7)(tree, "definition", (definition)=>{
        const id = $d0d9f24b4d726d50$var$clean(definition.identifier);
        if (id && !$d0d9f24b4d726d50$var$own.call(cache, id)) cache[id] = definition;
    });
    return definition;
    /** @type {GetDefinition} */ function definition(identifier) {
        const id = $d0d9f24b4d726d50$var$clean(identifier);
        // To do: next major: return `undefined` when not found.
        return id && $d0d9f24b4d726d50$var$own.call(cache, id) ? cache[id] : null;
    }
}
/**
 * @param {string | null | undefined} [value]
 * @returns {string}
 */ function $d0d9f24b4d726d50$var$clean(value) {
    return String(value || "").toUpperCase();
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $cfabe029e83929de$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "blockquote",
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $2c74cb56557c9a6e$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "br",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: "text",
            value: "\n"
        }
    ];
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $30d2d9b1eab8ab9b$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + "\n" : "";
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    const lang = node.lang ? node.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null;
    /** @type {Properties} */ const properties = {};
    if (lang) properties.className = [
        "language-" + lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: "element",
        tagName: "code",
        properties: properties,
        children: [
            {
                type: "text",
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: "element",
        tagName: "pre",
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $37d21debbfb82901$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "del",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $8bfaa0b4d4ea3f23$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "em",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('hast').Element} Element
 * @typedef {import('../state.js').State} State
 */ 
function $ab7ba82480196dc9$export$7f87ee744075c1ba(state, node) {
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $d3ce3b13b8721472$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    if (index === -1) {
        state.footnoteOrder.push(id);
        state.footnoteCounts[id] = 1;
        counter = state.footnoteOrder.length;
    } else {
        state.footnoteCounts[id]++;
        counter = index + 1;
    }
    const reuseCounter = state.footnoteCounts[id];
    /** @type {Element} */ const link = {
        type: "element",
        tagName: "a",
        properties: {
            href: "#" + state.clobberPrefix + "fn-" + safeId,
            id: state.clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                "footnote-label"
            ]
        },
        children: [
            {
                type: "text",
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../state.js').State} State
 */ 
function $4416a73d2f819125$export$3b6a720baa2c20ec(state, node) {
    const footnoteById = state.footnoteById;
    let no = 1;
    while(no in footnoteById)no++;
    const identifier = String(no);
    footnoteById[identifier] = {
        type: "footnoteDefinition",
        identifier: identifier,
        children: [
            {
                type: "paragraph",
                children: node.children
            }
        ],
        position: node.position
    };
    return (0, $ab7ba82480196dc9$export$7f87ee744075c1ba)(state, {
        type: "footnoteReference",
        identifier: identifier,
        position: node.position
    });
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $282cfd2582c41957$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "h" + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').HTML} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Raw | Element | null}
 *   hast node.
 */ function $45c38008b8d82e4f$export$c0bb0b647f701bb5(state, node) {
    if (state.dangerous) {
        /** @type {Raw} */ const result = {
            type: "raw",
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    // To do: next major: return `undefined`.
    return null;
}


/**
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Reference} Reference
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Reference>} References
 */ // To do: next major: always return array.
/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {References} node
 *   Reference node (image, link).
 * @returns {ElementContent | Array<ElementContent>}
 *   hast content.
 */ function $729af79e0a2617fe$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = "]";
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return {
        type: "text",
        value: "![" + node.alt + suffix
    };
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift({
        type: "text",
        value: "["
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push({
        type: "text",
        value: suffix
    });
    return contents;
}


function $f4b81a319465e6fa$export$f281796f6bc3b8db(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $729af79e0a2617fe$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $d3ce3b13b8721472$export$e42a3e39590d28b5)(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
function $8961ae6352557ffc$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $d3ce3b13b8721472$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $42eaae3cc4aa7fbc$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: "text",
        value: node.value.replace(/\r?\n|\r/g, " ")
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "code",
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 

function $3143794b7ae728d5$export$e6c469b1b7b2bc6a(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $729af79e0a2617fe$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $d3ce3b13b8721472$export$e42a3e39590d28b5)(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
function $2f940218936805af$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $d3ce3b13b8721472$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $4b8167b103eb52e7$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $4b8167b103eb52e7$var$listLoose(parent) : $4b8167b103eb52e7$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === "boolean") {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === "element" && head.tagName === "p") paragraph = head;
        else {
            paragraph = {
                type: "element",
                tagName: "p",
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: "text",
            value: " "
        });
        paragraph.children.unshift({
            type: "element",
            tagName: "input",
            properties: {
                type: "checkbox",
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            "task-list-item"
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== "element" || child.tagName !== "p") children.push({
            type: "text",
            value: "\n"
        });
        if (child.type === "element" && child.tagName === "p" && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) children.push({
        type: "text",
        value: "\n"
    });
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "li",
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $4b8167b103eb52e7$var$listLoose(node) {
    let loose = false;
    if (node.type === "list") {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $4b8167b103eb52e7$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $4b8167b103eb52e7$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $a9e4da90662a43ba$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === "number" && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
            properties.className = [
                "contains-task-list"
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: node.ordered ? "ol" : "ul",
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $754c9ceb563a146f$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "p",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastRoot | HastElement}
 *   hast node.
 */ function $6c814ba67c7f3e73$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: "root",
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $9b52d93ee5304ed9$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "strong",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
function $4d180f5a0494973d$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: "element",
            tagName: "thead",
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: "element",
            tagName: "tbody",
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $3f2d203466255ecf$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $3f2d203466255ecf$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start.line && end.line) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "table",
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $7e516a5ff7e389f2$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? "th" : "td";
    const align = parent && parent.type === "table" ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: "element",
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(node, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "tr",
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $7def995ea5484477$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "td",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ const $44fdbd04e809e473$var$tab = 9 /* `\t` */ ;
const $44fdbd04e809e473$var$space = 32 /* ` ` */ ;
function $44fdbd04e809e473$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($44fdbd04e809e473$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($44fdbd04e809e473$var$trimLine(source.slice(last), last > 0, false));
    return lines.join("");
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $44fdbd04e809e473$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $44fdbd04e809e473$var$tab || code === $44fdbd04e809e473$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $44fdbd04e809e473$var$tab || code === $44fdbd04e809e473$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}


function $cd26dde082a2829b$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: "text",
        value: (0, $44fdbd04e809e473$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $edebaf778006e7d1$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "hr",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $a0dc1a8f6c20ae52$export$455ce229eb3d2472 = {
    blockquote: $cfabe029e83929de$export$67dc04e652a298ca,
    break: (0, $2c74cb56557c9a6e$export$371da9dd35aba193),
    code: $30d2d9b1eab8ab9b$export$6565f9f03506010b,
    delete: (0, $37d21debbfb82901$export$19426ff118fe8be),
    emphasis: $8bfaa0b4d4ea3f23$export$bef81ba411953b51,
    footnoteReference: $ab7ba82480196dc9$export$7f87ee744075c1ba,
    footnote: $4416a73d2f819125$export$3b6a720baa2c20ec,
    heading: $282cfd2582c41957$export$46e4a324ac90507f,
    html: $45c38008b8d82e4f$export$c0bb0b647f701bb5,
    imageReference: $f4b81a319465e6fa$export$f281796f6bc3b8db,
    image: $8961ae6352557ffc$export$5c452ff88e35e47d,
    inlineCode: $42eaae3cc4aa7fbc$export$91b9bee19a0d8569,
    linkReference: $3143794b7ae728d5$export$e6c469b1b7b2bc6a,
    link: $2f940218936805af$export$9c30223ca0a664fb,
    listItem: $4b8167b103eb52e7$export$76c7e83ecc9cdf05,
    list: $a9e4da90662a43ba$export$8837f4fc672e936d,
    paragraph: $754c9ceb563a146f$export$9c206ddddb32a9b,
    root: $6c814ba67c7f3e73$export$e8e78c978b129247,
    strong: $9b52d93ee5304ed9$export$59ae2c325a998f89,
    table: $4d180f5a0494973d$export$9852986a3ec5f6a0,
    tableCell: $7def995ea5484477$export$e1e720e5f4603e6a,
    tableRow: $7e516a5ff7e389f2$export$ce666bf02318c957,
    text: $cd26dde082a2829b$export$6f093cfa640b7166,
    thematicBreak: $edebaf778006e7d1$export$ba7b13e047416c03,
    toml: $a0dc1a8f6c20ae52$var$ignore,
    yaml: $a0dc1a8f6c20ae52$var$ignore,
    definition: $a0dc1a8f6c20ae52$var$ignore,
    footnoteDefinition: $a0dc1a8f6c20ae52$var$ignore
};
// Return nothing for nodes that are ignored.
function $a0dc1a8f6c20ae52$var$ignore() {
    // To do: next major: return `undefined`.
    return null;
}


const $d4a3b516413b2908$var$own = {}.hasOwnProperty;
function $d4a3b516413b2908$export$e6a0daad8304de(tree, options) {
    const settings = options || {};
    const dangerous = settings.allowDangerousHtml || false;
    /** @type {Record<string, MdastFootnoteDefinition>} */ const footnoteById = {};
    // To do: next major: add `options` to state, remove:
    // `dangerous`, `clobberPrefix`, `footnoteLabel`, `footnoteLabelTagName`,
    // `footnoteLabelProperties`, `footnoteBackLabel`, `passThrough`,
    // `unknownHandler`.
    // To do: next major: move to `state.options.allowDangerousHtml`.
    state.dangerous = dangerous;
    // To do: next major: move to `state.options`.
    state.clobberPrefix = settings.clobberPrefix === undefined || settings.clobberPrefix === null ? "user-content-" : settings.clobberPrefix;
    // To do: next major: move to `state.options`.
    state.footnoteLabel = settings.footnoteLabel || "Footnotes";
    // To do: next major: move to `state.options`.
    state.footnoteLabelTagName = settings.footnoteLabelTagName || "h2";
    // To do: next major: move to `state.options`.
    state.footnoteLabelProperties = settings.footnoteLabelProperties || {
        className: [
            "sr-only"
        ]
    };
    // To do: next major: move to `state.options`.
    state.footnoteBackLabel = settings.footnoteBackLabel || "Back to content";
    // To do: next major: move to `state.options`.
    state.unknownHandler = settings.unknownHandler;
    // To do: next major: move to `state.options`.
    state.passThrough = settings.passThrough;
    state.handlers = {
        ...(0, $a0dc1a8f6c20ae52$export$455ce229eb3d2472),
        ...settings.handlers
    };
    // To do: next major: replace utility with `definitionById` object, so we
    // only walk once (as we need footnotes too).
    state.definition = (0, $d0d9f24b4d726d50$export$d79264f26953ec1)(tree);
    state.footnoteById = footnoteById;
    /** @type {Array<string>} */ state.footnoteOrder = [];
    /** @type {Record<string, number>} */ state.footnoteCounts = {};
    state.patch = $d4a3b516413b2908$var$patch;
    state.applyData = $d4a3b516413b2908$var$applyData;
    state.one = oneBound;
    state.all = allBound;
    state.wrap = $d4a3b516413b2908$export$4997ffc0176396a6;
    // To do: next major: remove `augment`.
    state.augment = augment;
    (0, $c2aea4b6e52090f1$export$bf638b60ea8b89b7)(tree, "footnoteDefinition", (definition)=>{
        const id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$d4a3b516413b2908$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    });
    // @ts-expect-error Hush, it’s fine!
    return state;
    /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {MdastNodeWithData | PositionLike | null | undefined} left
   * @param {HastElementContent} right
   * @returns {HastElementContent}
   */ /* c8 ignore start */ // To do: next major: remove.
    function augment(left, right) {
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && "data" in left && left.data) {
            /** @type {MdastData} */ const data = left.data;
            if (data.hName) {
                if (right.type !== "element") right = {
                    type: "element",
                    tagName: "",
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === "element" && data.hProperties) right.properties = {
                ...right.properties,
                ...data.hProperties
            };
            if ("children" in right && right.children && data.hChildren) right.children = data.hChildren;
        }
        if (left) {
            const ctx = "type" in left ? left : {
                position: left
            };
            if (!(0, $2afa62ca857a7e9f$export$41ad1363166ec91a)(ctx)) // @ts-expect-error: fine.
            right.position = {
                start: (0, $3f2d203466255ecf$export$771bf3e4949bfbee)(ctx),
                end: (0, $3f2d203466255ecf$export$da309cdce9dc2a25)(ctx)
            };
        }
        return right;
    }
    /* c8 ignore stop */ /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */ /* c8 ignore start */ // To do: next major: remove.
    function state(node, tagName, props, children) {
        if (Array.isArray(props)) {
            children = props;
            props = {};
        }
        // @ts-expect-error augmenting an element yields an element.
        return augment(node, {
            type: "element",
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    /* c8 ignore stop */ /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | null | undefined} [parent]
   *   Parent of `node`.
   * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
   *   Resulting hast node.
   */ function oneBound(node, parent) {
        // @ts-expect-error: that’s a state :)
        return $d4a3b516413b2908$export$80bf7733f1207381(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function allBound(parent) {
        // @ts-expect-error: that’s a state :)
        return $d4a3b516413b2908$export$84bf76cd7afc7469(state, parent);
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {void}
 *   Nothing.
 */ function $d4a3b516413b2908$var$patch(from, to) {
    if (from.position) to.position = (0, $3f2d203466255ecf$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {Type | HastElement}
 *   Nothing.
 */ function $d4a3b516413b2908$var$applyData(from, to) {
    /** @type {Type | HastElement} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === "string") {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === "element") result.tagName = hName;
            else result = {
                type: "element",
                tagName: hName,
                properties: {},
                children: []
            };
        }
        if (result.type === "element" && hProperties) result.properties = {
            ...result.properties,
            ...hProperties
        };
        if ("children" in result && result.children && hChildren !== null && hChildren !== undefined) // @ts-expect-error: assume valid children are defined.
        result.children = hChildren;
    }
    return result;
}
function $d4a3b516413b2908$export$80bf7733f1207381(state, node, parent) {
    const type = node && node.type;
    // Fail on non-nodes.
    if (!type) throw new Error("Expected node, got `" + node + "`");
    if ($d4a3b516413b2908$var$own.call(state.handlers, type)) return state.handlers[type](state, node, parent);
    if (state.passThrough && state.passThrough.includes(type)) // To do: next major: deep clone.
    // @ts-expect-error: types of passed through nodes are expected to be added manually.
    return "children" in node ? {
        ...node,
        children: $d4a3b516413b2908$export$84bf76cd7afc7469(state, node)
    } : node;
    if (state.unknownHandler) return state.unknownHandler(state, node, parent);
    return $d4a3b516413b2908$var$defaultUnknownHandler(state, node);
}
function $d4a3b516413b2908$export$84bf76cd7afc7469(state, parent) {
    /** @type {Array<HastElementContent>} */ const values = [];
    if ("children" in parent) {
        const nodes = parent.children;
        let index = -1;
        while(++index < nodes.length){
            const result = $d4a3b516413b2908$export$80bf7733f1207381(state, nodes[index], parent);
            // To do: see if we van clean this? Can we merge texts?
            if (result) {
                if (index && nodes[index - 1].type === "break") {
                    if (!Array.isArray(result) && result.type === "text") result.value = result.value.replace(/^\s+/, "");
                    if (!Array.isArray(result) && result.type === "element") {
                        const head = result.children[0];
                        if (head && head.type === "text") head.value = head.value.replace(/^\s+/, "");
                    }
                }
                if (Array.isArray(result)) values.push(...result);
                else values.push(result);
            }
        }
    }
    return values;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastText | HastElement}
 *   Resulting hast node.
 */ function $d4a3b516413b2908$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastText | HastElement} */ const result = "value" in node && !($d4a3b516413b2908$var$own.call(data, "hProperties") || $d4a3b516413b2908$var$own.call(data, "hChildren")) ? {
        type: "text",
        value: node.value
    } : {
        type: "element",
        tagName: "div",
        properties: {},
        children: $d4a3b516413b2908$export$84bf76cd7afc7469(state, node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $d4a3b516413b2908$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<Type | HastText>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: "text",
        value: "\n"
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: "text",
            value: "\n"
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: "text",
        value: "\n"
    });
    return result;
}


function $159f48ae505a53bf$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $d4a3b516413b2908$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, null);
    const foot = (0, $219eedda29ca8e2a$export$adb608be33961c98)(state);
    if (foot) // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push({
        type: "text",
        value: "\n"
    }, foot);
    // To do: next major: always return root?
    return Array.isArray(node) ? {
        type: "root",
        children: node
    } : node;
}


// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(
/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */ const $b146722a21ae9bd5$var$remarkRehype = /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */ function(destination, options) {
    return destination && "run" in destination ? $b146722a21ae9bd5$var$bridge(destination, options) : $b146722a21ae9bd5$var$mutate(destination || options);
};
var $b146722a21ae9bd5$export$2e2bcd8739ae039 = $b146722a21ae9bd5$var$remarkRehype;
/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */ function $b146722a21ae9bd5$var$bridge(destination, options) {
    return (node, file, next)=>{
        destination.run((0, $159f48ae505a53bf$export$c0e4c5cf07538633)(node, options), file, (error)=>{
            next(error);
        });
    };
}
/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */ function $b146722a21ae9bd5$var$mutate(options) {
    // @ts-expect-error: assume a corresponding node is returned by `toHast`.
    return (node)=>(0, $159f48ae505a53bf$export$c0e4c5cf07538633)(node, options);
}



var $2TkGT = parcelRequire("2TkGT");
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $f325308b3beb0d03$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $f325308b3beb0d03$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $f325308b3beb0d03$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $f325308b3beb0d03$export$19342e026b58ebb7.prototype.space = null;


function $1cf5b6ea156f13b8$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $f325308b3beb0d03$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $13d7c4c1d69579da$export$a3295358bff77e(value) {
    return value.toLowerCase();
}



class $a9267f10ab7ea8be$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $a9267f10ab7ea8be$export$c4868e4a24d48fad.prototype.space = null;
$a9267f10ab7ea8be$export$c4868e4a24d48fad.prototype.boolean = false;
$a9267f10ab7ea8be$export$c4868e4a24d48fad.prototype.booleanish = false;
$a9267f10ab7ea8be$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$a9267f10ab7ea8be$export$c4868e4a24d48fad.prototype.number = false;
$a9267f10ab7ea8be$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$a9267f10ab7ea8be$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$a9267f10ab7ea8be$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$a9267f10ab7ea8be$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$a9267f10ab7ea8be$export$c4868e4a24d48fad.prototype.defined = false;


var $8083207e477f103b$exports = {};

$parcel$export($8083207e477f103b$exports, "boolean", () => $8083207e477f103b$export$4a21f16c33752377);
$parcel$export($8083207e477f103b$exports, "booleanish", () => $8083207e477f103b$export$55e9e1fbc638dc8f);
$parcel$export($8083207e477f103b$exports, "overloadedBoolean", () => $8083207e477f103b$export$242ac3d3042558aa);
$parcel$export($8083207e477f103b$exports, "number", () => $8083207e477f103b$export$98e628dec113755e);
$parcel$export($8083207e477f103b$exports, "spaceSeparated", () => $8083207e477f103b$export$ab8645c862eb5a3e);
$parcel$export($8083207e477f103b$exports, "commaSeparated", () => $8083207e477f103b$export$9c8d678629b3d3);
$parcel$export($8083207e477f103b$exports, "commaOrSpaceSeparated", () => $8083207e477f103b$export$2ad25cfebf36cacd);
let $8083207e477f103b$var$powers = 0;
const $8083207e477f103b$export$4a21f16c33752377 = $8083207e477f103b$var$increment();
const $8083207e477f103b$export$55e9e1fbc638dc8f = $8083207e477f103b$var$increment();
const $8083207e477f103b$export$242ac3d3042558aa = $8083207e477f103b$var$increment();
const $8083207e477f103b$export$98e628dec113755e = $8083207e477f103b$var$increment();
const $8083207e477f103b$export$ab8645c862eb5a3e = $8083207e477f103b$var$increment();
const $8083207e477f103b$export$9c8d678629b3d3 = $8083207e477f103b$var$increment();
const $8083207e477f103b$export$2ad25cfebf36cacd = $8083207e477f103b$var$increment();
function $8083207e477f103b$var$increment() {
    return 2 ** ++$8083207e477f103b$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $26f5759d8ecfa4ef$var$checks = Object.keys($8083207e477f103b$exports);
class $26f5759d8ecfa4ef$export$ea6b9f0064e88c9b extends (0, $a9267f10ab7ea8be$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $26f5759d8ecfa4ef$var$mark(this, "space", space);
        if (typeof mask === "number") while(++index < $26f5759d8ecfa4ef$var$checks.length){
            const check = $26f5759d8ecfa4ef$var$checks[index];
            $26f5759d8ecfa4ef$var$mark(this, $26f5759d8ecfa4ef$var$checks[index], (mask & $8083207e477f103b$exports[check]) === $8083207e477f103b$exports[check]);
        }
    }
}
$26f5759d8ecfa4ef$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $26f5759d8ecfa4ef$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}


const $bacea0595f8953a6$var$own = {}.hasOwnProperty;
function $bacea0595f8953a6$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($bacea0595f8953a6$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $26f5759d8ecfa4ef$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $13d7c4c1d69579da$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $13d7c4c1d69579da$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $f325308b3beb0d03$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $a8f51f25d1f95d34$export$2bd1230ec7600845 = (0, $bacea0595f8953a6$export$185802fd694ee1f5)({
    space: "xlink",
    transform (_, prop) {
        return "xlink:" + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $6fb106d77ab7a483$export$f2913fe8983302e = (0, $bacea0595f8953a6$export$185802fd694ee1f5)({
    space: "xml",
    transform (_, prop) {
        return "xml:" + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $7b1b956ee1999b87$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $529e01a05202ed7c$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $7b1b956ee1999b87$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $90752402b241d2b9$export$e20c24a128671213 = (0, $bacea0595f8953a6$export$185802fd694ee1f5)({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: (0, $529e01a05202ed7c$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $1094ae15831ae621$export$4d2d26490572750a = (0, $bacea0595f8953a6$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $8083207e477f103b$export$98e628dec113755e),
        ariaColIndex: (0, $8083207e477f103b$export$98e628dec113755e),
        ariaColSpan: (0, $8083207e477f103b$export$98e628dec113755e),
        ariaControls: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        ariaLevel: (0, $8083207e477f103b$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $8083207e477f103b$export$98e628dec113755e),
        ariaPressed: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $8083207e477f103b$export$98e628dec113755e),
        ariaRowIndex: (0, $8083207e477f103b$export$98e628dec113755e),
        ariaRowSpan: (0, $8083207e477f103b$export$98e628dec113755e),
        ariaSelected: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $8083207e477f103b$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $8083207e477f103b$export$98e628dec113755e),
        ariaValueMin: (0, $8083207e477f103b$export$98e628dec113755e),
        ariaValueNow: (0, $8083207e477f103b$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $064ad904da64dfa2$export$c0bb0b647f701bb5 = (0, $bacea0595f8953a6$export$185802fd694ee1f5)({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: (0, $529e01a05202ed7c$export$32b9e4cec9c208e1),
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $8083207e477f103b$export$9c8d678629b3d3),
        acceptCharset: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        accessKey: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $8083207e477f103b$export$4a21f16c33752377),
        allowPaymentRequest: (0, $8083207e477f103b$export$4a21f16c33752377),
        allowUserMedia: (0, $8083207e477f103b$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $8083207e477f103b$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        autoFocus: (0, $8083207e477f103b$export$4a21f16c33752377),
        autoPlay: (0, $8083207e477f103b$export$4a21f16c33752377),
        blocking: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $8083207e477f103b$export$4a21f16c33752377),
        cite: null,
        className: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        cols: (0, $8083207e477f103b$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        controls: (0, $8083207e477f103b$export$4a21f16c33752377),
        controlsList: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        coords: (0, $8083207e477f103b$export$98e628dec113755e) | (0, $8083207e477f103b$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $8083207e477f103b$export$4a21f16c33752377),
        defer: (0, $8083207e477f103b$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $8083207e477f103b$export$4a21f16c33752377),
        download: (0, $8083207e477f103b$export$242ac3d3042558aa),
        draggable: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $8083207e477f103b$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        height: (0, $8083207e477f103b$export$98e628dec113755e),
        hidden: (0, $8083207e477f103b$export$4a21f16c33752377),
        high: (0, $8083207e477f103b$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        httpEquiv: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $8083207e477f103b$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $8083207e477f103b$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        itemRef: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        itemScope: (0, $8083207e477f103b$export$4a21f16c33752377),
        itemType: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $8083207e477f103b$export$4a21f16c33752377),
        low: (0, $8083207e477f103b$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $8083207e477f103b$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $8083207e477f103b$export$98e628dec113755e),
        multiple: (0, $8083207e477f103b$export$4a21f16c33752377),
        muted: (0, $8083207e477f103b$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $8083207e477f103b$export$4a21f16c33752377),
        noValidate: (0, $8083207e477f103b$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $8083207e477f103b$export$4a21f16c33752377),
        optimum: (0, $8083207e477f103b$export$98e628dec113755e),
        pattern: null,
        ping: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $8083207e477f103b$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $8083207e477f103b$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        required: (0, $8083207e477f103b$export$4a21f16c33752377),
        reversed: (0, $8083207e477f103b$export$4a21f16c33752377),
        rows: (0, $8083207e477f103b$export$98e628dec113755e),
        rowSpan: (0, $8083207e477f103b$export$98e628dec113755e),
        sandbox: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $8083207e477f103b$export$4a21f16c33752377),
        seamless: (0, $8083207e477f103b$export$4a21f16c33752377),
        selected: (0, $8083207e477f103b$export$4a21f16c33752377),
        shadowRootClonable: (0, $8083207e477f103b$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $8083207e477f103b$export$4a21f16c33752377),
        shadowRootMode: null,
        shape: null,
        size: (0, $8083207e477f103b$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $8083207e477f103b$export$98e628dec113755e),
        spellCheck: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $8083207e477f103b$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $8083207e477f103b$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $8083207e477f103b$export$4a21f16c33752377),
        useMap: null,
        value: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        width: (0, $8083207e477f103b$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $8083207e477f103b$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $8083207e477f103b$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $8083207e477f103b$export$4a21f16c33752377),
        declare: (0, $8083207e477f103b$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $8083207e477f103b$export$98e628dec113755e),
        leftMargin: (0, $8083207e477f103b$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $8083207e477f103b$export$98e628dec113755e),
        marginWidth: (0, $8083207e477f103b$export$98e628dec113755e),
        noResize: (0, $8083207e477f103b$export$4a21f16c33752377),
        noHref: (0, $8083207e477f103b$export$4a21f16c33752377),
        noShade: (0, $8083207e477f103b$export$4a21f16c33752377),
        noWrap: (0, $8083207e477f103b$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $8083207e477f103b$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $8083207e477f103b$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $8083207e477f103b$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $8083207e477f103b$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $8083207e477f103b$export$4a21f16c33752377),
        disableRemotePlayback: (0, $8083207e477f103b$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $8083207e477f103b$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $f8f2b96b49bd748f$export$7ed1367e7fa1ad68 = (0, $bacea0595f8953a6$export$185802fd694ee1f5)({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        transformOrigin: "transform-origin",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: (0, $7b1b956ee1999b87$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $8083207e477f103b$export$2ad25cfebf36cacd),
        accentHeight: (0, $8083207e477f103b$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $8083207e477f103b$export$98e628dec113755e),
        amplitude: (0, $8083207e477f103b$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $8083207e477f103b$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $8083207e477f103b$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $8083207e477f103b$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $8083207e477f103b$export$98e628dec113755e),
        className: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $8083207e477f103b$export$98e628dec113755e),
        diffuseConstant: (0, $8083207e477f103b$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $8083207e477f103b$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $8083207e477f103b$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $8083207e477f103b$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $8083207e477f103b$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $8083207e477f103b$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $8083207e477f103b$export$9c8d678629b3d3),
        g2: (0, $8083207e477f103b$export$9c8d678629b3d3),
        glyphName: (0, $8083207e477f103b$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $8083207e477f103b$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $8083207e477f103b$export$98e628dec113755e),
        horizOriginX: (0, $8083207e477f103b$export$98e628dec113755e),
        horizOriginY: (0, $8083207e477f103b$export$98e628dec113755e),
        id: null,
        ideographic: (0, $8083207e477f103b$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $8083207e477f103b$export$98e628dec113755e),
        k: (0, $8083207e477f103b$export$98e628dec113755e),
        k1: (0, $8083207e477f103b$export$98e628dec113755e),
        k2: (0, $8083207e477f103b$export$98e628dec113755e),
        k3: (0, $8083207e477f103b$export$98e628dec113755e),
        k4: (0, $8083207e477f103b$export$98e628dec113755e),
        kernelMatrix: (0, $8083207e477f103b$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $8083207e477f103b$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $8083207e477f103b$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $8083207e477f103b$export$98e628dec113755e),
        overlineThickness: (0, $8083207e477f103b$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $8083207e477f103b$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $8083207e477f103b$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $8083207e477f103b$export$98e628dec113755e),
        pointsAtY: (0, $8083207e477f103b$export$98e628dec113755e),
        pointsAtZ: (0, $8083207e477f103b$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $8083207e477f103b$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $8083207e477f103b$export$2ad25cfebf36cacd),
        rev: (0, $8083207e477f103b$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $8083207e477f103b$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $8083207e477f103b$export$2ad25cfebf36cacd),
        requiredFonts: (0, $8083207e477f103b$export$2ad25cfebf36cacd),
        requiredFormats: (0, $8083207e477f103b$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $8083207e477f103b$export$98e628dec113755e),
        specularExponent: (0, $8083207e477f103b$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $8083207e477f103b$export$98e628dec113755e),
        strikethroughThickness: (0, $8083207e477f103b$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $8083207e477f103b$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $8083207e477f103b$export$98e628dec113755e),
        strokeOpacity: (0, $8083207e477f103b$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $8083207e477f103b$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $8083207e477f103b$export$2ad25cfebf36cacd),
        tabIndex: (0, $8083207e477f103b$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $8083207e477f103b$export$98e628dec113755e),
        targetY: (0, $8083207e477f103b$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $8083207e477f103b$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $8083207e477f103b$export$98e628dec113755e),
        underlineThickness: (0, $8083207e477f103b$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $8083207e477f103b$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $8083207e477f103b$export$98e628dec113755e),
        vMathematical: (0, $8083207e477f103b$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $8083207e477f103b$export$98e628dec113755e),
        vIdeographic: (0, $8083207e477f103b$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $8083207e477f103b$export$98e628dec113755e),
        vertOriginX: (0, $8083207e477f103b$export$98e628dec113755e),
        vertOriginY: (0, $8083207e477f103b$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $8083207e477f103b$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ 


const $d0176375645c5b16$var$valid = /^data[-\w.:]+$/i;
const $d0176375645c5b16$var$dash = /-[a-z]/g;
const $d0176375645c5b16$var$cap = /[A-Z]/g;
function $d0176375645c5b16$export$71aa6c912b956294(schema, value) {
    const normal = (0, $13d7c4c1d69579da$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $a9267f10ab7ea8be$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === "data" && $d0176375645c5b16$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") {
            // Turn it into a property.
            const rest = value.slice(5).replace($d0176375645c5b16$var$dash, $d0176375645c5b16$var$camelcase);
            prop = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$d0176375645c5b16$var$dash.test(rest)) {
                let dashes = rest.replace($d0176375645c5b16$var$cap, $d0176375645c5b16$var$kebab);
                if (dashes.charAt(0) !== "-") dashes = "-" + dashes;
                value = "data" + dashes;
            }
        }
        Type = (0, $26f5759d8ecfa4ef$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $d0176375645c5b16$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $d0176375645c5b16$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}


/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $c5608189dbc8e1b1$export$d8abd7e5fb6871f9 = {
    classId: "classID",
    dataType: "datatype",
    itemId: "itemID",
    strokeDashArray: "strokeDasharray",
    strokeDashOffset: "strokeDashoffset",
    strokeLineCap: "strokeLinecap",
    strokeLineJoin: "strokeLinejoin",
    strokeMiterLimit: "strokeMiterlimit",
    typeOf: "typeof",
    xLinkActuate: "xlinkActuate",
    xLinkArcRole: "xlinkArcrole",
    xLinkHref: "xlinkHref",
    xLinkRole: "xlinkRole",
    xLinkShow: "xlinkShow",
    xLinkTitle: "xlinkTitle",
    xLinkType: "xlinkType",
    xmlnsXLink: "xmlnsXlink"
};



const $18964ceaa117e6f2$export$c0bb0b647f701bb5 = (0, $1cf5b6ea156f13b8$export$4950aa0f605343fb)([
    (0, $6fb106d77ab7a483$export$f2913fe8983302e),
    (0, $a8f51f25d1f95d34$export$2bd1230ec7600845),
    (0, $90752402b241d2b9$export$e20c24a128671213),
    (0, $1094ae15831ae621$export$4d2d26490572750a),
    (0, $064ad904da64dfa2$export$c0bb0b647f701bb5)
], "html");
const $18964ceaa117e6f2$export$7ed1367e7fa1ad68 = (0, $1cf5b6ea156f13b8$export$4950aa0f605343fb)([
    (0, $6fb106d77ab7a483$export$f2913fe8983302e),
    (0, $a8f51f25d1f95d34$export$2bd1230ec7600845),
    (0, $90752402b241d2b9$export$e20c24a128671213),
    (0, $1094ae15831ae621$export$4d2d26490572750a),
    (0, $f8f2b96b49bd748f$export$7ed1367e7fa1ad68)
], "svg");



function $d85e3057ed017e8b$export$2e2bcd8739ae039(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError("Only one of `allowedElements` and `disallowedElements` should be defined");
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        (0, $c2aea4b6e52090f1$export$bf638b60ea8b89b7)(tree, "element", (node, index, parent_)=>{
            const parent = /** @type {Element|Root} */ parent_;
            /** @type {boolean|undefined} */ let remove;
            if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
            else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
            if (!remove && options.allowElement && typeof index === "number") remove = !options.allowElement(node, index, parent);
            if (remove && typeof index === "number") {
                if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
            return undefined;
        });
    };
}


/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */ /**
 * @template {import('react').ElementType} T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */ /**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types.js').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'td'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: false}} TableDataCellProps
 * @typedef {ComponentPropsWithoutRef<'th'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: true}} TableHeaderCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableDataCellProps>} TableDataCellComponent
 * @typedef {ComponentType<TableHeaderCellProps>} TableHeaderCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableDataCellComponent|ReactMarkdownNames} td
 * @property {TableHeaderCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types.js').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ 
var $1EuC8 = parcelRequire("1EuC8");

var $7xTXF = parcelRequire("7xTXF");
/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {unknown} thing
 *   Thing to check (typically `Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`).
 *   If a node is passed it must be a `Text` node, whose `value` field is
 *   checked.
 */ function $d1815b3fe7b53575$export$7af1228ff777d175(thing) {
    /** @type {string} */ const value = // @ts-expect-error looks like a node.
    thing && typeof thing === "object" && thing.type === "text" ? thing.value || "" : thing;
    // HTML whitespace expression.
    // See <https://infra.spec.whatwg.org/#ascii-whitespace>.
    return typeof value === "string" && value.replace(/[ \t\n\f\r]/g, "") === "";
}



/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $78a983f075722656$export$98e6a39c04603d36(value) {
    const input = String(value || "").trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $78a983f075722656$export$fac44ee5b035f737(values) {
    return values.join(" ").trim();
}


/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $113922d5c9905d28$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || "");
    let index = input.indexOf(",");
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(",", start);
    }
    return tokens;
}
function $113922d5c9905d28$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === "" ? [
        ...values,
        ""
    ] : values;
    return input.join((settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")).trim();
}


var $8fcec900a158166d$exports = {};
var $b750244ffcc389b9$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $b750244ffcc389b9$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $b750244ffcc389b9$var$NEWLINE_REGEX = /\n/g;
var $b750244ffcc389b9$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $b750244ffcc389b9$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $b750244ffcc389b9$var$COLON_REGEX = /^:\s*/;
var $b750244ffcc389b9$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $b750244ffcc389b9$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $b750244ffcc389b9$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $b750244ffcc389b9$var$NEWLINE = "\n";
var $b750244ffcc389b9$var$FORWARD_SLASH = "/";
var $b750244ffcc389b9$var$ASTERISK = "*";
var $b750244ffcc389b9$var$EMPTY_STRING = "";
// types
var $b750244ffcc389b9$var$TYPE_COMMENT = "comment";
var $b750244ffcc389b9$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $b750244ffcc389b9$exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($b750244ffcc389b9$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($b750244ffcc389b9$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($b750244ffcc389b9$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($b750244ffcc389b9$var$FORWARD_SLASH != style.charAt(0) || $b750244ffcc389b9$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($b750244ffcc389b9$var$EMPTY_STRING != style.charAt(i) && ($b750244ffcc389b9$var$ASTERISK != style.charAt(i) || $b750244ffcc389b9$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($b750244ffcc389b9$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $b750244ffcc389b9$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($b750244ffcc389b9$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($b750244ffcc389b9$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($b750244ffcc389b9$var$VALUE_REGEX);
        var ret = pos({
            type: $b750244ffcc389b9$var$TYPE_DECLARATION,
            property: $b750244ffcc389b9$var$trim(prop[0].replace($b750244ffcc389b9$var$COMMENT_REGEX, $b750244ffcc389b9$var$EMPTY_STRING)),
            value: val ? $b750244ffcc389b9$var$trim(val[0].replace($b750244ffcc389b9$var$COMMENT_REGEX, $b750244ffcc389b9$var$EMPTY_STRING)) : $b750244ffcc389b9$var$EMPTY_STRING
        });
        // ;
        match($b750244ffcc389b9$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $b750244ffcc389b9$var$trim(str) {
    return str ? str.replace($b750244ffcc389b9$var$TRIM_REGEX, $b750244ffcc389b9$var$EMPTY_STRING) : $b750244ffcc389b9$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $8fcec900a158166d$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $b750244ffcc389b9$exports(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$8fcec900a158166d$exports = $8fcec900a158166d$var$StyleToObject;
$8fcec900a158166d$exports.default = $8fcec900a158166d$var$StyleToObject; // ESM support


var $0b11d0faa493e76f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8fcec900a158166d$exports)));


const $8f425a4355b5fa39$var$protocols = [
    "http",
    "https",
    "mailto",
    "tel"
];
function $8f425a4355b5fa39$export$b83532a10e2e268b(uri) {
    const url = (uri || "").trim();
    const first = url.charAt(0);
    if (first === "#" || first === "/") return url;
    const colon = url.indexOf(":");
    if (colon === -1) return url;
    let index = -1;
    while(++index < $8f425a4355b5fa39$var$protocols.length){
        const protocol = $8f425a4355b5fa39$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf("?");
    if (index !== -1 && colon > index) return url;
    index = url.indexOf("#");
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return "javascript:void(0)";
}


const $9acf91d1ffa48bc7$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $9acf91d1ffa48bc7$var$tableElements = new Set([
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr"
]);
function $9acf91d1ffa48bc7$export$4b745c302603ab5d(context, node) {
    /** @type {Array<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === "element") children.push($9acf91d1ffa48bc7$var$toReact(context, child, childIndex, node));
        else if (child.type === "text") // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we drop it.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        // See: <https://github.com/remarkjs/react-markdown/issues/576>.
        {
            if (node.type !== "element" || !$9acf91d1ffa48bc7$var$tableElements.has(node.tagName) || !(0, $d1815b3fe7b53575$export$7af1228ff777d175)(child)) children.push(child.value);
        } else if (child.type === "raw" && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $9acf91d1ffa48bc7$var$toReact(context, node, index, parent) {
    const options = context.options;
    const transform = options.transformLinkUri === undefined ? (0, $8f425a4355b5fa39$export$b83532a10e2e268b) : options.transformLinkUri;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Record<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === "html" && name === "svg") {
        schema = (0, $18964ceaa117e6f2$export$7ed1367e7fa1ad68);
        context.schema = schema;
    }
    if (node.properties) {
        for(property in node.properties)if ($9acf91d1ffa48bc7$var$own.call(node.properties, property)) $9acf91d1ffa48bc7$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === "ol" || name === "ul") context.listDepth++;
    const children = $9acf91d1ffa48bc7$export$4b745c302603ab5d(context, node);
    if (name === "ol" || name === "ul") context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the position interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $9acf91d1ffa48bc7$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === "string" || component === (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).Fragment;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($7xTXF))).isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = index;
    if (name === "a" && options.linkTarget) properties.target = typeof options.linkTarget === "function" ? options.linkTarget(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null) : options.linkTarget;
    if (name === "a" && transform) properties.href = transform(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "code" && parent.type === "element" && parent.tagName !== "pre") properties.inline = true;
    if (!basic && (name === "h1" || name === "h2" || name === "h3" || name === "h4" || name === "h5" || name === "h6")) properties.level = Number.parseInt(name.charAt(1), 10);
    if (name === "img" && options.transformImageUri) properties.src = options.transformImageUri(String(properties.src || ""), String(properties.alt || ""), typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "li" && parent.type === "element") {
        const input = $9acf91d1ffa48bc7$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $9acf91d1ffa48bc7$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === "ol";
    }
    if (!basic && (name === "ol" || name === "ul")) {
        properties.ordered = name === "ol";
        properties.depth = context.listDepth;
    }
    if (name === "td" || name === "th") {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === "th";
    }
    if (!basic && name === "tr" && parent.type === "element") properties.isHeader = Boolean(parent.tagName === "thead");
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties["data-sourcepos"] = $9acf91d1ffa48bc7$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $9acf91d1ffa48bc7$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $9acf91d1ffa48bc7$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).createElement(component, properties, children) : (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $9acf91d1ffa48bc7$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === "element" && child.tagName === "input") return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $9acf91d1ffa48bc7$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === "element") count++;
    }
    return count;
}
/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $9acf91d1ffa48bc7$var$addProperty(props, prop, value, ctx) {
    const info = (0, $d0176375645c5b16$export$71aa6c912b956294)(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (Array.isArray(result)) result = info.commaSeparated ? (0, $113922d5c9905d28$export$fac44ee5b035f737)(result) : (0, $78a983f075722656$export$fac44ee5b035f737)(result);
    if (info.property === "style" && typeof result === "string") result = $9acf91d1ffa48bc7$var$parseStyle(result);
    if (info.space && info.property) props[$9acf91d1ffa48bc7$var$own.call((0, $c5608189dbc8e1b1$export$d8abd7e5fb6871f9), info.property) ? (0, $c5608189dbc8e1b1$export$d8abd7e5fb6871f9)[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Record<string, string>}
 */ function $9acf91d1ffa48bc7$var$parseStyle(value) {
    /** @type {Record<string, string>} */ const result = {};
    try {
        (0, $0b11d0faa493e76f$export$2e2bcd8739ae039)(value, iterator);
    } catch  {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === "-ms-" ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $9acf91d1ffa48bc7$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $9acf91d1ffa48bc7$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $9acf91d1ffa48bc7$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ":",
        pos.start.column,
        "-",
        pos.end.line,
        ":",
        pos.end.column
    ].map(String).join("");
}


const $31bdb7db456b4918$var$own = {}.hasOwnProperty;
const $31bdb7db456b4918$var$changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
/** @type {Record<string, Deprecation>} */ const $31bdb7db456b4918$var$deprecated = {
    plugins: {
        to: "remarkPlugins",
        id: "change-plugins-to-remarkplugins"
    },
    renderers: {
        to: "components",
        id: "change-renderers-to-components"
    },
    astPlugins: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    allowDangerousHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    escapeHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    source: {
        to: "children",
        id: "change-source-to-children"
    },
    allowNode: {
        to: "allowElement",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    allowedTypes: {
        to: "allowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    disallowedTypes: {
        to: "disallowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    includeNodeIndex: {
        to: "includeElementIndex",
        id: "change-includenodeindex-to-includeelementindex"
    }
};
function $31bdb7db456b4918$export$83ef7ab426386201(options) {
    for(const key in $31bdb7db456b4918$var$deprecated)if ($31bdb7db456b4918$var$own.call($31bdb7db456b4918$var$deprecated, key) && $31bdb7db456b4918$var$own.call(options, key)) {
        const deprecation = $31bdb7db456b4918$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : "remove"} \`${key}\` (see <${$31bdb7db456b4918$var$changelog}#${deprecation.id}> for more info)`);
        delete $31bdb7db456b4918$var$deprecated[key];
    }
    const processor = (0, $2d1177fd06828c6f$export$7cc1b2fe10c52bb)().use((0, $5c41691a86fad5ee$export$2e2bcd8739ae039)).use(options.remarkPlugins || []).use((0, $b146722a21ae9bd5$export$2e2bcd8739ae039), {
        ...options.remarkRehypeOptions,
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use((0, $d85e3057ed017e8b$export$2e2bcd8739ae039), options);
    const file = new (0, $f49d062054ceb833$export$93dff69eb10dc7ce)();
    if (typeof options.children === "string") file.value = options.children;
    else if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== "root") throw new TypeError("Expected a `root` node");
    /** @type {ReactElement} */ let result = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).Fragment, {}, (0, $9acf91d1ffa48bc7$export$4b745c302603ab5d)({
        options: options,
        schema: (0, $18964ceaa117e6f2$export$c0bb0b647f701bb5),
        listDepth: 0
    }, hastNode));
    if (options.className) result = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).createElement("div", {
        className: options.className
    }, result);
    return result;
}
$31bdb7db456b4918$export$83ef7ab426386201.propTypes = {
    // Core options:
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).string,
    // Layout options:
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).string,
    // Filter options:
    allowElement: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).func,
    allowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).string),
    disallowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).string),
    unwrapDisallowed: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).bool,
    // Plugin options:
    remarkPlugins: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).any)
        ]))
    ])),
    rehypePlugins: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).any)
        ]))
    ])),
    // Transform options:
    sourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).bool,
    rawSourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).bool,
    skipHtml: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).bool,
    includeElementIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).bool,
    transformLinkUri: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).bool
    ]),
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).string
    ]),
    transformImageUri: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).func,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($2TkGT))).object
};


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('micromark-extension-gfm').Options & import('mdast-util-gfm').Options} Options
 */ /**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $102b977a0cd0461a$var$wwwPrefix = {
    tokenize: $102b977a0cd0461a$var$tokenizeWwwPrefix,
    partial: true
};
const $102b977a0cd0461a$var$domain = {
    tokenize: $102b977a0cd0461a$var$tokenizeDomain,
    partial: true
};
const $102b977a0cd0461a$var$path = {
    tokenize: $102b977a0cd0461a$var$tokenizePath,
    partial: true
};
const $102b977a0cd0461a$var$trail = {
    tokenize: $102b977a0cd0461a$var$tokenizeTrail,
    partial: true
};
const $102b977a0cd0461a$var$emailDomainDotTrail = {
    tokenize: $102b977a0cd0461a$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $102b977a0cd0461a$var$wwwAutolink = {
    tokenize: $102b977a0cd0461a$var$tokenizeWwwAutolink,
    previous: $102b977a0cd0461a$var$previousWww
};
const $102b977a0cd0461a$var$protocolAutolink = {
    tokenize: $102b977a0cd0461a$var$tokenizeProtocolAutolink,
    previous: $102b977a0cd0461a$var$previousProtocol
};
const $102b977a0cd0461a$var$emailAutolink = {
    tokenize: $102b977a0cd0461a$var$tokenizeEmailAutolink,
    previous: $102b977a0cd0461a$var$previousEmail
};
/** @type {ConstructRecord} */ const $102b977a0cd0461a$var$text = {};
const $102b977a0cd0461a$export$608123d9b549151 = {
    text: $102b977a0cd0461a$var$text
};
/** @type {Code} */ let $102b977a0cd0461a$var$code = 48;
// Add alphanumerics.
while($102b977a0cd0461a$var$code < 123){
    $102b977a0cd0461a$var$text[$102b977a0cd0461a$var$code] = $102b977a0cd0461a$var$emailAutolink;
    $102b977a0cd0461a$var$code++;
    if ($102b977a0cd0461a$var$code === 58) $102b977a0cd0461a$var$code = 65;
    else if ($102b977a0cd0461a$var$code === 91) $102b977a0cd0461a$var$code = 97;
}
$102b977a0cd0461a$var$text[43] = $102b977a0cd0461a$var$emailAutolink;
$102b977a0cd0461a$var$text[45] = $102b977a0cd0461a$var$emailAutolink;
$102b977a0cd0461a$var$text[46] = $102b977a0cd0461a$var$emailAutolink;
$102b977a0cd0461a$var$text[95] = $102b977a0cd0461a$var$emailAutolink;
$102b977a0cd0461a$var$text[72] = [
    $102b977a0cd0461a$var$emailAutolink,
    $102b977a0cd0461a$var$protocolAutolink
];
$102b977a0cd0461a$var$text[104] = [
    $102b977a0cd0461a$var$emailAutolink,
    $102b977a0cd0461a$var$protocolAutolink
];
$102b977a0cd0461a$var$text[87] = [
    $102b977a0cd0461a$var$emailAutolink,
    $102b977a0cd0461a$var$wwwAutolink
];
$102b977a0cd0461a$var$text[119] = [
    $102b977a0cd0461a$var$emailAutolink,
    $102b977a0cd0461a$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $102b977a0cd0461a$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$102b977a0cd0461a$var$gfmAtext(code) || !$102b977a0cd0461a$var$previousEmail.call(self, self.previous) || $102b977a0cd0461a$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkEmail");
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($102b977a0cd0461a$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($102b977a0cd0461a$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(self.previous)) {
            effects.exit("literalAutolinkEmail");
            effects.exit("literalAutolink");
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $102b977a0cd0461a$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$102b977a0cd0461a$var$previousWww.call(self, self.previous) || $102b977a0cd0461a$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkWww");
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($102b977a0cd0461a$var$wwwPrefix, effects.attempt($102b977a0cd0461a$var$domain, effects.attempt($102b977a0cd0461a$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit("literalAutolinkWww");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $102b977a0cd0461a$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = "";
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $102b977a0cd0461a$var$previousProtocol.call(self, self.previous) && !$102b977a0cd0461a$var$previousUnbalanced(self.events)) {
            effects.enter("literalAutolink");
            effects.enter("literalAutolinkHttp");
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === "http" || protocol === "https") {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $bcbf19ba9aa2a126$export$67dbf494fc8394df)(code) || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code) || (0, $bcbf19ba9aa2a126$export$a0ff789c034ffdf4)(code) || (0, $bcbf19ba9aa2a126$export$aa04114dd888a7a0)(code) ? nok(code) : effects.attempt($102b977a0cd0461a$var$domain, effects.attempt($102b977a0cd0461a$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit("literalAutolinkHttp");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $102b977a0cd0461a$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $102b977a0cd0461a$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($102b977a0cd0461a$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code) || (0, $bcbf19ba9aa2a126$export$a0ff789c034ffdf4)(code) || code !== 45 && (0, $bcbf19ba9aa2a126$export$aa04114dd888a7a0)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $102b977a0cd0461a$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($102b977a0cd0461a$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code) || (0, $bcbf19ba9aa2a126$export$a0ff789c034ffdf4)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $102b977a0cd0461a$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharRefStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code) || (0, $bcbf19ba9aa2a126$export$a0ff789c034ffdf4)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code) || (0, $bcbf19ba9aa2a126$export$a0ff789c034ffdf4)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(code) ? trailCharRefInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return trailCharRefInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $102b977a0cd0461a$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $102b977a0cd0461a$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $102b977a0cd0461a$var$previousProtocol(code) {
    return !(0, $bcbf19ba9aa2a126$export$d65d6b62c24d5436)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $102b977a0cd0461a$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $102b977a0cd0461a$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $102b977a0cd0461a$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $bcbf19ba9aa2a126$export$75c76db11865a9f4)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $102b977a0cd0461a$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === "labelLink" || token.type === "labelImage") && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').Handle} Handle
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ 
const $bd017d0e1236ee18$export$999603f1f1c3d2f9 = {
    exit: {
        literalAutolinkEmail: $bd017d0e1236ee18$var$literalAutolinkEmail,
        literalAutolinkHttp: $bd017d0e1236ee18$var$literalAutolinkHttp,
        literalAutolinkWww: $bd017d0e1236ee18$var$literalAutolinkWww
    }
};
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $bd017d0e1236ee18$var$literalAutolinkWww(token) {
    $bd017d0e1236ee18$var$anchorFromToken.call(this, token, "http://");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $bd017d0e1236ee18$var$literalAutolinkEmail(token) {
    $bd017d0e1236ee18$var$anchorFromToken.call(this, token, "mailto:");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $bd017d0e1236ee18$var$literalAutolinkHttp(token) {
    $bd017d0e1236ee18$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {void}
 */ function $bd017d0e1236ee18$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $d3ce3b13b8721472$export$d130a2d684099e5a)((protocol || "") + url) + '">');
    this.raw(this.encode(url));
    this.tag("</a>");
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 



const $e8aa495bac6fec06$var$indent = {
    tokenize: $e8aa495bac6fec06$var$tokenizeIndent,
    partial: true
};
function $e8aa495bac6fec06$export$c82499b6656305df() {
    /** @type {Extension} */ return {
        document: {
            [91]: {
                tokenize: $e8aa495bac6fec06$var$tokenizeDefinitionStart,
                continuation: {
                    tokenize: $e8aa495bac6fec06$var$tokenizeDefinitionContinuation
                },
                exit: $e8aa495bac6fec06$var$gfmFootnoteDefinitionEnd
            }
        },
        text: {
            [91]: {
                tokenize: $e8aa495bac6fec06$var$tokenizeGfmFootnoteCall
            },
            [93]: {
                add: "after",
                tokenize: $e8aa495bac6fec06$var$tokenizePotentialGfmFootnoteCall,
                resolveTo: $e8aa495bac6fec06$var$resolveToPotentialGfmFootnoteCall
            }
        }
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e8aa495bac6fec06$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ let labelStart;
    // Find an opening.
    while(index--){
        const token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === "gfmFootnoteCall" || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        const id = (0, $e3ffbc1ff2da7d5d$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $e8aa495bac6fec06$var$resolveToPotentialGfmFootnoteCall(events, context) {
    let index = events.length;
    /** @type {Token | undefined} */ let labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === "enter") {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = "gfmFootnoteCallLabelMarker";
    // The whole (without `!`):
    /** @type {Token} */ const call = {
        type: "gfmFootnoteCall",
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ const marker = {
        type: "gfmFootnoteCallMarker",
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ const string = {
        type: "gfmFootnoteCallString",
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ const chunk = {
        type: "chunkString",
        contentType: "string",
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ const replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            "enter",
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            "enter",
            marker,
            context
        ],
        [
            "exit",
            marker,
            context
        ],
        // Everything in between.
        [
            "enter",
            string,
            context
        ],
        [
            "enter",
            chunk,
            context
        ],
        [
            "exit",
            chunk,
            context
        ],
        [
            "exit",
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            "exit",
            call,
            context
        ]
    ];
    events.splice(index, events.length - index + 1, ...replacement);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e8aa495bac6fec06$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    let size = 0;
    /** @type {boolean} */ let data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteCall");
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter("gfmFootnoteCallMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallMarker");
        effects.enter("gfmFootnoteCallString");
        effects.enter("chunkString").contentType = "string";
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteCallString");
            if (!defined.includes((0, $e3ffbc1ff2da7d5d$export$806d55e226cfcd08)(self.sliceSerialize(token)))) return nok(code);
            effects.enter("gfmFootnoteCallLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteCallLabelMarker");
            effects.exit("gfmFootnoteCall");
            return ok;
        }
        if (!(0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e8aa495bac6fec06$var$tokenizeDefinitionStart(effects, ok, nok) {
    const self = this;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ let identifier;
    let size = 0;
    /** @type {boolean | undefined} */ let data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteDefinition")._container = true;
        effects.enter("gfmFootnoteDefinitionLabel");
        effects.enter("gfmFootnoteDefinitionLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteDefinitionLabelMarker");
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter("gfmFootnoteDefinitionMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionMarker");
            effects.enter("gfmFootnoteDefinitionLabelString");
            effects.enter("chunkString").contentType = "string";
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteDefinitionLabelString");
            identifier = (0, $e3ffbc1ff2da7d5d$export$806d55e226cfcd08)(self.sliceSerialize(token));
            effects.enter("gfmFootnoteDefinitionLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionLabelMarker");
            effects.exit("gfmFootnoteDefinitionLabel");
            return labelAfter;
        }
        if (!(0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, whitespaceAfter, "gfmFootnoteDefinitionWhitespace");
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e8aa495bac6fec06$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $8219420e5fbadbac$export$d50d28ce3ab2a612), ok, effects.attempt($e8aa495bac6fec06$var$indent, ok, nok));
}
/** @type {Exiter} */ function $e8aa495bac6fec06$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit("gfmFootnoteDefinition");
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e8aa495bac6fec06$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, afterPrefix, "gfmFootnoteDefinitionIndent", 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "gfmFootnoteDefinitionIndent" && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @callback BackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   * `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   * `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   * `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {string} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent them from
 *   *clobbering*.
 *
 *   The default is `'user-content-'`.
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {string} [label='Footnotes']
 *   Textual label to use for the footnotes section.
 *
 *   The default value is `'Footnotes'`.
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {string} [labelAttributes='class="sr-only"']
 *   Attributes to use on the footnote label.
 *
 *   Change it to show the label and add other attributes.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different attributes.
 *
 *   > 👉 **Note**: `id="footnote-label"` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string} [labelTagName='h2']
 *   HTML tag name to use for the footnote label element.
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {BackLabelTemplate | string} [backLabel]
 *   Textual label to describe the backreference back to references.
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *  }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `aria-label` attribute on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 */ 

const $542afd525f0edf5c$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $542afd525f0edf5c$var$emptyOptions = {};
function $542afd525f0edf5c$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
function $542afd525f0edf5c$export$a731a1f6cf81900c(options) {
    const config = options || $542afd525f0edf5c$var$emptyOptions;
    const label = config.label || "Footnotes";
    const labelTagName = config.labelTagName || "h2";
    const labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    const backLabel = config.backLabel || $542afd525f0edf5c$export$a18c77a47f4154b6;
    const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? "user-content-" : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition () {
                const stack = this.getData("tightStack");
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString () {
                this.buffer();
            },
            gfmFootnoteCallString () {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition () {
                let definitions = this.getData("gfmFootnoteDefinitions");
                const footnoteStack = this.getData("gfmFootnoteDefinitionStack");
                const tightStack = this.getData("tightStack");
                const current = footnoteStack.pop();
                const value = this.resume();
                if (!definitions) this.setData("gfmFootnoteDefinitions", definitions = {});
                if (!$542afd525f0edf5c$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData("slurpOneLineEnding", true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData("lastWasTag");
            },
            gfmFootnoteDefinitionLabelString (token) {
                let footnoteStack = /** @type {Array<string>} */ this.getData("gfmFootnoteDefinitionStack");
                if (!footnoteStack) this.setData("gfmFootnoteDefinitionStack", footnoteStack = []);
                footnoteStack.push((0, $e3ffbc1ff2da7d5d$export$806d55e226cfcd08)(this.sliceSerialize(token)));
                this.resume() // Drop the label.
                ;
                this.buffer() // Get ready for a value.
                ;
            },
            gfmFootnoteCallString (token) {
                let calls = this.getData("gfmFootnoteCallOrder");
                let counts = this.getData("gfmFootnoteCallCounts");
                const id = (0, $e3ffbc1ff2da7d5d$export$806d55e226cfcd08)(this.sliceSerialize(token));
                /** @type {number} */ let counter;
                this.resume();
                if (!calls) this.setData("gfmFootnoteCallOrder", calls = []);
                if (!counts) this.setData("gfmFootnoteCallCounts", counts = {});
                const index = calls.indexOf(id);
                const safeId = (0, $d3ce3b13b8721472$export$d130a2d684099e5a)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                const reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + "fn-" + safeId + '" id="' + clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : "") + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + "</a></sup>");
            },
            null () {
                const calls = /** @type {Array<string>} */ this.getData("gfmFootnoteCallOrder") || [];
                const counts = /** @type {Record<string, number>} */ this.getData("gfmFootnoteCallCounts") || {};
                const definitions = /** @type {Record<string, string>} */ this.getData("gfmFootnoteDefinitions") || {};
                let index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? " " + labelAttributes : "") + ">");
                    this.raw(this.encode(label));
                    this.tag("</" + labelTagName + ">");
                    this.lineEndingIfNeeded();
                    this.tag("<ol>");
                }
                while(++index < calls.length){
                    // Called definitions are always defined.
                    const id = calls[index];
                    const safeId = (0, $d3ce3b13b8721472$export$d130a2d684099e5a)(id.toLowerCase());
                    let referenceIndex = 0;
                    /** @type {Array<string>} */ const references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : "") + '" data-footnote-backref="" aria-label="' + this.encode(typeof backLabel === "string" ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">\u21A9' + (referenceIndex > 1 ? "<sup>" + referenceIndex + "</sup>" : "") + "</a>");
                    const reference = references.join(" ");
                    let injected = false;
                    this.lineEndingIfNeeded();
                    this.tag('<li id="' + clobberPrefix + "fn-" + safeId + '">');
                    this.lineEndingIfNeeded();
                    this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, (/** @type {string} */ $0)=>{
                        injected = true;
                        return " " + reference + $0;
                    }));
                    if (!injected) {
                        this.lineEndingIfNeeded();
                        this.tag(reference);
                    }
                    this.lineEndingIfNeeded();
                    this.tag("</li>");
                }
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag("</ol>");
                    this.lineEndingIfNeeded();
                    this.tag("</section>");
                }
            }
        }
    };
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean} [singleTilde=true]
 *   Whether to support strikethrough with a single tilde.
 *
 *   Single tildes work on github.com, but are technically prohibited by the
 *   GFM spec.
 */ 


function $1846f43de587cb65$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === "enter" && events[index][1].type === "strikethroughSequenceTemporary" && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === "exit" && events[open][1].type === "strikethroughSequenceTemporary" && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = "strikethroughSequence";
                events[open][1].type = "strikethroughSequence";
                /** @type {Token} */ const strikethrough = {
                    type: "strikethrough",
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: "strikethroughText",
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        "enter",
                        strikethrough,
                        context
                    ],
                    [
                        "enter",
                        events[open][1],
                        context
                    ],
                    [
                        "exit",
                        events[open][1],
                        context
                    ],
                    [
                        "enter",
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $d243901ff94656bd$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $34133fc7a9cfcf1e$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $d243901ff94656bd$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        "exit",
                        text,
                        context
                    ],
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        strikethrough,
                        context
                    ]
                ]);
                (0, $d243901ff94656bd$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === "strikethroughSequenceTemporary") events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter("strikethroughSequenceTemporary");
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $924261223d5276fa$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit("strikethroughSequenceTemporary");
            const after = (0, $924261223d5276fa$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ // To do: next major: expose function instead of object.
/**
 * Extension for `micromark` that can be passed in `htmlExtensions`, to
 * support GFM strikethrough when serializing to HTML.
 *
 * @type {HtmlExtension}
 */ const $0ca28c1e5705effc$export$58acedca46108820 = {
    enter: {
        strikethrough () {
            this.tag("<del>");
        }
    },
    exit: {
        strikethrough () {
            this.tag("</del>");
        }
    }
};


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $0504f1614b3a765e$export$9348908dd4518b4a {
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {void}
   */ add(index, remove, add) {
        $0504f1614b3a765e$var$addImpl(this, index, remove, add);
    }
    // To do: not used here.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {void}
    //  */
    // addBefore(index, remove, add) {
    //   addImpl(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {void}
   */ consume(events) {
        this.map.sort((a, b)=>a[0] - b[0]);
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]));
            // eslint-disable-next-line unicorn/no-array-push-push
            vecs.push(this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push([
            ...events
        ]);
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            events.push(...slice);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {void}
 */ function $0504f1614b3a765e$var$addImpl(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       console.log('to do: links?', add, rmCurr)
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ /**
 * @typedef {'left' | 'center' | 'right' | 'none'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {Array<Align>}
 */ function $31c55c8d7a456568$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === "enter") // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === "tableContent") align.push(events[index + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
            } else if (event[1].type === "tableContent") {
                if (events[index - 1][1].type === "tableDelimiterMarker") {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === "left" ? "center" : "right";
                }
            } else if (event[1].type === "tableDelimiterRow") break;
        } else if (event[0] === "enter" && event[1].type === "tableDelimiterRow") inDelimiterRow = true;
        index += 1;
    }
    return align;
}


const $babbaa2108bb26ec$export$e36cebda627bf2dd = {
    flow: {
        null: {
            tokenize: $babbaa2108bb26ec$var$tokenizeTable,
            resolveAll: $babbaa2108bb26ec$var$resolveTable
        }
    }
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $babbaa2108bb26ec$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === "tableHead" || tail === "tableRow" ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter("tableHead");
        effects.enter("tableRow");
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit("tableRow");
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter("tableDelimiterRow");
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter("tableDelimiterFiller");
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit("tableDelimiterFiller");
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit("tableDelimiterFiller");
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit("tableDelimiterRow");
            effects.exit("tableHead");
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter("tableRow");
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return bodyRowBreak;
        }
        if (code === null || (0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) {
            effects.exit("tableRow");
            return ok(code);
        }
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ // eslint-disable-next-line complexity
function $babbaa2108bb26ec$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $0504f1614b3a765e$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === "enter") {
            // Start of head.
            if (token.type === "tableHead") {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $babbaa2108bb26ec$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: "table",
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        "enter",
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: "tableBody",
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            "enter",
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === "tableDelimiterRow" ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $babbaa2108bb26ec$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === "tableCellDivider") {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $babbaa2108bb26ec$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === "tableHead") {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $babbaa2108bb26ec$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $babbaa2108bb26ec$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) cell[3] = index;
    }
    if (lastTableEnd !== 0) $babbaa2108bb26ec$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === "enter" && event[1].type === "table") event[1]._align = (0, $31c55c8d7a456568$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/// Generate a cell.
/**
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {Range} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $babbaa2108bb26ec$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? "tableHeader" : rowKind === 2 ? "tableDelimiter" : "tableData";
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = "tableContent";
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $babbaa2108bb26ec$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $babbaa2108bb26ec$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            "enter",
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $babbaa2108bb26ec$var$getPoint(context.events, range[2]);
        const relatedEnd = $babbaa2108bb26ec$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                "enter",
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                "exit",
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $babbaa2108bb26ec$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $babbaa2108bb26ec$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $babbaa2108bb26ec$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            "exit",
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        "exit",
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {readonly Point}
 */ function $babbaa2108bb26ec$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === "enter" ? "start" : "end";
    return event[1][side];
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @typedef {import('./infer.js').Align} Align
 */ const $fa36436c0ae3b74e$var$alignment = {
    none: "",
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
const $fa36436c0ae3b74e$export$c64626c032567c7f = {
    enter: {
        table (token) {
            const tableAlign = token._align;
            this.lineEndingIfNeeded();
            this.tag("<table>");
            this.setData("tableAlign", tableAlign);
        },
        tableBody () {
            this.tag("<tbody>");
        },
        tableData () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            const align = $fa36436c0ae3b74e$var$alignment[tableAlign[tableColumn]];
            if (align === undefined) // Capture results to ignore them.
            this.buffer();
            else {
                this.lineEndingIfNeeded();
                this.tag("<td" + align + ">");
            }
        },
        tableHead () {
            this.lineEndingIfNeeded();
            this.tag("<thead>");
        },
        tableHeader () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            const align = $fa36436c0ae3b74e$var$alignment[tableAlign[tableColumn]];
            this.lineEndingIfNeeded();
            this.tag("<th" + align + ">");
        },
        tableRow () {
            this.setData("tableColumn", 0);
            this.lineEndingIfNeeded();
            this.tag("<tr>");
        }
    },
    exit: {
        // Overwrite the default code text data handler to unescape escaped pipes when
        // they are in tables.
        codeTextData (token) {
            let value = this.sliceSerialize(token);
            if (this.getData("tableAlign")) value = value.replace(/\\([\\|])/g, $fa36436c0ae3b74e$var$replace);
            this.raw(this.encode(value));
        },
        table () {
            this.setData("tableAlign");
            // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
            // but we do need to reset it to match a funky newline GH generates for
            // list items combined with tables.
            this.setData("slurpAllLineEndings");
            this.lineEndingIfNeeded();
            this.tag("</table>");
        },
        tableBody () {
            this.lineEndingIfNeeded();
            this.tag("</tbody>");
        },
        tableData () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            if (tableColumn in tableAlign) {
                this.tag("</td>");
                this.setData("tableColumn", tableColumn + 1);
            } else // Stop capturing.
            this.resume();
        },
        tableHead () {
            this.lineEndingIfNeeded();
            this.tag("</thead>");
        },
        tableHeader () {
            const tableColumn = this.getData("tableColumn");
            this.tag("</th>");
            this.setData("tableColumn", tableColumn + 1);
        },
        tableRow () {
            const tableAlign = this.getData("tableAlign");
            let tableColumn = this.getData("tableColumn");
            while(tableColumn < tableAlign.length){
                this.lineEndingIfNeeded();
                this.tag("<td" + $fa36436c0ae3b74e$var$alignment[tableAlign[tableColumn]] + "></td>");
                tableColumn++;
            }
            this.setData("tableColumn", tableColumn);
            this.lineEndingIfNeeded();
            this.tag("</tr>");
        }
    }
};
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $fa36436c0ae3b74e$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}


/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $c735fde640fc4618$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $c735fde640fc4618$var$reText = new RegExp("^" + $c735fde640fc4618$var$reFlow.source, "i");
const $c735fde640fc4618$export$c9bf87ea36d00682 = {
    exit: {
        htmlFlowData (token) {
            $c735fde640fc4618$var$exitHtmlData.call(this, token, $c735fde640fc4618$var$reFlow);
        },
        htmlTextData (token) {
            $c735fde640fc4618$var$exitHtmlData.call(this, token, $c735fde640fc4618$var$reText);
        }
    }
};
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 */ function $c735fde640fc4618$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, "&lt;$1$2");
    this.raw(this.encode(value));
}


/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $1122e191fb640d3d$var$tasklistCheck = {
    tokenize: $1122e191fb640d3d$var$tokenizeTasklistCheck
};
const $1122e191fb640d3d$export$2912e8b2802475ff = {
    text: {
        [91]: $1122e191fb640d3d$var$tasklistCheck
    }
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1122e191fb640d3d$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter("taskListCheck");
        effects.enter("taskListCheckMarker");
        effects.consume(code);
        effects.exit("taskListCheckMarker");
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $bcbf19ba9aa2a126$export$a30284361b3814b7)(code)) {
            effects.enter("taskListCheckValueUnchecked");
            effects.consume(code);
            effects.exit("taskListCheckValueUnchecked");
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter("taskListCheckValueChecked");
            effects.consume(code);
            effects.exit("taskListCheckValueChecked");
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter("taskListCheckMarker");
            effects.consume(code);
            effects.exit("taskListCheckMarker");
            effects.exit("taskListCheck");
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $bcbf19ba9aa2a126$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $bcbf19ba9aa2a126$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $1122e191fb640d3d$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1122e191fb640d3d$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $c5c9f05ec7b14fe5$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ // To do: next major: expose function to make extension.
/**
 * Extension for `micromark` that can be passed in `htmlExtensions` to
 * support GFM task list items when serializing to HTML.
 *
 * @type {HtmlExtension}
 */ const $5aec21e5a749975a$export$4b6a13e2af1b08ed = {
    enter: {
        taskListCheck () {
            this.tag('<input type="checkbox" disabled="" ');
        }
    },
    exit: {
        taskListCheck () {
            this.tag("/>");
        },
        taskListCheckValueChecked () {
            this.tag('checked="" ');
        }
    }
};


function $d3faee55b3d31e7a$export$59ffe8c4d7a4aab2(options) {
    return (0, $845c4ed1478b7476$export$86a865d89ef3c690)([
        (0, $102b977a0cd0461a$export$608123d9b549151),
        (0, $e8aa495bac6fec06$export$c82499b6656305df)(),
        (0, $1846f43de587cb65$export$8bbec8ea1400a00e)(options),
        (0, $babbaa2108bb26ec$export$e36cebda627bf2dd),
        (0, $1122e191fb640d3d$export$2912e8b2802475ff)
    ]);
}
function $d3faee55b3d31e7a$export$6983b82e6105d62a(options) {
    return (0, $845c4ed1478b7476$export$eaf8c406dfb0a620)([
        (0, $bd017d0e1236ee18$export$999603f1f1c3d2f9),
        (0, $542afd525f0edf5c$export$a731a1f6cf81900c)(options),
        (0, $0ca28c1e5705effc$export$58acedca46108820),
        (0, $fa36436c0ae3b74e$export$c64626c032567c7f),
        (0, $c735fde640fc4618$export$c9bf87ea36d00682),
        (0, $5aec21e5a749975a$export$4b6a13e2af1b08ed)
    ]);
}


/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * @typedef {import('mdast-util-gfm-table').Options} Options
 *   Configuration.
 */ /**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-from-markdown').Transform} FromMarkdownTransform
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 * @typedef {import('mdast-util-find-and-replace').RegExpMatchObject} RegExpMatchObject
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $44614872b0679a78$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== "string") throw new TypeError("Expected character");
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}


/**
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Text} Text
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Content | Root} Node
 * @typedef {Extract<Node, MdastParent>} Parent
 * @typedef {Exclude<Parent, Root>} ContentParent
 *
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[Root, ...Array<ContentParent>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | undefined | null}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {string | RegExp} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 * @typedef {Record<string, Replace>} FindAndReplaceSchema
 *   Several find and replaces, in object form.
 * @typedef {[Find, Replace]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 * @typedef {string | ReplaceFunction} Replace
 *   Thing to replace with.
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore.
 */ function $a2b48c080da913fc$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}




const $b24c0eac52ecbf7f$var$own = {}.hasOwnProperty;
const $b24c0eac52ecbf7f$export$fb306ebf003fc574 = /**
   * @type {(
   *   (<Tree extends Node>(tree: Tree, find: Find, replace?: Replace | null | undefined, options?: Options | null | undefined) => Tree) &
   *   (<Tree extends Node>(tree: Tree, schema: FindAndReplaceSchema | FindAndReplaceList, options?: Options | null | undefined) => Tree)
   * )}
   **/ /**
     * @template {Node} Tree
     * @param {Tree} tree
     * @param {Find | FindAndReplaceSchema | FindAndReplaceList} find
     * @param {Replace | Options | null | undefined} [replace]
     * @param {Options | null | undefined} [options]
     * @returns {Tree}
     */ function(tree, find, replace, options) {
    /** @type {Options | null | undefined} */ let settings;
    /** @type {FindAndReplaceSchema|FindAndReplaceList} */ let schema;
    if (typeof find === "string" || find instanceof RegExp) {
        // @ts-expect-error don’t expect options twice.
        schema = [
            [
                find,
                replace
            ]
        ];
        settings = options;
    } else {
        schema = find;
        // @ts-expect-error don’t expect replace twice.
        settings = replace;
    }
    if (!settings) settings = {};
    const ignored = (0, $6f0c7d19bfb186b2$export$9c68d69a4c5bbcf9)(settings.ignore || []);
    const pairs = $b24c0eac52ecbf7f$var$toPairs(schema);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $371d9ea3e9a3c1b5$export$70008a21eb6de899)(tree, "text", visitor);
    // To do next major: don’t return the given tree.
    return tree;
    /** @type {import('unist-util-visit-parents/complex-types.js').BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parent | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            if (ignored(parent, // @ts-expect-error: TS doesn’t understand but it’s perfect.
            grandparent ? grandparent.children.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
       * Handle a text node which is not in an ignored parent.
       *
       * @param {Text} node
       *   Text node.
       * @param {Array<Parent>} parents
       *   Parents.
       * @returns {VisitorResult}
       *   Result.
       */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        // @ts-expect-error: TS is wrong, some of these children can be text.
        const index = parent.children.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                // @ts-expect-error: stack is fine.
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === "string") value = value.length > 0 ? {
                type: "text",
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value !== false) {
                if (start !== position) nodes.push({
                    type: "text",
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) nodes.push(...value);
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) nodes.push({
                type: "text",
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
};
/**
 * Turn a schema into pairs.
 *
 * @param {FindAndReplaceSchema | FindAndReplaceList} schema
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $b24c0eac52ecbf7f$var$toPairs(schema) {
    /** @type {Pairs} */ const result = [];
    if (typeof schema !== "object") throw new TypeError("Expected array or object as schema");
    if (Array.isArray(schema)) {
        let index = -1;
        while(++index < schema.length)result.push([
            $b24c0eac52ecbf7f$var$toExpression(schema[index][0]),
            $b24c0eac52ecbf7f$var$toFunction(schema[index][1])
        ]);
    } else {
        /** @type {string} */ let key;
        for(key in schema)if ($b24c0eac52ecbf7f$var$own.call(schema, key)) result.push([
            $b24c0eac52ecbf7f$var$toExpression(key),
            $b24c0eac52ecbf7f$var$toFunction(schema[key])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $b24c0eac52ecbf7f$var$toExpression(find) {
    return typeof find === "string" ? new RegExp((0, $a2b48c080da913fc$export$2e2bcd8739ae039)(find), "g") : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $b24c0eac52ecbf7f$var$toFunction(replace) {
    return typeof replace === "function" ? replace : ()=>replace;
}



/** @type {ConstructName} */ const $486551edb37ede8c$var$inConstruct = "phrasing";
/** @type {Array<ConstructName>} */ const $486551edb37ede8c$var$notInConstruct = [
    "autolink",
    "link",
    "image",
    "label"
];
const $486551edb37ede8c$export$b6afdfff2163546f = {
    transforms: [
        $486551edb37ede8c$var$transformGfmAutolinkLiterals
    ],
    enter: {
        literalAutolink: $486551edb37ede8c$var$enterLiteralAutolink,
        literalAutolinkEmail: $486551edb37ede8c$var$enterLiteralAutolinkValue,
        literalAutolinkHttp: $486551edb37ede8c$var$enterLiteralAutolinkValue,
        literalAutolinkWww: $486551edb37ede8c$var$enterLiteralAutolinkValue
    },
    exit: {
        literalAutolink: $486551edb37ede8c$var$exitLiteralAutolink,
        literalAutolinkEmail: $486551edb37ede8c$var$exitLiteralAutolinkEmail,
        literalAutolinkHttp: $486551edb37ede8c$var$exitLiteralAutolinkHttp,
        literalAutolinkWww: $486551edb37ede8c$var$exitLiteralAutolinkWww
    }
};
const $486551edb37ede8c$export$d3ace9096b01c39d = {
    unsafe: [
        {
            character: "@",
            before: "[+\\-.\\w]",
            after: "[\\-.\\w]",
            inConstruct: $486551edb37ede8c$var$inConstruct,
            notInConstruct: $486551edb37ede8c$var$notInConstruct
        },
        {
            character: ".",
            before: "[Ww]",
            after: "[\\-.\\w]",
            inConstruct: $486551edb37ede8c$var$inConstruct,
            notInConstruct: $486551edb37ede8c$var$notInConstruct
        },
        {
            character: ":",
            before: "[ps]",
            after: "\\/",
            inConstruct: $486551edb37ede8c$var$inConstruct,
            notInConstruct: $486551edb37ede8c$var$notInConstruct
        }
    ]
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $486551edb37ede8c$var$enterLiteralAutolink(token) {
    this.enter({
        type: "link",
        title: null,
        url: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $486551edb37ede8c$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $486551edb37ede8c$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $486551edb37ede8c$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = /** @type {Link} */ this.stack[this.stack.length - 1];
    node.url = "http://" + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $486551edb37ede8c$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $486551edb37ede8c$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $486551edb37ede8c$var$transformGfmAutolinkLiterals(tree) {
    (0, $b24c0eac52ecbf7f$export$fb306ebf003fc574)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $486551edb37ede8c$var$findUrl
        ],
        [
            /([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g,
            $486551edb37ede8c$var$findEmail
        ]
    ], {
        ignore: [
            "link",
            "linkReference"
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Link | Array<PhrasingContent> | false}
 */ // eslint-disable-next-line max-params
function $486551edb37ede8c$var$findUrl(_, protocol, domain, path, match) {
    let prefix = "";
    // Not an expected previous character.
    if (!$486551edb37ede8c$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = "";
        prefix = "http://";
    }
    if (!$486551edb37ede8c$var$isCorrectDomain(domain)) return false;
    const parts = $486551edb37ede8c$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: "link",
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: "text",
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: "text",
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $486551edb37ede8c$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$486551edb37ede8c$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: "link",
        title: null,
        url: "mailto:" + atext + "@" + label,
        children: [
            {
                type: "text",
                value: atext + "@" + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $486551edb37ede8c$var$isCorrectDomain(domain) {
    const parts = domain.split(".");
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $486551edb37ede8c$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(")");
    const openingParens = (0, $44614872b0679a78$export$fa42eaa97a352e23)(url, "(");
    let closingParens = (0, $44614872b0679a78$export$fa42eaa97a352e23)(url, ")");
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(")");
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $486551edb37ede8c$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $bcbf19ba9aa2a126$export$a0ff789c034ffdf4)(code) || (0, $bcbf19ba9aa2a126$export$aa04114dd888a7a0)(code)) && (!email || code !== 47);
}


/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Map} Map
 */ 
/**
 * @typedef {import('../types.js').AssociationId} AssociationId
 */ 
function $20c58eafed917358$export$c4ca1a6065421754(node) {
    if (node.label || !node.identifier) return node.label || "";
    return (0, $b24137254738ca7e$export$a0fb664af7d0cc44)(node.identifier);
}


/**
 * @typedef {import('../types.js').FlowContent} FlowContent
 * @typedef {import('../types.js').Node} Node
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').TrackFields} TrackFields
 */ /**
 * @param {Parent & {children: Array<FlowContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $bd5486f7bbc9fcc6$export$134f7fdacfea8b16(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    const tracker = state.createTracker(info);
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    indexStack.push(-1);
    while(++index < children.length){
        const child = children[index];
        indexStack[indexStack.length - 1] = index;
        results.push(tracker.move(state.handle(child, parent, state, {
            before: "\n",
            after: "\n",
            ...tracker.current()
        })));
        if (child.type !== "list") state.bulletLastUsed = undefined;
        if (index < children.length - 1) results.push(tracker.move($bd5486f7bbc9fcc6$var$between(child, children[index + 1], parent, state)));
    }
    indexStack.pop();
    return results.join("");
}
/**
 * @param {Node} left
 * @param {Node} right
 * @param {Parent} parent
 * @param {State} state
 * @returns {string}
 */ function $bd5486f7bbc9fcc6$var$between(left, right, parent, state) {
    let index = state.join.length;
    while(index--){
        const result = state.join[index](left, right, parent, state);
        if (result === true || result === 1) break;
        if (typeof result === "number") return "\n".repeat(1 + result);
        if (result === false) return "\n\n<!---->\n\n";
    }
    return "\n\n";
}


/**
 * @typedef {import('../types.js').IndentLines} IndentLines
 */ const $cd57873cfa160768$var$eol = /\r?\n|\r/g;
function $cd57873cfa160768$export$7c3cf23d514b264a(value, map) {
    /** @type {Array<string>} */ const result = [];
    let start = 0;
    let line = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = $cd57873cfa160768$var$eol.exec(value)){
        one(value.slice(start, match.index));
        result.push(match[0]);
        start = match.index + match[0].length;
        line++;
    }
    one(value.slice(start));
    return result.join("");
    /**
   * @param {string} value
   */ function one(value) {
        result.push(map(value, line, !value));
    }
}


/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').SafeConfig} SafeConfig
 */ /**
 * @typedef {import('../types.js').Unsafe} Unsafe
 */ /**
 * @param {Unsafe} pattern
 * @returns {RegExp}
 */ function $232c131782cddd0d$export$7993761911514c15(pattern) {
    if (!pattern._compiled) {
        const before = (pattern.atBreak ? "[\\r\\n][\\t ]*" : "") + (pattern.before ? "(?:" + pattern.before + ")" : "");
        pattern._compiled = new RegExp((before ? "(" + before + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? "\\" : "") + pattern.character + (pattern.after ? "(?:" + pattern.after + ")" : ""), "g");
    }
    return pattern._compiled;
}


/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 * @typedef {import('../types.js').ConstructName} ConstructName
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $6859a141b475c3f6$export$78221a09424368d(stack, pattern) {
    return $6859a141b475c3f6$var$listInScope(stack, pattern.inConstruct, true) && !$6859a141b475c3f6$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $6859a141b475c3f6$var$listInScope(stack, list, none) {
    if (typeof list === "string") list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $c3da9d22923c81a5$export$170b8c323eee7bec(state, input, config) {
    const value = (config.before || "") + (input || "") + (config.after || "");
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const result = [];
    /** @type {Record<number, {before: boolean, after: boolean}>} */ const infos = {};
    let index = -1;
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        if (!(0, $6859a141b475c3f6$export$78221a09424368d)(state.stack, pattern)) continue;
        const expression = (0, $232c131782cddd0d$export$7993761911514c15)(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        while(match = expression.exec(value)){
            const before = "before" in pattern || Boolean(pattern.atBreak);
            const after = "after" in pattern;
            const position = match.index + (before ? match[1].length : 0);
            if (positions.includes(position)) {
                if (infos[position].before && !before) infos[position].before = false;
                if (infos[position].after && !after) infos[position].after = false;
            } else {
                positions.push(position);
                infos[position] = {
                    before: before,
                    after: after
                };
            }
        }
    }
    positions.sort($c3da9d22923c81a5$var$numerical);
    let start = config.before ? config.before.length : 0;
    const end = value.length - (config.after ? config.after.length : 0);
    index = -1;
    while(++index < positions.length){
        const position = positions[index];
        // Character before or after matched:
        if (position < start || position >= end) continue;
        // If this character is supposed to be escaped because it has a condition on
        // the next character, and the next character is definitly being escaped,
        // then skip this escape.
        if (position + 1 < end && positions[index + 1] === position + 1 && infos[position].after && !infos[position + 1].before && !infos[position + 1].after || positions[index - 1] === position - 1 && infos[position].before && !infos[position - 1].before && !infos[position - 1].after) continue;
        if (start !== position) // If we have to use a character reference, an ampersand would be more
        // correct, but as backslashes only care about punctuation, either will
        // do the trick
        result.push($c3da9d22923c81a5$var$escapeBackslashes(value.slice(start, position), "\\"));
        start = position;
        if (/[!-/:-@[-`{-~]/.test(value.charAt(position)) && (!config.encode || !config.encode.includes(value.charAt(position)))) // Character escape.
        result.push("\\");
        else {
            // Character reference.
            result.push("&#x" + value.charCodeAt(position).toString(16).toUpperCase() + ";");
            start++;
        }
    }
    result.push($c3da9d22923c81a5$var$escapeBackslashes(value.slice(start, end), config.after));
    return result.join("");
}
/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */ function $c3da9d22923c81a5$var$numerical(a, b) {
    return a - b;
}
/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */ function $c3da9d22923c81a5$var$escapeBackslashes(value, after) {
    const expression = /\\(?=[!-/:-@[-`{-~])/g;
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const results = [];
    const whole = value + after;
    let index = -1;
    let start = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = expression.exec(whole))positions.push(match.index);
    while(++index < positions.length){
        if (start !== positions[index]) results.push(value.slice(start, positions[index]));
        results.push("\\");
        start = positions[index];
    }
    results.push(value.slice(start));
    return results.join("");
}


/**
 * @typedef {import('../types.js').CreateTracker} CreateTracker
 * @typedef {import('../types.js').TrackCurrent} TrackCurrent
 * @typedef {import('../types.js').TrackMove} TrackMove
 * @typedef {import('../types.js').TrackShift} TrackShift
 */ /**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */ function $e9b033e355d7af7a$export$6b2a7d5132615086(config) {
    // Defaults are used to prevent crashes when older utilities somehow activate
    // this code.
    /* c8 ignore next 5 */ const options = config || {};
    const now = options.now || {};
    let lineShift = options.lineShift || 0;
    let line = now.line || 1;
    let column = now.column || 1;
    return {
        move: move,
        current: current,
        shift: shift
    };
    /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */ function current() {
        return {
            now: {
                line: line,
                column: column
            },
            lineShift: lineShift
        };
    }
    /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */ function shift(value) {
        lineShift += value;
    }
    /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */ function move(input) {
        // eslint-disable-next-line unicorn/prefer-default-parameters
        const value = input || "";
        const chunks = value.split(/\r?\n|\r/g);
        const tail = chunks[chunks.length - 1];
        line += chunks.length - 1;
        column = chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
        return value;
    }
}


$0f121ba590f25e9f$var$footnoteReference.peek = $0f121ba590f25e9f$var$footnoteReferencePeek;
function $0f121ba590f25e9f$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteDefinition: $0f121ba590f25e9f$var$enterFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $0f121ba590f25e9f$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteCall: $0f121ba590f25e9f$var$enterFootnoteCall,
            gfmFootnoteCallString: $0f121ba590f25e9f$var$enterFootnoteCallString
        },
        exit: {
            gfmFootnoteDefinition: $0f121ba590f25e9f$var$exitFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $0f121ba590f25e9f$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteCall: $0f121ba590f25e9f$var$exitFootnoteCall,
            gfmFootnoteCallString: $0f121ba590f25e9f$var$exitFootnoteCallString
        }
    };
}
function $0f121ba590f25e9f$export$3727766a73a6c09f() {
    return {
        // This is on by default already.
        unsafe: [
            {
                character: "[",
                inConstruct: [
                    "phrasing",
                    "label",
                    "reference"
                ]
            }
        ],
        handlers: {
            footnoteDefinition: $0f121ba590f25e9f$var$footnoteDefinition,
            footnoteReference: $0f121ba590f25e9f$var$footnoteReference
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $0f121ba590f25e9f$var$enterFootnoteDefinition(token) {
    this.enter({
        type: "footnoteDefinition",
        identifier: "",
        label: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $0f121ba590f25e9f$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $0f121ba590f25e9f$var$exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = /** @type {FootnoteDefinition} */ this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = (0, $e3ffbc1ff2da7d5d$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $0f121ba590f25e9f$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $0f121ba590f25e9f$var$enterFootnoteCall(token) {
    this.enter({
        type: "footnoteReference",
        identifier: "",
        label: ""
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $0f121ba590f25e9f$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $0f121ba590f25e9f$var$exitFootnoteCallString(token) {
    const label = this.resume();
    const node = /** @type {FootnoteDefinition} */ this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = (0, $e3ffbc1ff2da7d5d$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $0f121ba590f25e9f$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $0f121ba590f25e9f$var$footnoteReference(node, _, context, safeOptions) {
    const tracker = (0, $e9b033e355d7af7a$export$6b2a7d5132615086)(safeOptions);
    let value = tracker.move("[^");
    const exit = context.enter("footnoteReference");
    const subexit = context.enter("reference");
    value += tracker.move((0, $c3da9d22923c81a5$export$170b8c323eee7bec)(context, (0, $20c58eafed917358$export$c4ca1a6065421754)(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    exit();
    value += tracker.move("]");
    return value;
}
/** @type {ToMarkdownHandle} */ function $0f121ba590f25e9f$var$footnoteReferencePeek() {
    return "[";
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteDefinition} node
 */ function $0f121ba590f25e9f$var$footnoteDefinition(node, _, context, safeOptions) {
    const tracker = (0, $e9b033e355d7af7a$export$6b2a7d5132615086)(safeOptions);
    let value = tracker.move("[^");
    const exit = context.enter("footnoteDefinition");
    const subexit = context.enter("label");
    value += tracker.move((0, $c3da9d22923c81a5$export$170b8c323eee7bec)(context, (0, $20c58eafed917358$export$c4ca1a6065421754)(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    value += tracker.move("]:" + (node.children && node.children.length > 0 ? " " : ""));
    tracker.shift(4);
    value += tracker.move((0, $cd57873cfa160768$export$7c3cf23d514b264a)((0, $bd5486f7bbc9fcc6$export$134f7fdacfea8b16)(node, context, tracker.current()), $0f121ba590f25e9f$var$map));
    exit();
    return value;
}
/** @type {Map} */ function $0f121ba590f25e9f$var$map(line, index, blank) {
    if (index === 0) return line;
    return (blank ? "" : "    ") + line;
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ /**
 * @typedef {import('../types.js').Handle} Handle
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').PhrasingContent} PhrasingContent
 * @typedef {import('../types.js').State} State
 */ /**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @param {Parent & {children: Array<PhrasingContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */ function $a57501923d4d98b4$export$f4090a9439f37631(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    let before = info.before;
    indexStack.push(-1);
    let tracker = state.createTracker(info);
    while(++index < children.length){
        const child = children[index];
        /** @type {string} */ let after;
        indexStack[indexStack.length - 1] = index;
        if (index + 1 < children.length) {
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            let handle = state.handle.handlers[children[index + 1].type];
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, state, {
                before: "",
                after: "",
                ...tracker.current()
            }).charAt(0) : "";
        } else after = info.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === "\r" || before === "\n") && child.type === "html") {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, " ");
            before = " ";
            // To do: does this work to reset tracker?
            tracker = state.createTracker(info);
            tracker.move(results.join(""));
        }
        results.push(tracker.move(state.handle(child, parent, state, {
            ...tracker.current(),
            before: before,
            after: after
        })));
        before = results[results.length - 1].slice(-1);
    }
    indexStack.pop();
    return results.join("");
}



// To do: next major: expose functions.
// To do: next major: use `state`, state utilities.
/**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $ae63166f2fe190e7$var$constructsWithoutStrikethrough = [
    "autolink",
    "destinationLiteral",
    "destinationRaw",
    "reference",
    "titleQuote",
    "titleApostrophe"
];
$ae63166f2fe190e7$var$handleDelete.peek = $ae63166f2fe190e7$var$peekDelete;
const $ae63166f2fe190e7$export$34d64e709dd0b9bb = {
    canContainEols: [
        "delete"
    ],
    enter: {
        strikethrough: $ae63166f2fe190e7$var$enterStrikethrough
    },
    exit: {
        strikethrough: $ae63166f2fe190e7$var$exitStrikethrough
    }
};
const $ae63166f2fe190e7$export$1632835bd2c84956 = {
    unsafe: [
        {
            character: "~",
            inConstruct: "phrasing",
            notInConstruct: $ae63166f2fe190e7$var$constructsWithoutStrikethrough
        }
    ],
    handlers: {
        delete: $ae63166f2fe190e7$var$handleDelete
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ae63166f2fe190e7$var$enterStrikethrough(token) {
    this.enter({
        type: "delete",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ae63166f2fe190e7$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $ae63166f2fe190e7$var$handleDelete(node, _, context, safeOptions) {
    const tracker = (0, $e9b033e355d7af7a$export$6b2a7d5132615086)(safeOptions);
    const exit = context.enter("strikethrough");
    let value = tracker.move("~~");
    value += (0, $a57501923d4d98b4$export$f4090a9439f37631)(node, context, {
        ...tracker.current(),
        before: value,
        after: "~"
    });
    value += tracker.move("~~");
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $ae63166f2fe190e7$var$peekDelete() {
    return "~";
}


/**
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').InlineCode} InlineCode
 *
 * @typedef {import('markdown-table').MarkdownTableOptions} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Context} ToMarkdownContext
 * @typedef {import('mdast-util-to-markdown').SafeOptions} SafeOptions
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells.
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters.
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells
 */ 
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 */ 
$c64cf51e43e9a3df$export$91b9bee19a0d8569.peek = $c64cf51e43e9a3df$var$inlineCodePeek;
function $c64cf51e43e9a3df$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || "";
    let sequence = "`";
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp("(^|[^`])" + sequence + "([^`]|$)").test(value))sequence += "`";
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = " " + value + " ";
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = (0, $232c131782cddd0d$export$7993761911514c15)(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + " " + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $c64cf51e43e9a3df$var$inlineCodePeek() {
    return "`";
}


/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|ReadonlyArray<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */ /**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {ReadonlyArray<ReadonlyArray<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */ function $9f23aa219a5e93c3$export$cdb7288612c4f3d6(table, options = {}) {
    const align = (options.align || []).concat();
    const stringLength = options.stringLength || $9f23aa219a5e93c3$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $9f23aa219a5e93c3$var$serialize(table[rowIndex][columnIndex]);
            if (options.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === "object" && "length" in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $9f23aa219a5e93c3$var$toAlignment(align[columnIndex]);
    else {
        const code = $9f23aa219a5e93c3$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = "";
        let after = "";
        if (code === 99 /* `c` */ ) {
            before = ":";
            after = ":";
        } else if (code === 108 /* `l` */ ) before = ":";
        else if (code === 114 /* `r` */ ) after = ":";
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = options.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + "-".repeat(size) + after;
        if (options.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || "";
            let before = "";
            let after = "";
            if (options.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = " ".repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = " ".repeat(size / 2 + 0.5);
                        after = " ".repeat(size / 2 - 0.5);
                    } else {
                        before = " ".repeat(size / 2);
                        after = before;
                    }
                } else after = " ".repeat(size);
            }
            if (options.delimiterStart !== false && !columnIndex) line.push("|");
            if (options.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(options.alignDelimiters === false && cell === "") && (options.delimiterStart !== false || columnIndex)) line.push(" ");
            if (options.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (options.alignDelimiters !== false) line.push(after);
            if (options.padding !== false) line.push(" ");
            if (options.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push("|");
        }
        lines.push(options.delimiterEnd === false ? line.join("").replace(/ +$/, "") : line.join(""));
    }
    return lines.join("\n");
}
/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */ function $9f23aa219a5e93c3$var$serialize(value) {
    return value === null || value === undefined ? "" : String(value);
}
/**
 * @param {string} value
 * @returns {number}
 */ function $9f23aa219a5e93c3$var$defaultStringLength(value) {
    return value.length;
}
/**
 * @param {string|null|undefined} value
 * @returns {number}
 */ function $9f23aa219a5e93c3$var$toAlignment(value) {
    const code = typeof value === "string" ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}


const $38fc5e4f686fdcde$export$8bd0ec8ecf6adb7d = {
    enter: {
        table: $38fc5e4f686fdcde$var$enterTable,
        tableData: $38fc5e4f686fdcde$var$enterCell,
        tableHeader: $38fc5e4f686fdcde$var$enterCell,
        tableRow: $38fc5e4f686fdcde$var$enterRow
    },
    exit: {
        codeText: $38fc5e4f686fdcde$var$exitCodeText,
        table: $38fc5e4f686fdcde$var$exitTable,
        tableData: $38fc5e4f686fdcde$var$exit,
        tableHeader: $38fc5e4f686fdcde$var$exit,
        tableRow: $38fc5e4f686fdcde$var$exit
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $38fc5e4f686fdcde$var$enterTable(token) {
    /** @type {Array<'left' | 'right' | 'center' | 'none'>} */ // @ts-expect-error: `align` is custom.
    const align = token._align;
    this.enter({
        type: "table",
        align: align.map((d)=>d === "none" ? null : d),
        children: []
    }, token);
    this.setData("inTable", true);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $38fc5e4f686fdcde$var$exitTable(token) {
    this.exit(token);
    this.setData("inTable");
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $38fc5e4f686fdcde$var$enterRow(token) {
    this.enter({
        type: "tableRow",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $38fc5e4f686fdcde$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $38fc5e4f686fdcde$var$enterCell(token) {
    this.enter({
        type: "tableCell",
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $38fc5e4f686fdcde$var$exitCodeText(token) {
    let value = this.resume();
    if (this.getData("inTable")) value = value.replace(/\\([\\|])/g, $38fc5e4f686fdcde$var$replace);
    const node = /** @type {InlineCode} */ this.stack[this.stack.length - 1];
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $38fc5e4f686fdcde$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}
function $38fc5e4f686fdcde$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? " " : "|";
    return {
        unsafe: [
            {
                character: "\r",
                inConstruct: "tableCell"
            },
            {
                character: "\n",
                inConstruct: "tableCell"
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: "|",
                after: "[	 :-]"
            },
            // A pipe in a cell must be encoded.
            {
                character: "|",
                inConstruct: "tableCell"
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ":",
                after: "-"
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: "-",
                after: "[:|-]"
            }
        ],
        handlers: {
            table: handleTable,
            tableRow: handleTableRow,
            tableCell: handleTableCell,
            inlineCode: inlineCodeWithTable
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, context, safeOptions) {
        return serializeData(handleTableAsData(node, context, safeOptions), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, context, safeOptions) {
        const row = handleTableRowAsData(node, context, safeOptions);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf("\n"));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, context, safeOptions) {
        const exit = context.enter("tableCell");
        const subexit = context.enter("phrasing");
        const value = (0, $a57501923d4d98b4$export$f4090a9439f37631)(node, context, {
            ...safeOptions,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $9f23aa219a5e93c3$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */ function handleTableAsData(node, context, safeOptions) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = context.enter("table");
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], context, safeOptions);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */ function handleTableRowAsData(node, context, safeOptions) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = context.enter("tableRow");
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, context, safeOptions);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, context) {
        let value = (0, $c64cf51e43e9a3df$export$91b9bee19a0d8569)(node, parent, context);
        if (context.stack.includes("tableCell")) value = value.replace(/\|/g, "\\$&");
        return value;
    }
}


/**
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ /**
 * @typedef {Extract<Root | Content, Parent>} Parents
 */ /**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ /**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $c61b569b3e52b749$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || "*";
    if (marker !== "*" && marker !== "+" && marker !== "-") throw new Error("Cannot serialize items with `" + marker + "` for `options.bullet`, expected `*`, `+`, or `-`");
    return marker;
}


/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $409727d164b622a0$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || "tab";
    // To do: remove in a major.
    // @ts-expect-error: deprecated.
    if (style === 1 || style === "1") return "one";
    if (style !== "tab" && style !== "one" && style !== "mixed") throw new Error("Cannot serialize items with `" + style + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
    return style;
}


function $5ca2d3352d060620$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $409727d164b622a0$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $c61b569b3e52b749$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === "list" && parent.ordered) bullet = (typeof parent.start === "number" && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === "tab" || listItemIndent === "mixed" && (parent && parent.type === "list" && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + " ".repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter("listItem");
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? "" : " ".repeat(size)) + line;
        return (blank ? bullet : bullet + " ".repeat(size - bullet.length)) + line;
    }
}



const $ee66b7655bfc3626$export$a427a608608b215f = {
    exit: {
        taskListCheckValueChecked: $ee66b7655bfc3626$var$exitCheck,
        taskListCheckValueUnchecked: $ee66b7655bfc3626$var$exitCheck,
        paragraph: $ee66b7655bfc3626$var$exitParagraphWithTaskListItem
    }
};
const $ee66b7655bfc3626$export$9975722e7e834b78 = {
    unsafe: [
        {
            atBreak: true,
            character: "-",
            after: "[:|-]"
        }
    ],
    handlers: {
        listItem: $ee66b7655bfc3626$var$listItemWithTaskListItem
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ee66b7655bfc3626$var$exitCheck(token) {
    const node = /** @type {ListItem} */ this.stack[this.stack.length - 2];
    // We’re always in a paragraph, in a list item.
    node.checked = token.type === "taskListCheckValueChecked";
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ee66b7655bfc3626$var$exitParagraphWithTaskListItem(token) {
    const parent = /** @type {Parents} */ this.stack[this.stack.length - 2];
    if (parent && parent.type === "listItem" && typeof parent.checked === "boolean") {
        const node = /** @type {Paragraph} */ this.stack[this.stack.length - 1];
        const head = node.children[0];
        if (head && head.type === "text") {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === "paragraph") {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === "number") {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $ee66b7655bfc3626$var$listItemWithTaskListItem(node, parent, context, safeOptions) {
    const head = node.children[0];
    const checkable = typeof node.checked === "boolean" && head && head.type === "paragraph";
    const checkbox = "[" + (node.checked ? "x" : " ") + "] ";
    const tracker = (0, $e9b033e355d7af7a$export$6b2a7d5132615086)(safeOptions);
    if (checkable) tracker.move(checkbox);
    let value = (0, $5ca2d3352d060620$export$76c7e83ecc9cdf05)(node, parent, context, {
        ...safeOptions,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


function $0f98f7a2d0c82f1c$export$95adae814eb7433e() {
    return [
        (0, $486551edb37ede8c$export$b6afdfff2163546f),
        (0, $0f121ba590f25e9f$export$c9d5ad4bdf6ff801)(),
        (0, $ae63166f2fe190e7$export$34d64e709dd0b9bb),
        (0, $38fc5e4f686fdcde$export$8bd0ec8ecf6adb7d),
        (0, $ee66b7655bfc3626$export$a427a608608b215f)
    ];
}
function $0f98f7a2d0c82f1c$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $486551edb37ede8c$export$d3ace9096b01c39d),
            (0, $0f121ba590f25e9f$export$3727766a73a6c09f)(),
            (0, $ae63166f2fe190e7$export$1632835bd2c84956),
            (0, $38fc5e4f686fdcde$export$dafcad76ea6e0045)(options),
            (0, $ee66b7655bfc3626$export$9975722e7e834b78)
        ]
    };
}


function $ef9b7cac3038e51d$export$2e2bcd8739ae039(options = {}) {
    const data = this.data();
    add("micromarkExtensions", (0, $d3faee55b3d31e7a$export$59ffe8c4d7a4aab2)(options));
    add("fromMarkdownExtensions", (0, $0f98f7a2d0c82f1c$export$95adae814eb7433e)());
    add("toMarkdownExtensions", (0, $0f98f7a2d0c82f1c$export$ea77de6901e7c72b)(options));
    /**
   * @param {string} field
   * @param {unknown} value
   */ function add(field, value) {
        const list = /** @type {unknown[]} */ // Other extensions
        /* c8 ignore next 2 */ data[field] ? data[field] : data[field] = [];
        list.push(value);
    }
}


var $71a4fede2ecb9267$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($71a4fede2ecb9267$export$7debb50ef11d5e0b || ($71a4fede2ecb9267$export$7debb50ef11d5e0b = {}));
var $71a4fede2ecb9267$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($71a4fede2ecb9267$export$4aa2142c225fd5c7 || ($71a4fede2ecb9267$export$4aa2142c225fd5c7 = {}));
const $71a4fede2ecb9267$export$5716da67bfaa244d = $71a4fede2ecb9267$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $71a4fede2ecb9267$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $71a4fede2ecb9267$export$5716da67bfaa244d.undefined;
        case "string":
            return $71a4fede2ecb9267$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $71a4fede2ecb9267$export$5716da67bfaa244d.nan : $71a4fede2ecb9267$export$5716da67bfaa244d.number;
        case "boolean":
            return $71a4fede2ecb9267$export$5716da67bfaa244d.boolean;
        case "function":
            return $71a4fede2ecb9267$export$5716da67bfaa244d.function;
        case "bigint":
            return $71a4fede2ecb9267$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $71a4fede2ecb9267$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $71a4fede2ecb9267$export$5716da67bfaa244d.array;
            if (data === null) return $71a4fede2ecb9267$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $71a4fede2ecb9267$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $71a4fede2ecb9267$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $71a4fede2ecb9267$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $71a4fede2ecb9267$export$5716da67bfaa244d.date;
            return $71a4fede2ecb9267$export$5716da67bfaa244d.object;
        default:
            return $71a4fede2ecb9267$export$5716da67bfaa244d.unknown;
    }
};
const $71a4fede2ecb9267$export$5ba560653e4a1035 = $71a4fede2ecb9267$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $71a4fede2ecb9267$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $71a4fede2ecb9267$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $71a4fede2ecb9267$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$71a4fede2ecb9267$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $71a4fede2ecb9267$export$f98dac4b251ab333(issues);
    return error;
};
const $71a4fede2ecb9267$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $71a4fede2ecb9267$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $71a4fede2ecb9267$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$71a4fede2ecb9267$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$71a4fede2ecb9267$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$71a4fede2ecb9267$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $71a4fede2ecb9267$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $71a4fede2ecb9267$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $71a4fede2ecb9267$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $71a4fede2ecb9267$var$overrideErrorMap = $71a4fede2ecb9267$export$341b0b6e0a6f5099;
function $71a4fede2ecb9267$export$1097a8289cfd22d7(map) {
    $71a4fede2ecb9267$var$overrideErrorMap = map;
}
function $71a4fede2ecb9267$export$32f27c719778d4c4() {
    return $71a4fede2ecb9267$var$overrideErrorMap;
}
const $71a4fede2ecb9267$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
const $71a4fede2ecb9267$export$1526d2e05f74572 = [];
function $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $71a4fede2ecb9267$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $71a4fede2ecb9267$export$32f27c719778d4c4(),
            $71a4fede2ecb9267$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $71a4fede2ecb9267$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $71a4fede2ecb9267$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $71a4fede2ecb9267$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $71a4fede2ecb9267$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $71a4fede2ecb9267$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (typeof value.value !== "undefined" || pair.alwaysSet) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $71a4fede2ecb9267$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $71a4fede2ecb9267$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $71a4fede2ecb9267$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $71a4fede2ecb9267$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $71a4fede2ecb9267$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $71a4fede2ecb9267$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $71a4fede2ecb9267$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $71a4fede2ecb9267$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($71a4fede2ecb9267$var$errorUtil || ($71a4fede2ecb9267$var$errorUtil = {}));
class $71a4fede2ecb9267$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $71a4fede2ecb9267$var$handleResult = (ctx, result)=>{
    if ($71a4fede2ecb9267$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $71a4fede2ecb9267$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $71a4fede2ecb9267$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $71a4fede2ecb9267$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $71a4fede2ecb9267$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $71a4fede2ecb9267$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $71a4fede2ecb9267$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $71a4fede2ecb9267$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($71a4fede2ecb9267$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $71a4fede2ecb9267$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $71a4fede2ecb9267$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $71a4fede2ecb9267$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($71a4fede2ecb9267$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $71a4fede2ecb9267$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $71a4fede2ecb9267$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $71a4fede2ecb9267$export$a60af00cc0ce2582({
            schema: this,
            typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $71a4fede2ecb9267$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $71a4fede2ecb9267$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $71a4fede2ecb9267$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $71a4fede2ecb9267$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $71a4fede2ecb9267$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $71a4fede2ecb9267$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $71a4fede2ecb9267$export$a60af00cc0ce2582({
            ...$71a4fede2ecb9267$var$processCreateParams(this._def),
            schema: this,
            typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $71a4fede2ecb9267$export$bb19b37874861e7e({
            ...$71a4fede2ecb9267$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $71a4fede2ecb9267$export$66b0c798a395271f({
            typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$71a4fede2ecb9267$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $71a4fede2ecb9267$export$75a44ec6249ac76b({
            ...$71a4fede2ecb9267$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $71a4fede2ecb9267$export$a3c3ef8a0e95c6da.create(this, target);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $71a4fede2ecb9267$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $71a4fede2ecb9267$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $71a4fede2ecb9267$var$ulidRegex = /[0-9A-HJKMNP-TV-Z]{26}/;
const $71a4fede2ecb9267$var$uuidRegex = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
const $71a4fede2ecb9267$var$emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $71a4fede2ecb9267$var$emojiRegex = /^(\p{Extended_Pictographic}|\p{Emoji_Component})+$/u;
const $71a4fede2ecb9267$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $71a4fede2ecb9267$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $71a4fede2ecb9267$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $71a4fede2ecb9267$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $71a4fede2ecb9267$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $71a4fede2ecb9267$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $71a4fede2ecb9267$export$1230eb29b8d3b502 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._regex = (regex, validation, message)=>this.refinement((data)=>regex.test(data), {
                validation: validation,
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string,
                ...$71a4fede2ecb9267$var$errorUtil.errToObj(message)
            });
        /**
         * @deprecated Use z.string().min(1) instead.
         * @see {@link ZodString.min}
         */ this.nonempty = (message)=>this.min(1, $71a4fede2ecb9267$var$errorUtil.errToObj(message));
        this.trim = ()=>new $71a4fede2ecb9267$export$1230eb29b8d3b502({
                ...this._def,
                checks: [
                    ...this._def.checks,
                    {
                        kind: "trim"
                    }
                ]
            });
        this.toLowerCase = ()=>new $71a4fede2ecb9267$export$1230eb29b8d3b502({
                ...this._def,
                checks: [
                    ...this._def.checks,
                    {
                        kind: "toLowerCase"
                    }
                ]
            });
        this.toUpperCase = ()=>new $71a4fede2ecb9267$export$1230eb29b8d3b502({
                ...this._def,
                checks: [
                    ...this._def.checks,
                    {
                        kind: "toUpperCase"
                    }
                ]
            });
    }
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        const status = new $71a4fede2ecb9267$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$71a4fede2ecb9267$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$71a4fede2ecb9267$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$71a4fede2ecb9267$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$71a4fede2ecb9267$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$71a4fede2ecb9267$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$71a4fede2ecb9267$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $71a4fede2ecb9267$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$71a4fede2ecb9267$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $71a4fede2ecb9267$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _addCheck(check) {
        return new $71a4fede2ecb9267$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$71a4fede2ecb9267$var$errorUtil.errToObj(message)
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$71a4fede2ecb9267$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $71a4fede2ecb9267$export$1230eb29b8d3b502({
        checks: [],
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $71a4fede2ecb9267$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $71a4fede2ecb9267$export$5b070a55c0c43e09 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $71a4fede2ecb9267$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$71a4fede2ecb9267$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($71a4fede2ecb9267$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $71a4fede2ecb9267$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $71a4fede2ecb9267$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $71a4fede2ecb9267$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $71a4fede2ecb9267$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $71a4fede2ecb9267$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $71a4fede2ecb9267$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $71a4fede2ecb9267$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $71a4fede2ecb9267$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $71a4fede2ecb9267$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$71a4fede2ecb9267$export$5b070a55c0c43e09.create = (params)=>{
    return new $71a4fede2ecb9267$export$5b070a55c0c43e09({
        checks: [],
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$67d741fd70ff98f4 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $71a4fede2ecb9267$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $71a4fede2ecb9267$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $71a4fede2ecb9267$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $71a4fede2ecb9267$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $71a4fede2ecb9267$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $71a4fede2ecb9267$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $71a4fede2ecb9267$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $71a4fede2ecb9267$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $71a4fede2ecb9267$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$71a4fede2ecb9267$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $71a4fede2ecb9267$export$67d741fd70ff98f4({
        checks: [],
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$723d146f80596191 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        return $71a4fede2ecb9267$export$c6813a8d51f77eaf(input.data);
    }
}
$71a4fede2ecb9267$export$723d146f80596191.create = (params)=>{
    return new $71a4fede2ecb9267$export$723d146f80596191({
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$e974be33bdc55521 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_date
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        const status = new $71a4fede2ecb9267$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $71a4fede2ecb9267$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $71a4fede2ecb9267$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $71a4fede2ecb9267$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$71a4fede2ecb9267$export$e974be33bdc55521.create = (params)=>{
    return new $71a4fede2ecb9267$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodDate,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$bcc3b40f6b638044 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        return $71a4fede2ecb9267$export$c6813a8d51f77eaf(input.data);
    }
}
$71a4fede2ecb9267$export$bcc3b40f6b638044.create = (params)=>{
    return new $71a4fede2ecb9267$export$bcc3b40f6b638044({
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodSymbol,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$4e780e961c30340d extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        return $71a4fede2ecb9267$export$c6813a8d51f77eaf(input.data);
    }
}
$71a4fede2ecb9267$export$4e780e961c30340d.create = (params)=>{
    return new $71a4fede2ecb9267$export$4e780e961c30340d({
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodUndefined,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$a96281f914484f2d extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        return $71a4fede2ecb9267$export$c6813a8d51f77eaf(input.data);
    }
}
$71a4fede2ecb9267$export$a96281f914484f2d.create = (params)=>{
    return new $71a4fede2ecb9267$export$a96281f914484f2d({
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodNull,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$b9d1edb536b4e4eb extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $71a4fede2ecb9267$export$c6813a8d51f77eaf(input.data);
    }
}
$71a4fede2ecb9267$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $71a4fede2ecb9267$export$b9d1edb536b4e4eb({
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodAny,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$ef3b1bb1630977ae extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $71a4fede2ecb9267$export$c6813a8d51f77eaf(input.data);
    }
}
$71a4fede2ecb9267$export$ef3b1bb1630977ae.create = (params)=>{
    return new $71a4fede2ecb9267$export$ef3b1bb1630977ae({
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodUnknown,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$1e576a20c3ce9fb5 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
            code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
            expected: $71a4fede2ecb9267$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $71a4fede2ecb9267$export$9a105a556e65c2c0;
    }
}
$71a4fede2ecb9267$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $71a4fede2ecb9267$export$1e576a20c3ce9fb5({
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodNever,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$7d39f5df85f21031 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        return $71a4fede2ecb9267$export$c6813a8d51f77eaf(input.data);
    }
}
$71a4fede2ecb9267$export$7d39f5df85f21031.create = (params)=>{
    return new $71a4fede2ecb9267$export$7d39f5df85f21031({
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodVoid,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$7acfc3e64785411 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.array) {
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $71a4fede2ecb9267$export$5ba560653e4a1035.too_big : $71a4fede2ecb9267$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                    code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                    code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $71a4fede2ecb9267$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $71a4fede2ecb9267$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $71a4fede2ecb9267$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $71a4fede2ecb9267$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $71a4fede2ecb9267$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $71a4fede2ecb9267$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $71a4fede2ecb9267$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $71a4fede2ecb9267$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $71a4fede2ecb9267$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $71a4fede2ecb9267$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$71a4fede2ecb9267$export$7acfc3e64785411.create = (schema, params)=>{
    return new $71a4fede2ecb9267$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodArray,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
function $71a4fede2ecb9267$var$deepPartialify(schema) {
    if (schema instanceof $71a4fede2ecb9267$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $71a4fede2ecb9267$export$aa56fec1e9d629b8.create($71a4fede2ecb9267$var$deepPartialify(fieldSchema));
        }
        return new $71a4fede2ecb9267$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $71a4fede2ecb9267$export$7acfc3e64785411) return new $71a4fede2ecb9267$export$7acfc3e64785411({
        ...schema._def,
        type: $71a4fede2ecb9267$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $71a4fede2ecb9267$export$aa56fec1e9d629b8) return $71a4fede2ecb9267$export$aa56fec1e9d629b8.create($71a4fede2ecb9267$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $71a4fede2ecb9267$export$aaac0b8b429cef5) return $71a4fede2ecb9267$export$aaac0b8b429cef5.create($71a4fede2ecb9267$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $71a4fede2ecb9267$export$e2a18bb771d8e6a3) return $71a4fede2ecb9267$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$71a4fede2ecb9267$var$deepPartialify(item)));
    else return schema;
}
class $71a4fede2ecb9267$export$736315c5b55efbad extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $71a4fede2ecb9267$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $71a4fede2ecb9267$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $71a4fede2ecb9267$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $71a4fede2ecb9267$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                        code: $71a4fede2ecb9267$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $71a4fede2ecb9267$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $71a4fede2ecb9267$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $71a4fede2ecb9267$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $71a4fede2ecb9267$var$errorUtil.errToObj;
        return new $71a4fede2ecb9267$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $71a4fede2ecb9267$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $71a4fede2ecb9267$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $71a4fede2ecb9267$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $71a4fede2ecb9267$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $71a4fede2ecb9267$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $71a4fede2ecb9267$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $71a4fede2ecb9267$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $71a4fede2ecb9267$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $71a4fede2ecb9267$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $71a4fede2ecb9267$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $71a4fede2ecb9267$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $71a4fede2ecb9267$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $71a4fede2ecb9267$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $71a4fede2ecb9267$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $71a4fede2ecb9267$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $71a4fede2ecb9267$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $71a4fede2ecb9267$var$createZodEnum($71a4fede2ecb9267$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$71a4fede2ecb9267$export$736315c5b55efbad.create = (shape, params)=>{
    return new $71a4fede2ecb9267$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $71a4fede2ecb9267$export$1e576a20c3ce9fb5.create(),
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodObject,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
$71a4fede2ecb9267$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $71a4fede2ecb9267$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $71a4fede2ecb9267$export$1e576a20c3ce9fb5.create(),
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodObject,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
$71a4fede2ecb9267$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $71a4fede2ecb9267$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $71a4fede2ecb9267$export$1e576a20c3ce9fb5.create(),
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodObject,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$a8b236cb5070a311 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $71a4fede2ecb9267$export$f98dac4b251ab333(result.ctx.common.issues));
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $71a4fede2ecb9267$export$f98dac4b251ab333(issues));
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$71a4fede2ecb9267$export$a8b236cb5070a311.create = (types, params)=>{
    return new $71a4fede2ecb9267$export$a8b236cb5070a311({
        options: types,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodUnion,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $71a4fede2ecb9267$var$getDiscriminator = (type)=>{
    if (type instanceof $71a4fede2ecb9267$export$378d0cfce37406e6) return $71a4fede2ecb9267$var$getDiscriminator(type.schema);
    else if (type instanceof $71a4fede2ecb9267$export$a60af00cc0ce2582) return $71a4fede2ecb9267$var$getDiscriminator(type.innerType());
    else if (type instanceof $71a4fede2ecb9267$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $71a4fede2ecb9267$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $71a4fede2ecb9267$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $71a4fede2ecb9267$export$bb19b37874861e7e) return $71a4fede2ecb9267$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $71a4fede2ecb9267$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $71a4fede2ecb9267$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $71a4fede2ecb9267$export$5ef2424805ac76a3 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.object) {
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $71a4fede2ecb9267$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $71a4fede2ecb9267$export$5ef2424805ac76a3({
            typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$71a4fede2ecb9267$var$processCreateParams(params)
        });
    }
}
function $71a4fede2ecb9267$var$mergeValues(a, b) {
    const aType = $71a4fede2ecb9267$export$3e9057828ebd5c7a(a);
    const bType = $71a4fede2ecb9267$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $71a4fede2ecb9267$export$5716da67bfaa244d.object && bType === $71a4fede2ecb9267$export$5716da67bfaa244d.object) {
        const bKeys = $71a4fede2ecb9267$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $71a4fede2ecb9267$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $71a4fede2ecb9267$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $71a4fede2ecb9267$export$5716da67bfaa244d.array && bType === $71a4fede2ecb9267$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $71a4fede2ecb9267$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $71a4fede2ecb9267$export$5716da67bfaa244d.date && bType === $71a4fede2ecb9267$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $71a4fede2ecb9267$export$c02deaf0bb5203d4 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($71a4fede2ecb9267$export$afa861e3c5730743(parsedLeft) || $71a4fede2ecb9267$export$afa861e3c5730743(parsedRight)) return $71a4fede2ecb9267$export$9a105a556e65c2c0;
            const merged = $71a4fede2ecb9267$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                    code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $71a4fede2ecb9267$export$9a105a556e65c2c0;
            }
            if ($71a4fede2ecb9267$export$910b6cdd390341b3(parsedLeft) || $71a4fede2ecb9267$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$71a4fede2ecb9267$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $71a4fede2ecb9267$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodIntersection,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$e2a18bb771d8e6a3 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.array) {
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $71a4fede2ecb9267$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $71a4fede2ecb9267$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $71a4fede2ecb9267$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $71a4fede2ecb9267$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$71a4fede2ecb9267$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $71a4fede2ecb9267$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$a2acc09968cb4b7f extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.object) {
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $71a4fede2ecb9267$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $71a4fede2ecb9267$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $71a4fede2ecb9267$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $71a4fede2ecb9267$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $71a4fede2ecb9267$export$19342e026b58ebb7) return new $71a4fede2ecb9267$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodRecord,
            ...$71a4fede2ecb9267$var$processCreateParams(third)
        });
        return new $71a4fede2ecb9267$export$a2acc09968cb4b7f({
            keyType: $71a4fede2ecb9267$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodRecord,
            ...$71a4fede2ecb9267$var$processCreateParams(second)
        });
    }
}
class $71a4fede2ecb9267$export$163b6a2b712d9542 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.map) {
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $71a4fede2ecb9267$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $71a4fede2ecb9267$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $71a4fede2ecb9267$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $71a4fede2ecb9267$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$71a4fede2ecb9267$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $71a4fede2ecb9267$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodMap,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$977057706f816712 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.set) {
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                    code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                    code: $71a4fede2ecb9267$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $71a4fede2ecb9267$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $71a4fede2ecb9267$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $71a4fede2ecb9267$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $71a4fede2ecb9267$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $71a4fede2ecb9267$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $71a4fede2ecb9267$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$71a4fede2ecb9267$export$977057706f816712.create = (valueType, params)=>{
    return new $71a4fede2ecb9267$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodSet,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$d4602ba55673f53c extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.function) {
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $71a4fede2ecb9267$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $71a4fede2ecb9267$export$32f27c719778d4c4(),
                    $71a4fede2ecb9267$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $71a4fede2ecb9267$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $71a4fede2ecb9267$export$32f27c719778d4c4(),
                    $71a4fede2ecb9267$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $71a4fede2ecb9267$export$3f196b0127d6e50a) return $71a4fede2ecb9267$export$c6813a8d51f77eaf(async (...args)=>{
            const error = new $71a4fede2ecb9267$export$f98dac4b251ab333([]);
            const parsedArgs = await this._def.args.parseAsync(args, params).catch((e)=>{
                error.addIssue(makeArgsIssue(args, e));
                throw error;
            });
            const result = await fn(...parsedArgs);
            const parsedReturns = await this._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                error.addIssue(makeReturnsIssue(result, e));
                throw error;
            });
            return parsedReturns;
        });
        else return $71a4fede2ecb9267$export$c6813a8d51f77eaf((...args)=>{
            const parsedArgs = this._def.args.safeParse(args, params);
            if (!parsedArgs.success) throw new $71a4fede2ecb9267$export$f98dac4b251ab333([
                makeArgsIssue(args, parsedArgs.error)
            ]);
            const result = fn(...parsedArgs.data);
            const parsedReturns = this._def.returns.safeParse(result, params);
            if (!parsedReturns.success) throw new $71a4fede2ecb9267$export$f98dac4b251ab333([
                makeReturnsIssue(result, parsedReturns.error)
            ]);
            return parsedReturns.data;
        });
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $71a4fede2ecb9267$export$d4602ba55673f53c({
            ...this._def,
            args: $71a4fede2ecb9267$export$e2a18bb771d8e6a3.create(items).rest($71a4fede2ecb9267$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $71a4fede2ecb9267$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $71a4fede2ecb9267$export$d4602ba55673f53c({
            args: args ? args : $71a4fede2ecb9267$export$e2a18bb771d8e6a3.create([]).rest($71a4fede2ecb9267$export$ef3b1bb1630977ae.create()),
            returns: returns || $71a4fede2ecb9267$export$ef3b1bb1630977ae.create(),
            typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodFunction,
            ...$71a4fede2ecb9267$var$processCreateParams(params)
        });
    }
}
class $71a4fede2ecb9267$export$378d0cfce37406e6 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$71a4fede2ecb9267$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $71a4fede2ecb9267$export$378d0cfce37406e6({
        getter: getter,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodLazy,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$7e44096782a165d3 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$71a4fede2ecb9267$export$7e44096782a165d3.create = (value, params)=>{
    return new $71a4fede2ecb9267$export$7e44096782a165d3({
        value: value,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodLiteral,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
function $71a4fede2ecb9267$var$createZodEnum(values, params) {
    return new $71a4fede2ecb9267$export$d325d1f0e1c20179({
        values: values,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodEnum,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
}
class $71a4fede2ecb9267$export$d325d1f0e1c20179 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                expected: $71a4fede2ecb9267$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        return $71a4fede2ecb9267$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $71a4fede2ecb9267$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $71a4fede2ecb9267$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$71a4fede2ecb9267$export$d325d1f0e1c20179.create = $71a4fede2ecb9267$var$createZodEnum;
class $71a4fede2ecb9267$export$370b2e8d6d6f5c56 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $71a4fede2ecb9267$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.string && ctx.parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.number) {
            const expectedValues = $71a4fede2ecb9267$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                expected: $71a4fede2ecb9267$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $71a4fede2ecb9267$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        return $71a4fede2ecb9267$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$71a4fede2ecb9267$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $71a4fede2ecb9267$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodNativeEnum,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$3f196b0127d6e50a extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $71a4fede2ecb9267$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $71a4fede2ecb9267$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$71a4fede2ecb9267$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $71a4fede2ecb9267$export$3f196b0127d6e50a({
        type: schema,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodPromise,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$a60af00cc0ce2582 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $71a4fede2ecb9267$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data);
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        const checkCtx = {
            addIssue: (arg)=>{
                $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $71a4fede2ecb9267$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $71a4fede2ecb9267$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$71a4fede2ecb9267$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$71a4fede2ecb9267$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $71a4fede2ecb9267$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$71a4fede2ecb9267$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $71a4fede2ecb9267$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
$71a4fede2ecb9267$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $71a4fede2ecb9267$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodEffects,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$aa56fec1e9d629b8 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $71a4fede2ecb9267$export$5716da67bfaa244d.undefined) return $71a4fede2ecb9267$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$71a4fede2ecb9267$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $71a4fede2ecb9267$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodOptional,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$aaac0b8b429cef5 extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $71a4fede2ecb9267$export$5716da67bfaa244d.null) return $71a4fede2ecb9267$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$71a4fede2ecb9267$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $71a4fede2ecb9267$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodNullable,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$bb19b37874861e7e extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $71a4fede2ecb9267$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$71a4fede2ecb9267$export$bb19b37874861e7e.create = (type, params)=>{
    return new $71a4fede2ecb9267$export$bb19b37874861e7e({
        innerType: type,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$75a44ec6249ac76b extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($71a4fede2ecb9267$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $71a4fede2ecb9267$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $71a4fede2ecb9267$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$71a4fede2ecb9267$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $71a4fede2ecb9267$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
class $71a4fede2ecb9267$export$26ccfa0145e8511f extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $71a4fede2ecb9267$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $71a4fede2ecb9267$export$db7caee60e5d514d(ctx, {
                code: $71a4fede2ecb9267$export$5ba560653e4a1035.invalid_type,
                expected: $71a4fede2ecb9267$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $71a4fede2ecb9267$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$71a4fede2ecb9267$export$26ccfa0145e8511f.create = (params)=>{
    return new $71a4fede2ecb9267$export$26ccfa0145e8511f({
        typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodNaN,
        ...$71a4fede2ecb9267$var$processCreateParams(params)
    });
};
const $71a4fede2ecb9267$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $71a4fede2ecb9267$export$66b0c798a395271f extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $71a4fede2ecb9267$export$a3c3ef8a0e95c6da extends $71a4fede2ecb9267$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $71a4fede2ecb9267$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $71a4fede2ecb9267$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $71a4fede2ecb9267$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $71a4fede2ecb9267$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $71a4fede2ecb9267$export$558106ce543bd011.ZodPipeline
        });
    }
}
const $71a4fede2ecb9267$export$4c00f665f0d4b443 = (check, params = {}, /*
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $71a4fede2ecb9267$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $71a4fede2ecb9267$export$b9d1edb536b4e4eb.create();
};
const $71a4fede2ecb9267$export$1ee8ee30835eab8b = {
    object: $71a4fede2ecb9267$export$736315c5b55efbad.lazycreate
};
var $71a4fede2ecb9267$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
})($71a4fede2ecb9267$export$558106ce543bd011 || ($71a4fede2ecb9267$export$558106ce543bd011 = {}));
const $71a4fede2ecb9267$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$71a4fede2ecb9267$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $71a4fede2ecb9267$export$22b082955e083ec3 = $71a4fede2ecb9267$export$1230eb29b8d3b502.create;
const $71a4fede2ecb9267$export$98e628dec113755e = $71a4fede2ecb9267$export$5b070a55c0c43e09.create;
const $71a4fede2ecb9267$export$9e06de0973666692 = $71a4fede2ecb9267$export$26ccfa0145e8511f.create;
const $71a4fede2ecb9267$export$a0f65b52274bcc00 = $71a4fede2ecb9267$export$67d741fd70ff98f4.create;
const $71a4fede2ecb9267$export$4a21f16c33752377 = $71a4fede2ecb9267$export$723d146f80596191.create;
const $71a4fede2ecb9267$export$324d90190a8b822a = $71a4fede2ecb9267$export$e974be33bdc55521.create;
const $71a4fede2ecb9267$export$8f701197936bc2a6 = $71a4fede2ecb9267$export$bcc3b40f6b638044.create;
const $71a4fede2ecb9267$export$1db45310990710a5 = $71a4fede2ecb9267$export$4e780e961c30340d.create;
const $71a4fede2ecb9267$export$7b1b591b262c240 = $71a4fede2ecb9267$export$a96281f914484f2d.create;
const $71a4fede2ecb9267$export$4154a199d7d90455 = $71a4fede2ecb9267$export$b9d1edb536b4e4eb.create;
const $71a4fede2ecb9267$export$19282c40b967aec6 = $71a4fede2ecb9267$export$ef3b1bb1630977ae.create;
const $71a4fede2ecb9267$export$b3e22bcfd64c1022 = $71a4fede2ecb9267$export$1e576a20c3ce9fb5.create;
const $71a4fede2ecb9267$export$490e536ee7389aeb = $71a4fede2ecb9267$export$7d39f5df85f21031.create;
const $71a4fede2ecb9267$export$2f23118c22fb2630 = $71a4fede2ecb9267$export$7acfc3e64785411.create;
const $71a4fede2ecb9267$export$be5493f9613cbbe = $71a4fede2ecb9267$export$736315c5b55efbad.create;
const $71a4fede2ecb9267$export$8fb0df5f40d0b477 = $71a4fede2ecb9267$export$736315c5b55efbad.strictCreate;
const $71a4fede2ecb9267$export$971dd5b0dfd021b6 = $71a4fede2ecb9267$export$a8b236cb5070a311.create;
const $71a4fede2ecb9267$export$4b888e40c4ee26dd = $71a4fede2ecb9267$export$5ef2424805ac76a3.create;
const $71a4fede2ecb9267$export$bc86dfbf7795668c = $71a4fede2ecb9267$export$c02deaf0bb5203d4.create;
const $71a4fede2ecb9267$export$65e3907585753458 = $71a4fede2ecb9267$export$e2a18bb771d8e6a3.create;
const $71a4fede2ecb9267$export$e5185e241753e543 = $71a4fede2ecb9267$export$a2acc09968cb4b7f.create;
const $71a4fede2ecb9267$export$871de8747c9eaa88 = $71a4fede2ecb9267$export$163b6a2b712d9542.create;
const $71a4fede2ecb9267$export$adaa4cf7ef1b65be = $71a4fede2ecb9267$export$977057706f816712.create;
const $71a4fede2ecb9267$export$44e51c8aac7c2deb = $71a4fede2ecb9267$export$d4602ba55673f53c.create;
const $71a4fede2ecb9267$export$488013bae63b21da = $71a4fede2ecb9267$export$378d0cfce37406e6.create;
const $71a4fede2ecb9267$export$c8ec6e1ec9fefcb0 = $71a4fede2ecb9267$export$7e44096782a165d3.create;
const $71a4fede2ecb9267$export$78a99c8d44d72635 = $71a4fede2ecb9267$export$d325d1f0e1c20179.create;
const $71a4fede2ecb9267$export$6fe7eca19ebe5199 = $71a4fede2ecb9267$export$370b2e8d6d6f5c56.create;
const $71a4fede2ecb9267$export$c957ef27a0ebfd4 = $71a4fede2ecb9267$export$3f196b0127d6e50a.create;
const $71a4fede2ecb9267$export$dc573d8a6576cdb3 = $71a4fede2ecb9267$export$a60af00cc0ce2582.create;
const $71a4fede2ecb9267$export$516e28dec6a4b6d4 = $71a4fede2ecb9267$export$aa56fec1e9d629b8.create;
const $71a4fede2ecb9267$export$133fc36489ac9add = $71a4fede2ecb9267$export$aaac0b8b429cef5.create;
const $71a4fede2ecb9267$export$fc37fe19dfda43ee = $71a4fede2ecb9267$export$a60af00cc0ce2582.createWithPreprocess;
const $71a4fede2ecb9267$export$43f28b24e1eb8181 = $71a4fede2ecb9267$export$a3c3ef8a0e95c6da.create;
const $71a4fede2ecb9267$export$3b3d07727c5b702c = ()=>$71a4fede2ecb9267$export$22b082955e083ec3().optional();
const $71a4fede2ecb9267$export$eb150471a61fced6 = ()=>$71a4fede2ecb9267$export$98e628dec113755e().optional();
const $71a4fede2ecb9267$export$269251733cdcbbf1 = ()=>$71a4fede2ecb9267$export$4a21f16c33752377().optional();
const $71a4fede2ecb9267$export$8c14e57e778d3873 = {
    string: (arg)=>$71a4fede2ecb9267$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$71a4fede2ecb9267$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$71a4fede2ecb9267$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$71a4fede2ecb9267$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$71a4fede2ecb9267$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $71a4fede2ecb9267$export$96c94437c95d7862 = $71a4fede2ecb9267$export$9a105a556e65c2c0;
var $71a4fede2ecb9267$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $71a4fede2ecb9267$export$341b0b6e0a6f5099,
    setErrorMap: $71a4fede2ecb9267$export$1097a8289cfd22d7,
    getErrorMap: $71a4fede2ecb9267$export$32f27c719778d4c4,
    makeIssue: $71a4fede2ecb9267$export$244a85fde9c419ed,
    EMPTY_PATH: $71a4fede2ecb9267$export$1526d2e05f74572,
    addIssueToContext: $71a4fede2ecb9267$export$db7caee60e5d514d,
    ParseStatus: $71a4fede2ecb9267$export$5b20a5c3d05c1f6f,
    INVALID: $71a4fede2ecb9267$export$9a105a556e65c2c0,
    DIRTY: $71a4fede2ecb9267$export$325a211da9693fcf,
    OK: $71a4fede2ecb9267$export$c6813a8d51f77eaf,
    isAborted: $71a4fede2ecb9267$export$afa861e3c5730743,
    isDirty: $71a4fede2ecb9267$export$910b6cdd390341b3,
    isValid: $71a4fede2ecb9267$export$1ea939691cdc45b8,
    isAsync: $71a4fede2ecb9267$export$aefee5ebe1dcfd9e,
    get util () {
        return $71a4fede2ecb9267$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $71a4fede2ecb9267$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $71a4fede2ecb9267$export$5716da67bfaa244d,
    getParsedType: $71a4fede2ecb9267$export$3e9057828ebd5c7a,
    ZodType: $71a4fede2ecb9267$export$19342e026b58ebb7,
    ZodString: $71a4fede2ecb9267$export$1230eb29b8d3b502,
    ZodNumber: $71a4fede2ecb9267$export$5b070a55c0c43e09,
    ZodBigInt: $71a4fede2ecb9267$export$67d741fd70ff98f4,
    ZodBoolean: $71a4fede2ecb9267$export$723d146f80596191,
    ZodDate: $71a4fede2ecb9267$export$e974be33bdc55521,
    ZodSymbol: $71a4fede2ecb9267$export$bcc3b40f6b638044,
    ZodUndefined: $71a4fede2ecb9267$export$4e780e961c30340d,
    ZodNull: $71a4fede2ecb9267$export$a96281f914484f2d,
    ZodAny: $71a4fede2ecb9267$export$b9d1edb536b4e4eb,
    ZodUnknown: $71a4fede2ecb9267$export$ef3b1bb1630977ae,
    ZodNever: $71a4fede2ecb9267$export$1e576a20c3ce9fb5,
    ZodVoid: $71a4fede2ecb9267$export$7d39f5df85f21031,
    ZodArray: $71a4fede2ecb9267$export$7acfc3e64785411,
    ZodObject: $71a4fede2ecb9267$export$736315c5b55efbad,
    ZodUnion: $71a4fede2ecb9267$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $71a4fede2ecb9267$export$5ef2424805ac76a3,
    ZodIntersection: $71a4fede2ecb9267$export$c02deaf0bb5203d4,
    ZodTuple: $71a4fede2ecb9267$export$e2a18bb771d8e6a3,
    ZodRecord: $71a4fede2ecb9267$export$a2acc09968cb4b7f,
    ZodMap: $71a4fede2ecb9267$export$163b6a2b712d9542,
    ZodSet: $71a4fede2ecb9267$export$977057706f816712,
    ZodFunction: $71a4fede2ecb9267$export$d4602ba55673f53c,
    ZodLazy: $71a4fede2ecb9267$export$378d0cfce37406e6,
    ZodLiteral: $71a4fede2ecb9267$export$7e44096782a165d3,
    ZodEnum: $71a4fede2ecb9267$export$d325d1f0e1c20179,
    ZodNativeEnum: $71a4fede2ecb9267$export$370b2e8d6d6f5c56,
    ZodPromise: $71a4fede2ecb9267$export$3f196b0127d6e50a,
    ZodEffects: $71a4fede2ecb9267$export$a60af00cc0ce2582,
    ZodTransformer: $71a4fede2ecb9267$export$a60af00cc0ce2582,
    ZodOptional: $71a4fede2ecb9267$export$aa56fec1e9d629b8,
    ZodNullable: $71a4fede2ecb9267$export$aaac0b8b429cef5,
    ZodDefault: $71a4fede2ecb9267$export$bb19b37874861e7e,
    ZodCatch: $71a4fede2ecb9267$export$75a44ec6249ac76b,
    ZodNaN: $71a4fede2ecb9267$export$26ccfa0145e8511f,
    BRAND: $71a4fede2ecb9267$export$cf2deea74cde46b4,
    ZodBranded: $71a4fede2ecb9267$export$66b0c798a395271f,
    ZodPipeline: $71a4fede2ecb9267$export$a3c3ef8a0e95c6da,
    custom: $71a4fede2ecb9267$export$4c00f665f0d4b443,
    Schema: $71a4fede2ecb9267$export$19342e026b58ebb7,
    ZodSchema: $71a4fede2ecb9267$export$19342e026b58ebb7,
    late: $71a4fede2ecb9267$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $71a4fede2ecb9267$export$558106ce543bd011;
    },
    coerce: $71a4fede2ecb9267$export$8c14e57e778d3873,
    any: $71a4fede2ecb9267$export$4154a199d7d90455,
    array: $71a4fede2ecb9267$export$2f23118c22fb2630,
    bigint: $71a4fede2ecb9267$export$a0f65b52274bcc00,
    boolean: $71a4fede2ecb9267$export$4a21f16c33752377,
    date: $71a4fede2ecb9267$export$324d90190a8b822a,
    discriminatedUnion: $71a4fede2ecb9267$export$4b888e40c4ee26dd,
    effect: $71a4fede2ecb9267$export$dc573d8a6576cdb3,
    "enum": $71a4fede2ecb9267$export$78a99c8d44d72635,
    "function": $71a4fede2ecb9267$export$44e51c8aac7c2deb,
    "instanceof": $71a4fede2ecb9267$export$3d916e7c22dbd8b5,
    intersection: $71a4fede2ecb9267$export$bc86dfbf7795668c,
    lazy: $71a4fede2ecb9267$export$488013bae63b21da,
    literal: $71a4fede2ecb9267$export$c8ec6e1ec9fefcb0,
    map: $71a4fede2ecb9267$export$871de8747c9eaa88,
    nan: $71a4fede2ecb9267$export$9e06de0973666692,
    nativeEnum: $71a4fede2ecb9267$export$6fe7eca19ebe5199,
    never: $71a4fede2ecb9267$export$b3e22bcfd64c1022,
    "null": $71a4fede2ecb9267$export$7b1b591b262c240,
    nullable: $71a4fede2ecb9267$export$133fc36489ac9add,
    number: $71a4fede2ecb9267$export$98e628dec113755e,
    object: $71a4fede2ecb9267$export$be5493f9613cbbe,
    oboolean: $71a4fede2ecb9267$export$269251733cdcbbf1,
    onumber: $71a4fede2ecb9267$export$eb150471a61fced6,
    optional: $71a4fede2ecb9267$export$516e28dec6a4b6d4,
    ostring: $71a4fede2ecb9267$export$3b3d07727c5b702c,
    pipeline: $71a4fede2ecb9267$export$43f28b24e1eb8181,
    preprocess: $71a4fede2ecb9267$export$fc37fe19dfda43ee,
    promise: $71a4fede2ecb9267$export$c957ef27a0ebfd4,
    record: $71a4fede2ecb9267$export$e5185e241753e543,
    set: $71a4fede2ecb9267$export$adaa4cf7ef1b65be,
    strictObject: $71a4fede2ecb9267$export$8fb0df5f40d0b477,
    string: $71a4fede2ecb9267$export$22b082955e083ec3,
    symbol: $71a4fede2ecb9267$export$8f701197936bc2a6,
    transformer: $71a4fede2ecb9267$export$dc573d8a6576cdb3,
    tuple: $71a4fede2ecb9267$export$65e3907585753458,
    "undefined": $71a4fede2ecb9267$export$1db45310990710a5,
    union: $71a4fede2ecb9267$export$971dd5b0dfd021b6,
    unknown: $71a4fede2ecb9267$export$19282c40b967aec6,
    "void": $71a4fede2ecb9267$export$490e536ee7389aeb,
    NEVER: $71a4fede2ecb9267$export$96c94437c95d7862,
    ZodIssueCode: $71a4fede2ecb9267$export$5ba560653e4a1035,
    quotelessJson: $71a4fede2ecb9267$export$913eddeaf297cfea,
    ZodError: $71a4fede2ecb9267$export$f98dac4b251ab333
});



var $6iAGf = parcelRequire("6iAGf");
var $d4a92e0193471692$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($d4a92e0193471692$exports, "__esModule", {
    value: true
});
$d4a92e0193471692$exports.default = void 0;

var $d4a92e0193471692$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $d4a92e0193471692$var$_default = $d4a92e0193471692$exports.default = (0, $d4a92e0193471692$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "M14.59 2.59c-.38-.38-.89-.59-1.42-.59H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8.83c0-.53-.21-1.04-.59-1.41zM15 18H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1m0-4H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1m-2-6V3.5L18.5 9H14c-.55 0-1-.45-1-1"
}), "DescriptionRounded");


var $c055b0bcf60b8545$exports = {};
"use strict";
"use client";

var $4n9Eb = parcelRequire("4n9Eb");
Object.defineProperty($c055b0bcf60b8545$exports, "__esModule", {
    value: true
});
$c055b0bcf60b8545$exports.default = void 0;

var $c055b0bcf60b8545$var$_createSvgIcon = $4n9Eb((parcelRequire("ec9mM")));

var $6iAGf = parcelRequire("6iAGf");
var $c055b0bcf60b8545$var$_default = $c055b0bcf60b8545$exports.default = (0, $c055b0bcf60b8545$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $6iAGf.jsx)("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2m6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56M12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56m2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8M12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96M14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2m.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56M16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2z"
}), "LanguageRounded");





var $1EuC8 = parcelRequire("1EuC8");
function $d88accc9fccb44f6$var$SourceComponent({ source: source, onClick: onClick }) {
    let icon = null;
    let scoreColor = "neutral";
    switch(source.datasource_type){
        case "web_page":
            icon = /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c055b0bcf60b8545$exports))), {});
            break;
        case "file":
            icon = /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d4a92e0193471692$exports))), {});
            break;
        default:
            break;
    }
    if (source.score >= 0.8) scoreColor = "success";
    else if (source.score >= 0.7) scoreColor = "neutral";
    else if (source.score >= 0.5) scoreColor = "warning";
    else if (source.score < 0.5) scoreColor = "danger";
    const handleClick = (0, $1EuC8.useCallback)(()=>{
        onClick?.(source);
    }, [
        source
    ]);
    return /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c221795da3cfda3d$export$2e2bcd8739ae039), {
        variant: "outlined",
        color: "neutral",
        size: "sm",
        className: "truncate",
        sx: {
            maxWidth: "450px",
            marginRight: "auto"
        },
        startDecorator: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
            direction: "row",
            gap: 1,
            children: icon
        }),
        endDecorator: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c51e530d5ca68d95$export$2e2bcd8739ae039), {
            level: "body4",
            variant: "soft",
            color: scoreColor,
            sx: {
                borderRadius: 100,
                ml: 1
            },
            children: source.score?.toFixed(2)
        }),
        onClick: onClick ? handleClick : undefined,
        children: source.source_url && !onClick ? /*#__PURE__*/ (0, $6iAGf.jsx)("a", {
            href: source.source_url || "#",
            target: "_blank",
            children: source.datasource_name || source.source_url
        }) : source.datasource_name || source.source_url
    }, source.chunk_id);
}
var $d88accc9fccb44f6$export$2e2bcd8739ae039 = $d88accc9fccb44f6$var$SourceComponent;


const $8c80a2b4338ff3f0$var$Schema = (0, $71a4fede2ecb9267$export$2e2bcd8739ae039).object({
    query: (0, $71a4fede2ecb9267$export$2e2bcd8739ae039).string().min(1)
});
const $8c80a2b4338ff3f0$var$CopyButton = (props)=>{
    const [copied, setCopied] = (0, $1EuC8.useState)(false);
    const handleCopy = (0, $1EuC8.useCallback)(async ()=>{
        try {
            await navigator.clipboard.writeText(props.text);
            setCopied(true);
            setTimeout(()=>{
                setCopied(false);
            }, 2000);
        } catch (err) {}
    }, [
        props.text
    ]);
    return copied ? /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c33af7c22d14ddc1$export$2e2bcd8739ae039), {
        size: "sm",
        color: "neutral",
        variant: "plain",
        children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($19feae430f2998b0$exports))), {
            fontSize: "sm"
        })
    }) : /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c33af7c22d14ddc1$export$2e2bcd8739ae039), {
        size: "sm",
        color: "neutral",
        variant: "plain",
        onClick: handleCopy,
        children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9c34a6e94ffc2707$exports))), {
            fontSize: "sm"
        })
    });
};
const $8c80a2b4338ff3f0$var$EvalButton = (props)=>{
    const [value, setValue] = (0, $1EuC8.useState)(props.eval);
    const handleClick = (0, $1EuC8.useCallback)(async (value)=>{
        setValue(value);
        await props.handleEvalAnswer?.({
            messageId: props.messageId,
            value: value
        });
    }, [
        props.handleEvalAnswer
    ]);
    return /*#__PURE__*/ (0, $6iAGf.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).Fragment, {
        children: [
            (!value || value === "good") && /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c33af7c22d14ddc1$export$2e2bcd8739ae039), {
                size: "sm",
                color: value ? "success" : "neutral",
                variant: "plain",
                onClick: async (e)=>{
                    e.stopPropagation();
                    await handleClick("good");
                },
                children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($976bbbd90af325f8$exports))), {
                    fontSize: "sm"
                })
            }),
            (!value || value === "bad") && /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c33af7c22d14ddc1$export$2e2bcd8739ae039), {
                size: "sm",
                color: value ? "danger" : "neutral",
                variant: "plain",
                onClick: async (e)=>{
                    e.stopPropagation();
                    await handleClick("bad");
                },
                children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1553ce48ecd80991$exports))), {
                    fontSize: "sm"
                })
            })
        ]
    });
};
function $8c80a2b4338ff3f0$var$ChatBox({ messages: messages, onSubmit: onSubmit, messageTemplates: messageTemplates, initialMessage: initialMessage, readOnly: readOnly, renderAfterMessages: renderAfterMessages, disableWatermark: disableWatermark, agentIconUrl: agentIconUrl, isLoadingConversation: isLoadingConversation, hasMoreMessages: hasMoreMessages, topSettings: topSettings, emptyComponent: emptyComponent, handleLoadMoreMessages: handleLoadMoreMessages, handleEvalAnswer: handleEvalAnswer, handleImprove: handleImprove, handleSourceClick: handleSourceClick, handleAbort: handleAbort }) {
    const session = (0, $e0ddeeb9e921301b$exports.useSession)();
    const scrollableRef = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useRef(null);
    const [isLoading, setIsLoading] = (0, $1EuC8.useState)(false);
    const [firstMsg, setFirstMsg] = (0, $1EuC8.useState)();
    const [hideTemplateMessages, setHideTemplateMessages] = (0, $1EuC8.useState)(false);
    const lastMessageLength = messages?.length > 0 ? messages?.[messages?.length - 1]?.message?.length : 0;
    const methods = (0, $7f239c261aab7111$export$87c0cf8eb5a167e0)({
        resolver: (0, $c93e1755686e840b$export$66b7b5879c70f722)($8c80a2b4338ff3f0$var$Schema),
        defaultValues: {}
    });
    const submit = async ({ query: query })=>{
        if (isLoading) return;
        try {
            setIsLoading(true);
            setHideTemplateMessages(true);
            methods.reset();
            await onSubmit(query);
        } catch (err) {} finally{
            setIsLoading(false);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>{
        if (!scrollableRef.current) return;
        scrollableRef.current.scrollTo(0, scrollableRef.current.scrollHeight);
    }, [
        lastMessageLength
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useEffect(()=>{
        setTimeout(()=>{
            setFirstMsg(initialMessage ? {
                from: "agent",
                message: initialMessage
            } : undefined);
        }, 0);
    }, [
        initialMessage
    ]);
    return /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
        direction: "column",
        gap: 2,
        sx: {
            display: "flex",
            flex: 1,
            flexBasis: "100%",
            maxWidth: "700px",
            width: "100%",
            height: "100%",
            maxHeight: "100%",
            minHeight: "100%",
            mx: "auto"
        },
        children: [
            /*#__PURE__*/ (0, $6iAGf.jsx)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                ref: scrollableRef,
                direction: "column",
                sx: {
                    boxSizing: "border-box",
                    maxWidth: "100%",
                    width: "100%",
                    mx: "auto",
                    flex: 1,
                    maxHeight: "100%",
                    overflowY: "auto",
                    pb: 8,
                    pt: 2
                },
                children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e07878b5de1c0516$exports))), {
                    isReverse: true,
                    useWindow: false,
                    getScrollParent: ()=>scrollableRef.current,
                    loadMore: handleLoadMoreMessages ? handleLoadMoreMessages : ()=>{},
                    hasMore: hasMoreMessages,
                    loader: Array(1).fill(0).map((_, index)=>/*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                            direction: "row",
                            gap: 2,
                            mb: 2,
                            children: [
                                /*#__PURE__*/ (0, $6iAGf.jsx)((0, $9c99723ec254925f$export$2e2bcd8739ae039), {
                                    variant: "circular",
                                    width: 34,
                                    height: 34
                                }),
                                /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                                    gap: 1,
                                    sx: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $6iAGf.jsx)((0, $9c99723ec254925f$export$2e2bcd8739ae039), {
                                            variant: "text",
                                            width: "97%"
                                        }),
                                        /*#__PURE__*/ (0, $6iAGf.jsx)((0, $9c99723ec254925f$export$2e2bcd8739ae039), {
                                            variant: "text",
                                            width: "92%"
                                        }),
                                        /*#__PURE__*/ (0, $6iAGf.jsx)((0, $9c99723ec254925f$export$2e2bcd8739ae039), {
                                            variant: "text",
                                            width: "95%"
                                        })
                                    ]
                                })
                            ]
                        }, index)),
                    children: /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                        gap: 2,
                        children: [
                            firstMsg && /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                                sx: {
                                    width: "100%"
                                },
                                direction: "row",
                                gap: 1,
                                children: [
                                    /*#__PURE__*/ (0, $6iAGf.jsx)((0, $016b7e45bbf1bcde$export$2e2bcd8739ae039), {
                                        size: "sm",
                                        variant: "outlined",
                                        src: agentIconUrl || "/app-rounded-bg-white.png"
                                    }),
                                    /*#__PURE__*/ (0, $6iAGf.jsx)((0, $7a200f4c9addd534$export$2e2bcd8739ae039), {
                                        size: "sm",
                                        variant: "outlined",
                                        color: "primary",
                                        className: "prose-sm message-agent",
                                        sx: {
                                            mr: "auto",
                                            ml: "none",
                                            whiteSpace: "pre-wrap"
                                        },
                                        children: firstMsg?.message
                                    })
                                ]
                            }),
                            isLoadingConversation && /*#__PURE__*/ (0, $6iAGf.jsx)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                                gap: 2,
                                children: Array(1).fill(0).map((_, index)=>/*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                                        direction: "row",
                                        gap: 2,
                                        children: [
                                            /*#__PURE__*/ (0, $6iAGf.jsx)((0, $9c99723ec254925f$export$2e2bcd8739ae039), {
                                                variant: "circular",
                                                width: 34,
                                                height: 34
                                            }),
                                            /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                                                gap: 1,
                                                sx: {
                                                    width: "100%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $6iAGf.jsx)((0, $9c99723ec254925f$export$2e2bcd8739ae039), {
                                                        variant: "text",
                                                        width: "97%"
                                                    }),
                                                    /*#__PURE__*/ (0, $6iAGf.jsx)((0, $9c99723ec254925f$export$2e2bcd8739ae039), {
                                                        variant: "text",
                                                        width: "92%"
                                                    }),
                                                    /*#__PURE__*/ (0, $6iAGf.jsx)((0, $9c99723ec254925f$export$2e2bcd8739ae039), {
                                                        variant: "text",
                                                        width: "95%"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index))
                            }),
                            messages?.length <= 0 && emptyComponent,
                            messages.map((each, index)=>/*#__PURE__*/ (0, $6iAGf.jsx)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                                    sx: {
                                        width: "100%",
                                        maxWidth: "100%",
                                        mr: each.from === "agent" ? "auto" : "none",
                                        ml: each.from === "human" ? "auto" : "none"
                                    },
                                    children: /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                                        sx: {
                                            width: "100%",
                                            maxWidth: "100%"
                                        },
                                        direction: "row",
                                        gap: 1,
                                        children: [
                                            each.from === "agent" && /*#__PURE__*/ (0, $6iAGf.jsx)((0, $016b7e45bbf1bcde$export$2e2bcd8739ae039), {
                                                size: "sm",
                                                variant: "outlined",
                                                src: agentIconUrl || "/app-rounded-bg-white.png"
                                            }),
                                            each.from === "human" && /*#__PURE__*/ (0, $6iAGf.jsx)((0, $016b7e45bbf1bcde$export$2e2bcd8739ae039), {
                                                size: "sm",
                                                variant: "outlined",
                                                src: session?.data?.user?.image || undefined
                                            }),
                                            /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $7a200f4c9addd534$export$2e2bcd8739ae039), {
                                                        size: "sm",
                                                        variant: "outlined",
                                                        className: (0, $f8208f51eaf9f9e6$export$2e2bcd8739ae039)(each.from === "agent" ? "message-agent" : "message-human"),
                                                        color: each.from === "agent" ? "primary" : "neutral",
                                                        sx: (theme)=>({
                                                                overflowY: "hidden",
                                                                overflowX: "auto",
                                                                marginRight: "auto",
                                                                gap: 0,
                                                                maxWidth: "100%",
                                                                // '.prose > *:first-child': {
                                                                //   pt: 1,
                                                                //   mt: 0,
                                                                // },
                                                                // '.prose > *:last-child': {
                                                                //   pb: 1,
                                                                //   mb: 0,
                                                                // },
                                                                py: 1,
                                                                px: 2,
                                                                [" p "]: {
                                                                    m: 0,
                                                                    // p: 0,
                                                                    maxWidth: "100%"
                                                                },
                                                                "h1,h2,h3,h4,h5": {
                                                                    fontSize: theme.fontSize.sm
                                                                },
                                                                table: {
                                                                    overflowX: "auto"
                                                                }
                                                            }),
                                                        children: [
                                                            each.from === "agent" ? /*#__PURE__*/ (0, $6iAGf.jsx)((0, $31bdb7db456b4918$export$83ef7ab426386201), {
                                                                className: "prose-sm prose dark:prose-invert",
                                                                remarkPlugins: [
                                                                    (0, $ef9b7cac3038e51d$export$2e2bcd8739ae039)
                                                                ],
                                                                linkTarget: "_blank",
                                                                children: each.message
                                                            }) : /*#__PURE__*/ (0, $6iAGf.jsx)("p", {
                                                                className: "prose-sm ",
                                                                children: each.message
                                                            }),
                                                            /*#__PURE__*/ (0, $6iAGf.jsx)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                                                                direction: "row",
                                                                justifyContent: "space-between",
                                                                children: (each?.sources?.length || 0) > 0 && /*#__PURE__*/ (0, $6iAGf.jsx)((0, $d6bc128423f5f36a$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        mt: 2,
                                                                        width: "100%",
                                                                        maxWidth: "100%"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $6iAGf.jsxs)("details", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $6iAGf.jsx)("summary", {
                                                                                className: "cursor-pointer",
                                                                                children: "Sources"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $6iAGf.jsx)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                                                                                direction: "column",
                                                                                gap: 1,
                                                                                sx: {
                                                                                    pt: 1
                                                                                },
                                                                                children: each?.sources?.map((source)=>/*#__PURE__*/ (0, $6iAGf.jsx)((0, $d88accc9fccb44f6$export$2e2bcd8739ae039), {
                                                                                        source: source,
                                                                                        onClick: handleSourceClick
                                                                                    }, source.chunk_id))
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    each.from === "agent" && each?.id && /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                                                        direction: "row",
                                                        marginLeft: "auto",
                                                        children: [
                                                            /*#__PURE__*/ (0, $6iAGf.jsx)($8c80a2b4338ff3f0$var$CopyButton, {
                                                                text: each?.message
                                                            }),
                                                            /*#__PURE__*/ (0, $6iAGf.jsx)($8c80a2b4338ff3f0$var$EvalButton, {
                                                                messageId: each?.id,
                                                                handleEvalAnswer: handleEvalAnswer,
                                                                eval: each?.eval
                                                            }),
                                                            handleImprove && /*#__PURE__*/ (0, $6iAGf.jsx)((0, $19d5cd0cd935946e$export$2e2bcd8739ae039), {
                                                                size: "sm",
                                                                variant: "plain",
                                                                color: "neutral",
                                                                startDecorator: /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dc17c59b2b003b31$exports))), {}),
                                                                onClick: ()=>handleImprove(each),
                                                                children: "Improve"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, index)),
                            isLoading && /*#__PURE__*/ (0, $6iAGf.jsx)((0, $fe3d69a7e20c10a9$export$2e2bcd8739ae039), {
                                variant: "soft",
                                color: "neutral",
                                size: "sm",
                                sx: {
                                    mx: "auto",
                                    my: 2
                                }
                            })
                        ]
                    })
                })
            }),
            !!hideTemplateMessages && renderAfterMessages,
            !readOnly && /*#__PURE__*/ (0, $6iAGf.jsxs)("form", {
                style: {
                    maxWidth: "100%",
                    width: "100%",
                    position: "relative",
                    display: "flex",
                    marginTop: "auto",
                    overflow: "visible",
                    background: "none",
                    justifyContent: "center",
                    marginLeft: "auto",
                    marginRight: "auto"
                },
                onSubmit: (e)=>{
                    e.stopPropagation();
                    methods.handleSubmit(submit)(e);
                },
                children: [
                    !hideTemplateMessages && (messageTemplates?.length || 0) > 0 && /*#__PURE__*/ (0, $6iAGf.jsx)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                        direction: "row",
                        gap: 1,
                        sx: {
                            position: "absolute",
                            zIndex: 1,
                            transform: "translateY(-100%)",
                            flexWrap: "wrap",
                            mt: -1,
                            left: "0"
                        },
                        children: messageTemplates?.map((each, idx)=>/*#__PURE__*/ (0, $6iAGf.jsx)((0, $19d5cd0cd935946e$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "soft",
                                onClick: ()=>submit({
                                        query: each
                                    }),
                                children: each
                            }, idx))
                    }),
                    /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                        width: "100%",
                        gap: 0.5,
                        children: [
                            topSettings,
                            /*#__PURE__*/ (0, $6iAGf.jsx)((0, $166bff791ea1ea3d$export$2e2bcd8739ae039), {
                                slotProps: {
                                    textarea: {
                                        id: "chatbox-input"
                                    }
                                },
                                maxRows: 4,
                                minRows: 1,
                                onKeyDown: (e)=>{
                                    if (e.key === "Enter" && !e.shiftKey) {
                                        e.preventDefault();
                                        methods.handleSubmit(submit)(e);
                                    }
                                },
                                sx: {
                                    width: "100%",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    ".MuiTextarea-endDecorator": {
                                        "margin-block-start": "auto"
                                    }
                                },
                                // disabled={!state.currentDatastoreId || state.loading}
                                variant: "outlined",
                                endDecorator: /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                                    direction: "row",
                                    children: [
                                        !isLoading && /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c33af7c22d14ddc1$export$2e2bcd8739ae039), {
                                            size: "sm",
                                            type: "submit",
                                            disabled: isLoading,
                                            sx: {
                                                maxHeight: "100%"
                                            },
                                            children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ae0bb7cfd9538ddc$exports))), {})
                                        }),
                                        isLoading && handleAbort && /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c33af7c22d14ddc1$export$2e2bcd8739ae039), {
                                            size: "sm",
                                            color: "danger",
                                            sx: {
                                                maxHeight: "100%"
                                            },
                                            variant: "soft",
                                            onClick: ()=>{
                                                handleAbort?.();
                                            },
                                            children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b38c869611eac6db$exports))), {})
                                        })
                                    ]
                                }),
                                ...methods.register("query")
                            }),
                            !disableWatermark && /*#__PURE__*/ (0, $6iAGf.jsx)("a", {
                                href: "https://chatsmart.pro",
                                target: "_blank",
                                style: {
                                    textDecoration: "none",
                                    marginLeft: "auto"
                                },
                                children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $d6bc128423f5f36a$export$2e2bcd8739ae039), {
                                    sx: {
                                        mt: 1
                                    },
                                    children: /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $c51e530d5ca68d95$export$2e2bcd8739ae039), {
                                        level: "body3",
                                        children: [
                                            "Powered by",
                                            " ",
                                            /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c51e530d5ca68d95$export$2e2bcd8739ae039), {
                                                color: "primary",
                                                fontWeight: "bold",
                                                children: "Chatsmart"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $8c80a2b4338ff3f0$export$2e2bcd8739ae039 = $8c80a2b4338ff3f0$var$ChatBox;


async function $49513f1113f4f5e2$export$a3521add2594f3c8(stream, onChunk) {
    const reader = stream.getReader();
    let result;
    while(!(result = await reader.read()).done)onChunk(result.value);
}
function $49513f1113f4f5e2$export$89440da1893f4202(onLine) {
    let buffer;
    let position;
    let fieldLength;
    let discardTrailingNewline = false;
    return function onChunk(arr) {
        if (buffer === undefined) {
            buffer = arr;
            position = 0;
            fieldLength = -1;
        } else buffer = $49513f1113f4f5e2$var$concat(buffer, arr);
        const bufLength = buffer.length;
        let lineStart = 0;
        while(position < bufLength){
            if (discardTrailingNewline) {
                if (buffer[position] === 10) lineStart = ++position;
                discardTrailingNewline = false;
            }
            let lineEnd = -1;
            for(; position < bufLength && lineEnd === -1; ++position)switch(buffer[position]){
                case 58:
                    if (fieldLength === -1) fieldLength = position - lineStart;
                    break;
                case 13:
                    discardTrailingNewline = true;
                case 10:
                    lineEnd = position;
                    break;
            }
            if (lineEnd === -1) break;
            onLine(buffer.subarray(lineStart, lineEnd), fieldLength);
            lineStart = position;
            fieldLength = -1;
        }
        if (lineStart === bufLength) buffer = undefined;
        else if (lineStart !== 0) {
            buffer = buffer.subarray(lineStart);
            position -= lineStart;
        }
    };
}
function $49513f1113f4f5e2$export$8c20ab16ac9cf14f(onId, onRetry, onMessage) {
    let message = $49513f1113f4f5e2$var$newMessage();
    const decoder = new TextDecoder();
    return function onLine(line, fieldLength) {
        if (line.length === 0) {
            onMessage === null || onMessage === void 0 || onMessage(message);
            message = $49513f1113f4f5e2$var$newMessage();
        } else if (fieldLength > 0) {
            const field = decoder.decode(line.subarray(0, fieldLength));
            const valueOffset = fieldLength + (line[fieldLength + 1] === 32 ? 2 : 1);
            const value = decoder.decode(line.subarray(valueOffset));
            switch(field){
                case "data":
                    message.data = message.data ? message.data + "\n" + value : value;
                    break;
                case "event":
                    message.event = value;
                    break;
                case "id":
                    onId(message.id = value);
                    break;
                case "retry":
                    const retry = parseInt(value, 10);
                    if (!isNaN(retry)) onRetry(message.retry = retry);
                    break;
            }
        }
    };
}
function $49513f1113f4f5e2$var$concat(a, b) {
    const res = new Uint8Array(a.length + b.length);
    res.set(a);
    res.set(b, a.length);
    return res;
}
function $49513f1113f4f5e2$var$newMessage() {
    return {
        data: "",
        event: "",
        id: "",
        retry: undefined
    };
}


var $88c0fe1a5e0bde62$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $88c0fe1a5e0bde62$export$d7c56894fc591754 = "text/event-stream";
const $88c0fe1a5e0bde62$var$DefaultRetryInterval = 1000;
const $88c0fe1a5e0bde62$var$LastEventId = "last-event-id";
function $88c0fe1a5e0bde62$export$a0ddad8789ba715(input, _a) {
    var { signal: inputSignal, headers: inputHeaders, onopen: inputOnOpen, onmessage: onmessage, onclose: onclose, onerror: onerror, openWhenHidden: openWhenHidden, fetch: inputFetch } = _a, rest = $88c0fe1a5e0bde62$var$__rest(_a, [
        "signal",
        "headers",
        "onopen",
        "onmessage",
        "onclose",
        "onerror",
        "openWhenHidden",
        "fetch"
    ]);
    return new Promise((resolve, reject)=>{
        const headers = Object.assign({}, inputHeaders);
        if (!headers.accept) headers.accept = $88c0fe1a5e0bde62$export$d7c56894fc591754;
        let curRequestController;
        function onVisibilityChange() {
            curRequestController.abort();
            if (!document.hidden) create();
        }
        if (!openWhenHidden) document.addEventListener("visibilitychange", onVisibilityChange);
        let retryInterval = $88c0fe1a5e0bde62$var$DefaultRetryInterval;
        let retryTimer = 0;
        function dispose() {
            document.removeEventListener("visibilitychange", onVisibilityChange);
            window.clearTimeout(retryTimer);
            curRequestController.abort();
        }
        inputSignal === null || inputSignal === void 0 || inputSignal.addEventListener("abort", ()=>{
            dispose();
            resolve();
        });
        const fetch = inputFetch !== null && inputFetch !== void 0 ? inputFetch : window.fetch;
        const onopen = inputOnOpen !== null && inputOnOpen !== void 0 ? inputOnOpen : $88c0fe1a5e0bde62$var$defaultOnOpen;
        async function create() {
            var _a;
            curRequestController = new AbortController();
            try {
                const response = await fetch(input, Object.assign(Object.assign({}, rest), {
                    headers: headers,
                    signal: curRequestController.signal
                }));
                await onopen(response);
                await (0, $49513f1113f4f5e2$export$a3521add2594f3c8)(response.body, (0, $49513f1113f4f5e2$export$89440da1893f4202)((0, $49513f1113f4f5e2$export$8c20ab16ac9cf14f)((id)=>{
                    if (id) headers[$88c0fe1a5e0bde62$var$LastEventId] = id;
                    else delete headers[$88c0fe1a5e0bde62$var$LastEventId];
                }, (retry)=>{
                    retryInterval = retry;
                }, onmessage)));
                onclose === null || onclose === void 0 || onclose();
                dispose();
                resolve();
            } catch (err) {
                if (!curRequestController.signal.aborted) try {
                    const interval = (_a = onerror === null || onerror === void 0 ? void 0 : onerror(err)) !== null && _a !== void 0 ? _a : retryInterval;
                    window.clearTimeout(retryTimer);
                    retryTimer = window.setTimeout(create, interval);
                } catch (innerErr) {
                    dispose();
                    reject(innerErr);
                }
            }
        }
        create();
    });
}
function $88c0fe1a5e0bde62$var$defaultOnOpen(response) {
    const contentType = response.headers.get("content-type");
    if (!(contentType === null || contentType === void 0 ? void 0 : contentType.startsWith($88c0fe1a5e0bde62$export$d7c56894fc591754))) throw new Error(`Expected content-type to be ${$88c0fe1a5e0bde62$export$d7c56894fc591754}, Actual: ${contentType}`);
}



var $1EuC8 = parcelRequire("1EuC8");

var $1EuC8 = parcelRequire("1EuC8");


var $16f05ab202eabde2$exports = {};
"use strict";

$16f05ab202eabde2$exports = (parcelRequire("cUUdJ"));



var $1EuC8 = parcelRequire("1EuC8");
// Shared state between server components and client components
const $fffa9c7be4ab05ff$export$8793edee2d425525 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $fffa9c7be4ab05ff$export$6db089fe7b26f5b6 = /*#__NOINLINE__*/ $fffa9c7be4ab05ff$export$8793edee2d425525();
const $fffa9c7be4ab05ff$export$8b8a958a7f6f130c = Object;
const $fffa9c7be4ab05ff$export$fce6876652108ab = (v)=>v === $fffa9c7be4ab05ff$export$6db089fe7b26f5b6;
const $fffa9c7be4ab05ff$export$f6e2535fb5126e54 = (v)=>typeof v == "function";
const $fffa9c7be4ab05ff$export$2321aea138b44780 = (a, b)=>({
        ...a,
        ...b
    });
const $fffa9c7be4ab05ff$export$ae936b9d47e5870e = (x)=>$fffa9c7be4ab05ff$export$f6e2535fb5126e54(x.then);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $fffa9c7be4ab05ff$var$table = new WeakMap();
// counter of the key
let $fffa9c7be4ab05ff$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $fffa9c7be4ab05ff$export$e9a4e06c7dfb0bd4 = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if ($fffa9c7be4ab05ff$export$8b8a958a7f6f130c(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $fffa9c7be4ab05ff$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$fffa9c7be4ab05ff$var$counter + "~";
        $fffa9c7be4ab05ff$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = "@";
            for(index = 0; index < arg.length; index++)result += $fffa9c7be4ab05ff$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $fffa9c7be4ab05ff$var$table.set(arg, result);
        }
        if (constructor == $fffa9c7be4ab05ff$export$8b8a958a7f6f130c) {
            // Object, sort keys.
            result = "#";
            const keys = $fffa9c7be4ab05ff$export$8b8a958a7f6f130c.keys(arg).sort();
            while(!$fffa9c7be4ab05ff$export$fce6876652108ab(index = keys.pop()))if (!$fffa9c7be4ab05ff$export$fce6876652108ab(arg[index])) result += index + ":" + $fffa9c7be4ab05ff$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $fffa9c7be4ab05ff$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
    return result;
};
// Global state used to deduplicate requests and store listeners
const $fffa9c7be4ab05ff$export$b94ca9901c60634 = new WeakMap();
const $fffa9c7be4ab05ff$var$EMPTY_CACHE = {};
const $fffa9c7be4ab05ff$var$INITIAL_CACHE = {};
const $fffa9c7be4ab05ff$var$STR_UNDEFINED = "undefined";
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $fffa9c7be4ab05ff$export$6e85fd745dc51282 = typeof window != $fffa9c7be4ab05ff$var$STR_UNDEFINED;
const $fffa9c7be4ab05ff$export$842dfe7a9f24298 = typeof document != $fffa9c7be4ab05ff$var$STR_UNDEFINED;
const $fffa9c7be4ab05ff$export$a9116928c9d15917 = ()=>$fffa9c7be4ab05ff$export$6e85fd745dc51282 && typeof window["requestAnimationFrame"] != $fffa9c7be4ab05ff$var$STR_UNDEFINED;
const $fffa9c7be4ab05ff$export$1251d51d9c571b45 = (cache, key)=>{
    const state = $fffa9c7be4ab05ff$export$b94ca9901c60634.get(cache);
    return [
        // Getter
        ()=>!$fffa9c7be4ab05ff$export$fce6876652108ab(key) && cache.get(key) || $fffa9c7be4ab05ff$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$fffa9c7be4ab05ff$export$fce6876652108ab(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $fffa9c7be4ab05ff$var$INITIAL_CACHE)) $fffa9c7be4ab05ff$var$INITIAL_CACHE[key] = prev;
                state[5](key, $fffa9c7be4ab05ff$export$2321aea138b44780(prev, info), prev || $fffa9c7be4ab05ff$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$fffa9c7be4ab05ff$export$fce6876652108ab(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $fffa9c7be4ab05ff$var$INITIAL_CACHE) return $fffa9c7be4ab05ff$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$fffa9c7be4ab05ff$export$fce6876652108ab(key) && cache.get(key) || $fffa9c7be4ab05ff$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $fffa9c7be4ab05ff$var$online = true;
const $fffa9c7be4ab05ff$var$isOnline = ()=>$fffa9c7be4ab05ff$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$fffa9c7be4ab05ff$var$onWindowEvent, $fffa9c7be4ab05ff$var$offWindowEvent] = $fffa9c7be4ab05ff$export$6e85fd745dc51282 && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $fffa9c7be4ab05ff$export$8793edee2d425525,
    $fffa9c7be4ab05ff$export$8793edee2d425525
];
const $fffa9c7be4ab05ff$var$isVisible = ()=>{
    const visibilityState = $fffa9c7be4ab05ff$export$842dfe7a9f24298 && document.visibilityState;
    return $fffa9c7be4ab05ff$export$fce6876652108ab(visibilityState) || visibilityState !== "hidden";
};
const $fffa9c7be4ab05ff$var$initFocus = (callback)=>{
    // focus revalidate
    if ($fffa9c7be4ab05ff$export$842dfe7a9f24298) document.addEventListener("visibilitychange", callback);
    $fffa9c7be4ab05ff$var$onWindowEvent("focus", callback);
    return ()=>{
        if ($fffa9c7be4ab05ff$export$842dfe7a9f24298) document.removeEventListener("visibilitychange", callback);
        $fffa9c7be4ab05ff$var$offWindowEvent("focus", callback);
    };
};
const $fffa9c7be4ab05ff$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $fffa9c7be4ab05ff$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $fffa9c7be4ab05ff$var$online = false;
    };
    $fffa9c7be4ab05ff$var$onWindowEvent("online", onOnline);
    $fffa9c7be4ab05ff$var$onWindowEvent("offline", onOffline);
    return ()=>{
        $fffa9c7be4ab05ff$var$offWindowEvent("online", onOnline);
        $fffa9c7be4ab05ff$var$offWindowEvent("offline", onOffline);
    };
};
const $fffa9c7be4ab05ff$export$f5ab8217e0edff04 = {
    isOnline: $fffa9c7be4ab05ff$var$isOnline,
    isVisible: $fffa9c7be4ab05ff$var$isVisible
};
const $fffa9c7be4ab05ff$export$b1857f3440a65373 = {
    initFocus: $fffa9c7be4ab05ff$var$initFocus,
    initReconnect: $fffa9c7be4ab05ff$var$initReconnect
};
const $fffa9c7be4ab05ff$export$ddb64fe6466374f7 = !(0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).useId;
const $fffa9c7be4ab05ff$export$d2f4d8e74279c212 = !$fffa9c7be4ab05ff$export$6e85fd745dc51282 || "Deno" in window;
// Polyfill requestAnimationFrame
const $fffa9c7be4ab05ff$export$eba6076d3d7d0c06 = (f)=>$fffa9c7be4ab05ff$export$a9116928c9d15917() ? window["requestAnimationFrame"](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $fffa9c7be4ab05ff$export$700979bc83e7db82 = $fffa9c7be4ab05ff$export$d2f4d8e74279c212 ? (0, $1EuC8.useEffect) : (0, $1EuC8.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $fffa9c7be4ab05ff$var$navigatorConnection = typeof navigator !== "undefined" && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $fffa9c7be4ab05ff$export$3723beb60427dc52 = !$fffa9c7be4ab05ff$export$d2f4d8e74279c212 && $fffa9c7be4ab05ff$var$navigatorConnection && ([
    "slow-2g",
    "2g"
].includes($fffa9c7be4ab05ff$var$navigatorConnection.effectiveType) || $fffa9c7be4ab05ff$var$navigatorConnection.saveData);
const $fffa9c7be4ab05ff$export$dfdc1655ccc5b9cb = (key)=>{
    if ($fffa9c7be4ab05ff$export$f6e2535fb5126e54(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = "";
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? $fffa9c7be4ab05ff$export$e9a4e06c7dfb0bd4(key) : "";
    return [
        key,
        args
    ];
};
// Global timestamp.
let $fffa9c7be4ab05ff$var$__timestamp = 0;
const $fffa9c7be4ab05ff$export$3c95c4c8b671ef0 = ()=>++$fffa9c7be4ab05ff$var$__timestamp;
const $fffa9c7be4ab05ff$var$FOCUS_EVENT = 0;
const $fffa9c7be4ab05ff$var$RECONNECT_EVENT = 1;
const $fffa9c7be4ab05ff$var$MUTATE_EVENT = 2;
const $fffa9c7be4ab05ff$var$ERROR_REVALIDATE_EVENT = 3;
var $fffa9c7be4ab05ff$export$10213d6aa5ce32e6 = {
    __proto__: null,
    ERROR_REVALIDATE_EVENT: $fffa9c7be4ab05ff$var$ERROR_REVALIDATE_EVENT,
    FOCUS_EVENT: $fffa9c7be4ab05ff$var$FOCUS_EVENT,
    MUTATE_EVENT: $fffa9c7be4ab05ff$var$MUTATE_EVENT,
    RECONNECT_EVENT: $fffa9c7be4ab05ff$var$RECONNECT_EVENT
};
async function $fffa9c7be4ab05ff$export$c9d44e5bea4509be(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $fffa9c7be4ab05ff$export$2321aea138b44780({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === "boolean" ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === "function" ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($fffa9c7be4ab05ff$export$f6e2535fb5126e54(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $fffa9c7be4ab05ff$export$dfdc1655ccc5b9cb(_k);
        if (!key) return;
        const [get, set] = $fffa9c7be4ab05ff$export$1251d51d9c571b45(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $fffa9c7be4ab05ff$export$b94ca9901c60634.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $fffa9c7be4ab05ff$export$f6e2535fb5126e54(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($fffa9c7be4ab05ff$var$MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $fffa9c7be4ab05ff$export$3c95c4c8b671ef0();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$fffa9c7be4ab05ff$export$fce6876652108ab(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $fffa9c7be4ab05ff$export$fce6876652108ab(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $fffa9c7be4ab05ff$export$f6e2535fb5126e54(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($fffa9c7be4ab05ff$export$f6e2535fb5126e54(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $fffa9c7be4ab05ff$export$ae936b9d47e5870e(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $fffa9c7be4ab05ff$export$6db089fe7b26f5b6
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($fffa9c7be4ab05ff$export$f6e2535fb5126e54(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $fffa9c7be4ab05ff$export$6db089fe7b26f5b6,
                        _c: $fffa9c7be4ab05ff$export$6db089fe7b26f5b6
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $fffa9c7be4ab05ff$export$6db089fe7b26f5b6,
                    _c: $fffa9c7be4ab05ff$export$6db089fe7b26f5b6
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $fffa9c7be4ab05ff$export$3c95c4c8b671ef0();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $fffa9c7be4ab05ff$export$6db089fe7b26f5b6
            });
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $fffa9c7be4ab05ff$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $fffa9c7be4ab05ff$export$4008f5b66f9e0b3c = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$fffa9c7be4ab05ff$export$b94ca9901c60634.has(provider)) {
        const opts = $fffa9c7be4ab05ff$export$2321aea138b44780($fffa9c7be4ab05ff$export$b1857f3440a65373, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $fffa9c7be4ab05ff$export$c9d44e5bea4509be.bind($fffa9c7be4ab05ff$export$6db089fe7b26f5b6, provider);
        let unmount = $fffa9c7be4ab05ff$export$8793edee2d425525;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$fffa9c7be4ab05ff$export$b94ca9901c60634.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $fffa9c7be4ab05ff$export$b94ca9901c60634.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$fffa9c7be4ab05ff$export$d2f4d8e74279c212) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($fffa9c7be4ab05ff$export$6db089fe7b26f5b6, $fffa9c7be4ab05ff$var$revalidateAllKeys.bind($fffa9c7be4ab05ff$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $fffa9c7be4ab05ff$var$FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($fffa9c7be4ab05ff$export$6db089fe7b26f5b6, $fffa9c7be4ab05ff$var$revalidateAllKeys.bind($fffa9c7be4ab05ff$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $fffa9c7be4ab05ff$var$RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $fffa9c7be4ab05ff$export$b94ca9901c60634.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $fffa9c7be4ab05ff$export$b94ca9901c60634.get(provider)[4]
    ];
};
// error retry
const $fffa9c7be4ab05ff$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$fffa9c7be4ab05ff$export$fce6876652108ab(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $fffa9c7be4ab05ff$export$398604a469f7de9a = (currentData, newData)=>$fffa9c7be4ab05ff$export$e9a4e06c7dfb0bd4(currentData) == $fffa9c7be4ab05ff$export$e9a4e06c7dfb0bd4(newData);
// Default cache provider
const [$fffa9c7be4ab05ff$export$69a3209f1a06c04d, $fffa9c7be4ab05ff$export$57e795267c26e600] = $fffa9c7be4ab05ff$export$4008f5b66f9e0b3c(new Map());
// Default config
const $fffa9c7be4ab05ff$export$f84bd70098573c5c = $fffa9c7be4ab05ff$export$2321aea138b44780({
    // events
    onLoadingSlow: $fffa9c7be4ab05ff$export$8793edee2d425525,
    onSuccess: $fffa9c7be4ab05ff$export$8793edee2d425525,
    onError: $fffa9c7be4ab05ff$export$8793edee2d425525,
    onErrorRetry: $fffa9c7be4ab05ff$var$onErrorRetry,
    onDiscarded: $fffa9c7be4ab05ff$export$8793edee2d425525,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $fffa9c7be4ab05ff$export$3723beb60427dc52 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $fffa9c7be4ab05ff$export$3723beb60427dc52 ? 5000 : 3000,
    compare: // providers
    $fffa9c7be4ab05ff$export$398604a469f7de9a,
    isPaused: ()=>false,
    cache: $fffa9c7be4ab05ff$export$69a3209f1a06c04d,
    mutate: $fffa9c7be4ab05ff$export$57e795267c26e600,
    fallback: {}
}, $fffa9c7be4ab05ff$export$f5ab8217e0edff04);
const $fffa9c7be4ab05ff$export$5d86b86a654a7039 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $fffa9c7be4ab05ff$export$2321aea138b44780(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $fffa9c7be4ab05ff$export$2321aea138b44780(f1, f2);
    }
    return v;
};
const $fffa9c7be4ab05ff$var$SWRConfigContext = (0, $1EuC8.createContext)({});
const $fffa9c7be4ab05ff$export$4c7bbecdacc3ca2c = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $1EuC8.useContext)($fffa9c7be4ab05ff$var$SWRConfigContext);
    const isFunctionalConfig = $fffa9c7be4ab05ff$export$f6e2535fb5126e54(value);
    const config = (0, $1EuC8.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $1EuC8.useMemo)(()=>isFunctionalConfig ? config : $fffa9c7be4ab05ff$export$5d86b86a654a7039(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $1EuC8.useRef)($fffa9c7be4ab05ff$export$6db089fe7b26f5b6);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $fffa9c7be4ab05ff$export$4008f5b66f9e0b3c(provider(extendedConfig.cache || $fffa9c7be4ab05ff$export$69a3209f1a06c04d), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $fffa9c7be4ab05ff$export$700979bc83e7db82(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $1EuC8.createElement)($fffa9c7be4ab05ff$var$SWRConfigContext.Provider, $fffa9c7be4ab05ff$export$2321aea138b44780(props, {
        value: extendedConfig
    }));
};
const $fffa9c7be4ab05ff$export$8667f065faedc62c = "$inf$";
// @ts-expect-error
const $fffa9c7be4ab05ff$var$enableDevtools = $fffa9c7be4ab05ff$export$6e85fd745dc51282 && window.__SWR_DEVTOOLS_USE__;
const $fffa9c7be4ab05ff$var$use = $fffa9c7be4ab05ff$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $fffa9c7be4ab05ff$var$setupDevTools = ()=>{
    if ($fffa9c7be4ab05ff$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8)));
};
const $fffa9c7be4ab05ff$export$a3295358bff77e = (args)=>{
    return $fffa9c7be4ab05ff$export$f6e2535fb5126e54(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $fffa9c7be4ab05ff$export$f1dc0e282d4c1c0 = ()=>{
    return $fffa9c7be4ab05ff$export$2321aea138b44780($fffa9c7be4ab05ff$export$f84bd70098573c5c, (0, $1EuC8.useContext)($fffa9c7be4ab05ff$var$SWRConfigContext));
};
const $fffa9c7be4ab05ff$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = $fffa9c7be4ab05ff$export$dfdc1655ccc5b9cb(key_);
    const [, , , PRELOAD] = $fffa9c7be4ab05ff$export$b94ca9901c60634.get($fffa9c7be4ab05ff$export$69a3209f1a06c04d);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $fffa9c7be4ab05ff$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = $fffa9c7be4ab05ff$export$dfdc1655ccc5b9cb(key_);
            const [, , , PRELOAD] = $fffa9c7be4ab05ff$export$b94ca9901c60634.get($fffa9c7be4ab05ff$export$69a3209f1a06c04d);
            if (key.startsWith($fffa9c7be4ab05ff$export$8667f065faedc62c)) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ($fffa9c7be4ab05ff$export$fce6876652108ab(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $fffa9c7be4ab05ff$var$BUILT_IN_MIDDLEWARE = $fffa9c7be4ab05ff$var$use.concat($fffa9c7be4ab05ff$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $fffa9c7be4ab05ff$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $fffa9c7be4ab05ff$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $fffa9c7be4ab05ff$export$a3295358bff77e(args);
        // Merge configurations.
        const config = $fffa9c7be4ab05ff$export$5d86b86a654a7039(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($fffa9c7be4ab05ff$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $fffa9c7be4ab05ff$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $fffa9c7be4ab05ff$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $fffa9c7be4ab05ff$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$fffa9c7be4ab05ff$var$setupDevTools();


/// <reference types="react/experimental" />
const $86b46a0f8c2e4a70$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($1EuC8))).use || ((promise)=>{
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then((v)=>{
            promise.status = "fulfilled";
            promise.value = v;
        }, (e)=>{
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
});
const $86b46a0f8c2e4a70$var$WITH_DEDUPE = {
    dedupe: true
};
const $86b46a0f8c2e4a70$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $fffa9c7be4ab05ff$export$b94ca9901c60634).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $fffa9c7be4ab05ff$export$dfdc1655ccc5b9cb)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $1EuC8.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $1EuC8.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $1EuC8.useRef)(key);
    const fetcherRef = (0, $1EuC8.useRef)(fetcher);
    const configRef = (0, $1EuC8.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $fffa9c7be4ab05ff$export$1251d51d9c571b45)(cache, key);
    const stateDependencies = (0, $1EuC8.useRef)({}).current;
    const fallback = (0, $fffa9c7be4ab05ff$export$fce6876652108ab)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === "data") {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $fffa9c7be4ab05ff$export$fce6876652108ab)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $1EuC8.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $fffa9c7be4ab05ff$export$fce6876652108ab)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $fffa9c7be4ab05ff$export$fce6876652108ab)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $fffa9c7be4ab05ff$export$2321aea138b44780)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $16f05ab202eabde2$exports.useSyncExternalStore)((0, $1EuC8.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $fffa9c7be4ab05ff$export$fce6876652108ab)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $1EuC8.useRef)(data);
    const returnedData = keepPreviousData ? (0, $fffa9c7be4ab05ff$export$fce6876652108ab)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $fffa9c7be4ab05ff$export$fce6876652108ab)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $fffa9c7be4ab05ff$export$fce6876652108ab)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $fffa9c7be4ab05ff$export$fce6876652108ab)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $fffa9c7be4ab05ff$export$fce6876652108ab)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $fffa9c7be4ab05ff$export$fce6876652108ab)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $fffa9c7be4ab05ff$export$fce6876652108ab)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $1EuC8.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $fffa9c7be4ab05ff$export$ddb64fe6466374f7) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $fffa9c7be4ab05ff$export$fce6876652108ab)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $fffa9c7be4ab05ff$export$fce6876652108ab)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $fffa9c7be4ab05ff$export$3c95c4c8b671ef0)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $fffa9c7be4ab05ff$export$6db089fe7b26f5b6);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $fffa9c7be4ab05ff$export$fce6876652108ab)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $fffa9c7be4ab05ff$export$f6e2535fb5126e54)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $fffa9c7be4ab05ff$export$10213d6aa5ce32e6).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $1EuC8.useCallback)((...args)=>{
        return (0, $fffa9c7be4ab05ff$export$c9d44e5bea4509be)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $fffa9c7be4ab05ff$export$700979bc83e7db82)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $fffa9c7be4ab05ff$export$fce6876652108ab)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $fffa9c7be4ab05ff$export$700979bc83e7db82)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $fffa9c7be4ab05ff$export$6db089fe7b26f5b6), $86b46a0f8c2e4a70$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $fffa9c7be4ab05ff$export$10213d6aa5ce32e6).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $fffa9c7be4ab05ff$export$10213d6aa5ce32e6).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $fffa9c7be4ab05ff$export$10213d6aa5ce32e6).MUTATE_EVENT) return revalidate();
            else if (type == (0, $fffa9c7be4ab05ff$export$10213d6aa5ce32e6).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $fffa9c7be4ab05ff$export$e005210ed621746)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $fffa9c7be4ab05ff$export$fce6876652108ab)(data) || (0, $fffa9c7be4ab05ff$export$d2f4d8e74279c212)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $fffa9c7be4ab05ff$export$eba6076d3d7d0c06)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $fffa9c7be4ab05ff$export$700979bc83e7db82)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $fffa9c7be4ab05ff$export$f6e2535fb5126e54)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($86b46a0f8c2e4a70$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $1EuC8.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $fffa9c7be4ab05ff$export$fce6876652108ab)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $fffa9c7be4ab05ff$export$ddb64fe6466374f7) && (0, $fffa9c7be4ab05ff$export$d2f4d8e74279c212)) throw new Error("Fallback data is required when using suspense in SSR.");
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $fffa9c7be4ab05ff$export$fce6876652108ab)(req)) {
            const promise = boundMutate(req);
            $86b46a0f8c2e4a70$var$use(promise);
        }
        if ((0, $fffa9c7be4ab05ff$export$fce6876652108ab)(error)) {
            const promise = revalidate($86b46a0f8c2e4a70$var$WITH_DEDUPE);
            if (!(0, $fffa9c7be4ab05ff$export$fce6876652108ab)(returnedData)) {
                promise.status = "fulfilled";
                promise.value = true;
            }
            $86b46a0f8c2e4a70$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
(0, $fffa9c7be4ab05ff$export$8b8a958a7f6f130c).defineProperty((0, $fffa9c7be4ab05ff$export$4c7bbecdacc3ca2c), "defaultValue", {
    value: (0, $fffa9c7be4ab05ff$export$f84bd70098573c5c)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $86b46a0f8c2e4a70$var$useSWR = (0, $fffa9c7be4ab05ff$export$84d44e54e14b0133)($86b46a0f8c2e4a70$var$useSWRHandler);
const $86b46a0f8c2e4a70$var$getFirstPageKey = (getKey)=>{
    return (0, $fffa9c7be4ab05ff$export$dfdc1655ccc5b9cb)(getKey ? getKey(0, null) : null)[0];
};
const $86b46a0f8c2e4a70$export$dbab534a48e651ef = (getKey)=>{
    return (0, $fffa9c7be4ab05ff$export$8667f065faedc62c) + $86b46a0f8c2e4a70$var$getFirstPageKey(getKey);
};
// We have to several type castings here because `useSWRInfinite` is a special
// hook where `key` and return type are not like the normal `useSWR` types.
// const INFINITE_PREFIX = '$inf$'
const $86b46a0f8c2e4a70$var$EMPTY_PROMISE = Promise.resolve();
// export const unstable_serialize = (getKey: SWRInfiniteKeyLoader) => {
//   return INFINITE_PREFIX + getFirstPageKey(getKey)
// }
const $86b46a0f8c2e4a70$export$f27219e7b43e81d = (useSWRNext)=>(getKey, fn, config)=>{
        const didMountRef = (0, $1EuC8.useRef)(false);
        const { cache: cache$1, initialSize: initialSize = 1, revalidateAll: revalidateAll = false, persistSize: persistSize = false, revalidateFirstPage: revalidateFirstPage = true, revalidateOnMount: revalidateOnMount = false, parallel: parallel = false } = config;
        const [, , , PRELOAD] = (0, $fffa9c7be4ab05ff$export$b94ca9901c60634).get((0, $fffa9c7be4ab05ff$export$69a3209f1a06c04d));
        // The serialized key of the first page. This key will be used to store
        // metadata of this SWR infinite hook.
        let infiniteKey;
        try {
            infiniteKey = $86b46a0f8c2e4a70$var$getFirstPageKey(getKey);
            if (infiniteKey) infiniteKey = (0, $fffa9c7be4ab05ff$export$8667f065faedc62c) + infiniteKey;
        } catch (err) {
        // Not ready yet.
        }
        const [get, set, subscribeCache] = (0, $fffa9c7be4ab05ff$export$1251d51d9c571b45)(cache$1, infiniteKey);
        const getSnapshot = (0, $1EuC8.useCallback)(()=>{
            const size = (0, $fffa9c7be4ab05ff$export$fce6876652108ab)(get()._l) ? initialSize : get()._l;
            return size;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            cache$1,
            infiniteKey,
            initialSize
        ]);
        (0, $16f05ab202eabde2$exports.useSyncExternalStore)((0, $1EuC8.useCallback)((callback)=>{
            if (infiniteKey) return subscribeCache(infiniteKey, ()=>{
                callback();
            });
            return ()=>{};
        }, [
            cache$1,
            infiniteKey
        ]), getSnapshot, getSnapshot);
        const resolvePageSize = (0, $1EuC8.useCallback)(()=>{
            const cachedPageSize = get()._l;
            return (0, $fffa9c7be4ab05ff$export$fce6876652108ab)(cachedPageSize) ? initialSize : cachedPageSize;
        // `cache` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            infiniteKey,
            initialSize
        ]);
        // keep the last page size to restore it with the persistSize option
        const lastPageSizeRef = (0, $1EuC8.useRef)(resolvePageSize());
        // When the page key changes, we reset the page size if it's not persisted
        (0, $fffa9c7be4ab05ff$export$700979bc83e7db82)(()=>{
            if (!didMountRef.current) {
                didMountRef.current = true;
                return;
            }
            if (infiniteKey) // If the key has been changed, we keep the current page size if persistSize is enabled
            // Otherwise, we reset the page size to cached pageSize
            set({
                _l: persistSize ? lastPageSizeRef.current : resolvePageSize()
            });
        // `initialSize` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            infiniteKey,
            cache$1
        ]);
        // Needs to check didMountRef during mounting, not in the fetcher
        const shouldRevalidateOnMount = revalidateOnMount && !didMountRef.current;
        // Actual SWR hook to load all pages in one fetcher.
        const swr = useSWRNext(infiniteKey, async (key)=>{
            // get the revalidate context
            const forceRevalidateAll = get()._i;
            const shouldRevalidatePage = get()._r;
            set({
                _r: (0, $fffa9c7be4ab05ff$export$6db089fe7b26f5b6)
            });
            // return an array of page data
            const data = [];
            const pageSize = resolvePageSize();
            const [getCache] = (0, $fffa9c7be4ab05ff$export$1251d51d9c571b45)(cache$1, key);
            const cacheData = getCache().data;
            const revalidators = [];
            let previousPageData = null;
            for(let i = 0; i < pageSize; ++i){
                const [pageKey, pageArg] = (0, $fffa9c7be4ab05ff$export$dfdc1655ccc5b9cb)(getKey(i, parallel ? null : previousPageData));
                if (!pageKey) break;
                const [getSWRCache, setSWRCache] = (0, $fffa9c7be4ab05ff$export$1251d51d9c571b45)(cache$1, pageKey);
                // Get the cached page data.
                let pageData = getSWRCache().data;
                // should fetch (or revalidate) if:
                // - `revalidateAll` is enabled
                // - `mutate()` called
                // - the cache is missing
                // - it's the first page and it's not the initial render
                // - `revalidateOnMount` is enabled and it's on mount
                // - cache for that page has changed
                const shouldFetchPage = revalidateAll || forceRevalidateAll || (0, $fffa9c7be4ab05ff$export$fce6876652108ab)(pageData) || revalidateFirstPage && !i && !(0, $fffa9c7be4ab05ff$export$fce6876652108ab)(cacheData) || shouldRevalidateOnMount || cacheData && !(0, $fffa9c7be4ab05ff$export$fce6876652108ab)(cacheData[i]) && !config.compare(cacheData[i], pageData);
                if (fn && (typeof shouldRevalidatePage === "function" ? shouldRevalidatePage(pageData, pageArg) : shouldFetchPage)) {
                    const revalidate = async ()=>{
                        const hasPreloadedRequest = pageKey in PRELOAD;
                        if (!hasPreloadedRequest) pageData = await fn(pageArg);
                        else {
                            const req = PRELOAD[pageKey];
                            // delete the preload cache key before resolving it
                            // in case there's an error
                            delete PRELOAD[pageKey];
                            // get the page data from the preload cache
                            pageData = await req;
                        }
                        setSWRCache({
                            data: pageData,
                            _k: pageArg
                        });
                        data[i] = pageData;
                    };
                    if (parallel) revalidators.push(revalidate);
                    else await revalidate();
                } else data[i] = pageData;
                if (!parallel) previousPageData = pageData;
            }
            // flush all revalidateions in parallel
            if (parallel) await Promise.all(revalidators.map((r)=>r()));
            // once we executed the data fetching based on the context, clear the context
            set({
                _i: (0, $fffa9c7be4ab05ff$export$6db089fe7b26f5b6)
            });
            // return the data
            return data;
        }, config);
        const mutate = (0, $1EuC8.useCallback)(function(data, opts) {
            // When passing as a boolean, it's explicitly used to disable/enable
            // revalidation.
            const options = typeof opts === "boolean" ? {
                revalidate: opts
            } : opts || {};
            // Default to true.
            const shouldRevalidate = options.revalidate !== false;
            // It is possible that the key is still falsy.
            if (!infiniteKey) return $86b46a0f8c2e4a70$var$EMPTY_PROMISE;
            if (shouldRevalidate) {
                if (!(0, $fffa9c7be4ab05ff$export$fce6876652108ab)(data)) // We only revalidate the pages that are changed
                set({
                    _i: false,
                    _r: options.revalidate
                });
                else // Calling `mutate()`, we revalidate all pages
                set({
                    _i: true,
                    _r: options.revalidate
                });
            }
            return arguments.length ? swr.mutate(data, {
                ...options,
                revalidate: shouldRevalidate
            }) : swr.mutate();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            infiniteKey,
            cache$1
        ]);
        // Extend the SWR API
        const setSize = (0, $1EuC8.useCallback)((arg)=>{
            // It is possible that the key is still falsy.
            if (!infiniteKey) return $86b46a0f8c2e4a70$var$EMPTY_PROMISE;
            const [, changeSize] = (0, $fffa9c7be4ab05ff$export$1251d51d9c571b45)(cache$1, infiniteKey);
            let size;
            if ((0, $fffa9c7be4ab05ff$export$f6e2535fb5126e54)(arg)) size = arg(resolvePageSize());
            else if (typeof arg == "number") size = arg;
            if (typeof size != "number") return $86b46a0f8c2e4a70$var$EMPTY_PROMISE;
            changeSize({
                _l: size
            });
            lastPageSizeRef.current = size;
            // Calculate the page data after the size change.
            const data = [];
            const [getInfiniteCache] = (0, $fffa9c7be4ab05ff$export$1251d51d9c571b45)(cache$1, infiniteKey);
            let previousPageData = null;
            for(let i = 0; i < size; ++i){
                const [pageKey] = (0, $fffa9c7be4ab05ff$export$dfdc1655ccc5b9cb)(getKey(i, previousPageData));
                const [getCache] = (0, $fffa9c7be4ab05ff$export$1251d51d9c571b45)(cache$1, pageKey);
                // Get the cached page data.
                const pageData = pageKey ? getCache().data : (0, $fffa9c7be4ab05ff$export$6db089fe7b26f5b6);
                // Call `mutate` with infinte cache data if we can't get it from the page cache.
                if ((0, $fffa9c7be4ab05ff$export$fce6876652108ab)(pageData)) return mutate(getInfiniteCache().data);
                data.push(pageData);
                previousPageData = pageData;
            }
            return mutate(data);
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            infiniteKey,
            cache$1,
            mutate,
            resolvePageSize
        ]);
        // Use getter functions to avoid unnecessary re-renders caused by triggering
        // all the getters of the returned swr object.
        return {
            size: resolvePageSize(),
            setSize: setSize,
            mutate: mutate,
            get data () {
                return swr.data;
            },
            get error () {
                return swr.error;
            },
            get isValidating () {
                return swr.isValidating;
            },
            get isLoading () {
                return swr.isLoading;
            }
        };
    };
const $86b46a0f8c2e4a70$export$2e2bcd8739ae039 = (0, $fffa9c7be4ab05ff$export$525ea7fc6ba00096)($86b46a0f8c2e4a70$var$useSWR, $86b46a0f8c2e4a70$export$f27219e7b43e81d);


var $b359885d68b982f7$export$f4bfbadc8ccd5fbc;
(function(RouteNames) {
    RouteNames["HOME"] = "/agents";
    RouteNames["SIGN_IN"] = "/signin";
    RouteNames["SIGN_UP"] = "/signup";
    RouteNames["AGENTS"] = "/agents";
    RouteNames["DATASTORES"] = "/datastores";
    RouteNames["LOGS"] = "/logs";
    RouteNames["CHAT"] = "/chat";
    RouteNames["MAINTENANCE"] = "/maintenance";
    RouteNames["ACCOUNT"] = "/account";
    RouteNames["APPS"] = "/apps";
    RouteNames["CHAT_SITE"] = "/products/crisp-plugin";
    RouteNames["SLACK_BOT"] = "/products/slack-bot";
})($b359885d68b982f7$export$f4bfbadc8ccd5fbc || ($b359885d68b982f7$export$f4bfbadc8ccd5fbc = {}));
var $b359885d68b982f7$export$18d75a2b47d28ad6;
(function(PromptTypesLabels) {
    PromptTypesLabels["customer_support"] = "Customer support";
    PromptTypesLabels["raw"] = "Raw";
})($b359885d68b982f7$export$18d75a2b47d28ad6 || ($b359885d68b982f7$export$18d75a2b47d28ad6 = {}));
var $b359885d68b982f7$export$97051052e8f36fe7;
(function(AppStatus) {
    AppStatus["OK"] = "OK";
    AppStatus["WARNING"] = "WARNING";
    AppStatus["KO"] = "KO";
})($b359885d68b982f7$export$97051052e8f36fe7 || ($b359885d68b982f7$export$97051052e8f36fe7 = {}));
var $b359885d68b982f7$export$6ffd3d1839ca7b87;
(function(MetadataFields) {
    MetadataFields["datastore_id"] = "datastore_id";
    MetadataFields["datasource_id"] = "datasource_id";
    MetadataFields["tags"] = "tags";
    MetadataFields["text"] = "text";
    MetadataFields["chunk_hash"] = "chunk_hash";
    MetadataFields["datasource_hash"] = "datasource_hash";
    MetadataFields["chunk_offset"] = "chunk_offset";
    MetadataFields["custom_id"] = "custom_id";
    MetadataFields["page_number"] = "page_number";
    MetadataFields["total_pages"] = "total_pages";
})($b359885d68b982f7$export$6ffd3d1839ca7b87 || ($b359885d68b982f7$export$6ffd3d1839ca7b87 = {}));
var $b359885d68b982f7$export$a8cb919cf3665a66;
(function(TaskQueue) {
    TaskQueue["load_datasource"] = "load-datasource";
})($b359885d68b982f7$export$a8cb919cf3665a66 || ($b359885d68b982f7$export$a8cb919cf3665a66 = {}));
var $b359885d68b982f7$export$d45b9cbb82ebd6c5;
(function(SSE_EVENT) {
    SSE_EVENT["answer"] = "answer";
    SSE_EVENT["endpoint_response"] = "endpoint_response";
    SSE_EVENT["step"] = "step";
})($b359885d68b982f7$export$d45b9cbb82ebd6c5 || ($b359885d68b982f7$export$d45b9cbb82ebd6c5 = {}));
var $b359885d68b982f7$export$feb52200d964722b;
(function(ChainType) {
    ChainType["qa"] = "qa";
})($b359885d68b982f7$export$feb52200d964722b || ($b359885d68b982f7$export$feb52200d964722b = {}));


var $99efa7b7dc940226$export$eb26b24d7b7bab09;
(function(ApiErrorType) {
    ApiErrorType["UNAUTHORIZED"] = "UNAUTHORIZED";
    ApiErrorType["USAGE_LIMIT"] = "USAGE_LIMIT";
    ApiErrorType["NOT_FOUND"] = "NOT_FOUND";
    ApiErrorType["INVALID_REQUEST"] = "INVALID_REQUEST";
    ApiErrorType["WEBPAGE_IS_SITEMAP"] = "WEBPAGE_IS_SITEMAP";
    ApiErrorType["EMPTY_DATASOURCE"] = "EMPTY_DATASOURCE";
})($99efa7b7dc940226$export$eb26b24d7b7bab09 || ($99efa7b7dc940226$export$eb26b24d7b7bab09 = {}));
class $99efa7b7dc940226$export$f2e832acab1bdd79 extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        if (!status) switch(message){
            case "UNAUTHORIZED":
                this.status = 403;
                break;
            case "USAGE_LIMIT":
                this.status = 402;
                break;
            case "NOT_FOUND":
                this.status = 404;
                break;
            case "INVALID_REQUEST":
                this.status = 400;
                break;
            case "EMPTY_DATASOURCE":
                this.status = 400;
                break;
            default:
                this.status = 500;
                break;
        }
        Object.setPrototypeOf(this, $99efa7b7dc940226$export$f2e832acab1bdd79.prototype);
    }
}


"use strict";
function $4a46f5d8663578b6$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $fe1a0f2b0dd0162b$exports = {};
// shim for using process in browser
var $fe1a0f2b0dd0162b$var$process = $fe1a0f2b0dd0162b$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $fe1a0f2b0dd0162b$var$cachedSetTimeout;
var $fe1a0f2b0dd0162b$var$cachedClearTimeout;
function $fe1a0f2b0dd0162b$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $fe1a0f2b0dd0162b$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $fe1a0f2b0dd0162b$var$cachedSetTimeout = setTimeout;
        else $fe1a0f2b0dd0162b$var$cachedSetTimeout = $fe1a0f2b0dd0162b$var$defaultSetTimout;
    } catch (e) {
        $fe1a0f2b0dd0162b$var$cachedSetTimeout = $fe1a0f2b0dd0162b$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $fe1a0f2b0dd0162b$var$cachedClearTimeout = clearTimeout;
        else $fe1a0f2b0dd0162b$var$cachedClearTimeout = $fe1a0f2b0dd0162b$var$defaultClearTimeout;
    } catch (e) {
        $fe1a0f2b0dd0162b$var$cachedClearTimeout = $fe1a0f2b0dd0162b$var$defaultClearTimeout;
    }
})();
function $fe1a0f2b0dd0162b$var$runTimeout(fun) {
    if ($fe1a0f2b0dd0162b$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($fe1a0f2b0dd0162b$var$cachedSetTimeout === $fe1a0f2b0dd0162b$var$defaultSetTimout || !$fe1a0f2b0dd0162b$var$cachedSetTimeout) && setTimeout) {
        $fe1a0f2b0dd0162b$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $fe1a0f2b0dd0162b$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $fe1a0f2b0dd0162b$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $fe1a0f2b0dd0162b$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $fe1a0f2b0dd0162b$var$runClearTimeout(marker) {
    if ($fe1a0f2b0dd0162b$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($fe1a0f2b0dd0162b$var$cachedClearTimeout === $fe1a0f2b0dd0162b$var$defaultClearTimeout || !$fe1a0f2b0dd0162b$var$cachedClearTimeout) && clearTimeout) {
        $fe1a0f2b0dd0162b$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $fe1a0f2b0dd0162b$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $fe1a0f2b0dd0162b$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $fe1a0f2b0dd0162b$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $fe1a0f2b0dd0162b$var$queue = [];
var $fe1a0f2b0dd0162b$var$draining = false;
var $fe1a0f2b0dd0162b$var$currentQueue;
var $fe1a0f2b0dd0162b$var$queueIndex = -1;
function $fe1a0f2b0dd0162b$var$cleanUpNextTick() {
    if (!$fe1a0f2b0dd0162b$var$draining || !$fe1a0f2b0dd0162b$var$currentQueue) return;
    $fe1a0f2b0dd0162b$var$draining = false;
    if ($fe1a0f2b0dd0162b$var$currentQueue.length) $fe1a0f2b0dd0162b$var$queue = $fe1a0f2b0dd0162b$var$currentQueue.concat($fe1a0f2b0dd0162b$var$queue);
    else $fe1a0f2b0dd0162b$var$queueIndex = -1;
    if ($fe1a0f2b0dd0162b$var$queue.length) $fe1a0f2b0dd0162b$var$drainQueue();
}
function $fe1a0f2b0dd0162b$var$drainQueue() {
    if ($fe1a0f2b0dd0162b$var$draining) return;
    var timeout = $fe1a0f2b0dd0162b$var$runTimeout($fe1a0f2b0dd0162b$var$cleanUpNextTick);
    $fe1a0f2b0dd0162b$var$draining = true;
    var len = $fe1a0f2b0dd0162b$var$queue.length;
    while(len){
        $fe1a0f2b0dd0162b$var$currentQueue = $fe1a0f2b0dd0162b$var$queue;
        $fe1a0f2b0dd0162b$var$queue = [];
        while(++$fe1a0f2b0dd0162b$var$queueIndex < len)if ($fe1a0f2b0dd0162b$var$currentQueue) $fe1a0f2b0dd0162b$var$currentQueue[$fe1a0f2b0dd0162b$var$queueIndex].run();
        $fe1a0f2b0dd0162b$var$queueIndex = -1;
        len = $fe1a0f2b0dd0162b$var$queue.length;
    }
    $fe1a0f2b0dd0162b$var$currentQueue = null;
    $fe1a0f2b0dd0162b$var$draining = false;
    $fe1a0f2b0dd0162b$var$runClearTimeout(timeout);
}
$fe1a0f2b0dd0162b$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $fe1a0f2b0dd0162b$var$queue.push(new $fe1a0f2b0dd0162b$var$Item(fun, args));
    if ($fe1a0f2b0dd0162b$var$queue.length === 1 && !$fe1a0f2b0dd0162b$var$draining) $fe1a0f2b0dd0162b$var$runTimeout($fe1a0f2b0dd0162b$var$drainQueue);
};
// v8 likes predictible objects
function $fe1a0f2b0dd0162b$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$fe1a0f2b0dd0162b$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$fe1a0f2b0dd0162b$var$process.title = "browser";
$fe1a0f2b0dd0162b$var$process.browser = true;
$fe1a0f2b0dd0162b$var$process.env = {};
$fe1a0f2b0dd0162b$var$process.argv = [];
$fe1a0f2b0dd0162b$var$process.version = ""; // empty string to avoid regexp issues
$fe1a0f2b0dd0162b$var$process.versions = {};
function $fe1a0f2b0dd0162b$var$noop() {}
$fe1a0f2b0dd0162b$var$process.on = $fe1a0f2b0dd0162b$var$noop;
$fe1a0f2b0dd0162b$var$process.addListener = $fe1a0f2b0dd0162b$var$noop;
$fe1a0f2b0dd0162b$var$process.once = $fe1a0f2b0dd0162b$var$noop;
$fe1a0f2b0dd0162b$var$process.off = $fe1a0f2b0dd0162b$var$noop;
$fe1a0f2b0dd0162b$var$process.removeListener = $fe1a0f2b0dd0162b$var$noop;
$fe1a0f2b0dd0162b$var$process.removeAllListeners = $fe1a0f2b0dd0162b$var$noop;
$fe1a0f2b0dd0162b$var$process.emit = $fe1a0f2b0dd0162b$var$noop;
$fe1a0f2b0dd0162b$var$process.prependListener = $fe1a0f2b0dd0162b$var$noop;
$fe1a0f2b0dd0162b$var$process.prependOnceListener = $fe1a0f2b0dd0162b$var$noop;
$fe1a0f2b0dd0162b$var$process.listeners = function(name) {
    return [];
};
$fe1a0f2b0dd0162b$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$fe1a0f2b0dd0162b$var$process.cwd = function() {
    return "/";
};
$fe1a0f2b0dd0162b$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$fe1a0f2b0dd0162b$var$process.umask = function() {
    return 0;
};


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $9d5c1981c8d67177$var$toString } = Object.prototype;
const { getPrototypeOf: $9d5c1981c8d67177$var$getPrototypeOf } = Object;
const $9d5c1981c8d67177$var$kindOf = ((cache)=>(thing)=>{
        const str = $9d5c1981c8d67177$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $9d5c1981c8d67177$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$9d5c1981c8d67177$var$kindOf(thing) === type;
};
const $9d5c1981c8d67177$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $9d5c1981c8d67177$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $9d5c1981c8d67177$var$isUndefined = $9d5c1981c8d67177$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $9d5c1981c8d67177$var$isBuffer(val) {
    return val !== null && !$9d5c1981c8d67177$var$isUndefined(val) && val.constructor !== null && !$9d5c1981c8d67177$var$isUndefined(val.constructor) && $9d5c1981c8d67177$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $9d5c1981c8d67177$var$isArrayBuffer = $9d5c1981c8d67177$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $9d5c1981c8d67177$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $9d5c1981c8d67177$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $9d5c1981c8d67177$var$isString = $9d5c1981c8d67177$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $9d5c1981c8d67177$var$isFunction = $9d5c1981c8d67177$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $9d5c1981c8d67177$var$isNumber = $9d5c1981c8d67177$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $9d5c1981c8d67177$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $9d5c1981c8d67177$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $9d5c1981c8d67177$var$isPlainObject = (val)=>{
    if ($9d5c1981c8d67177$var$kindOf(val) !== "object") return false;
    const prototype = $9d5c1981c8d67177$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $9d5c1981c8d67177$var$isDate = $9d5c1981c8d67177$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $9d5c1981c8d67177$var$isFile = $9d5c1981c8d67177$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $9d5c1981c8d67177$var$isBlob = $9d5c1981c8d67177$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $9d5c1981c8d67177$var$isFileList = $9d5c1981c8d67177$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $9d5c1981c8d67177$var$isStream = (val)=>$9d5c1981c8d67177$var$isObject(val) && $9d5c1981c8d67177$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $9d5c1981c8d67177$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $9d5c1981c8d67177$var$isFunction(thing.append) && ((kind = $9d5c1981c8d67177$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $9d5c1981c8d67177$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $9d5c1981c8d67177$var$isURLSearchParams = $9d5c1981c8d67177$var$kindOfTest("URLSearchParams");
const [$9d5c1981c8d67177$var$isReadableStream, $9d5c1981c8d67177$var$isRequest, $9d5c1981c8d67177$var$isResponse, $9d5c1981c8d67177$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($9d5c1981c8d67177$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $9d5c1981c8d67177$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $9d5c1981c8d67177$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($9d5c1981c8d67177$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $9d5c1981c8d67177$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $9d5c1981c8d67177$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $9d5c1981c8d67177$var$isContextDefined = (context)=>!$9d5c1981c8d67177$var$isUndefined(context) && context !== $9d5c1981c8d67177$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $9d5c1981c8d67177$var$merge() {
    const { caseless: caseless } = $9d5c1981c8d67177$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $9d5c1981c8d67177$var$findKey(result, key) || key;
        if ($9d5c1981c8d67177$var$isPlainObject(result[targetKey]) && $9d5c1981c8d67177$var$isPlainObject(val)) result[targetKey] = $9d5c1981c8d67177$var$merge(result[targetKey], val);
        else if ($9d5c1981c8d67177$var$isPlainObject(val)) result[targetKey] = $9d5c1981c8d67177$var$merge({}, val);
        else if ($9d5c1981c8d67177$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $9d5c1981c8d67177$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $9d5c1981c8d67177$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $9d5c1981c8d67177$var$forEach(b, (val, key)=>{
        if (thisArg && $9d5c1981c8d67177$var$isFunction(val)) a[key] = (0, $4a46f5d8663578b6$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $9d5c1981c8d67177$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $9d5c1981c8d67177$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $9d5c1981c8d67177$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $9d5c1981c8d67177$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $9d5c1981c8d67177$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $9d5c1981c8d67177$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($9d5c1981c8d67177$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$9d5c1981c8d67177$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $9d5c1981c8d67177$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $9d5c1981c8d67177$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $9d5c1981c8d67177$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $9d5c1981c8d67177$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $9d5c1981c8d67177$var$isHTMLForm = $9d5c1981c8d67177$var$kindOfTest("HTMLFormElement");
const $9d5c1981c8d67177$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $9d5c1981c8d67177$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $9d5c1981c8d67177$var$isRegExp = $9d5c1981c8d67177$var$kindOfTest("RegExp");
const $9d5c1981c8d67177$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $9d5c1981c8d67177$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $9d5c1981c8d67177$var$freezeMethods = (obj)=>{
    $9d5c1981c8d67177$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($9d5c1981c8d67177$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$9d5c1981c8d67177$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $9d5c1981c8d67177$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $9d5c1981c8d67177$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $9d5c1981c8d67177$var$noop = ()=>{};
const $9d5c1981c8d67177$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $9d5c1981c8d67177$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $9d5c1981c8d67177$var$DIGIT = "0123456789";
const $9d5c1981c8d67177$var$ALPHABET = {
    DIGIT: $9d5c1981c8d67177$var$DIGIT,
    ALPHA: $9d5c1981c8d67177$var$ALPHA,
    ALPHA_DIGIT: $9d5c1981c8d67177$var$ALPHA + $9d5c1981c8d67177$var$ALPHA.toUpperCase() + $9d5c1981c8d67177$var$DIGIT
};
const $9d5c1981c8d67177$var$generateString = (size = 16, alphabet = $9d5c1981c8d67177$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $9d5c1981c8d67177$var$isSpecCompliantForm(thing) {
    return !!(thing && $9d5c1981c8d67177$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $9d5c1981c8d67177$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($9d5c1981c8d67177$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $9d5c1981c8d67177$var$isArray(source) ? [] : {};
                $9d5c1981c8d67177$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$9d5c1981c8d67177$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $9d5c1981c8d67177$var$isAsyncFn = $9d5c1981c8d67177$var$kindOfTest("AsyncFunction");
const $9d5c1981c8d67177$var$isThenable = (thing)=>thing && ($9d5c1981c8d67177$var$isObject(thing) || $9d5c1981c8d67177$var$isFunction(thing)) && $9d5c1981c8d67177$var$isFunction(thing.then) && $9d5c1981c8d67177$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $9d5c1981c8d67177$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $9d5c1981c8d67177$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $9d5c1981c8d67177$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $9d5c1981c8d67177$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $9d5c1981c8d67177$var$isFunction($9d5c1981c8d67177$var$_global.postMessage));
const $9d5c1981c8d67177$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($9d5c1981c8d67177$var$_global) : typeof $fe1a0f2b0dd0162b$exports !== "undefined" && $fe1a0f2b0dd0162b$exports.nextTick || $9d5c1981c8d67177$var$_setImmediate;
var // *********************
$9d5c1981c8d67177$export$2e2bcd8739ae039 = {
    isArray: $9d5c1981c8d67177$var$isArray,
    isArrayBuffer: $9d5c1981c8d67177$var$isArrayBuffer,
    isBuffer: $9d5c1981c8d67177$var$isBuffer,
    isFormData: $9d5c1981c8d67177$var$isFormData,
    isArrayBufferView: $9d5c1981c8d67177$var$isArrayBufferView,
    isString: $9d5c1981c8d67177$var$isString,
    isNumber: $9d5c1981c8d67177$var$isNumber,
    isBoolean: $9d5c1981c8d67177$var$isBoolean,
    isObject: $9d5c1981c8d67177$var$isObject,
    isPlainObject: $9d5c1981c8d67177$var$isPlainObject,
    isReadableStream: $9d5c1981c8d67177$var$isReadableStream,
    isRequest: $9d5c1981c8d67177$var$isRequest,
    isResponse: $9d5c1981c8d67177$var$isResponse,
    isHeaders: $9d5c1981c8d67177$var$isHeaders,
    isUndefined: $9d5c1981c8d67177$var$isUndefined,
    isDate: $9d5c1981c8d67177$var$isDate,
    isFile: $9d5c1981c8d67177$var$isFile,
    isBlob: $9d5c1981c8d67177$var$isBlob,
    isRegExp: $9d5c1981c8d67177$var$isRegExp,
    isFunction: $9d5c1981c8d67177$var$isFunction,
    isStream: $9d5c1981c8d67177$var$isStream,
    isURLSearchParams: $9d5c1981c8d67177$var$isURLSearchParams,
    isTypedArray: $9d5c1981c8d67177$var$isTypedArray,
    isFileList: $9d5c1981c8d67177$var$isFileList,
    forEach: $9d5c1981c8d67177$var$forEach,
    merge: $9d5c1981c8d67177$var$merge,
    extend: $9d5c1981c8d67177$var$extend,
    trim: $9d5c1981c8d67177$var$trim,
    stripBOM: $9d5c1981c8d67177$var$stripBOM,
    inherits: $9d5c1981c8d67177$var$inherits,
    toFlatObject: $9d5c1981c8d67177$var$toFlatObject,
    kindOf: $9d5c1981c8d67177$var$kindOf,
    kindOfTest: $9d5c1981c8d67177$var$kindOfTest,
    endsWith: $9d5c1981c8d67177$var$endsWith,
    toArray: $9d5c1981c8d67177$var$toArray,
    forEachEntry: $9d5c1981c8d67177$var$forEachEntry,
    matchAll: $9d5c1981c8d67177$var$matchAll,
    isHTMLForm: $9d5c1981c8d67177$var$isHTMLForm,
    hasOwnProperty: $9d5c1981c8d67177$var$hasOwnProperty,
    hasOwnProp: $9d5c1981c8d67177$var$hasOwnProperty,
    reduceDescriptors: $9d5c1981c8d67177$var$reduceDescriptors,
    freezeMethods: $9d5c1981c8d67177$var$freezeMethods,
    toObjectSet: $9d5c1981c8d67177$var$toObjectSet,
    toCamelCase: $9d5c1981c8d67177$var$toCamelCase,
    noop: $9d5c1981c8d67177$var$noop,
    toFiniteNumber: $9d5c1981c8d67177$var$toFiniteNumber,
    findKey: $9d5c1981c8d67177$var$findKey,
    global: $9d5c1981c8d67177$var$_global,
    isContextDefined: $9d5c1981c8d67177$var$isContextDefined,
    ALPHABET: $9d5c1981c8d67177$var$ALPHABET,
    generateString: $9d5c1981c8d67177$var$generateString,
    isSpecCompliantForm: $9d5c1981c8d67177$var$isSpecCompliantForm,
    toJSONObject: $9d5c1981c8d67177$var$toJSONObject,
    isAsyncFn: $9d5c1981c8d67177$var$isAsyncFn,
    isThenable: $9d5c1981c8d67177$var$isThenable,
    setImmediate: $9d5c1981c8d67177$var$_setImmediate,
    asap: $9d5c1981c8d67177$var$asap
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $b0bf1e70f4835062$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).inherits($b0bf1e70f4835062$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $b0bf1e70f4835062$var$prototype = $b0bf1e70f4835062$var$AxiosError.prototype;
const $b0bf1e70f4835062$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $b0bf1e70f4835062$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($b0bf1e70f4835062$var$AxiosError, $b0bf1e70f4835062$var$descriptors);
Object.defineProperty($b0bf1e70f4835062$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$b0bf1e70f4835062$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($b0bf1e70f4835062$var$prototype);
    (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $b0bf1e70f4835062$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $b0bf1e70f4835062$export$2e2bcd8739ae039 = $b0bf1e70f4835062$var$AxiosError;


// eslint-disable-next-line strict
var $740b6a112ef75fc8$export$2e2bcd8739ae039 = null;


var $2f4ddff75a0a9006$exports = {};
"use strict";


var $2ca98cec6a9bd582$require$Buffer = $2f4ddff75a0a9006$exports.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $2ca98cec6a9bd582$var$isVisitable(thing) {
    return (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $2ca98cec6a9bd582$var$removeBrackets(key) {
    return (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $2ca98cec6a9bd582$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $2ca98cec6a9bd582$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $2ca98cec6a9bd582$var$isFlatArray(arr) {
    return (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArray(arr) && !arr.some($2ca98cec6a9bd582$var$isVisitable);
}
const $2ca98cec6a9bd582$var$predicates = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).toFlatObject((0, $9d5c1981c8d67177$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $2ca98cec6a9bd582$var$toFormData(obj, formData, options) {
    if (!(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $740b6a112ef75fc8$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $2ca98cec6a9bd582$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArray(value) && $2ca98cec6a9bd582$var$isFlatArray(value) || ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFileList(value) || (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $2ca98cec6a9bd582$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $2ca98cec6a9bd582$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($2ca98cec6a9bd582$var$isVisitable(value)) return true;
        formData.append($2ca98cec6a9bd582$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($2ca98cec6a9bd582$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $2ca98cec6a9bd582$var$isVisitable
    });
    function build(value, path) {
        if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $2ca98cec6a9bd582$export$2e2bcd8739ae039 = $2ca98cec6a9bd582$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $e6496b0986d343b1$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $e6496b0986d343b1$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $2ca98cec6a9bd582$export$2e2bcd8739ae039)(params, this, options);
}
const $e6496b0986d343b1$var$prototype = $e6496b0986d343b1$var$AxiosURLSearchParams.prototype;
$e6496b0986d343b1$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$e6496b0986d343b1$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $e6496b0986d343b1$var$encode);
    } : $e6496b0986d343b1$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $e6496b0986d343b1$export$2e2bcd8739ae039 = $e6496b0986d343b1$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $0be69c2ac4a5988b$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $0be69c2ac4a5988b$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $0be69c2ac4a5988b$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $e6496b0986d343b1$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $74dd218e995a80c6$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $74dd218e995a80c6$export$2e2bcd8739ae039 = $74dd218e995a80c6$var$InterceptorManager;





"use strict";
var $334ccacb1a9cbb93$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $89952610ee9cf5ab$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $e6496b0986d343b1$export$2e2bcd8739ae039);


"use strict";
var $f383226b112d01ba$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $e8ad4f131a9a1ef8$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $b84fd7b71d02d20a$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $89952610ee9cf5ab$export$2e2bcd8739ae039,
        FormData: $f383226b112d01ba$export$2e2bcd8739ae039,
        Blob: $e8ad4f131a9a1ef8$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $1f4db1aad966dc8f$exports = {};

$parcel$export($1f4db1aad966dc8f$exports, "hasBrowserEnv", () => $1f4db1aad966dc8f$export$c4996c4b7b93b0bf);
$parcel$export($1f4db1aad966dc8f$exports, "navigator", () => $1f4db1aad966dc8f$export$ec7c8efa7f5790ae);
$parcel$export($1f4db1aad966dc8f$exports, "hasStandardBrowserEnv", () => $1f4db1aad966dc8f$export$c0bcc9250309d66);
$parcel$export($1f4db1aad966dc8f$exports, "hasStandardBrowserWebWorkerEnv", () => $1f4db1aad966dc8f$export$c81692cf5af97dac);
$parcel$export($1f4db1aad966dc8f$exports, "origin", () => $1f4db1aad966dc8f$export$f710a83a91838a36);
const $1f4db1aad966dc8f$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $1f4db1aad966dc8f$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $1f4db1aad966dc8f$export$c0bcc9250309d66 = $1f4db1aad966dc8f$export$c4996c4b7b93b0bf && (!$1f4db1aad966dc8f$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($1f4db1aad966dc8f$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $1f4db1aad966dc8f$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $1f4db1aad966dc8f$export$f710a83a91838a36 = $1f4db1aad966dc8f$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $2d0e9d3dee104573$export$2e2bcd8739ae039 = {
    ...$1f4db1aad966dc8f$exports,
    ...(0, $b84fd7b71d02d20a$export$2e2bcd8739ae039)
};


"use strict";
function $f666b9738b612b0e$export$2e2bcd8739ae039(data, options) {
    return (0, $2ca98cec6a9bd582$export$2e2bcd8739ae039)(data, new (0, $2d0e9d3dee104573$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $2d0e9d3dee104573$export$2e2bcd8739ae039).isNode && (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $54ff0dc040b003eb$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $54ff0dc040b003eb$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $54ff0dc040b003eb$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $54ff0dc040b003eb$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFormData(formData) && (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($54ff0dc040b003eb$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $54ff0dc040b003eb$export$2e2bcd8739ae039 = $54ff0dc040b003eb$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $7902afa80c48087a$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $7902afa80c48087a$var$defaults = {
    transitional: (0, $334ccacb1a9cbb93$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $54ff0dc040b003eb$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isBuffer(data) || (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isStream(data) || (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFile(data) || (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isBlob(data) || (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $f666b9738b612b0e$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $2ca98cec6a9bd582$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $7902afa80c48087a$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $7902afa80c48087a$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isResponse(data) || (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).from(e, (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $2d0e9d3dee104573$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $2d0e9d3dee104573$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $7902afa80c48087a$var$defaults.headers[method] = {};
});
var $7902afa80c48087a$export$2e2bcd8739ae039 = $7902afa80c48087a$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $dc4dc4d96dd38049$var$ignoreDuplicateOf = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $dc4dc4d96dd38049$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $dc4dc4d96dd38049$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $a8278480c25d7445$var$$internals = Symbol("internals");
function $a8278480c25d7445$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $a8278480c25d7445$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArray(value) ? value.map($a8278480c25d7445$var$normalizeValue) : String(value);
}
function $a8278480c25d7445$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $a8278480c25d7445$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $a8278480c25d7445$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $a8278480c25d7445$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $a8278480c25d7445$var$buildAccessors(obj, header) {
    const accessorName = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $a8278480c25d7445$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $a8278480c25d7445$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $a8278480c25d7445$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$a8278480c25d7445$var$isValidHeaderName(header)) setHeaders((0, $dc4dc4d96dd38049$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $a8278480c25d7445$var$normalizeHeader(header);
        if (header) {
            const key = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $a8278480c25d7445$var$parseTokens(value);
                if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $a8278480c25d7445$var$normalizeHeader(header);
        if (header) {
            const key = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $a8278480c25d7445$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $a8278480c25d7445$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $a8278480c25d7445$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $a8278480c25d7445$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $a8278480c25d7445$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $a8278480c25d7445$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $a8278480c25d7445$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$a8278480c25d7445$var$$internals] = this[$a8278480c25d7445$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $a8278480c25d7445$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $a8278480c25d7445$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$a8278480c25d7445$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).reduceDescriptors($a8278480c25d7445$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).freezeMethods($a8278480c25d7445$var$AxiosHeaders);
var $a8278480c25d7445$export$2e2bcd8739ae039 = $a8278480c25d7445$var$AxiosHeaders;


"use strict";
function $c5ac26be0b4082da$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $7902afa80c48087a$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $a8278480c25d7445$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $0d83534992e0bedd$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $ac4fb0cf1e9ba991$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).inherits($ac4fb0cf1e9ba991$var$CanceledError, (0, $b0bf1e70f4835062$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $ac4fb0cf1e9ba991$export$2e2bcd8739ae039 = $ac4fb0cf1e9ba991$var$CanceledError;







"use strict";
function $7f567f45892b55f4$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $924a270084e35313$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $ca5901194fe301cf$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $ca5901194fe301cf$export$2e2bcd8739ae039 = $ca5901194fe301cf$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $6c8c7de078349487$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $6c8c7de078349487$export$2e2bcd8739ae039 = $6c8c7de078349487$var$throttle;



const $78030c6cd44c2074$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $ca5901194fe301cf$export$2e2bcd8739ae039)(50, 250);
    return (0, $6c8c7de078349487$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $78030c6cd44c2074$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $78030c6cd44c2074$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).asap(()=>fn(...args));






"use strict";
var $ec4b1f7daadd7f8a$export$2e2bcd8739ae039 = (0, $2d0e9d3dee104573$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = (0, $2d0e9d3dee104573$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $2d0e9d3dee104573$export$2e2bcd8739ae039).navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $a4a3cdbe9541e279$export$2e2bcd8739ae039 = (0, $2d0e9d3dee104573$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $f7870d672779fa2d$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $d2d6b025387cbadd$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $cb69d02eee72bac2$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $f7870d672779fa2d$export$2e2bcd8739ae039)(requestedURL)) return (0, $d2d6b025387cbadd$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $d472aa5704a2e347$var$headersToObject = (thing)=>thing instanceof (0, $a8278480c25d7445$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $d472aa5704a2e347$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isPlainObject(target) && (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($d472aa5704a2e347$var$headersToObject(a), $d472aa5704a2e347$var$headersToObject(b), true)
    };
    (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $3b69c22dbb9d39fd$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $d472aa5704a2e347$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $a8278480c25d7445$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $0be69c2ac4a5988b$export$2e2bcd8739ae039)((0, $cb69d02eee72bac2$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $2d0e9d3dee104573$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $2d0e9d3dee104573$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $2d0e9d3dee104573$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $ec4b1f7daadd7f8a$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $a4a3cdbe9541e279$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $fafe892a386e488a$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $fafe892a386e488a$export$2e2bcd8739ae039 = $fafe892a386e488a$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $3b69c22dbb9d39fd$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $a8278480c25d7445$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $a8278480c25d7445$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $7f567f45892b55f4$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)("Request aborted", (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)("Network Error", (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $334ccacb1a9cbb93$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ETIMEDOUT : (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $78030c6cd44c2074$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $78030c6cd44c2074$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $ac4fb0cf1e9ba991$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $924a270084e35313$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $2d0e9d3dee104573$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};







const $aadb4ed2a298b0ba$var$composeSignals = (signals, timeout)=>{
    let controller = new AbortController();
    let aborted;
    const onabort = function(cancel) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = cancel instanceof Error ? cancel : this.reason;
            controller.abort(err instanceof (0, $b0bf1e70f4835062$export$2e2bcd8739ae039) ? err : new (0, $ac4fb0cf1e9ba991$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        onabort(new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (signals) {
            timer && clearTimeout(timer);
            timer = null;
            signals.forEach((signal)=>{
                signal && (signal.removeEventListener ? signal.removeEventListener("abort", onabort) : signal.unsubscribe(onabort));
            });
            signals = null;
        }
    };
    signals.forEach((signal)=>signal && signal.addEventListener && signal.addEventListener("abort", onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = unsubscribe;
    return [
        signal,
        ()=>{
            timer && clearTimeout(timer);
            timer = null;
        }
    ];
};
var $aadb4ed2a298b0ba$export$2e2bcd8739ae039 = $aadb4ed2a298b0ba$var$composeSignals;


const $b659d21f9f0ea1be$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $b659d21f9f0ea1be$export$f9f241124ee3198e = async function*(iterable, chunkSize, encode) {
    for await (const chunk of iterable)yield* $b659d21f9f0ea1be$export$71b051935044bd5d(ArrayBuffer.isView(chunk) ? chunk : await encode(String(chunk)), chunkSize);
};
const $b659d21f9f0ea1be$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish, encode)=>{
    const iterator = $b659d21f9f0ea1be$export$f9f241124ee3198e(stream, chunkSize, encode);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $f3d7f83f8eac23f1$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $f3d7f83f8eac23f1$var$isReadableStreamSupported = $f3d7f83f8eac23f1$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $f3d7f83f8eac23f1$var$encodeText = $f3d7f83f8eac23f1$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $f3d7f83f8eac23f1$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $f3d7f83f8eac23f1$var$supportsRequestStream = $f3d7f83f8eac23f1$var$isReadableStreamSupported && $f3d7f83f8eac23f1$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $2d0e9d3dee104573$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $f3d7f83f8eac23f1$var$DEFAULT_CHUNK_SIZE = 65536;
const $f3d7f83f8eac23f1$var$supportsResponseStream = $f3d7f83f8eac23f1$var$isReadableStreamSupported && $f3d7f83f8eac23f1$var$test(()=>(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
const $f3d7f83f8eac23f1$var$resolvers = {
    stream: $f3d7f83f8eac23f1$var$supportsResponseStream && ((res)=>res.body)
};
$f3d7f83f8eac23f1$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$f3d7f83f8eac23f1$var$resolvers[type] && ($f3d7f83f8eac23f1$var$resolvers[type] = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $f3d7f83f8eac23f1$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return (await new Request(body).arrayBuffer()).byteLength;
    if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isString(body)) return (await $f3d7f83f8eac23f1$var$encodeText(body)).byteLength;
};
const $f3d7f83f8eac23f1$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $f3d7f83f8eac23f1$var$getBodyLength(body) : length;
};
var $f3d7f83f8eac23f1$export$2e2bcd8739ae039 = $f3d7f83f8eac23f1$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $3b69c22dbb9d39fd$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let [composedSignal, stopTimeout] = signal || cancelToken || timeout ? (0, $aadb4ed2a298b0ba$export$2e2bcd8739ae039)([
        signal,
        cancelToken
    ], timeout) : [];
    let finished, request;
    const onFinish = ()=>{
        !finished && setTimeout(()=>{
            composedSignal && composedSignal.unsubscribe();
        });
        finished = true;
    };
    let requestContentLength;
    try {
        if (onUploadProgress && $f3d7f83f8eac23f1$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $f3d7f83f8eac23f1$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $78030c6cd44c2074$export$d9fadd12586c18d6)(requestContentLength, (0, $78030c6cd44c2074$export$c1b28109d46c3592)((0, $78030c6cd44c2074$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $b659d21f9f0ea1be$export$b0119225647bd83)(_request.body, $f3d7f83f8eac23f1$var$DEFAULT_CHUNK_SIZE, onProgress, flush, $f3d7f83f8eac23f1$var$encodeText);
            }
        }
        if (!(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $f3d7f83f8eac23f1$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($f3d7f83f8eac23f1$var$supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $78030c6cd44c2074$export$d9fadd12586c18d6)(responseContentLength, (0, $78030c6cd44c2074$export$c1b28109d46c3592)((0, $78030c6cd44c2074$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $b659d21f9f0ea1be$export$b0119225647bd83)(response.body, $f3d7f83f8eac23f1$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                isStreamResponse && onFinish();
            }, $f3d7f83f8eac23f1$var$encodeText), options);
        }
        responseType = responseType || "text";
        let responseData = await $f3d7f83f8eac23f1$var$resolvers[(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).findKey($f3d7f83f8eac23f1$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && onFinish();
        stopTimeout && stopTimeout();
        return await new Promise((resolve, reject)=>{
            (0, $7f567f45892b55f4$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $a8278480c25d7445$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        onFinish();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)("Network Error", (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $d8c4cdc4b8377f90$var$knownAdapters = {
    http: (0, $740b6a112ef75fc8$export$2e2bcd8739ae039),
    xhr: (0, $fafe892a386e488a$export$2e2bcd8739ae039),
    fetch: (0, $f3d7f83f8eac23f1$export$2e2bcd8739ae039)
};
(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).forEach($d8c4cdc4b8377f90$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $d8c4cdc4b8377f90$var$renderReason = (reason)=>`- ${reason}`;
const $d8c4cdc4b8377f90$var$isResolvedHandle = (adapter)=>(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $d8c4cdc4b8377f90$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$d8c4cdc4b8377f90$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $d8c4cdc4b8377f90$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($d8c4cdc4b8377f90$var$renderReason).join("\n") : " " + $d8c4cdc4b8377f90$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $d8c4cdc4b8377f90$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $d007a6ded67eb35b$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $ac4fb0cf1e9ba991$export$2e2bcd8739ae039)(null, config);
}
function $d007a6ded67eb35b$export$2e2bcd8739ae039(config) {
    $d007a6ded67eb35b$var$throwIfCancellationRequested(config);
    config.headers = (0, $a8278480c25d7445$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $c5ac26be0b4082da$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $d8c4cdc4b8377f90$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $7902afa80c48087a$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $d007a6ded67eb35b$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $c5ac26be0b4082da$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $a8278480c25d7445$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $0d83534992e0bedd$export$2e2bcd8739ae039)(reason)) {
            $d007a6ded67eb35b$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $c5ac26be0b4082da$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $a8278480c25d7445$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $07be83f0f1926157$export$a4ad2735b021c132 = "1.7.5";



"use strict";
const $756ed683ec7dd3dc$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $756ed683ec7dd3dc$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $756ed683ec7dd3dc$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $756ed683ec7dd3dc$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $07be83f0f1926157$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$756ed683ec7dd3dc$var$deprecatedWarnings[opt]) {
            $756ed683ec7dd3dc$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $756ed683ec7dd3dc$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)("options must be an object", (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $b0bf1e70f4835062$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $b0bf1e70f4835062$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $756ed683ec7dd3dc$export$2e2bcd8739ae039 = {
    assertOptions: $756ed683ec7dd3dc$var$assertOptions,
    validators: $756ed683ec7dd3dc$var$validators
};



"use strict";
const $ecd90d01db2714a3$var$validators = (0, $756ed683ec7dd3dc$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $ecd90d01db2714a3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $74dd218e995a80c6$export$2e2bcd8739ae039)(),
            response: new (0, $74dd218e995a80c6$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $d472aa5704a2e347$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $756ed683ec7dd3dc$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $ecd90d01db2714a3$var$validators.transitional($ecd90d01db2714a3$var$validators.boolean),
            forcedJSONParsing: $ecd90d01db2714a3$var$validators.transitional($ecd90d01db2714a3$var$validators.boolean),
            clarifyTimeoutError: $ecd90d01db2714a3$var$validators.transitional($ecd90d01db2714a3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $756ed683ec7dd3dc$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $ecd90d01db2714a3$var$validators.function,
                serialize: $ecd90d01db2714a3$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $a8278480c25d7445$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $d007a6ded67eb35b$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $d007a6ded67eb35b$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $d472aa5704a2e347$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $cb69d02eee72bac2$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $0be69c2ac4a5988b$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $ecd90d01db2714a3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $d472aa5704a2e347$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $9d5c1981c8d67177$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $d472aa5704a2e347$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $ecd90d01db2714a3$var$Axios.prototype[method] = generateHTTPMethod();
    $ecd90d01db2714a3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $ecd90d01db2714a3$export$2e2bcd8739ae039 = $ecd90d01db2714a3$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $5ba1fe13087fb318$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $ac4fb0cf1e9ba991$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $5ba1fe13087fb318$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $5ba1fe13087fb318$export$2e2bcd8739ae039 = $5ba1fe13087fb318$var$CancelToken;






"use strict";
function $a03b75294a6bda04$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $776af20bc69171a4$export$2e2bcd8739ae039(payload) {
    return (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $241c07dbe2c5f08b$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($241c07dbe2c5f08b$var$HttpStatusCode).forEach(([key, value])=>{
    $241c07dbe2c5f08b$var$HttpStatusCode[value] = key;
});
var $241c07dbe2c5f08b$export$2e2bcd8739ae039 = $241c07dbe2c5f08b$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $40871541b61664db$var$createInstance(defaultConfig) {
    const context = new (0, $ecd90d01db2714a3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $4a46f5d8663578b6$export$2e2bcd8739ae039)((0, $ecd90d01db2714a3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).extend(instance, (0, $ecd90d01db2714a3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $9d5c1981c8d67177$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $40871541b61664db$var$createInstance((0, $d472aa5704a2e347$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $40871541b61664db$var$axios = $40871541b61664db$var$createInstance((0, $7902afa80c48087a$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$40871541b61664db$var$axios.Axios = (0, $ecd90d01db2714a3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$40871541b61664db$var$axios.CanceledError = (0, $ac4fb0cf1e9ba991$export$2e2bcd8739ae039);
$40871541b61664db$var$axios.CancelToken = (0, $5ba1fe13087fb318$export$2e2bcd8739ae039);
$40871541b61664db$var$axios.isCancel = (0, $0d83534992e0bedd$export$2e2bcd8739ae039);
$40871541b61664db$var$axios.VERSION = (0, $07be83f0f1926157$export$a4ad2735b021c132);
$40871541b61664db$var$axios.toFormData = (0, $2ca98cec6a9bd582$export$2e2bcd8739ae039);
// Expose AxiosError class
$40871541b61664db$var$axios.AxiosError = (0, $b0bf1e70f4835062$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$40871541b61664db$var$axios.Cancel = $40871541b61664db$var$axios.CanceledError;
// Expose all/spread
$40871541b61664db$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$40871541b61664db$var$axios.spread = (0, $a03b75294a6bda04$export$2e2bcd8739ae039);
// Expose isAxiosError
$40871541b61664db$var$axios.isAxiosError = (0, $776af20bc69171a4$export$2e2bcd8739ae039);
// Expose mergeConfig
$40871541b61664db$var$axios.mergeConfig = (0, $d472aa5704a2e347$export$2e2bcd8739ae039);
$40871541b61664db$var$axios.AxiosHeaders = (0, $a8278480c25d7445$export$2e2bcd8739ae039);
$40871541b61664db$var$axios.formToJSON = (thing)=>(0, $54ff0dc040b003eb$export$2e2bcd8739ae039)((0, $9d5c1981c8d67177$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$40871541b61664db$var$axios.getAdapter = (0, $d8c4cdc4b8377f90$export$2e2bcd8739ae039).getAdapter;
$40871541b61664db$var$axios.HttpStatusCode = (0, $241c07dbe2c5f08b$export$2e2bcd8739ae039);
$40871541b61664db$var$axios.default = $40871541b61664db$var$axios;
var // this module should only have a default export
$40871541b61664db$export$2e2bcd8739ae039 = $40871541b61664db$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $ea0502f09c2d74dd$export$1c00760e9e5a4e95, AxiosError: $ea0502f09c2d74dd$export$c1fbed17c2f6a328, CanceledError: $ea0502f09c2d74dd$export$1ab0c6b20d94fa14, isCancel: $ea0502f09c2d74dd$export$3b22524397b493c6, CancelToken: $ea0502f09c2d74dd$export$fd08e3cb425f0d61, VERSION: $ea0502f09c2d74dd$export$a4ad2735b021c132, all: $ea0502f09c2d74dd$export$84bf76cd7afc7469, Cancel: $ea0502f09c2d74dd$export$848c9b7ead0df967, isAxiosError: $ea0502f09c2d74dd$export$fbafdbe06a5b5a9a, spread: $ea0502f09c2d74dd$export$3ae0fd4797ed47c8, toFormData: $ea0502f09c2d74dd$export$10ae0d317ea97f8b, AxiosHeaders: $ea0502f09c2d74dd$export$4e7d6ff0f3e6520, HttpStatusCode: $ea0502f09c2d74dd$export$a972f69c851492b3, formToJSON: $ea0502f09c2d74dd$export$86d7c59254d6a2c9, getAdapter: $ea0502f09c2d74dd$export$17ddc20a97d669e2, mergeConfig: $ea0502f09c2d74dd$export$7ec1ebcfa9d8bd6a } = (0, $40871541b61664db$export$2e2bcd8739ae039);


const $48acbfba8b7c6bc2$export$121604ee484c30df = (uri, { arg: arg })=>(0, $40871541b61664db$export$2e2bcd8739ae039)(uri, {
        method: "POST",
        data: arg
    }).then((r)=>r.data);
const $48acbfba8b7c6bc2$export$be9296b8fbc3de66 = (config)=>(url, { arg: arg })=>(0, $40871541b61664db$export$2e2bcd8739ae039)({
            url: url,
            ...config,
            data: arg
        }).then((r)=>r.data);
const $48acbfba8b7c6bc2$export$47fdd40111eda34c = (...args)=>(0, $40871541b61664db$export$2e2bcd8739ae039)(...args).then((r)=>r.data);



var $1EuC8 = parcelRequire("1EuC8");
const $baa2e015d50bcf16$var$useStateReducer = (initialState)=>{
    const methods = (0, $1EuC8.useReducer)((state, newState)=>({
            ...state,
            ...newState
        }), {
        ...initialState
    });
    return methods;
};
var $baa2e015d50bcf16$export$2e2bcd8739ae039 = $baa2e015d50bcf16$var$useStateReducer;


const $f07823b99a8d78c2$var$API_URL = "https://app.chatsmart.pro";
const $f07823b99a8d78c2$export$5b0140bff86c58b9 = async (props)=>{
    await fetch(`${$f07823b99a8d78c2$var$API_URL}/api/conversations/eval-answer`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            eval: props.value,
            messageId: props.messageId
        })
    });
};
const $f07823b99a8d78c2$var$LOCAL_STORAGE_CONVERSATION_ID_KEY = "conversationId";
const $f07823b99a8d78c2$var$useChat = ({ endpoint: endpoint, channel: channel, queryBody: queryBody, ...otherProps })=>{
    const localStorageConversationIdKey = otherProps.localStorageConversationIdKey || $f07823b99a8d78c2$var$LOCAL_STORAGE_CONVERSATION_ID_KEY;
    const [state, setState] = (0, $baa2e015d50bcf16$export$2e2bcd8739ae039)({
        visitorId: "",
        conversationId: "",
        hasMoreMessages: true,
        prevConversationId: "",
        mounted: false,
        history: [],
        handleAbort: undefined
    });
    const getConversationQuery = (0, $86b46a0f8c2e4a70$export$2e2bcd8739ae039)((pageIndex, previousPageData)=>{
        if (!state.conversationId) {
            if (state.hasMoreMessages) setState({
                hasMoreMessages: false
            });
            return null;
        }
        if (previousPageData && previousPageData?.messages?.length === 0) {
            setState({
                hasMoreMessages: false
            });
            return null;
        }
        const cursor = previousPageData?.messages?.[previousPageData?.messages?.length - 1]?.id;
        return `${$f07823b99a8d78c2$var$API_URL}/api/conversations/${state.conversationId}?cursor=${cursor || ""}`;
    }, (0, $48acbfba8b7c6bc2$export$47fdd40111eda34c), {
        onSuccess: (data)=>{
            setState({
                history: data?.map((each)=>each?.messages)?.flat()?.reverse()?.map((message)=>({
                        id: message?.id,
                        eval: message?.eval,
                        from: message?.from,
                        message: message?.text,
                        createdAt: message?.createdAt,
                        sources: message?.sources
                    }))
            });
        }
    });
    const handleLoadMoreMessages = ()=>{
        if (getConversationQuery.isLoading || getConversationQuery.isValidating) return;
        getConversationQuery.setSize(getConversationQuery.size + 1);
    };
    const handleChatSubmit = async (message)=>{
        if (!message || !endpoint) return;
        const ctrl = new AbortController();
        const history = [
            ...state.history,
            {
                from: "human",
                message: message
            }
        ];
        const nextIndex = history.length;
        setState({
            history: history,
            handleAbort: ()=>{
                ctrl.abort();
            }
        });
        let answer = "";
        let error = "";
        try {
            let buffer = "";
            let bufferStep = "";
            let bufferEndpointResponse = "";
            class RetriableError extends Error {
            }
            class FatalError extends Error {
            }
            await (0, $88c0fe1a5e0bde62$export$a0ddad8789ba715)(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                openWhenHidden: true,
                body: JSON.stringify({
                    ...queryBody,
                    streaming: true,
                    query: message,
                    visitorId: state.visitorId,
                    conversationId: state.conversationId,
                    channel: channel
                }),
                signal: ctrl.signal,
                async onopen (response) {
                    if (response.ok && response.headers.get("content-type") === (0, $88c0fe1a5e0bde62$export$d7c56894fc591754)) return; // everything's good
                    else if (response.status >= 400 && response.status < 500 && response.status !== 429) {
                        if (response.status === 402) throw new (0, $99efa7b7dc940226$export$f2e832acab1bdd79)((0, $99efa7b7dc940226$export$eb26b24d7b7bab09).USAGE_LIMIT);
                        // client-side errors are usually non-retriable:
                        throw new FatalError();
                    } else throw new RetriableError();
                },
                onclose () {
                    // if the server closes the connection unexpectedly, retry:
                    throw new RetriableError();
                },
                onerror (err) {
                    console.error("on error", err, Object.keys(err));
                    if (err instanceof FatalError) {
                        ctrl.abort();
                        throw err; // rethrow to stop the operation
                    } else if (err instanceof (0, $99efa7b7dc940226$export$f2e832acab1bdd79)) {
                        console.error("ApiError", (0, $99efa7b7dc940226$export$f2e832acab1bdd79));
                        throw err;
                    }
                },
                onmessage: (event)=>{
                    console.debug("[EventSource]", event);
                    if (event.data === "[DONE]") {
                        ctrl.abort();
                        console.debug("[answer]", buffer);
                        console.log("[response]", bufferEndpointResponse);
                        try {
                            const { sources: sources, conversationId: conversationId, visitorId: visitorId, messageId: messageId } = JSON.parse(bufferEndpointResponse);
                            const h = [
                                ...history
                            ];
                            if (h?.[nextIndex]) {
                                h[nextIndex].message = `${buffer}`;
                                h[nextIndex].id = messageId;
                            } else h.push({
                                id: messageId,
                                from: "agent",
                                message: buffer,
                                sources: sources
                            });
                            localStorage.setItem("visitorId", visitorId || "");
                            localStorage.setItem(localStorageConversationIdKey, conversationId || "");
                            setState({
                                history: h,
                                conversationId: conversationId,
                                prevConversationId: state.conversationId,
                                visitorId: visitorId
                            });
                        } catch (err) {
                            console.log(err);
                        }
                    } else if (event.data?.startsWith("[ERROR]")) {
                        ctrl.abort();
                        setState({
                            history: [
                                ...history,
                                {
                                    from: "agent",
                                    message: event.data.replace("[ERROR]", "")
                                }
                            ]
                        });
                    } else if (event.event === (0, $b359885d68b982f7$export$d45b9cbb82ebd6c5).endpoint_response) bufferEndpointResponse += decodeURIComponent(event.data);
                    else if (event.event === (0, $b359885d68b982f7$export$d45b9cbb82ebd6c5).step) {
                        bufferStep += decodeURIComponent(event.data);
                        const h = [
                            ...history
                        ];
                        if (h?.[nextIndex]) h[nextIndex].message = `${bufferStep}`;
                        else h.push({
                            from: "agent",
                            message: bufferStep
                        });
                        setState({
                            history: h
                        });
                    } else if (event.event === (0, $b359885d68b982f7$export$d45b9cbb82ebd6c5).answer) {
                        // const data = JSON.parse(event.data || `{}`);
                        buffer += decodeURIComponent(event.data);
                        // buffer = buffer?.replace(EXTRACT_SOURCES, '');
                        const h = [
                            ...history
                        ];
                        if (h?.[nextIndex]) h[nextIndex].message = `${buffer}`;
                        else h.push({
                            from: "agent",
                            message: buffer
                        });
                        setState({
                            history: h
                        });
                    }
                }
            });
        } catch (err) {
            console.error("err", err);
            if (err instanceof (0, $99efa7b7dc940226$export$f2e832acab1bdd79)) {
                if (err?.message) {
                    error = err?.message;
                    if (error === (0, $99efa7b7dc940226$export$eb26b24d7b7bab09).USAGE_LIMIT) answer = "Usage limit reached. Please upgrade your plan to get higher usage.";
                    else answer = `Error: ${error}`;
                } else answer = `Error: ${error}`;
                setState({
                    history: [
                        ...history,
                        {
                            from: "agent",
                            message: answer
                        }
                    ]
                });
            }
        }
    };
    const setConversationId = (0, $1EuC8.useCallback)((value)=>{
        localStorage.setItem(localStorageConversationIdKey, value || "");
        setState({
            conversationId: value || ""
        });
    }, []);
    const setVisitorId = (0, $1EuC8.useCallback)((value)=>{
        localStorage.setItem("visitorId", value || "");
        setState({
            visitorId: value || ""
        });
    }, []);
    (0, $1EuC8.useEffect)(()=>{
        if (typeof window !== "undefined") // Init from localStorage onmount (for chatbubble widget)
        setState({
            visitorId: localStorage.getItem("visitorId"),
            conversationId: localStorage.getItem(localStorageConversationIdKey)
        });
    }, []);
    (0, $1EuC8.useEffect)(()=>{
        if (!state.prevConversationId && state.conversationId) {
            // New conversation
            setState({
                hasMoreMessages: false
            });
            return;
        }
        // Conversation changed, reset history (for conversation switching)
        setState({
            history: []
        });
    }, [
        state.conversationId
    ]);
    return {
        handleChatSubmit: handleChatSubmit,
        history: state.history,
        isLoadingConversation: getConversationQuery.isLoading,
        hasMoreMessages: state.hasMoreMessages,
        handleLoadMoreMessages: handleLoadMoreMessages,
        visitorId: state.visitorId,
        conversationId: state.conversationId,
        setConversationId: setConversationId,
        setVisitorId: setVisitorId,
        handleEvalAnswer: $f07823b99a8d78c2$export$5b0140bff86c58b9,
        handleAbort: state.handleAbort
    };
};
var $f07823b99a8d78c2$export$2e2bcd8739ae039 = $f07823b99a8d78c2$var$useChat;



const $db89fa5438b5865d$var$pickColorBasedOnBgColor = (bgColor, lightColor, darkColor)=>{
    var color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    var uicolors = [
        r / 255,
        g / 255,
        b / 255
    ];
    var c = uicolors.map((col)=>{
        if (col <= 0.03928) return col / 12.92;
        return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
    return L > 0.179 ? darkColor : lightColor;
};
var $db89fa5438b5865d$export$2e2bcd8739ae039 = $db89fa5438b5865d$var$pickColorBasedOnBgColor;


const $04b47b95cb349a0d$export$bca14c5b3b88a9c9 = (0, $f99a3103be8f6dd5$export$2e2bcd8739ae039)({
    cssVarPrefix: "chatsmart-chat-bubble",
    colorSchemes: {
        dark: {
            palette: {
                primary: (0, $8bd845dd04c3d933$export$2e2bcd8739ae039).grey
            }
        },
        light: {
            palette: {
                primary: (0, $8bd845dd04c3d933$export$2e2bcd8739ae039).grey
            }
        }
    }
});
const $04b47b95cb349a0d$var$defaultChatBubbleConfig = {
    // displayName: 'Agent Smith',
    theme: "light",
    primaryColor: "#000000"
};
const $04b47b95cb349a0d$var$API_URL = "https://app.chatsmart.pro";
function $04b47b95cb349a0d$var$App(props) {
    // const { setMode } = useColorScheme();
    const initMessageRef = (0, $1EuC8.useRef)(null);
    const chatBoxRef = (0, $1EuC8.useRef)(null);
    const [state, setState] = (0, $baa2e015d50bcf16$export$2e2bcd8739ae039)({
        isOpen: false,
        agent: undefined,
        config: props.initConfig || $04b47b95cb349a0d$var$defaultChatBubbleConfig,
        hasOpenOnce: false,
        showInitialMessage: false,
        showHelp: true,
        showCaptureForm: false,
        isCaptureLoading: false,
        visitorEmail: ""
    });
    const { history: history, handleChatSubmit: handleChatSubmit, conversationId: conversationId, visitorId: visitorId, isLoadingConversation: isLoadingConversation, hasMoreMessages: hasMoreMessages, handleLoadMoreMessages: handleLoadMoreMessages, handleEvalAnswer: handleEvalAnswer, handleAbort: handleAbort } = (0, $f07823b99a8d78c2$export$2e2bcd8739ae039)({
        endpoint: `${$04b47b95cb349a0d$var$API_URL}/api/agents/${props.agentId}/query`,
        channel: "website"
    });
    const textColor = (0, $1EuC8.useMemo)(()=>{
        return (0, $db89fa5438b5865d$export$2e2bcd8739ae039)(state.config.primaryColor || "#ffffff", "#ffffff", "#000000");
    }, [
        state.config.primaryColor
    ]);
    const handleFetchAgent = async ()=>{
        try {
            const res = await fetch(`${$04b47b95cb349a0d$var$API_URL}/api/agents/${props.agentId}`);
            const data = await res.json();
            const agentConfig = data?.interfaceConfig;
            setState({
                agent: data,
                config: {
                    ...$04b47b95cb349a0d$var$defaultChatBubbleConfig,
                    ...agentConfig
                }
            });
        } catch (err) {
            console.error(err);
        } finally{}
    };
    (0, $1EuC8.useEffect)(()=>{
        handleFetchAgent();
    }, []);
    (0, $1EuC8.useEffect)(()=>{
        if (state.config?.initialMessage) setTimeout(()=>{
            setState({
                showInitialMessage: true
            });
        }, 5000);
    }, [
        state?.config?.initialMessage
    ]);
    (0, $1EuC8.useEffect)(()=>{
        if (props.initConfig) setState({
            config: props.initConfig
        });
    }, [
        props.initConfig
    ]);
    (0, $1EuC8.useEffect)(()=>{
        if (localStorage) {
            const visitorEmail = localStorage.getItem("visitorEmail");
            if (visitorEmail) setState({
                visitorEmail: visitorEmail
            });
        }
    }, []);
    // useEffect(() => {
    //   if (config?.theme) {
    //     setMode(config.theme!);
    //   }
    // }, [config.theme]);
    const transitionStyles = {
        entering: {
            opacity: 0
        },
        entered: {
            opacity: 1
        },
        exiting: {
            opacity: 0
        },
        exited: {
            opacity: 0
        }
    };
    const bubbleIcon = (0, $1EuC8.useMemo)(()=>{
        if (state.agent?.iconUrl) return /*#__PURE__*/ (0, $6iAGf.jsx)("img", {
            src: state.agent?.iconUrl,
            width: 30,
            height: 30
        });
        else return /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e5384f96e1af87bb$exports))), {});
    }, [
        state.agent?.iconUrl
    ]);
    const Capture = (0, $1EuC8.useMemo)(()=>{
        let Component = null;
        if (state.showHelp || state.visitorEmail) Component = /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
            sx: {
                mb: -1
            },
            children: [
                state.visitorEmail && /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c221795da3cfda3d$export$2e2bcd8739ae039), {
                    size: "sm",
                    color: "success",
                    variant: "soft",
                    sx: {
                        mr: "auto"
                    },
                    endDecorator: /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cb8ae238302d8481$exports))), {}),
                    children: "help requested"
                }),
                !state.visitorEmail && !state.showCaptureForm && /*#__PURE__*/ (0, $6iAGf.jsx)((0, $19d5cd0cd935946e$export$2e2bcd8739ae039), {
                    size: "sm",
                    variant: "plain",
                    color: "neutral",
                    startDecorator: /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2272c2abf146540d$exports))), {}),
                    sx: {
                        mr: "auto"
                    },
                    onClick: ()=>setState({
                            showCaptureForm: true
                        }),
                    children: "Help"
                }),
                !state.visitorEmail && state.showCaptureForm && /*#__PURE__*/ (0, $6iAGf.jsx)("form", {
                    onSubmit: async (e)=>{
                        console.log(e.target);
                        e.preventDefault();
                        e.stopPropagation();
                        const form = e.target;
                        const email = form.email.value;
                        if (email) {
                            setState({
                                isCaptureLoading: true
                            });
                            await fetch(`${$04b47b95cb349a0d$var$API_URL}/api/agents/${props.agentId}/capture`, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    visitorEmail: email,
                                    conversationId: conversationId,
                                    visitorId: visitorId
                                })
                            });
                            setState({
                                showHelp: false,
                                isCaptureLoading: false,
                                visitorEmail: email
                            });
                            localStorage.setItem("visitorEmail", email);
                        }
                    },
                    children: /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                        direction: "row",
                        gap: 0.5,
                        sx: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c33af7c22d14ddc1$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "plain",
                                onClick: ()=>{
                                    setState({
                                        showCaptureForm: false
                                    });
                                },
                                children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f99d326ceed242e9$exports))), {})
                            }),
                            /*#__PURE__*/ (0, $6iAGf.jsx)((0, $f049161e9712eaba$export$2e2bcd8739ae039), {
                                sx: {
                                    width: "100%"
                                },
                                size: "sm",
                                name: "email",
                                type: "email",
                                placeholder: "Leave your email to get contacted by the team",
                                required: true,
                                // startDecorator={<AlternateEmailRoundedIcon />}
                                disabled: state.isCaptureLoading,
                                endDecorator: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c33af7c22d14ddc1$export$2e2bcd8739ae039), {
                                    color: "neutral",
                                    type: "submit",
                                    disabled: state.isCaptureLoading,
                                    children: state.isCaptureLoading ? /*#__PURE__*/ (0, $6iAGf.jsx)((0, $fe3d69a7e20c10a9$export$2e2bcd8739ae039), {
                                        size: "sm",
                                        variant: "soft"
                                    }) : /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cb8ae238302d8481$exports))), {})
                                })
                            })
                        ]
                    })
                })
            ]
        });
        return Component;
    }, [
        props.agentId,
        state.isCaptureLoading,
        state.showCaptureForm,
        setState,
        state.visitorEmail,
        visitorId
    ]);
    if (!state.agent) return null;
    return /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $6iAGf.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6iAGf.jsx)((0, $6651db035ad6809a$export$2e2bcd8739ae039), {
                nodeRef: initMessageRef,
                in: state.showInitialMessage && !state.hasOpenOnce,
                timeout: 0,
                mountOnEnter: true,
                unmountOnExit: true,
                children: (s)=>/*#__PURE__*/ (0, $6iAGf.jsx)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                        ref: initMessageRef,
                        sx: {
                            position: "fixed",
                            bottom: 100,
                            transition: `opacity 300ms ease-in-out`,
                            opacity: 0,
                            zIndex: 9999999998,
                            ...transitionStyles[s],
                            ...state.config.position === "left" ? {
                                left: "20px"
                            } : {},
                            ...state.config.position === "right" ? {
                                right: "20px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $7a200f4c9addd534$export$2e2bcd8739ae039), {
                            sx: {
                                width: "100%",
                                maxWidth: 1000,
                                display: "flex",
                                boxShadow: "md"
                            },
                            children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c51e530d5ca68d95$export$2e2bcd8739ae039), {
                                children: state.config?.initialMessage
                            })
                        })
                    })
            }),
            /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $d6bc128423f5f36a$export$2e2bcd8739ae039), {
                sx: {
                    // bgcolor: 'red',
                    overflow: "visible",
                    position: "fixed",
                    height: "60px",
                    bottom: "20px",
                    zIndex: 9999999999,
                    ...state.config.position === "left" ? {
                        left: "20px"
                    } : {},
                    ...state.config.position === "right" ? {
                        right: "20px"
                    } : {}
                },
                children: [
                    /*#__PURE__*/ (0, $6iAGf.jsx)((0, $6651db035ad6809a$export$2e2bcd8739ae039), {
                        nodeRef: chatBoxRef,
                        in: state.isOpen,
                        timeout: 0,
                        mountOnEnter: true,
                        unmountOnExit: true,
                        children: (s)=>/*#__PURE__*/ (0, $6iAGf.jsxs)((0, $7a200f4c9addd534$export$2e2bcd8739ae039), {
                                ref: chatBoxRef,
                                variant: "outlined",
                                sx: (theme)=>({
                                        zIndex: 9999,
                                        position: "absolute",
                                        bottom: "80px",
                                        display: "flex",
                                        flexDirection: "column",
                                        boxSizing: "border-box",
                                        boxShadow: "md",
                                        transition: `opacity 150ms ease-in-out`,
                                        opacity: 0,
                                        ...transitionStyles[s],
                                        ...state.config.position === "right" ? {
                                            transform: `translateX(${-450}px)`
                                        } : {},
                                        [theme.breakpoints.up("sm")]: {
                                            width: "500px"
                                        },
                                        [theme.breakpoints.only("xs")]: {
                                            width: "100vw",
                                            height: "100vh",
                                            maxWidth: "100vw",
                                            position: "fixed",
                                            left: 0,
                                            top: 0,
                                            transform: `translateX(0px)`
                                        }
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $6iAGf.jsx)((0, $d6bc128423f5f36a$export$2e2bcd8739ae039), {
                                        sx: {
                                            width: "100%",
                                            mt: -2,
                                            py: 1
                                        },
                                        children: /*#__PURE__*/ (0, $6iAGf.jsxs)((0, $97ef477f809727ed$export$2e2bcd8739ae039), {
                                            direction: "row",
                                            alignItems: "center",
                                            children: [
                                                state.config?.displayName && /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c51e530d5ca68d95$export$2e2bcd8739ae039), {
                                                    children: state.config?.displayName
                                                }),
                                                /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c33af7c22d14ddc1$export$2e2bcd8739ae039), {
                                                    variant: "plain",
                                                    sx: {
                                                        ml: "auto"
                                                    },
                                                    size: "sm",
                                                    onClick: ()=>setState({
                                                            isOpen: false
                                                        }),
                                                    children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a88209f7b217d9e7$exports))), {})
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6iAGf.jsx)((0, $7494f686b33c5859$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $6iAGf.jsx)((0, $d6bc128423f5f36a$export$2e2bcd8739ae039), {
                                        sx: (theme)=>({
                                                // flex: 1,
                                                // display: 'flex',
                                                width: "100%",
                                                position: "relative",
                                                height: "calc(100vh - 200px)",
                                                [theme.breakpoints.up("sm")]: {
                                                    maxHeight: "680px"
                                                },
                                                [theme.breakpoints.only("xs")]: {
                                                    height: "calc(100vh - 100px)",
                                                    // maxHeight: '100vh',
                                                    maxWidth: "100vw"
                                                },
                                                "& .message-agent": {},
                                                "& .message-human": {
                                                    backgroundColor: state.config.primaryColor
                                                },
                                                "& .message-human *": {
                                                    color: textColor
                                                }
                                            }),
                                        children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $8c80a2b4338ff3f0$export$2e2bcd8739ae039), {
                                            messages: history,
                                            onSubmit: handleChatSubmit,
                                            messageTemplates: state.config.messageTemplates,
                                            initialMessage: state.config.initialMessage,
                                            renderAfterMessages: Capture,
                                            agentIconUrl: state.agent?.iconUrl,
                                            isLoadingConversation: isLoadingConversation,
                                            hasMoreMessages: hasMoreMessages,
                                            handleLoadMoreMessages: handleLoadMoreMessages,
                                            handleEvalAnswer: handleEvalAnswer,
                                            handleAbort: handleAbort
                                        })
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $6iAGf.jsx)((0, $c33af7c22d14ddc1$export$2e2bcd8739ae039), {
                        // color={'neutral'}
                        variant: "solid",
                        onClick: ()=>setState({
                                isOpen: !state.isOpen,
                                ...!state.isOpen ? {
                                    hasOpenOnce: true
                                } : {}
                            }),
                        sx: (theme)=>({
                                backgroundColor: state.config.primaryColor,
                                width: "60px",
                                height: "60px",
                                borderRadius: "100%",
                                color: textColor,
                                transition: "all 100ms ease-in-out",
                                borderWidth: "1px",
                                borderColor: theme.palette.divider,
                                borderStyle: "solid",
                                "&:hover": {
                                    backgroundColor: state.config.primaryColor,
                                    filter: "brightness(0.9)",
                                    transform: "scale(1.05)"
                                }
                            }),
                        children: state.isOpen ? /*#__PURE__*/ (0, $6iAGf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2bcc20a60ebe1ea3$exports))), {}) : bubbleIcon
                    })
                ]
            })
        ]
    });
}
var $04b47b95cb349a0d$export$2e2bcd8739ae039 = $04b47b95cb349a0d$var$App;


if (typeof window !== "undefined") addEventListener("DOMContentLoaded", (event)=>{
    const cache = (0, $4tJ1W.default)({
        key: "chat-bubble",
        prepend: true,
        speedy: true
    });
    const me = document.querySelector('script[data-name="chatsmart-chat-bubble"]');
    if (!me?.id) return;
    const div = document.createElement("div");
    document.body.appendChild(div);
    const root = (0, $6fb24a13c371e5cf$export$882461b6382ed46c)(div);
    root.render(/*#__PURE__*/ (0, $6iAGf.jsx)((0, $1EuC8.StrictMode), {
        children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $e0ddeeb9e921301b$exports.SessionProvider), {
            children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $j2qx3.default), {
                injectFirst: true,
                children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $69fRv.C), {
                    value: cache,
                    children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $e4321228e0a5ec0b$export$2e2bcd8739ae039), {
                        theme: (0, $04b47b95cb349a0d$export$bca14c5b3b88a9c9),
                        children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $cfb032a577a9592a$export$50ec01b133c61652), {
                            theme: (0, $04b47b95cb349a0d$export$bca14c5b3b88a9c9),
                            defaultMode: "light",
                            modeStorageKey: "chatsmart-chat-bubble",
                            colorSchemeStorageKey: "chatsmart-chat-bubble-scheme",
                            attribute: "chatsmart-chat-bubble-scheme",
                            colorSchemeNode: div,
                            children: /*#__PURE__*/ (0, $6iAGf.jsx)((0, $04b47b95cb349a0d$export$2e2bcd8739ae039), {
                                agentId: me.id
                            })
                        })
                    })
                })
            })
        })
    }));
});

})();
//# sourceMappingURL=chat-bubble.js.map
